/*! For license information please see web-video-player.js.LICENSE.txt */
var t, e;
(t = window),
  (e = function() {
    return (function(t) {
      function e(n) {
        if (r[n]) return r[n].exports;
        var i = (r[n] = { i: n, l: !1, exports: {} });
        return t[n].call(i.exports, i, i.exports, e), (i.l = !0), i.exports;
      }
      var r = {};
      return (
        (e.m = t),
        (e.c = r),
        (e.d = function(t, r, n) {
          e.o(t, r) || Object.defineProperty(t, r, { enumerable: !0, get: n });
        }),
        (e.r = function(t) {
          'undefined' != typeof Symbol &&
            Symbol.toStringTag &&
            Object.defineProperty(t, Symbol.toStringTag, { value: 'Module' }),
            Object.defineProperty(t, '__esModule', { value: !0 });
        }),
        (e.t = function(t, r) {
          if ((1 & r && (t = e(t)), 8 & r)) return t;
          if (4 & r && 'object' == typeof t && t && t.__esModule) return t;
          var n = Object.create(null);
          if (
            (e.r(n),
            Object.defineProperty(n, 'default', { enumerable: !0, value: t }),
            2 & r && 'string' != typeof t)
          )
            for (var i in t)
              e.d(
                n,
                i,
                function(e) {
                  return t[e];
                }.bind(null, i),
              );
          return n;
        }),
        (e.n = function(t) {
          var r =
            t && t.__esModule
              ? function() {
                  return t.default;
                }
              : function() {
                  return t;
                };
          return e.d(r, 'a', r), r;
        }),
        (e.o = function(t, e) {
          return Object.prototype.hasOwnProperty.call(t, e);
        }),
        (e.p = ''),
        e((e.s = 72))
      );
    })([
      function(t, e, r) {
        function n(t, e) {
          function r() {
            this.constructor = t;
          }
          i(t, e),
            (t.prototype =
              null === e
                ? Object.create(e)
                : ((r.prototype = e.prototype), new r()));
        }
        r.d(e, 'a', function() {
          return n;
        });
        var i = function(t, e) {
          return (i =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function(t, e) {
                t.__proto__ = e;
              }) ||
            function(t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            })(t, e);
        };
      },
      function(t, e, r) {
        r.d(e, 'a', function() {
          return c;
        });
        var n = r(0),
          i = r(23),
          s = r(49),
          a = r(4),
          o = r(37),
          u = r(13),
          l = r(33),
          c = (function(t) {
            function e(r, n, i) {
              var a = t.call(this) || this;
              switch (
                ((a.syncErrorValue = null),
                (a.syncErrorThrown = !1),
                (a.syncErrorThrowable = !1),
                (a.isStopped = !1),
                arguments.length)
              ) {
                case 0:
                  a.destination = s.a;
                  break;
                case 1:
                  if (!r) {
                    a.destination = s.a;
                    break;
                  }
                  if ('object' == typeof r) {
                    r instanceof e
                      ? ((a.syncErrorThrowable = r.syncErrorThrowable),
                        (a.destination = r),
                        r.add(a))
                      : ((a.syncErrorThrowable = !0),
                        (a.destination = new h(a, r)));
                    break;
                  }
                default:
                  (a.syncErrorThrowable = !0),
                    (a.destination = new h(a, r, n, i));
              }
              return a;
            }
            return (
              n.a(e, t),
              (e.prototype[o.a] = function() {
                return this;
              }),
              (e.create = function(t, r, n) {
                var i = new e(t, r, n);
                return (i.syncErrorThrowable = !1), i;
              }),
              (e.prototype.next = function(t) {
                this.isStopped || this._next(t);
              }),
              (e.prototype.error = function(t) {
                this.isStopped || ((this.isStopped = !0), this._error(t));
              }),
              (e.prototype.complete = function() {
                this.isStopped || ((this.isStopped = !0), this._complete());
              }),
              (e.prototype.unsubscribe = function() {
                this.closed ||
                  ((this.isStopped = !0), t.prototype.unsubscribe.call(this));
              }),
              (e.prototype._next = function(t) {
                this.destination.next(t);
              }),
              (e.prototype._error = function(t) {
                this.destination.error(t), this.unsubscribe();
              }),
              (e.prototype._complete = function() {
                this.destination.complete(), this.unsubscribe();
              }),
              (e.prototype._unsubscribeAndRecycle = function() {
                var t = this._parentOrParents;
                return (
                  (this._parentOrParents = null),
                  this.unsubscribe(),
                  (this.closed = !1),
                  (this.isStopped = !1),
                  (this._parentOrParents = t),
                  this
                );
              }),
              e
            );
          })(a.a),
          h = (function(t) {
            function e(e, r, n, a) {
              var o,
                u = t.call(this) || this;
              u._parentSubscriber = e;
              var l = u;
              return (
                Object(i.a)(r)
                  ? (o = r)
                  : r &&
                    ((o = r.next),
                    (n = r.error),
                    (a = r.complete),
                    r !== s.a &&
                      ((l = Object.create(r)),
                      Object(i.a)(l.unsubscribe) &&
                        u.add(l.unsubscribe.bind(l)),
                      (l.unsubscribe = u.unsubscribe.bind(u)))),
                (u._context = l),
                (u._next = o),
                (u._error = n),
                (u._complete = a),
                u
              );
            }
            return (
              n.a(e, t),
              (e.prototype.next = function(t) {
                if (!this.isStopped && this._next) {
                  var e = this._parentSubscriber;
                  u.a.useDeprecatedSynchronousErrorHandling &&
                  e.syncErrorThrowable
                    ? this.__tryOrSetError(e, this._next, t) &&
                      this.unsubscribe()
                    : this.__tryOrUnsub(this._next, t);
                }
              }),
              (e.prototype.error = function(t) {
                if (!this.isStopped) {
                  var e = this._parentSubscriber,
                    r = u.a.useDeprecatedSynchronousErrorHandling;
                  if (this._error)
                    r && e.syncErrorThrowable
                      ? (this.__tryOrSetError(e, this._error, t),
                        this.unsubscribe())
                      : (this.__tryOrUnsub(this._error, t), this.unsubscribe());
                  else if (e.syncErrorThrowable)
                    r
                      ? ((e.syncErrorValue = t), (e.syncErrorThrown = !0))
                      : Object(l.a)(t),
                      this.unsubscribe();
                  else {
                    if ((this.unsubscribe(), r)) throw t;
                    Object(l.a)(t);
                  }
                }
              }),
              (e.prototype.complete = function() {
                var t = this;
                if (!this.isStopped) {
                  var e = this._parentSubscriber;
                  if (this._complete) {
                    var r = function() {
                      return t._complete.call(t._context);
                    };
                    u.a.useDeprecatedSynchronousErrorHandling &&
                    e.syncErrorThrowable
                      ? (this.__tryOrSetError(e, r), this.unsubscribe())
                      : (this.__tryOrUnsub(r), this.unsubscribe());
                  } else this.unsubscribe();
                }
              }),
              (e.prototype.__tryOrUnsub = function(t, e) {
                try {
                  t.call(this._context, e);
                } catch (t) {
                  if (
                    (this.unsubscribe(),
                    u.a.useDeprecatedSynchronousErrorHandling)
                  )
                    throw t;
                  Object(l.a)(t);
                }
              }),
              (e.prototype.__tryOrSetError = function(t, e, r) {
                if (!u.a.useDeprecatedSynchronousErrorHandling)
                  throw new Error('bad call');
                try {
                  e.call(this._context, r);
                } catch (e) {
                  return u.a.useDeprecatedSynchronousErrorHandling
                    ? ((t.syncErrorValue = e), (t.syncErrorThrown = !0), !0)
                    : (Object(l.a)(e), !0);
                }
                return !1;
              }),
              (e.prototype._unsubscribe = function() {
                var t = this._parentSubscriber;
                (this._context = null),
                  (this._parentSubscriber = null),
                  t.unsubscribe();
              }),
              e
            );
          })(c);
      },
      function(t, e, r) {
        function n(t, e) {
          if (!e.closed) {
            if (t instanceof a.a) return t.subscribe(e);
            var r;
            try {
              r = Object(o.a)(t)(e);
            } catch (t) {
              e.error(t);
            }
            return r;
          }
        }
        r.d(e, 'a', function() {
          return u;
        }),
          r.d(e, 'b', function() {
            return l;
          }),
          r.d(e, 'c', function() {
            return n;
          });
        var i = r(0),
          s = r(1),
          a = r(3),
          o = r(32),
          u = (function(t) {
            function e(e) {
              var r = t.call(this) || this;
              return (r.parent = e), r;
            }
            return (
              i.a(e, t),
              (e.prototype._next = function(t) {
                this.parent.notifyNext(t);
              }),
              (e.prototype._error = function(t) {
                this.parent.notifyError(t), this.unsubscribe();
              }),
              (e.prototype._complete = function() {
                this.parent.notifyComplete(), this.unsubscribe();
              }),
              e
            );
          })(s.a),
          l =
            (s.a,
            (function(t) {
              function e() {
                return (null !== t && t.apply(this, arguments)) || this;
              }
              return (
                i.a(e, t),
                (e.prototype.notifyNext = function(t) {
                  this.destination.next(t);
                }),
                (e.prototype.notifyError = function(t) {
                  this.destination.error(t);
                }),
                (e.prototype.notifyComplete = function() {
                  this.destination.complete();
                }),
                e
              );
            })(s.a));
        s.a;
      },
      function(t, e, r) {
        function n(t) {
          if ((t || (t = c.a.Promise || Promise), !t))
            throw new Error('no Promise impl found');
          return t;
        }
        var i = r(47),
          s = r(1),
          a = r(37),
          o = r(49),
          u = r(20),
          l = r(35),
          c = r(13);
        r.d(e, 'a', function() {
          return h;
        });
        var h = (function() {
          function t(t) {
            (this._isScalar = !1), t && (this._subscribe = t);
          }
          return (
            (t.prototype.lift = function(e) {
              var r = new t();
              return (r.source = this), (r.operator = e), r;
            }),
            (t.prototype.subscribe = function(t, e, r) {
              var n = this.operator,
                i = (function(t, e, r) {
                  if (t) {
                    if (t instanceof s.a) return t;
                    if (t[a.a]) return t[a.a]();
                  }
                  return t || e || r ? new s.a(t, e, r) : new s.a(o.a);
                })(t, e, r);
              if (
                (n
                  ? i.add(n.call(i, this.source))
                  : i.add(
                      this.source ||
                        (c.a.useDeprecatedSynchronousErrorHandling &&
                          !i.syncErrorThrowable)
                        ? this._subscribe(i)
                        : this._trySubscribe(i),
                    ),
                c.a.useDeprecatedSynchronousErrorHandling &&
                  i.syncErrorThrowable &&
                  ((i.syncErrorThrowable = !1), i.syncErrorThrown))
              )
                throw i.syncErrorValue;
              return i;
            }),
            (t.prototype._trySubscribe = function(t) {
              try {
                return this._subscribe(t);
              } catch (e) {
                c.a.useDeprecatedSynchronousErrorHandling &&
                  ((t.syncErrorThrown = !0), (t.syncErrorValue = e)),
                  Object(i.a)(t) ? t.error(e) : console.warn(e);
              }
            }),
            (t.prototype.forEach = function(t, e) {
              var r = this;
              return new (e = n(e))(function(e, n) {
                var i;
                i = r.subscribe(
                  function(e) {
                    try {
                      t(e);
                    } catch (t) {
                      n(t), i && i.unsubscribe();
                    }
                  },
                  n,
                  e,
                );
              });
            }),
            (t.prototype._subscribe = function(t) {
              var e = this.source;
              return e && e.subscribe(t);
            }),
            (t.prototype[u.a] = function() {
              return this;
            }),
            (t.prototype.pipe = function() {
              for (var t = [], e = 0; e < arguments.length; e++)
                t[e] = arguments[e];
              return 0 === t.length ? this : Object(l.b)(t)(this);
            }),
            (t.prototype.toPromise = function(t) {
              var e = this;
              return new (t = n(t))(function(t, r) {
                var n;
                e.subscribe(
                  function(t) {
                    return (n = t);
                  },
                  function(t) {
                    return r(t);
                  },
                  function() {
                    return t(n);
                  },
                );
              });
            }),
            (t.create = function(e) {
              return new t(e);
            }),
            t
          );
        })();
      },
      function(t, e, r) {
        function n(t) {
          return t.reduce(function(t, e) {
            return t.concat(e instanceof o.a ? e.errors : e);
          }, []);
        }
        r.d(e, 'a', function() {
          return u;
        });
        var i = r(7),
          s = r(46),
          a = r(23),
          o = r(38),
          u = (function() {
            function t(t) {
              (this.closed = !1),
                (this._parentOrParents = null),
                (this._subscriptions = null),
                t && ((this._ctorUnsubscribe = !0), (this._unsubscribe = t));
            }
            var e;
            return (
              (t.prototype.unsubscribe = function() {
                var e;
                if (!this.closed) {
                  var r = this._parentOrParents,
                    u = this._ctorUnsubscribe,
                    l = this._unsubscribe,
                    c = this._subscriptions;
                  if (
                    ((this.closed = !0),
                    (this._parentOrParents = null),
                    (this._subscriptions = null),
                    r instanceof t)
                  )
                    r.remove(this);
                  else if (null !== r)
                    for (var h = 0; h < r.length; ++h) r[h].remove(this);
                  if (Object(a.a)(l)) {
                    u && (this._unsubscribe = void 0);
                    try {
                      l.call(this);
                    } catch (t) {
                      e = t instanceof o.a ? n(t.errors) : [t];
                    }
                  }
                  if (Object(i.a)(c)) {
                    h = -1;
                    for (var d = c.length; ++h < d; ) {
                      var f = c[h];
                      if (Object(s.a)(f))
                        try {
                          f.unsubscribe();
                        } catch (t) {
                          (e = e || []),
                            t instanceof o.a
                              ? (e = e.concat(n(t.errors)))
                              : e.push(t);
                        }
                    }
                  }
                  if (e) throw new o.a(e);
                }
              }),
              (t.prototype.add = function(e) {
                var r = e;
                if (!e) return t.EMPTY;
                switch (typeof e) {
                  case 'function':
                    r = new t(e);
                  case 'object':
                    if (
                      r === this ||
                      r.closed ||
                      'function' != typeof r.unsubscribe
                    )
                      return r;
                    if (this.closed) return r.unsubscribe(), r;
                    if (!(r instanceof t)) {
                      var n = r;
                      (r = new t())._subscriptions = [n];
                    }
                    break;
                  default:
                    throw new Error(
                      'unrecognized teardown ' + e + ' added to Subscription.',
                    );
                }
                var i = r._parentOrParents;
                if (null === i) r._parentOrParents = this;
                else if (i instanceof t) {
                  if (i === this) return r;
                  r._parentOrParents = [i, this];
                } else {
                  if (-1 !== i.indexOf(this)) return r;
                  i.push(this);
                }
                var s = this._subscriptions;
                return null === s ? (this._subscriptions = [r]) : s.push(r), r;
              }),
              (t.prototype.remove = function(t) {
                var e = this._subscriptions;
                if (e) {
                  var r = e.indexOf(t);
                  -1 !== r && e.splice(r, 1);
                }
              }),
              (t.EMPTY = (((e = new t()).closed = !0), e)),
              t
            );
          })();
      },
      function(t, e, r) {
        r.d(e, 'b', function() {
          return c;
        }),
          r.d(e, 'a', function() {
            return h;
          });
        var n = r(0),
          i = r(3),
          s = r(1),
          a = r(4),
          o = r(21),
          u = r(63),
          l = r(37),
          c = (function(t) {
            function e(e) {
              var r = t.call(this, e) || this;
              return (r.destination = e), r;
            }
            return n.a(e, t), e;
          })(s.a),
          h = (function(t) {
            function e() {
              var e = t.call(this) || this;
              return (
                (e.observers = []),
                (e.closed = !1),
                (e.isStopped = !1),
                (e.hasError = !1),
                (e.thrownError = null),
                e
              );
            }
            return (
              n.a(e, t),
              (e.prototype[l.a] = function() {
                return new c(this);
              }),
              (e.prototype.lift = function(t) {
                var e = new d(this, this);
                return (e.operator = t), e;
              }),
              (e.prototype.next = function(t) {
                if (this.closed) throw new o.a();
                if (!this.isStopped)
                  for (
                    var e = this.observers, r = e.length, n = e.slice(), i = 0;
                    i < r;
                    i++
                  )
                    n[i].next(t);
              }),
              (e.prototype.error = function(t) {
                if (this.closed) throw new o.a();
                (this.hasError = !0),
                  (this.thrownError = t),
                  (this.isStopped = !0);
                for (
                  var e = this.observers, r = e.length, n = e.slice(), i = 0;
                  i < r;
                  i++
                )
                  n[i].error(t);
                this.observers.length = 0;
              }),
              (e.prototype.complete = function() {
                if (this.closed) throw new o.a();
                this.isStopped = !0;
                for (
                  var t = this.observers, e = t.length, r = t.slice(), n = 0;
                  n < e;
                  n++
                )
                  r[n].complete();
                this.observers.length = 0;
              }),
              (e.prototype.unsubscribe = function() {
                (this.isStopped = !0),
                  (this.closed = !0),
                  (this.observers = null);
              }),
              (e.prototype._trySubscribe = function(e) {
                if (this.closed) throw new o.a();
                return t.prototype._trySubscribe.call(this, e);
              }),
              (e.prototype._subscribe = function(t) {
                if (this.closed) throw new o.a();
                return this.hasError
                  ? (t.error(this.thrownError), a.a.EMPTY)
                  : this.isStopped
                  ? (t.complete(), a.a.EMPTY)
                  : (this.observers.push(t), new u.a(this, t));
              }),
              (e.prototype.asObservable = function() {
                var t = new i.a();
                return (t.source = this), t;
              }),
              (e.create = function(t, e) {
                return new d(t, e);
              }),
              e
            );
          })(i.a),
          d = (function(t) {
            function e(e, r) {
              var n = t.call(this) || this;
              return (n.destination = e), (n.source = r), n;
            }
            return (
              n.a(e, t),
              (e.prototype.next = function(t) {
                var e = this.destination;
                e && e.next && e.next(t);
              }),
              (e.prototype.error = function(t) {
                var e = this.destination;
                e && e.error && this.destination.error(t);
              }),
              (e.prototype.complete = function() {
                var t = this.destination;
                t && t.complete && this.destination.complete();
              }),
              (e.prototype._subscribe = function(t) {
                return this.source ? this.source.subscribe(t) : a.a.EMPTY;
              }),
              e
            );
          })(h);
      },
      function(t, e, r) {
        r.d(e, 'b', function() {
          return i;
        }),
          r.d(e, 'a', function() {
            return s;
          });
        var n = r(29),
          i = new (r(27).a)(n.a),
          s = i;
      },
      function(t, e, r) {
        r.d(e, 'a', function() {
          return n;
        });
        var n = (function() {
          return (
            Array.isArray ||
            function(t) {
              return t && 'number' == typeof t.length;
            }
          );
        })();
      },
      function(t, e, r) {
        function n(t, e) {
          return function(r) {
            if ('function' != typeof t)
              throw new TypeError(
                'argument is not a function. Are you looking for `mapTo()`?',
              );
            return r.lift(new a(t, e));
          };
        }
        r.d(e, 'a', function() {
          return n;
        });
        var i = r(0),
          s = r(1),
          a = (function() {
            function t(t, e) {
              (this.project = t), (this.thisArg = e);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new o(t, this.project, this.thisArg));
              }),
              t
            );
          })(),
          o = (function(t) {
            function e(e, r, n) {
              var i = t.call(this, e) || this;
              return (i.project = r), (i.count = 0), (i.thisArg = n || i), i;
            }
            return (
              i.a(e, t),
              (e.prototype._next = function(t) {
                var e;
                try {
                  e = this.project.call(this.thisArg, t, this.count++);
                } catch (t) {
                  return void this.destination.error(t);
                }
                this.destination.next(e);
              }),
              e
            );
          })(s.a);
      },
      function(t, e, r) {
        function n(t) {
          return t && 'function' == typeof t.schedule;
        }
        r.d(e, 'a', function() {
          return n;
        });
      },
      function(t, e, r) {
        function n(t) {
          return t
            ? (function(t) {
                return new i.a(function(e) {
                  return t.schedule(function() {
                    return e.complete();
                  });
                });
              })(t)
            : s;
        }
        r.d(e, 'a', function() {
          return s;
        }),
          r.d(e, 'b', function() {
            return n;
          });
        var i = r(3),
          s = new i.a(function(t) {
            return t.complete();
          });
      },
      function(t, e, r) {
        function n(t, e) {
          return e
            ? Object(a.a)(t, e)
            : t instanceof i.a
            ? t
            : new i.a(Object(s.a)(t));
        }
        r.d(e, 'a', function() {
          return n;
        });
        var i = r(3),
          s = r(32),
          a = r(62);
      },
      function(t, e, r) {
        function n(t, e, r, n, i) {
          if ((void 0 === i && (i = new s(t, r, n)), !i.closed))
            return e instanceof o.a ? e.subscribe(i) : Object(a.a)(e)(i);
        }
        var i = r(0),
          s = (function(t) {
            function e(e, r, n) {
              var i = t.call(this) || this;
              return (
                (i.parent = e),
                (i.outerValue = r),
                (i.outerIndex = n),
                (i.index = 0),
                i
              );
            }
            return (
              i.a(e, t),
              (e.prototype._next = function(t) {
                this.parent.notifyNext(
                  this.outerValue,
                  t,
                  this.outerIndex,
                  this.index++,
                  this,
                );
              }),
              (e.prototype._error = function(t) {
                this.parent.notifyError(t, this), this.unsubscribe();
              }),
              (e.prototype._complete = function() {
                this.parent.notifyComplete(this), this.unsubscribe();
              }),
              e
            );
          })(r(1).a),
          a = r(32),
          o = r(3);
        r.d(e, 'a', function() {
          return n;
        });
      },
      function(t, e, r) {
        r.d(e, 'a', function() {
          return i;
        });
        var n = !1,
          i = {
            Promise: void 0,
            set useDeprecatedSynchronousErrorHandling(t) {
              t && new Error().stack, (n = t);
            },
            get useDeprecatedSynchronousErrorHandling() {
              return n;
            },
          };
      },
      function(t, e, r) {
        function n(t) {
          return t;
        }
        r.d(e, 'a', function() {
          return n;
        });
      },
      function(t, e, r) {
        r.d(e, 'a', function() {
          return i;
        });
        var n = r(0),
          i = (function(t) {
            function e() {
              return (null !== t && t.apply(this, arguments)) || this;
            }
            return (
              n.a(e, t),
              (e.prototype.notifyNext = function(t, e, r, n, i) {
                this.destination.next(e);
              }),
              (e.prototype.notifyError = function(t, e) {
                this.destination.error(t);
              }),
              (e.prototype.notifyComplete = function(t) {
                this.destination.complete();
              }),
              e
            );
          })(r(1).a);
      },
      function(t, e, r) {
        function n(t, e) {
          return function(r) {
            return r.lift(new a(t, e));
          };
        }
        r.d(e, 'a', function() {
          return n;
        });
        var i = r(0),
          s = r(1),
          a = (function() {
            function t(t, e) {
              (this.predicate = t), (this.thisArg = e);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new o(t, this.predicate, this.thisArg));
              }),
              t
            );
          })(),
          o = (function(t) {
            function e(e, r, n) {
              var i = t.call(this, e) || this;
              return (i.predicate = r), (i.thisArg = n), (i.count = 0), i;
            }
            return (
              i.a(e, t),
              (e.prototype._next = function(t) {
                var e;
                try {
                  e = this.predicate.call(this.thisArg, t, this.count++);
                } catch (t) {
                  return void this.destination.error(t);
                }
                e && this.destination.next(t);
              }),
              e
            );
          })(s.a);
      },
      function(t, e, r) {
        r.d(e, 'b', function() {
          return n;
        }),
          r.d(e, 'a', function() {
            return o;
          });
        var n,
          i = r(10),
          s = r(34),
          a = r(41);
        n || (n = {});
        var o = (function() {
          function t(t, e, r) {
            (this.kind = t),
              (this.value = e),
              (this.error = r),
              (this.hasValue = 'N' === t);
          }
          return (
            (t.prototype.observe = function(t) {
              switch (this.kind) {
                case 'N':
                  return t.next && t.next(this.value);
                case 'E':
                  return t.error && t.error(this.error);
                case 'C':
                  return t.complete && t.complete();
              }
            }),
            (t.prototype.do = function(t, e, r) {
              switch (this.kind) {
                case 'N':
                  return t && t(this.value);
                case 'E':
                  return e && e(this.error);
                case 'C':
                  return r && r();
              }
            }),
            (t.prototype.accept = function(t, e, r) {
              return t && 'function' == typeof t.next
                ? this.observe(t)
                : this.do(t, e, r);
            }),
            (t.prototype.toObservable = function() {
              switch (this.kind) {
                case 'N':
                  return Object(s.a)(this.value);
                case 'E':
                  return Object(a.a)(this.error);
                case 'C':
                  return Object(i.b)();
              }
              throw new Error('unexpected notification kind value');
            }),
            (t.createNext = function(e) {
              return void 0 !== e
                ? new t('N', e)
                : t.undefinedValueNotification;
            }),
            (t.createError = function(e) {
              return new t('E', void 0, e);
            }),
            (t.createComplete = function() {
              return t.completeNotification;
            }),
            (t.completeNotification = new t('C')),
            (t.undefinedValueNotification = new t('N', void 0)),
            t
          );
        })();
      },
      function(t, e, r) {
        function n() {
          return 'function' == typeof Symbol && Symbol.iterator
            ? Symbol.iterator
            : '@@iterator';
        }
        r.d(e, 'a', function() {
          return i;
        });
        var i = n();
      },
      function(t, e, r) {
        function n() {}
        r.d(e, 'a', function() {
          return n;
        });
      },
      function(t, e, r) {
        r.d(e, 'a', function() {
          return n;
        });
        var n = (function() {
          return (
            ('function' == typeof Symbol && Symbol.observable) || '@@observable'
          );
        })();
      },
      function(t, e, r) {
        r.d(e, 'a', function() {
          return n;
        });
        var n = (function() {
          function t() {
            return (
              Error.call(this),
              (this.message = 'object unsubscribed'),
              (this.name = 'ObjectUnsubscribedError'),
              this
            );
          }
          return (t.prototype = Object.create(Error.prototype)), t;
        })();
      },
      function(t, e, r) {
        r.d(e, 'a', function() {
          return n;
        });
        var n = (function() {
          function t() {
            return (
              Error.call(this),
              (this.message = 'argument out of range'),
              (this.name = 'ArgumentOutOfRangeError'),
              this
            );
          }
          return (t.prototype = Object.create(Error.prototype)), t;
        })();
      },
      function(t, e, r) {
        function n(t) {
          return 'function' == typeof t;
        }
        r.d(e, 'a', function() {
          return n;
        });
      },
      function(t, e, r) {
        r.d(e, 'a', function() {
          return n;
        });
        var n = (function() {
          function t() {
            return (
              Error.call(this),
              (this.message = 'no elements in sequence'),
              (this.name = 'EmptyError'),
              this
            );
          }
          return (t.prototype = Object.create(Error.prototype)), t;
        })();
      },
      function(t, e, r) {
        function n(t, e, r) {
          return (
            void 0 === r && (r = Number.POSITIVE_INFINITY),
            'function' == typeof e
              ? function(i) {
                  return i.pipe(
                    n(function(r, n) {
                      return Object(a.a)(t(r, n)).pipe(
                        Object(s.a)(function(t, i) {
                          return e(r, t, n, i);
                        }),
                      );
                    }, r),
                  );
                }
              : ('number' == typeof e && (r = e),
                function(e) {
                  return e.lift(new u(t, r));
                })
          );
        }
        r.d(e, 'b', function() {
          return n;
        }),
          r.d(e, 'a', function() {
            return c;
          });
        var i = r(0),
          s = r(8),
          a = r(11),
          o = r(2),
          u = (function() {
            function t(t, e) {
              void 0 === e && (e = Number.POSITIVE_INFINITY),
                (this.project = t),
                (this.concurrent = e);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new l(t, this.project, this.concurrent));
              }),
              t
            );
          })(),
          l = (function(t) {
            function e(e, r, n) {
              void 0 === n && (n = Number.POSITIVE_INFINITY);
              var i = t.call(this, e) || this;
              return (
                (i.project = r),
                (i.concurrent = n),
                (i.hasCompleted = !1),
                (i.buffer = []),
                (i.active = 0),
                (i.index = 0),
                i
              );
            }
            return (
              i.a(e, t),
              (e.prototype._next = function(t) {
                this.active < this.concurrent
                  ? this._tryNext(t)
                  : this.buffer.push(t);
              }),
              (e.prototype._tryNext = function(t) {
                var e,
                  r = this.index++;
                try {
                  e = this.project(t, r);
                } catch (t) {
                  return void this.destination.error(t);
                }
                this.active++, this._innerSub(e);
              }),
              (e.prototype._innerSub = function(t) {
                var e = new o.a(this),
                  r = this.destination;
                r.add(e);
                var n = Object(o.c)(t, e);
                n !== e && r.add(n);
              }),
              (e.prototype._complete = function() {
                (this.hasCompleted = !0),
                  0 === this.active &&
                    0 === this.buffer.length &&
                    this.destination.complete(),
                  this.unsubscribe();
              }),
              (e.prototype.notifyNext = function(t) {
                this.destination.next(t);
              }),
              (e.prototype.notifyComplete = function() {
                var t = this.buffer;
                this.active--,
                  t.length > 0
                    ? this._next(t.shift())
                    : 0 === this.active &&
                      this.hasCompleted &&
                      this.destination.complete();
              }),
              e
            );
          })(o.b),
          c = n;
      },
      function(t, e, r) {
        function n(t, e) {
          return e ? Object(a.a)(t, e) : new i.a(Object(s.a)(t));
        }
        r.d(e, 'a', function() {
          return n;
        });
        var i = r(3),
          s = r(64),
          a = r(48);
      },
      function(t, e, r) {
        r.d(e, 'a', function() {
          return s;
        });
        var n = r(0),
          i = r(51),
          s = (function(t) {
            function e(r, n) {
              void 0 === n && (n = i.a.now);
              var s =
                t.call(this, r, function() {
                  return e.delegate && e.delegate !== s
                    ? e.delegate.now()
                    : n();
                }) || this;
              return (
                (s.actions = []), (s.active = !1), (s.scheduled = void 0), s
              );
            }
            return (
              n.a(e, t),
              (e.prototype.schedule = function(r, n, i) {
                return (
                  void 0 === n && (n = 0),
                  e.delegate && e.delegate !== this
                    ? e.delegate.schedule(r, n, i)
                    : t.prototype.schedule.call(this, r, n, i)
                );
              }),
              (e.prototype.flush = function(t) {
                var e = this.actions;
                if (this.active) e.push(t);
                else {
                  var r;
                  this.active = !0;
                  do {
                    if ((r = t.execute(t.state, t.delay))) break;
                  } while ((t = e.shift()));
                  if (((this.active = !1), r)) {
                    for (; (t = e.shift()); ) t.unsubscribe();
                    throw r;
                  }
                }
              }),
              e
            );
          })(i.a);
      },
      function(t, e, r) {
        r.d(e, 'a', function() {
          return a;
        });
        var n = r(0),
          i = r(5),
          s = r(4),
          a = (function(t) {
            function e() {
              var e = (null !== t && t.apply(this, arguments)) || this;
              return (
                (e.value = null), (e.hasNext = !1), (e.hasCompleted = !1), e
              );
            }
            return (
              n.a(e, t),
              (e.prototype._subscribe = function(e) {
                return this.hasError
                  ? (e.error(this.thrownError), s.a.EMPTY)
                  : this.hasCompleted && this.hasNext
                  ? (e.next(this.value), e.complete(), s.a.EMPTY)
                  : t.prototype._subscribe.call(this, e);
              }),
              (e.prototype.next = function(t) {
                this.hasCompleted || ((this.value = t), (this.hasNext = !0));
              }),
              (e.prototype.error = function(e) {
                this.hasCompleted || t.prototype.error.call(this, e);
              }),
              (e.prototype.complete = function() {
                (this.hasCompleted = !0),
                  this.hasNext && t.prototype.next.call(this, this.value),
                  t.prototype.complete.call(this);
              }),
              e
            );
          })(i.a);
      },
      function(t, e, r) {
        var n = r(0),
          i = (function(t) {
            function e(e, r) {
              return t.call(this) || this;
            }
            return (
              n.a(e, t),
              (e.prototype.schedule = function(t, e) {
                return void 0 === e && (e = 0), this;
              }),
              e
            );
          })(r(4).a);
        r.d(e, 'a', function() {
          return s;
        });
        var s = (function(t) {
          function e(e, r) {
            var n = t.call(this, e, r) || this;
            return (n.scheduler = e), (n.work = r), (n.pending = !1), n;
          }
          return (
            n.a(e, t),
            (e.prototype.schedule = function(t, e) {
              if ((void 0 === e && (e = 0), this.closed)) return this;
              this.state = t;
              var r = this.id,
                n = this.scheduler;
              return (
                null != r && (this.id = this.recycleAsyncId(n, r, e)),
                (this.pending = !0),
                (this.delay = e),
                (this.id = this.id || this.requestAsyncId(n, this.id, e)),
                this
              );
            }),
            (e.prototype.requestAsyncId = function(t, e, r) {
              return (
                void 0 === r && (r = 0), setInterval(t.flush.bind(t, this), r)
              );
            }),
            (e.prototype.recycleAsyncId = function(t, e, r) {
              if (
                (void 0 === r && (r = 0),
                null !== r && this.delay === r && !1 === this.pending)
              )
                return e;
              clearInterval(e);
            }),
            (e.prototype.execute = function(t, e) {
              if (this.closed) return new Error('executing a cancelled action');
              this.pending = !1;
              var r = this._execute(t, e);
              if (r) return r;
              !1 === this.pending &&
                null != this.id &&
                (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
            }),
            (e.prototype._execute = function(t, e) {
              var r = !1,
                n = void 0;
              try {
                this.work(t);
              } catch (t) {
                (r = !0), (n = (!!t && t) || new Error(t));
              }
              if (r) return this.unsubscribe(), n;
            }),
            (e.prototype._unsubscribe = function() {
              var t = this.id,
                e = this.scheduler,
                r = e.actions,
                n = r.indexOf(this);
              (this.work = null),
                (this.state = null),
                (this.pending = !1),
                (this.scheduler = null),
                -1 !== n && r.splice(n, 1),
                null != t && (this.id = this.recycleAsyncId(e, t, null)),
                (this.delay = null);
            }),
            e
          );
        })(i);
      },
      function(t, e, r) {
        function n(t) {
          return !Object(i.a)(t) && t - parseFloat(t) + 1 >= 0;
        }
        r.d(e, 'a', function() {
          return n;
        });
        var i = r(7);
      },
      function(t, e, r) {
        function n() {
          for (var t = [], e = 0; e < arguments.length; e++)
            t[e] = arguments[e];
          return Object(s.a)()(i.a.apply(void 0, t));
        }
        r.d(e, 'a', function() {
          return n;
        });
        var i = r(34),
          s = r(58);
      },
      function(t, e, r) {
        var n = r(64),
          i = r(33),
          s = r(18),
          a = r(20),
          o = r(65),
          u = r(66),
          l = r(46);
        r.d(e, 'a', function() {
          return c;
        });
        var c = function(t) {
          if (t && 'function' == typeof t[a.a])
            return (
              (c = t),
              function(t) {
                var e = c[a.a]();
                if ('function' != typeof e.subscribe)
                  throw new TypeError(
                    'Provided object does not correctly implement Symbol.observable',
                  );
                return e.subscribe(t);
              }
            );
          if (Object(o.a)(t)) return Object(n.a)(t);
          if (Object(u.a)(t))
            return (
              (r = t),
              function(t) {
                return (
                  r
                    .then(
                      function(e) {
                        t.closed || (t.next(e), t.complete());
                      },
                      function(e) {
                        return t.error(e);
                      },
                    )
                    .then(null, i.a),
                  t
                );
              }
            );
          if (t && 'function' == typeof t[s.a])
            return (
              (e = t),
              function(t) {
                for (var r = e[s.a](); ; ) {
                  var n = void 0;
                  try {
                    n = r.next();
                  } catch (e) {
                    return t.error(e), t;
                  }
                  if (n.done) {
                    t.complete();
                    break;
                  }
                  if ((t.next(n.value), t.closed)) break;
                }
                return (
                  'function' == typeof r.return &&
                    t.add(function() {
                      r.return && r.return();
                    }),
                  t
                );
              }
            );
          var e,
            r,
            c,
            h = Object(l.a)(t) ? 'an invalid object' : "'" + t + "'";
          throw new TypeError(
            'You provided ' +
              h +
              ' where a stream was expected. You can provide an Observable, Promise, Array, or Iterable.',
          );
        };
      },
      function(t, e, r) {
        function n(t) {
          setTimeout(function() {
            throw t;
          }, 0);
        }
        r.d(e, 'a', function() {
          return n;
        });
      },
      function(t, e, r) {
        function n() {
          for (var t = [], e = 0; e < arguments.length; e++)
            t[e] = arguments[e];
          var r = t[t.length - 1];
          return Object(i.a)(r) ? (t.pop(), Object(a.a)(t, r)) : Object(s.a)(t);
        }
        r.d(e, 'a', function() {
          return n;
        });
        var i = r(9),
          s = r(26),
          a = r(48);
      },
      function(t, e, r) {
        function n() {
          for (var t = [], e = 0; e < arguments.length; e++)
            t[e] = arguments[e];
          return i(t);
        }
        function i(t) {
          return 0 === t.length
            ? s.a
            : 1 === t.length
            ? t[0]
            : function(e) {
                return t.reduce(function(t, e) {
                  return e(t);
                }, e);
              };
        }
        r.d(e, 'a', function() {
          return n;
        }),
          r.d(e, 'b', function() {
            return i;
          });
        var s = r(14);
      },
      function(t, e, r) {
        function n(t) {
          return t in o && (delete o[t], !0);
        }
        var i = r(0),
          s = 1,
          a = (function() {
            return Promise.resolve();
          })(),
          o = {},
          u = (function(t) {
            function e(e, r) {
              var n = t.call(this, e, r) || this;
              return (n.scheduler = e), (n.work = r), n;
            }
            return (
              i.a(e, t),
              (e.prototype.requestAsyncId = function(e, r, i) {
                return (
                  void 0 === i && (i = 0),
                  null !== i && i > 0
                    ? t.prototype.requestAsyncId.call(this, e, r, i)
                    : (e.actions.push(this),
                      e.scheduled ||
                        (e.scheduled =
                          ((u = e.flush.bind(e, null)),
                          (l = s++),
                          (o[l] = !0),
                          a.then(function() {
                            return n(l) && u();
                          }),
                          l)))
                );
                var u, l;
              }),
              (e.prototype.recycleAsyncId = function(e, r, i) {
                if (
                  (void 0 === i && (i = 0),
                  (null !== i && i > 0) || (null === i && this.delay > 0))
                )
                  return t.prototype.recycleAsyncId.call(this, e, r, i);
                0 === e.actions.length && (n(r), (e.scheduled = void 0));
              }),
              e
            );
          })(r(29).a),
          l = (function(t) {
            function e() {
              return (null !== t && t.apply(this, arguments)) || this;
            }
            return (
              i.a(e, t),
              (e.prototype.flush = function(t) {
                (this.active = !0), (this.scheduled = void 0);
                var e,
                  r = this.actions,
                  n = -1,
                  i = r.length;
                t = t || r.shift();
                do {
                  if ((e = t.execute(t.state, t.delay))) break;
                } while (++n < i && (t = r.shift()));
                if (((this.active = !1), e)) {
                  for (; ++n < i && (t = r.shift()); ) t.unsubscribe();
                  throw e;
                }
              }),
              e
            );
          })(r(27).a);
        r.d(e, 'b', function() {
          return c;
        }),
          r.d(e, 'a', function() {
            return h;
          });
        var c = new l(u),
          h = c;
      },
      function(t, e, r) {
        r.d(e, 'a', function() {
          return n;
        });
        var n = (function() {
          return 'function' == typeof Symbol
            ? Symbol('rxSubscriber')
            : '@@rxSubscriber_' + Math.random();
        })();
      },
      function(t, e, r) {
        r.d(e, 'a', function() {
          return n;
        });
        var n = (function() {
          function t(t) {
            return (
              Error.call(this),
              (this.message = t
                ? t.length +
                  ' errors occurred during unsubscription:\n' +
                  t
                    .map(function(t, e) {
                      return e + 1 + ') ' + t.toString();
                    })
                    .join('\n  ')
                : ''),
              (this.name = 'UnsubscriptionError'),
              (this.errors = t),
              this
            );
          }
          return (t.prototype = Object.create(Error.prototype)), t;
        })();
      },
      function(t, e, r) {
        function n() {
          return function(t) {
            return t.lift(new a(t));
          };
        }
        r.d(e, 'a', function() {
          return n;
        });
        var i = r(0),
          s = r(1),
          a = (function() {
            function t(t) {
              this.connectable = t;
            }
            return (
              (t.prototype.call = function(t, e) {
                var r = this.connectable;
                r._refCount++;
                var n = new o(t, r),
                  i = e.subscribe(n);
                return n.closed || (n.connection = r.connect()), i;
              }),
              t
            );
          })(),
          o = (function(t) {
            function e(e, r) {
              var n = t.call(this, e) || this;
              return (n.connectable = r), n;
            }
            return (
              i.a(e, t),
              (e.prototype._unsubscribe = function() {
                var t = this.connectable;
                if (t) {
                  this.connectable = null;
                  var e = t._refCount;
                  if (e <= 0) this.connection = null;
                  else if (((t._refCount = e - 1), e > 1))
                    this.connection = null;
                  else {
                    var r = this.connection,
                      n = t._connection;
                    (this.connection = null),
                      !n || (r && n !== r) || n.unsubscribe();
                  }
                } else this.connection = null;
              }),
              e
            );
          })(s.a);
      },
      function(t, e, r) {
        r.d(e, 'a', function() {
          return c;
        });
        var n = r(0),
          i = r(5),
          s = r(50),
          a = r(4),
          o = r(56),
          u = r(21),
          l = r(63),
          c = (function(t) {
            function e(e, r, n) {
              void 0 === e && (e = Number.POSITIVE_INFINITY),
                void 0 === r && (r = Number.POSITIVE_INFINITY);
              var i = t.call(this) || this;
              return (
                (i.scheduler = n),
                (i._events = []),
                (i._infiniteTimeWindow = !1),
                (i._bufferSize = e < 1 ? 1 : e),
                (i._windowTime = r < 1 ? 1 : r),
                r === Number.POSITIVE_INFINITY
                  ? ((i._infiniteTimeWindow = !0),
                    (i.next = i.nextInfiniteTimeWindow))
                  : (i.next = i.nextTimeWindow),
                i
              );
            }
            return (
              n.a(e, t),
              (e.prototype.nextInfiniteTimeWindow = function(e) {
                if (!this.isStopped) {
                  var r = this._events;
                  r.push(e), r.length > this._bufferSize && r.shift();
                }
                t.prototype.next.call(this, e);
              }),
              (e.prototype.nextTimeWindow = function(e) {
                this.isStopped ||
                  (this._events.push(new h(this._getNow(), e)),
                  this._trimBufferThenGetEvents()),
                  t.prototype.next.call(this, e);
              }),
              (e.prototype._subscribe = function(t) {
                var e,
                  r = this._infiniteTimeWindow,
                  n = r ? this._events : this._trimBufferThenGetEvents(),
                  i = this.scheduler,
                  s = n.length;
                if (this.closed) throw new u.a();
                if (
                  (this.isStopped || this.hasError
                    ? (e = a.a.EMPTY)
                    : (this.observers.push(t), (e = new l.a(this, t))),
                  i && t.add((t = new o.a(t, i))),
                  r)
                )
                  for (var c = 0; c < s && !t.closed; c++) t.next(n[c]);
                else for (c = 0; c < s && !t.closed; c++) t.next(n[c].value);
                return (
                  this.hasError
                    ? t.error(this.thrownError)
                    : this.isStopped && t.complete(),
                  e
                );
              }),
              (e.prototype._getNow = function() {
                return (this.scheduler || s.a).now();
              }),
              (e.prototype._trimBufferThenGetEvents = function() {
                for (
                  var t = this._getNow(),
                    e = this._bufferSize,
                    r = this._windowTime,
                    n = this._events,
                    i = n.length,
                    s = 0;
                  s < i && !(t - n[s].time < r);

                )
                  s++;
                return (
                  i > e && (s = Math.max(s, i - e)), s > 0 && n.splice(0, s), n
                );
              }),
              e
            );
          })(i.a),
          h = (function() {
            return function(t, e) {
              (this.time = t), (this.value = e);
            };
          })();
      },
      function(t, e, r) {
        function n(t, e) {
          return e
            ? new s.a(function(r) {
                return e.schedule(i, 0, { error: t, subscriber: r });
              })
            : new s.a(function(e) {
                return e.error(t);
              });
        }
        function i(t) {
          var e = t.error;
          t.subscriber.error(e);
        }
        r.d(e, 'a', function() {
          return n;
        });
        var s = r(3);
      },
      function(t, e, r) {
        function n() {
          for (var t = [], e = 0; e < arguments.length; e++)
            t[e] = arguments[e];
          var r = void 0,
            n = void 0;
          return (
            Object(s.a)(t[t.length - 1]) && (n = t.pop()),
            'function' == typeof t[t.length - 1] && (r = t.pop()),
            1 === t.length && Object(a.a)(t[0]) && (t = t[0]),
            Object(l.a)(t, n).lift(new h(r))
          );
        }
        r.d(e, 'b', function() {
          return n;
        }),
          r.d(e, 'a', function() {
            return h;
          });
        var i = r(0),
          s = r(9),
          a = r(7),
          o = r(15),
          u = r(12),
          l = r(26),
          c = {},
          h = (function() {
            function t(t) {
              this.resultSelector = t;
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new d(t, this.resultSelector));
              }),
              t
            );
          })(),
          d = (function(t) {
            function e(e, r) {
              var n = t.call(this, e) || this;
              return (
                (n.resultSelector = r),
                (n.active = 0),
                (n.values = []),
                (n.observables = []),
                n
              );
            }
            return (
              i.a(e, t),
              (e.prototype._next = function(t) {
                this.values.push(c), this.observables.push(t);
              }),
              (e.prototype._complete = function() {
                var t = this.observables,
                  e = t.length;
                if (0 === e) this.destination.complete();
                else {
                  (this.active = e), (this.toRespond = e);
                  for (var r = 0; r < e; r++) {
                    var n = t[r];
                    this.add(Object(u.a)(this, n, void 0, r));
                  }
                }
              }),
              (e.prototype.notifyComplete = function(t) {
                0 == (this.active -= 1) && this.destination.complete();
              }),
              (e.prototype.notifyNext = function(t, e, r) {
                var n = this.values,
                  i = n[r],
                  s = this.toRespond
                    ? i === c
                      ? --this.toRespond
                      : this.toRespond
                    : 0;
                (n[r] = e),
                  0 === s &&
                    (this.resultSelector
                      ? this._tryResultSelector(n)
                      : this.destination.next(n.slice()));
              }),
              (e.prototype._tryResultSelector = function(t) {
                var e;
                try {
                  e = this.resultSelector.apply(this, t);
                } catch (t) {
                  return void this.destination.error(t);
                }
                this.destination.next(e);
              }),
              e
            );
          })(o.a);
      },
      function(t, e, r) {
        function n(t) {
          return (
            void 0 === t && (t = Number.POSITIVE_INFINITY), Object(i.b)(s.a, t)
          );
        }
        r.d(e, 'a', function() {
          return n;
        });
        var i = r(25),
          s = r(14);
      },
      function(t, e, r) {
        function n(t) {
          return new i.a(function(e) {
            var r;
            try {
              r = t();
            } catch (t) {
              return void e.error(t);
            }
            return (r ? Object(s.a)(r) : Object(a.b)()).subscribe(e);
          });
        }
        r.d(e, 'a', function() {
          return n;
        });
        var i = r(3),
          s = r(11),
          a = r(10);
      },
      function(t, e, r) {
        function n() {
          for (var t = [], e = 0; e < arguments.length; e++)
            t[e] = arguments[e];
          var r = t[t.length - 1];
          return (
            'function' == typeof r && t.pop(),
            Object(s.a)(t, void 0).lift(new c(r))
          );
        }
        r.d(e, 'b', function() {
          return n;
        }),
          r.d(e, 'a', function() {
            return c;
          });
        var i = r(0),
          s = r(26),
          a = r(7),
          o = r(1),
          u = r(18),
          l = r(2),
          c = (function() {
            function t(t) {
              this.resultSelector = t;
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new h(t, this.resultSelector));
              }),
              t
            );
          })(),
          h = (function(t) {
            function e(e, r, n) {
              void 0 === n && (n = Object.create(null));
              var i = t.call(this, e) || this;
              return (
                (i.resultSelector = r),
                (i.iterators = []),
                (i.active = 0),
                (i.resultSelector = 'function' == typeof r ? r : void 0),
                i
              );
            }
            return (
              i.a(e, t),
              (e.prototype._next = function(t) {
                var e = this.iterators;
                Object(a.a)(t)
                  ? e.push(new f(t))
                  : 'function' == typeof t[u.a]
                  ? e.push(new d(t[u.a]()))
                  : e.push(new p(this.destination, this, t));
              }),
              (e.prototype._complete = function() {
                var t = this.iterators,
                  e = t.length;
                if ((this.unsubscribe(), 0 !== e)) {
                  this.active = e;
                  for (var r = 0; r < e; r++) {
                    var n = t[r];
                    n.stillUnsubscribed
                      ? this.destination.add(n.subscribe())
                      : this.active--;
                  }
                } else this.destination.complete();
              }),
              (e.prototype.notifyInactive = function() {
                this.active--, 0 === this.active && this.destination.complete();
              }),
              (e.prototype.checkIterators = function() {
                for (
                  var t = this.iterators,
                    e = t.length,
                    r = this.destination,
                    n = 0;
                  n < e;
                  n++
                )
                  if ('function' == typeof (a = t[n]).hasValue && !a.hasValue())
                    return;
                var i = !1,
                  s = [];
                for (n = 0; n < e; n++) {
                  var a,
                    o = (a = t[n]).next();
                  if ((a.hasCompleted() && (i = !0), o.done))
                    return void r.complete();
                  s.push(o.value);
                }
                this.resultSelector ? this._tryresultSelector(s) : r.next(s),
                  i && r.complete();
              }),
              (e.prototype._tryresultSelector = function(t) {
                var e;
                try {
                  e = this.resultSelector.apply(this, t);
                } catch (t) {
                  return void this.destination.error(t);
                }
                this.destination.next(e);
              }),
              e
            );
          })(o.a),
          d = (function() {
            function t(t) {
              (this.iterator = t), (this.nextResult = t.next());
            }
            return (
              (t.prototype.hasValue = function() {
                return !0;
              }),
              (t.prototype.next = function() {
                var t = this.nextResult;
                return (this.nextResult = this.iterator.next()), t;
              }),
              (t.prototype.hasCompleted = function() {
                var t = this.nextResult;
                return Boolean(t && t.done);
              }),
              t
            );
          })(),
          f = (function() {
            function t(t) {
              (this.array = t),
                (this.index = 0),
                (this.length = 0),
                (this.length = t.length);
            }
            return (
              (t.prototype[u.a] = function() {
                return this;
              }),
              (t.prototype.next = function(t) {
                var e = this.index++,
                  r = this.array;
                return e < this.length
                  ? { value: r[e], done: !1 }
                  : { value: null, done: !0 };
              }),
              (t.prototype.hasValue = function() {
                return this.array.length > this.index;
              }),
              (t.prototype.hasCompleted = function() {
                return this.array.length === this.index;
              }),
              t
            );
          })(),
          p = (function(t) {
            function e(e, r, n) {
              var i = t.call(this, e) || this;
              return (
                (i.parent = r),
                (i.observable = n),
                (i.stillUnsubscribed = !0),
                (i.buffer = []),
                (i.isComplete = !1),
                i
              );
            }
            return (
              i.a(e, t),
              (e.prototype[u.a] = function() {
                return this;
              }),
              (e.prototype.next = function() {
                var t = this.buffer;
                return 0 === t.length && this.isComplete
                  ? { value: null, done: !0 }
                  : { value: t.shift(), done: !1 };
              }),
              (e.prototype.hasValue = function() {
                return this.buffer.length > 0;
              }),
              (e.prototype.hasCompleted = function() {
                return 0 === this.buffer.length && this.isComplete;
              }),
              (e.prototype.notifyComplete = function() {
                this.buffer.length > 0
                  ? ((this.isComplete = !0), this.parent.notifyInactive())
                  : this.destination.complete();
              }),
              (e.prototype.notifyNext = function(t) {
                this.buffer.push(t), this.parent.checkIterators();
              }),
              (e.prototype.subscribe = function() {
                return Object(l.c)(this.observable, new l.a(this));
              }),
              e
            );
          })(l.b);
      },
      function(t, e, r) {
        function n(t) {
          return null !== t && 'object' == typeof t;
        }
        r.d(e, 'a', function() {
          return n;
        });
      },
      function(t, e, r) {
        function n(t) {
          for (; t; ) {
            var e = t,
              r = e.closed,
              n = e.destination,
              s = e.isStopped;
            if (r || s) return !1;
            t = n && n instanceof i.a ? n : null;
          }
          return !0;
        }
        r.d(e, 'a', function() {
          return n;
        });
        var i = r(1);
      },
      function(t, e, r) {
        function n(t, e) {
          return new i.a(function(r) {
            var n = new s.a(),
              i = 0;
            return (
              n.add(
                e.schedule(function() {
                  i !== t.length
                    ? (r.next(t[i++]), r.closed || n.add(this.schedule()))
                    : r.complete();
                }),
              ),
              n
            );
          });
        }
        r.d(e, 'a', function() {
          return n;
        });
        var i = r(3),
          s = r(4);
      },
      function(t, e, r) {
        r.d(e, 'a', function() {
          return s;
        });
        var n = r(13),
          i = r(33),
          s = {
            closed: !0,
            next: function(t) {},
            error: function(t) {
              if (n.a.useDeprecatedSynchronousErrorHandling) throw t;
              Object(i.a)(t);
            },
            complete: function() {},
          };
      },
      function(t, e, r) {
        var n = r(0),
          i = (function(t) {
            function e(e, r) {
              var n = t.call(this, e, r) || this;
              return (n.scheduler = e), (n.work = r), n;
            }
            return (
              n.a(e, t),
              (e.prototype.schedule = function(e, r) {
                return (
                  void 0 === r && (r = 0),
                  r > 0
                    ? t.prototype.schedule.call(this, e, r)
                    : ((this.delay = r),
                      (this.state = e),
                      this.scheduler.flush(this),
                      this)
                );
              }),
              (e.prototype.execute = function(e, r) {
                return r > 0 || this.closed
                  ? t.prototype.execute.call(this, e, r)
                  : this._execute(e, r);
              }),
              (e.prototype.requestAsyncId = function(e, r, n) {
                return (
                  void 0 === n && (n = 0),
                  (null !== n && n > 0) || (null === n && this.delay > 0)
                    ? t.prototype.requestAsyncId.call(this, e, r, n)
                    : e.flush(this)
                );
              }),
              e
            );
          })(r(29).a),
          s = (function(t) {
            function e() {
              return (null !== t && t.apply(this, arguments)) || this;
            }
            return n.a(e, t), e;
          })(r(27).a);
        r.d(e, 'b', function() {
          return a;
        }),
          r.d(e, 'a', function() {
            return o;
          });
        var a = new s(i),
          o = a;
      },
      function(t, e, r) {
        r.d(e, 'a', function() {
          return n;
        });
        var n = (function() {
          function t(e, r) {
            void 0 === r && (r = t.now),
              (this.SchedulerAction = e),
              (this.now = r);
          }
          return (
            (t.prototype.schedule = function(t, e, r) {
              return (
                void 0 === e && (e = 0),
                new this.SchedulerAction(this, t).schedule(r, e)
              );
            }),
            (t.now = function() {
              return Date.now();
            }),
            t
          );
        })();
      },
      function(t, e, r) {
        function n(t, e, r, n) {
          return function(i) {
            return i.lift(new l(t, e, r, n));
          };
        }
        r.d(e, 'b', function() {
          return n;
        }),
          r.d(e, 'a', function() {
            return d;
          });
        var i = r(0),
          s = r(1),
          a = r(4),
          o = r(3),
          u = r(5),
          l = (function() {
            function t(t, e, r, n) {
              (this.keySelector = t),
                (this.elementSelector = e),
                (this.durationSelector = r),
                (this.subjectSelector = n);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(
                  new c(
                    t,
                    this.keySelector,
                    this.elementSelector,
                    this.durationSelector,
                    this.subjectSelector,
                  ),
                );
              }),
              t
            );
          })(),
          c = (function(t) {
            function e(e, r, n, i, s) {
              var a = t.call(this, e) || this;
              return (
                (a.keySelector = r),
                (a.elementSelector = n),
                (a.durationSelector = i),
                (a.subjectSelector = s),
                (a.groups = null),
                (a.attemptedToUnsubscribe = !1),
                (a.count = 0),
                a
              );
            }
            return (
              i.a(e, t),
              (e.prototype._next = function(t) {
                var e;
                try {
                  e = this.keySelector(t);
                } catch (t) {
                  return void this.error(t);
                }
                this._group(t, e);
              }),
              (e.prototype._group = function(t, e) {
                var r = this.groups;
                r || (r = this.groups = new Map());
                var n,
                  i = r.get(e);
                if (this.elementSelector)
                  try {
                    n = this.elementSelector(t);
                  } catch (t) {
                    this.error(t);
                  }
                else n = t;
                if (!i) {
                  (i = this.subjectSelector
                    ? this.subjectSelector()
                    : new u.a()),
                    r.set(e, i);
                  var s = new d(e, i, this);
                  if ((this.destination.next(s), this.durationSelector)) {
                    var a = void 0;
                    try {
                      a = this.durationSelector(new d(e, i));
                    } catch (t) {
                      return void this.error(t);
                    }
                    this.add(a.subscribe(new h(e, i, this)));
                  }
                }
                i.closed || i.next(n);
              }),
              (e.prototype._error = function(t) {
                var e = this.groups;
                e &&
                  (e.forEach(function(e, r) {
                    e.error(t);
                  }),
                  e.clear()),
                  this.destination.error(t);
              }),
              (e.prototype._complete = function() {
                var t = this.groups;
                t &&
                  (t.forEach(function(t, e) {
                    t.complete();
                  }),
                  t.clear()),
                  this.destination.complete();
              }),
              (e.prototype.removeGroup = function(t) {
                this.groups.delete(t);
              }),
              (e.prototype.unsubscribe = function() {
                this.closed ||
                  ((this.attemptedToUnsubscribe = !0),
                  0 === this.count && t.prototype.unsubscribe.call(this));
              }),
              e
            );
          })(s.a),
          h = (function(t) {
            function e(e, r, n) {
              var i = t.call(this, r) || this;
              return (i.key = e), (i.group = r), (i.parent = n), i;
            }
            return (
              i.a(e, t),
              (e.prototype._next = function(t) {
                this.complete();
              }),
              (e.prototype._unsubscribe = function() {
                var t = this.parent,
                  e = this.key;
                (this.key = this.parent = null), t && t.removeGroup(e);
              }),
              e
            );
          })(s.a),
          d = (function(t) {
            function e(e, r, n) {
              var i = t.call(this) || this;
              return (
                (i.key = e),
                (i.groupSubject = r),
                (i.refCountSubscription = n),
                i
              );
            }
            return (
              i.a(e, t),
              (e.prototype._subscribe = function(t) {
                var e = new a.a(),
                  r = this.refCountSubscription,
                  n = this.groupSubject;
                return (
                  r && !r.closed && e.add(new f(r)), e.add(n.subscribe(t)), e
                );
              }),
              e
            );
          })(o.a),
          f = (function(t) {
            function e(e) {
              var r = t.call(this) || this;
              return (r.parent = e), e.count++, r;
            }
            return (
              i.a(e, t),
              (e.prototype.unsubscribe = function() {
                var e = this.parent;
                e.closed ||
                  this.closed ||
                  (t.prototype.unsubscribe.call(this),
                  (e.count -= 1),
                  0 === e.count && e.attemptedToUnsubscribe && e.unsubscribe());
              }),
              e
            );
          })(a.a);
      },
      function(t, e, r) {
        e.__esModule = !0;
        var n = (function() {
          function t() {}
          return (
            (t.IDLE = 'IDLE'),
            (t.LOADING = 'LOADING'),
            (t.LOADED = 'LOADED'),
            (t.ERROR = 'ERROR'),
            (t.PLAY = 'PLAY'),
            (t.READY = 'READY'),
            (t.PLAYING = 'PLAYING'),
            (t.PLAYED = 'PLAYED'),
            (t.STOPPED = 'STOPPED'),
            (t.BUFFERING = 'BUFFERING'),
            (t.BUFFERED = 'BUFFERED'),
            (t.SEEKING = 'SEEKING'),
            (t.SEEK = 'SEEK'),
            (t.PRELOADING = 'PRELOADING'),
            (t.PAUSED = 'PAUSED'),
            (t.PAUSED_BY_SAFARI = 'PAUSED_BY_SAFARI'),
            (t.FINISHED = 'FINISHED'),
            (t.HLS = 'hls'),
            (t.MIN_VOLUME_VALUE = 0),
            (t.MID_VOLUME_VALUE = 50),
            (t.MAX_VOLUME_VALUE = 100),
            (t.PLAYLIST_SIZE_LARGE = 'LARGE'),
            (t.PLAYLIST_SIZE_MEDIUM = 'MEDIUM'),
            (t.PLAYLIST_SIZE_SMALL = 'SMALL'),
            (t.HTML5_PLAYER = 'html5'),
            (t.FLASH_PLAYER = 'web'),
            t
          );
        })();
        e.PlayerConstants = n;
        var i = (function() {
          function t() {}
          return (
            (t.READY = 'ready'),
            (t.MANIFEST = 'manifest'),
            (t.COMPLETE = 'complete'),
            (t.ERROR = 'error'),
            (t.STATE = 'state'),
            (t.POSITION = 'position'),
            (t.SEEK_STATE = 'seekState'),
            (t.PLAYING = 'fragmentPlaying'),
            t
          );
        })();
        e.FlashEvents = i;
        var s = (function() {
          function t() {}
          return (
            (t.PLAYING = 'PLAYING'),
            (t.PAUSED = 'PAUSED'),
            (t.PAUSED_BUFFERING = 'PAUSED_BUFFERING'),
            (t.PLAYING_BUFFERING = 'PLAYING_BUFFERING'),
            (t.SEEKED = 'SEEKED'),
            t
          );
        })();
        e.FlashStates = s;
        var a = (function() {
          function t() {}
          return (
            (t.DURATION_CHANGE = 'durationchange'),
            (t.WAITING = 'waiting'),
            (t.CAN_PLAY = 'canplay'),
            (t.ENDED = 'ended'),
            (t.SEEKING = 'seeking'),
            (t.SEEKED = 'seeked'),
            (t.PLAY = 'play'),
            (t.PLAYING = 'playing'),
            (t.PAUSE = 'pause'),
            (t.TIME_UPDATE = 'timeupdate'),
            (t.STALLED = 'stalled'),
            (t.LOAD_META_DATA = 'loadedmetadata'),
            (t.LOADED_DATA = 'loadeddata'),
            (t.CAN_PLAY_THROUGH = 'canplaythrough'),
            (t.ERROR = 'error'),
            (t.LOAD_START = 'loadstart'),
            t
          );
        })();
        e.HTMLMediaEvents = a;
        var o = (function() {
          function t() {}
          return (
            (t.PLAYBACK_READY = 'playbackready'),
            (t.PLAYER_CREATED = 'playercreated'),
            (t.PLAYING = 'playing'),
            (t.PAUSED = 'paused'),
            (t.LOAD_START = 'loadstart'),
            (t.PLAYHEAD_TIME_CHANGED = 'playheadtimechanged'),
            (t.SEEKED = 'seeked'),
            (t.PLAYBACK_COMPLETE = 'playbackcomplete'),
            (t.STALLED = 'stalled'),
            (t.AUTOPLAY_BLOCKED = 'autoplayblocked'),
            t
          );
        })();
        e.WebVideoPlayerEvents = o;
        var u = (function() {
          function t() {}
          return (
            (t.MP4 = 'video/mp4'),
            (t.OGG = 'video/ogg'),
            (t.MOV = 'video/mov'),
            (t.MPEG = 'video/mpeg'),
            (t.WEBM = 'video/webm'),
            (t.HLS = 'application/x-mpegURL'),
            t
          );
        })();
        e.VideoFileTypes = u;
      },
      function(t, e, r) {
        r.d(e, 'a', function() {
          return l;
        }),
          r.d(e, 'b', function() {
            return c;
          });
        var n = r(0),
          i = r(5),
          s = r(3),
          a = r(1),
          o = r(4),
          u = r(39),
          l = (function(t) {
            function e(e, r) {
              var n = t.call(this) || this;
              return (
                (n.source = e),
                (n.subjectFactory = r),
                (n._refCount = 0),
                (n._isComplete = !1),
                n
              );
            }
            return (
              n.a(e, t),
              (e.prototype._subscribe = function(t) {
                return this.getSubject().subscribe(t);
              }),
              (e.prototype.getSubject = function() {
                var t = this._subject;
                return (
                  (t && !t.isStopped) ||
                    (this._subject = this.subjectFactory()),
                  this._subject
                );
              }),
              (e.prototype.connect = function() {
                var t = this._connection;
                return (
                  t ||
                    ((this._isComplete = !1),
                    (t = this._connection = new o.a()).add(
                      this.source.subscribe(new h(this.getSubject(), this)),
                    ),
                    t.closed && ((this._connection = null), (t = o.a.EMPTY))),
                  t
                );
              }),
              (e.prototype.refCount = function() {
                return Object(u.a)()(this);
              }),
              e
            );
          })(s.a),
          c = (function() {
            var t = l.prototype;
            return {
              operator: { value: null },
              _refCount: { value: 0, writable: !0 },
              _subject: { value: null, writable: !0 },
              _connection: { value: null, writable: !0 },
              _subscribe: { value: t._subscribe },
              _isComplete: { value: t._isComplete, writable: !0 },
              getSubject: { value: t.getSubject },
              connect: { value: t.connect },
              refCount: { value: t.refCount },
            };
          })(),
          h = (function(t) {
            function e(e, r) {
              var n = t.call(this, e) || this;
              return (n.connectable = r), n;
            }
            return (
              n.a(e, t),
              (e.prototype._error = function(e) {
                this._unsubscribe(), t.prototype._error.call(this, e);
              }),
              (e.prototype._complete = function() {
                (this.connectable._isComplete = !0),
                  this._unsubscribe(),
                  t.prototype._complete.call(this);
              }),
              (e.prototype._unsubscribe = function() {
                var t = this.connectable;
                if (t) {
                  this.connectable = null;
                  var e = t._connection;
                  (t._refCount = 0),
                    (t._subject = null),
                    (t._connection = null),
                    e && e.unsubscribe();
                }
              }),
              e
            );
          })(i.b);
        a.a;
      },
      function(t, e, r) {
        r.d(e, 'a', function() {
          return a;
        });
        var n = r(0),
          i = r(5),
          s = r(21),
          a = (function(t) {
            function e(e) {
              var r = t.call(this) || this;
              return (r._value = e), r;
            }
            return (
              n.a(e, t),
              Object.defineProperty(e.prototype, 'value', {
                get: function() {
                  return this.getValue();
                },
                enumerable: !0,
                configurable: !0,
              }),
              (e.prototype._subscribe = function(e) {
                var r = t.prototype._subscribe.call(this, e);
                return r && !r.closed && e.next(this._value), r;
              }),
              (e.prototype.getValue = function() {
                if (this.hasError) throw this.thrownError;
                if (this.closed) throw new s.a();
                return this._value;
              }),
              (e.prototype.next = function(e) {
                t.prototype.next.call(this, (this._value = e));
              }),
              e
            );
          })(i.a);
      },
      function(t, e, r) {
        function n(t, e) {
          return (
            void 0 === e && (e = 0),
            function(r) {
              return r.lift(new o(t, e));
            }
          );
        }
        r.d(e, 'b', function() {
          return n;
        }),
          r.d(e, 'a', function() {
            return u;
          });
        var i = r(0),
          s = r(1),
          a = r(17),
          o = (function() {
            function t(t, e) {
              void 0 === e && (e = 0), (this.scheduler = t), (this.delay = e);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new u(t, this.scheduler, this.delay));
              }),
              t
            );
          })(),
          u = (function(t) {
            function e(e, r, n) {
              void 0 === n && (n = 0);
              var i = t.call(this, e) || this;
              return (i.scheduler = r), (i.delay = n), i;
            }
            return (
              i.a(e, t),
              (e.dispatch = function(t) {
                var e = t.notification,
                  r = t.destination;
                e.observe(r), this.unsubscribe();
              }),
              (e.prototype.scheduleMessage = function(t) {
                this.destination.add(
                  this.scheduler.schedule(
                    e.dispatch,
                    this.delay,
                    new l(t, this.destination),
                  ),
                );
              }),
              (e.prototype._next = function(t) {
                this.scheduleMessage(a.a.createNext(t));
              }),
              (e.prototype._error = function(t) {
                this.scheduleMessage(a.a.createError(t)), this.unsubscribe();
              }),
              (e.prototype._complete = function() {
                this.scheduleMessage(a.a.createComplete()), this.unsubscribe();
              }),
              e
            );
          })(s.a),
          l = (function() {
            return function(t, e) {
              (this.notification = t), (this.destination = e);
            };
          })();
      },
      function(t, e, r) {
        r.d(e, 'a', function() {
          return n;
        });
        var n = (function() {
          function t() {
            return (
              Error.call(this),
              (this.message = 'Timeout has occurred'),
              (this.name = 'TimeoutError'),
              this
            );
          }
          return (t.prototype = Object.create(Error.prototype)), t;
        })();
      },
      function(t, e, r) {
        function n() {
          return Object(i.a)(1);
        }
        r.d(e, 'a', function() {
          return n;
        });
        var i = r(43);
      },
      function(t, e, r) {
        function n() {
          for (var t = [], e = 0; e < arguments.length; e++)
            t[e] = arguments[e];
          var r = Number.POSITIVE_INFINITY,
            n = null,
            u = t[t.length - 1];
          return (
            Object(s.a)(u)
              ? ((n = t.pop()),
                t.length > 1 &&
                  'number' == typeof t[t.length - 1] &&
                  (r = t.pop()))
              : 'number' == typeof u && (r = t.pop()),
            null === n && 1 === t.length && t[0] instanceof i.a
              ? t[0]
              : Object(a.a)(r)(Object(o.a)(t, n))
          );
        }
        r.d(e, 'a', function() {
          return n;
        });
        var i = r(3),
          s = r(9),
          a = r(43),
          o = r(26);
      },
      function(t, e, r) {
        function n() {
          for (var t = [], e = 0; e < arguments.length; e++)
            t[e] = arguments[e];
          if (1 === t.length) {
            if (!Object(s.a)(t[0])) return t[0];
            t = t[0];
          }
          return Object(a.a)(t, void 0).lift(new l());
        }
        r.d(e, 'a', function() {
          return n;
        });
        var i = r(0),
          s = r(7),
          a = r(26),
          o = r(15),
          u = r(12),
          l = (function() {
            function t() {}
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new c(t));
              }),
              t
            );
          })(),
          c = (function(t) {
            function e(e) {
              var r = t.call(this, e) || this;
              return (
                (r.hasFirst = !1),
                (r.observables = []),
                (r.subscriptions = []),
                r
              );
            }
            return (
              i.a(e, t),
              (e.prototype._next = function(t) {
                this.observables.push(t);
              }),
              (e.prototype._complete = function() {
                var t = this.observables,
                  e = t.length;
                if (0 === e) this.destination.complete();
                else {
                  for (var r = 0; r < e && !this.hasFirst; r++) {
                    var n = t[r],
                      i = Object(u.a)(this, n, void 0, r);
                    this.subscriptions && this.subscriptions.push(i),
                      this.add(i);
                  }
                  this.observables = null;
                }
              }),
              (e.prototype.notifyNext = function(t, e, r) {
                if (!this.hasFirst) {
                  this.hasFirst = !0;
                  for (var n = 0; n < this.subscriptions.length; n++)
                    if (n !== r) {
                      var i = this.subscriptions[n];
                      i.unsubscribe(), this.remove(i);
                    }
                  this.subscriptions = null;
                }
                this.destination.next(e);
              }),
              e
            );
          })(o.a);
      },
      function(t, e, r) {
        function n(t, e, r) {
          void 0 === t && (t = 0);
          var n = -1;
          return (
            Object(o.a)(e)
              ? (n = Number(e) < 1 ? 1 : Number(e))
              : Object(u.a)(e) && (r = e),
            Object(u.a)(r) || (r = a.a),
            new s.a(function(e) {
              var s = Object(o.a)(t) ? t : +t - r.now();
              return r.schedule(i, s, { index: 0, period: n, subscriber: e });
            })
          );
        }
        function i(t) {
          var e = t.index,
            r = t.period,
            n = t.subscriber;
          if ((n.next(e), !n.closed)) {
            if (-1 === r) return n.complete();
            (t.index = e + 1), this.schedule(t, r);
          }
        }
        r.d(e, 'a', function() {
          return n;
        });
        var s = r(3),
          a = r(6),
          o = r(30),
          u = r(9);
      },
      function(t, e, r) {
        function n(t, e) {
          if (null != t) {
            if (
              (function(t) {
                return t && 'function' == typeof t[a.a];
              })(t)
            )
              return (function(t, e) {
                return new i.a(function(r) {
                  var n = new s.a();
                  return (
                    n.add(
                      e.schedule(function() {
                        var i = t[a.a]();
                        n.add(
                          i.subscribe({
                            next: function(t) {
                              n.add(
                                e.schedule(function() {
                                  return r.next(t);
                                }),
                              );
                            },
                            error: function(t) {
                              n.add(
                                e.schedule(function() {
                                  return r.error(t);
                                }),
                              );
                            },
                            complete: function() {
                              n.add(
                                e.schedule(function() {
                                  return r.complete();
                                }),
                              );
                            },
                          }),
                        );
                      }),
                    ),
                    n
                  );
                });
              })(t, e);
            if (Object(l.a)(t))
              return (function(t, e) {
                return new i.a(function(r) {
                  var n = new s.a();
                  return (
                    n.add(
                      e.schedule(function() {
                        return t.then(
                          function(t) {
                            n.add(
                              e.schedule(function() {
                                r.next(t),
                                  n.add(
                                    e.schedule(function() {
                                      return r.complete();
                                    }),
                                  );
                              }),
                            );
                          },
                          function(t) {
                            n.add(
                              e.schedule(function() {
                                return r.error(t);
                              }),
                            );
                          },
                        );
                      }),
                    ),
                    n
                  );
                });
              })(t, e);
            if (Object(c.a)(t)) return Object(o.a)(t, e);
            if (
              (function(t) {
                return t && 'function' == typeof t[u.a];
              })(t) ||
              'string' == typeof t
            )
              return (function(t, e) {
                if (!t) throw new Error('Iterable cannot be null');
                return new i.a(function(r) {
                  var n,
                    i = new s.a();
                  return (
                    i.add(function() {
                      n && 'function' == typeof n.return && n.return();
                    }),
                    i.add(
                      e.schedule(function() {
                        (n = t[u.a]()),
                          i.add(
                            e.schedule(function() {
                              if (!r.closed) {
                                var t, e;
                                try {
                                  var i = n.next();
                                  (t = i.value), (e = i.done);
                                } catch (t) {
                                  return void r.error(t);
                                }
                                e ? r.complete() : (r.next(t), this.schedule());
                              }
                            }),
                          );
                      }),
                    ),
                    i
                  );
                });
              })(t, e);
          }
          throw new TypeError(
            ((null !== t && typeof t) || t) + ' is not observable',
          );
        }
        var i = r(3),
          s = r(4),
          a = r(20),
          o = r(48),
          u = r(18),
          l = r(66),
          c = r(65);
        r.d(e, 'a', function() {
          return n;
        });
      },
      function(t, e, r) {
        r.d(e, 'a', function() {
          return i;
        });
        var n = r(0),
          i = (function(t) {
            function e(e, r) {
              var n = t.call(this) || this;
              return (n.subject = e), (n.subscriber = r), (n.closed = !1), n;
            }
            return (
              n.a(e, t),
              (e.prototype.unsubscribe = function() {
                if (!this.closed) {
                  this.closed = !0;
                  var t = this.subject,
                    e = t.observers;
                  if (
                    ((this.subject = null),
                    e && 0 !== e.length && !t.isStopped && !t.closed)
                  ) {
                    var r = e.indexOf(this.subscriber);
                    -1 !== r && e.splice(r, 1);
                  }
                }
              }),
              e
            );
          })(r(4).a);
      },
      function(t, e, r) {
        r.d(e, 'a', function() {
          return n;
        });
        var n = function(t) {
          return function(e) {
            for (var r = 0, n = t.length; r < n && !e.closed; r++) e.next(t[r]);
            e.complete();
          };
        };
      },
      function(t, e, r) {
        r.d(e, 'a', function() {
          return n;
        });
        var n = function(t) {
          return t && 'number' == typeof t.length && 'function' != typeof t;
        };
      },
      function(t, e, r) {
        function n(t) {
          return (
            !!t &&
            'function' != typeof t.subscribe &&
            'function' == typeof t.then
          );
        }
        r.d(e, 'a', function() {
          return n;
        });
      },
      function(t, e, r) {
        function n(t, e) {
          function r() {
            return !r.pred.apply(r.thisArg, arguments);
          }
          return (r.pred = t), (r.thisArg = e), r;
        }
        r.d(e, 'a', function() {
          return n;
        });
      },
      function(t, e, r) {
        e.__esModule = !0;
        var n = (function() {
          function t() {}
          return (
            (t.logMessage = function(e, r) {
              for (var n = [], i = 2; i < arguments.length; i++)
                n[i - 2] = arguments[i];
              if (e)
                switch (r) {
                  case t.LEVEL_WARN:
                    console.warn(n);
                    break;
                  case t.LEVEL_ERROR:
                    console.error(n);
                    break;
                  default:
                    console.log(n);
                }
            }),
            (t.LEVEL_DEBUG = 0),
            (t.LEVEL_WARN = 1),
            (t.LEVEL_ERROR = 2),
            t
          );
        })();
        e.Logger = n;
      },
      function(t, e, r) {
        function n(t) {
          return function(e) {
            return e.lift(new ae(t));
          };
        }
        function i(t, e) {
          return (
            void 0 === e && (e = ue.a),
            n(function() {
              return Object(le.a)(t, e);
            })
          );
        }
        function s(t) {
          return function(e) {
            return e.lift(new ce(t));
          };
        }
        function a(t, e) {
          return (
            void 0 === e && (e = null),
            function(r) {
              return r.lift(new fe(t, e));
            }
          );
        }
        function o(t) {
          var e = arguments.length,
            r = ue.a;
          Object(ge.a)(arguments[arguments.length - 1]) &&
            ((r = arguments[arguments.length - 1]), e--);
          var n = null;
          e >= 2 && (n = arguments[1]);
          var i = Number.POSITIVE_INFINITY;
          return (
            e >= 3 && (i = arguments[2]),
            function(e) {
              return e.lift(new me(t, n, i, r));
            }
          );
        }
        function u(t) {
          var e = t.subscriber,
            r = t.context;
          r && e.closeContext(r),
            e.closed ||
              ((t.context = e.openContext()),
              (t.context.closeAction = this.schedule(t, t.bufferTimeSpan)));
        }
        function l(t) {
          var e = t.bufferCreationInterval,
            r = t.bufferTimeSpan,
            n = t.subscriber,
            i = t.scheduler,
            s = n.openContext();
          n.closed ||
            (n.add(
              (s.closeAction = i.schedule(c, r, { subscriber: n, context: s })),
            ),
            this.schedule(t, e));
        }
        function c(t) {
          var e = t.subscriber,
            r = t.context;
          e.closeContext(r);
        }
        function h(t, e) {
          return function(r) {
            return r.lift(new Le(t, e));
          };
        }
        function d(t) {
          return function(e) {
            return e.lift(new Ae(t));
          };
        }
        function f(t) {
          return function(e) {
            var r = new we(t),
              n = e.lift(r);
            return (r.caught = n);
          };
        }
        function p(t) {
          return function(e) {
            return e.lift(new Re.a(t));
          };
        }
        function v() {
          for (var t = [], e = 0; e < arguments.length; e++)
            t[e] = arguments[e];
          var r = null;
          return (
            'function' == typeof t[t.length - 1] && (r = t.pop()),
            1 === t.length && Object(Oe.a)(t[0]) && (t = t[0].slice()),
            function(e) {
              return e.lift.call(Object(Ie.a)([e].concat(t)), new Re.a(r));
            }
          );
        }
        function g() {
          for (var t = [], e = 0; e < arguments.length; e++)
            t[e] = arguments[e];
          return function(e) {
            return e.lift.call(Ce.a.apply(void 0, [e].concat(t)));
          };
        }
        function m(t, e) {
          return Object(Pe.b)(t, e, 1);
        }
        function y(t, e) {
          return m(function() {
            return t;
          }, e);
        }
        function b(t) {
          return function(e) {
            return e.lift(new Me(t, e));
          };
        }
        function E(t) {
          return function(e) {
            return e.lift(new Ne(t));
          };
        }
        function T(t, e) {
          return (
            void 0 === e && (e = ue.a),
            function(r) {
              return r.lift(new Be(t, e));
            }
          );
        }
        function S(t) {
          t.debouncedNext();
        }
        function L(t) {
          return (
            void 0 === t && (t = null),
            function(e) {
              return e.lift(new Ge(t));
            }
          );
        }
        function _(t) {
          return t instanceof Date && !isNaN(+t);
        }
        function A(t, e) {
          void 0 === e && (e = ue.a);
          var r = _(t) ? +t - e.now() : Math.abs(t);
          return function(t) {
            return t.lift(new Ke(r, e));
          };
        }
        function D(t, e) {
          return e
            ? function(r) {
                return new $e(r, e).lift(new ze(t));
              }
            : function(e) {
                return e.lift(new ze(t));
              };
        }
        function w() {
          return function(t) {
            return t.lift(new Je());
          };
        }
        function k(t, e) {
          return function(r) {
            return r.lift(new tr(t, e));
          };
        }
        function R(t, e) {
          return function(r) {
            return r.lift(new rr(t, e));
          };
        }
        function O(t, e) {
          return R(function(r, n) {
            return e ? e(r[t], n[t]) : r[t] === n[t];
          });
        }
        function I(t) {
          return (
            void 0 === t && (t = C),
            function(e) {
              return e.lift(new or(t));
            }
          );
        }
        function C() {
          return new ar.a();
        }
        function x(t) {
          return function(e) {
            return 0 === t ? Object(lr.b)() : e.lift(new cr(t));
          };
        }
        function P(t, e) {
          if (t < 0) throw new ir.a();
          var r = arguments.length >= 2;
          return function(n) {
            return n.pipe(
              Object(sr.a)(function(e, r) {
                return r === t;
              }),
              x(1),
              r
                ? L(e)
                : I(function() {
                    return new ir.a();
                  }),
            );
          };
        }
        function M() {
          for (var t = [], e = 0; e < arguments.length; e++)
            t[e] = arguments[e];
          return function(e) {
            return Object(Ce.a)(e, dr.a.apply(void 0, t));
          };
        }
        function F(t, e) {
          return function(r) {
            return r.lift(new fr(t, e, r));
          };
        }
        function N() {
          return function(t) {
            return t.lift(new vr());
          };
        }
        function U(t, e) {
          return e
            ? function(r) {
                return r.pipe(
                  U(function(r, n) {
                    return Object(Ie.a)(t(r, n)).pipe(
                      Object(mr.a)(function(t, i) {
                        return e(r, t, n, i);
                      }),
                    );
                  }),
                );
              }
            : function(e) {
                return e.lift(new yr(t));
              };
        }
        function B(t, e, r) {
          return (
            void 0 === e && (e = Number.POSITIVE_INFINITY),
            (e = (e || 0) < 1 ? Number.POSITIVE_INFINITY : e),
            function(n) {
              return n.lift(new Er(t, e, r));
            }
          );
        }
        function j(t) {
          return function(e) {
            return e.lift(new Sr(t));
          };
        }
        function G(t, e) {
          if ('function' != typeof t)
            throw new TypeError('predicate is not a function');
          return function(r) {
            return r.lift(new _r(t, r, !1, e));
          };
        }
        function V(t, e) {
          return function(r) {
            return r.lift(new _r(t, r, !0, e));
          };
        }
        function H(t, e) {
          var r = arguments.length >= 2;
          return function(n) {
            return n.pipe(
              t
                ? Object(sr.a)(function(e, r) {
                    return t(e, r, n);
                  })
                : Dr.a,
              x(1),
              r
                ? L(e)
                : I(function() {
                    return new ar.a();
                  }),
            );
          };
        }
        function K() {
          return function(t) {
            return t.lift(new kr());
          };
        }
        function W() {
          return function(t) {
            return t.lift(new Or());
          };
        }
        function Y(t) {
          return function(e) {
            return 0 === t ? Object(lr.b)() : e.lift(new Cr(t));
          };
        }
        function q(t, e) {
          var r = arguments.length >= 2;
          return function(n) {
            return n.pipe(
              t
                ? Object(sr.a)(function(e, r) {
                    return t(e, r, n);
                  })
                : Dr.a,
              Y(1),
              r
                ? L(e)
                : I(function() {
                    return new ar.a();
                  }),
            );
          };
        }
        function z(t) {
          return function(e) {
            return e.lift(new Pr(t));
          };
        }
        function X() {
          return function(t) {
            return t.lift(new Fr());
          };
        }
        function $(t, e) {
          var r = !1;
          return (
            arguments.length >= 2 && (r = !0),
            function(n) {
              return n.lift(new Ur(t, e, r));
            }
          );
        }
        function Q(t, e) {
          return arguments.length >= 2
            ? function(r) {
                return Object(jr.a)($(t, e), Y(1), L(e))(r);
              }
            : function(e) {
                return Object(jr.a)(
                  $(function(e, r, n) {
                    return t(e, r, n + 1);
                  }),
                  Y(1),
                )(e);
              };
        }
        function J(t) {
          return Q(
            'function' == typeof t
              ? function(e, r) {
                  return t(e, r) > 0 ? e : r;
                }
              : function(t, e) {
                  return t > e ? t : e;
                },
          );
        }
        function Z() {
          for (var t = [], e = 0; e < arguments.length; e++)
            t[e] = arguments[e];
          return function(e) {
            return e.lift.call(Gr.a.apply(void 0, [e].concat(t)));
          };
        }
        function tt(t, e, r) {
          return (
            void 0 === r && (r = Number.POSITIVE_INFINITY),
            'function' == typeof e
              ? Object(Pe.b)(
                  function() {
                    return t;
                  },
                  e,
                  r,
                )
              : ('number' == typeof e && (r = e),
                Object(Pe.b)(function() {
                  return t;
                }, r))
          );
        }
        function et(t, e, r) {
          return (
            void 0 === r && (r = Number.POSITIVE_INFINITY),
            function(n) {
              return n.lift(new Hr(t, e, r));
            }
          );
        }
        function rt(t) {
          return Q(
            'function' == typeof t
              ? function(e, r) {
                  return t(e, r) < 0 ? e : r;
                }
              : function(t, e) {
                  return t < e ? t : e;
                },
          );
        }
        function nt(t, e) {
          return function(r) {
            var n;
            if (
              ((n =
                'function' == typeof t
                  ? t
                  : function() {
                      return t;
                    }),
              'function' == typeof e)
            )
              return r.lift(new Yr(n, e));
            var i = Object.create(r, Wr.b);
            return (i.source = r), (i.subjectFactory = n), i;
          };
        }
        function it() {
          for (var t = [], e = 0; e < arguments.length; e++)
            t[e] = arguments[e];
          return (
            1 === t.length && Object(Oe.a)(t[0]) && (t = t[0]),
            function(e) {
              return e.lift(new zr(t));
            }
          );
        }
        function st() {
          return function(t) {
            return t.lift(new $r());
          };
        }
        function at(t, e) {
          return function(r) {
            return [Object(sr.a)(t, e)(r), Object(sr.a)(Object(Jr.a)(t, e))(r)];
          };
        }
        function ot() {
          for (var t = [], e = 0; e < arguments.length; e++)
            t[e] = arguments[e];
          var r = t.length;
          if (0 === r) throw new Error('list of properties cannot be empty.');
          return function(e) {
            return Object(mr.a)(ut(t, r))(e);
          };
        }
        function ut(t, e) {
          return function(r) {
            for (var n = r, i = 0; i < e; i++) {
              var s = null != n ? n[t[i]] : void 0;
              if (void 0 === s) return;
              n = s;
            }
            return n;
          };
        }
        function lt(t) {
          return t
            ? nt(function() {
                return new Zr.a();
              }, t)
            : nt(new Zr.a());
        }
        function ct(t) {
          return function(e) {
            return nt(new tn.a(t))(e);
          };
        }
        function ht() {
          return function(t) {
            return nt(new en.a())(t);
          };
        }
        function dt(t, e, r, n) {
          r && 'function' != typeof r && (n = r);
          var i = 'function' == typeof r ? r : void 0,
            s = new rn.a(t, e, n);
          return function(t) {
            return nt(function() {
              return s;
            }, i)(t);
          };
        }
        function ft() {
          for (var t = [], e = 0; e < arguments.length; e++)
            t[e] = arguments[e];
          return function(e) {
            return (
              1 === t.length && Object(Oe.a)(t[0]) && (t = t[0]),
              e.lift.call(nn.a.apply(void 0, [e].concat(t)))
            );
          };
        }
        function pt(t) {
          return (
            void 0 === t && (t = -1),
            function(e) {
              return 0 === t
                ? Object(lr.b)()
                : t < 0
                ? e.lift(new sn(-1, e))
                : e.lift(new sn(t - 1, e));
            }
          );
        }
        function vt(t) {
          return function(e) {
            return e.lift(new on(t));
          };
        }
        function gt(t) {
          return (
            void 0 === t && (t = -1),
            function(e) {
              return e.lift(new ln(t, e));
            }
          );
        }
        function mt(t) {
          return function(e) {
            return e.lift(new hn(t, e));
          };
        }
        function yt(t) {
          return function(e) {
            return e.lift(new pn(t));
          };
        }
        function bt(t, e) {
          return (
            void 0 === e && (e = ue.a),
            function(r) {
              return r.lift(new gn(t, e));
            }
          );
        }
        function Et(t) {
          var e = t.subscriber,
            r = t.period;
          e.notifyNext(), this.schedule(t, r);
        }
        function Tt(t, e) {
          return function(r) {
            return r.lift(new yn(t, e));
          };
        }
        function St() {
          return new Zr.a();
        }
        function Lt() {
          return function(t) {
            return Object(fn.a)()(nt(St)(t));
          };
        }
        function _t(t, e, r) {
          var n;
          return (
            (n =
              t && 'object' == typeof t
                ? t
                : { bufferSize: t, windowTime: e, refCount: !1, scheduler: r }),
            function(t) {
              return t.lift(
                (function(t) {
                  var e,
                    r,
                    n = t.bufferSize,
                    i = void 0 === n ? Number.POSITIVE_INFINITY : n,
                    s = t.windowTime,
                    a = void 0 === s ? Number.POSITIVE_INFINITY : s,
                    o = t.refCount,
                    u = t.scheduler,
                    l = 0,
                    c = !1,
                    h = !1;
                  return function(t) {
                    var n;
                    l++,
                      !e || c
                        ? ((c = !1),
                          (e = new rn.a(i, a, u)),
                          (n = e.subscribe(this)),
                          (r = t.subscribe({
                            next: function(t) {
                              e.next(t);
                            },
                            error: function(t) {
                              (c = !0), e.error(t);
                            },
                            complete: function() {
                              (h = !0), (r = void 0), e.complete();
                            },
                          })),
                          h && (r = void 0))
                        : (n = e.subscribe(this)),
                      this.add(function() {
                        l--,
                          n.unsubscribe(),
                          (n = void 0),
                          r &&
                            !h &&
                            o &&
                            0 === l &&
                            (r.unsubscribe(), (r = void 0), (e = void 0));
                      });
                  };
                })(n),
              );
            }
          );
        }
        function At(t) {
          return function(e) {
            return e.lift(new Tn(t, e));
          };
        }
        function Dt(t) {
          return function(e) {
            return e.lift(new Ln(t));
          };
        }
        function wt(t) {
          return function(e) {
            return e.lift(new An(t));
          };
        }
        function kt(t) {
          return function(e) {
            return e.lift(new wn(t));
          };
        }
        function Rt(t) {
          return function(e) {
            return e.lift(new Rn(t));
          };
        }
        function Ot() {
          for (var t = [], e = 0; e < arguments.length; e++)
            t[e] = arguments[e];
          var r = t[t.length - 1];
          return Object(ge.a)(r)
            ? (t.pop(),
              function(e) {
                return Object(Ce.a)(t, e, r);
              })
            : function(e) {
                return Object(Ce.a)(t, e);
              };
        }
        function It(t, e) {
          return (
            void 0 === e && (e = 0),
            function(r) {
              return r.lift(new Pn(t, e));
            }
          );
        }
        function Ct(t, e) {
          return 'function' == typeof e
            ? function(r) {
                return r.pipe(
                  Ct(function(r, n) {
                    return Object(Ie.a)(t(r, n)).pipe(
                      Object(mr.a)(function(t, i) {
                        return e(r, t, n, i);
                      }),
                    );
                  }),
                );
              }
            : function(e) {
                return e.lift(new Mn(t));
              };
        }
        function xt() {
          return Ct(Dr.a);
        }
        function Pt(t, e) {
          return e
            ? Ct(function() {
                return t;
              }, e)
            : Ct(function() {
                return t;
              });
        }
        function Mt(t) {
          return function(e) {
            return e.lift(new Nn(t));
          };
        }
        function Ft(t, e) {
          return (
            void 0 === e && (e = !1),
            function(r) {
              return r.lift(new Bn(t, e));
            }
          );
        }
        function Nt(t, e, r) {
          return function(n) {
            return n.lift(new Hn(t, e, r));
          };
        }
        function Ut(t, e) {
          return (
            void 0 === e && (e = Wn),
            function(r) {
              return r.lift(new Yn(t, !!e.leading, !!e.trailing));
            }
          );
        }
        function Bt(t, e, r) {
          return (
            void 0 === e && (e = ue.a),
            void 0 === r && (r = Wn),
            function(n) {
              return n.lift(new zn(t, e, r.leading, r.trailing));
            }
          );
        }
        function jt(t) {
          t.subscriber.clearThrottle();
        }
        function Gt(t) {
          return (
            void 0 === t && (t = ue.a),
            function(e) {
              return Object($n.a)(function() {
                return e.pipe(
                  $(
                    function(e, r) {
                      var n = e.current;
                      return { value: r, current: t.now(), last: n };
                    },
                    { current: t.now(), value: void 0, last: void 0 },
                  ),
                  Object(mr.a)(function(t) {
                    var e = t.current,
                      r = t.last,
                      n = t.value;
                    return new Qn(n, e - r);
                  }),
                );
              });
            }
          );
        }
        function Vt(t, e, r) {
          return (
            void 0 === r && (r = ue.a),
            function(n) {
              var i = _(t),
                s = i ? +t - r.now() : Math.abs(t);
              return n.lift(new Zn(s, i, e, r));
            }
          );
        }
        function Ht(t, e) {
          return void 0 === e && (e = ue.a), Vt(t, Object(ei.a)(new Jn.a()), e);
        }
        function Kt(t) {
          return (
            void 0 === t && (t = ue.a),
            Object(mr.a)(function(e) {
              return new ri(e, t.now());
            })
          );
        }
        function Wt(t, e, r) {
          return 0 === r ? [e] : (t.push(e), t);
        }
        function Yt() {
          return Q(Wt, []);
        }
        function qt(t) {
          return function(e) {
            return e.lift(new ni(t));
          };
        }
        function zt(t, e) {
          return (
            void 0 === e && (e = 0),
            function(r) {
              return r.lift(new si(t, e));
            }
          );
        }
        function Xt(t) {
          var e = ue.a,
            r = null,
            n = Number.POSITIVE_INFINITY;
          return (
            Object(ge.a)(arguments[3]) && (e = arguments[3]),
            Object(ge.a)(arguments[2])
              ? (e = arguments[2])
              : Object(Cn.a)(arguments[2]) && (n = Number(arguments[2])),
            Object(ge.a)(arguments[1])
              ? (e = arguments[1])
              : Object(Cn.a)(arguments[1]) && (r = Number(arguments[1])),
            function(i) {
              return i.lift(new oi(t, r, n, e));
            }
          );
        }
        function $t(t) {
          var e = t.subscriber,
            r = t.windowTimeSpan,
            n = t.window;
          n && e.closeWindow(n),
            (t.window = e.openWindow()),
            this.schedule(t, r);
        }
        function Qt(t) {
          var e = t.windowTimeSpan,
            r = t.subscriber,
            n = t.scheduler,
            i = t.windowCreationInterval,
            s = r.openWindow(),
            a = { action: this, subscription: null },
            o = { subscriber: r, window: s, context: a };
          (a.subscription = n.schedule(Jt, e, o)),
            this.add(a.subscription),
            this.schedule(t, i);
        }
        function Jt(t) {
          var e = t.subscriber,
            r = t.window,
            n = t.context;
          n && n.action && n.subscription && n.action.remove(n.subscription),
            e.closeWindow(r);
        }
        function Zt(t, e) {
          return function(r) {
            return r.lift(new ci(t, e));
          };
        }
        function te(t) {
          return function(e) {
            return e.lift(new di(t));
          };
        }
        function ee() {
          for (var t = [], e = 0; e < arguments.length; e++)
            t[e] = arguments[e];
          return function(e) {
            var r;
            'function' == typeof t[t.length - 1] && (r = t.pop());
            var n = t;
            return e.lift(new pi(n, r));
          };
        }
        function re() {
          for (var t = [], e = 0; e < arguments.length; e++)
            t[e] = arguments[e];
          return function(e) {
            return e.lift.call(gi.b.apply(void 0, [e].concat(t)));
          };
        }
        function ne(t) {
          return function(e) {
            return e.lift(new gi.a(t));
          };
        }
        r.r(e);
        var ie = r(0),
          se = r(2),
          ae = (function() {
            function t(t) {
              this.durationSelector = t;
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new oe(t, this.durationSelector));
              }),
              t
            );
          })(),
          oe = (function(t) {
            function e(e, r) {
              var n = t.call(this, e) || this;
              return (n.durationSelector = r), (n.hasValue = !1), n;
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                if (((this.value = t), (this.hasValue = !0), !this.throttled)) {
                  var e = void 0;
                  try {
                    e = (0, this.durationSelector)(t);
                  } catch (t) {
                    return this.destination.error(t);
                  }
                  var r = Object(se.c)(e, new se.a(this));
                  !r || r.closed
                    ? this.clearThrottle()
                    : this.add((this.throttled = r));
                }
              }),
              (e.prototype.clearThrottle = function() {
                var t = this.value,
                  e = this.hasValue,
                  r = this.throttled;
                r &&
                  (this.remove(r), (this.throttled = void 0), r.unsubscribe()),
                  e &&
                    ((this.value = void 0),
                    (this.hasValue = !1),
                    this.destination.next(t));
              }),
              (e.prototype.notifyNext = function() {
                this.clearThrottle();
              }),
              (e.prototype.notifyComplete = function() {
                this.clearThrottle();
              }),
              e
            );
          })(se.b),
          ue = r(6),
          le = r(61),
          ce = (function() {
            function t(t) {
              this.closingNotifier = t;
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new he(t, this.closingNotifier));
              }),
              t
            );
          })(),
          he = (function(t) {
            function e(e, r) {
              var n = t.call(this, e) || this;
              return (n.buffer = []), n.add(Object(se.c)(r, new se.a(n))), n;
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                this.buffer.push(t);
              }),
              (e.prototype.notifyNext = function() {
                var t = this.buffer;
                (this.buffer = []), this.destination.next(t);
              }),
              e
            );
          })(se.b),
          de = r(1),
          fe = (function() {
            function t(t, e) {
              (this.bufferSize = t),
                (this.startBufferEvery = e),
                (this.subscriberClass = e && t !== e ? ve : pe);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(
                  new this.subscriberClass(
                    t,
                    this.bufferSize,
                    this.startBufferEvery,
                  ),
                );
              }),
              t
            );
          })(),
          pe = (function(t) {
            function e(e, r) {
              var n = t.call(this, e) || this;
              return (n.bufferSize = r), (n.buffer = []), n;
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                var e = this.buffer;
                e.push(t),
                  e.length == this.bufferSize &&
                    (this.destination.next(e), (this.buffer = []));
              }),
              (e.prototype._complete = function() {
                var e = this.buffer;
                e.length > 0 && this.destination.next(e),
                  t.prototype._complete.call(this);
              }),
              e
            );
          })(de.a),
          ve = (function(t) {
            function e(e, r, n) {
              var i = t.call(this, e) || this;
              return (
                (i.bufferSize = r),
                (i.startBufferEvery = n),
                (i.buffers = []),
                (i.count = 0),
                i
              );
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                var e = this.bufferSize,
                  r = this.startBufferEvery,
                  n = this.buffers,
                  i = this.count;
                this.count++, i % r == 0 && n.push([]);
                for (var s = n.length; s--; ) {
                  var a = n[s];
                  a.push(t),
                    a.length === e &&
                      (n.splice(s, 1), this.destination.next(a));
                }
              }),
              (e.prototype._complete = function() {
                for (
                  var e = this.buffers, r = this.destination;
                  e.length > 0;

                ) {
                  var n = e.shift();
                  n.length > 0 && r.next(n);
                }
                t.prototype._complete.call(this);
              }),
              e
            );
          })(de.a),
          ge = r(9),
          me = (function() {
            function t(t, e, r, n) {
              (this.bufferTimeSpan = t),
                (this.bufferCreationInterval = e),
                (this.maxBufferSize = r),
                (this.scheduler = n);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(
                  new be(
                    t,
                    this.bufferTimeSpan,
                    this.bufferCreationInterval,
                    this.maxBufferSize,
                    this.scheduler,
                  ),
                );
              }),
              t
            );
          })(),
          ye = (function() {
            return function() {
              this.buffer = [];
            };
          })(),
          be = (function(t) {
            function e(e, r, n, i, s) {
              var a = t.call(this, e) || this;
              (a.bufferTimeSpan = r),
                (a.bufferCreationInterval = n),
                (a.maxBufferSize = i),
                (a.scheduler = s),
                (a.contexts = []);
              var o = a.openContext();
              if (((a.timespanOnly = null == n || n < 0), a.timespanOnly)) {
                var h = { subscriber: a, context: o, bufferTimeSpan: r };
                a.add((o.closeAction = s.schedule(u, r, h)));
              } else {
                var d = { subscriber: a, context: o },
                  f = {
                    bufferTimeSpan: r,
                    bufferCreationInterval: n,
                    subscriber: a,
                    scheduler: s,
                  };
                a.add((o.closeAction = s.schedule(c, r, d))),
                  a.add(s.schedule(l, n, f));
              }
              return a;
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                for (
                  var e, r = this.contexts, n = r.length, i = 0;
                  i < n;
                  i++
                ) {
                  var s = r[i],
                    a = s.buffer;
                  a.push(t), a.length == this.maxBufferSize && (e = s);
                }
                e && this.onBufferFull(e);
              }),
              (e.prototype._error = function(e) {
                (this.contexts.length = 0), t.prototype._error.call(this, e);
              }),
              (e.prototype._complete = function() {
                for (
                  var e = this.contexts, r = this.destination;
                  e.length > 0;

                ) {
                  var n = e.shift();
                  r.next(n.buffer);
                }
                t.prototype._complete.call(this);
              }),
              (e.prototype._unsubscribe = function() {
                this.contexts = null;
              }),
              (e.prototype.onBufferFull = function(t) {
                this.closeContext(t);
                var e = t.closeAction;
                if (
                  (e.unsubscribe(),
                  this.remove(e),
                  !this.closed && this.timespanOnly)
                ) {
                  t = this.openContext();
                  var r = this.bufferTimeSpan,
                    n = { subscriber: this, context: t, bufferTimeSpan: r };
                  this.add((t.closeAction = this.scheduler.schedule(u, r, n)));
                }
              }),
              (e.prototype.openContext = function() {
                var t = new ye();
                return this.contexts.push(t), t;
              }),
              (e.prototype.closeContext = function(t) {
                this.destination.next(t.buffer);
                var e = this.contexts;
                (e ? e.indexOf(t) : -1) >= 0 && e.splice(e.indexOf(t), 1);
              }),
              e
            );
          })(de.a),
          Ee = r(4),
          Te = r(12),
          Se = r(15),
          Le = (function() {
            function t(t, e) {
              (this.openings = t), (this.closingSelector = e);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(
                  new _e(t, this.openings, this.closingSelector),
                );
              }),
              t
            );
          })(),
          _e = (function(t) {
            function e(e, r, n) {
              var i = t.call(this, e) || this;
              return (
                (i.closingSelector = n),
                (i.contexts = []),
                i.add(Object(Te.a)(i, r)),
                i
              );
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                for (var e = this.contexts, r = e.length, n = 0; n < r; n++)
                  e[n].buffer.push(t);
              }),
              (e.prototype._error = function(e) {
                for (var r = this.contexts; r.length > 0; ) {
                  var n = r.shift();
                  n.subscription.unsubscribe(),
                    (n.buffer = null),
                    (n.subscription = null);
                }
                (this.contexts = null), t.prototype._error.call(this, e);
              }),
              (e.prototype._complete = function() {
                for (var e = this.contexts; e.length > 0; ) {
                  var r = e.shift();
                  this.destination.next(r.buffer),
                    r.subscription.unsubscribe(),
                    (r.buffer = null),
                    (r.subscription = null);
                }
                (this.contexts = null), t.prototype._complete.call(this);
              }),
              (e.prototype.notifyNext = function(t, e) {
                t ? this.closeBuffer(t) : this.openBuffer(e);
              }),
              (e.prototype.notifyComplete = function(t) {
                this.closeBuffer(t.context);
              }),
              (e.prototype.openBuffer = function(t) {
                try {
                  var e = this.closingSelector.call(this, t);
                  e && this.trySubscribe(e);
                } catch (t) {
                  this._error(t);
                }
              }),
              (e.prototype.closeBuffer = function(t) {
                var e = this.contexts;
                if (e && t) {
                  var r = t.buffer,
                    n = t.subscription;
                  this.destination.next(r),
                    e.splice(e.indexOf(t), 1),
                    this.remove(n),
                    n.unsubscribe();
                }
              }),
              (e.prototype.trySubscribe = function(t) {
                var e = this.contexts,
                  r = new Ee.a(),
                  n = { buffer: [], subscription: r };
                e.push(n);
                var i = Object(Te.a)(this, t, n);
                !i || i.closed
                  ? this.closeBuffer(n)
                  : ((i.context = n), this.add(i), r.add(i));
              }),
              e
            );
          })(Se.a),
          Ae = (function() {
            function t(t) {
              this.closingSelector = t;
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new De(t, this.closingSelector));
              }),
              t
            );
          })(),
          De = (function(t) {
            function e(e, r) {
              var n = t.call(this, e) || this;
              return (
                (n.closingSelector = r), (n.subscribing = !1), n.openBuffer(), n
              );
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                this.buffer.push(t);
              }),
              (e.prototype._complete = function() {
                var e = this.buffer;
                e && this.destination.next(e), t.prototype._complete.call(this);
              }),
              (e.prototype._unsubscribe = function() {
                (this.buffer = void 0), (this.subscribing = !1);
              }),
              (e.prototype.notifyNext = function() {
                this.openBuffer();
              }),
              (e.prototype.notifyComplete = function() {
                this.subscribing ? this.complete() : this.openBuffer();
              }),
              (e.prototype.openBuffer = function() {
                var t = this.closingSubscription;
                t && (this.remove(t), t.unsubscribe());
                var e,
                  r = this.buffer;
                this.buffer && this.destination.next(r), (this.buffer = []);
                try {
                  e = (0, this.closingSelector)();
                } catch (t) {
                  return this.error(t);
                }
                (t = new Ee.a()),
                  (this.closingSubscription = t),
                  this.add(t),
                  (this.subscribing = !0),
                  t.add(Object(se.c)(e, new se.a(this))),
                  (this.subscribing = !1);
              }),
              e
            );
          })(se.b),
          we = (function() {
            function t(t) {
              this.selector = t;
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new ke(t, this.selector, this.caught));
              }),
              t
            );
          })(),
          ke = (function(t) {
            function e(e, r, n) {
              var i = t.call(this, e) || this;
              return (i.selector = r), (i.caught = n), i;
            }
            return (
              ie.a(e, t),
              (e.prototype.error = function(e) {
                if (!this.isStopped) {
                  var r = void 0;
                  try {
                    r = this.selector(e, this.caught);
                  } catch (e) {
                    return void t.prototype.error.call(this, e);
                  }
                  this._unsubscribeAndRecycle();
                  var n = new se.a(this);
                  this.add(n);
                  var i = Object(se.c)(r, n);
                  i !== n && this.add(i);
                }
              }),
              e
            );
          })(se.b),
          Re = r(42),
          Oe = r(7),
          Ie = r(11),
          Ce = r(31),
          xe = r(58),
          Pe = r(25),
          Me = (function() {
            function t(t, e) {
              (this.predicate = t), (this.source = e);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new Fe(t, this.predicate, this.source));
              }),
              t
            );
          })(),
          Fe = (function(t) {
            function e(e, r, n) {
              var i = t.call(this, e) || this;
              return (
                (i.predicate = r),
                (i.source = n),
                (i.count = 0),
                (i.index = 0),
                i
              );
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                this.predicate ? this._tryPredicate(t) : this.count++;
              }),
              (e.prototype._tryPredicate = function(t) {
                var e;
                try {
                  e = this.predicate(t, this.index++, this.source);
                } catch (t) {
                  return void this.destination.error(t);
                }
                e && this.count++;
              }),
              (e.prototype._complete = function() {
                this.destination.next(this.count), this.destination.complete();
              }),
              e
            );
          })(de.a),
          Ne = (function() {
            function t(t) {
              this.durationSelector = t;
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new Ue(t, this.durationSelector));
              }),
              t
            );
          })(),
          Ue = (function(t) {
            function e(e, r) {
              var n = t.call(this, e) || this;
              return (n.durationSelector = r), (n.hasValue = !1), n;
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                try {
                  var e = this.durationSelector.call(this, t);
                  e && this._tryNext(t, e);
                } catch (t) {
                  this.destination.error(t);
                }
              }),
              (e.prototype._complete = function() {
                this.emitValue(), this.destination.complete();
              }),
              (e.prototype._tryNext = function(t, e) {
                var r = this.durationSubscription;
                (this.value = t),
                  (this.hasValue = !0),
                  r && (r.unsubscribe(), this.remove(r)),
                  (r = Object(se.c)(e, new se.a(this))) &&
                    !r.closed &&
                    this.add((this.durationSubscription = r));
              }),
              (e.prototype.notifyNext = function() {
                this.emitValue();
              }),
              (e.prototype.notifyComplete = function() {
                this.emitValue();
              }),
              (e.prototype.emitValue = function() {
                if (this.hasValue) {
                  var e = this.value,
                    r = this.durationSubscription;
                  r &&
                    ((this.durationSubscription = void 0),
                    r.unsubscribe(),
                    this.remove(r)),
                    (this.value = void 0),
                    (this.hasValue = !1),
                    t.prototype._next.call(this, e);
                }
              }),
              e
            );
          })(se.b),
          Be = (function() {
            function t(t, e) {
              (this.dueTime = t), (this.scheduler = e);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new je(t, this.dueTime, this.scheduler));
              }),
              t
            );
          })(),
          je = (function(t) {
            function e(e, r, n) {
              var i = t.call(this, e) || this;
              return (
                (i.dueTime = r),
                (i.scheduler = n),
                (i.debouncedSubscription = null),
                (i.lastValue = null),
                (i.hasValue = !1),
                i
              );
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                this.clearDebounce(),
                  (this.lastValue = t),
                  (this.hasValue = !0),
                  this.add(
                    (this.debouncedSubscription = this.scheduler.schedule(
                      S,
                      this.dueTime,
                      this,
                    )),
                  );
              }),
              (e.prototype._complete = function() {
                this.debouncedNext(), this.destination.complete();
              }),
              (e.prototype.debouncedNext = function() {
                if ((this.clearDebounce(), this.hasValue)) {
                  var t = this.lastValue;
                  (this.lastValue = null),
                    (this.hasValue = !1),
                    this.destination.next(t);
                }
              }),
              (e.prototype.clearDebounce = function() {
                var t = this.debouncedSubscription;
                null !== t &&
                  (this.remove(t),
                  t.unsubscribe(),
                  (this.debouncedSubscription = null));
              }),
              e
            );
          })(de.a),
          Ge = (function() {
            function t(t) {
              this.defaultValue = t;
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new Ve(t, this.defaultValue));
              }),
              t
            );
          })(),
          Ve = (function(t) {
            function e(e, r) {
              var n = t.call(this, e) || this;
              return (n.defaultValue = r), (n.isEmpty = !0), n;
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                (this.isEmpty = !1), this.destination.next(t);
              }),
              (e.prototype._complete = function() {
                this.isEmpty && this.destination.next(this.defaultValue),
                  this.destination.complete();
              }),
              e
            );
          })(de.a),
          He = r(17),
          Ke = (function() {
            function t(t, e) {
              (this.delay = t), (this.scheduler = e);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new We(t, this.delay, this.scheduler));
              }),
              t
            );
          })(),
          We = (function(t) {
            function e(e, r, n) {
              var i = t.call(this, e) || this;
              return (
                (i.delay = r),
                (i.scheduler = n),
                (i.queue = []),
                (i.active = !1),
                (i.errored = !1),
                i
              );
            }
            return (
              ie.a(e, t),
              (e.dispatch = function(t) {
                for (
                  var e = t.source,
                    r = e.queue,
                    n = t.scheduler,
                    i = t.destination;
                  r.length > 0 && r[0].time - n.now() <= 0;

                )
                  r.shift().notification.observe(i);
                if (r.length > 0) {
                  var s = Math.max(0, r[0].time - n.now());
                  this.schedule(t, s);
                } else this.unsubscribe(), (e.active = !1);
              }),
              (e.prototype._schedule = function(t) {
                (this.active = !0),
                  this.destination.add(
                    t.schedule(e.dispatch, this.delay, {
                      source: this,
                      destination: this.destination,
                      scheduler: t,
                    }),
                  );
              }),
              (e.prototype.scheduleNotification = function(t) {
                if (!0 !== this.errored) {
                  var e = this.scheduler,
                    r = new Ye(e.now() + this.delay, t);
                  this.queue.push(r), !1 === this.active && this._schedule(e);
                }
              }),
              (e.prototype._next = function(t) {
                this.scheduleNotification(He.a.createNext(t));
              }),
              (e.prototype._error = function(t) {
                (this.errored = !0),
                  (this.queue = []),
                  this.destination.error(t),
                  this.unsubscribe();
              }),
              (e.prototype._complete = function() {
                this.scheduleNotification(He.a.createComplete()),
                  this.unsubscribe();
              }),
              e
            );
          })(de.a),
          Ye = (function() {
            return function(t, e) {
              (this.time = t), (this.notification = e);
            };
          })(),
          qe = r(3),
          ze = (function() {
            function t(t) {
              this.delayDurationSelector = t;
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new Xe(t, this.delayDurationSelector));
              }),
              t
            );
          })(),
          Xe = (function(t) {
            function e(e, r) {
              var n = t.call(this, e) || this;
              return (
                (n.delayDurationSelector = r),
                (n.completed = !1),
                (n.delayNotifierSubscriptions = []),
                (n.index = 0),
                n
              );
            }
            return (
              ie.a(e, t),
              (e.prototype.notifyNext = function(t, e, r, n, i) {
                this.destination.next(t),
                  this.removeSubscription(i),
                  this.tryComplete();
              }),
              (e.prototype.notifyError = function(t, e) {
                this._error(t);
              }),
              (e.prototype.notifyComplete = function(t) {
                var e = this.removeSubscription(t);
                e && this.destination.next(e), this.tryComplete();
              }),
              (e.prototype._next = function(t) {
                var e = this.index++;
                try {
                  var r = this.delayDurationSelector(t, e);
                  r && this.tryDelay(r, t);
                } catch (t) {
                  this.destination.error(t);
                }
              }),
              (e.prototype._complete = function() {
                (this.completed = !0), this.tryComplete(), this.unsubscribe();
              }),
              (e.prototype.removeSubscription = function(t) {
                t.unsubscribe();
                var e = this.delayNotifierSubscriptions.indexOf(t);
                return (
                  -1 !== e && this.delayNotifierSubscriptions.splice(e, 1),
                  t.outerValue
                );
              }),
              (e.prototype.tryDelay = function(t, e) {
                var r = Object(Te.a)(this, t, e);
                r &&
                  !r.closed &&
                  (this.destination.add(r),
                  this.delayNotifierSubscriptions.push(r));
              }),
              (e.prototype.tryComplete = function() {
                this.completed &&
                  0 === this.delayNotifierSubscriptions.length &&
                  this.destination.complete();
              }),
              e
            );
          })(Se.a),
          $e = (function(t) {
            function e(e, r) {
              var n = t.call(this) || this;
              return (n.source = e), (n.subscriptionDelay = r), n;
            }
            return (
              ie.a(e, t),
              (e.prototype._subscribe = function(t) {
                this.subscriptionDelay.subscribe(new Qe(t, this.source));
              }),
              e
            );
          })(qe.a),
          Qe = (function(t) {
            function e(e, r) {
              var n = t.call(this) || this;
              return (
                (n.parent = e), (n.source = r), (n.sourceSubscribed = !1), n
              );
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                this.subscribeToSource();
              }),
              (e.prototype._error = function(t) {
                this.unsubscribe(), this.parent.error(t);
              }),
              (e.prototype._complete = function() {
                this.unsubscribe(), this.subscribeToSource();
              }),
              (e.prototype.subscribeToSource = function() {
                this.sourceSubscribed ||
                  ((this.sourceSubscribed = !0),
                  this.unsubscribe(),
                  this.source.subscribe(this.parent));
              }),
              e
            );
          })(de.a),
          Je = (function() {
            function t() {}
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new Ze(t));
              }),
              t
            );
          })(),
          Ze = (function(t) {
            function e(e) {
              return t.call(this, e) || this;
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                t.observe(this.destination);
              }),
              e
            );
          })(de.a),
          tr = (function() {
            function t(t, e) {
              (this.keySelector = t), (this.flushes = e);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new er(t, this.keySelector, this.flushes));
              }),
              t
            );
          })(),
          er = (function(t) {
            function e(e, r, n) {
              var i = t.call(this, e) || this;
              return (
                (i.keySelector = r),
                (i.values = new Set()),
                n && i.add(Object(se.c)(n, new se.a(i))),
                i
              );
            }
            return (
              ie.a(e, t),
              (e.prototype.notifyNext = function() {
                this.values.clear();
              }),
              (e.prototype.notifyError = function(t) {
                this._error(t);
              }),
              (e.prototype._next = function(t) {
                this.keySelector
                  ? this._useKeySelector(t)
                  : this._finalizeNext(t, t);
              }),
              (e.prototype._useKeySelector = function(t) {
                var e,
                  r = this.destination;
                try {
                  e = this.keySelector(t);
                } catch (t) {
                  return void r.error(t);
                }
                this._finalizeNext(e, t);
              }),
              (e.prototype._finalizeNext = function(t, e) {
                var r = this.values;
                r.has(t) || (r.add(t), this.destination.next(e));
              }),
              e
            );
          })(se.b),
          rr = (function() {
            function t(t, e) {
              (this.compare = t), (this.keySelector = e);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new nr(t, this.compare, this.keySelector));
              }),
              t
            );
          })(),
          nr = (function(t) {
            function e(e, r, n) {
              var i = t.call(this, e) || this;
              return (
                (i.keySelector = n),
                (i.hasKey = !1),
                'function' == typeof r && (i.compare = r),
                i
              );
            }
            return (
              ie.a(e, t),
              (e.prototype.compare = function(t, e) {
                return t === e;
              }),
              (e.prototype._next = function(t) {
                var e;
                try {
                  var r = this.keySelector;
                  e = r ? r(t) : t;
                } catch (t) {
                  return this.destination.error(t);
                }
                var n = !1;
                if (this.hasKey)
                  try {
                    n = (0, this.compare)(this.key, e);
                  } catch (t) {
                    return this.destination.error(t);
                  }
                else this.hasKey = !0;
                n || ((this.key = e), this.destination.next(t));
              }),
              e
            );
          })(de.a),
          ir = r(22),
          sr = r(16),
          ar = r(24),
          or = (function() {
            function t(t) {
              this.errorFactory = t;
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new ur(t, this.errorFactory));
              }),
              t
            );
          })(),
          ur = (function(t) {
            function e(e, r) {
              var n = t.call(this, e) || this;
              return (n.errorFactory = r), (n.hasValue = !1), n;
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                (this.hasValue = !0), this.destination.next(t);
              }),
              (e.prototype._complete = function() {
                if (this.hasValue) return this.destination.complete();
                var t = void 0;
                try {
                  t = this.errorFactory();
                } catch (e) {
                  t = e;
                }
                this.destination.error(t);
              }),
              e
            );
          })(de.a),
          lr = r(10),
          cr = (function() {
            function t(t) {
              if (((this.total = t), this.total < 0)) throw new ir.a();
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new hr(t, this.total));
              }),
              t
            );
          })(),
          hr = (function(t) {
            function e(e, r) {
              var n = t.call(this, e) || this;
              return (n.total = r), (n.count = 0), n;
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                var e = this.total,
                  r = ++this.count;
                r <= e &&
                  (this.destination.next(t),
                  r === e && (this.destination.complete(), this.unsubscribe()));
              }),
              e
            );
          })(de.a),
          dr = r(34),
          fr = (function() {
            function t(t, e, r) {
              (this.predicate = t), (this.thisArg = e), (this.source = r);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(
                  new pr(t, this.predicate, this.thisArg, this.source),
                );
              }),
              t
            );
          })(),
          pr = (function(t) {
            function e(e, r, n, i) {
              var s = t.call(this, e) || this;
              return (
                (s.predicate = r),
                (s.thisArg = n),
                (s.source = i),
                (s.index = 0),
                (s.thisArg = n || s),
                s
              );
            }
            return (
              ie.a(e, t),
              (e.prototype.notifyComplete = function(t) {
                this.destination.next(t), this.destination.complete();
              }),
              (e.prototype._next = function(t) {
                var e = !1;
                try {
                  e = this.predicate.call(
                    this.thisArg,
                    t,
                    this.index++,
                    this.source,
                  );
                } catch (t) {
                  return void this.destination.error(t);
                }
                e || this.notifyComplete(!1);
              }),
              (e.prototype._complete = function() {
                this.notifyComplete(!0);
              }),
              e
            );
          })(de.a),
          vr = (function() {
            function t() {}
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new gr(t));
              }),
              t
            );
          })(),
          gr = (function(t) {
            function e(e) {
              var r = t.call(this, e) || this;
              return (r.hasCompleted = !1), (r.hasSubscription = !1), r;
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                this.hasSubscription ||
                  ((this.hasSubscription = !0),
                  this.add(Object(se.c)(t, new se.a(this))));
              }),
              (e.prototype._complete = function() {
                (this.hasCompleted = !0),
                  this.hasSubscription || this.destination.complete();
              }),
              (e.prototype.notifyComplete = function() {
                (this.hasSubscription = !1),
                  this.hasCompleted && this.destination.complete();
              }),
              e
            );
          })(se.b),
          mr = r(8),
          yr = (function() {
            function t(t) {
              this.project = t;
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new br(t, this.project));
              }),
              t
            );
          })(),
          br = (function(t) {
            function e(e, r) {
              var n = t.call(this, e) || this;
              return (
                (n.project = r),
                (n.hasSubscription = !1),
                (n.hasCompleted = !1),
                (n.index = 0),
                n
              );
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                this.hasSubscription || this.tryNext(t);
              }),
              (e.prototype.tryNext = function(t) {
                var e,
                  r = this.index++;
                try {
                  e = this.project(t, r);
                } catch (t) {
                  return void this.destination.error(t);
                }
                (this.hasSubscription = !0), this._innerSub(e);
              }),
              (e.prototype._innerSub = function(t) {
                var e = new se.a(this),
                  r = this.destination;
                r.add(e);
                var n = Object(se.c)(t, e);
                n !== e && r.add(n);
              }),
              (e.prototype._complete = function() {
                (this.hasCompleted = !0),
                  this.hasSubscription || this.destination.complete(),
                  this.unsubscribe();
              }),
              (e.prototype.notifyNext = function(t) {
                this.destination.next(t);
              }),
              (e.prototype.notifyError = function(t) {
                this.destination.error(t);
              }),
              (e.prototype.notifyComplete = function() {
                (this.hasSubscription = !1),
                  this.hasCompleted && this.destination.complete();
              }),
              e
            );
          })(se.b),
          Er = (function() {
            function t(t, e, r) {
              (this.project = t), (this.concurrent = e), (this.scheduler = r);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(
                  new Tr(t, this.project, this.concurrent, this.scheduler),
                );
              }),
              t
            );
          })(),
          Tr = (function(t) {
            function e(e, r, n, i) {
              var s = t.call(this, e) || this;
              return (
                (s.project = r),
                (s.concurrent = n),
                (s.scheduler = i),
                (s.index = 0),
                (s.active = 0),
                (s.hasCompleted = !1),
                n < Number.POSITIVE_INFINITY && (s.buffer = []),
                s
              );
            }
            return (
              ie.a(e, t),
              (e.dispatch = function(t) {
                var e = t.subscriber,
                  r = t.result,
                  n = t.value,
                  i = t.index;
                e.subscribeToProjection(r, n, i);
              }),
              (e.prototype._next = function(t) {
                var r = this.destination;
                if (r.closed) this._complete();
                else {
                  var n = this.index++;
                  if (this.active < this.concurrent) {
                    r.next(t);
                    try {
                      var i = (0, this.project)(t, n);
                      if (this.scheduler) {
                        var s = {
                          subscriber: this,
                          result: i,
                          value: t,
                          index: n,
                        };
                        this.destination.add(
                          this.scheduler.schedule(e.dispatch, 0, s),
                        );
                      } else this.subscribeToProjection(i, t, n);
                    } catch (t) {
                      r.error(t);
                    }
                  } else this.buffer.push(t);
                }
              }),
              (e.prototype.subscribeToProjection = function(t, e, r) {
                this.active++,
                  this.destination.add(Object(se.c)(t, new se.a(this)));
              }),
              (e.prototype._complete = function() {
                (this.hasCompleted = !0),
                  this.hasCompleted &&
                    0 === this.active &&
                    this.destination.complete(),
                  this.unsubscribe();
              }),
              (e.prototype.notifyNext = function(t) {
                this._next(t);
              }),
              (e.prototype.notifyComplete = function() {
                var t = this.buffer;
                this.active--,
                  t && t.length > 0 && this._next(t.shift()),
                  this.hasCompleted &&
                    0 === this.active &&
                    this.destination.complete();
              }),
              e
            );
          })(se.b),
          Sr = (function() {
            function t(t) {
              this.callback = t;
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new Lr(t, this.callback));
              }),
              t
            );
          })(),
          Lr = (function(t) {
            function e(e, r) {
              var n = t.call(this, e) || this;
              return n.add(new Ee.a(r)), n;
            }
            return ie.a(e, t), e;
          })(de.a),
          _r = (function() {
            function t(t, e, r, n) {
              (this.predicate = t),
                (this.source = e),
                (this.yieldIndex = r),
                (this.thisArg = n);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(
                  new Ar(
                    t,
                    this.predicate,
                    this.source,
                    this.yieldIndex,
                    this.thisArg,
                  ),
                );
              }),
              t
            );
          })(),
          Ar = (function(t) {
            function e(e, r, n, i, s) {
              var a = t.call(this, e) || this;
              return (
                (a.predicate = r),
                (a.source = n),
                (a.yieldIndex = i),
                (a.thisArg = s),
                (a.index = 0),
                a
              );
            }
            return (
              ie.a(e, t),
              (e.prototype.notifyComplete = function(t) {
                var e = this.destination;
                e.next(t), e.complete(), this.unsubscribe();
              }),
              (e.prototype._next = function(t) {
                var e = this.predicate,
                  r = this.thisArg,
                  n = this.index++;
                try {
                  e.call(r || this, t, n, this.source) &&
                    this.notifyComplete(this.yieldIndex ? n : t);
                } catch (t) {
                  this.destination.error(t);
                }
              }),
              (e.prototype._complete = function() {
                this.notifyComplete(this.yieldIndex ? -1 : void 0);
              }),
              e
            );
          })(de.a),
          Dr = r(14),
          wr = r(52),
          kr = (function() {
            function t() {}
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new Rr(t));
              }),
              t
            );
          })(),
          Rr = (function(t) {
            function e() {
              return (null !== t && t.apply(this, arguments)) || this;
            }
            return ie.a(e, t), (e.prototype._next = function(t) {}), e;
          })(de.a),
          Or = (function() {
            function t() {}
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new Ir(t));
              }),
              t
            );
          })(),
          Ir = (function(t) {
            function e(e) {
              return t.call(this, e) || this;
            }
            return (
              ie.a(e, t),
              (e.prototype.notifyComplete = function(t) {
                var e = this.destination;
                e.next(t), e.complete();
              }),
              (e.prototype._next = function(t) {
                this.notifyComplete(!1);
              }),
              (e.prototype._complete = function() {
                this.notifyComplete(!0);
              }),
              e
            );
          })(de.a),
          Cr = (function() {
            function t(t) {
              if (((this.total = t), this.total < 0)) throw new ir.a();
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new xr(t, this.total));
              }),
              t
            );
          })(),
          xr = (function(t) {
            function e(e, r) {
              var n = t.call(this, e) || this;
              return (n.total = r), (n.ring = new Array()), (n.count = 0), n;
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                var e = this.ring,
                  r = this.total,
                  n = this.count++;
                e.length < r ? e.push(t) : (e[n % r] = t);
              }),
              (e.prototype._complete = function() {
                var t = this.destination,
                  e = this.count;
                if (e > 0)
                  for (
                    var r = this.count >= this.total ? this.total : this.count,
                      n = this.ring,
                      i = 0;
                    i < r;
                    i++
                  ) {
                    var s = e++ % r;
                    t.next(n[s]);
                  }
                t.complete();
              }),
              e
            );
          })(de.a),
          Pr = (function() {
            function t(t) {
              this.value = t;
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new Mr(t, this.value));
              }),
              t
            );
          })(),
          Mr = (function(t) {
            function e(e, r) {
              var n = t.call(this, e) || this;
              return (n.value = r), n;
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                this.destination.next(this.value);
              }),
              e
            );
          })(de.a),
          Fr = (function() {
            function t() {}
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new Nr(t));
              }),
              t
            );
          })(),
          Nr = (function(t) {
            function e(e) {
              return t.call(this, e) || this;
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                this.destination.next(He.a.createNext(t));
              }),
              (e.prototype._error = function(t) {
                var e = this.destination;
                e.next(He.a.createError(t)), e.complete();
              }),
              (e.prototype._complete = function() {
                var t = this.destination;
                t.next(He.a.createComplete()), t.complete();
              }),
              e
            );
          })(de.a),
          Ur = (function() {
            function t(t, e, r) {
              void 0 === r && (r = !1),
                (this.accumulator = t),
                (this.seed = e),
                (this.hasSeed = r);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(
                  new Br(t, this.accumulator, this.seed, this.hasSeed),
                );
              }),
              t
            );
          })(),
          Br = (function(t) {
            function e(e, r, n, i) {
              var s = t.call(this, e) || this;
              return (
                (s.accumulator = r),
                (s._seed = n),
                (s.hasSeed = i),
                (s.index = 0),
                s
              );
            }
            return (
              ie.a(e, t),
              Object.defineProperty(e.prototype, 'seed', {
                get: function() {
                  return this._seed;
                },
                set: function(t) {
                  (this.hasSeed = !0), (this._seed = t);
                },
                enumerable: !0,
                configurable: !0,
              }),
              (e.prototype._next = function(t) {
                if (this.hasSeed) return this._tryNext(t);
                (this.seed = t), this.destination.next(t);
              }),
              (e.prototype._tryNext = function(t) {
                var e,
                  r = this.index++;
                try {
                  e = this.accumulator(this.seed, t, r);
                } catch (t) {
                  this.destination.error(t);
                }
                (this.seed = e), this.destination.next(e);
              }),
              e
            );
          })(de.a),
          jr = r(35),
          Gr = r(59),
          Vr = r(43),
          Hr = (function() {
            function t(t, e, r) {
              (this.accumulator = t), (this.seed = e), (this.concurrent = r);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(
                  new Kr(t, this.accumulator, this.seed, this.concurrent),
                );
              }),
              t
            );
          })(),
          Kr = (function(t) {
            function e(e, r, n, i) {
              var s = t.call(this, e) || this;
              return (
                (s.accumulator = r),
                (s.acc = n),
                (s.concurrent = i),
                (s.hasValue = !1),
                (s.hasCompleted = !1),
                (s.buffer = []),
                (s.active = 0),
                (s.index = 0),
                s
              );
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                if (this.active < this.concurrent) {
                  var e = this.index++,
                    r = this.destination,
                    n = void 0;
                  try {
                    n = (0, this.accumulator)(this.acc, t, e);
                  } catch (t) {
                    return r.error(t);
                  }
                  this.active++, this._innerSub(n);
                } else this.buffer.push(t);
              }),
              (e.prototype._innerSub = function(t) {
                var e = new se.a(this),
                  r = this.destination;
                r.add(e);
                var n = Object(se.c)(t, e);
                n !== e && r.add(n);
              }),
              (e.prototype._complete = function() {
                (this.hasCompleted = !0),
                  0 === this.active &&
                    0 === this.buffer.length &&
                    (!1 === this.hasValue && this.destination.next(this.acc),
                    this.destination.complete()),
                  this.unsubscribe();
              }),
              (e.prototype.notifyNext = function(t) {
                var e = this.destination;
                (this.acc = t), (this.hasValue = !0), e.next(t);
              }),
              (e.prototype.notifyComplete = function() {
                var t = this.buffer;
                this.active--,
                  t.length > 0
                    ? this._next(t.shift())
                    : 0 === this.active &&
                      this.hasCompleted &&
                      (!1 === this.hasValue && this.destination.next(this.acc),
                      this.destination.complete());
              }),
              e
            );
          })(se.b),
          Wr = r(54),
          Yr = (function() {
            function t(t, e) {
              (this.subjectFactory = t), (this.selector = e);
            }
            return (
              (t.prototype.call = function(t, e) {
                var r = this.selector,
                  n = this.subjectFactory(),
                  i = r(n).subscribe(t);
                return i.add(e.subscribe(n)), i;
              }),
              t
            );
          })(),
          qr = r(56),
          zr = (function() {
            function t(t) {
              this.nextSources = t;
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new Xr(t, this.nextSources));
              }),
              t
            );
          })(),
          Xr = (function(t) {
            function e(e, r) {
              var n = t.call(this, e) || this;
              return (n.destination = e), (n.nextSources = r), n;
            }
            return (
              ie.a(e, t),
              (e.prototype.notifyError = function() {
                this.subscribeToNextSource();
              }),
              (e.prototype.notifyComplete = function() {
                this.subscribeToNextSource();
              }),
              (e.prototype._error = function(t) {
                this.subscribeToNextSource(), this.unsubscribe();
              }),
              (e.prototype._complete = function() {
                this.subscribeToNextSource(), this.unsubscribe();
              }),
              (e.prototype.subscribeToNextSource = function() {
                var t = this.nextSources.shift();
                if (t) {
                  var e = new se.a(this),
                    r = this.destination;
                  r.add(e);
                  var n = Object(se.c)(t, e);
                  n !== e && r.add(n);
                } else this.destination.complete();
              }),
              e
            );
          })(se.b),
          $r = (function() {
            function t() {}
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new Qr(t));
              }),
              t
            );
          })(),
          Qr = (function(t) {
            function e(e) {
              var r = t.call(this, e) || this;
              return (r.hasPrev = !1), r;
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                var e;
                this.hasPrev ? (e = [this.prev, t]) : (this.hasPrev = !0),
                  (this.prev = t),
                  e && this.destination.next(e);
              }),
              e
            );
          })(de.a),
          Jr = r(67),
          Zr = r(5),
          tn = r(55),
          en = r(28),
          rn = r(40),
          nn = r(60),
          sn = (function() {
            function t(t, e) {
              (this.count = t), (this.source = e);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new an(t, this.count, this.source));
              }),
              t
            );
          })(),
          an = (function(t) {
            function e(e, r, n) {
              var i = t.call(this, e) || this;
              return (i.count = r), (i.source = n), i;
            }
            return (
              ie.a(e, t),
              (e.prototype.complete = function() {
                if (!this.isStopped) {
                  var e = this.source,
                    r = this.count;
                  if (0 === r) return t.prototype.complete.call(this);
                  r > -1 && (this.count = r - 1),
                    e.subscribe(this._unsubscribeAndRecycle());
                }
              }),
              e
            );
          })(de.a),
          on = (function() {
            function t(t) {
              this.notifier = t;
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new un(t, this.notifier, e));
              }),
              t
            );
          })(),
          un = (function(t) {
            function e(e, r, n) {
              var i = t.call(this, e) || this;
              return (
                (i.notifier = r),
                (i.source = n),
                (i.sourceIsBeingSubscribedTo = !0),
                i
              );
            }
            return (
              ie.a(e, t),
              (e.prototype.notifyNext = function() {
                (this.sourceIsBeingSubscribedTo = !0),
                  this.source.subscribe(this);
              }),
              (e.prototype.notifyComplete = function() {
                if (!1 === this.sourceIsBeingSubscribedTo)
                  return t.prototype.complete.call(this);
              }),
              (e.prototype.complete = function() {
                if (((this.sourceIsBeingSubscribedTo = !1), !this.isStopped)) {
                  if (
                    (this.retries || this.subscribeToRetries(),
                    !this.retriesSubscription ||
                      this.retriesSubscription.closed)
                  )
                    return t.prototype.complete.call(this);
                  this._unsubscribeAndRecycle(),
                    this.notifications.next(void 0);
                }
              }),
              (e.prototype._unsubscribe = function() {
                var t = this.notifications,
                  e = this.retriesSubscription;
                t && (t.unsubscribe(), (this.notifications = void 0)),
                  e && (e.unsubscribe(), (this.retriesSubscription = void 0)),
                  (this.retries = void 0);
              }),
              (e.prototype._unsubscribeAndRecycle = function() {
                var e = this._unsubscribe;
                return (
                  (this._unsubscribe = null),
                  t.prototype._unsubscribeAndRecycle.call(this),
                  (this._unsubscribe = e),
                  this
                );
              }),
              (e.prototype.subscribeToRetries = function() {
                var e;
                this.notifications = new Zr.a();
                try {
                  e = (0, this.notifier)(this.notifications);
                } catch (e) {
                  return t.prototype.complete.call(this);
                }
                (this.retries = e),
                  (this.retriesSubscription = Object(se.c)(e, new se.a(this)));
              }),
              e
            );
          })(se.b),
          ln = (function() {
            function t(t, e) {
              (this.count = t), (this.source = e);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new cn(t, this.count, this.source));
              }),
              t
            );
          })(),
          cn = (function(t) {
            function e(e, r, n) {
              var i = t.call(this, e) || this;
              return (i.count = r), (i.source = n), i;
            }
            return (
              ie.a(e, t),
              (e.prototype.error = function(e) {
                if (!this.isStopped) {
                  var r = this.source,
                    n = this.count;
                  if (0 === n) return t.prototype.error.call(this, e);
                  n > -1 && (this.count = n - 1),
                    r.subscribe(this._unsubscribeAndRecycle());
                }
              }),
              e
            );
          })(de.a),
          hn = (function() {
            function t(t, e) {
              (this.notifier = t), (this.source = e);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new dn(t, this.notifier, this.source));
              }),
              t
            );
          })(),
          dn = (function(t) {
            function e(e, r, n) {
              var i = t.call(this, e) || this;
              return (i.notifier = r), (i.source = n), i;
            }
            return (
              ie.a(e, t),
              (e.prototype.error = function(e) {
                if (!this.isStopped) {
                  var r = this.errors,
                    n = this.retries,
                    i = this.retriesSubscription;
                  if (n)
                    (this.errors = void 0), (this.retriesSubscription = void 0);
                  else {
                    r = new Zr.a();
                    try {
                      n = (0, this.notifier)(r);
                    } catch (e) {
                      return t.prototype.error.call(this, e);
                    }
                    i = Object(se.c)(n, new se.a(this));
                  }
                  this._unsubscribeAndRecycle(),
                    (this.errors = r),
                    (this.retries = n),
                    (this.retriesSubscription = i),
                    r.next(e);
                }
              }),
              (e.prototype._unsubscribe = function() {
                var t = this.errors,
                  e = this.retriesSubscription;
                t && (t.unsubscribe(), (this.errors = void 0)),
                  e && (e.unsubscribe(), (this.retriesSubscription = void 0)),
                  (this.retries = void 0);
              }),
              (e.prototype.notifyNext = function() {
                var t = this._unsubscribe;
                (this._unsubscribe = null),
                  this._unsubscribeAndRecycle(),
                  (this._unsubscribe = t),
                  this.source.subscribe(this);
              }),
              e
            );
          })(se.b),
          fn = r(39),
          pn = (function() {
            function t(t) {
              this.notifier = t;
            }
            return (
              (t.prototype.call = function(t, e) {
                var r = new vn(t),
                  n = e.subscribe(r);
                return n.add(Object(se.c)(this.notifier, new se.a(r))), n;
              }),
              t
            );
          })(),
          vn = (function(t) {
            function e() {
              var e = (null !== t && t.apply(this, arguments)) || this;
              return (e.hasValue = !1), e;
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                (this.value = t), (this.hasValue = !0);
              }),
              (e.prototype.notifyNext = function() {
                this.emitValue();
              }),
              (e.prototype.notifyComplete = function() {
                this.emitValue();
              }),
              (e.prototype.emitValue = function() {
                this.hasValue &&
                  ((this.hasValue = !1), this.destination.next(this.value));
              }),
              e
            );
          })(se.b),
          gn = (function() {
            function t(t, e) {
              (this.period = t), (this.scheduler = e);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new mn(t, this.period, this.scheduler));
              }),
              t
            );
          })(),
          mn = (function(t) {
            function e(e, r, n) {
              var i = t.call(this, e) || this;
              return (
                (i.period = r),
                (i.scheduler = n),
                (i.hasValue = !1),
                i.add(n.schedule(Et, r, { subscriber: i, period: r })),
                i
              );
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                (this.lastValue = t), (this.hasValue = !0);
              }),
              (e.prototype.notifyNext = function() {
                this.hasValue &&
                  ((this.hasValue = !1), this.destination.next(this.lastValue));
              }),
              e
            );
          })(de.a),
          yn = (function() {
            function t(t, e) {
              (this.compareTo = t), (this.comparator = e);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new bn(t, this.compareTo, this.comparator));
              }),
              t
            );
          })(),
          bn = (function(t) {
            function e(e, r, n) {
              var i = t.call(this, e) || this;
              return (
                (i.compareTo = r),
                (i.comparator = n),
                (i._a = []),
                (i._b = []),
                (i._oneComplete = !1),
                i.destination.add(r.subscribe(new En(e, i))),
                i
              );
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                this._oneComplete && 0 === this._b.length
                  ? this.emit(!1)
                  : (this._a.push(t), this.checkValues());
              }),
              (e.prototype._complete = function() {
                this._oneComplete
                  ? this.emit(0 === this._a.length && 0 === this._b.length)
                  : (this._oneComplete = !0),
                  this.unsubscribe();
              }),
              (e.prototype.checkValues = function() {
                for (
                  var t = this._a, e = this._b, r = this.comparator;
                  t.length > 0 && e.length > 0;

                ) {
                  var n = t.shift(),
                    i = e.shift(),
                    s = !1;
                  try {
                    s = r ? r(n, i) : n === i;
                  } catch (t) {
                    this.destination.error(t);
                  }
                  s || this.emit(!1);
                }
              }),
              (e.prototype.emit = function(t) {
                var e = this.destination;
                e.next(t), e.complete();
              }),
              (e.prototype.nextB = function(t) {
                this._oneComplete && 0 === this._a.length
                  ? this.emit(!1)
                  : (this._b.push(t), this.checkValues());
              }),
              (e.prototype.completeB = function() {
                this._oneComplete
                  ? this.emit(0 === this._a.length && 0 === this._b.length)
                  : (this._oneComplete = !0);
              }),
              e
            );
          })(de.a),
          En = (function(t) {
            function e(e, r) {
              var n = t.call(this, e) || this;
              return (n.parent = r), n;
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                this.parent.nextB(t);
              }),
              (e.prototype._error = function(t) {
                this.parent.error(t), this.unsubscribe();
              }),
              (e.prototype._complete = function() {
                this.parent.completeB(), this.unsubscribe();
              }),
              e
            );
          })(de.a),
          Tn = (function() {
            function t(t, e) {
              (this.predicate = t), (this.source = e);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new Sn(t, this.predicate, this.source));
              }),
              t
            );
          })(),
          Sn = (function(t) {
            function e(e, r, n) {
              var i = t.call(this, e) || this;
              return (
                (i.predicate = r),
                (i.source = n),
                (i.seenValue = !1),
                (i.index = 0),
                i
              );
            }
            return (
              ie.a(e, t),
              (e.prototype.applySingleValue = function(t) {
                this.seenValue
                  ? this.destination.error(
                      'Sequence contains more than one element',
                    )
                  : ((this.seenValue = !0), (this.singleValue = t));
              }),
              (e.prototype._next = function(t) {
                var e = this.index++;
                this.predicate ? this.tryNext(t, e) : this.applySingleValue(t);
              }),
              (e.prototype.tryNext = function(t, e) {
                try {
                  this.predicate(t, e, this.source) && this.applySingleValue(t);
                } catch (t) {
                  this.destination.error(t);
                }
              }),
              (e.prototype._complete = function() {
                var t = this.destination;
                this.index > 0
                  ? (t.next(this.seenValue ? this.singleValue : void 0),
                    t.complete())
                  : t.error(new ar.a());
              }),
              e
            );
          })(de.a),
          Ln = (function() {
            function t(t) {
              this.total = t;
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new _n(t, this.total));
              }),
              t
            );
          })(),
          _n = (function(t) {
            function e(e, r) {
              var n = t.call(this, e) || this;
              return (n.total = r), (n.count = 0), n;
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                ++this.count > this.total && this.destination.next(t);
              }),
              e
            );
          })(de.a),
          An = (function() {
            function t(t) {
              if (((this._skipCount = t), this._skipCount < 0))
                throw new ir.a();
            }
            return (
              (t.prototype.call = function(t, e) {
                return 0 === this._skipCount
                  ? e.subscribe(new de.a(t))
                  : e.subscribe(new Dn(t, this._skipCount));
              }),
              t
            );
          })(),
          Dn = (function(t) {
            function e(e, r) {
              var n = t.call(this, e) || this;
              return (
                (n._skipCount = r), (n._count = 0), (n._ring = new Array(r)), n
              );
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                var e = this._skipCount,
                  r = this._count++;
                if (r < e) this._ring[r] = t;
                else {
                  var n = r % e,
                    i = this._ring,
                    s = i[n];
                  (i[n] = t), this.destination.next(s);
                }
              }),
              e
            );
          })(de.a),
          wn = (function() {
            function t(t) {
              this.notifier = t;
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new kn(t, this.notifier));
              }),
              t
            );
          })(),
          kn = (function(t) {
            function e(e, r) {
              var n = t.call(this, e) || this;
              n.hasValue = !1;
              var i = new se.a(n);
              n.add(i), (n.innerSubscription = i);
              var s = Object(se.c)(r, i);
              return s !== i && (n.add(s), (n.innerSubscription = s)), n;
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(e) {
                this.hasValue && t.prototype._next.call(this, e);
              }),
              (e.prototype.notifyNext = function() {
                (this.hasValue = !0),
                  this.innerSubscription &&
                    this.innerSubscription.unsubscribe();
              }),
              (e.prototype.notifyComplete = function() {}),
              e
            );
          })(se.b),
          Rn = (function() {
            function t(t) {
              this.predicate = t;
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new On(t, this.predicate));
              }),
              t
            );
          })(),
          On = (function(t) {
            function e(e, r) {
              var n = t.call(this, e) || this;
              return (n.predicate = r), (n.skipping = !0), (n.index = 0), n;
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                var e = this.destination;
                this.skipping && this.tryCallPredicate(t),
                  this.skipping || e.next(t);
              }),
              (e.prototype.tryCallPredicate = function(t) {
                try {
                  var e = this.predicate(t, this.index++);
                  this.skipping = Boolean(e);
                } catch (t) {
                  this.destination.error(t);
                }
              }),
              e
            );
          })(de.a),
          In = r(36),
          Cn = r(30),
          xn = (function(t) {
            function e(e, r, n) {
              void 0 === r && (r = 0), void 0 === n && (n = In.a);
              var i = t.call(this) || this;
              return (
                (i.source = e),
                (i.delayTime = r),
                (i.scheduler = n),
                (!Object(Cn.a)(r) || r < 0) && (i.delayTime = 0),
                (n && 'function' == typeof n.schedule) || (i.scheduler = In.a),
                i
              );
            }
            return (
              ie.a(e, t),
              (e.create = function(t, r, n) {
                return (
                  void 0 === r && (r = 0),
                  void 0 === n && (n = In.a),
                  new e(t, r, n)
                );
              }),
              (e.dispatch = function(t) {
                var e = t.source,
                  r = t.subscriber;
                return this.add(e.subscribe(r));
              }),
              (e.prototype._subscribe = function(t) {
                var r = this.delayTime,
                  n = this.source;
                return this.scheduler.schedule(e.dispatch, r, {
                  source: n,
                  subscriber: t,
                });
              }),
              e
            );
          })(qe.a),
          Pn = (function() {
            function t(t, e) {
              (this.scheduler = t), (this.delay = e);
            }
            return (
              (t.prototype.call = function(t, e) {
                return new xn(e, this.delay, this.scheduler).subscribe(t);
              }),
              t
            );
          })(),
          Mn = (function() {
            function t(t) {
              this.project = t;
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new Fn(t, this.project));
              }),
              t
            );
          })(),
          Fn = (function(t) {
            function e(e, r) {
              var n = t.call(this, e) || this;
              return (n.project = r), (n.index = 0), n;
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                var e,
                  r = this.index++;
                try {
                  e = this.project(t, r);
                } catch (t) {
                  return void this.destination.error(t);
                }
                this._innerSub(e);
              }),
              (e.prototype._innerSub = function(t) {
                var e = this.innerSubscription;
                e && e.unsubscribe();
                var r = new se.a(this),
                  n = this.destination;
                n.add(r),
                  (this.innerSubscription = Object(se.c)(t, r)),
                  this.innerSubscription !== r && n.add(this.innerSubscription);
              }),
              (e.prototype._complete = function() {
                var e = this.innerSubscription;
                (e && !e.closed) || t.prototype._complete.call(this),
                  this.unsubscribe();
              }),
              (e.prototype._unsubscribe = function() {
                this.innerSubscription = void 0;
              }),
              (e.prototype.notifyComplete = function() {
                (this.innerSubscription = void 0),
                  this.isStopped && t.prototype._complete.call(this);
              }),
              (e.prototype.notifyNext = function(t) {
                this.destination.next(t);
              }),
              e
            );
          })(se.b),
          Nn = (function() {
            function t(t) {
              this.notifier = t;
            }
            return (
              (t.prototype.call = function(t, e) {
                var r = new Un(t),
                  n = Object(se.c)(this.notifier, new se.a(r));
                return n && !r.seenValue ? (r.add(n), e.subscribe(r)) : r;
              }),
              t
            );
          })(),
          Un = (function(t) {
            function e(e) {
              var r = t.call(this, e) || this;
              return (r.seenValue = !1), r;
            }
            return (
              ie.a(e, t),
              (e.prototype.notifyNext = function() {
                (this.seenValue = !0), this.complete();
              }),
              (e.prototype.notifyComplete = function() {}),
              e
            );
          })(se.b),
          Bn = (function() {
            function t(t, e) {
              (this.predicate = t), (this.inclusive = e);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new jn(t, this.predicate, this.inclusive));
              }),
              t
            );
          })(),
          jn = (function(t) {
            function e(e, r, n) {
              var i = t.call(this, e) || this;
              return (i.predicate = r), (i.inclusive = n), (i.index = 0), i;
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                var e,
                  r = this.destination;
                try {
                  e = this.predicate(t, this.index++);
                } catch (t) {
                  return void r.error(t);
                }
                this.nextOrComplete(t, e);
              }),
              (e.prototype.nextOrComplete = function(t, e) {
                var r = this.destination;
                Boolean(e)
                  ? r.next(t)
                  : (this.inclusive && r.next(t), r.complete());
              }),
              e
            );
          })(de.a),
          Gn = r(19),
          Vn = r(23),
          Hn = (function() {
            function t(t, e, r) {
              (this.nextOrObserver = t), (this.error = e), (this.complete = r);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(
                  new Kn(t, this.nextOrObserver, this.error, this.complete),
                );
              }),
              t
            );
          })(),
          Kn = (function(t) {
            function e(e, r, n, i) {
              var s = t.call(this, e) || this;
              return (
                (s._tapNext = Gn.a),
                (s._tapError = Gn.a),
                (s._tapComplete = Gn.a),
                (s._tapError = n || Gn.a),
                (s._tapComplete = i || Gn.a),
                Object(Vn.a)(r)
                  ? ((s._context = s), (s._tapNext = r))
                  : r &&
                    ((s._context = r),
                    (s._tapNext = r.next || Gn.a),
                    (s._tapError = r.error || Gn.a),
                    (s._tapComplete = r.complete || Gn.a)),
                s
              );
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                try {
                  this._tapNext.call(this._context, t);
                } catch (t) {
                  return void this.destination.error(t);
                }
                this.destination.next(t);
              }),
              (e.prototype._error = function(t) {
                try {
                  this._tapError.call(this._context, t);
                } catch (t) {
                  return void this.destination.error(t);
                }
                this.destination.error(t);
              }),
              (e.prototype._complete = function() {
                try {
                  this._tapComplete.call(this._context);
                } catch (t) {
                  return void this.destination.error(t);
                }
                return this.destination.complete();
              }),
              e
            );
          })(de.a),
          Wn = { leading: !0, trailing: !1 },
          Yn = (function() {
            function t(t, e, r) {
              (this.durationSelector = t),
                (this.leading = e),
                (this.trailing = r);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(
                  new qn(t, this.durationSelector, this.leading, this.trailing),
                );
              }),
              t
            );
          })(),
          qn = (function(t) {
            function e(e, r, n, i) {
              var s = t.call(this, e) || this;
              return (
                (s.destination = e),
                (s.durationSelector = r),
                (s._leading = n),
                (s._trailing = i),
                (s._hasValue = !1),
                s
              );
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                (this._hasValue = !0),
                  (this._sendValue = t),
                  this._throttled ||
                    (this._leading ? this.send() : this.throttle(t));
              }),
              (e.prototype.send = function() {
                var t = this._hasValue,
                  e = this._sendValue;
                t && (this.destination.next(e), this.throttle(e)),
                  (this._hasValue = !1),
                  (this._sendValue = void 0);
              }),
              (e.prototype.throttle = function(t) {
                var e = this.tryDurationSelector(t);
                e &&
                  this.add((this._throttled = Object(se.c)(e, new se.a(this))));
              }),
              (e.prototype.tryDurationSelector = function(t) {
                try {
                  return this.durationSelector(t);
                } catch (t) {
                  return this.destination.error(t), null;
                }
              }),
              (e.prototype.throttlingDone = function() {
                var t = this._throttled,
                  e = this._trailing;
                t && t.unsubscribe(),
                  (this._throttled = void 0),
                  e && this.send();
              }),
              (e.prototype.notifyNext = function() {
                this.throttlingDone();
              }),
              (e.prototype.notifyComplete = function() {
                this.throttlingDone();
              }),
              e
            );
          })(se.b),
          zn = (function() {
            function t(t, e, r, n) {
              (this.duration = t),
                (this.scheduler = e),
                (this.leading = r),
                (this.trailing = n);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(
                  new Xn(
                    t,
                    this.duration,
                    this.scheduler,
                    this.leading,
                    this.trailing,
                  ),
                );
              }),
              t
            );
          })(),
          Xn = (function(t) {
            function e(e, r, n, i, s) {
              var a = t.call(this, e) || this;
              return (
                (a.duration = r),
                (a.scheduler = n),
                (a.leading = i),
                (a.trailing = s),
                (a._hasTrailingValue = !1),
                (a._trailingValue = null),
                a
              );
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                this.throttled
                  ? this.trailing &&
                    ((this._trailingValue = t), (this._hasTrailingValue = !0))
                  : (this.add(
                      (this.throttled = this.scheduler.schedule(
                        jt,
                        this.duration,
                        { subscriber: this },
                      )),
                    ),
                    this.leading
                      ? this.destination.next(t)
                      : this.trailing &&
                        ((this._trailingValue = t),
                        (this._hasTrailingValue = !0)));
              }),
              (e.prototype._complete = function() {
                this._hasTrailingValue
                  ? (this.destination.next(this._trailingValue),
                    this.destination.complete())
                  : this.destination.complete();
              }),
              (e.prototype.clearThrottle = function() {
                var t = this.throttled;
                t &&
                  (this.trailing &&
                    this._hasTrailingValue &&
                    (this.destination.next(this._trailingValue),
                    (this._trailingValue = null),
                    (this._hasTrailingValue = !1)),
                  t.unsubscribe(),
                  this.remove(t),
                  (this.throttled = null));
              }),
              e
            );
          })(de.a),
          $n = r(44),
          Qn = (function() {
            return function(t, e) {
              (this.value = t), (this.interval = e);
            };
          })(),
          Jn = r(57),
          Zn = (function() {
            function t(t, e, r, n) {
              (this.waitFor = t),
                (this.absoluteTimeout = e),
                (this.withObservable = r),
                (this.scheduler = n);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(
                  new ti(
                    t,
                    this.absoluteTimeout,
                    this.waitFor,
                    this.withObservable,
                    this.scheduler,
                  ),
                );
              }),
              t
            );
          })(),
          ti = (function(t) {
            function e(e, r, n, i, s) {
              var a = t.call(this, e) || this;
              return (
                (a.absoluteTimeout = r),
                (a.waitFor = n),
                (a.withObservable = i),
                (a.scheduler = s),
                a.scheduleTimeout(),
                a
              );
            }
            return (
              ie.a(e, t),
              (e.dispatchTimeout = function(t) {
                var e = t.withObservable;
                t._unsubscribeAndRecycle(), t.add(Object(se.c)(e, new se.a(t)));
              }),
              (e.prototype.scheduleTimeout = function() {
                var t = this.action;
                t
                  ? (this.action = t.schedule(this, this.waitFor))
                  : this.add(
                      (this.action = this.scheduler.schedule(
                        e.dispatchTimeout,
                        this.waitFor,
                        this,
                      )),
                    );
              }),
              (e.prototype._next = function(e) {
                this.absoluteTimeout || this.scheduleTimeout(),
                  t.prototype._next.call(this, e);
              }),
              (e.prototype._unsubscribe = function() {
                (this.action = void 0),
                  (this.scheduler = null),
                  (this.withObservable = null);
              }),
              e
            );
          })(se.b),
          ei = r(41),
          ri = (function() {
            return function(t, e) {
              (this.value = t), (this.timestamp = e);
            };
          })(),
          ni = (function() {
            function t(t) {
              this.windowBoundaries = t;
            }
            return (
              (t.prototype.call = function(t, e) {
                var r = new ii(t),
                  n = e.subscribe(r);
                return (
                  n.closed ||
                    r.add(Object(se.c)(this.windowBoundaries, new se.a(r))),
                  n
                );
              }),
              t
            );
          })(),
          ii = (function(t) {
            function e(e) {
              var r = t.call(this, e) || this;
              return (r.window = new Zr.a()), e.next(r.window), r;
            }
            return (
              ie.a(e, t),
              (e.prototype.notifyNext = function() {
                this.openWindow();
              }),
              (e.prototype.notifyError = function(t) {
                this._error(t);
              }),
              (e.prototype.notifyComplete = function() {
                this._complete();
              }),
              (e.prototype._next = function(t) {
                this.window.next(t);
              }),
              (e.prototype._error = function(t) {
                this.window.error(t), this.destination.error(t);
              }),
              (e.prototype._complete = function() {
                this.window.complete(), this.destination.complete();
              }),
              (e.prototype._unsubscribe = function() {
                this.window = null;
              }),
              (e.prototype.openWindow = function() {
                var t = this.window;
                t && t.complete();
                var e = this.destination,
                  r = (this.window = new Zr.a());
                e.next(r);
              }),
              e
            );
          })(se.b),
          si = (function() {
            function t(t, e) {
              (this.windowSize = t), (this.startWindowEvery = e);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(
                  new ai(t, this.windowSize, this.startWindowEvery),
                );
              }),
              t
            );
          })(),
          ai = (function(t) {
            function e(e, r, n) {
              var i = t.call(this, e) || this;
              return (
                (i.destination = e),
                (i.windowSize = r),
                (i.startWindowEvery = n),
                (i.windows = [new Zr.a()]),
                (i.count = 0),
                e.next(i.windows[0]),
                i
              );
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                for (
                  var e =
                      this.startWindowEvery > 0
                        ? this.startWindowEvery
                        : this.windowSize,
                    r = this.destination,
                    n = this.windowSize,
                    i = this.windows,
                    s = i.length,
                    a = 0;
                  a < s && !this.closed;
                  a++
                )
                  i[a].next(t);
                var o = this.count - n + 1;
                if (
                  (o >= 0 && o % e == 0 && !this.closed && i.shift().complete(),
                  ++this.count % e == 0 && !this.closed)
                ) {
                  var u = new Zr.a();
                  i.push(u), r.next(u);
                }
              }),
              (e.prototype._error = function(t) {
                var e = this.windows;
                if (e)
                  for (; e.length > 0 && !this.closed; ) e.shift().error(t);
                this.destination.error(t);
              }),
              (e.prototype._complete = function() {
                var t = this.windows;
                if (t)
                  for (; t.length > 0 && !this.closed; ) t.shift().complete();
                this.destination.complete();
              }),
              (e.prototype._unsubscribe = function() {
                (this.count = 0), (this.windows = null);
              }),
              e
            );
          })(de.a),
          oi = (function() {
            function t(t, e, r, n) {
              (this.windowTimeSpan = t),
                (this.windowCreationInterval = e),
                (this.maxWindowSize = r),
                (this.scheduler = n);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(
                  new li(
                    t,
                    this.windowTimeSpan,
                    this.windowCreationInterval,
                    this.maxWindowSize,
                    this.scheduler,
                  ),
                );
              }),
              t
            );
          })(),
          ui = (function(t) {
            function e() {
              var e = (null !== t && t.apply(this, arguments)) || this;
              return (e._numberOfNextedValues = 0), e;
            }
            return (
              ie.a(e, t),
              (e.prototype.next = function(e) {
                this._numberOfNextedValues++, t.prototype.next.call(this, e);
              }),
              Object.defineProperty(e.prototype, 'numberOfNextedValues', {
                get: function() {
                  return this._numberOfNextedValues;
                },
                enumerable: !0,
                configurable: !0,
              }),
              e
            );
          })(Zr.a),
          li = (function(t) {
            function e(e, r, n, i, s) {
              var a = t.call(this, e) || this;
              (a.destination = e),
                (a.windowTimeSpan = r),
                (a.windowCreationInterval = n),
                (a.maxWindowSize = i),
                (a.scheduler = s),
                (a.windows = []);
              var o = a.openWindow();
              if (null !== n && n >= 0) {
                var u = { subscriber: a, window: o, context: null },
                  l = {
                    windowTimeSpan: r,
                    windowCreationInterval: n,
                    subscriber: a,
                    scheduler: s,
                  };
                a.add(s.schedule(Jt, r, u)), a.add(s.schedule(Qt, n, l));
              } else {
                var c = { subscriber: a, window: o, windowTimeSpan: r };
                a.add(s.schedule($t, r, c));
              }
              return a;
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                for (var e = this.windows, r = e.length, n = 0; n < r; n++) {
                  var i = e[n];
                  i.closed ||
                    (i.next(t),
                    i.numberOfNextedValues >= this.maxWindowSize &&
                      this.closeWindow(i));
                }
              }),
              (e.prototype._error = function(t) {
                for (var e = this.windows; e.length > 0; ) e.shift().error(t);
                this.destination.error(t);
              }),
              (e.prototype._complete = function() {
                for (var t = this.windows; t.length > 0; ) {
                  var e = t.shift();
                  e.closed || e.complete();
                }
                this.destination.complete();
              }),
              (e.prototype.openWindow = function() {
                var t = new ui();
                return this.windows.push(t), this.destination.next(t), t;
              }),
              (e.prototype.closeWindow = function(t) {
                t.complete();
                var e = this.windows;
                e.splice(e.indexOf(t), 1);
              }),
              e
            );
          })(de.a),
          ci = (function() {
            function t(t, e) {
              (this.openings = t), (this.closingSelector = e);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(
                  new hi(t, this.openings, this.closingSelector),
                );
              }),
              t
            );
          })(),
          hi = (function(t) {
            function e(e, r, n) {
              var i = t.call(this, e) || this;
              return (
                (i.openings = r),
                (i.closingSelector = n),
                (i.contexts = []),
                i.add((i.openSubscription = Object(Te.a)(i, r, r))),
                i
              );
            }
            return (
              ie.a(e, t),
              (e.prototype._next = function(t) {
                var e = this.contexts;
                if (e)
                  for (var r = e.length, n = 0; n < r; n++) e[n].window.next(t);
              }),
              (e.prototype._error = function(e) {
                var r = this.contexts;
                if (((this.contexts = null), r))
                  for (var n = r.length, i = -1; ++i < n; ) {
                    var s = r[i];
                    s.window.error(e), s.subscription.unsubscribe();
                  }
                t.prototype._error.call(this, e);
              }),
              (e.prototype._complete = function() {
                var e = this.contexts;
                if (((this.contexts = null), e))
                  for (var r = e.length, n = -1; ++n < r; ) {
                    var i = e[n];
                    i.window.complete(), i.subscription.unsubscribe();
                  }
                t.prototype._complete.call(this);
              }),
              (e.prototype._unsubscribe = function() {
                var t = this.contexts;
                if (((this.contexts = null), t))
                  for (var e = t.length, r = -1; ++r < e; ) {
                    var n = t[r];
                    n.window.unsubscribe(), n.subscription.unsubscribe();
                  }
              }),
              (e.prototype.notifyNext = function(t, e, r, n, i) {
                if (t === this.openings) {
                  var s = void 0;
                  try {
                    s = (0, this.closingSelector)(e);
                  } catch (t) {
                    return this.error(t);
                  }
                  var a = new Zr.a(),
                    o = new Ee.a(),
                    u = { window: a, subscription: o };
                  this.contexts.push(u);
                  var l = Object(Te.a)(this, s, u);
                  l.closed
                    ? this.closeWindow(this.contexts.length - 1)
                    : ((l.context = u), o.add(l)),
                    this.destination.next(a);
                } else this.closeWindow(this.contexts.indexOf(t));
              }),
              (e.prototype.notifyError = function(t) {
                this.error(t);
              }),
              (e.prototype.notifyComplete = function(t) {
                t !== this.openSubscription &&
                  this.closeWindow(this.contexts.indexOf(t.context));
              }),
              (e.prototype.closeWindow = function(t) {
                if (-1 !== t) {
                  var e = this.contexts,
                    r = e[t],
                    n = r.window,
                    i = r.subscription;
                  e.splice(t, 1), n.complete(), i.unsubscribe();
                }
              }),
              e
            );
          })(Se.a),
          di = (function() {
            function t(t) {
              this.closingSelector = t;
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new fi(t, this.closingSelector));
              }),
              t
            );
          })(),
          fi = (function(t) {
            function e(e, r) {
              var n = t.call(this, e) || this;
              return (
                (n.destination = e), (n.closingSelector = r), n.openWindow(), n
              );
            }
            return (
              ie.a(e, t),
              (e.prototype.notifyNext = function(t, e, r, n, i) {
                this.openWindow(i);
              }),
              (e.prototype.notifyError = function(t) {
                this._error(t);
              }),
              (e.prototype.notifyComplete = function(t) {
                this.openWindow(t);
              }),
              (e.prototype._next = function(t) {
                this.window.next(t);
              }),
              (e.prototype._error = function(t) {
                this.window.error(t),
                  this.destination.error(t),
                  this.unsubscribeClosingNotification();
              }),
              (e.prototype._complete = function() {
                this.window.complete(),
                  this.destination.complete(),
                  this.unsubscribeClosingNotification();
              }),
              (e.prototype.unsubscribeClosingNotification = function() {
                this.closingNotification &&
                  this.closingNotification.unsubscribe();
              }),
              (e.prototype.openWindow = function(t) {
                void 0 === t && (t = null),
                  t && (this.remove(t), t.unsubscribe());
                var e = this.window;
                e && e.complete();
                var r,
                  n = (this.window = new Zr.a());
                this.destination.next(n);
                try {
                  r = (0, this.closingSelector)();
                } catch (t) {
                  return this.destination.error(t), void this.window.error(t);
                }
                this.add((this.closingNotification = Object(Te.a)(this, r)));
              }),
              e
            );
          })(Se.a),
          pi = (function() {
            function t(t, e) {
              (this.observables = t), (this.project = e);
            }
            return (
              (t.prototype.call = function(t, e) {
                return e.subscribe(new vi(t, this.observables, this.project));
              }),
              t
            );
          })(),
          vi = (function(t) {
            function e(e, r, n) {
              var i = t.call(this, e) || this;
              (i.observables = r), (i.project = n), (i.toRespond = []);
              var s = r.length;
              i.values = new Array(s);
              for (var a = 0; a < s; a++) i.toRespond.push(a);
              for (a = 0; a < s; a++) {
                var o = r[a];
                i.add(Object(Te.a)(i, o, void 0, a));
              }
              return i;
            }
            return (
              ie.a(e, t),
              (e.prototype.notifyNext = function(t, e, r) {
                this.values[r] = e;
                var n = this.toRespond;
                if (n.length > 0) {
                  var i = n.indexOf(r);
                  -1 !== i && n.splice(i, 1);
                }
              }),
              (e.prototype.notifyComplete = function() {}),
              (e.prototype._next = function(t) {
                if (0 === this.toRespond.length) {
                  var e = [t].concat(this.values);
                  this.project ? this._tryProject(e) : this.destination.next(e);
                }
              }),
              (e.prototype._tryProject = function(t) {
                var e;
                try {
                  e = this.project.apply(this, t);
                } catch (t) {
                  return void this.destination.error(t);
                }
                this.destination.next(e);
              }),
              e
            );
          })(Se.a),
          gi = r(45);
        r.d(e, 'audit', function() {
          return n;
        }),
          r.d(e, 'auditTime', function() {
            return i;
          }),
          r.d(e, 'buffer', function() {
            return s;
          }),
          r.d(e, 'bufferCount', function() {
            return a;
          }),
          r.d(e, 'bufferTime', function() {
            return o;
          }),
          r.d(e, 'bufferToggle', function() {
            return h;
          }),
          r.d(e, 'bufferWhen', function() {
            return d;
          }),
          r.d(e, 'catchError', function() {
            return f;
          }),
          r.d(e, 'combineAll', function() {
            return p;
          }),
          r.d(e, 'combineLatest', function() {
            return v;
          }),
          r.d(e, 'concat', function() {
            return g;
          }),
          r.d(e, 'concatAll', function() {
            return xe.a;
          }),
          r.d(e, 'concatMap', function() {
            return m;
          }),
          r.d(e, 'concatMapTo', function() {
            return y;
          }),
          r.d(e, 'count', function() {
            return b;
          }),
          r.d(e, 'debounce', function() {
            return E;
          }),
          r.d(e, 'debounceTime', function() {
            return T;
          }),
          r.d(e, 'defaultIfEmpty', function() {
            return L;
          }),
          r.d(e, 'delay', function() {
            return A;
          }),
          r.d(e, 'delayWhen', function() {
            return D;
          }),
          r.d(e, 'dematerialize', function() {
            return w;
          }),
          r.d(e, 'distinct', function() {
            return k;
          }),
          r.d(e, 'distinctUntilChanged', function() {
            return R;
          }),
          r.d(e, 'distinctUntilKeyChanged', function() {
            return O;
          }),
          r.d(e, 'elementAt', function() {
            return P;
          }),
          r.d(e, 'endWith', function() {
            return M;
          }),
          r.d(e, 'every', function() {
            return F;
          }),
          r.d(e, 'exhaust', function() {
            return N;
          }),
          r.d(e, 'exhaustMap', function() {
            return U;
          }),
          r.d(e, 'expand', function() {
            return B;
          }),
          r.d(e, 'filter', function() {
            return sr.a;
          }),
          r.d(e, 'finalize', function() {
            return j;
          }),
          r.d(e, 'find', function() {
            return G;
          }),
          r.d(e, 'findIndex', function() {
            return V;
          }),
          r.d(e, 'first', function() {
            return H;
          }),
          r.d(e, 'groupBy', function() {
            return wr.b;
          }),
          r.d(e, 'ignoreElements', function() {
            return K;
          }),
          r.d(e, 'isEmpty', function() {
            return W;
          }),
          r.d(e, 'last', function() {
            return q;
          }),
          r.d(e, 'map', function() {
            return mr.a;
          }),
          r.d(e, 'mapTo', function() {
            return z;
          }),
          r.d(e, 'materialize', function() {
            return X;
          }),
          r.d(e, 'max', function() {
            return J;
          }),
          r.d(e, 'merge', function() {
            return Z;
          }),
          r.d(e, 'mergeAll', function() {
            return Vr.a;
          }),
          r.d(e, 'mergeMap', function() {
            return Pe.b;
          }),
          r.d(e, 'flatMap', function() {
            return Pe.a;
          }),
          r.d(e, 'mergeMapTo', function() {
            return tt;
          }),
          r.d(e, 'mergeScan', function() {
            return et;
          }),
          r.d(e, 'min', function() {
            return rt;
          }),
          r.d(e, 'multicast', function() {
            return nt;
          }),
          r.d(e, 'observeOn', function() {
            return qr.b;
          }),
          r.d(e, 'onErrorResumeNext', function() {
            return it;
          }),
          r.d(e, 'pairwise', function() {
            return st;
          }),
          r.d(e, 'partition', function() {
            return at;
          }),
          r.d(e, 'pluck', function() {
            return ot;
          }),
          r.d(e, 'publish', function() {
            return lt;
          }),
          r.d(e, 'publishBehavior', function() {
            return ct;
          }),
          r.d(e, 'publishLast', function() {
            return ht;
          }),
          r.d(e, 'publishReplay', function() {
            return dt;
          }),
          r.d(e, 'race', function() {
            return ft;
          }),
          r.d(e, 'reduce', function() {
            return Q;
          }),
          r.d(e, 'repeat', function() {
            return pt;
          }),
          r.d(e, 'repeatWhen', function() {
            return vt;
          }),
          r.d(e, 'retry', function() {
            return gt;
          }),
          r.d(e, 'retryWhen', function() {
            return mt;
          }),
          r.d(e, 'refCount', function() {
            return fn.a;
          }),
          r.d(e, 'sample', function() {
            return yt;
          }),
          r.d(e, 'sampleTime', function() {
            return bt;
          }),
          r.d(e, 'scan', function() {
            return $;
          }),
          r.d(e, 'sequenceEqual', function() {
            return Tt;
          }),
          r.d(e, 'share', function() {
            return Lt;
          }),
          r.d(e, 'shareReplay', function() {
            return _t;
          }),
          r.d(e, 'single', function() {
            return At;
          }),
          r.d(e, 'skip', function() {
            return Dt;
          }),
          r.d(e, 'skipLast', function() {
            return wt;
          }),
          r.d(e, 'skipUntil', function() {
            return kt;
          }),
          r.d(e, 'skipWhile', function() {
            return Rt;
          }),
          r.d(e, 'startWith', function() {
            return Ot;
          }),
          r.d(e, 'subscribeOn', function() {
            return It;
          }),
          r.d(e, 'switchAll', function() {
            return xt;
          }),
          r.d(e, 'switchMap', function() {
            return Ct;
          }),
          r.d(e, 'switchMapTo', function() {
            return Pt;
          }),
          r.d(e, 'take', function() {
            return x;
          }),
          r.d(e, 'takeLast', function() {
            return Y;
          }),
          r.d(e, 'takeUntil', function() {
            return Mt;
          }),
          r.d(e, 'takeWhile', function() {
            return Ft;
          }),
          r.d(e, 'tap', function() {
            return Nt;
          }),
          r.d(e, 'throttle', function() {
            return Ut;
          }),
          r.d(e, 'throttleTime', function() {
            return Bt;
          }),
          r.d(e, 'throwIfEmpty', function() {
            return I;
          }),
          r.d(e, 'timeInterval', function() {
            return Gt;
          }),
          r.d(e, 'timeout', function() {
            return Ht;
          }),
          r.d(e, 'timeoutWith', function() {
            return Vt;
          }),
          r.d(e, 'timestamp', function() {
            return Kt;
          }),
          r.d(e, 'toArray', function() {
            return Yt;
          }),
          r.d(e, 'window', function() {
            return qt;
          }),
          r.d(e, 'windowCount', function() {
            return zt;
          }),
          r.d(e, 'windowTime', function() {
            return Xt;
          }),
          r.d(e, 'windowToggle', function() {
            return Zt;
          }),
          r.d(e, 'windowWhen', function() {
            return te;
          }),
          r.d(e, 'withLatestFrom', function() {
            return ee;
          }),
          r.d(e, 'zip', function() {
            return re;
          }),
          r.d(e, 'zipAll', function() {
            return ne;
          });
      },
      function(t, e, r) {
        function n(t) {
          return (
            !!t &&
            (t instanceof k.a ||
              ('function' == typeof t.lift && 'function' == typeof t.subscribe))
          );
        }
        function i(t, e, r) {
          if (e) {
            if (!Object(ut.a)(e))
              return function() {
                for (var n = [], s = 0; s < arguments.length; s++)
                  n[s] = arguments[s];
                return i(t, r)
                  .apply(void 0, n)
                  .pipe(
                    Object(st.a)(function(t) {
                      return Object(ot.a)(t) ? e.apply(void 0, t) : e(t);
                    }),
                  );
              };
            r = e;
          }
          return function() {
            for (var e = [], n = 0; n < arguments.length; n++)
              e[n] = arguments[n];
            var i,
              a = this,
              o = { context: a, subject: i, callbackFunc: t, scheduler: r };
            return new k.a(function(n) {
              if (r) {
                var u = { args: e, subscriber: n, params: o };
                return r.schedule(s, 0, u);
              }
              if (!i) {
                i = new M.a();
                try {
                  t.apply(
                    a,
                    e.concat([
                      function() {
                        for (var t = [], e = 0; e < arguments.length; e++)
                          t[e] = arguments[e];
                        i.next(t.length <= 1 ? t[0] : t), i.complete();
                      },
                    ]),
                  );
                } catch (t) {
                  Object(at.a)(i) ? i.error(t) : console.warn(t);
                }
              }
              return i.subscribe(n);
            });
          };
        }
        function s(t) {
          var e = this,
            r = t.args,
            n = t.subscriber,
            i = t.params,
            s = i.callbackFunc,
            o = i.context,
            u = i.scheduler,
            l = i.subject;
          if (!l) {
            l = i.subject = new M.a();
            try {
              s.apply(
                o,
                r.concat([
                  function() {
                    for (var t = [], r = 0; r < arguments.length; r++)
                      t[r] = arguments[r];
                    var n = t.length <= 1 ? t[0] : t;
                    e.add(u.schedule(a, 0, { value: n, subject: l }));
                  },
                ]),
              );
            } catch (t) {
              l.error(t);
            }
          }
          this.add(l.subscribe(n));
        }
        function a(t) {
          var e = t.value,
            r = t.subject;
          r.next(e), r.complete();
        }
        function o(t, e, r) {
          if (e) {
            if (!Object(ut.a)(e))
              return function() {
                for (var n = [], i = 0; i < arguments.length; i++)
                  n[i] = arguments[i];
                return o(t, r)
                  .apply(void 0, n)
                  .pipe(
                    Object(st.a)(function(t) {
                      return Object(ot.a)(t) ? e.apply(void 0, t) : e(t);
                    }),
                  );
              };
            r = e;
          }
          return function() {
            for (var e = [], n = 0; n < arguments.length; n++)
              e[n] = arguments[n];
            var i = {
              subject: void 0,
              args: e,
              callbackFunc: t,
              scheduler: r,
              context: this,
            };
            return new k.a(function(n) {
              var s = i.context,
                a = i.subject;
              if (r)
                return r.schedule(u, 0, {
                  params: i,
                  subscriber: n,
                  context: s,
                });
              if (!a) {
                a = i.subject = new M.a();
                try {
                  t.apply(
                    s,
                    e.concat([
                      function() {
                        for (var t = [], e = 0; e < arguments.length; e++)
                          t[e] = arguments[e];
                        var r = t.shift();
                        r
                          ? a.error(r)
                          : (a.next(t.length <= 1 ? t[0] : t), a.complete());
                      },
                    ]),
                  );
                } catch (t) {
                  Object(at.a)(a) ? a.error(t) : console.warn(t);
                }
              }
              return a.subscribe(n);
            });
          };
        }
        function u(t) {
          var e = this,
            r = t.params,
            n = t.subscriber,
            i = t.context,
            s = r.callbackFunc,
            a = r.args,
            o = r.scheduler,
            u = r.subject;
          if (!u) {
            u = r.subject = new M.a();
            try {
              s.apply(
                i,
                a.concat([
                  function() {
                    for (var t = [], r = 0; r < arguments.length; r++)
                      t[r] = arguments[r];
                    var n = t.shift();
                    if (n) e.add(o.schedule(c, 0, { err: n, subject: u }));
                    else {
                      var i = t.length <= 1 ? t[0] : t;
                      e.add(o.schedule(l, 0, { value: i, subject: u }));
                    }
                  },
                ]),
              );
            } catch (t) {
              this.add(o.schedule(c, 0, { err: t, subject: u }));
            }
          }
          this.add(u.subscribe(n));
        }
        function l(t) {
          var e = t.value,
            r = t.subject;
          r.next(e), r.complete();
        }
        function c(t) {
          var e = t.err;
          t.subject.error(e);
        }
        function h() {
          for (var t = [], e = 0; e < arguments.length; e++)
            t[e] = arguments[e];
          if (1 === t.length) {
            var r = t[0];
            if (Object(ot.a)(r)) return d(r, null);
            if (
              Object(ft.a)(r) &&
              Object.getPrototypeOf(r) === Object.prototype
            ) {
              var n = Object.keys(r);
              return d(
                n.map(function(t) {
                  return r[t];
                }),
                n,
              );
            }
          }
          if ('function' == typeof t[t.length - 1]) {
            var i = t.pop();
            return d(
              (t = 1 === t.length && Object(ot.a)(t[0]) ? t[0] : t),
              null,
            ).pipe(
              Object(st.a)(function(t) {
                return i.apply(void 0, t);
              }),
            );
          }
          return d(t, null);
        }
        function d(t, e) {
          return new k.a(function(r) {
            var n = t.length;
            if (0 !== n)
              for (
                var i = new Array(n),
                  s = 0,
                  a = 0,
                  o = function(o) {
                    var u = Object(pt.a)(t[o]),
                      l = !1;
                    r.add(
                      u.subscribe({
                        next: function(t) {
                          l || ((l = !0), a++), (i[o] = t);
                        },
                        error: function(t) {
                          return r.error(t);
                        },
                        complete: function() {
                          (++s !== n && l) ||
                            (a === n &&
                              r.next(
                                e
                                  ? e.reduce(function(t, e, r) {
                                      return (t[e] = i[r]), t;
                                    }, {})
                                  : i,
                              ),
                            r.complete());
                        },
                      }),
                    );
                  },
                  u = 0;
                u < n;
                u++
              )
                o(u);
            else r.complete();
          });
        }
        function f(t, e, r, n) {
          return (
            Object(vt.a)(r) && ((n = r), (r = void 0)),
            n
              ? f(t, e, r).pipe(
                  Object(st.a)(function(t) {
                    return Object(ot.a)(t) ? n.apply(void 0, t) : n(t);
                  }),
                )
              : new k.a(function(n) {
                  !(function t(e, r, n, i, s) {
                    var a;
                    if (
                      (function(t) {
                        return (
                          t &&
                          'function' == typeof t.addEventListener &&
                          'function' == typeof t.removeEventListener
                        );
                      })(e)
                    ) {
                      var o = e;
                      e.addEventListener(r, n, s),
                        (a = function() {
                          return o.removeEventListener(r, n, s);
                        });
                    } else if (
                      (function(t) {
                        return (
                          t &&
                          'function' == typeof t.on &&
                          'function' == typeof t.off
                        );
                      })(e)
                    ) {
                      var u = e;
                      e.on(r, n),
                        (a = function() {
                          return u.off(r, n);
                        });
                    } else if (
                      (function(t) {
                        return (
                          t &&
                          'function' == typeof t.addListener &&
                          'function' == typeof t.removeListener
                        );
                      })(e)
                    ) {
                      var l = e;
                      e.addListener(r, n),
                        (a = function() {
                          return l.removeListener(r, n);
                        });
                    } else {
                      if (!e || !e.length)
                        throw new TypeError('Invalid event target');
                      for (var c = 0, h = e.length; c < h; c++)
                        t(e[c], r, n, i, s);
                    }
                    i.add(a);
                  })(
                    t,
                    e,
                    function(t) {
                      arguments.length > 1
                        ? n.next(Array.prototype.slice.call(arguments))
                        : n.next(t);
                    },
                    n,
                    r,
                  );
                })
          );
        }
        function p(t, e, r) {
          return r
            ? p(t, e).pipe(
                Object(st.a)(function(t) {
                  return Object(ot.a)(t) ? r.apply(void 0, t) : r(t);
                }),
              )
            : new k.a(function(r) {
                var n,
                  i = function() {
                    for (var t = [], e = 0; e < arguments.length; e++)
                      t[e] = arguments[e];
                    return r.next(1 === t.length ? t[0] : t);
                  };
                try {
                  n = t(i);
                } catch (t) {
                  return void r.error(t);
                }
                if (Object(vt.a)(e))
                  return function() {
                    return e(i, n);
                  };
              });
        }
        function v(t, e, r, n, i) {
          var s, a;
          if (1 == arguments.length) {
            var o = t;
            (a = o.initialState),
              (e = o.condition),
              (r = o.iterate),
              (s = o.resultSelector || Z.a),
              (i = o.scheduler);
          } else
            void 0 === n || Object(ut.a)(n)
              ? ((a = t), (s = Z.a), (i = n))
              : ((a = t), (s = n));
          return new k.a(function(t) {
            var n = a;
            if (i)
              return i.schedule(g, 0, {
                subscriber: t,
                iterate: r,
                condition: e,
                resultSelector: s,
                state: n,
              });
            for (;;) {
              if (e) {
                var o = void 0;
                try {
                  o = e(n);
                } catch (e) {
                  return void t.error(e);
                }
                if (!o) {
                  t.complete();
                  break;
                }
              }
              var u = void 0;
              try {
                u = s(n);
              } catch (e) {
                return void t.error(e);
              }
              if ((t.next(u), t.closed)) break;
              try {
                n = r(n);
              } catch (e) {
                return void t.error(e);
              }
            }
          });
        }
        function g(t) {
          var e = t.subscriber,
            r = t.condition;
          if (!e.closed) {
            if (t.needIterate)
              try {
                t.state = t.iterate(t.state);
              } catch (t) {
                return void e.error(t);
              }
            else t.needIterate = !0;
            if (r) {
              var n = void 0;
              try {
                n = r(t.state);
              } catch (t) {
                return void e.error(t);
              }
              if (!n) return void e.complete();
              if (e.closed) return;
            }
            var i;
            try {
              i = t.resultSelector(t.state);
            } catch (t) {
              return void e.error(t);
            }
            if (!e.closed && (e.next(i), !e.closed)) return this.schedule(t);
          }
        }
        function m(t, e, r) {
          return (
            void 0 === e && (e = dt.a),
            void 0 === r && (r = dt.a),
            Object(ht.a)(function() {
              return t() ? e : r;
            })
          );
        }
        function y(t, e) {
          return (
            void 0 === t && (t = 0),
            void 0 === e && (e = N.a),
            (!Object(gt.a)(t) || t < 0) && (t = 0),
            (e && 'function' == typeof e.schedule) || (e = N.a),
            new k.a(function(r) {
              return (
                r.add(
                  e.schedule(b, t, { subscriber: r, counter: 0, period: t }),
                ),
                r
              );
            })
          );
        }
        function b(t) {
          var e = t.subscriber,
            r = t.counter,
            n = t.period;
          e.next(r),
            this.schedule({ subscriber: e, counter: r + 1, period: n }, n);
        }
        function E() {
          return yt;
        }
        function T() {
          for (var t = [], e = 0; e < arguments.length; e++)
            t[e] = arguments[e];
          if (0 === t.length) return dt.a;
          var r = t[0],
            n = t.slice(1);
          return 1 === t.length && Object(ot.a)(r)
            ? T.apply(void 0, r)
            : new k.a(function(t) {
                var e = function() {
                  return t.add(T.apply(void 0, n).subscribe(t));
                };
                return Object(pt.a)(r).subscribe({
                  next: function(e) {
                    t.next(e);
                  },
                  error: e,
                  complete: e,
                });
              });
        }
        function S(t, e) {
          return e
            ? new k.a(function(r) {
                var n = Object.keys(t),
                  i = new z.a();
                return (
                  i.add(
                    e.schedule(L, 0, {
                      keys: n,
                      index: 0,
                      subscriber: r,
                      subscription: i,
                      obj: t,
                    }),
                  ),
                  i
                );
              })
            : new k.a(function(e) {
                for (
                  var r = Object.keys(t), n = 0;
                  n < r.length && !e.closed;
                  n++
                ) {
                  var i = r[n];
                  t.hasOwnProperty(i) && e.next([i, t[i]]);
                }
                e.complete();
              });
        }
        function L(t) {
          var e = t.keys,
            r = t.index,
            n = t.subscriber,
            i = t.subscription,
            s = t.obj;
          if (!n.closed)
            if (r < e.length) {
              var a = e[r];
              n.next([a, s[a]]),
                i.add(
                  this.schedule({
                    keys: e,
                    index: r + 1,
                    subscriber: n,
                    subscription: i,
                    obj: s,
                  }),
                );
            } else n.complete();
        }
        function _(t, e, r) {
          return [
            Object(St.a)(e, r)(new k.a(Object(Tt.a)(t))),
            Object(St.a)(Object(Et.a)(e, r))(new k.a(Object(Tt.a)(t))),
          ];
        }
        function A(t, e, r) {
          return (
            void 0 === t && (t = 0),
            new k.a(function(n) {
              void 0 === e && ((e = t), (t = 0));
              var i = 0,
                s = t;
              if (r)
                return r.schedule(D, 0, {
                  index: i,
                  count: e,
                  start: t,
                  subscriber: n,
                });
              for (;;) {
                if (i++ >= e) {
                  n.complete();
                  break;
                }
                if ((n.next(s++), n.closed)) break;
              }
            })
          );
        }
        function D(t) {
          var e = t.start,
            r = t.index,
            n = t.count,
            i = t.subscriber;
          r >= n
            ? i.complete()
            : (i.next(e),
              i.closed ||
                ((t.index = r + 1), (t.start = e + 1), this.schedule(t)));
        }
        function w(t, e) {
          return new k.a(function(r) {
            var n, i;
            try {
              n = t();
            } catch (t) {
              return void r.error(t);
            }
            try {
              i = e(n);
            } catch (t) {
              return void r.error(t);
            }
            var s = (i ? Object(pt.a)(i) : dt.a).subscribe(r);
            return function() {
              s.unsubscribe(), n && n.unsubscribe();
            };
          });
        }
        r.r(e);
        var k = r(3),
          R = r(54),
          O = r(52),
          I = r(20),
          C = r(5),
          x = r(55),
          P = r(40),
          M = r(28),
          F = r(36),
          N = r(6),
          U = r(50),
          B = r(0),
          j = r(29),
          G = (function(t) {
            function e(e, r) {
              var n = t.call(this, e, r) || this;
              return (n.scheduler = e), (n.work = r), n;
            }
            return (
              B.a(e, t),
              (e.prototype.requestAsyncId = function(e, r, n) {
                return (
                  void 0 === n && (n = 0),
                  null !== n && n > 0
                    ? t.prototype.requestAsyncId.call(this, e, r, n)
                    : (e.actions.push(this),
                      e.scheduled ||
                        (e.scheduled = requestAnimationFrame(function() {
                          return e.flush(null);
                        })))
                );
              }),
              (e.prototype.recycleAsyncId = function(e, r, n) {
                if (
                  (void 0 === n && (n = 0),
                  (null !== n && n > 0) || (null === n && this.delay > 0))
                )
                  return t.prototype.recycleAsyncId.call(this, e, r, n);
                0 === e.actions.length &&
                  (cancelAnimationFrame(r), (e.scheduled = void 0));
              }),
              e
            );
          })(j.a),
          V = r(27),
          H = new ((function(t) {
            function e() {
              return (null !== t && t.apply(this, arguments)) || this;
            }
            return (
              B.a(e, t),
              (e.prototype.flush = function(t) {
                (this.active = !0), (this.scheduled = void 0);
                var e,
                  r = this.actions,
                  n = -1,
                  i = r.length;
                t = t || r.shift();
                do {
                  if ((e = t.execute(t.state, t.delay))) break;
                } while (++n < i && (t = r.shift()));
                if (((this.active = !1), e)) {
                  for (; ++n < i && (t = r.shift()); ) t.unsubscribe();
                  throw e;
                }
              }),
              e
            );
          })(V.a))(G),
          K = H,
          W = (function(t) {
            function e(e, r) {
              void 0 === e && (e = Y),
                void 0 === r && (r = Number.POSITIVE_INFINITY);
              var n =
                t.call(this, e, function() {
                  return n.frame;
                }) || this;
              return (n.maxFrames = r), (n.frame = 0), (n.index = -1), n;
            }
            return (
              B.a(e, t),
              (e.prototype.flush = function() {
                for (
                  var t, e, r = this.actions, n = this.maxFrames;
                  (e = r[0]) &&
                  e.delay <= n &&
                  (r.shift(),
                  (this.frame = e.delay),
                  !(t = e.execute(e.state, e.delay)));

                );
                if (t) {
                  for (; (e = r.shift()); ) e.unsubscribe();
                  throw t;
                }
              }),
              (e.frameTimeFactor = 10),
              e
            );
          })(V.a),
          Y = (function(t) {
            function e(e, r, n) {
              void 0 === n && (n = e.index += 1);
              var i = t.call(this, e, r) || this;
              return (
                (i.scheduler = e),
                (i.work = r),
                (i.index = n),
                (i.active = !0),
                (i.index = e.index = n),
                i
              );
            }
            return (
              B.a(e, t),
              (e.prototype.schedule = function(r, n) {
                if ((void 0 === n && (n = 0), !this.id))
                  return t.prototype.schedule.call(this, r, n);
                this.active = !1;
                var i = new e(this.scheduler, this.work);
                return this.add(i), i.schedule(r, n);
              }),
              (e.prototype.requestAsyncId = function(t, r, n) {
                void 0 === n && (n = 0), (this.delay = t.frame + n);
                var i = t.actions;
                return i.push(this), i.sort(e.sortActions), !0;
              }),
              (e.prototype.recycleAsyncId = function(t, e, r) {
                void 0 === r && (r = 0);
              }),
              (e.prototype._execute = function(e, r) {
                if (!0 === this.active)
                  return t.prototype._execute.call(this, e, r);
              }),
              (e.sortActions = function(t, e) {
                return t.delay === e.delay
                  ? t.index === e.index
                    ? 0
                    : t.index > e.index
                    ? 1
                    : -1
                  : t.delay > e.delay
                  ? 1
                  : -1;
              }),
              e
            );
          })(j.a),
          q = r(51),
          z = r(4),
          X = r(1),
          $ = r(17),
          Q = r(35),
          J = r(19),
          Z = r(14),
          tt = r(22),
          et = r(24),
          rt = r(21),
          nt = r(38),
          it = r(57),
          st = r(8),
          at = r(47),
          ot = r(7),
          ut = r(9),
          lt = r(42),
          ct = r(31),
          ht = r(44),
          dt = r(10),
          ft = r(46),
          pt = r(11),
          vt = r(23),
          gt = r(30),
          mt = r(59),
          yt = new k.a(J.a),
          bt = r(34),
          Et = r(67),
          Tt = r(32),
          St = r(16),
          Lt = r(60),
          _t = r(41),
          At = r(61),
          Dt = r(45),
          wt = r(62),
          kt = r(13);
        r.d(e, 'Observable', function() {
          return k.a;
        }),
          r.d(e, 'ConnectableObservable', function() {
            return R.a;
          }),
          r.d(e, 'GroupedObservable', function() {
            return O.a;
          }),
          r.d(e, 'observable', function() {
            return I.a;
          }),
          r.d(e, 'Subject', function() {
            return C.a;
          }),
          r.d(e, 'BehaviorSubject', function() {
            return x.a;
          }),
          r.d(e, 'ReplaySubject', function() {
            return P.a;
          }),
          r.d(e, 'AsyncSubject', function() {
            return M.a;
          }),
          r.d(e, 'asap', function() {
            return F.a;
          }),
          r.d(e, 'asapScheduler', function() {
            return F.b;
          }),
          r.d(e, 'async', function() {
            return N.a;
          }),
          r.d(e, 'asyncScheduler', function() {
            return N.b;
          }),
          r.d(e, 'queue', function() {
            return U.a;
          }),
          r.d(e, 'queueScheduler', function() {
            return U.b;
          }),
          r.d(e, 'animationFrame', function() {
            return K;
          }),
          r.d(e, 'animationFrameScheduler', function() {
            return H;
          }),
          r.d(e, 'VirtualTimeScheduler', function() {
            return W;
          }),
          r.d(e, 'VirtualAction', function() {
            return Y;
          }),
          r.d(e, 'Scheduler', function() {
            return q.a;
          }),
          r.d(e, 'Subscription', function() {
            return z.a;
          }),
          r.d(e, 'Subscriber', function() {
            return X.a;
          }),
          r.d(e, 'Notification', function() {
            return $.a;
          }),
          r.d(e, 'NotificationKind', function() {
            return $.b;
          }),
          r.d(e, 'pipe', function() {
            return Q.a;
          }),
          r.d(e, 'noop', function() {
            return J.a;
          }),
          r.d(e, 'identity', function() {
            return Z.a;
          }),
          r.d(e, 'isObservable', function() {
            return n;
          }),
          r.d(e, 'ArgumentOutOfRangeError', function() {
            return tt.a;
          }),
          r.d(e, 'EmptyError', function() {
            return et.a;
          }),
          r.d(e, 'ObjectUnsubscribedError', function() {
            return rt.a;
          }),
          r.d(e, 'UnsubscriptionError', function() {
            return nt.a;
          }),
          r.d(e, 'TimeoutError', function() {
            return it.a;
          }),
          r.d(e, 'bindCallback', function() {
            return i;
          }),
          r.d(e, 'bindNodeCallback', function() {
            return o;
          }),
          r.d(e, 'combineLatest', function() {
            return lt.b;
          }),
          r.d(e, 'concat', function() {
            return ct.a;
          }),
          r.d(e, 'defer', function() {
            return ht.a;
          }),
          r.d(e, 'empty', function() {
            return dt.b;
          }),
          r.d(e, 'forkJoin', function() {
            return h;
          }),
          r.d(e, 'from', function() {
            return pt.a;
          }),
          r.d(e, 'fromEvent', function() {
            return f;
          }),
          r.d(e, 'fromEventPattern', function() {
            return p;
          }),
          r.d(e, 'generate', function() {
            return v;
          }),
          r.d(e, 'iif', function() {
            return m;
          }),
          r.d(e, 'interval', function() {
            return y;
          }),
          r.d(e, 'merge', function() {
            return mt.a;
          }),
          r.d(e, 'never', function() {
            return E;
          }),
          r.d(e, 'of', function() {
            return bt.a;
          }),
          r.d(e, 'onErrorResumeNext', function() {
            return T;
          }),
          r.d(e, 'pairs', function() {
            return S;
          }),
          r.d(e, 'partition', function() {
            return _;
          }),
          r.d(e, 'race', function() {
            return Lt.a;
          }),
          r.d(e, 'range', function() {
            return A;
          }),
          r.d(e, 'throwError', function() {
            return _t.a;
          }),
          r.d(e, 'timer', function() {
            return At.a;
          }),
          r.d(e, 'using', function() {
            return w;
          }),
          r.d(e, 'zip', function() {
            return Dt.b;
          }),
          r.d(e, 'scheduled', function() {
            return wt.a;
          }),
          r.d(e, 'EMPTY', function() {
            return dt.a;
          }),
          r.d(e, 'NEVER', function() {
            return yt;
          }),
          r.d(e, 'config', function() {
            return kt.a;
          });
      },
      function(t, e, r) {
        var n;
        'undefined' != typeof window &&
          ((n = function() {
            return (function(t) {
              function e(n) {
                if (r[n]) return r[n].exports;
                var i = (r[n] = { i: n, l: !1, exports: {} });
                return (
                  t[n].call(i.exports, i, i.exports, e), (i.l = !0), i.exports
                );
              }
              var r = {};
              return (
                (e.m = t),
                (e.c = r),
                (e.d = function(t, r, n) {
                  e.o(t, r) ||
                    Object.defineProperty(t, r, { enumerable: !0, get: n });
                }),
                (e.r = function(t) {
                  'undefined' != typeof Symbol &&
                    Symbol.toStringTag &&
                    Object.defineProperty(t, Symbol.toStringTag, {
                      value: 'Module',
                    }),
                    Object.defineProperty(t, '__esModule', { value: !0 });
                }),
                (e.t = function(t, r) {
                  if ((1 & r && (t = e(t)), 8 & r)) return t;
                  if (4 & r && 'object' == typeof t && t && t.__esModule)
                    return t;
                  var n = Object.create(null);
                  if (
                    (e.r(n),
                    Object.defineProperty(n, 'default', {
                      enumerable: !0,
                      value: t,
                    }),
                    2 & r && 'string' != typeof t)
                  )
                    for (var i in t)
                      e.d(
                        n,
                        i,
                        function(e) {
                          return t[e];
                        }.bind(null, i),
                      );
                  return n;
                }),
                (e.n = function(t) {
                  var r =
                    t && t.__esModule
                      ? function() {
                          return t.default;
                        }
                      : function() {
                          return t;
                        };
                  return e.d(r, 'a', r), r;
                }),
                (e.o = function(t, e) {
                  return Object.prototype.hasOwnProperty.call(t, e);
                }),
                (e.p = '/dist/'),
                e((e.s = './src/hls.ts'))
              );
            })({
              './node_modules/eventemitter3/index.js': function(t, e, r) {
                function n() {}
                function i(t, e, r) {
                  (this.fn = t), (this.context = e), (this.once = r || !1);
                }
                function s(t, e, r, n, s) {
                  if ('function' != typeof r)
                    throw new TypeError('The listener must be a function');
                  var a = new i(r, n || t, s),
                    o = l ? l + e : e;
                  return (
                    t._events[o]
                      ? t._events[o].fn
                        ? (t._events[o] = [t._events[o], a])
                        : t._events[o].push(a)
                      : ((t._events[o] = a), t._eventsCount++),
                    t
                  );
                }
                function a(t, e) {
                  0 == --t._eventsCount
                    ? (t._events = new n())
                    : delete t._events[e];
                }
                function o() {
                  (this._events = new n()), (this._eventsCount = 0);
                }
                var u = Object.prototype.hasOwnProperty,
                  l = '~';
                Object.create &&
                  ((n.prototype = Object.create(null)),
                  new n().__proto__ || (l = !1)),
                  (o.prototype.eventNames = function() {
                    var t,
                      e,
                      r = [];
                    if (0 === this._eventsCount) return r;
                    for (e in (t = this._events))
                      u.call(t, e) && r.push(l ? e.slice(1) : e);
                    return Object.getOwnPropertySymbols
                      ? r.concat(Object.getOwnPropertySymbols(t))
                      : r;
                  }),
                  (o.prototype.listeners = function(t) {
                    var e = l ? l + t : t,
                      r = this._events[e];
                    if (!r) return [];
                    if (r.fn) return [r.fn];
                    for (var n = 0, i = r.length, s = new Array(i); n < i; n++)
                      s[n] = r[n].fn;
                    return s;
                  }),
                  (o.prototype.listenerCount = function(t) {
                    var e = l ? l + t : t,
                      r = this._events[e];
                    return r ? (r.fn ? 1 : r.length) : 0;
                  }),
                  (o.prototype.emit = function(t, e, r, n, i, s) {
                    var a = l ? l + t : t;
                    if (!this._events[a]) return !1;
                    var o,
                      u,
                      c = this._events[a],
                      h = arguments.length;
                    if (c.fn) {
                      switch (
                        (c.once && this.removeListener(t, c.fn, void 0, !0), h)
                      ) {
                        case 1:
                          return c.fn.call(c.context), !0;
                        case 2:
                          return c.fn.call(c.context, e), !0;
                        case 3:
                          return c.fn.call(c.context, e, r), !0;
                        case 4:
                          return c.fn.call(c.context, e, r, n), !0;
                        case 5:
                          return c.fn.call(c.context, e, r, n, i), !0;
                        case 6:
                          return c.fn.call(c.context, e, r, n, i, s), !0;
                      }
                      for (u = 1, o = new Array(h - 1); u < h; u++)
                        o[u - 1] = arguments[u];
                      c.fn.apply(c.context, o);
                    } else {
                      var d,
                        f = c.length;
                      for (u = 0; u < f; u++)
                        switch (
                          (c[u].once &&
                            this.removeListener(t, c[u].fn, void 0, !0),
                          h)
                        ) {
                          case 1:
                            c[u].fn.call(c[u].context);
                            break;
                          case 2:
                            c[u].fn.call(c[u].context, e);
                            break;
                          case 3:
                            c[u].fn.call(c[u].context, e, r);
                            break;
                          case 4:
                            c[u].fn.call(c[u].context, e, r, n);
                            break;
                          default:
                            if (!o)
                              for (d = 1, o = new Array(h - 1); d < h; d++)
                                o[d - 1] = arguments[d];
                            c[u].fn.apply(c[u].context, o);
                        }
                    }
                    return !0;
                  }),
                  (o.prototype.on = function(t, e, r) {
                    return s(this, t, e, r, !1);
                  }),
                  (o.prototype.once = function(t, e, r) {
                    return s(this, t, e, r, !0);
                  }),
                  (o.prototype.removeListener = function(t, e, r, n) {
                    var i = l ? l + t : t;
                    if (!this._events[i]) return this;
                    if (!e) return a(this, i), this;
                    var s = this._events[i];
                    if (s.fn)
                      s.fn !== e ||
                        (n && !s.once) ||
                        (r && s.context !== r) ||
                        a(this, i);
                    else {
                      for (var o = 0, u = [], c = s.length; o < c; o++)
                        (s[o].fn !== e ||
                          (n && !s[o].once) ||
                          (r && s[o].context !== r)) &&
                          u.push(s[o]);
                      u.length
                        ? (this._events[i] = 1 === u.length ? u[0] : u)
                        : a(this, i);
                    }
                    return this;
                  }),
                  (o.prototype.removeAllListeners = function(t) {
                    var e;
                    return (
                      t
                        ? ((e = l ? l + t : t), this._events[e] && a(this, e))
                        : ((this._events = new n()), (this._eventsCount = 0)),
                      this
                    );
                  }),
                  (o.prototype.off = o.prototype.removeListener),
                  (o.prototype.addListener = o.prototype.on),
                  (o.prefixed = l),
                  (o.EventEmitter = o),
                  (t.exports = o);
              },
              './node_modules/url-toolkit/src/url-toolkit.js': function(
                t,
                e,
                r,
              ) {
                var n, i, s, a, o;
                (n = /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/),
                  (i = /^(?=([^\/?#]*))\1([^]*)$/),
                  (s = /(?:\/|^)\.(?=\/)/g),
                  (a = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g),
                  (o = {
                    buildAbsoluteURL: function(t, e, r) {
                      if (((r = r || {}), (t = t.trim()), !(e = e.trim()))) {
                        if (!r.alwaysNormalize) return t;
                        var n = o.parseURL(t);
                        if (!n)
                          throw new Error('Error trying to parse base URL.');
                        return (
                          (n.path = o.normalizePath(n.path)),
                          o.buildURLFromParts(n)
                        );
                      }
                      var s = o.parseURL(e);
                      if (!s)
                        throw new Error('Error trying to parse relative URL.');
                      if (s.scheme)
                        return r.alwaysNormalize
                          ? ((s.path = o.normalizePath(s.path)),
                            o.buildURLFromParts(s))
                          : e;
                      var a = o.parseURL(t);
                      if (!a)
                        throw new Error('Error trying to parse base URL.');
                      if (!a.netLoc && a.path && '/' !== a.path[0]) {
                        var u = i.exec(a.path);
                        (a.netLoc = u[1]), (a.path = u[2]);
                      }
                      a.netLoc && !a.path && (a.path = '/');
                      var l = {
                        scheme: a.scheme,
                        netLoc: s.netLoc,
                        path: null,
                        params: s.params,
                        query: s.query,
                        fragment: s.fragment,
                      };
                      if (
                        !s.netLoc &&
                        ((l.netLoc = a.netLoc), '/' !== s.path[0])
                      )
                        if (s.path) {
                          var c = a.path,
                            h = c.substring(0, c.lastIndexOf('/') + 1) + s.path;
                          l.path = o.normalizePath(h);
                        } else
                          (l.path = a.path),
                            s.params ||
                              ((l.params = a.params),
                              s.query || (l.query = a.query));
                      return (
                        null === l.path &&
                          (l.path = r.alwaysNormalize
                            ? o.normalizePath(s.path)
                            : s.path),
                        o.buildURLFromParts(l)
                      );
                    },
                    parseURL: function(t) {
                      var e = n.exec(t);
                      return e
                        ? {
                            scheme: e[1] || '',
                            netLoc: e[2] || '',
                            path: e[3] || '',
                            params: e[4] || '',
                            query: e[5] || '',
                            fragment: e[6] || '',
                          }
                        : null;
                    },
                    normalizePath: function(t) {
                      for (
                        t = t
                          .split('')
                          .reverse()
                          .join('')
                          .replace(s, '');
                        t.length !== (t = t.replace(a, '')).length;

                      );
                      return t
                        .split('')
                        .reverse()
                        .join('');
                    },
                    buildURLFromParts: function(t) {
                      return (
                        t.scheme +
                        t.netLoc +
                        t.path +
                        t.params +
                        t.query +
                        t.fragment
                      );
                    },
                  }),
                  (t.exports = o);
              },
              './node_modules/webworkify-webpack/index.js': function(t, e, r) {
                function n(t) {
                  function e(n) {
                    if (r[n]) return r[n].exports;
                    var i = (r[n] = { i: n, l: !1, exports: {} });
                    return (
                      t[n].call(i.exports, i, i.exports, e),
                      (i.l = !0),
                      i.exports
                    );
                  }
                  var r = {};
                  (e.m = t),
                    (e.c = r),
                    (e.i = function(t) {
                      return t;
                    }),
                    (e.d = function(t, r, n) {
                      e.o(t, r) ||
                        Object.defineProperty(t, r, {
                          configurable: !1,
                          enumerable: !0,
                          get: n,
                        });
                    }),
                    (e.r = function(t) {
                      Object.defineProperty(t, '__esModule', { value: !0 });
                    }),
                    (e.n = function(t) {
                      var r =
                        t && t.__esModule
                          ? function() {
                              return t.default;
                            }
                          : function() {
                              return t;
                            };
                      return e.d(r, 'a', r), r;
                    }),
                    (e.o = function(t, e) {
                      return Object.prototype.hasOwnProperty.call(t, e);
                    }),
                    (e.p = '/'),
                    (e.oe = function(t) {
                      throw (console.error(t), t);
                    });
                  var n = e((e.s = ENTRY_MODULE));
                  return n.default || n;
                }
                function i(t) {
                  return (t + '').replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
                }
                function s(t, e, n) {
                  var s = {};
                  s[n] = [];
                  var a = e.toString(),
                    o = a.match(/^function\s?\w*\(\w+,\s*\w+,\s*(\w+)\)/);
                  if (!o) return s;
                  for (
                    var u,
                      l = o[1],
                      c = new RegExp(
                        '(\\\\n|\\W)' +
                          i(l) +
                          '\\(\\s*(/\\*.*?\\*/)?\\s*.*?([\\.|\\-|\\+|\\w|/|@]+).*?\\)',
                        'g',
                      );
                    (u = c.exec(a));

                  )
                    'dll-reference' !== u[3] && s[n].push(u[3]);
                  for (
                    c = new RegExp(
                      '\\(' +
                        i(l) +
                        '\\("(dll-reference\\s([\\.|\\-|\\+|\\w|/|@]+))"\\)\\)\\(\\s*(/\\*.*?\\*/)?\\s*.*?([\\.|\\-|\\+|\\w|/|@]+).*?\\)',
                      'g',
                    );
                    (u = c.exec(a));

                  )
                    t[u[2]] || (s[n].push(u[1]), (t[u[2]] = r(u[1]).m)),
                      (s[u[2]] = s[u[2]] || []),
                      s[u[2]].push(u[4]);
                  for (var h, d = Object.keys(s), f = 0; f < d.length; f++)
                    for (var p = 0; p < s[d[f]].length; p++)
                      (h = s[d[f]][p]),
                        isNaN(1 * h) || (s[d[f]][p] = 1 * s[d[f]][p]);
                  return s;
                }
                function a(t) {
                  return Object.keys(t).reduce(function(e, r) {
                    return e || t[r].length > 0;
                  }, !1);
                }
                t.exports = function(t, e) {
                  e = e || {};
                  var i = { main: r.m },
                    o = e.all
                      ? { main: Object.keys(i.main) }
                      : (function(t, e) {
                          for (
                            var r = { main: [e] },
                              n = { main: [] },
                              i = { main: {} };
                            a(r);

                          )
                            for (
                              var o = Object.keys(r), u = 0;
                              u < o.length;
                              u++
                            ) {
                              var l = o[u],
                                c = r[l].pop();
                              if (((i[l] = i[l] || {}), !i[l][c] && t[l][c])) {
                                (i[l][c] = !0),
                                  (n[l] = n[l] || []),
                                  n[l].push(c);
                                for (
                                  var h = s(t, t[l][c], l),
                                    d = Object.keys(h),
                                    f = 0;
                                  f < d.length;
                                  f++
                                )
                                  (r[d[f]] = r[d[f]] || []),
                                    (r[d[f]] = r[d[f]].concat(h[d[f]]));
                              }
                            }
                          return n;
                        })(i, t),
                    u = '';
                  Object.keys(o)
                    .filter(function(t) {
                      return 'main' !== t;
                    })
                    .forEach(function(t) {
                      for (var e = 0; o[t][e]; ) e++;
                      o[t].push(e),
                        (i[t][e] =
                          '(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })'),
                        (u =
                          u +
                          'var ' +
                          t +
                          ' = (' +
                          n
                            .toString()
                            .replace('ENTRY_MODULE', JSON.stringify(e)) +
                          ')({' +
                          o[t]
                            .map(function(e) {
                              return (
                                JSON.stringify(e) + ': ' + i[t][e].toString()
                              );
                            })
                            .join(',') +
                          '});\n');
                    }),
                    (u =
                      u +
                      'new ((' +
                      n.toString().replace('ENTRY_MODULE', JSON.stringify(t)) +
                      ')({' +
                      o.main
                        .map(function(t) {
                          return (
                            JSON.stringify(t) + ': ' + i.main[t].toString()
                          );
                        })
                        .join(',') +
                      '}))(self);');
                  var l = new window.Blob([u], { type: 'text/javascript' });
                  if (e.bare) return l;
                  var c = (
                      window.URL ||
                      window.webkitURL ||
                      window.mozURL ||
                      window.msURL
                    ).createObjectURL(l),
                    h = new window.Worker(c);
                  return (h.objectURL = c), h;
                };
              },
              './src/config.ts': function(t, e, r) {
                function n() {
                  return (n = Object.assign
                    ? Object.assign.bind()
                    : function(t) {
                        for (var e = 1; e < arguments.length; e++) {
                          var r = arguments[e];
                          for (var n in r)
                            Object.prototype.hasOwnProperty.call(r, n) &&
                              (t[n] = r[n]);
                        }
                        return t;
                      }).apply(this, arguments);
                }
                function i(t, e) {
                  var r = Object.keys(t);
                  if (Object.getOwnPropertySymbols) {
                    var n = Object.getOwnPropertySymbols(t);
                    e &&
                      (n = n.filter(function(e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                      })),
                      r.push.apply(r, n);
                  }
                  return r;
                }
                function s(t) {
                  for (var e = 1; e < arguments.length; e++) {
                    var r = null != arguments[e] ? arguments[e] : {};
                    e % 2
                      ? i(Object(r), !0).forEach(function(e) {
                          a(t, e, r[e]);
                        })
                      : Object.getOwnPropertyDescriptors
                      ? Object.defineProperties(
                          t,
                          Object.getOwnPropertyDescriptors(r),
                        )
                      : i(Object(r)).forEach(function(e) {
                          Object.defineProperty(
                            t,
                            e,
                            Object.getOwnPropertyDescriptor(r, e),
                          );
                        });
                  }
                  return t;
                }
                function a(t, e, r) {
                  return (
                    e in t
                      ? Object.defineProperty(t, e, {
                          value: r,
                          enumerable: !0,
                          configurable: !0,
                          writable: !0,
                        })
                      : (t[e] = r),
                    t
                  );
                }
                function o(t, e) {
                  if (
                    (e.liveSyncDurationCount ||
                      e.liveMaxLatencyDurationCount) &&
                    (e.liveSyncDuration || e.liveMaxLatencyDuration)
                  )
                    throw new Error(
                      "Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration",
                    );
                  if (
                    void 0 !== e.liveMaxLatencyDurationCount &&
                    (void 0 === e.liveSyncDurationCount ||
                      e.liveMaxLatencyDurationCount <= e.liveSyncDurationCount)
                  )
                    throw new Error(
                      'Illegal hls.js config: "liveMaxLatencyDurationCount" must be greater than "liveSyncDurationCount"',
                    );
                  if (
                    void 0 !== e.liveMaxLatencyDuration &&
                    (void 0 === e.liveSyncDuration ||
                      e.liveMaxLatencyDuration <= e.liveSyncDuration)
                  )
                    throw new Error(
                      'Illegal hls.js config: "liveMaxLatencyDuration" must be greater than "liveSyncDuration"',
                    );
                  return n({}, t, e);
                }
                function u(t) {
                  var e = t.loader;
                  e !== T.default && e !== E.default
                    ? (_.logger.log(
                        '[config]: Custom loader detected, cannot enable progressive streaming',
                      ),
                      (t.progressive = !1))
                    : Object(T.fetchSupported)() &&
                      ((t.loader = T.default),
                      (t.progressive = !0),
                      (t.enableSoftwareAES = !0),
                      _.logger.log(
                        '[config]: Progressive streaming enabled, using FetchLoader',
                      ));
                }
                r.r(e),
                  r.d(e, 'hlsDefaultConfig', function() {
                    return A;
                  }),
                  r.d(e, 'mergeConfig', function() {
                    return o;
                  }),
                  r.d(e, 'enableStreamingMode', function() {
                    return u;
                  });
                var l = r('./src/controller/abr-controller.ts'),
                  c = r('./src/controller/audio-stream-controller.ts'),
                  h = r('./src/controller/audio-track-controller.ts'),
                  d = r('./src/controller/subtitle-stream-controller.ts'),
                  f = r('./src/controller/subtitle-track-controller.ts'),
                  p = r('./src/controller/buffer-controller.ts'),
                  v = r('./src/controller/timeline-controller.ts'),
                  g = r('./src/controller/cap-level-controller.ts'),
                  m = r('./src/controller/fps-controller.ts'),
                  y = r('./src/controller/eme-controller.ts'),
                  b = r('./src/controller/cmcd-controller.ts'),
                  E = r('./src/utils/xhr-loader.ts'),
                  T = r('./src/utils/fetch-loader.ts'),
                  S = r('./src/utils/cues.ts'),
                  L = r('./src/utils/mediakeys-helper.ts'),
                  _ = r('./src/utils/logger.ts'),
                  A = s(
                    s(
                      {
                        autoStartLoad: !0,
                        startPosition: -1,
                        defaultAudioCodec: void 0,
                        debug: !1,
                        capLevelOnFPSDrop: !1,
                        capLevelToPlayerSize: !1,
                        ignoreDevicePixelRatio: !1,
                        initialLiveManifestSize: 1,
                        maxBufferLength: 30,
                        backBufferLength: 1 / 0,
                        maxBufferSize: 6e7,
                        maxBufferHole: 0.1,
                        highBufferWatchdogPeriod: 2,
                        nudgeOffset: 0.1,
                        nudgeMaxRetry: 3,
                        maxFragLookUpTolerance: 0.25,
                        liveSyncDurationCount: 3,
                        liveMaxLatencyDurationCount: 1 / 0,
                        liveSyncDuration: void 0,
                        liveMaxLatencyDuration: void 0,
                        maxLiveSyncPlaybackRate: 1,
                        liveDurationInfinity: !1,
                        liveBackBufferLength: null,
                        maxMaxBufferLength: 600,
                        enableWorker: !0,
                        enableSoftwareAES: !0,
                        manifestLoadingTimeOut: 1e4,
                        manifestLoadingMaxRetry: 1,
                        manifestLoadingRetryDelay: 1e3,
                        manifestLoadingMaxRetryTimeout: 64e3,
                        startLevel: void 0,
                        levelLoadingTimeOut: 1e4,
                        levelLoadingMaxRetry: 4,
                        levelLoadingRetryDelay: 1e3,
                        levelLoadingMaxRetryTimeout: 64e3,
                        fragLoadingTimeOut: 2e4,
                        fragLoadingMaxRetry: 6,
                        fragLoadingRetryDelay: 1e3,
                        fragLoadingMaxRetryTimeout: 64e3,
                        startFragPrefetch: !1,
                        fpsDroppedMonitoringPeriod: 5e3,
                        fpsDroppedMonitoringThreshold: 0.2,
                        appendErrorMaxRetry: 3,
                        loader: E.default,
                        fLoader: void 0,
                        pLoader: void 0,
                        xhrSetup: void 0,
                        licenseXhrSetup: void 0,
                        licenseResponseCallback: void 0,
                        abrController: l.default,
                        bufferController: p.default,
                        capLevelController: g.default,
                        fpsController: m.default,
                        stretchShortVideoTrack: !1,
                        maxAudioFramesDrift: 1,
                        forceKeyFrameOnDiscontinuity: !0,
                        abrEwmaFastLive: 3,
                        abrEwmaSlowLive: 9,
                        abrEwmaFastVoD: 3,
                        abrEwmaSlowVoD: 9,
                        abrEwmaDefaultEstimate: 5e5,
                        abrBandWidthFactor: 0.95,
                        abrBandWidthUpFactor: 0.7,
                        abrMaxWithRealBitrate: !1,
                        maxStarvationDelay: 4,
                        maxLoadingDelay: 4,
                        minAutoBitrate: 0,
                        emeEnabled: !1,
                        widevineLicenseUrl: void 0,
                        drmSystemOptions: {},
                        requestMediaKeySystemAccessFunc:
                          L.requestMediaKeySystemAccess,
                        testBandwidth: !0,
                        progressive: !1,
                        lowLatencyMode: !0,
                        cmcd: void 0,
                        enableDateRangeMetadataCues: !0,
                        enableEmsgMetadataCues: !0,
                        enableID3MetadataCues: !0,
                      },
                      {
                        cueHandler: S.default,
                        enableWebVTT: !0,
                        enableIMSC1: !0,
                        enableCEA708Captions: !0,
                        captionsTextTrack1Label: 'English',
                        captionsTextTrack1LanguageCode: 'en',
                        captionsTextTrack2Label: 'Spanish',
                        captionsTextTrack2LanguageCode: 'es',
                        captionsTextTrack3Label: 'Unknown CC',
                        captionsTextTrack3LanguageCode: '',
                        captionsTextTrack4Label: 'Unknown CC',
                        captionsTextTrack4LanguageCode: '',
                        renderTextTracksNatively: !0,
                      },
                    ),
                    {},
                    {
                      subtitleStreamController: d.SubtitleStreamController,
                      subtitleTrackController: f.default,
                      timelineController: v.TimelineController,
                      audioStreamController: c.default,
                      audioTrackController: h.default,
                      emeController: y.default,
                      cmcdController: b.default,
                    },
                  );
              },
              './src/controller/abr-controller.ts': function(t, e, r) {
                function n(t, e) {
                  for (var r = 0; r < e.length; r++) {
                    var n = e[r];
                    (n.enumerable = n.enumerable || !1),
                      (n.configurable = !0),
                      'value' in n && (n.writable = !0),
                      Object.defineProperty(t, n.key, n);
                  }
                }
                r.r(e);
                var i = r('./src/polyfills/number.ts'),
                  s = r('./src/utils/ewma-bandwidth-estimator.ts'),
                  a = r('./src/events.ts'),
                  o = r('./src/errors.ts'),
                  u = r('./src/types/loader.ts'),
                  l = r('./src/utils/logger.ts'),
                  c = (function() {
                    function t(t) {
                      (this.hls = void 0),
                        (this.lastLoadedFragLevel = 0),
                        (this._nextAutoLevel = -1),
                        (this.timer = void 0),
                        (this.onCheck = this._abandonRulesCheck.bind(this)),
                        (this.fragCurrent = null),
                        (this.partCurrent = null),
                        (this.bitrateTestDelay = 0),
                        (this.bwEstimator = void 0),
                        (this.hls = t);
                      var e = t.config;
                      (this.bwEstimator = new s.default(
                        e.abrEwmaSlowVoD,
                        e.abrEwmaFastVoD,
                        e.abrEwmaDefaultEstimate,
                      )),
                        this.registerListeners();
                    }
                    var e,
                      r,
                      c = t.prototype;
                    return (
                      (c.registerListeners = function() {
                        var t = this.hls;
                        t.on(a.Events.FRAG_LOADING, this.onFragLoading, this),
                          t.on(a.Events.FRAG_LOADED, this.onFragLoaded, this),
                          t.on(
                            a.Events.FRAG_BUFFERED,
                            this.onFragBuffered,
                            this,
                          ),
                          t.on(a.Events.LEVEL_LOADED, this.onLevelLoaded, this),
                          t.on(a.Events.ERROR, this.onError, this);
                      }),
                      (c.unregisterListeners = function() {
                        var t = this.hls;
                        t.off(a.Events.FRAG_LOADING, this.onFragLoading, this),
                          t.off(a.Events.FRAG_LOADED, this.onFragLoaded, this),
                          t.off(
                            a.Events.FRAG_BUFFERED,
                            this.onFragBuffered,
                            this,
                          ),
                          t.off(
                            a.Events.LEVEL_LOADED,
                            this.onLevelLoaded,
                            this,
                          ),
                          t.off(a.Events.ERROR, this.onError, this);
                      }),
                      (c.destroy = function() {
                        this.unregisterListeners(),
                          this.clearTimer(),
                          (this.hls = this.onCheck = null),
                          (this.fragCurrent = this.partCurrent = null);
                      }),
                      (c.onFragLoading = function(t, e) {
                        var r,
                          n = e.frag;
                        n.type === u.PlaylistLevelType.MAIN &&
                          (this.timer ||
                            ((this.fragCurrent = n),
                            (this.partCurrent =
                              null != (r = e.part) ? r : null),
                            (this.timer = self.setInterval(
                              this.onCheck,
                              100,
                            ))));
                      }),
                      (c.onLevelLoaded = function(t, e) {
                        var r = this.hls.config;
                        e.details.live
                          ? this.bwEstimator.update(
                              r.abrEwmaSlowLive,
                              r.abrEwmaFastLive,
                            )
                          : this.bwEstimator.update(
                              r.abrEwmaSlowVoD,
                              r.abrEwmaFastVoD,
                            );
                      }),
                      (c._abandonRulesCheck = function() {
                        var t = this.fragCurrent,
                          e = this.partCurrent,
                          r = this.hls,
                          n = r.autoLevelEnabled,
                          s = (r.config, r.media);
                        if (t && s) {
                          var o = e ? e.stats : t.stats,
                            u = e ? e.duration : t.duration;
                          if (
                            o.aborted ||
                            (o.loaded && o.loaded === o.total) ||
                            0 === t.level
                          )
                            return (
                              this.clearTimer(), void (this._nextAutoLevel = -1)
                            );
                          if (
                            n &&
                            !s.paused &&
                            s.playbackRate &&
                            s.readyState
                          ) {
                            var c = r.mainForwardBufferInfo;
                            if (null !== c) {
                              var h = performance.now() - o.loading.start,
                                d = Math.abs(s.playbackRate);
                              if (!(h <= (500 * u) / d)) {
                                var f = o.loaded && o.loading.first,
                                  p = this.bwEstimator.getEstimate(),
                                  v = r.levels,
                                  g = r.minAutoLevel,
                                  m = v[t.level],
                                  y =
                                    o.total ||
                                    Math.max(
                                      o.loaded,
                                      Math.round((u * m.maxBitrate) / 8),
                                    ),
                                  b = f ? (1e3 * o.loaded) / h : 0,
                                  E = b ? (y - o.loaded) / b : (8 * y) / p,
                                  T = c.len / d;
                                if (!(E <= T)) {
                                  var S,
                                    L = Number.POSITIVE_INFINITY;
                                  for (S = t.level - 1; S > g; S--) {
                                    var _ = v[S].maxBitrate;
                                    if (
                                      (L = b
                                        ? (u * _) / (6.4 * b)
                                        : (u * _) / p) < T
                                    )
                                      break;
                                  }
                                  L >= E ||
                                    (l.logger.warn(
                                      'Fragment ' +
                                        t.sn +
                                        (e ? ' part ' + e.index : '') +
                                        ' of level ' +
                                        t.level +
                                        ' is loading too slowly and will cause an underbuffer; aborting and switching to level ' +
                                        S +
                                        '\n      Current BW estimate: ' +
                                        (Object(i.isFiniteNumber)(p)
                                          ? (p / 1024).toFixed(3)
                                          : 'Unknown') +
                                        ' Kb/s\n      Estimated load time for current fragment: ' +
                                        E.toFixed(3) +
                                        ' s\n      Estimated load time for the next fragment: ' +
                                        L.toFixed(3) +
                                        ' s\n      Time to underbuffer: ' +
                                        T.toFixed(3) +
                                        ' s',
                                    ),
                                    (r.nextLoadLevel = S),
                                    f && this.bwEstimator.sample(h, o.loaded),
                                    this.clearTimer(),
                                    t.loader &&
                                      ((this.fragCurrent = this.partCurrent = null),
                                      t.loader.abort()),
                                    r.trigger(
                                      a.Events.FRAG_LOAD_EMERGENCY_ABORTED,
                                      { frag: t, part: e, stats: o },
                                    ));
                                }
                              }
                            }
                          }
                        }
                      }),
                      (c.onFragLoaded = function(t, e) {
                        var r = e.frag,
                          n = e.part;
                        if (
                          r.type === u.PlaylistLevelType.MAIN &&
                          Object(i.isFiniteNumber)(r.sn)
                        ) {
                          var s = n ? n.stats : r.stats,
                            o = n ? n.duration : r.duration;
                          if (
                            (this.clearTimer(),
                            (this.lastLoadedFragLevel = r.level),
                            (this._nextAutoLevel = -1),
                            this.hls.config.abrMaxWithRealBitrate)
                          ) {
                            var l = this.hls.levels[r.level],
                              c = (l.loaded ? l.loaded.bytes : 0) + s.loaded,
                              h = (l.loaded ? l.loaded.duration : 0) + o;
                            (l.loaded = { bytes: c, duration: h }),
                              (l.realBitrate = Math.round((8 * c) / h));
                          }
                          if (r.bitrateTest) {
                            var d = { stats: s, frag: r, part: n, id: r.type };
                            this.onFragBuffered(a.Events.FRAG_BUFFERED, d);
                          }
                        }
                      }),
                      (c.onFragBuffered = function(t, e) {
                        var r = e.frag,
                          n = e.part,
                          i = n ? n.stats : r.stats;
                        if (
                          !i.aborted &&
                          r.type === u.PlaylistLevelType.MAIN &&
                          'initSegment' !== r.sn
                        ) {
                          var s = i.parsing.end - i.loading.start;
                          this.bwEstimator.sample(s, i.loaded),
                            (i.bwEstimate = this.bwEstimator.getEstimate()),
                            r.bitrateTest
                              ? (this.bitrateTestDelay = s / 1e3)
                              : (this.bitrateTestDelay = 0);
                        }
                      }),
                      (c.onError = function(t, e) {
                        switch (e.details) {
                          case o.ErrorDetails.FRAG_LOAD_ERROR:
                          case o.ErrorDetails.FRAG_LOAD_TIMEOUT:
                            this.clearTimer();
                        }
                      }),
                      (c.clearTimer = function() {
                        self.clearInterval(this.timer), (this.timer = void 0);
                      }),
                      (c.getNextABRAutoLevel = function() {
                        var t = this.fragCurrent,
                          e = this.partCurrent,
                          r = this.hls,
                          n = r.maxAutoLevel,
                          i = r.config,
                          s = r.minAutoLevel,
                          a = r.media,
                          o = e ? e.duration : t ? t.duration : 0,
                          u =
                            (a && a.currentTime,
                            a && 0 !== a.playbackRate
                              ? Math.abs(a.playbackRate)
                              : 1),
                          c = this.bwEstimator
                            ? this.bwEstimator.getEstimate()
                            : i.abrEwmaDefaultEstimate,
                          h = r.mainForwardBufferInfo,
                          d = (h ? h.len : 0) / u,
                          f = this.findBestLevel(
                            c,
                            s,
                            n,
                            d,
                            i.abrBandWidthFactor,
                            i.abrBandWidthUpFactor,
                          );
                        if (f >= 0) return f;
                        l.logger.trace(
                          (d ? 'rebuffering expected' : 'buffer is empty') +
                            ', finding optimal quality level',
                        );
                        var p = o
                            ? Math.min(o, i.maxStarvationDelay)
                            : i.maxStarvationDelay,
                          v = i.abrBandWidthFactor,
                          g = i.abrBandWidthUpFactor;
                        if (!d) {
                          var m = this.bitrateTestDelay;
                          m &&
                            ((p =
                              (o
                                ? Math.min(o, i.maxLoadingDelay)
                                : i.maxLoadingDelay) - m),
                            l.logger.trace(
                              'bitrate test took ' +
                                Math.round(1e3 * m) +
                                'ms, set first fragment max fetchDuration to ' +
                                Math.round(1e3 * p) +
                                ' ms',
                            ),
                            (v = g = 1));
                        }
                        return (
                          (f = this.findBestLevel(c, s, n, d + p, v, g)),
                          Math.max(f, 0)
                        );
                      }),
                      (c.findBestLevel = function(t, e, r, n, s, a) {
                        for (
                          var o,
                            u = this.fragCurrent,
                            c = this.partCurrent,
                            h = this.lastLoadedFragLevel,
                            d = this.hls.levels,
                            f = d[h],
                            p = !(
                              null == f ||
                              null === (o = f.details) ||
                              void 0 === o ||
                              !o.live
                            ),
                            v = null == f ? void 0 : f.codecSet,
                            g = c ? c.duration : u ? u.duration : 0,
                            m = r;
                          m >= e;
                          m--
                        ) {
                          var y = d[m];
                          if (y && (!v || y.codecSet === v)) {
                            var b,
                              E = y.details,
                              T =
                                (c
                                  ? null == E
                                    ? void 0
                                    : E.partTarget
                                  : null == E
                                  ? void 0
                                  : E.averagetargetduration) || g;
                            b = m <= h ? s * t : a * t;
                            var S = d[m].maxBitrate,
                              L = (S * T) / b;
                            if (
                              (l.logger.trace(
                                'level/adjustedbw/bitrate/avgDuration/maxFetchDuration/fetchDuration: ' +
                                  m +
                                  '/' +
                                  Math.round(b) +
                                  '/' +
                                  S +
                                  '/' +
                                  T +
                                  '/' +
                                  n +
                                  '/' +
                                  L,
                              ),
                              b > S &&
                                (0 === L ||
                                  !Object(i.isFiniteNumber)(L) ||
                                  (p && !this.bitrateTestDelay) ||
                                  L < n))
                            )
                              return m;
                          }
                        }
                        return -1;
                      }),
                      (e = t),
                      (r = [
                        {
                          key: 'nextAutoLevel',
                          get: function() {
                            var t = this._nextAutoLevel,
                              e = this.bwEstimator;
                            if (-1 !== t && !e.canEstimate()) return t;
                            var r = this.getNextABRAutoLevel();
                            return -1 !== t && this.hls.levels[r].loadError
                              ? t
                              : (-1 !== t && (r = Math.min(t, r)), r);
                          },
                          set: function(t) {
                            this._nextAutoLevel = t;
                          },
                        },
                      ]) && n(e.prototype, r),
                      Object.defineProperty(e, 'prototype', { writable: !1 }),
                      t
                    );
                  })();
                e.default = c;
              },
              './src/controller/audio-stream-controller.ts': function(t, e, r) {
                function n() {
                  return (n = Object.assign
                    ? Object.assign.bind()
                    : function(t) {
                        for (var e = 1; e < arguments.length; e++) {
                          var r = arguments[e];
                          for (var n in r)
                            Object.prototype.hasOwnProperty.call(r, n) &&
                              (t[n] = r[n]);
                        }
                        return t;
                      }).apply(this, arguments);
                }
                function i(t, e) {
                  return (i = Object.setPrototypeOf
                    ? Object.setPrototypeOf.bind()
                    : function(t, e) {
                        return (t.__proto__ = e), t;
                      })(t, e);
                }
                r.r(e);
                var s = r('./src/polyfills/number.ts'),
                  a = r('./src/controller/base-stream-controller.ts'),
                  o = r('./src/events.ts'),
                  u = r('./src/utils/buffer-helper.ts'),
                  l = r('./src/controller/fragment-tracker.ts'),
                  c = r('./src/types/level.ts'),
                  h = r('./src/types/loader.ts'),
                  d = r('./src/loader/fragment.ts'),
                  f = r('./src/demux/chunk-cache.ts'),
                  p = r('./src/demux/transmuxer-interface.ts'),
                  v = r('./src/types/transmuxer.ts'),
                  g = r('./src/controller/fragment-finders.ts'),
                  m = r('./src/utils/discontinuities.ts'),
                  y = r('./src/errors.ts'),
                  b = (function(t) {
                    function e(e, r) {
                      var n;
                      return (
                        ((n =
                          t.call(this, e, r, '[audio-stream-controller]') ||
                          this).videoBuffer = null),
                        (n.videoTrackCC = -1),
                        (n.waitingVideoCC = -1),
                        (n.audioSwitch = !1),
                        (n.trackId = -1),
                        (n.waitingData = null),
                        (n.mainDetails = null),
                        (n.bufferFlushed = !1),
                        (n.cachedTrackLoadedData = null),
                        n._registerListeners(),
                        n
                      );
                    }
                    var r, b;
                    (b = t),
                      ((r = e).prototype = Object.create(b.prototype)),
                      (r.prototype.constructor = r),
                      i(r, b);
                    var E = e.prototype;
                    return (
                      (E.onHandlerDestroying = function() {
                        this._unregisterListeners(), (this.mainDetails = null);
                      }),
                      (E._registerListeners = function() {
                        var t = this.hls;
                        t.on(
                          o.Events.MEDIA_ATTACHED,
                          this.onMediaAttached,
                          this,
                        ),
                          t.on(
                            o.Events.MEDIA_DETACHING,
                            this.onMediaDetaching,
                            this,
                          ),
                          t.on(
                            o.Events.MANIFEST_LOADING,
                            this.onManifestLoading,
                            this,
                          ),
                          t.on(o.Events.LEVEL_LOADED, this.onLevelLoaded, this),
                          t.on(
                            o.Events.AUDIO_TRACKS_UPDATED,
                            this.onAudioTracksUpdated,
                            this,
                          ),
                          t.on(
                            o.Events.AUDIO_TRACK_SWITCHING,
                            this.onAudioTrackSwitching,
                            this,
                          ),
                          t.on(
                            o.Events.AUDIO_TRACK_LOADED,
                            this.onAudioTrackLoaded,
                            this,
                          ),
                          t.on(o.Events.ERROR, this.onError, this),
                          t.on(o.Events.BUFFER_RESET, this.onBufferReset, this),
                          t.on(
                            o.Events.BUFFER_CREATED,
                            this.onBufferCreated,
                            this,
                          ),
                          t.on(
                            o.Events.BUFFER_FLUSHED,
                            this.onBufferFlushed,
                            this,
                          ),
                          t.on(
                            o.Events.INIT_PTS_FOUND,
                            this.onInitPtsFound,
                            this,
                          ),
                          t.on(
                            o.Events.FRAG_BUFFERED,
                            this.onFragBuffered,
                            this,
                          );
                      }),
                      (E._unregisterListeners = function() {
                        var t = this.hls;
                        t.off(
                          o.Events.MEDIA_ATTACHED,
                          this.onMediaAttached,
                          this,
                        ),
                          t.off(
                            o.Events.MEDIA_DETACHING,
                            this.onMediaDetaching,
                            this,
                          ),
                          t.off(
                            o.Events.MANIFEST_LOADING,
                            this.onManifestLoading,
                            this,
                          ),
                          t.off(
                            o.Events.LEVEL_LOADED,
                            this.onLevelLoaded,
                            this,
                          ),
                          t.off(
                            o.Events.AUDIO_TRACKS_UPDATED,
                            this.onAudioTracksUpdated,
                            this,
                          ),
                          t.off(
                            o.Events.AUDIO_TRACK_SWITCHING,
                            this.onAudioTrackSwitching,
                            this,
                          ),
                          t.off(
                            o.Events.AUDIO_TRACK_LOADED,
                            this.onAudioTrackLoaded,
                            this,
                          ),
                          t.off(o.Events.ERROR, this.onError, this),
                          t.off(
                            o.Events.BUFFER_RESET,
                            this.onBufferReset,
                            this,
                          ),
                          t.off(
                            o.Events.BUFFER_CREATED,
                            this.onBufferCreated,
                            this,
                          ),
                          t.off(
                            o.Events.BUFFER_FLUSHED,
                            this.onBufferFlushed,
                            this,
                          ),
                          t.off(
                            o.Events.INIT_PTS_FOUND,
                            this.onInitPtsFound,
                            this,
                          ),
                          t.off(
                            o.Events.FRAG_BUFFERED,
                            this.onFragBuffered,
                            this,
                          );
                      }),
                      (E.onInitPtsFound = function(t, e) {
                        var r = e.frag,
                          n = e.id,
                          i = e.initPTS;
                        if ('main' === n) {
                          var s = r.cc;
                          (this.initPTS[r.cc] = i),
                            this.log(
                              'InitPTS for cc: ' + s + ' found from main: ' + i,
                            ),
                            (this.videoTrackCC = s),
                            this.state === a.State.WAITING_INIT_PTS &&
                              this.tick();
                        }
                      }),
                      (E.startLoad = function(t) {
                        if (!this.levels)
                          return (
                            (this.startPosition = t),
                            void (this.state = a.State.STOPPED)
                          );
                        var e = this.lastCurrentTime;
                        this.stopLoad(),
                          this.setInterval(100),
                          (this.fragLoadError = 0),
                          e > 0 && -1 === t
                            ? (this.log(
                                'Override startPosition with lastCurrentTime @' +
                                  e.toFixed(3),
                              ),
                              (t = e),
                              (this.state = a.State.IDLE))
                            : ((this.loadedmetadata = !1),
                              (this.state = a.State.WAITING_TRACK)),
                          (this.nextLoadPosition = this.startPosition = this.lastCurrentTime = t),
                          this.tick();
                      }),
                      (E.doTick = function() {
                        switch (this.state) {
                          case a.State.IDLE:
                            this.doTickIdle();
                            break;
                          case a.State.WAITING_TRACK:
                            var e,
                              r = this.levels,
                              n = this.trackId,
                              i =
                                null == r || null === (e = r[n]) || void 0 === e
                                  ? void 0
                                  : e.details;
                            if (i) {
                              if (this.waitForCdnTuneIn(i)) break;
                              this.state = a.State.WAITING_INIT_PTS;
                            }
                            break;
                          case a.State.FRAG_LOADING_WAITING_RETRY:
                            var s,
                              o = performance.now(),
                              l = this.retryDate;
                            (!l ||
                              o >= l ||
                              (null !== (s = this.media) &&
                                void 0 !== s &&
                                s.seeking)) &&
                              (this.log(
                                'RetryDate reached, switch back to IDLE state',
                              ),
                              this.resetStartWhenNotLoaded(this.trackId),
                              (this.state = a.State.IDLE));
                            break;
                          case a.State.WAITING_INIT_PTS:
                            var c = this.waitingData;
                            if (c) {
                              var h = c.frag,
                                d = c.part,
                                f = c.cache,
                                p = c.complete;
                              if (void 0 !== this.initPTS[h.cc]) {
                                (this.waitingData = null),
                                  (this.waitingVideoCC = -1),
                                  (this.state = a.State.FRAG_LOADING);
                                var v = {
                                  frag: h,
                                  part: d,
                                  payload: f.flush(),
                                  networkDetails: null,
                                };
                                this._handleFragmentLoadProgress(v),
                                  p &&
                                    t.prototype._handleFragmentLoadComplete.call(
                                      this,
                                      v,
                                    );
                              } else if (
                                this.videoTrackCC !== this.waitingVideoCC
                              )
                                this.log(
                                  'Waiting fragment cc (' +
                                    h.cc +
                                    ') cancelled because video is at cc ' +
                                    this.videoTrackCC,
                                ),
                                  this.clearWaitingFragment();
                              else {
                                var m = this.getLoadPosition(),
                                  y = u.BufferHelper.bufferInfo(
                                    this.mediaBuffer,
                                    m,
                                    this.config.maxBufferHole,
                                  );
                                Object(g.fragmentWithinToleranceTest)(
                                  y.end,
                                  this.config.maxFragLookUpTolerance,
                                  h,
                                ) < 0 &&
                                  (this.log(
                                    'Waiting fragment cc (' +
                                      h.cc +
                                      ') @ ' +
                                      h.start +
                                      ' cancelled because another fragment at ' +
                                      y.end +
                                      ' is needed',
                                  ),
                                  this.clearWaitingFragment());
                              }
                            } else this.state = a.State.IDLE;
                        }
                        this.onTickEnd();
                      }),
                      (E.clearWaitingFragment = function() {
                        var t = this.waitingData;
                        t &&
                          (this.fragmentTracker.removeFragment(t.frag),
                          (this.waitingData = null),
                          (this.waitingVideoCC = -1),
                          (this.state = a.State.IDLE));
                      }),
                      (E.resetLoadingState = function() {
                        this.clearWaitingFragment(),
                          t.prototype.resetLoadingState.call(this);
                      }),
                      (E.onTickEnd = function() {
                        var t = this.media;
                        if (t && t.readyState) {
                          var e = (this.mediaBuffer ? this.mediaBuffer : t)
                            .buffered;
                          !this.loadedmetadata &&
                            e.length &&
                            (this.loadedmetadata = !0),
                            (this.lastCurrentTime = t.currentTime);
                        }
                      }),
                      (E.doTickIdle = function() {
                        var t,
                          e,
                          r = this.hls,
                          n = this.levels,
                          i = this.media,
                          s = this.trackId,
                          u = r.config;
                        if (
                          n &&
                          n[s] &&
                          (i ||
                            (!this.startFragRequested && u.startFragPrefetch))
                        ) {
                          var l = n[s].details;
                          if (
                            !l ||
                            (l.live && this.levelLastLoaded !== s) ||
                            this.waitForCdnTuneIn(l)
                          )
                            this.state = a.State.WAITING_TRACK;
                          else {
                            var c = this.mediaBuffer
                              ? this.mediaBuffer
                              : this.media;
                            this.bufferFlushed &&
                              c &&
                              ((this.bufferFlushed = !1),
                              this.afterBufferFlushed(
                                c,
                                d.ElementaryStreamTypes.AUDIO,
                                h.PlaylistLevelType.AUDIO,
                              ));
                            var f = this.getFwdBufferInfo(
                              c,
                              h.PlaylistLevelType.AUDIO,
                            );
                            if (null !== f) {
                              var p = this.getFwdBufferInfo(
                                  this.videoBuffer
                                    ? this.videoBuffer
                                    : this.media,
                                  h.PlaylistLevelType.MAIN,
                                ),
                                v = f.len,
                                g = this.getMaxBufferLength(
                                  null == p ? void 0 : p.len,
                                ),
                                m = this.audioSwitch;
                              if (!(v >= g) || m) {
                                if (!m && this._streamEnded(f, l))
                                  return (
                                    r.trigger(o.Events.BUFFER_EOS, {
                                      type: 'audio',
                                    }),
                                    void (this.state = a.State.ENDED)
                                  );
                                var y = l.fragments[0].start,
                                  b = f.end;
                                if (m && i) {
                                  var E = this.getLoadPosition();
                                  (b = E),
                                    l.PTSKnown &&
                                      E < y &&
                                      (f.end > y || f.nextStart) &&
                                      (this.log(
                                        'Alt audio track ahead of main track, seek to start of alt audio track',
                                      ),
                                      (i.currentTime = y + 0.05));
                                }
                                if (
                                  !(p && b > p.end + l.targetduration) &&
                                  ((p && p.len) || !f.len)
                                ) {
                                  var T = this.getNextFragment(b, l);
                                  T
                                    ? 'identity' !==
                                        (null === (t = T.decryptdata) ||
                                        void 0 === t
                                          ? void 0
                                          : t.keyFormat) ||
                                      (null !== (e = T.decryptdata) &&
                                        void 0 !== e &&
                                        e.key)
                                      ? this.loadFragment(T, l, b)
                                      : this.loadKey(T, l)
                                    : (this.bufferFlushed = !0);
                                }
                              }
                            }
                          }
                        }
                      }),
                      (E.getMaxBufferLength = function(e) {
                        var r = t.prototype.getMaxBufferLength.call(this);
                        return e ? Math.max(r, e) : r;
                      }),
                      (E.onMediaDetaching = function() {
                        (this.videoBuffer = null),
                          t.prototype.onMediaDetaching.call(this);
                      }),
                      (E.onAudioTracksUpdated = function(t, e) {
                        var r = e.audioTracks;
                        this.resetTransmuxer(),
                          (this.levels = r.map(function(t) {
                            return new c.Level(t);
                          }));
                      }),
                      (E.onAudioTrackSwitching = function(t, e) {
                        var r = !!e.url;
                        this.trackId = e.id;
                        var n = this.fragCurrent;
                        null != n && n.loader && n.loader.abort(),
                          (this.fragCurrent = null),
                          this.clearWaitingFragment(),
                          r ? this.setInterval(100) : this.resetTransmuxer(),
                          r
                            ? ((this.audioSwitch = !0),
                              (this.state = a.State.IDLE))
                            : (this.state = a.State.STOPPED),
                          this.tick();
                      }),
                      (E.onManifestLoading = function() {
                        (this.mainDetails = null),
                          this.fragmentTracker.removeAllFragments(),
                          (this.startPosition = this.lastCurrentTime = 0),
                          (this.bufferFlushed = !1);
                      }),
                      (E.onLevelLoaded = function(t, e) {
                        (this.mainDetails = e.details),
                          null !== this.cachedTrackLoadedData &&
                            (this.hls.trigger(
                              o.Events.AUDIO_TRACK_LOADED,
                              this.cachedTrackLoadedData,
                            ),
                            (this.cachedTrackLoadedData = null));
                      }),
                      (E.onAudioTrackLoaded = function(t, e) {
                        var r;
                        if (null != this.mainDetails) {
                          var n = this.levels,
                            i = e.details,
                            s = e.id;
                          if (n) {
                            this.log(
                              'Track ' +
                                s +
                                ' loaded [' +
                                i.startSN +
                                ',' +
                                i.endSN +
                                '],duration:' +
                                i.totalduration,
                            );
                            var o = n[s],
                              u = 0;
                            if (
                              i.live ||
                              (null !== (r = o.details) &&
                                void 0 !== r &&
                                r.live)
                            ) {
                              var l = this.mainDetails;
                              if (
                                (i.fragments[0] || (i.deltaUpdateFailed = !0),
                                i.deltaUpdateFailed || !l)
                              )
                                return;
                              !o.details &&
                              i.hasProgramDateTime &&
                              l.hasProgramDateTime
                                ? (Object(m.alignMediaPlaylistByPDT)(i, l),
                                  (u = i.fragments[0].start))
                                : (u = this.alignPlaylists(i, o.details));
                            }
                            (o.details = i),
                              (this.levelLastLoaded = s),
                              this.startFragRequested ||
                                (!this.mainDetails && i.live) ||
                                this.setStartPosition(o.details, u),
                              this.state !== a.State.WAITING_TRACK ||
                                this.waitForCdnTuneIn(i) ||
                                (this.state = a.State.IDLE),
                              this.tick();
                          } else
                            this.warn(
                              'Audio tracks were reset while loading level ' +
                                s,
                            );
                        } else this.cachedTrackLoadedData = e;
                      }),
                      (E._handleFragmentLoadProgress = function(t) {
                        var e,
                          r = t.frag,
                          n = t.part,
                          i = t.payload,
                          s = this.config,
                          o = this.trackId,
                          u = this.levels;
                        if (u) {
                          var l = u[o];
                          console.assert(
                            l,
                            'Audio track is defined on fragment load progress',
                          );
                          var c = l.details;
                          console.assert(
                            c,
                            'Audio track details are defined on fragment load progress',
                          );
                          var d =
                              s.defaultAudioCodec ||
                              l.audioCodec ||
                              'mp4a.40.2',
                            g = this.transmuxer;
                          g ||
                            (g = this.transmuxer = new p.default(
                              this.hls,
                              h.PlaylistLevelType.AUDIO,
                              this._handleTransmuxComplete.bind(this),
                              this._handleTransmuxerFlush.bind(this),
                            ));
                          var m = this.initPTS[r.cc],
                            y =
                              null === (e = r.initSegment) || void 0 === e
                                ? void 0
                                : e.data;
                          if (void 0 !== m) {
                            var b = n ? n.index : -1,
                              E = -1 !== b,
                              T = new v.ChunkMetadata(
                                r.level,
                                r.sn,
                                r.stats.chunkCount,
                                i.byteLength,
                                b,
                                E,
                              );
                            g.push(
                              i,
                              y,
                              d,
                              '',
                              r,
                              n,
                              c.totalduration,
                              !1,
                              T,
                              m,
                            );
                          } else
                            this.log(
                              'Unknown video PTS for cc ' +
                                r.cc +
                                ', waiting for video PTS before demuxing audio frag ' +
                                r.sn +
                                ' of [' +
                                c.startSN +
                                ' ,' +
                                c.endSN +
                                '],track ' +
                                o,
                            ),
                              (this.waitingData = this.waitingData || {
                                frag: r,
                                part: n,
                                cache: new f.default(),
                                complete: !1,
                              }).cache.push(new Uint8Array(i)),
                              (this.waitingVideoCC = this.videoTrackCC),
                              (this.state = a.State.WAITING_INIT_PTS);
                        } else
                          this.warn(
                            'Audio tracks were reset while fragment load was in progress. Fragment ' +
                              r.sn +
                              ' of level ' +
                              r.level +
                              ' will not be buffered',
                          );
                      }),
                      (E._handleFragmentLoadComplete = function(e) {
                        this.waitingData
                          ? (this.waitingData.complete = !0)
                          : t.prototype._handleFragmentLoadComplete.call(
                              this,
                              e,
                            );
                      }),
                      (E.onBufferReset = function() {
                        (this.mediaBuffer = this.videoBuffer = null),
                          (this.loadedmetadata = !1);
                      }),
                      (E.onBufferCreated = function(t, e) {
                        var r = e.tracks.audio;
                        r && (this.mediaBuffer = r.buffer || null),
                          e.tracks.video &&
                            (this.videoBuffer = e.tracks.video.buffer || null);
                      }),
                      (E.onFragBuffered = function(t, e) {
                        var r = e.frag,
                          n = e.part;
                        r.type === h.PlaylistLevelType.AUDIO &&
                          (this.fragContextChanged(r)
                            ? this.warn(
                                'Fragment ' +
                                  r.sn +
                                  (n ? ' p: ' + n.index : '') +
                                  ' of level ' +
                                  r.level +
                                  ' finished buffering, but was aborted. state: ' +
                                  this.state +
                                  ', audioSwitch: ' +
                                  this.audioSwitch,
                              )
                            : ('initSegment' !== r.sn &&
                                ((this.fragPrevious = r),
                                this.audioSwitch &&
                                  ((this.audioSwitch = !1),
                                  this.hls.trigger(
                                    o.Events.AUDIO_TRACK_SWITCHED,
                                    { id: this.trackId },
                                  ))),
                              this.fragBufferedComplete(r, n)));
                      }),
                      (E.onError = function(e, r) {
                        switch (r.details) {
                          case y.ErrorDetails.FRAG_LOAD_ERROR:
                          case y.ErrorDetails.FRAG_LOAD_TIMEOUT:
                          case y.ErrorDetails.KEY_LOAD_ERROR:
                          case y.ErrorDetails.KEY_LOAD_TIMEOUT:
                            this.onFragmentOrKeyLoadError(
                              h.PlaylistLevelType.AUDIO,
                              r,
                            );
                            break;
                          case y.ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
                          case y.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
                            this.state !== a.State.ERROR &&
                              this.state !== a.State.STOPPED &&
                              ((this.state = r.fatal
                                ? a.State.ERROR
                                : a.State.IDLE),
                              this.warn(
                                r.details +
                                  ' while loading frag, switching to ' +
                                  this.state +
                                  ' state',
                              ));
                            break;
                          case y.ErrorDetails.BUFFER_FULL_ERROR:
                            if (
                              'audio' === r.parent &&
                              (this.state === a.State.PARSING ||
                                this.state === a.State.PARSED)
                            ) {
                              var n = !0,
                                i = this.getFwdBufferInfo(
                                  this.mediaBuffer,
                                  h.PlaylistLevelType.AUDIO,
                                );
                              i &&
                                i.len > 0.5 &&
                                (n = !this.reduceMaxBufferLength(i.len)),
                                n &&
                                  (this.warn(
                                    'Buffer full error also media.currentTime is not buffered, flush audio buffer',
                                  ),
                                  (this.fragCurrent = null),
                                  t.prototype.flushMainBuffer.call(
                                    this,
                                    0,
                                    Number.POSITIVE_INFINITY,
                                    'audio',
                                  )),
                                this.resetLoadingState();
                            }
                        }
                      }),
                      (E.onBufferFlushed = function(t, e) {
                        e.type === d.ElementaryStreamTypes.AUDIO &&
                          (this.bufferFlushed = !0);
                      }),
                      (E._handleTransmuxComplete = function(t) {
                        var e,
                          r = 'audio',
                          i = this.hls,
                          s = t.remuxResult,
                          u = t.chunkMeta,
                          l = this.getCurrentContext(u);
                        if (!l)
                          return (
                            this.warn(
                              'The loading context changed while buffering fragment ' +
                                u.sn +
                                ' of level ' +
                                u.level +
                                '. This chunk will not be buffered.',
                            ),
                            void this.resetStartWhenNotLoaded(u.level)
                          );
                        var c = l.frag,
                          h = l.part,
                          f = l.level.details,
                          p = s.audio,
                          v = s.text,
                          g = s.id3,
                          m = s.initSegment;
                        if (!this.fragContextChanged(c) && f) {
                          if (
                            ((this.state = a.State.PARSING),
                            this.audioSwitch && p && this.completeAudioSwitch(),
                            null != m &&
                              m.tracks &&
                              (this._bufferInitSegment(m.tracks, c, u),
                              i.trigger(o.Events.FRAG_PARSING_INIT_SEGMENT, {
                                frag: c,
                                id: r,
                                tracks: m.tracks,
                              })),
                            p)
                          ) {
                            var y = p.startPTS,
                              b = p.endPTS,
                              E = p.startDTS,
                              T = p.endDTS;
                            h &&
                              (h.elementaryStreams[
                                d.ElementaryStreamTypes.AUDIO
                              ] = {
                                startPTS: y,
                                endPTS: b,
                                startDTS: E,
                                endDTS: T,
                              }),
                              c.setElementaryStreamInfo(
                                d.ElementaryStreamTypes.AUDIO,
                                y,
                                b,
                                E,
                                T,
                              ),
                              this.bufferFragmentData(p, c, h, u);
                          }
                          if (
                            null != g &&
                            null !== (e = g.samples) &&
                            void 0 !== e &&
                            e.length
                          ) {
                            var S = n({ id: r, frag: c, details: f }, g);
                            i.trigger(o.Events.FRAG_PARSING_METADATA, S);
                          }
                          if (v) {
                            var L = n({ id: r, frag: c, details: f }, v);
                            i.trigger(o.Events.FRAG_PARSING_USERDATA, L);
                          }
                        }
                      }),
                      (E._bufferInitSegment = function(t, e, r) {
                        if (this.state === a.State.PARSING) {
                          t.video && delete t.video;
                          var n = t.audio;
                          if (n) {
                            (n.levelCodec = n.codec),
                              (n.id = 'audio'),
                              this.log(
                                'Init audio buffer, container:' +
                                  n.container +
                                  ', codecs[parsed]=[' +
                                  n.codec +
                                  ']',
                              ),
                              this.hls.trigger(o.Events.BUFFER_CODECS, t);
                            var i = n.initSegment;
                            if (null != i && i.byteLength) {
                              var s = {
                                type: 'audio',
                                frag: e,
                                part: null,
                                chunkMeta: r,
                                parent: e.type,
                                data: i,
                              };
                              this.hls.trigger(o.Events.BUFFER_APPENDING, s);
                            }
                            this.tick();
                          }
                        }
                      }),
                      (E.loadFragment = function(e, r, n) {
                        var i = this.fragmentTracker.getState(e);
                        (this.fragCurrent = e),
                          (this.audioSwitch ||
                            i === l.FragmentState.NOT_LOADED ||
                            i === l.FragmentState.PARTIAL) &&
                            ('initSegment' === e.sn
                              ? this._loadInitSegment(e)
                              : r.live &&
                                !Object(s.isFiniteNumber)(this.initPTS[e.cc])
                              ? (this.log(
                                  'Waiting for video PTS in continuity counter ' +
                                    e.cc +
                                    ' of live stream before loading audio fragment ' +
                                    e.sn +
                                    ' of level ' +
                                    this.trackId,
                                ),
                                (this.state = a.State.WAITING_INIT_PTS))
                              : ((this.startFragRequested = !0),
                                t.prototype.loadFragment.call(this, e, r, n)));
                      }),
                      (E.completeAudioSwitch = function() {
                        var e = this.hls,
                          r = this.media,
                          n = this.trackId;
                        r &&
                          (this.log(
                            'Switching audio track : flushing all audio',
                          ),
                          t.prototype.flushMainBuffer.call(
                            this,
                            0,
                            Number.POSITIVE_INFINITY,
                            'audio',
                          )),
                          (this.audioSwitch = !1),
                          e.trigger(o.Events.AUDIO_TRACK_SWITCHED, { id: n });
                      }),
                      e
                    );
                  })(a.default);
                e.default = b;
              },
              './src/controller/audio-track-controller.ts': function(t, e, r) {
                function n(t, e) {
                  for (var r = 0; r < e.length; r++) {
                    var n = e[r];
                    (n.enumerable = n.enumerable || !1),
                      (n.configurable = !0),
                      'value' in n && (n.writable = !0),
                      Object.defineProperty(t, n.key, n);
                  }
                }
                function i(t, e) {
                  return (i = Object.setPrototypeOf
                    ? Object.setPrototypeOf.bind()
                    : function(t, e) {
                        return (t.__proto__ = e), t;
                      })(t, e);
                }
                r.r(e);
                var s = r('./src/events.ts'),
                  a = r('./src/errors.ts'),
                  o = r('./src/controller/base-playlist-controller.ts'),
                  u = r('./src/types/loader.ts'),
                  l = (function(t) {
                    function e(e) {
                      var r;
                      return (
                        ((r =
                          t.call(this, e, '[audio-track-controller]') ||
                          this).tracks = []),
                        (r.groupId = null),
                        (r.tracksInGroup = []),
                        (r.trackId = -1),
                        (r.trackName = ''),
                        (r.selectDefaultTrack = !0),
                        r.registerListeners(),
                        r
                      );
                    }
                    var r, o;
                    (o = t),
                      ((r = e).prototype = Object.create(o.prototype)),
                      (r.prototype.constructor = r),
                      i(r, o);
                    var l,
                      c,
                      h = e.prototype;
                    return (
                      (h.registerListeners = function() {
                        var t = this.hls;
                        t.on(
                          s.Events.MANIFEST_LOADING,
                          this.onManifestLoading,
                          this,
                        ),
                          t.on(
                            s.Events.MANIFEST_PARSED,
                            this.onManifestParsed,
                            this,
                          ),
                          t.on(
                            s.Events.LEVEL_LOADING,
                            this.onLevelLoading,
                            this,
                          ),
                          t.on(
                            s.Events.LEVEL_SWITCHING,
                            this.onLevelSwitching,
                            this,
                          ),
                          t.on(
                            s.Events.AUDIO_TRACK_LOADED,
                            this.onAudioTrackLoaded,
                            this,
                          ),
                          t.on(s.Events.ERROR, this.onError, this);
                      }),
                      (h.unregisterListeners = function() {
                        var t = this.hls;
                        t.off(
                          s.Events.MANIFEST_LOADING,
                          this.onManifestLoading,
                          this,
                        ),
                          t.off(
                            s.Events.MANIFEST_PARSED,
                            this.onManifestParsed,
                            this,
                          ),
                          t.off(
                            s.Events.LEVEL_LOADING,
                            this.onLevelLoading,
                            this,
                          ),
                          t.off(
                            s.Events.LEVEL_SWITCHING,
                            this.onLevelSwitching,
                            this,
                          ),
                          t.off(
                            s.Events.AUDIO_TRACK_LOADED,
                            this.onAudioTrackLoaded,
                            this,
                          ),
                          t.off(s.Events.ERROR, this.onError, this);
                      }),
                      (h.destroy = function() {
                        this.unregisterListeners(),
                          (this.tracks.length = 0),
                          (this.tracksInGroup.length = 0),
                          t.prototype.destroy.call(this);
                      }),
                      (h.onManifestLoading = function() {
                        (this.tracks = []),
                          (this.groupId = null),
                          (this.tracksInGroup = []),
                          (this.trackId = -1),
                          (this.trackName = ''),
                          (this.selectDefaultTrack = !0);
                      }),
                      (h.onManifestParsed = function(t, e) {
                        this.tracks = e.audioTracks || [];
                      }),
                      (h.onAudioTrackLoaded = function(t, e) {
                        var r = e.id,
                          n = e.details,
                          i = this.tracksInGroup[r];
                        if (i) {
                          var s = i.details;
                          (i.details = e.details),
                            this.log(
                              'audioTrack ' +
                                r +
                                ' loaded [' +
                                n.startSN +
                                '-' +
                                n.endSN +
                                ']',
                            ),
                            r === this.trackId &&
                              ((this.retryCount = 0),
                              this.playlistLoaded(r, e, s));
                        } else this.warn('Invalid audio track id ' + r);
                      }),
                      (h.onLevelLoading = function(t, e) {
                        this.switchLevel(e.level);
                      }),
                      (h.onLevelSwitching = function(t, e) {
                        this.switchLevel(e.level);
                      }),
                      (h.switchLevel = function(t) {
                        var e = this.hls.levels[t];
                        if (null != e && e.audioGroupIds) {
                          var r = e.audioGroupIds[e.urlId];
                          if (this.groupId !== r) {
                            this.groupId = r;
                            var n = this.tracks.filter(function(t) {
                              return !r || t.groupId === r;
                            });
                            this.selectDefaultTrack &&
                              !n.some(function(t) {
                                return t.default;
                              }) &&
                              (this.selectDefaultTrack = !1),
                              (this.tracksInGroup = n);
                            var i = { audioTracks: n };
                            this.log(
                              'Updating audio tracks, ' +
                                n.length +
                                ' track(s) found in "' +
                                r +
                                '" group-id',
                            ),
                              this.hls.trigger(
                                s.Events.AUDIO_TRACKS_UPDATED,
                                i,
                              ),
                              this.selectInitialTrack();
                          }
                        }
                      }),
                      (h.onError = function(e, r) {
                        t.prototype.onError.call(this, e, r),
                          !r.fatal &&
                            r.context &&
                            r.context.type ===
                              u.PlaylistContextType.AUDIO_TRACK &&
                            r.context.id === this.trackId &&
                            r.context.groupId === this.groupId &&
                            this.retryLoadingOrFail(r);
                      }),
                      (h.setAudioTrack = function(t) {
                        var e = this.tracksInGroup;
                        if (t < 0 || t >= e.length)
                          this.warn(
                            'Invalid id passed to audio-track controller',
                          );
                        else {
                          this.clearTimer();
                          var r = e[this.trackId];
                          this.log('Now switching to audio-track index ' + t);
                          var n = e[t],
                            i = n.id,
                            a = n.groupId,
                            o = void 0 === a ? '' : a,
                            u = n.name,
                            l = n.type,
                            c = n.url;
                          if (
                            ((this.trackId = t),
                            (this.trackName = u),
                            (this.selectDefaultTrack = !1),
                            this.hls.trigger(s.Events.AUDIO_TRACK_SWITCHING, {
                              id: i,
                              groupId: o,
                              name: u,
                              type: l,
                              url: c,
                            }),
                            !n.details || n.details.live)
                          ) {
                            var h = this.switchParams(
                              n.url,
                              null == r ? void 0 : r.details,
                            );
                            this.loadPlaylist(h);
                          }
                        }
                      }),
                      (h.selectInitialTrack = function() {
                        var t = this.tracksInGroup;
                        console.assert(
                          t.length,
                          'Initial audio track should be selected when tracks are known',
                        );
                        var e = this.trackName,
                          r = this.findTrackId(e) || this.findTrackId();
                        -1 !== r
                          ? this.setAudioTrack(r)
                          : (this.warn(
                              'No track found for running audio group-ID: ' +
                                this.groupId,
                            ),
                            this.hls.trigger(s.Events.ERROR, {
                              type: a.ErrorTypes.MEDIA_ERROR,
                              details: a.ErrorDetails.AUDIO_TRACK_LOAD_ERROR,
                              fatal: !0,
                            }));
                      }),
                      (h.findTrackId = function(t) {
                        for (
                          var e = this.tracksInGroup, r = 0;
                          r < e.length;
                          r++
                        ) {
                          var n = e[r];
                          if (
                            (!this.selectDefaultTrack || n.default) &&
                            (!t || t === n.name)
                          )
                            return n.id;
                        }
                        return -1;
                      }),
                      (h.loadPlaylist = function(t) {
                        var e = this.tracksInGroup[this.trackId];
                        if (this.shouldLoadTrack(e)) {
                          var r = e.id,
                            n = e.groupId,
                            i = e.url;
                          if (t)
                            try {
                              i = t.addDirectives(i);
                            } catch (t) {
                              this.warn(
                                'Could not construct new URL with HLS Delivery Directives: ' +
                                  t,
                              );
                            }
                          this.log('loading audio-track playlist for id: ' + r),
                            this.clearTimer(),
                            this.hls.trigger(s.Events.AUDIO_TRACK_LOADING, {
                              url: i,
                              id: r,
                              groupId: n,
                              deliveryDirectives: t || null,
                            });
                        }
                      }),
                      (l = e),
                      (c = [
                        {
                          key: 'audioTracks',
                          get: function() {
                            return this.tracksInGroup;
                          },
                        },
                        {
                          key: 'audioTrack',
                          get: function() {
                            return this.trackId;
                          },
                          set: function(t) {
                            (this.selectDefaultTrack = !1),
                              this.setAudioTrack(t);
                          },
                        },
                      ]) && n(l.prototype, c),
                      Object.defineProperty(l, 'prototype', { writable: !1 }),
                      e
                    );
                  })(o.default);
                e.default = l;
              },
              './src/controller/base-playlist-controller.ts': function(
                t,
                e,
                r,
              ) {
                r.r(e),
                  r.d(e, 'default', function() {
                    return u;
                  });
                var n = r('./src/polyfills/number.ts'),
                  i = r('./src/types/level.ts'),
                  s = r('./src/controller/level-helper.ts'),
                  a = r('./src/utils/logger.ts'),
                  o = r('./src/errors.ts'),
                  u = (function() {
                    function t(t, e) {
                      (this.hls = void 0),
                        (this.timer = -1),
                        (this.canLoad = !1),
                        (this.retryCount = 0),
                        (this.log = void 0),
                        (this.warn = void 0),
                        (this.log = a.logger.log.bind(a.logger, e + ':')),
                        (this.warn = a.logger.warn.bind(a.logger, e + ':')),
                        (this.hls = t);
                    }
                    var e = t.prototype;
                    return (
                      (e.destroy = function() {
                        this.clearTimer(),
                          (this.hls = this.log = this.warn = null);
                      }),
                      (e.onError = function(t, e) {
                        e.fatal &&
                          e.type === o.ErrorTypes.NETWORK_ERROR &&
                          this.clearTimer();
                      }),
                      (e.clearTimer = function() {
                        clearTimeout(this.timer), (this.timer = -1);
                      }),
                      (e.startLoad = function() {
                        (this.canLoad = !0),
                          (this.retryCount = 0),
                          this.loadPlaylist();
                      }),
                      (e.stopLoad = function() {
                        (this.canLoad = !1), this.clearTimer();
                      }),
                      (e.switchParams = function(t, e) {
                        var r = null == e ? void 0 : e.renditionReports;
                        if (r)
                          for (var s = 0; s < r.length; s++) {
                            var a = r[s],
                              o = '' + a.URI;
                            if (o === t.slice(-o.length)) {
                              var u = parseInt(a['LAST-MSN']),
                                l = parseInt(a['LAST-PART']);
                              if (e && this.hls.config.lowLatencyMode) {
                                var c = Math.min(
                                  e.age - e.partTarget,
                                  e.targetduration,
                                );
                                void 0 !== l && c > e.partTarget && (l += 1);
                              }
                              if (Object(n.isFiniteNumber)(u))
                                return new i.HlsUrlParameters(
                                  u,
                                  Object(n.isFiniteNumber)(l) ? l : void 0,
                                  i.HlsSkip.No,
                                );
                            }
                          }
                      }),
                      (e.loadPlaylist = function(t) {}),
                      (e.shouldLoadTrack = function(t) {
                        return (
                          this.canLoad &&
                          t &&
                          !!t.url &&
                          (!t.details || t.details.live)
                        );
                      }),
                      (e.playlistLoaded = function(t, e, r) {
                        var n = this,
                          i = e.details,
                          a = e.stats,
                          o = a.loading.end
                            ? Math.max(
                                0,
                                self.performance.now() - a.loading.end,
                              )
                            : 0;
                        if (
                          ((i.advancedDateTime = Date.now() - o),
                          i.live || (null != r && r.live))
                        ) {
                          if (
                            (i.reloaded(r),
                            r &&
                              this.log(
                                'live playlist ' +
                                  t +
                                  ' ' +
                                  (i.advanced
                                    ? 'REFRESHED ' +
                                      i.lastPartSn +
                                      '-' +
                                      i.lastPartIndex
                                    : 'MISSED'),
                              ),
                            r &&
                              i.fragments.length > 0 &&
                              Object(s.mergeDetails)(r, i),
                            !this.canLoad || !i.live)
                          )
                            return;
                          var u,
                            l = void 0,
                            c = void 0;
                          if (i.canBlockReload && i.endSN && i.advanced) {
                            var h = this.hls.config.lowLatencyMode,
                              d = i.lastPartSn,
                              f = i.endSN,
                              p = i.lastPartIndex,
                              v = d === f;
                            -1 !== p
                              ? ((l = v ? f + 1 : d),
                                (c = v ? (h ? 0 : p) : p + 1))
                              : (l = f + 1);
                            var g = i.age,
                              m = g + i.ageHeader,
                              y = Math.min(
                                m - i.partTarget,
                                1.5 * i.targetduration,
                              );
                            if (y > 0) {
                              if (r && y > r.tuneInGoal)
                                this.warn(
                                  'CDN Tune-in goal increased from: ' +
                                    r.tuneInGoal +
                                    ' to: ' +
                                    y +
                                    ' with playlist age: ' +
                                    i.age,
                                ),
                                  (y = 0);
                              else {
                                var b = Math.floor(y / i.targetduration);
                                (l += b),
                                  void 0 !== c &&
                                    (c += Math.round(
                                      (y % i.targetduration) / i.partTarget,
                                    )),
                                  this.log(
                                    'CDN Tune-in age: ' +
                                      i.ageHeader +
                                      's last advanced ' +
                                      g.toFixed(2) +
                                      's goal: ' +
                                      y +
                                      ' skip sn ' +
                                      b +
                                      ' to part ' +
                                      c,
                                  );
                              }
                              i.tuneInGoal = y;
                            }
                            if (
                              ((u = this.getDeliveryDirectives(
                                i,
                                e.deliveryDirectives,
                                l,
                                c,
                              )),
                              h || !v)
                            )
                              return void this.loadPlaylist(u);
                          } else
                            u = this.getDeliveryDirectives(
                              i,
                              e.deliveryDirectives,
                              l,
                              c,
                            );
                          var E = Object(s.computeReloadInterval)(i, a);
                          void 0 !== l &&
                            i.canBlockReload &&
                            (E -= i.partTarget || 1),
                            this.log(
                              'reload live playlist ' +
                                t +
                                ' in ' +
                                Math.round(E) +
                                ' ms',
                            ),
                            (this.timer = self.setTimeout(function() {
                              return n.loadPlaylist(u);
                            }, E));
                        } else this.clearTimer();
                      }),
                      (e.getDeliveryDirectives = function(t, e, r, n) {
                        var s = Object(i.getSkipValue)(t, r);
                        return (
                          null != e &&
                            e.skip &&
                            t.deltaUpdateFailed &&
                            ((r = e.msn), (n = e.part), (s = i.HlsSkip.No)),
                          new i.HlsUrlParameters(r, n, s)
                        );
                      }),
                      (e.retryLoadingOrFail = function(t) {
                        var e,
                          r = this,
                          n = this.hls.config,
                          i = this.retryCount < n.levelLoadingMaxRetry;
                        if (i)
                          if (
                            (this.retryCount++,
                            t.details.indexOf('LoadTimeOut') > -1 &&
                              null !== (e = t.context) &&
                              void 0 !== e &&
                              e.deliveryDirectives)
                          )
                            this.warn(
                              'retry playlist loading #' +
                                this.retryCount +
                                ' after "' +
                                t.details +
                                '"',
                            ),
                              this.loadPlaylist();
                          else {
                            var s = Math.min(
                              Math.pow(2, this.retryCount) *
                                n.levelLoadingRetryDelay,
                              n.levelLoadingMaxRetryTimeout,
                            );
                            (this.timer = self.setTimeout(function() {
                              return r.loadPlaylist();
                            }, s)),
                              this.warn(
                                'retry playlist loading #' +
                                  this.retryCount +
                                  ' in ' +
                                  s +
                                  ' ms after "' +
                                  t.details +
                                  '"',
                              );
                          }
                        else
                          this.warn(
                            'cannot recover from error "' + t.details + '"',
                          ),
                            this.clearTimer(),
                            (t.fatal = !0);
                        return i;
                      }),
                      t
                    );
                  })();
              },
              './src/controller/base-stream-controller.ts': function(t, e, r) {
                function n(t, e) {
                  for (var r = 0; r < e.length; r++) {
                    var n = e[r];
                    (n.enumerable = n.enumerable || !1),
                      (n.configurable = !0),
                      'value' in n && (n.writable = !0),
                      Object.defineProperty(t, n.key, n);
                  }
                }
                function i(t) {
                  if (void 0 === t)
                    throw new ReferenceError(
                      "this hasn't been initialised - super() hasn't been called",
                    );
                  return t;
                }
                function s(t, e) {
                  return (s = Object.setPrototypeOf
                    ? Object.setPrototypeOf.bind()
                    : function(t, e) {
                        return (t.__proto__ = e), t;
                      })(t, e);
                }
                r.r(e),
                  r.d(e, 'State', function() {
                    return S;
                  }),
                  r.d(e, 'default', function() {
                    return L;
                  });
                var a = r('./src/polyfills/number.ts'),
                  o = r('./src/task-loop.ts'),
                  u = r('./src/controller/fragment-tracker.ts'),
                  l = r('./src/utils/buffer-helper.ts'),
                  c = r('./src/utils/logger.ts'),
                  h = r('./src/events.ts'),
                  d = r('./src/errors.ts'),
                  f = r('./src/types/transmuxer.ts'),
                  p = r('./src/utils/mp4-tools.ts'),
                  v = r('./src/utils/discontinuities.ts'),
                  g = r('./src/controller/fragment-finders.ts'),
                  m = r('./src/controller/level-helper.ts'),
                  y = r('./src/loader/fragment-loader.ts'),
                  b = r('./src/crypt/decrypter.ts'),
                  E = r('./src/utils/time-ranges.ts'),
                  T = r('./src/types/loader.ts'),
                  S = {
                    STOPPED: 'STOPPED',
                    IDLE: 'IDLE',
                    KEY_LOADING: 'KEY_LOADING',
                    FRAG_LOADING: 'FRAG_LOADING',
                    FRAG_LOADING_WAITING_RETRY: 'FRAG_LOADING_WAITING_RETRY',
                    WAITING_TRACK: 'WAITING_TRACK',
                    PARSING: 'PARSING',
                    PARSED: 'PARSED',
                    ENDED: 'ENDED',
                    ERROR: 'ERROR',
                    WAITING_INIT_PTS: 'WAITING_INIT_PTS',
                    WAITING_LEVEL: 'WAITING_LEVEL',
                  },
                  L = (function(t) {
                    function e(e, r, n) {
                      var s;
                      return (
                        ((s = t.call(this) || this).hls = void 0),
                        (s.fragPrevious = null),
                        (s.fragCurrent = null),
                        (s.fragmentTracker = void 0),
                        (s.transmuxer = null),
                        (s._state = S.STOPPED),
                        (s.media = null),
                        (s.mediaBuffer = null),
                        (s.config = void 0),
                        (s.bitrateTest = !1),
                        (s.lastCurrentTime = 0),
                        (s.nextLoadPosition = 0),
                        (s.startPosition = 0),
                        (s.loadedmetadata = !1),
                        (s.fragLoadError = 0),
                        (s.retryDate = 0),
                        (s.levels = null),
                        (s.fragmentLoader = void 0),
                        (s.levelLastLoaded = null),
                        (s.startFragRequested = !1),
                        (s.decrypter = void 0),
                        (s.initPTS = []),
                        (s.onvseeking = null),
                        (s.onvended = null),
                        (s.logPrefix = ''),
                        (s.log = void 0),
                        (s.warn = void 0),
                        (s.logPrefix = n),
                        (s.log = c.logger.log.bind(c.logger, n + ':')),
                        (s.warn = c.logger.warn.bind(c.logger, n + ':')),
                        (s.hls = e),
                        (s.fragmentLoader = new y.default(e.config)),
                        (s.fragmentTracker = r),
                        (s.config = e.config),
                        (s.decrypter = new b.default(e, e.config)),
                        e.on(h.Events.KEY_LOADED, s.onKeyLoaded, i(s)),
                        e.on(
                          h.Events.LEVEL_SWITCHING,
                          s.onLevelSwitching,
                          i(s),
                        ),
                        s
                      );
                    }
                    var r, o;
                    (o = t),
                      ((r = e).prototype = Object.create(o.prototype)),
                      (r.prototype.constructor = r),
                      s(r, o);
                    var L,
                      _,
                      A = e.prototype;
                    return (
                      (A.doTick = function() {
                        this.onTickEnd();
                      }),
                      (A.onTickEnd = function() {}),
                      (A.startLoad = function(t) {}),
                      (A.stopLoad = function() {
                        this.fragmentLoader.abort();
                        var t = this.fragCurrent;
                        t && this.fragmentTracker.removeFragment(t),
                          this.resetTransmuxer(),
                          (this.fragCurrent = null),
                          (this.fragPrevious = null),
                          this.clearInterval(),
                          this.clearNextTick(),
                          (this.state = S.STOPPED);
                      }),
                      (A._streamEnded = function(t, e) {
                        var r = this.fragCurrent,
                          n = this.fragmentTracker;
                        if (
                          !e.live &&
                          r &&
                          this.media &&
                          r.sn >= e.endSN &&
                          !t.nextStart
                        ) {
                          var i = e.partList;
                          if (null != i && i.length) {
                            var s = i[i.length - 1];
                            return l.BufferHelper.isBuffered(
                              this.media,
                              s.start + s.duration / 2,
                            );
                          }
                          var a = n.getState(r);
                          return (
                            a === u.FragmentState.PARTIAL ||
                            a === u.FragmentState.OK
                          );
                        }
                        return !1;
                      }),
                      (A.onMediaAttached = function(t, e) {
                        var r = (this.media = this.mediaBuffer = e.media);
                        (this.onvseeking = this.onMediaSeeking.bind(this)),
                          (this.onvended = this.onMediaEnded.bind(this)),
                          r.addEventListener('seeking', this.onvseeking),
                          r.addEventListener('ended', this.onvended);
                        var n = this.config;
                        this.levels &&
                          n.autoStartLoad &&
                          this.state === S.STOPPED &&
                          this.startLoad(n.startPosition);
                      }),
                      (A.onMediaDetaching = function() {
                        var t = this.media;
                        null != t &&
                          t.ended &&
                          (this.log(
                            'MSE detaching and video ended, reset startPosition',
                          ),
                          (this.startPosition = this.lastCurrentTime = 0)),
                          t &&
                            this.onvseeking &&
                            this.onvended &&
                            (t.removeEventListener('seeking', this.onvseeking),
                            t.removeEventListener('ended', this.onvended),
                            (this.onvseeking = this.onvended = null)),
                          (this.media = this.mediaBuffer = null),
                          (this.loadedmetadata = !1),
                          this.fragmentTracker.removeAllFragments(),
                          this.stopLoad();
                      }),
                      (A.onMediaSeeking = function() {
                        var t = this.config,
                          e = this.fragCurrent,
                          r = this.media,
                          n = this.mediaBuffer,
                          i = this.state,
                          s = r ? r.currentTime : 0,
                          o = l.BufferHelper.bufferInfo(
                            n || r,
                            s,
                            t.maxBufferHole,
                          );
                        if (
                          (this.log(
                            'media seeking to ' +
                              (Object(a.isFiniteNumber)(s) ? s.toFixed(3) : s) +
                              ', state: ' +
                              i,
                          ),
                          i === S.ENDED)
                        )
                          this.resetLoadingState();
                        else if (e && !o.len) {
                          var u = t.maxFragLookUpTolerance,
                            c = e.start - u,
                            h = s > e.start + e.duration + u;
                          (s < c || h) &&
                            (h &&
                              e.loader &&
                              (this.log(
                                'seeking outside of buffer while fragment load in progress, cancel fragment load',
                              ),
                              e.loader.abort()),
                            this.resetLoadingState());
                        }
                        r && (this.lastCurrentTime = s),
                          this.loadedmetadata ||
                            o.len ||
                            (this.nextLoadPosition = this.startPosition = s),
                          this.tickImmediate();
                      }),
                      (A.onMediaEnded = function() {
                        this.startPosition = this.lastCurrentTime = 0;
                      }),
                      (A.onKeyLoaded = function(t, e) {
                        if (
                          this.state === S.KEY_LOADING &&
                          e.frag === this.fragCurrent &&
                          this.levels
                        ) {
                          this.state = S.IDLE;
                          var r = this.levels[e.frag.level].details;
                          r && this.loadFragment(e.frag, r, e.frag.start);
                        }
                      }),
                      (A.onLevelSwitching = function(t, e) {
                        this.fragLoadError = 0;
                      }),
                      (A.onHandlerDestroying = function() {
                        this.stopLoad(),
                          t.prototype.onHandlerDestroying.call(this);
                      }),
                      (A.onHandlerDestroyed = function() {
                        (this.state = S.STOPPED),
                          this.hls.off(
                            h.Events.KEY_LOADED,
                            this.onKeyLoaded,
                            this,
                          ),
                          this.hls.off(
                            h.Events.LEVEL_SWITCHING,
                            this.onLevelSwitching,
                            this,
                          ),
                          this.fragmentLoader && this.fragmentLoader.destroy(),
                          this.decrypter && this.decrypter.destroy(),
                          (this.hls = this.log = this.warn = this.decrypter = this.fragmentLoader = this.fragmentTracker = null),
                          t.prototype.onHandlerDestroyed.call(this);
                      }),
                      (A.loadKey = function(t, e) {
                        this.log(
                          'Loading key for ' +
                            t.sn +
                            ' of [' +
                            e.startSN +
                            '-' +
                            e.endSN +
                            '], ' +
                            ('[stream-controller]' === this.logPrefix
                              ? 'level'
                              : 'track') +
                            ' ' +
                            t.level,
                        ),
                          (this.state = S.KEY_LOADING),
                          (this.fragCurrent = t),
                          this.hls.trigger(h.Events.KEY_LOADING, { frag: t });
                      }),
                      (A.loadFragment = function(t, e, r) {
                        this._loadFragForPlayback(t, e, r);
                      }),
                      (A._loadFragForPlayback = function(t, e, r) {
                        var n = this;
                        this._doFragLoad(t, e, r, function(e) {
                          if (n.fragContextChanged(t))
                            return (
                              n.warn(
                                'Fragment ' +
                                  t.sn +
                                  (e.part ? ' p: ' + e.part.index : '') +
                                  ' of level ' +
                                  t.level +
                                  ' was dropped during download.',
                              ),
                              void n.fragmentTracker.removeFragment(t)
                            );
                          t.stats.chunkCount++,
                            n._handleFragmentLoadProgress(e);
                        })
                          .then(function(e) {
                            if (e) {
                              n.fragLoadError = 0;
                              var r = n.state;
                              n.fragContextChanged(t)
                                ? (r === S.FRAG_LOADING ||
                                    (!n.fragCurrent && r === S.PARSING)) &&
                                  (n.fragmentTracker.removeFragment(t),
                                  (n.state = S.IDLE))
                                : ('payload' in e &&
                                    (n.log(
                                      'Loaded fragment ' +
                                        t.sn +
                                        ' of level ' +
                                        t.level,
                                    ),
                                    n.hls.trigger(h.Events.FRAG_LOADED, e)),
                                  n._handleFragmentLoadComplete(e));
                            }
                          })
                          .catch(function(e) {
                            n.state !== S.STOPPED &&
                              n.state !== S.ERROR &&
                              (n.warn(e), n.resetFragmentLoading(t));
                          });
                      }),
                      (A.flushMainBuffer = function(t, e, r) {
                        if ((void 0 === r && (r = null), t - e)) {
                          var n = { startOffset: t, endOffset: e, type: r };
                          (this.fragLoadError = 0),
                            this.hls.trigger(h.Events.BUFFER_FLUSHING, n);
                        }
                      }),
                      (A._loadInitSegment = function(t) {
                        var e = this;
                        this._doFragLoad(t)
                          .then(function(r) {
                            if (!r || e.fragContextChanged(t) || !e.levels)
                              throw new Error('init load aborted');
                            return r;
                          })
                          .then(function(r) {
                            var n = e.hls,
                              i = r.payload,
                              s = t.decryptdata;
                            if (
                              i &&
                              i.byteLength > 0 &&
                              s &&
                              s.key &&
                              s.iv &&
                              'AES-128' === s.method
                            ) {
                              var a = self.performance.now();
                              return e.decrypter
                                .webCryptoDecrypt(
                                  new Uint8Array(i),
                                  s.key.buffer,
                                  s.iv.buffer,
                                )
                                .then(function(e) {
                                  var i = self.performance.now();
                                  return (
                                    n.trigger(h.Events.FRAG_DECRYPTED, {
                                      frag: t,
                                      payload: e,
                                      stats: { tstart: a, tdecrypt: i },
                                    }),
                                    (r.payload = e),
                                    r
                                  );
                                });
                            }
                            return r;
                          })
                          .then(function(r) {
                            var n = e.fragCurrent,
                              i = e.hls,
                              s = e.levels;
                            if (!s)
                              throw new Error(
                                'init load aborted, missing levels',
                              );
                            var a = s[t.level].details;
                            console.assert(
                              a,
                              'Level details are defined when init segment is loaded',
                            );
                            var o = t.stats;
                            (e.state = S.IDLE),
                              (e.fragLoadError = 0),
                              (t.data = new Uint8Array(r.payload)),
                              (o.parsing.start = o.buffering.start = self.performance.now()),
                              (o.parsing.end = o.buffering.end = self.performance.now()),
                              r.frag === n &&
                                i.trigger(h.Events.FRAG_BUFFERED, {
                                  stats: o,
                                  frag: n,
                                  part: null,
                                  id: t.type,
                                }),
                              e.tick();
                          })
                          .catch(function(r) {
                            e.state !== S.STOPPED &&
                              e.state !== S.ERROR &&
                              (e.warn(r), e.resetFragmentLoading(t));
                          });
                      }),
                      (A.fragContextChanged = function(t) {
                        var e = this.fragCurrent;
                        return (
                          !t ||
                          !e ||
                          t.level !== e.level ||
                          t.sn !== e.sn ||
                          t.urlId !== e.urlId
                        );
                      }),
                      (A.fragBufferedComplete = function(t, e) {
                        var r = this.mediaBuffer
                          ? this.mediaBuffer
                          : this.media;
                        this.log(
                          'Buffered ' +
                            t.type +
                            ' sn: ' +
                            t.sn +
                            (e ? ' part: ' + e.index : '') +
                            ' of ' +
                            ('[stream-controller]' === this.logPrefix
                              ? 'level'
                              : 'track') +
                            ' ' +
                            t.level +
                            ' ' +
                            (r
                              ? E.default.toString(
                                  l.BufferHelper.getBuffered(r),
                                )
                              : '(detached)'),
                        ),
                          (this.state = S.IDLE),
                          r &&
                            (!this.loadedmetadata &&
                              r.buffered.length &&
                              this.fragCurrent === this.fragPrevious &&
                              ((this.loadedmetadata = !0),
                              this.seekToStartPos()),
                            this.tick());
                      }),
                      (A.seekToStartPos = function() {}),
                      (A._handleFragmentLoadComplete = function(t) {
                        var e = this.transmuxer;
                        if (e) {
                          var r = t.frag,
                            n = t.part,
                            i = t.partsLoaded,
                            s =
                              !i ||
                              0 === i.length ||
                              i.some(function(t) {
                                return !t;
                              }),
                            a = new f.ChunkMetadata(
                              r.level,
                              r.sn,
                              r.stats.chunkCount + 1,
                              0,
                              n ? n.index : -1,
                              !s,
                            );
                          e.flush(a);
                        }
                      }),
                      (A._handleFragmentLoadProgress = function(t) {}),
                      (A._doFragLoad = function(t, e, r, n) {
                        var i = this;
                        if ((void 0 === r && (r = null), !this.levels))
                          throw new Error('frag load aborted, missing levels');
                        if (
                          ((r = Math.max(t.start, r || 0)),
                          this.config.lowLatencyMode && e)
                        ) {
                          var s = e.partList;
                          if (s && n) {
                            r > t.end && e.fragmentHint && (t = e.fragmentHint);
                            var o = this.getNextPart(s, t, r);
                            if (o > -1) {
                              var u = s[o];
                              return (
                                this.log(
                                  'Loading part sn: ' +
                                    t.sn +
                                    ' p: ' +
                                    u.index +
                                    ' cc: ' +
                                    t.cc +
                                    ' of playlist [' +
                                    e.startSN +
                                    '-' +
                                    e.endSN +
                                    '] parts [0-' +
                                    o +
                                    '-' +
                                    (s.length - 1) +
                                    '] ' +
                                    ('[stream-controller]' === this.logPrefix
                                      ? 'level'
                                      : 'track') +
                                    ': ' +
                                    t.level +
                                    ', target: ' +
                                    parseFloat(r.toFixed(3)),
                                ),
                                (this.nextLoadPosition = u.start + u.duration),
                                (this.state = S.FRAG_LOADING),
                                this.hls.trigger(h.Events.FRAG_LOADING, {
                                  frag: t,
                                  part: s[o],
                                  targetBufferTime: r,
                                }),
                                this.doFragPartsLoad(t, s, o, n).catch(function(
                                  t,
                                ) {
                                  return i.handleFragLoadError(t);
                                })
                              );
                            }
                            if (!t.url || this.loadedEndOfParts(s, r))
                              return Promise.resolve(null);
                          }
                        }
                        return (
                          this.log(
                            'Loading fragment ' +
                              t.sn +
                              ' cc: ' +
                              t.cc +
                              ' ' +
                              (e
                                ? 'of [' + e.startSN + '-' + e.endSN + '] '
                                : '') +
                              ('[stream-controller]' === this.logPrefix
                                ? 'level'
                                : 'track') +
                              ': ' +
                              t.level +
                              ', target: ' +
                              parseFloat(r.toFixed(3)),
                          ),
                          Object(a.isFiniteNumber)(t.sn) &&
                            !this.bitrateTest &&
                            (this.nextLoadPosition = t.start + t.duration),
                          (this.state = S.FRAG_LOADING),
                          this.hls.trigger(h.Events.FRAG_LOADING, {
                            frag: t,
                            targetBufferTime: r,
                          }),
                          this.fragmentLoader.load(t, n).catch(function(t) {
                            return i.handleFragLoadError(t);
                          })
                        );
                      }),
                      (A.doFragPartsLoad = function(t, e, r, n) {
                        var i = this;
                        return new Promise(function(s, a) {
                          var o = [];
                          !(function r(u) {
                            var l = e[u];
                            i.fragmentLoader
                              .loadPart(t, l, n)
                              .then(function(n) {
                                o[l.index] = n;
                                var a = n.part;
                                i.hls.trigger(h.Events.FRAG_LOADED, n);
                                var c = e[u + 1];
                                if (!c || c.fragment !== t)
                                  return s({
                                    frag: t,
                                    part: a,
                                    partsLoaded: o,
                                  });
                                r(u + 1);
                              })
                              .catch(a);
                          })(r);
                        });
                      }),
                      (A.handleFragLoadError = function(t) {
                        var e = t.data;
                        return (
                          e && e.details === d.ErrorDetails.INTERNAL_ABORTED
                            ? this.handleFragLoadAborted(e.frag, e.part)
                            : this.hls.trigger(h.Events.ERROR, e),
                          null
                        );
                      }),
                      (A._handleTransmuxerFlush = function(t) {
                        var e = this.getCurrentContext(t);
                        if (e && this.state === S.PARSING) {
                          var r = e.frag,
                            n = e.part,
                            i = e.level,
                            s = self.performance.now();
                          (r.stats.parsing.end = s),
                            n && (n.stats.parsing.end = s),
                            this.updateLevelTiming(r, n, i, t.partial);
                        } else this.fragCurrent || (this.state = S.IDLE);
                      }),
                      (A.getCurrentContext = function(t) {
                        var e = this.levels,
                          r = t.level,
                          n = t.sn,
                          i = t.part;
                        if (!e || !e[r])
                          return (
                            this.warn(
                              'Levels object was unset while buffering fragment ' +
                                n +
                                ' of level ' +
                                r +
                                '. The current chunk will not be buffered.',
                            ),
                            null
                          );
                        var s = e[r],
                          a = i > -1 ? Object(m.getPartWith)(s, n, i) : null,
                          o = a
                            ? a.fragment
                            : Object(m.getFragmentWithSN)(
                                s,
                                n,
                                this.fragCurrent,
                              );
                        return o ? { frag: o, part: a, level: s } : null;
                      }),
                      (A.bufferFragmentData = function(t, e, r, n) {
                        if (t && this.state === S.PARSING) {
                          var i = t.data1,
                            s = t.data2,
                            a = i;
                          if (
                            (i && s && (a = Object(p.appendUint8Array)(i, s)),
                            a && a.length)
                          ) {
                            var o = {
                              type: t.type,
                              frag: e,
                              part: r,
                              chunkMeta: n,
                              parent: e.type,
                              data: a,
                            };
                            this.hls.trigger(h.Events.BUFFER_APPENDING, o),
                              t.dropped &&
                                t.independent &&
                                !r &&
                                this.flushBufferGap(e);
                          }
                        }
                      }),
                      (A.flushBufferGap = function(t) {
                        var e = this.media;
                        if (e)
                          if (l.BufferHelper.isBuffered(e, e.currentTime)) {
                            var r = e.currentTime,
                              n = l.BufferHelper.bufferInfo(e, r, 0),
                              i = t.duration,
                              s = Math.min(
                                2 * this.config.maxFragLookUpTolerance,
                                0.25 * i,
                              ),
                              a = Math.max(
                                Math.min(t.start - s, n.end - s),
                                r + s,
                              );
                            t.start - a > s && this.flushMainBuffer(a, t.start);
                          } else this.flushMainBuffer(0, t.start);
                      }),
                      (A.getFwdBufferInfo = function(t, e) {
                        var r = this.config,
                          n = this.getLoadPosition();
                        if (!Object(a.isFiniteNumber)(n)) return null;
                        var i = l.BufferHelper.bufferInfo(
                          t,
                          n,
                          r.maxBufferHole,
                        );
                        if (0 === i.len && void 0 !== i.nextStart) {
                          var s = this.fragmentTracker.getBufferedFrag(n, e);
                          if (s && i.nextStart < s.end)
                            return l.BufferHelper.bufferInfo(
                              t,
                              n,
                              Math.max(i.nextStart, r.maxBufferHole),
                            );
                        }
                        return i;
                      }),
                      (A.getMaxBufferLength = function(t) {
                        var e,
                          r = this.config;
                        return (
                          (e = t
                            ? Math.max(
                                (8 * r.maxBufferSize) / t,
                                r.maxBufferLength,
                              )
                            : r.maxBufferLength),
                          Math.min(e, r.maxMaxBufferLength)
                        );
                      }),
                      (A.reduceMaxBufferLength = function(t) {
                        var e = this.config,
                          r = t || e.maxBufferLength;
                        return (
                          e.maxMaxBufferLength >= r &&
                          ((e.maxMaxBufferLength /= 2),
                          this.warn(
                            'Reduce max buffer length to ' +
                              e.maxMaxBufferLength +
                              's',
                          ),
                          !0)
                        );
                      }),
                      (A.getNextFragment = function(t, e) {
                        var r = e.fragments,
                          n = r.length;
                        if (!n) return null;
                        var i,
                          s = this.config,
                          a = r[0].start;
                        if (e.live) {
                          var o = s.initialLiveManifestSize;
                          if (n < o)
                            return (
                              this.warn(
                                'Not enough fragments to start playback (have: ' +
                                  n +
                                  ', need: ' +
                                  o +
                                  ')',
                              ),
                              null
                            );
                          e.PTSKnown ||
                            this.startFragRequested ||
                            -1 !== this.startPosition ||
                            ((i = this.getInitialLiveFragment(e, r)),
                            (this.startPosition = i
                              ? this.hls.liveSyncPosition || i.start
                              : t));
                        } else t <= a && (i = r[0]);
                        if (!i) {
                          var u = s.lowLatencyMode ? e.partEnd : e.fragmentEnd;
                          i = this.getFragmentAtPosition(t, u, e);
                        }
                        return this.mapToInitFragWhenRequired(i);
                      }),
                      (A.mapToInitFragWhenRequired = function(t) {
                        return null == t ||
                          !t.initSegment ||
                          (null != t && t.initSegment.data) ||
                          this.bitrateTest
                          ? t
                          : t.initSegment;
                      }),
                      (A.getNextPart = function(t, e, r) {
                        for (
                          var n = -1, i = !1, s = !0, a = 0, o = t.length;
                          a < o;
                          a++
                        ) {
                          var u = t[a];
                          if (
                            ((s = s && !u.independent), n > -1 && r < u.start)
                          )
                            break;
                          var l = u.loaded;
                          !l &&
                            (i || u.independent || s) &&
                            u.fragment === e &&
                            (n = a),
                            (i = l);
                        }
                        return n;
                      }),
                      (A.loadedEndOfParts = function(t, e) {
                        var r = t[t.length - 1];
                        return r && e > r.start && r.loaded;
                      }),
                      (A.getInitialLiveFragment = function(t, e) {
                        var r = this.fragPrevious,
                          n = null;
                        if (r) {
                          if (
                            (t.hasProgramDateTime &&
                              (this.log(
                                'Live playlist, switching playlist, load frag with same PDT: ' +
                                  r.programDateTime,
                              ),
                              (n = Object(g.findFragmentByPDT)(
                                e,
                                r.endProgramDateTime,
                                this.config.maxFragLookUpTolerance,
                              ))),
                            !n)
                          ) {
                            var i = r.sn + 1;
                            if (i >= t.startSN && i <= t.endSN) {
                              var s = e[i - t.startSN];
                              r.cc === s.cc &&
                                ((n = s),
                                this.log(
                                  'Live playlist, switching playlist, load frag with next SN: ' +
                                    n.sn,
                                ));
                            }
                            n ||
                              ((n = Object(g.findFragWithCC)(e, r.cc)) &&
                                this.log(
                                  'Live playlist, switching playlist, load frag with same CC: ' +
                                    n.sn,
                                ));
                          }
                        } else {
                          var a = this.hls.liveSyncPosition;
                          null !== a &&
                            (n = this.getFragmentAtPosition(
                              a,
                              this.bitrateTest ? t.fragmentEnd : t.edge,
                              t,
                            ));
                        }
                        return n;
                      }),
                      (A.getFragmentAtPosition = function(t, e, r) {
                        var n,
                          i = this.config,
                          s = this.fragPrevious,
                          a = r.fragments,
                          o = r.endSN,
                          l = r.fragmentHint,
                          c = i.maxFragLookUpTolerance,
                          h = !!(i.lowLatencyMode && r.partList && l);
                        if (
                          (h &&
                            l &&
                            !this.bitrateTest &&
                            ((a = a.concat(l)), (o = l.sn)),
                          t < e)
                        ) {
                          var d = t > e - c ? 0 : c;
                          n = Object(g.findFragmentByPTS)(s, a, t, d);
                        } else n = a[a.length - 1];
                        if (n) {
                          var f = n.sn - r.startSN;
                          if (
                            s &&
                            n.sn === s.sn &&
                            !h &&
                            s &&
                            n.level === s.level
                          ) {
                            var p = a[f + 1];
                            n.sn < o &&
                            this.fragmentTracker.getState(p) !==
                              u.FragmentState.OK
                              ? (this.log(
                                  'SN ' +
                                    n.sn +
                                    ' just loaded, load next one: ' +
                                    p.sn,
                                ),
                                (n = p))
                              : (n = null);
                          }
                        }
                        return n;
                      }),
                      (A.synchronizeToLiveEdge = function(t) {
                        var e = this.config,
                          r = this.media;
                        if (r) {
                          var n = this.hls.liveSyncPosition,
                            i = r.currentTime,
                            s = t.fragments[0].start,
                            a = t.edge,
                            o = i >= s - e.maxFragLookUpTolerance && i <= a;
                          if (null !== n && r.duration > n && (i < n || !o)) {
                            var u =
                              void 0 !== e.liveMaxLatencyDuration
                                ? e.liveMaxLatencyDuration
                                : e.liveMaxLatencyDurationCount *
                                  t.targetduration;
                            ((!o && r.readyState < 4) || i < a - u) &&
                              (this.loadedmetadata ||
                                (this.nextLoadPosition = n),
                              r.readyState &&
                                (this.warn(
                                  'Playback: ' +
                                    i.toFixed(3) +
                                    ' is located too far from the end of live sliding playlist: ' +
                                    a +
                                    ', reset currentTime to : ' +
                                    n.toFixed(3),
                                ),
                                (r.currentTime = n)));
                          }
                        }
                      }),
                      (A.alignPlaylists = function(t, e) {
                        var r = this.levels,
                          n = this.levelLastLoaded,
                          i = this.fragPrevious,
                          s = null !== n ? r[n] : null,
                          o = t.fragments.length;
                        if (!o)
                          return this.warn('No fragments in live playlist'), 0;
                        var u = t.fragments[0].start,
                          l = !e,
                          c = t.alignedSliding && Object(a.isFiniteNumber)(u);
                        if (l || (!c && !u)) {
                          Object(v.alignStream)(i, s, t);
                          var h = t.fragments[0].start;
                          return (
                            this.log(
                              'Live playlist sliding: ' +
                                h.toFixed(2) +
                                ' start-sn: ' +
                                (e ? e.startSN : 'na') +
                                '->' +
                                t.startSN +
                                ' prev-sn: ' +
                                (i ? i.sn : 'na') +
                                ' fragments: ' +
                                o,
                            ),
                            h
                          );
                        }
                        return u;
                      }),
                      (A.waitForCdnTuneIn = function(t) {
                        return (
                          t.live &&
                          t.canBlockReload &&
                          t.partTarget &&
                          t.tuneInGoal >
                            Math.max(t.partHoldBack, 3 * t.partTarget)
                        );
                      }),
                      (A.setStartPosition = function(t, e) {
                        var r = this.startPosition;
                        if (
                          (r < e && (r = -1),
                          -1 === r || -1 === this.lastCurrentTime)
                        ) {
                          var n = t.startTimeOffset;
                          Object(a.isFiniteNumber)(n)
                            ? ((r = e + n),
                              n < 0 && (r += t.totalduration),
                              (r = Math.min(
                                Math.max(e, r),
                                e + t.totalduration,
                              )),
                              this.log(
                                'Start time offset ' +
                                  n +
                                  ' found in playlist, adjust startPosition to ' +
                                  r,
                              ),
                              (this.startPosition = r))
                            : t.live
                            ? (r = this.hls.liveSyncPosition || e)
                            : (this.startPosition = r = 0),
                            (this.lastCurrentTime = r);
                        }
                        this.nextLoadPosition = r;
                      }),
                      (A.getLoadPosition = function() {
                        var t = this.media,
                          e = 0;
                        return (
                          this.loadedmetadata && t
                            ? (e = t.currentTime)
                            : this.nextLoadPosition &&
                              (e = this.nextLoadPosition),
                          e
                        );
                      }),
                      (A.handleFragLoadAborted = function(t, e) {
                        this.transmuxer &&
                          'initSegment' !== t.sn &&
                          t.stats.aborted &&
                          (this.warn(
                            'Fragment ' +
                              t.sn +
                              (e ? ' part' + e.index : '') +
                              ' of level ' +
                              t.level +
                              ' was aborted',
                          ),
                          this.resetFragmentLoading(t));
                      }),
                      (A.resetFragmentLoading = function(t) {
                        (this.fragCurrent &&
                          (this.fragContextChanged(t) ||
                            this.state === S.FRAG_LOADING_WAITING_RETRY)) ||
                          (this.state = S.IDLE);
                      }),
                      (A.onFragmentOrKeyLoadError = function(t, e) {
                        if (!e.fatal) {
                          var r = e.frag;
                          if (r && r.type === t) {
                            var n = this.fragCurrent;
                            console.assert(
                              n &&
                                r.sn === n.sn &&
                                r.level === n.level &&
                                r.urlId === n.urlId,
                              'Frag load error must match current frag to retry',
                            );
                            var i = this.config;
                            if (
                              this.fragLoadError + 1 <=
                              i.fragLoadingMaxRetry
                            ) {
                              this.loadedmetadata ||
                                ((this.startFragRequested = !1),
                                (this.nextLoadPosition = this.startPosition));
                              var s = Math.min(
                                Math.pow(2, this.fragLoadError) *
                                  i.fragLoadingRetryDelay,
                                i.fragLoadingMaxRetryTimeout,
                              );
                              this.warn(
                                'Fragment ' +
                                  r.sn +
                                  ' of ' +
                                  t +
                                  ' ' +
                                  r.level +
                                  ' failed to load, retrying in ' +
                                  s +
                                  'ms',
                              ),
                                (this.retryDate = self.performance.now() + s),
                                this.fragLoadError++,
                                (this.state = S.FRAG_LOADING_WAITING_RETRY);
                            } else
                              e.levelRetry
                                ? (t === T.PlaylistLevelType.AUDIO &&
                                    (this.fragCurrent = null),
                                  (this.fragLoadError = 0),
                                  (this.state = S.IDLE))
                                : (c.logger.error(
                                    e.details +
                                      ' reaches max retry, redispatch as fatal ...',
                                  ),
                                  (e.fatal = !0),
                                  this.hls.stopLoad(),
                                  (this.state = S.ERROR));
                          }
                        }
                      }),
                      (A.afterBufferFlushed = function(t, e, r) {
                        if (t) {
                          var n = l.BufferHelper.getBuffered(t);
                          this.fragmentTracker.detectEvictedFragments(e, n, r),
                            this.state === S.ENDED && this.resetLoadingState();
                        }
                      }),
                      (A.resetLoadingState = function() {
                        (this.fragCurrent = null),
                          (this.fragPrevious = null),
                          (this.state = S.IDLE);
                      }),
                      (A.resetStartWhenNotLoaded = function(t) {
                        if (!this.loadedmetadata) {
                          this.startFragRequested = !1;
                          var e = this.levels ? this.levels[t].details : null;
                          null != e && e.live
                            ? ((this.startPosition = -1),
                              this.setStartPosition(e, 0),
                              this.resetLoadingState())
                            : (this.nextLoadPosition = this.startPosition);
                        }
                      }),
                      (A.updateLevelTiming = function(t, e, r, n) {
                        var i = this,
                          s = r.details;
                        console.assert(!!s, 'level.details must be defined'),
                          Object.keys(t.elementaryStreams).reduce(function(
                            e,
                            a,
                          ) {
                            var o = t.elementaryStreams[a];
                            if (o) {
                              var u = o.endPTS - o.startPTS;
                              if (u <= 0)
                                return (
                                  i.warn(
                                    'Could not parse fragment ' +
                                      t.sn +
                                      ' ' +
                                      a +
                                      ' duration reliably (' +
                                      u +
                                      ')',
                                  ),
                                  e || !1
                                );
                              var l = n
                                ? 0
                                : Object(m.updateFragPTSDTS)(
                                    s,
                                    t,
                                    o.startPTS,
                                    o.endPTS,
                                    o.startDTS,
                                    o.endDTS,
                                  );
                              return (
                                i.hls.trigger(h.Events.LEVEL_PTS_UPDATED, {
                                  details: s,
                                  level: r,
                                  drift: l,
                                  type: a,
                                  frag: t,
                                  start: o.startPTS,
                                  end: o.endPTS,
                                }),
                                !0
                              );
                            }
                            return e;
                          },
                          !1) ||
                            (this.warn(
                              'Found no media in fragment ' +
                                t.sn +
                                ' of level ' +
                                r.id +
                                ' resetting transmuxer to fallback to playlist timing',
                            ),
                            this.resetTransmuxer()),
                          (this.state = S.PARSED),
                          this.hls.trigger(h.Events.FRAG_PARSED, {
                            frag: t,
                            part: e,
                          });
                      }),
                      (A.resetTransmuxer = function() {
                        this.transmuxer &&
                          (this.transmuxer.destroy(), (this.transmuxer = null));
                      }),
                      (L = e),
                      (_ = [
                        {
                          key: 'state',
                          get: function() {
                            return this._state;
                          },
                          set: function(t) {
                            var e = this._state;
                            e !== t &&
                              ((this._state = t), this.log(e + '->' + t));
                          },
                        },
                      ]) && n(L.prototype, _),
                      Object.defineProperty(L, 'prototype', { writable: !1 }),
                      e
                    );
                  })(o.default);
              },
              './src/controller/buffer-controller.ts': function(t, e, r) {
                r.r(e),
                  r.d(e, 'default', function() {
                    return f;
                  });
                var n = r('./src/polyfills/number.ts'),
                  i = r('./src/events.ts'),
                  s = r('./src/utils/logger.ts'),
                  a = r('./src/errors.ts'),
                  o = r('./src/utils/buffer-helper.ts'),
                  u = r('./src/utils/mediasource-helper.ts'),
                  l = r('./src/loader/fragment.ts'),
                  c = r('./src/controller/buffer-operation-queue.ts'),
                  h = Object(u.getMediaSource)(),
                  d = /([ha]vc.)(?:\.[^.,]+)+/,
                  f = (function() {
                    function t(t) {
                      var e = this;
                      (this.details = null),
                        (this._objectUrl = null),
                        (this.operationQueue = void 0),
                        (this.listeners = void 0),
                        (this.hls = void 0),
                        (this.bufferCodecEventsExpected = 0),
                        (this._bufferCodecEventsTotal = 0),
                        (this.media = null),
                        (this.mediaSource = null),
                        (this.appendError = 0),
                        (this.tracks = {}),
                        (this.pendingTracks = {}),
                        (this.sourceBuffer = void 0),
                        (this._onMediaSourceOpen = function() {
                          var t = e.hls,
                            r = e.media,
                            n = e.mediaSource;
                          s.logger.log(
                            '[buffer-controller]: Media source opened',
                          ),
                            r &&
                              (e.updateMediaElementDuration(),
                              t.trigger(i.Events.MEDIA_ATTACHED, { media: r })),
                            n &&
                              n.removeEventListener(
                                'sourceopen',
                                e._onMediaSourceOpen,
                              ),
                            e.checkPendingTracks();
                        }),
                        (this._onMediaSourceClose = function() {
                          s.logger.log(
                            '[buffer-controller]: Media source closed',
                          );
                        }),
                        (this._onMediaSourceEnded = function() {
                          s.logger.log(
                            '[buffer-controller]: Media source ended',
                          );
                        }),
                        (this.hls = t),
                        this._initSourceBuffer(),
                        this.registerListeners();
                    }
                    var e = t.prototype;
                    return (
                      (e.hasSourceTypes = function() {
                        return (
                          this.getSourceBufferTypes().length > 0 ||
                          Object.keys(this.pendingTracks).length > 0
                        );
                      }),
                      (e.destroy = function() {
                        this.unregisterListeners(), (this.details = null);
                      }),
                      (e.registerListeners = function() {
                        var t = this.hls;
                        t.on(
                          i.Events.MEDIA_ATTACHING,
                          this.onMediaAttaching,
                          this,
                        ),
                          t.on(
                            i.Events.MEDIA_DETACHING,
                            this.onMediaDetaching,
                            this,
                          ),
                          t.on(
                            i.Events.MANIFEST_PARSED,
                            this.onManifestParsed,
                            this,
                          ),
                          t.on(i.Events.BUFFER_RESET, this.onBufferReset, this),
                          t.on(
                            i.Events.BUFFER_APPENDING,
                            this.onBufferAppending,
                            this,
                          ),
                          t.on(
                            i.Events.BUFFER_CODECS,
                            this.onBufferCodecs,
                            this,
                          ),
                          t.on(i.Events.BUFFER_EOS, this.onBufferEos, this),
                          t.on(
                            i.Events.BUFFER_FLUSHING,
                            this.onBufferFlushing,
                            this,
                          ),
                          t.on(
                            i.Events.LEVEL_UPDATED,
                            this.onLevelUpdated,
                            this,
                          ),
                          t.on(i.Events.FRAG_PARSED, this.onFragParsed, this),
                          t.on(i.Events.FRAG_CHANGED, this.onFragChanged, this);
                      }),
                      (e.unregisterListeners = function() {
                        var t = this.hls;
                        t.off(
                          i.Events.MEDIA_ATTACHING,
                          this.onMediaAttaching,
                          this,
                        ),
                          t.off(
                            i.Events.MEDIA_DETACHING,
                            this.onMediaDetaching,
                            this,
                          ),
                          t.off(
                            i.Events.MANIFEST_PARSED,
                            this.onManifestParsed,
                            this,
                          ),
                          t.off(
                            i.Events.BUFFER_RESET,
                            this.onBufferReset,
                            this,
                          ),
                          t.off(
                            i.Events.BUFFER_APPENDING,
                            this.onBufferAppending,
                            this,
                          ),
                          t.off(
                            i.Events.BUFFER_CODECS,
                            this.onBufferCodecs,
                            this,
                          ),
                          t.off(i.Events.BUFFER_EOS, this.onBufferEos, this),
                          t.off(
                            i.Events.BUFFER_FLUSHING,
                            this.onBufferFlushing,
                            this,
                          ),
                          t.off(
                            i.Events.LEVEL_UPDATED,
                            this.onLevelUpdated,
                            this,
                          ),
                          t.off(i.Events.FRAG_PARSED, this.onFragParsed, this),
                          t.off(
                            i.Events.FRAG_CHANGED,
                            this.onFragChanged,
                            this,
                          );
                      }),
                      (e._initSourceBuffer = function() {
                        (this.sourceBuffer = {}),
                          (this.operationQueue = new c.default(
                            this.sourceBuffer,
                          )),
                          (this.listeners = {
                            audio: [],
                            video: [],
                            audiovideo: [],
                          });
                      }),
                      (e.onManifestParsed = function(t, e) {
                        var r = 2;
                        ((e.audio && !e.video) || !e.altAudio) && (r = 1),
                          (this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = r),
                          (this.details = null),
                          s.logger.log(
                            this.bufferCodecEventsExpected +
                              ' bufferCodec event(s) expected',
                          );
                      }),
                      (e.onMediaAttaching = function(t, e) {
                        var r = (this.media = e.media);
                        if (r && h) {
                          var n = (this.mediaSource = new h());
                          n.addEventListener(
                            'sourceopen',
                            this._onMediaSourceOpen,
                          ),
                            n.addEventListener(
                              'sourceended',
                              this._onMediaSourceEnded,
                            ),
                            n.addEventListener(
                              'sourceclose',
                              this._onMediaSourceClose,
                            ),
                            (r.src = self.URL.createObjectURL(n)),
                            (this._objectUrl = r.src);
                        }
                      }),
                      (e.onMediaDetaching = function() {
                        var t = this.media,
                          e = this.mediaSource,
                          r = this._objectUrl;
                        if (e) {
                          if (
                            (s.logger.log(
                              '[buffer-controller]: media source detaching',
                            ),
                            'open' === e.readyState)
                          )
                            try {
                              e.endOfStream();
                            } catch (t) {
                              s.logger.warn(
                                '[buffer-controller]: onMediaDetaching: ' +
                                  t.message +
                                  ' while calling endOfStream',
                              );
                            }
                          this.onBufferReset(),
                            e.removeEventListener(
                              'sourceopen',
                              this._onMediaSourceOpen,
                            ),
                            e.removeEventListener(
                              'sourceended',
                              this._onMediaSourceEnded,
                            ),
                            e.removeEventListener(
                              'sourceclose',
                              this._onMediaSourceClose,
                            ),
                            t &&
                              (r && self.URL.revokeObjectURL(r),
                              t.src === r
                                ? (t.removeAttribute('src'), t.load())
                                : s.logger.warn(
                                    '[buffer-controller]: media.src was changed by a third party - skip cleanup',
                                  )),
                            (this.mediaSource = null),
                            (this.media = null),
                            (this._objectUrl = null),
                            (this.bufferCodecEventsExpected = this._bufferCodecEventsTotal),
                            (this.pendingTracks = {}),
                            (this.tracks = {});
                        }
                        this.hls.trigger(i.Events.MEDIA_DETACHED, void 0);
                      }),
                      (e.onBufferReset = function() {
                        var t = this;
                        this.getSourceBufferTypes().forEach(function(e) {
                          var r = t.sourceBuffer[e];
                          try {
                            r &&
                              (t.removeBufferListeners(e),
                              t.mediaSource &&
                                t.mediaSource.removeSourceBuffer(r),
                              (t.sourceBuffer[e] = void 0));
                          } catch (t) {
                            s.logger.warn(
                              '[buffer-controller]: Failed to reset the ' +
                                e +
                                ' buffer',
                              t,
                            );
                          }
                        }),
                          this._initSourceBuffer();
                      }),
                      (e.onBufferCodecs = function(t, e) {
                        var r = this,
                          n = this.getSourceBufferTypes().length;
                        Object.keys(e).forEach(function(t) {
                          if (n) {
                            var i = r.tracks[t];
                            if (i && 'function' == typeof i.buffer.changeType) {
                              var a = e[t],
                                o = a.id,
                                u = a.codec,
                                l = a.levelCodec,
                                c = a.container,
                                h = a.metadata,
                                f = (i.levelCodec || i.codec).replace(d, '$1'),
                                p = (l || u).replace(d, '$1');
                              if (f !== p) {
                                var v = c + ';codecs=' + (l || u);
                                r.appendChangeType(t, v),
                                  s.logger.log(
                                    '[buffer-controller]: switching codec ' +
                                      f +
                                      ' to ' +
                                      p,
                                  ),
                                  (r.tracks[t] = {
                                    buffer: i.buffer,
                                    codec: u,
                                    container: c,
                                    levelCodec: l,
                                    metadata: h,
                                    id: o,
                                  });
                              }
                            }
                          } else r.pendingTracks[t] = e[t];
                        }),
                          n ||
                            ((this.bufferCodecEventsExpected = Math.max(
                              this.bufferCodecEventsExpected - 1,
                              0,
                            )),
                            this.mediaSource &&
                              'open' === this.mediaSource.readyState &&
                              this.checkPendingTracks());
                      }),
                      (e.appendChangeType = function(t, e) {
                        var r = this,
                          n = this.operationQueue,
                          i = {
                            execute: function() {
                              var i = r.sourceBuffer[t];
                              i &&
                                (s.logger.log(
                                  '[buffer-controller]: changing ' +
                                    t +
                                    ' sourceBuffer type to ' +
                                    e,
                                ),
                                i.changeType(e)),
                                n.shiftAndExecuteNext(t);
                            },
                            onStart: function() {},
                            onComplete: function() {},
                            onError: function(e) {
                              s.logger.warn(
                                '[buffer-controller]: Failed to change ' +
                                  t +
                                  ' SourceBuffer type',
                                e,
                              );
                            },
                          };
                        n.append(i, t);
                      }),
                      (e.onBufferAppending = function(t, e) {
                        var r = this,
                          n = this.hls,
                          u = this.operationQueue,
                          l = this.tracks,
                          c = e.data,
                          h = e.type,
                          d = e.frag,
                          f = e.part,
                          p = e.chunkMeta,
                          v = p.buffering[h],
                          g = self.performance.now();
                        v.start = g;
                        var m = d.stats.buffering,
                          y = f ? f.stats.buffering : null;
                        0 === m.start && (m.start = g),
                          y && 0 === y.start && (y.start = g);
                        var b = l.audio,
                          E =
                            'audio' === h &&
                            1 === p.id &&
                            'audio/mpeg' === (null == b ? void 0 : b.container),
                          T = {
                            execute: function() {
                              if (
                                ((v.executeStart = self.performance.now()), E)
                              ) {
                                var t = r.sourceBuffer[h];
                                if (t) {
                                  var e = d.start - t.timestampOffset;
                                  Math.abs(e) >= 0.1 &&
                                    (s.logger.log(
                                      '[buffer-controller]: Updating audio SourceBuffer timestampOffset to ' +
                                        d.start +
                                        ' (delta: ' +
                                        e +
                                        ') sn: ' +
                                        d.sn +
                                        ')',
                                    ),
                                    (t.timestampOffset = d.start));
                                }
                              }
                              r.appendExecutor(c, h);
                            },
                            onStart: function() {},
                            onComplete: function() {
                              var t = self.performance.now();
                              (v.executeEnd = v.end = t),
                                0 === m.first && (m.first = t),
                                y && 0 === y.first && (y.first = t);
                              var e = r.sourceBuffer,
                                n = {};
                              for (var s in e)
                                n[s] = o.BufferHelper.getBuffered(e[s]);
                              (r.appendError = 0),
                                r.hls.trigger(i.Events.BUFFER_APPENDED, {
                                  type: h,
                                  frag: d,
                                  part: f,
                                  chunkMeta: p,
                                  parent: d.type,
                                  timeRanges: n,
                                });
                            },
                            onError: function(t) {
                              s.logger.error(
                                '[buffer-controller]: Error encountered while trying to append to the ' +
                                  h +
                                  ' SourceBuffer',
                                t,
                              );
                              var e = {
                                type: a.ErrorTypes.MEDIA_ERROR,
                                parent: d.type,
                                details: a.ErrorDetails.BUFFER_APPEND_ERROR,
                                err: t,
                                fatal: !1,
                              };
                              t.code === DOMException.QUOTA_EXCEEDED_ERR
                                ? (e.details = a.ErrorDetails.BUFFER_FULL_ERROR)
                                : (r.appendError++,
                                  (e.details =
                                    a.ErrorDetails.BUFFER_APPEND_ERROR),
                                  r.appendError >
                                    n.config.appendErrorMaxRetry &&
                                    (s.logger.error(
                                      '[buffer-controller]: Failed ' +
                                        n.config.appendErrorMaxRetry +
                                        ' times to append segment in sourceBuffer',
                                    ),
                                    (e.fatal = !0),
                                    n.stopLoad())),
                                n.trigger(i.Events.ERROR, e);
                            },
                          };
                        u.append(T, h);
                      }),
                      (e.onBufferFlushing = function(t, e) {
                        var r = this,
                          n = this.operationQueue,
                          a = function(t) {
                            return {
                              execute: r.removeExecutor.bind(
                                r,
                                t,
                                e.startOffset,
                                e.endOffset,
                              ),
                              onStart: function() {},
                              onComplete: function() {
                                r.hls.trigger(i.Events.BUFFER_FLUSHED, {
                                  type: t,
                                });
                              },
                              onError: function(e) {
                                s.logger.warn(
                                  '[buffer-controller]: Failed to remove from ' +
                                    t +
                                    ' SourceBuffer',
                                  e,
                                );
                              },
                            };
                          };
                        e.type
                          ? n.append(a(e.type), e.type)
                          : this.getSourceBufferTypes().forEach(function(t) {
                              n.append(a(t), t);
                            });
                      }),
                      (e.onFragParsed = function(t, e) {
                        var r = this,
                          n = e.frag,
                          a = e.part,
                          o = [],
                          u = a ? a.elementaryStreams : n.elementaryStreams;
                        u[l.ElementaryStreamTypes.AUDIOVIDEO]
                          ? o.push('audiovideo')
                          : (u[l.ElementaryStreamTypes.AUDIO] &&
                              o.push('audio'),
                            u[l.ElementaryStreamTypes.VIDEO] &&
                              o.push('video')),
                          0 === o.length &&
                            s.logger.warn(
                              'Fragments must have at least one ElementaryStreamType set. type: ' +
                                n.type +
                                ' level: ' +
                                n.level +
                                ' sn: ' +
                                n.sn,
                            ),
                          this.blockBuffers(function() {
                            var t = self.performance.now();
                            (n.stats.buffering.end = t),
                              a && (a.stats.buffering.end = t);
                            var e = a ? a.stats : n.stats;
                            r.hls.trigger(i.Events.FRAG_BUFFERED, {
                              frag: n,
                              part: a,
                              stats: e,
                              id: n.type,
                            });
                          }, o);
                      }),
                      (e.onFragChanged = function(t, e) {
                        this.flushBackBuffer();
                      }),
                      (e.onBufferEos = function(t, e) {
                        var r = this;
                        this.getSourceBufferTypes().reduce(function(t, n) {
                          var i = r.sourceBuffer[n];
                          return (
                            (e.type && e.type !== n) ||
                              (i &&
                                !i.ended &&
                                ((i.ended = !0),
                                s.logger.log(
                                  '[buffer-controller]: ' +
                                    n +
                                    ' sourceBuffer now EOS',
                                ))),
                            t && !(i && !i.ended)
                          );
                        }, !0) &&
                          this.blockBuffers(function() {
                            var t = r.mediaSource;
                            t && 'open' === t.readyState && t.endOfStream();
                          });
                      }),
                      (e.onLevelUpdated = function(t, e) {
                        var r = e.details;
                        r.fragments.length &&
                          ((this.details = r),
                          this.getSourceBufferTypes().length
                            ? this.blockBuffers(
                                this.updateMediaElementDuration.bind(this),
                              )
                            : this.updateMediaElementDuration());
                      }),
                      (e.flushBackBuffer = function() {
                        var t = this.hls,
                          e = this.details,
                          r = this.media,
                          s = this.sourceBuffer;
                        if (r && null !== e) {
                          var a = this.getSourceBufferTypes();
                          if (a.length) {
                            var u =
                              e.live && null !== t.config.liveBackBufferLength
                                ? t.config.liveBackBufferLength
                                : t.config.backBufferLength;
                            if (Object(n.isFiniteNumber)(u) && !(u < 0)) {
                              var l = r.currentTime,
                                c = e.levelTargetDuration,
                                h = Math.max(u, c),
                                d = Math.floor(l / c) * c - h;
                              a.forEach(function(r) {
                                var n = s[r];
                                if (n) {
                                  var a = o.BufferHelper.getBuffered(n);
                                  a.length > 0 &&
                                    d > a.start(0) &&
                                    (t.trigger(i.Events.BACK_BUFFER_REACHED, {
                                      bufferEnd: d,
                                    }),
                                    e.live &&
                                      t.trigger(
                                        i.Events.LIVE_BACK_BUFFER_REACHED,
                                        { bufferEnd: d },
                                      ),
                                    t.trigger(i.Events.BUFFER_FLUSHING, {
                                      startOffset: 0,
                                      endOffset: d,
                                      type: r,
                                    }));
                                }
                              });
                            }
                          }
                        }
                      }),
                      (e.updateMediaElementDuration = function() {
                        if (
                          this.details &&
                          this.media &&
                          this.mediaSource &&
                          'open' === this.mediaSource.readyState
                        ) {
                          var t = this.details,
                            e = this.hls,
                            r = this.media,
                            i = this.mediaSource,
                            a = t.fragments[0].start + t.totalduration,
                            o = r.duration,
                            u = Object(n.isFiniteNumber)(i.duration)
                              ? i.duration
                              : 0;
                          t.live && e.config.liveDurationInfinity
                            ? (s.logger.log(
                                '[buffer-controller]: Media Source duration is set to Infinity',
                              ),
                              (i.duration = 1 / 0),
                              this.updateSeekableRange(t))
                            : ((a > u && a > o) ||
                                !Object(n.isFiniteNumber)(o)) &&
                              (s.logger.log(
                                '[buffer-controller]: Updating Media Source duration to ' +
                                  a.toFixed(3),
                              ),
                              (i.duration = a));
                        }
                      }),
                      (e.updateSeekableRange = function(t) {
                        var e = this.mediaSource,
                          r = t.fragments;
                        if (
                          r.length &&
                          t.live &&
                          null != e &&
                          e.setLiveSeekableRange
                        ) {
                          var n = Math.max(0, r[0].start),
                            i = Math.max(n, n + t.totalduration);
                          e.setLiveSeekableRange(n, i);
                        }
                      }),
                      (e.checkPendingTracks = function() {
                        var t = this.bufferCodecEventsExpected,
                          e = this.operationQueue,
                          r = this.pendingTracks,
                          n = Object.keys(r).length;
                        if ((n && !t) || 2 === n) {
                          this.createSourceBuffers(r),
                            (this.pendingTracks = {});
                          var s = this.getSourceBufferTypes();
                          if (0 === s.length)
                            return void this.hls.trigger(i.Events.ERROR, {
                              type: a.ErrorTypes.MEDIA_ERROR,
                              details:
                                a.ErrorDetails.BUFFER_INCOMPATIBLE_CODECS_ERROR,
                              fatal: !0,
                              reason:
                                'could not create source buffer for media codec(s)',
                            });
                          s.forEach(function(t) {
                            e.executeNext(t);
                          });
                        }
                      }),
                      (e.createSourceBuffers = function(t) {
                        var e = this.sourceBuffer,
                          r = this.mediaSource;
                        if (!r)
                          throw Error(
                            'createSourceBuffers called when mediaSource was null',
                          );
                        var n = 0;
                        for (var o in t)
                          if (!e[o]) {
                            var u = t[o];
                            if (!u)
                              throw Error(
                                'source buffer exists for track ' +
                                  o +
                                  ', however track does not',
                              );
                            var l = u.levelCodec || u.codec,
                              c = u.container + ';codecs=' + l;
                            s.logger.log(
                              '[buffer-controller]: creating sourceBuffer(' +
                                c +
                                ')',
                            );
                            try {
                              var h = (e[o] = r.addSourceBuffer(c)),
                                d = o;
                              this.addBufferListener(
                                d,
                                'updatestart',
                                this._onSBUpdateStart,
                              ),
                                this.addBufferListener(
                                  d,
                                  'updateend',
                                  this._onSBUpdateEnd,
                                ),
                                this.addBufferListener(
                                  d,
                                  'error',
                                  this._onSBUpdateError,
                                ),
                                (this.tracks[o] = {
                                  buffer: h,
                                  codec: l,
                                  container: u.container,
                                  levelCodec: u.levelCodec,
                                  metadata: u.metadata,
                                  id: u.id,
                                }),
                                n++;
                            } catch (t) {
                              s.logger.error(
                                '[buffer-controller]: error while trying to add sourceBuffer: ' +
                                  t.message,
                              ),
                                this.hls.trigger(i.Events.ERROR, {
                                  type: a.ErrorTypes.MEDIA_ERROR,
                                  details:
                                    a.ErrorDetails.BUFFER_ADD_CODEC_ERROR,
                                  fatal: !1,
                                  error: t,
                                  mimeType: c,
                                });
                            }
                          }
                        n &&
                          this.hls.trigger(i.Events.BUFFER_CREATED, {
                            tracks: this.tracks,
                          });
                      }),
                      (e._onSBUpdateStart = function(t) {
                        this.operationQueue.current(t).onStart();
                      }),
                      (e._onSBUpdateEnd = function(t) {
                        var e = this.operationQueue;
                        e.current(t).onComplete(), e.shiftAndExecuteNext(t);
                      }),
                      (e._onSBUpdateError = function(t, e) {
                        s.logger.error(
                          '[buffer-controller]: ' + t + ' SourceBuffer error',
                          e,
                        ),
                          this.hls.trigger(i.Events.ERROR, {
                            type: a.ErrorTypes.MEDIA_ERROR,
                            details: a.ErrorDetails.BUFFER_APPENDING_ERROR,
                            fatal: !1,
                          });
                        var r = this.operationQueue.current(t);
                        r && r.onError(e);
                      }),
                      (e.removeExecutor = function(t, e, r) {
                        var i = this.media,
                          a = this.mediaSource,
                          o = this.operationQueue,
                          u = this.sourceBuffer[t];
                        if (!i || !a || !u)
                          return (
                            s.logger.warn(
                              '[buffer-controller]: Attempting to remove from the ' +
                                t +
                                ' SourceBuffer, but it does not exist',
                            ),
                            void o.shiftAndExecuteNext(t)
                          );
                        var l = Object(n.isFiniteNumber)(i.duration)
                            ? i.duration
                            : 1 / 0,
                          c = Object(n.isFiniteNumber)(a.duration)
                            ? a.duration
                            : 1 / 0,
                          h = Math.max(0, e),
                          d = Math.min(r, l, c);
                        d > h
                          ? (s.logger.log(
                              '[buffer-controller]: Removing [' +
                                h +
                                ',' +
                                d +
                                '] from the ' +
                                t +
                                ' SourceBuffer',
                            ),
                            console.assert(
                              !u.updating,
                              t + ' sourceBuffer must not be updating',
                            ),
                            u.remove(h, d))
                          : o.shiftAndExecuteNext(t);
                      }),
                      (e.appendExecutor = function(t, e) {
                        var r = this.operationQueue,
                          n = this.sourceBuffer[e];
                        if (!n)
                          return (
                            s.logger.warn(
                              '[buffer-controller]: Attempting to append to the ' +
                                e +
                                ' SourceBuffer, but it does not exist',
                            ),
                            void r.shiftAndExecuteNext(e)
                          );
                        (n.ended = !1),
                          console.assert(
                            !n.updating,
                            e + ' sourceBuffer must not be updating',
                          ),
                          n.appendBuffer(t);
                      }),
                      (e.blockBuffers = function(t, e) {
                        var r = this;
                        if (
                          (void 0 === e && (e = this.getSourceBufferTypes()),
                          !e.length)
                        )
                          return (
                            s.logger.log(
                              '[buffer-controller]: Blocking operation requested, but no SourceBuffers exist',
                            ),
                            void Promise.resolve().then(t)
                          );
                        var n = this.operationQueue,
                          i = e.map(function(t) {
                            return n.appendBlocker(t);
                          });
                        Promise.all(i).then(function() {
                          t(),
                            e.forEach(function(t) {
                              var e = r.sourceBuffer[t];
                              (e && e.updating) || n.shiftAndExecuteNext(t);
                            });
                        });
                      }),
                      (e.getSourceBufferTypes = function() {
                        return Object.keys(this.sourceBuffer);
                      }),
                      (e.addBufferListener = function(t, e, r) {
                        var n = this.sourceBuffer[t];
                        if (n) {
                          var i = r.bind(this, t);
                          this.listeners[t].push({ event: e, listener: i }),
                            n.addEventListener(e, i);
                        }
                      }),
                      (e.removeBufferListeners = function(t) {
                        var e = this.sourceBuffer[t];
                        e &&
                          this.listeners[t].forEach(function(t) {
                            e.removeEventListener(t.event, t.listener);
                          });
                      }),
                      t
                    );
                  })();
              },
              './src/controller/buffer-operation-queue.ts': function(t, e, r) {
                r.r(e),
                  r.d(e, 'default', function() {
                    return i;
                  });
                var n = r('./src/utils/logger.ts'),
                  i = (function() {
                    function t(t) {
                      (this.buffers = void 0),
                        (this.queues = {
                          video: [],
                          audio: [],
                          audiovideo: [],
                        }),
                        (this.buffers = t);
                    }
                    var e = t.prototype;
                    return (
                      (e.append = function(t, e) {
                        var r = this.queues[e];
                        r.push(t),
                          1 === r.length &&
                            this.buffers[e] &&
                            this.executeNext(e);
                      }),
                      (e.insertAbort = function(t, e) {
                        this.queues[e].unshift(t), this.executeNext(e);
                      }),
                      (e.appendBlocker = function(t) {
                        var e,
                          r = new Promise(function(t) {
                            e = t;
                          }),
                          n = {
                            execute: e,
                            onStart: function() {},
                            onComplete: function() {},
                            onError: function() {},
                          };
                        return this.append(n, t), r;
                      }),
                      (e.executeNext = function(t) {
                        var e = this.buffers,
                          r = this.queues,
                          i = e[t],
                          s = r[t];
                        if (s.length) {
                          var a = s[0];
                          try {
                            a.execute();
                          } catch (e) {
                            n.logger.warn(
                              '[buffer-operation-queue]: Unhandled exception executing the current operation',
                            ),
                              a.onError(e),
                              (i && i.updating) ||
                                (s.shift(), this.executeNext(t));
                          }
                        }
                      }),
                      (e.shiftAndExecuteNext = function(t) {
                        this.queues[t].shift(), this.executeNext(t);
                      }),
                      (e.current = function(t) {
                        return this.queues[t][0];
                      }),
                      t
                    );
                  })();
              },
              './src/controller/cap-level-controller.ts': function(t, e, r) {
                function n(t, e) {
                  for (var r = 0; r < e.length; r++) {
                    var n = e[r];
                    (n.enumerable = n.enumerable || !1),
                      (n.configurable = !0),
                      'value' in n && (n.writable = !0),
                      Object.defineProperty(t, n.key, n);
                  }
                }
                r.r(e);
                var i = r('./src/events.ts'),
                  s = (function() {
                    function t(t) {
                      (this.autoLevelCapping = void 0),
                        (this.firstLevel = void 0),
                        (this.media = void 0),
                        (this.restrictedLevels = void 0),
                        (this.timer = void 0),
                        (this.hls = void 0),
                        (this.streamController = void 0),
                        (this.clientRect = void 0),
                        (this.hls = t),
                        (this.autoLevelCapping = Number.POSITIVE_INFINITY),
                        (this.firstLevel = -1),
                        (this.media = null),
                        (this.restrictedLevels = []),
                        (this.timer = void 0),
                        (this.clientRect = null),
                        this.registerListeners();
                    }
                    var e,
                      r,
                      s = t.prototype;
                    return (
                      (s.setStreamController = function(t) {
                        this.streamController = t;
                      }),
                      (s.destroy = function() {
                        this.unregisterListener(),
                          this.hls.config.capLevelToPlayerSize &&
                            this.stopCapping(),
                          (this.media = null),
                          (this.clientRect = null),
                          (this.hls = this.streamController = null);
                      }),
                      (s.registerListeners = function() {
                        var t = this.hls;
                        t.on(
                          i.Events.FPS_DROP_LEVEL_CAPPING,
                          this.onFpsDropLevelCapping,
                          this,
                        ),
                          t.on(
                            i.Events.MEDIA_ATTACHING,
                            this.onMediaAttaching,
                            this,
                          ),
                          t.on(
                            i.Events.MANIFEST_PARSED,
                            this.onManifestParsed,
                            this,
                          ),
                          t.on(
                            i.Events.BUFFER_CODECS,
                            this.onBufferCodecs,
                            this,
                          ),
                          t.on(
                            i.Events.MEDIA_DETACHING,
                            this.onMediaDetaching,
                            this,
                          );
                      }),
                      (s.unregisterListener = function() {
                        var t = this.hls;
                        t.off(
                          i.Events.FPS_DROP_LEVEL_CAPPING,
                          this.onFpsDropLevelCapping,
                          this,
                        ),
                          t.off(
                            i.Events.MEDIA_ATTACHING,
                            this.onMediaAttaching,
                            this,
                          ),
                          t.off(
                            i.Events.MANIFEST_PARSED,
                            this.onManifestParsed,
                            this,
                          ),
                          t.off(
                            i.Events.BUFFER_CODECS,
                            this.onBufferCodecs,
                            this,
                          ),
                          t.off(
                            i.Events.MEDIA_DETACHING,
                            this.onMediaDetaching,
                            this,
                          );
                      }),
                      (s.onFpsDropLevelCapping = function(e, r) {
                        t.isLevelAllowed(
                          r.droppedLevel,
                          this.restrictedLevels,
                        ) && this.restrictedLevels.push(r.droppedLevel);
                      }),
                      (s.onMediaAttaching = function(t, e) {
                        this.media =
                          e.media instanceof HTMLVideoElement ? e.media : null;
                      }),
                      (s.onManifestParsed = function(t, e) {
                        var r = this.hls;
                        (this.restrictedLevels = []),
                          (this.firstLevel = e.firstLevel),
                          r.config.capLevelToPlayerSize &&
                            e.video &&
                            this.startCapping();
                      }),
                      (s.onBufferCodecs = function(t, e) {
                        this.hls.config.capLevelToPlayerSize &&
                          e.video &&
                          this.startCapping();
                      }),
                      (s.onMediaDetaching = function() {
                        this.stopCapping();
                      }),
                      (s.detectPlayerSize = function() {
                        if (
                          this.media &&
                          this.mediaHeight > 0 &&
                          this.mediaWidth > 0
                        ) {
                          var t = this.hls.levels;
                          if (t.length) {
                            var e = this.hls;
                            (e.autoLevelCapping = this.getMaxLevel(
                              t.length - 1,
                            )),
                              e.autoLevelCapping > this.autoLevelCapping &&
                                this.streamController &&
                                this.streamController.nextLevelSwitch(),
                              (this.autoLevelCapping = e.autoLevelCapping);
                          }
                        }
                      }),
                      (s.getMaxLevel = function(e) {
                        var r = this,
                          n = this.hls.levels;
                        if (!n.length) return -1;
                        var i = n.filter(function(n, i) {
                          return (
                            t.isLevelAllowed(i, r.restrictedLevels) && i <= e
                          );
                        });
                        return (
                          (this.clientRect = null),
                          t.getMaxLevelByMediaSize(
                            i,
                            this.mediaWidth,
                            this.mediaHeight,
                          )
                        );
                      }),
                      (s.startCapping = function() {
                        this.timer ||
                          ((this.autoLevelCapping = Number.POSITIVE_INFINITY),
                          (this.hls.firstLevel = this.getMaxLevel(
                            this.firstLevel,
                          )),
                          self.clearInterval(this.timer),
                          (this.timer = self.setInterval(
                            this.detectPlayerSize.bind(this),
                            1e3,
                          )),
                          this.detectPlayerSize());
                      }),
                      (s.stopCapping = function() {
                        (this.restrictedLevels = []),
                          (this.firstLevel = -1),
                          (this.autoLevelCapping = Number.POSITIVE_INFINITY),
                          this.timer &&
                            (self.clearInterval(this.timer),
                            (this.timer = void 0));
                      }),
                      (s.getDimensions = function() {
                        if (this.clientRect) return this.clientRect;
                        var t = this.media,
                          e = { width: 0, height: 0 };
                        if (t) {
                          var r = t.getBoundingClientRect();
                          (e.width = r.width),
                            (e.height = r.height),
                            e.width ||
                              e.height ||
                              ((e.width = r.right - r.left || t.width || 0),
                              (e.height = r.bottom - r.top || t.height || 0));
                        }
                        return (this.clientRect = e), e;
                      }),
                      (t.isLevelAllowed = function(t, e) {
                        return void 0 === e && (e = []), -1 === e.indexOf(t);
                      }),
                      (t.getMaxLevelByMediaSize = function(t, e, r) {
                        if (!t || !t.length) return -1;
                        for (
                          var n, i, s = t.length - 1, a = 0;
                          a < t.length;
                          a += 1
                        ) {
                          var o = t[a];
                          if (
                            (o.width >= e || o.height >= r) &&
                            ((n = o),
                            !(i = t[a + 1]) ||
                              n.width !== i.width ||
                              n.height !== i.height)
                          ) {
                            s = a;
                            break;
                          }
                        }
                        return s;
                      }),
                      (e = t),
                      (r = [
                        {
                          key: 'mediaWidth',
                          get: function() {
                            return (
                              this.getDimensions().width *
                              this.contentScaleFactor
                            );
                          },
                        },
                        {
                          key: 'mediaHeight',
                          get: function() {
                            return (
                              this.getDimensions().height *
                              this.contentScaleFactor
                            );
                          },
                        },
                        {
                          key: 'contentScaleFactor',
                          get: function() {
                            var t = 1;
                            if (!this.hls.config.ignoreDevicePixelRatio)
                              try {
                                t = self.devicePixelRatio;
                              } catch (t) {}
                            return t;
                          },
                        },
                      ]) && n(e.prototype, r),
                      Object.defineProperty(e, 'prototype', { writable: !1 }),
                      t
                    );
                  })();
                e.default = s;
              },
              './src/controller/cmcd-controller.ts': function(t, e, r) {
                function n(t, e) {
                  for (var r = 0; r < e.length; r++) {
                    var n = e[r];
                    (n.enumerable = n.enumerable || !1),
                      (n.configurable = !0),
                      'value' in n && (n.writable = !0),
                      Object.defineProperty(t, n.key, n);
                  }
                }
                function i(t, e, r) {
                  return (
                    e && n(t.prototype, e),
                    r && n(t, r),
                    Object.defineProperty(t, 'prototype', { writable: !1 }),
                    t
                  );
                }
                function s(t, e) {
                  var r =
                    ('undefined' != typeof Symbol && t[Symbol.iterator]) ||
                    t['@@iterator'];
                  if (r) return (r = r.call(t)).next.bind(r);
                  if (
                    Array.isArray(t) ||
                    (r = (function(t, e) {
                      if (t) {
                        if ('string' == typeof t) return a(t, void 0);
                        var r = Object.prototype.toString.call(t).slice(8, -1);
                        return (
                          'Object' === r &&
                            t.constructor &&
                            (r = t.constructor.name),
                          'Map' === r || 'Set' === r
                            ? Array.from(t)
                            : 'Arguments' === r ||
                              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                            ? a(t, void 0)
                            : void 0
                        );
                      }
                    })(t)) ||
                    (e && t && 'number' == typeof t.length)
                  ) {
                    r && (t = r);
                    var n = 0;
                    return function() {
                      return n >= t.length
                        ? { done: !0 }
                        : { done: !1, value: t[n++] };
                    };
                  }
                  throw new TypeError(
                    'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
                  );
                }
                function a(t, e) {
                  (null == e || e > t.length) && (e = t.length);
                  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
                  return n;
                }
                function o() {
                  return (o = Object.assign
                    ? Object.assign.bind()
                    : function(t) {
                        for (var e = 1; e < arguments.length; e++) {
                          var r = arguments[e];
                          for (var n in r)
                            Object.prototype.hasOwnProperty.call(r, n) &&
                              (t[n] = r[n]);
                        }
                        return t;
                      }).apply(this, arguments);
                }
                r.r(e),
                  r.d(e, 'default', function() {
                    return d;
                  });
                var u = r('./src/events.ts'),
                  l = r('./src/types/cmcd.ts'),
                  c = r('./src/utils/buffer-helper.ts'),
                  h = r('./src/utils/logger.ts'),
                  d = (function() {
                    function t(e) {
                      var r = this;
                      (this.hls = void 0),
                        (this.config = void 0),
                        (this.media = void 0),
                        (this.sid = void 0),
                        (this.cid = void 0),
                        (this.useHeaders = !1),
                        (this.initialized = !1),
                        (this.starved = !1),
                        (this.buffering = !0),
                        (this.audioBuffer = void 0),
                        (this.videoBuffer = void 0),
                        (this.onWaiting = function() {
                          r.initialized && (r.starved = !0), (r.buffering = !0);
                        }),
                        (this.onPlaying = function() {
                          r.initialized || (r.initialized = !0),
                            (r.buffering = !1);
                        }),
                        (this.applyPlaylistData = function(t) {
                          try {
                            r.apply(t, {
                              ot: l.CMCDObjectType.MANIFEST,
                              su: !r.initialized,
                            });
                          } catch (t) {
                            h.logger.warn(
                              'Could not generate manifest CMCD data.',
                              t,
                            );
                          }
                        }),
                        (this.applyFragmentData = function(t) {
                          try {
                            var e = t.frag,
                              n = r.hls.levels[e.level],
                              i = r.getObjectType(e),
                              s = { d: 1e3 * e.duration, ot: i };
                            (i !== l.CMCDObjectType.VIDEO &&
                              i !== l.CMCDObjectType.AUDIO &&
                              i != l.CMCDObjectType.MUXED) ||
                              ((s.br = n.bitrate / 1e3),
                              (s.tb = r.getTopBandwidth(i) / 1e3),
                              (s.bl = r.getBufferLength(i))),
                              r.apply(t, s);
                          } catch (t) {
                            h.logger.warn(
                              'Could not generate segment CMCD data.',
                              t,
                            );
                          }
                        }),
                        (this.hls = e);
                      var n = (this.config = e.config),
                        i = n.cmcd;
                      null != i &&
                        ((n.pLoader = this.createPlaylistLoader()),
                        (n.fLoader = this.createFragmentLoader()),
                        (this.sid = i.sessionId || t.uuid()),
                        (this.cid = i.contentId),
                        (this.useHeaders = !0 === i.useHeaders),
                        this.registerListeners());
                    }
                    var e = t.prototype;
                    return (
                      (e.registerListeners = function() {
                        var t = this.hls;
                        t.on(
                          u.Events.MEDIA_ATTACHED,
                          this.onMediaAttached,
                          this,
                        ),
                          t.on(
                            u.Events.MEDIA_DETACHED,
                            this.onMediaDetached,
                            this,
                          ),
                          t.on(
                            u.Events.BUFFER_CREATED,
                            this.onBufferCreated,
                            this,
                          );
                      }),
                      (e.unregisterListeners = function() {
                        var t = this.hls;
                        t.off(
                          u.Events.MEDIA_ATTACHED,
                          this.onMediaAttached,
                          this,
                        ),
                          t.off(
                            u.Events.MEDIA_DETACHED,
                            this.onMediaDetached,
                            this,
                          ),
                          t.off(
                            u.Events.BUFFER_CREATED,
                            this.onBufferCreated,
                            this,
                          ),
                          this.onMediaDetached();
                      }),
                      (e.destroy = function() {
                        this.unregisterListeners(),
                          (this.hls = this.config = this.audioBuffer = this.videoBuffer = null);
                      }),
                      (e.onMediaAttached = function(t, e) {
                        (this.media = e.media),
                          this.media.addEventListener(
                            'waiting',
                            this.onWaiting,
                          ),
                          this.media.addEventListener(
                            'playing',
                            this.onPlaying,
                          );
                      }),
                      (e.onMediaDetached = function() {
                        this.media &&
                          (this.media.removeEventListener(
                            'waiting',
                            this.onWaiting,
                          ),
                          this.media.removeEventListener(
                            'playing',
                            this.onPlaying,
                          ),
                          (this.media = null));
                      }),
                      (e.onBufferCreated = function(t, e) {
                        var r, n;
                        (this.audioBuffer =
                          null === (r = e.tracks.audio) || void 0 === r
                            ? void 0
                            : r.buffer),
                          (this.videoBuffer =
                            null === (n = e.tracks.video) || void 0 === n
                              ? void 0
                              : n.buffer);
                      }),
                      (e.createData = function() {
                        var t;
                        return {
                          v: l.CMCDVersion,
                          sf: l.CMCDStreamingFormat.HLS,
                          sid: this.sid,
                          cid: this.cid,
                          pr:
                            null === (t = this.media) || void 0 === t
                              ? void 0
                              : t.playbackRate,
                          mtp: this.hls.bandwidthEstimate / 1e3,
                        };
                      }),
                      (e.apply = function(e, r) {
                        void 0 === r && (r = {}), o(r, this.createData());
                        var n =
                          r.ot === l.CMCDObjectType.INIT ||
                          r.ot === l.CMCDObjectType.VIDEO ||
                          r.ot === l.CMCDObjectType.MUXED;
                        if (
                          (this.starved &&
                            n &&
                            ((r.bs = !0), (r.su = !0), (this.starved = !1)),
                          null == r.su && (r.su = this.buffering),
                          this.useHeaders)
                        ) {
                          var i = t.toHeaders(r);
                          if (!Object.keys(i).length) return;
                          e.headers || (e.headers = {}), o(e.headers, i);
                        } else {
                          var s = t.toQuery(r);
                          if (!s) return;
                          e.url = t.appendQueryToUri(e.url, s);
                        }
                      }),
                      (e.getObjectType = function(t) {
                        var e = t.type;
                        return 'subtitle' === e
                          ? l.CMCDObjectType.TIMED_TEXT
                          : 'initSegment' === t.sn
                          ? l.CMCDObjectType.INIT
                          : 'audio' === e
                          ? l.CMCDObjectType.AUDIO
                          : 'main' === e
                          ? this.hls.audioTracks.length
                            ? l.CMCDObjectType.VIDEO
                            : l.CMCDObjectType.MUXED
                          : void 0;
                      }),
                      (e.getTopBandwidth = function(t) {
                        var e,
                          r = 0,
                          n = this.hls;
                        if (t === l.CMCDObjectType.AUDIO) e = n.audioTracks;
                        else {
                          var i = n.maxAutoLevel,
                            a = i > -1 ? i + 1 : n.levels.length;
                          e = n.levels.slice(0, a);
                        }
                        for (var o, u = s(e); !(o = u()).done; ) {
                          var c = o.value;
                          c.bitrate > r && (r = c.bitrate);
                        }
                        return r > 0 ? r : NaN;
                      }),
                      (e.getBufferLength = function(t) {
                        var e = this.hls.media,
                          r =
                            t === l.CMCDObjectType.AUDIO
                              ? this.audioBuffer
                              : this.videoBuffer;
                        return r && e
                          ? 1e3 *
                              c.BufferHelper.bufferInfo(
                                r,
                                e.currentTime,
                                this.config.maxBufferHole,
                              ).len
                          : NaN;
                      }),
                      (e.createPlaylistLoader = function() {
                        var t = this.config.pLoader,
                          e = this.applyPlaylistData,
                          r = t || this.config.loader;
                        return (function() {
                          function t(t) {
                            (this.loader = void 0), (this.loader = new r(t));
                          }
                          var n = t.prototype;
                          return (
                            (n.destroy = function() {
                              this.loader.destroy();
                            }),
                            (n.abort = function() {
                              this.loader.abort();
                            }),
                            (n.load = function(t, r, n) {
                              e(t), this.loader.load(t, r, n);
                            }),
                            i(t, [
                              {
                                key: 'stats',
                                get: function() {
                                  return this.loader.stats;
                                },
                              },
                              {
                                key: 'context',
                                get: function() {
                                  return this.loader.context;
                                },
                              },
                            ]),
                            t
                          );
                        })();
                      }),
                      (e.createFragmentLoader = function() {
                        var t = this.config.fLoader,
                          e = this.applyFragmentData,
                          r = t || this.config.loader;
                        return (function() {
                          function t(t) {
                            (this.loader = void 0), (this.loader = new r(t));
                          }
                          var n = t.prototype;
                          return (
                            (n.destroy = function() {
                              this.loader.destroy();
                            }),
                            (n.abort = function() {
                              this.loader.abort();
                            }),
                            (n.load = function(t, r, n) {
                              e(t), this.loader.load(t, r, n);
                            }),
                            i(t, [
                              {
                                key: 'stats',
                                get: function() {
                                  return this.loader.stats;
                                },
                              },
                              {
                                key: 'context',
                                get: function() {
                                  return this.loader.context;
                                },
                              },
                            ]),
                            t
                          );
                        })();
                      }),
                      (t.uuid = function() {
                        var t = URL.createObjectURL(new Blob()),
                          e = t.toString();
                        return (
                          URL.revokeObjectURL(t),
                          e.slice(e.lastIndexOf('/') + 1)
                        );
                      }),
                      (t.serialize = function(t) {
                        for (
                          var e,
                            r = [],
                            n = function(t) {
                              return (
                                !Number.isNaN(t) &&
                                null != t &&
                                '' !== t &&
                                !1 !== t
                              );
                            },
                            i = function(t) {
                              return Math.round(t);
                            },
                            a = function(t) {
                              return 100 * i(t / 100);
                            },
                            o = {
                              br: i,
                              d: i,
                              bl: a,
                              dl: a,
                              mtp: a,
                              nor: function(t) {
                                return encodeURIComponent(t);
                              },
                              rtp: a,
                              tb: i,
                            },
                            u = s(Object.keys(t || {}).sort());
                          !(e = u()).done;

                        ) {
                          var l = e.value,
                            c = t[l];
                          if (
                            n(c) &&
                            !(('v' === l && 1 === c) || ('pr' == l && 1 === c))
                          ) {
                            var h = o[l];
                            h && (c = h(c));
                            var d,
                              f = typeof c;
                            (d =
                              'ot' === l || 'sf' === l || 'st' === l
                                ? l + '=' + c
                                : 'boolean' === f
                                ? l
                                : 'number' === f
                                ? l + '=' + c
                                : l + '=' + JSON.stringify(c)),
                              r.push(d);
                          }
                        }
                        return r.join(',');
                      }),
                      (t.toHeaders = function(e) {
                        for (
                          var r = {},
                            n = ['Object', 'Request', 'Session', 'Status'],
                            i = [{}, {}, {}, {}],
                            s = {
                              br: 0,
                              d: 0,
                              ot: 0,
                              tb: 0,
                              bl: 1,
                              dl: 1,
                              mtp: 1,
                              nor: 1,
                              nrr: 1,
                              su: 1,
                              cid: 2,
                              pr: 2,
                              sf: 2,
                              sid: 2,
                              st: 2,
                              v: 2,
                              bs: 3,
                              rtp: 3,
                            },
                            a = 0,
                            o = Object.keys(e);
                          a < o.length;
                          a++
                        ) {
                          var u = o[a];
                          i[null != s[u] ? s[u] : 1][u] = e[u];
                        }
                        for (var l = 0; l < i.length; l++) {
                          var c = t.serialize(i[l]);
                          c && (r['CMCD-' + n[l]] = c);
                        }
                        return r;
                      }),
                      (t.toQuery = function(e) {
                        return 'CMCD=' + encodeURIComponent(t.serialize(e));
                      }),
                      (t.appendQueryToUri = function(t, e) {
                        if (!e) return t;
                        var r = t.includes('?') ? '&' : '?';
                        return '' + t + r + e;
                      }),
                      t
                    );
                  })();
              },
              './src/controller/eme-controller.ts': function(t, e, r) {
                function n(t, e) {
                  for (var r = 0; r < e.length; r++) {
                    var n = e[r];
                    (n.enumerable = n.enumerable || !1),
                      (n.configurable = !0),
                      'value' in n && (n.writable = !0),
                      Object.defineProperty(t, n.key, n);
                  }
                }
                r.r(e);
                var i = r('./src/events.ts'),
                  s = r('./src/errors.ts'),
                  a = r('./src/utils/logger.ts'),
                  o = r('./src/utils/mediakeys-helper.ts'),
                  u = (function() {
                    function t(t) {
                      (this.hls = void 0),
                        (this._widevineLicenseUrl = void 0),
                        (this._licenseXhrSetup = void 0),
                        (this._licenseResponseCallback = void 0),
                        (this._emeEnabled = void 0),
                        (this._requestMediaKeySystemAccess = void 0),
                        (this._drmSystemOptions = void 0),
                        (this._config = void 0),
                        (this._mediaKeysList = []),
                        (this._media = null),
                        (this._hasSetMediaKeys = !1),
                        (this._requestLicenseFailureCount = 0),
                        (this.mediaKeysPromise = null),
                        (this._onMediaEncrypted = this.onMediaEncrypted.bind(
                          this,
                        )),
                        (this.hls = t),
                        (this._config = t.config),
                        (this._widevineLicenseUrl = this._config.widevineLicenseUrl),
                        (this._licenseXhrSetup = this._config.licenseXhrSetup),
                        (this._licenseResponseCallback = this._config.licenseResponseCallback),
                        (this._emeEnabled = this._config.emeEnabled),
                        (this._requestMediaKeySystemAccess = this._config.requestMediaKeySystemAccessFunc),
                        (this._drmSystemOptions = this._config.drmSystemOptions),
                        this._registerListeners();
                    }
                    var e,
                      r,
                      u = t.prototype;
                    return (
                      (u.destroy = function() {
                        this._unregisterListeners(),
                          (this.hls = this._onMediaEncrypted = null),
                          (this._requestMediaKeySystemAccess = null);
                      }),
                      (u._registerListeners = function() {
                        this.hls.on(
                          i.Events.MEDIA_ATTACHED,
                          this.onMediaAttached,
                          this,
                        ),
                          this.hls.on(
                            i.Events.MEDIA_DETACHED,
                            this.onMediaDetached,
                            this,
                          ),
                          this.hls.on(
                            i.Events.MANIFEST_PARSED,
                            this.onManifestParsed,
                            this,
                          );
                      }),
                      (u._unregisterListeners = function() {
                        this.hls.off(
                          i.Events.MEDIA_ATTACHED,
                          this.onMediaAttached,
                          this,
                        ),
                          this.hls.off(
                            i.Events.MEDIA_DETACHED,
                            this.onMediaDetached,
                            this,
                          ),
                          this.hls.off(
                            i.Events.MANIFEST_PARSED,
                            this.onManifestParsed,
                            this,
                          );
                      }),
                      (u.getLicenseServerUrl = function(t) {
                        switch (t) {
                          case o.KeySystems.WIDEVINE:
                            if (!this._widevineLicenseUrl) break;
                            return this._widevineLicenseUrl;
                        }
                        throw new Error(
                          'no license server URL configured for key-system "' +
                            t +
                            '"',
                        );
                      }),
                      (u._attemptKeySystemAccess = function(t, e, r) {
                        var n = this,
                          i = (function(t, e, r, n) {
                            switch (t) {
                              case o.KeySystems.WIDEVINE:
                                return (function(t, e, r) {
                                  var n = {
                                    audioCapabilities: [],
                                    videoCapabilities: [],
                                  };
                                  return (
                                    t.forEach(function(t) {
                                      n.audioCapabilities.push({
                                        contentType:
                                          'audio/mp4; codecs="' + t + '"',
                                        robustness: r.audioRobustness || '',
                                      });
                                    }),
                                    e.forEach(function(t) {
                                      n.videoCapabilities.push({
                                        contentType:
                                          'video/mp4; codecs="' + t + '"',
                                        robustness: r.videoRobustness || '',
                                      });
                                    }),
                                    [n]
                                  );
                                })(e, r, n);
                              default:
                                throw new Error('Unknown key-system: ' + t);
                            }
                          })(t, e, r, this._drmSystemOptions);
                        a.logger.log(
                          'Requesting encrypted media key-system access',
                        );
                        var s = this.requestMediaKeySystemAccess(t, i);
                        (this.mediaKeysPromise = s.then(function(e) {
                          return n._onMediaKeySystemAccessObtained(t, e);
                        })),
                          s.catch(function(e) {
                            a.logger.error(
                              'Failed to obtain key-system "' + t + '" access:',
                              e,
                            );
                          });
                      }),
                      (u._onMediaKeySystemAccessObtained = function(t, e) {
                        var r = this;
                        a.logger.log(
                          'Access for key-system "' + t + '" obtained',
                        );
                        var n = {
                          mediaKeysSessionInitialized: !1,
                          mediaKeySystemAccess: e,
                          mediaKeySystemDomain: t,
                        };
                        this._mediaKeysList.push(n);
                        var i = Promise.resolve()
                          .then(function() {
                            return e.createMediaKeys();
                          })
                          .then(function(e) {
                            return (
                              (n.mediaKeys = e),
                              a.logger.log(
                                'Media-keys created for key-system "' + t + '"',
                              ),
                              r._onMediaKeysCreated(),
                              e
                            );
                          });
                        return (
                          i.catch(function(t) {
                            a.logger.error('Failed to create media-keys:', t);
                          }),
                          i
                        );
                      }),
                      (u._onMediaKeysCreated = function() {
                        var t = this;
                        this._mediaKeysList.forEach(function(e) {
                          e.mediaKeysSession ||
                            ((e.mediaKeysSession = e.mediaKeys.createSession()),
                            t._onNewMediaKeySession(e.mediaKeysSession));
                        });
                      }),
                      (u._onNewMediaKeySession = function(t) {
                        var e = this;
                        a.logger.log('New key-system session ' + t.sessionId),
                          t.addEventListener(
                            'message',
                            function(r) {
                              e._onKeySessionMessage(t, r.message);
                            },
                            !1,
                          );
                      }),
                      (u._onKeySessionMessage = function(t, e) {
                        a.logger.log(
                          'Got EME message event, creating license request',
                        ),
                          this._requestLicense(e, function(e) {
                            a.logger.log(
                              'Received license data (length: ' +
                                (e ? e.byteLength : e) +
                                '), updating key-session',
                            ),
                              t.update(e).catch(function(t) {
                                a.logger.warn(
                                  'Updating key-session failed: ' + t,
                                );
                              });
                          });
                      }),
                      (u.onMediaEncrypted = function(t) {
                        var e = this;
                        if (
                          (a.logger.log(
                            'Media is encrypted using "' +
                              t.initDataType +
                              '" init data type',
                          ),
                          !this.mediaKeysPromise)
                        )
                          return (
                            a.logger.error(
                              'Fatal: Media is encrypted but no CDM access or no keys have been requested',
                            ),
                            void this.hls.trigger(i.Events.ERROR, {
                              type: s.ErrorTypes.KEY_SYSTEM_ERROR,
                              details: s.ErrorDetails.KEY_SYSTEM_NO_KEYS,
                              fatal: !0,
                            })
                          );
                        var r = function(r) {
                          e._media &&
                            (e._attemptSetMediaKeys(r),
                            e._generateRequestWithPreferredKeySession(
                              t.initDataType,
                              t.initData,
                            ));
                        };
                        this.mediaKeysPromise.then(r).catch(r);
                      }),
                      (u._attemptSetMediaKeys = function(t) {
                        if (!this._media)
                          throw new Error(
                            'Attempted to set mediaKeys without first attaching a media element',
                          );
                        if (!this._hasSetMediaKeys) {
                          var e = this._mediaKeysList[0];
                          if (!e || !e.mediaKeys)
                            return (
                              a.logger.error(
                                'Fatal: Media is encrypted but no CDM access or no keys have been obtained yet',
                              ),
                              void this.hls.trigger(i.Events.ERROR, {
                                type: s.ErrorTypes.KEY_SYSTEM_ERROR,
                                details: s.ErrorDetails.KEY_SYSTEM_NO_KEYS,
                                fatal: !0,
                              })
                            );
                          a.logger.log('Setting keys for encrypted media'),
                            this._media.setMediaKeys(e.mediaKeys),
                            (this._hasSetMediaKeys = !0);
                        }
                      }),
                      (u._generateRequestWithPreferredKeySession = function(
                        t,
                        e,
                      ) {
                        var r = this,
                          n = this._mediaKeysList[0];
                        if (!n)
                          return (
                            a.logger.error(
                              'Fatal: Media is encrypted but not any key-system access has been obtained yet',
                            ),
                            void this.hls.trigger(i.Events.ERROR, {
                              type: s.ErrorTypes.KEY_SYSTEM_ERROR,
                              details: s.ErrorDetails.KEY_SYSTEM_NO_ACCESS,
                              fatal: !0,
                            })
                          );
                        if (n.mediaKeysSessionInitialized)
                          a.logger.warn(
                            'Key-Session already initialized but requested again',
                          );
                        else {
                          var o = n.mediaKeysSession;
                          if (!o)
                            return (
                              a.logger.error(
                                'Fatal: Media is encrypted but no key-session existing',
                              ),
                              void this.hls.trigger(i.Events.ERROR, {
                                type: s.ErrorTypes.KEY_SYSTEM_ERROR,
                                details: s.ErrorDetails.KEY_SYSTEM_NO_SESSION,
                                fatal: !0,
                              })
                            );
                          if (!e)
                            return (
                              a.logger.warn(
                                'Fatal: initData required for generating a key session is null',
                              ),
                              void this.hls.trigger(i.Events.ERROR, {
                                type: s.ErrorTypes.KEY_SYSTEM_ERROR,
                                details: s.ErrorDetails.KEY_SYSTEM_NO_INIT_DATA,
                                fatal: !0,
                              })
                            );
                          a.logger.log(
                            'Generating key-session request for "' +
                              t +
                              '" init data type',
                          ),
                            (n.mediaKeysSessionInitialized = !0),
                            o
                              .generateRequest(t, e)
                              .then(function() {
                                a.logger.debug(
                                  'Key-session generation succeeded',
                                );
                              })
                              .catch(function(t) {
                                a.logger.error(
                                  'Error generating key-session request:',
                                  t,
                                ),
                                  r.hls.trigger(i.Events.ERROR, {
                                    type: s.ErrorTypes.KEY_SYSTEM_ERROR,
                                    details:
                                      s.ErrorDetails.KEY_SYSTEM_NO_SESSION,
                                    fatal: !1,
                                  });
                              });
                        }
                      }),
                      (u._createLicenseXhr = function(t, e, r) {
                        var n = new XMLHttpRequest();
                        (n.responseType = 'arraybuffer'),
                          (n.onreadystatechange = this._onLicenseRequestReadyStageChange.bind(
                            this,
                            n,
                            t,
                            e,
                            r,
                          ));
                        var i = this._licenseXhrSetup;
                        if (i)
                          try {
                            i.call(this.hls, n, t), (i = void 0);
                          } catch (t) {
                            a.logger.error(t);
                          }
                        try {
                          n.readyState || n.open('POST', t, !0),
                            i && i.call(this.hls, n, t);
                        } catch (t) {
                          throw new Error(
                            'issue setting up KeySystem license XHR ' + t,
                          );
                        }
                        return n;
                      }),
                      (u._onLicenseRequestReadyStageChange = function(
                        t,
                        e,
                        r,
                        n,
                      ) {
                        switch (t.readyState) {
                          case 4:
                            if (200 === t.status) {
                              (this._requestLicenseFailureCount = 0),
                                a.logger.log('License request succeeded');
                              var o = t.response,
                                u = this._licenseResponseCallback;
                              if (u)
                                try {
                                  o = u.call(this.hls, t, e);
                                } catch (t) {
                                  a.logger.error(t);
                                }
                              n(o);
                            } else {
                              if (
                                (a.logger.error(
                                  'License Request XHR failed (' +
                                    e +
                                    '). Status: ' +
                                    t.status +
                                    ' (' +
                                    t.statusText +
                                    ')',
                                ),
                                this._requestLicenseFailureCount++,
                                this._requestLicenseFailureCount > 3)
                              )
                                return void this.hls.trigger(i.Events.ERROR, {
                                  type: s.ErrorTypes.KEY_SYSTEM_ERROR,
                                  details:
                                    s.ErrorDetails
                                      .KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                                  fatal: !0,
                                });
                              var l = 3 - this._requestLicenseFailureCount + 1;
                              a.logger.warn(
                                'Retrying license request, ' +
                                  l +
                                  ' attempts left',
                              ),
                                this._requestLicense(r, n);
                            }
                        }
                      }),
                      (u._generateLicenseRequestChallenge = function(t, e) {
                        switch (t.mediaKeySystemDomain) {
                          case o.KeySystems.WIDEVINE:
                            return e;
                        }
                        throw new Error(
                          'unsupported key-system: ' + t.mediaKeySystemDomain,
                        );
                      }),
                      (u._requestLicense = function(t, e) {
                        a.logger.log(
                          'Requesting content license for key-system',
                        );
                        var r = this._mediaKeysList[0];
                        if (!r)
                          return (
                            a.logger.error(
                              'Fatal error: Media is encrypted but no key-system access has been obtained yet',
                            ),
                            void this.hls.trigger(i.Events.ERROR, {
                              type: s.ErrorTypes.KEY_SYSTEM_ERROR,
                              details: s.ErrorDetails.KEY_SYSTEM_NO_ACCESS,
                              fatal: !0,
                            })
                          );
                        try {
                          var n = this.getLicenseServerUrl(
                              r.mediaKeySystemDomain,
                            ),
                            o = this._createLicenseXhr(n, t, e);
                          a.logger.log('Sending license request to URL: ' + n);
                          var u = this._generateLicenseRequestChallenge(r, t);
                          o.send(u);
                        } catch (t) {
                          a.logger.error(
                            'Failure requesting DRM license: ' + t,
                          ),
                            this.hls.trigger(i.Events.ERROR, {
                              type: s.ErrorTypes.KEY_SYSTEM_ERROR,
                              details:
                                s.ErrorDetails
                                  .KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                              fatal: !0,
                            });
                        }
                      }),
                      (u.onMediaAttached = function(t, e) {
                        if (this._emeEnabled) {
                          var r = e.media;
                          (this._media = r),
                            r.addEventListener(
                              'encrypted',
                              this._onMediaEncrypted,
                            );
                        }
                      }),
                      (u.onMediaDetached = function() {
                        var t = this._media,
                          e = this._mediaKeysList;
                        t &&
                          (t.removeEventListener(
                            'encrypted',
                            this._onMediaEncrypted,
                          ),
                          (this._media = null),
                          (this._mediaKeysList = []),
                          Promise.all(
                            e.map(function(t) {
                              if (t.mediaKeysSession)
                                return t.mediaKeysSession
                                  .close()
                                  .catch(function() {});
                            }),
                          )
                            .then(function() {
                              return t.setMediaKeys(null);
                            })
                            .catch(function() {}));
                      }),
                      (u.onManifestParsed = function(t, e) {
                        if (this._emeEnabled) {
                          var r = e.levels
                              .map(function(t) {
                                return t.audioCodec;
                              })
                              .filter(function(t) {
                                return !!t;
                              }),
                            n = e.levels
                              .map(function(t) {
                                return t.videoCodec;
                              })
                              .filter(function(t) {
                                return !!t;
                              });
                          this._attemptKeySystemAccess(
                            o.KeySystems.WIDEVINE,
                            r,
                            n,
                          );
                        }
                      }),
                      (e = t),
                      (r = [
                        {
                          key: 'requestMediaKeySystemAccess',
                          get: function() {
                            if (!this._requestMediaKeySystemAccess)
                              throw new Error(
                                'No requestMediaKeySystemAccess function configured',
                              );
                            return this._requestMediaKeySystemAccess;
                          },
                        },
                      ]) && n(e.prototype, r),
                      Object.defineProperty(e, 'prototype', { writable: !1 }),
                      t
                    );
                  })();
                e.default = u;
              },
              './src/controller/fps-controller.ts': function(t, e, r) {
                r.r(e);
                var n = r('./src/events.ts'),
                  i = r('./src/utils/logger.ts'),
                  s = (function() {
                    function t(t) {
                      (this.hls = void 0),
                        (this.isVideoPlaybackQualityAvailable = !1),
                        (this.timer = void 0),
                        (this.media = null),
                        (this.lastTime = void 0),
                        (this.lastDroppedFrames = 0),
                        (this.lastDecodedFrames = 0),
                        (this.streamController = void 0),
                        (this.hls = t),
                        this.registerListeners();
                    }
                    var e = t.prototype;
                    return (
                      (e.setStreamController = function(t) {
                        this.streamController = t;
                      }),
                      (e.registerListeners = function() {
                        this.hls.on(
                          n.Events.MEDIA_ATTACHING,
                          this.onMediaAttaching,
                          this,
                        );
                      }),
                      (e.unregisterListeners = function() {
                        this.hls.off(
                          n.Events.MEDIA_ATTACHING,
                          this.onMediaAttaching,
                        );
                      }),
                      (e.destroy = function() {
                        this.timer && clearInterval(this.timer),
                          this.unregisterListeners(),
                          (this.isVideoPlaybackQualityAvailable = !1),
                          (this.media = null);
                      }),
                      (e.onMediaAttaching = function(t, e) {
                        var r = this.hls.config;
                        if (r.capLevelOnFPSDrop) {
                          var n =
                            e.media instanceof self.HTMLVideoElement
                              ? e.media
                              : null;
                          (this.media = n),
                            n &&
                              'function' == typeof n.getVideoPlaybackQuality &&
                              (this.isVideoPlaybackQualityAvailable = !0),
                            self.clearInterval(this.timer),
                            (this.timer = self.setInterval(
                              this.checkFPSInterval.bind(this),
                              r.fpsDroppedMonitoringPeriod,
                            ));
                        }
                      }),
                      (e.checkFPS = function(t, e, r) {
                        var s = performance.now();
                        if (e) {
                          if (this.lastTime) {
                            var a = s - this.lastTime,
                              o = r - this.lastDroppedFrames,
                              u = e - this.lastDecodedFrames,
                              l = (1e3 * o) / a,
                              c = this.hls;
                            if (
                              (c.trigger(n.Events.FPS_DROP, {
                                currentDropped: o,
                                currentDecoded: u,
                                totalDroppedFrames: r,
                              }),
                              l > 0 &&
                                o > c.config.fpsDroppedMonitoringThreshold * u)
                            ) {
                              var h = c.currentLevel;
                              i.logger.warn(
                                'drop FPS ratio greater than max allowed value for currentLevel: ' +
                                  h,
                              ),
                                h > 0 &&
                                  (-1 === c.autoLevelCapping ||
                                    c.autoLevelCapping >= h) &&
                                  ((h -= 1),
                                  c.trigger(n.Events.FPS_DROP_LEVEL_CAPPING, {
                                    level: h,
                                    droppedLevel: c.currentLevel,
                                  }),
                                  (c.autoLevelCapping = h),
                                  this.streamController.nextLevelSwitch());
                            }
                          }
                          (this.lastTime = s),
                            (this.lastDroppedFrames = r),
                            (this.lastDecodedFrames = e);
                        }
                      }),
                      (e.checkFPSInterval = function() {
                        var t = this.media;
                        if (t)
                          if (this.isVideoPlaybackQualityAvailable) {
                            var e = t.getVideoPlaybackQuality();
                            this.checkFPS(
                              t,
                              e.totalVideoFrames,
                              e.droppedVideoFrames,
                            );
                          } else
                            this.checkFPS(
                              t,
                              t.webkitDecodedFrameCount,
                              t.webkitDroppedFrameCount,
                            );
                      }),
                      t
                    );
                  })();
                e.default = s;
              },
              './src/controller/fragment-finders.ts': function(t, e, r) {
                function n(t, e, r) {
                  if (
                    null === e ||
                    !Array.isArray(t) ||
                    !t.length ||
                    !Object(u.isFiniteNumber)(e)
                  )
                    return null;
                  if (e < (t[0].programDateTime || 0)) return null;
                  if (e >= (t[t.length - 1].endProgramDateTime || 0))
                    return null;
                  r = r || 0;
                  for (var n = 0; n < t.length; ++n) {
                    var i = t[n];
                    if (a(e, r, i)) return i;
                  }
                  return null;
                }
                function i(t, e, r, n) {
                  void 0 === r && (r = 0), void 0 === n && (n = 0);
                  var i = null;
                  return (
                    t
                      ? (i = e[t.sn - e[0].sn + 1] || null)
                      : 0 === r && 0 === e[0].start && (i = e[0]),
                    i && 0 === s(r, n, i)
                      ? i
                      : l.default.search(e, s.bind(null, r, n)) || i
                  );
                }
                function s(t, e, r) {
                  void 0 === t && (t = 0), void 0 === e && (e = 0);
                  var n = Math.min(
                    e,
                    r.duration + (r.deltaPTS ? r.deltaPTS : 0),
                  );
                  return r.start + r.duration - n <= t
                    ? 1
                    : r.start - n > t && r.start
                    ? -1
                    : 0;
                }
                function a(t, e, r) {
                  var n =
                    1e3 *
                    Math.min(e, r.duration + (r.deltaPTS ? r.deltaPTS : 0));
                  return (r.endProgramDateTime || 0) - n > t;
                }
                function o(t, e) {
                  return l.default.search(t, function(t) {
                    return t.cc < e ? 1 : t.cc > e ? -1 : 0;
                  });
                }
                r.r(e),
                  r.d(e, 'findFragmentByPDT', function() {
                    return n;
                  }),
                  r.d(e, 'findFragmentByPTS', function() {
                    return i;
                  }),
                  r.d(e, 'fragmentWithinToleranceTest', function() {
                    return s;
                  }),
                  r.d(e, 'pdtWithinToleranceTest', function() {
                    return a;
                  }),
                  r.d(e, 'findFragWithCC', function() {
                    return o;
                  });
                var u = r('./src/polyfills/number.ts'),
                  l = r('./src/utils/binary-search.ts');
              },
              './src/controller/fragment-tracker.ts': function(t, e, r) {
                function n(t) {
                  var e, r;
                  return (
                    t.buffered &&
                    ((null === (e = t.range.video) || void 0 === e
                      ? void 0
                      : e.partial) ||
                      (null === (r = t.range.audio) || void 0 === r
                        ? void 0
                        : r.partial))
                  );
                }
                function i(t) {
                  return t.type + '_' + t.level + '_' + t.urlId + '_' + t.sn;
                }
                r.r(e),
                  r.d(e, 'FragmentState', function() {
                    return s;
                  }),
                  r.d(e, 'FragmentTracker', function() {
                    return u;
                  });
                var s,
                  a = r('./src/events.ts'),
                  o = r('./src/types/loader.ts');
                !(function(t) {
                  (t.NOT_LOADED = 'NOT_LOADED'),
                    (t.APPENDING = 'APPENDING'),
                    (t.PARTIAL = 'PARTIAL'),
                    (t.OK = 'OK');
                })(s || (s = {}));
                var u = (function() {
                  function t(t) {
                    (this.activeFragment = null),
                      (this.activeParts = null),
                      (this.fragments = Object.create(null)),
                      (this.timeRanges = Object.create(null)),
                      (this.bufferPadding = 0.2),
                      (this.hls = void 0),
                      (this.hls = t),
                      this._registerListeners();
                  }
                  var e = t.prototype;
                  return (
                    (e._registerListeners = function() {
                      var t = this.hls;
                      t.on(
                        a.Events.BUFFER_APPENDED,
                        this.onBufferAppended,
                        this,
                      ),
                        t.on(a.Events.FRAG_BUFFERED, this.onFragBuffered, this),
                        t.on(a.Events.FRAG_LOADED, this.onFragLoaded, this);
                    }),
                    (e._unregisterListeners = function() {
                      var t = this.hls;
                      t.off(
                        a.Events.BUFFER_APPENDED,
                        this.onBufferAppended,
                        this,
                      ),
                        t.off(
                          a.Events.FRAG_BUFFERED,
                          this.onFragBuffered,
                          this,
                        ),
                        t.off(a.Events.FRAG_LOADED, this.onFragLoaded, this);
                    }),
                    (e.destroy = function() {
                      this._unregisterListeners(),
                        (this.fragments = this.timeRanges = null);
                    }),
                    (e.getAppendedFrag = function(t, e) {
                      if (e === o.PlaylistLevelType.MAIN) {
                        var r = this.activeFragment,
                          n = this.activeParts;
                        if (!r) return null;
                        if (n)
                          for (var i = n.length; i--; ) {
                            var s = n[i],
                              a = s ? s.end : r.appendedPTS;
                            if (s.start <= t && void 0 !== a && t <= a)
                              return (
                                i > 9 && (this.activeParts = n.slice(i - 9)), s
                              );
                          }
                        else if (
                          r.start <= t &&
                          void 0 !== r.appendedPTS &&
                          t <= r.appendedPTS
                        )
                          return r;
                      }
                      return this.getBufferedFrag(t, e);
                    }),
                    (e.getBufferedFrag = function(t, e) {
                      for (
                        var r = this.fragments,
                          n = Object.keys(r),
                          i = n.length;
                        i--;

                      ) {
                        var s = r[n[i]];
                        if (
                          (null == s ? void 0 : s.body.type) === e &&
                          s.buffered
                        ) {
                          var a = s.body;
                          if (a.start <= t && t <= a.end) return a;
                        }
                      }
                      return null;
                    }),
                    (e.detectEvictedFragments = function(t, e, r) {
                      var n = this;
                      Object.keys(this.fragments).forEach(function(i) {
                        var s = n.fragments[i];
                        if (s)
                          if (s.buffered) {
                            var a = s.range[t];
                            a &&
                              a.time.some(function(t) {
                                var r = !n.isTimeBuffered(
                                  t.startPTS,
                                  t.endPTS,
                                  e,
                                );
                                return r && n.removeFragment(s.body), r;
                              });
                          } else s.body.type === r && n.removeFragment(s.body);
                      });
                    }),
                    (e.detectPartialFragments = function(t) {
                      var e = this,
                        r = this.timeRanges,
                        n = t.frag,
                        s = t.part;
                      if (r && 'initSegment' !== n.sn) {
                        var a = i(n),
                          o = this.fragments[a];
                        o &&
                          (Object.keys(r).forEach(function(t) {
                            var i = n.elementaryStreams[t];
                            if (i) {
                              var a = r[t],
                                u = null !== s || !0 === i.partial;
                              o.range[t] = e.getBufferedTimes(n, s, u, a);
                            }
                          }),
                          (o.loaded = null),
                          Object.keys(o.range).length
                            ? (o.buffered = !0)
                            : this.removeFragment(o.body));
                      }
                    }),
                    (e.fragBuffered = function(t) {
                      var e = i(t),
                        r = this.fragments[e];
                      r && ((r.loaded = null), (r.buffered = !0));
                    }),
                    (e.getBufferedTimes = function(t, e, r, n) {
                      for (
                        var i = { time: [], partial: r },
                          s = e ? e.start : t.start,
                          a = e ? e.end : t.end,
                          o = t.minEndPTS || a,
                          u = t.maxStartPTS || s,
                          l = 0;
                        l < n.length;
                        l++
                      ) {
                        var c = n.start(l) - this.bufferPadding,
                          h = n.end(l) + this.bufferPadding;
                        if (u >= c && o <= h) {
                          i.time.push({
                            startPTS: Math.max(s, n.start(l)),
                            endPTS: Math.min(a, n.end(l)),
                          });
                          break;
                        }
                        if (s < h && a > c)
                          (i.partial = !0),
                            i.time.push({
                              startPTS: Math.max(s, n.start(l)),
                              endPTS: Math.min(a, n.end(l)),
                            });
                        else if (a <= c) break;
                      }
                      return i;
                    }),
                    (e.getPartialFragment = function(t) {
                      var e,
                        r,
                        i,
                        s = null,
                        a = 0,
                        o = this.bufferPadding,
                        u = this.fragments;
                      return (
                        Object.keys(u).forEach(function(l) {
                          var c = u[l];
                          c &&
                            n(c) &&
                            ((r = c.body.start - o),
                            (i = c.body.end + o),
                            t >= r &&
                              t <= i &&
                              ((e = Math.min(t - r, i - t)),
                              a <= e && ((s = c.body), (a = e))));
                        }),
                        s
                      );
                    }),
                    (e.getState = function(t) {
                      var e = i(t),
                        r = this.fragments[e];
                      return r
                        ? r.buffered
                          ? n(r)
                            ? s.PARTIAL
                            : s.OK
                          : s.APPENDING
                        : s.NOT_LOADED;
                    }),
                    (e.isTimeBuffered = function(t, e, r) {
                      for (var n, i, s = 0; s < r.length; s++) {
                        if (
                          ((n = r.start(s) - this.bufferPadding),
                          (i = r.end(s) + this.bufferPadding),
                          t >= n && e <= i)
                        )
                          return !0;
                        if (e <= n) return !1;
                      }
                      return !1;
                    }),
                    (e.onFragLoaded = function(t, e) {
                      var r = e.frag,
                        n = e.part;
                      if ('initSegment' !== r.sn && !r.bitrateTest && !n) {
                        var s = i(r);
                        this.fragments[s] = {
                          body: r,
                          loaded: e,
                          buffered: !1,
                          range: Object.create(null),
                        };
                      }
                    }),
                    (e.onBufferAppended = function(t, e) {
                      var r = this,
                        n = e.frag,
                        i = e.part,
                        s = e.timeRanges;
                      if (n.type === o.PlaylistLevelType.MAIN)
                        if (((this.activeFragment = n), i)) {
                          var a = this.activeParts;
                          a || (this.activeParts = a = []), a.push(i);
                        } else this.activeParts = null;
                      (this.timeRanges = s),
                        Object.keys(s).forEach(function(t) {
                          var e = s[t];
                          if ((r.detectEvictedFragments(t, e), !i))
                            for (var a = 0; a < e.length; a++)
                              n.appendedPTS = Math.max(
                                e.end(a),
                                n.appendedPTS || 0,
                              );
                        });
                    }),
                    (e.onFragBuffered = function(t, e) {
                      this.detectPartialFragments(e);
                    }),
                    (e.hasFragment = function(t) {
                      var e = i(t);
                      return !!this.fragments[e];
                    }),
                    (e.removeFragmentsInRange = function(t, e, r) {
                      var n = this;
                      Object.keys(this.fragments).forEach(function(i) {
                        var s = n.fragments[i];
                        if (s && s.buffered) {
                          var a = s.body;
                          a.type === r &&
                            a.start < e &&
                            a.end > t &&
                            n.removeFragment(a);
                        }
                      });
                    }),
                    (e.removeFragment = function(t) {
                      var e = i(t);
                      (t.stats.loaded = 0),
                        t.clearElementaryStreamInfo(),
                        delete this.fragments[e];
                    }),
                    (e.removeAllFragments = function() {
                      (this.fragments = Object.create(null)),
                        (this.activeFragment = null),
                        (this.activeParts = null);
                    }),
                    t
                  );
                })();
              },
              './src/controller/gap-controller.ts': function(t, e, r) {
                r.r(e),
                  r.d(e, 'STALL_MINIMUM_DURATION_MS', function() {
                    return o;
                  }),
                  r.d(e, 'MAX_START_GAP_JUMP', function() {
                    return u;
                  }),
                  r.d(e, 'SKIP_BUFFER_HOLE_STEP_SECONDS', function() {
                    return l;
                  }),
                  r.d(e, 'SKIP_BUFFER_RANGE_START', function() {
                    return c;
                  }),
                  r.d(e, 'default', function() {
                    return h;
                  });
                var n = r('./src/utils/buffer-helper.ts'),
                  i = r('./src/errors.ts'),
                  s = r('./src/events.ts'),
                  a = r('./src/utils/logger.ts'),
                  o = 250,
                  u = 2,
                  l = 0.1,
                  c = 0.05,
                  h = (function() {
                    function t(t, e, r, n) {
                      (this.config = void 0),
                        (this.media = null),
                        (this.fragmentTracker = void 0),
                        (this.hls = void 0),
                        (this.nudgeRetry = 0),
                        (this.stallReported = !1),
                        (this.stalled = null),
                        (this.moved = !1),
                        (this.seeking = !1),
                        (this.config = t),
                        (this.media = e),
                        (this.fragmentTracker = r),
                        (this.hls = n);
                    }
                    var e = t.prototype;
                    return (
                      (e.destroy = function() {
                        (this.media = null),
                          (this.hls = this.fragmentTracker = null);
                      }),
                      (e.poll = function(t, e) {
                        var r = this.config,
                          i = this.media,
                          s = this.stalled;
                        if (null !== i) {
                          var l = i.currentTime,
                            c = i.seeking,
                            h = this.seeking && !c,
                            d = !this.seeking && c;
                          if (((this.seeking = c), l === t)) {
                            if (
                              ((d || h) && (this.stalled = null),
                              !(
                                (i.paused && !c) ||
                                i.ended ||
                                0 === i.playbackRate
                              ) && n.BufferHelper.getBuffered(i).length)
                            ) {
                              var f = n.BufferHelper.bufferInfo(i, l, 0),
                                p = f.len > 0,
                                v = f.nextStart || 0;
                              if (p || v) {
                                if (c) {
                                  var g = f.len > u,
                                    m =
                                      !v ||
                                      (e && e.start <= l) ||
                                      (v - l > u &&
                                        !this.fragmentTracker.getPartialFragment(
                                          l,
                                        ));
                                  if (g || m) return;
                                  this.moved = !1;
                                }
                                if (!this.moved && null !== this.stalled) {
                                  var y,
                                    b = Math.max(v, f.start || 0) - l,
                                    E = this.hls.levels
                                      ? this.hls.levels[this.hls.currentLevel]
                                      : null,
                                    T = (null == E ||
                                    null === (y = E.details) ||
                                    void 0 === y
                                    ? void 0
                                    : y.live)
                                      ? 2 * E.details.targetduration
                                      : u;
                                  if (b > 0 && b <= T)
                                    return void this._trySkipBufferHole(null);
                                }
                                var S = self.performance.now();
                                if (null !== s) {
                                  var L = S - s;
                                  if (
                                    c ||
                                    !(L >= o) ||
                                    (this._reportStall(f), this.media)
                                  ) {
                                    var _ = n.BufferHelper.bufferInfo(
                                      i,
                                      l,
                                      r.maxBufferHole,
                                    );
                                    this._tryFixBufferStall(_, L);
                                  }
                                } else this.stalled = S;
                              }
                            }
                          } else if (((this.moved = !0), null !== s)) {
                            if (this.stallReported) {
                              var A = self.performance.now() - s;
                              a.logger.warn(
                                'playback not stuck anymore @' +
                                  l +
                                  ', after ' +
                                  Math.round(A) +
                                  'ms',
                              ),
                                (this.stallReported = !1);
                            }
                            (this.stalled = null), (this.nudgeRetry = 0);
                          }
                        }
                      }),
                      (e._tryFixBufferStall = function(t, e) {
                        var r = this.config,
                          n = this.fragmentTracker,
                          i = this.media;
                        if (null !== i) {
                          var s = i.currentTime,
                            o = n.getPartialFragment(s);
                          if (o && (this._trySkipBufferHole(o) || !this.media))
                            return;
                          t.len > r.maxBufferHole &&
                            e > 1e3 * r.highBufferWatchdogPeriod &&
                            (a.logger.warn(
                              'Trying to nudge playhead over buffer-hole',
                            ),
                            (this.stalled = null),
                            this._tryNudgeBuffer());
                        }
                      }),
                      (e._reportStall = function(t) {
                        var e = this.hls,
                          r = this.media;
                        !this.stallReported &&
                          r &&
                          ((this.stallReported = !0),
                          a.logger.warn(
                            'Playback stalling at @' +
                              r.currentTime +
                              ' due to low buffer (' +
                              JSON.stringify(t) +
                              ')',
                          ),
                          e.trigger(s.Events.ERROR, {
                            type: i.ErrorTypes.MEDIA_ERROR,
                            details: i.ErrorDetails.BUFFER_STALLED_ERROR,
                            fatal: !1,
                            buffer: t.len,
                          }));
                      }),
                      (e._trySkipBufferHole = function(t) {
                        var e = this.config,
                          r = this.hls,
                          o = this.media;
                        if (null === o) return 0;
                        for (
                          var u = o.currentTime,
                            h = 0,
                            d = n.BufferHelper.getBuffered(o),
                            f = 0;
                          f < d.length;
                          f++
                        ) {
                          var p = d.start(f);
                          if (u + e.maxBufferHole >= h && u < p) {
                            var v = Math.max(p + c, o.currentTime + l);
                            return (
                              a.logger.warn(
                                'skipping hole, adjusting currentTime from ' +
                                  u +
                                  ' to ' +
                                  v,
                              ),
                              (this.moved = !0),
                              (this.stalled = null),
                              (o.currentTime = v),
                              t &&
                                r.trigger(s.Events.ERROR, {
                                  type: i.ErrorTypes.MEDIA_ERROR,
                                  details: i.ErrorDetails.BUFFER_SEEK_OVER_HOLE,
                                  fatal: !1,
                                  reason:
                                    'fragment loaded with buffer holes, seeking from ' +
                                    u +
                                    ' to ' +
                                    v,
                                  frag: t,
                                }),
                              v
                            );
                          }
                          h = d.end(f);
                        }
                        return 0;
                      }),
                      (e._tryNudgeBuffer = function() {
                        var t = this.config,
                          e = this.hls,
                          r = this.media,
                          n = this.nudgeRetry;
                        if (null !== r) {
                          var o = r.currentTime;
                          if ((this.nudgeRetry++, n < t.nudgeMaxRetry)) {
                            var u = o + (n + 1) * t.nudgeOffset;
                            a.logger.warn(
                              "Nudging 'currentTime' from " + o + ' to ' + u,
                            ),
                              (r.currentTime = u),
                              e.trigger(s.Events.ERROR, {
                                type: i.ErrorTypes.MEDIA_ERROR,
                                details: i.ErrorDetails.BUFFER_NUDGE_ON_STALL,
                                fatal: !1,
                              });
                          } else
                            a.logger.error(
                              'Playhead still not moving while enough data buffered @' +
                                o +
                                ' after ' +
                                t.nudgeMaxRetry +
                                ' nudges',
                            ),
                              e.trigger(s.Events.ERROR, {
                                type: i.ErrorTypes.MEDIA_ERROR,
                                details: i.ErrorDetails.BUFFER_STALLED_ERROR,
                                fatal: !0,
                              });
                        }
                      }),
                      t
                    );
                  })();
              },
              './src/controller/id3-track-controller.ts': function(t, e, r) {
                function n() {
                  return self.WebKitDataCue || self.VTTCue || self.TextTrackCue;
                }
                function i(t, e) {
                  return t.getTime() / 1e3 - e;
                }
                r.r(e);
                var s = r('./src/polyfills/number.ts'),
                  a = r('./src/events.ts'),
                  o = r('./src/utils/texttrack-utils.ts'),
                  u = r('./src/demux/id3.ts'),
                  l = r('./src/loader/date-range.ts'),
                  c = r('./src/types/demuxer.ts'),
                  h = (function() {
                    function t(t) {
                      (this.hls = void 0),
                        (this.id3Track = null),
                        (this.media = null),
                        (this.dateRangeCuesAppended = {}),
                        (this.hls = t),
                        this._registerListeners();
                    }
                    var e = t.prototype;
                    return (
                      (e.destroy = function() {
                        this._unregisterListeners(),
                          (this.id3Track = null),
                          (this.media = null),
                          (this.dateRangeCuesAppended = {}),
                          (this.hls = null);
                      }),
                      (e._registerListeners = function() {
                        var t = this.hls;
                        t.on(
                          a.Events.MEDIA_ATTACHED,
                          this.onMediaAttached,
                          this,
                        ),
                          t.on(
                            a.Events.MEDIA_DETACHING,
                            this.onMediaDetaching,
                            this,
                          ),
                          t.on(
                            a.Events.MANIFEST_LOADING,
                            this.onManifestLoading,
                            this,
                          ),
                          t.on(
                            a.Events.FRAG_PARSING_METADATA,
                            this.onFragParsingMetadata,
                            this,
                          ),
                          t.on(
                            a.Events.BUFFER_FLUSHING,
                            this.onBufferFlushing,
                            this,
                          ),
                          t.on(
                            a.Events.LEVEL_UPDATED,
                            this.onLevelUpdated,
                            this,
                          );
                      }),
                      (e._unregisterListeners = function() {
                        var t = this.hls;
                        t.off(
                          a.Events.MEDIA_ATTACHED,
                          this.onMediaAttached,
                          this,
                        ),
                          t.off(
                            a.Events.MEDIA_DETACHING,
                            this.onMediaDetaching,
                            this,
                          ),
                          t.off(
                            a.Events.MANIFEST_LOADING,
                            this.onManifestLoading,
                            this,
                          ),
                          t.off(
                            a.Events.FRAG_PARSING_METADATA,
                            this.onFragParsingMetadata,
                            this,
                          ),
                          t.off(
                            a.Events.BUFFER_FLUSHING,
                            this.onBufferFlushing,
                            this,
                          ),
                          t.off(
                            a.Events.LEVEL_UPDATED,
                            this.onLevelUpdated,
                            this,
                          );
                      }),
                      (e.onMediaAttached = function(t, e) {
                        this.media = e.media;
                      }),
                      (e.onMediaDetaching = function() {
                        this.id3Track &&
                          (Object(o.clearCurrentCues)(this.id3Track),
                          (this.id3Track = null),
                          (this.media = null),
                          (this.dateRangeCuesAppended = {}));
                      }),
                      (e.onManifestLoading = function() {
                        this.dateRangeCuesAppended = {};
                      }),
                      (e.createTrack = function(t) {
                        var e = this.getID3Track(t.textTracks);
                        return (e.mode = 'hidden'), e;
                      }),
                      (e.getID3Track = function(t) {
                        if (this.media) {
                          for (var e = 0; e < t.length; e++) {
                            var r = t[e];
                            if ('metadata' === r.kind && 'id3' === r.label)
                              return (
                                Object(o.sendAddTrackEvent)(r, this.media), r
                              );
                          }
                          return this.media.addTextTrack('metadata', 'id3');
                        }
                      }),
                      (e.onFragParsingMetadata = function(t, e) {
                        if (this.media) {
                          var r = this.hls.config,
                            i = r.enableEmsgMetadataCues,
                            s = r.enableID3MetadataCues;
                          if (i || s) {
                            var a = e.frag,
                              o = e.samples,
                              l = e.details;
                            this.id3Track ||
                              (this.id3Track = this.createTrack(this.media));
                            for (
                              var h = l.edge || a.end,
                                d = n(),
                                f = !1,
                                p = {},
                                v = 0;
                              v < o.length;
                              v++
                            ) {
                              var g = o[v].type;
                              if ((g !== c.MetadataSchema.emsg || i) && s) {
                                var m = u.getID3Frames(o[v].data);
                                if (m) {
                                  var y = o[v].pts,
                                    b = h;
                                  b - y <= 0 && (b = y + 0.25);
                                  for (var E = 0; E < m.length; E++) {
                                    var T = m[E];
                                    if (!u.isTimeStampFrame(T)) {
                                      var S = new d(y, b, '');
                                      (S.value = T),
                                        g && (S.type = g),
                                        this.id3Track.addCue(S),
                                        (p[T.key] = null),
                                        (f = !0);
                                    }
                                  }
                                }
                              }
                            }
                            f && this.updateId3CueEnds(p);
                          }
                        }
                      }),
                      (e.updateId3CueEnds = function(t) {
                        var e,
                          r =
                            null === (e = this.id3Track) || void 0 === e
                              ? void 0
                              : e.cues;
                        if (r)
                          for (var n = r.length; n--; ) {
                            var i,
                              s = r[n],
                              a =
                                null === (i = s.value) || void 0 === i
                                  ? void 0
                                  : i.key;
                            if (a && a in t) {
                              var o = t[a];
                              o && s.endTime !== o && (s.endTime = o),
                                (t[a] = s.startTime);
                            }
                          }
                      }),
                      (e.onBufferFlushing = function(t, e) {
                        var r = e.startOffset,
                          n = e.endOffset,
                          i = e.type,
                          s = this.id3Track,
                          a = this.hls;
                        if (a) {
                          var u,
                            l = a.config,
                            h = l.enableEmsgMetadataCues,
                            d = l.enableID3MetadataCues;
                          s &&
                            (h || d) &&
                            ((u =
                              'audio' === i
                                ? function(t) {
                                    return (
                                      t.type === c.MetadataSchema.audioId3 && d
                                    );
                                  }
                                : 'video' === i
                                ? function(t) {
                                    return (
                                      t.type === c.MetadataSchema.emsg && h
                                    );
                                  }
                                : function(t) {
                                    return (
                                      (t.type === c.MetadataSchema.audioId3 &&
                                        d) ||
                                      (t.type === c.MetadataSchema.emsg && h)
                                    );
                                  }),
                            Object(o.removeCuesInRange)(s, r, n, u));
                        }
                      }),
                      (e.onLevelUpdated = function(t, e) {
                        var r = this,
                          a = e.details;
                        if (
                          this.media &&
                          a.hasProgramDateTime &&
                          this.hls.config.enableDateRangeMetadataCues
                        ) {
                          var o = this.dateRangeCuesAppended,
                            u = this.id3Track,
                            h = a.dateRanges,
                            d = Object.keys(h);
                          if (u)
                            for (
                              var f = Object.keys(o).filter(function(t) {
                                  return !d.includes(t);
                                }),
                                p = function(t) {
                                  var e = f[t];
                                  Object.keys(o[e].cues).forEach(function(t) {
                                    u.removeCue(o[e].cues[t]);
                                  }),
                                    delete o[e];
                                },
                                v = f.length;
                              v--;

                            )
                              p(v);
                          var g = a.fragments[a.fragments.length - 1];
                          if (
                            0 !== d.length &&
                            Object(s.isFiniteNumber)(
                              null == g ? void 0 : g.programDateTime,
                            )
                          ) {
                            this.id3Track ||
                              (this.id3Track = this.createTrack(this.media));
                            for (
                              var m = g.programDateTime / 1e3 - g.start,
                                y = a.edge || g.end,
                                b = n(),
                                E = function(t) {
                                  var e = d[t],
                                    n = h[e],
                                    s = o[e],
                                    a = (null == s ? void 0 : s.cues) || {},
                                    u =
                                      (null == s ? void 0 : s.durationKnown) ||
                                      !1,
                                    f = i(n.startDate, m),
                                    p = y,
                                    v = n.endDate;
                                  if (v) (p = i(v, m)), (u = !0);
                                  else if (n.endOnNext && !u) {
                                    var g = d
                                      .reduce(function(t, e) {
                                        var r = h[e];
                                        return (
                                          r.class === n.class &&
                                            r.id !== e &&
                                            r.startDate > n.startDate &&
                                            t.push(r),
                                          t
                                        );
                                      }, [])
                                      .sort(function(t, e) {
                                        return (
                                          t.startDate.getTime() -
                                          e.startDate.getTime()
                                        );
                                      })[0];
                                    g && ((p = i(g.startDate, m)), (u = !0));
                                  }
                                  for (
                                    var E, T = Object.keys(n.attr), S = 0;
                                    S < T.length;
                                    S++
                                  ) {
                                    var L = T[S];
                                    if (
                                      L !== l.DateRangeAttribute.ID &&
                                      L !== l.DateRangeAttribute.CLASS &&
                                      L !== l.DateRangeAttribute.START_DATE &&
                                      L !== l.DateRangeAttribute.DURATION &&
                                      L !== l.DateRangeAttribute.END_DATE &&
                                      L !== l.DateRangeAttribute.END_ON_NEXT
                                    ) {
                                      var _ = a[L];
                                      if (_)
                                        u &&
                                          !s.durationKnown &&
                                          (_.endTime = p);
                                      else {
                                        var A = n.attr[L];
                                        (_ = new b(f, p, '')),
                                          (L !==
                                            l.DateRangeAttribute.SCTE35_OUT &&
                                            L !==
                                              l.DateRangeAttribute.SCTE35_IN) ||
                                            ((E = A),
                                            (A = Uint8Array.from(
                                              E.replace(/^0x/, '')
                                                .replace(
                                                  /([\da-fA-F]{2}) ?/g,
                                                  '0x$1 ',
                                                )
                                                .replace(/ +$/, '')
                                                .split(' '),
                                            ).buffer)),
                                          (_.value = { key: L, data: A }),
                                          (_.type = c.MetadataSchema.dateRange),
                                          r.id3Track.addCue(_),
                                          (a[L] = _);
                                      }
                                    }
                                  }
                                  o[e] = {
                                    cues: a,
                                    dateRange: n,
                                    durationKnown: u,
                                  };
                                },
                                T = 0;
                              T < d.length;
                              T++
                            )
                              E(T);
                          }
                        }
                      }),
                      t
                    );
                  })();
                e.default = h;
              },
              './src/controller/latency-controller.ts': function(t, e, r) {
                function n(t, e) {
                  for (var r = 0; r < e.length; r++) {
                    var n = e[r];
                    (n.enumerable = n.enumerable || !1),
                      (n.configurable = !0),
                      'value' in n && (n.writable = !0),
                      Object.defineProperty(t, n.key, n);
                  }
                }
                r.r(e),
                  r.d(e, 'default', function() {
                    return o;
                  });
                var i = r('./src/errors.ts'),
                  s = r('./src/events.ts'),
                  a = r('./src/utils/logger.ts'),
                  o = (function() {
                    function t(t) {
                      var e = this;
                      (this.hls = void 0),
                        (this.config = void 0),
                        (this.media = null),
                        (this.levelDetails = null),
                        (this.currentTime = 0),
                        (this.stallCount = 0),
                        (this._latency = null),
                        (this.timeupdateHandler = function() {
                          return e.timeupdate();
                        }),
                        (this.hls = t),
                        (this.config = t.config),
                        this.registerListeners();
                    }
                    var e,
                      r,
                      o = t.prototype;
                    return (
                      (o.destroy = function() {
                        this.unregisterListeners(),
                          this.onMediaDetaching(),
                          (this.levelDetails = null),
                          (this.hls = this.timeupdateHandler = null);
                      }),
                      (o.registerListeners = function() {
                        this.hls.on(
                          s.Events.MEDIA_ATTACHED,
                          this.onMediaAttached,
                          this,
                        ),
                          this.hls.on(
                            s.Events.MEDIA_DETACHING,
                            this.onMediaDetaching,
                            this,
                          ),
                          this.hls.on(
                            s.Events.MANIFEST_LOADING,
                            this.onManifestLoading,
                            this,
                          ),
                          this.hls.on(
                            s.Events.LEVEL_UPDATED,
                            this.onLevelUpdated,
                            this,
                          ),
                          this.hls.on(s.Events.ERROR, this.onError, this);
                      }),
                      (o.unregisterListeners = function() {
                        this.hls.off(
                          s.Events.MEDIA_ATTACHED,
                          this.onMediaAttached,
                        ),
                          this.hls.off(
                            s.Events.MEDIA_DETACHING,
                            this.onMediaDetaching,
                          ),
                          this.hls.off(
                            s.Events.MANIFEST_LOADING,
                            this.onManifestLoading,
                          ),
                          this.hls.off(
                            s.Events.LEVEL_UPDATED,
                            this.onLevelUpdated,
                          ),
                          this.hls.off(s.Events.ERROR, this.onError);
                      }),
                      (o.onMediaAttached = function(t, e) {
                        (this.media = e.media),
                          this.media.addEventListener(
                            'timeupdate',
                            this.timeupdateHandler,
                          );
                      }),
                      (o.onMediaDetaching = function() {
                        this.media &&
                          (this.media.removeEventListener(
                            'timeupdate',
                            this.timeupdateHandler,
                          ),
                          (this.media = null));
                      }),
                      (o.onManifestLoading = function() {
                        (this.levelDetails = null),
                          (this._latency = null),
                          (this.stallCount = 0);
                      }),
                      (o.onLevelUpdated = function(t, e) {
                        var r = e.details;
                        (this.levelDetails = r),
                          r.advanced && this.timeupdate(),
                          !r.live &&
                            this.media &&
                            this.media.removeEventListener(
                              'timeupdate',
                              this.timeupdateHandler,
                            );
                      }),
                      (o.onError = function(t, e) {
                        e.details === i.ErrorDetails.BUFFER_STALLED_ERROR &&
                          (this.stallCount++,
                          a.logger.warn(
                            '[playback-rate-controller]: Stall detected, adjusting target latency',
                          ));
                      }),
                      (o.timeupdate = function() {
                        var t = this.media,
                          e = this.levelDetails;
                        if (t && e) {
                          this.currentTime = t.currentTime;
                          var r = this.computeLatency();
                          if (null !== r) {
                            this._latency = r;
                            var n = this.config,
                              i = n.lowLatencyMode,
                              s = n.maxLiveSyncPlaybackRate;
                            if (i && 1 !== s) {
                              var a = this.targetLatency;
                              if (null !== a) {
                                var o = r - a,
                                  u =
                                    o <
                                    Math.min(
                                      this.maxLatency,
                                      a + e.targetduration,
                                    );
                                if (
                                  e.live &&
                                  u &&
                                  o > 0.05 &&
                                  this.forwardBufferLength > 1
                                ) {
                                  var l = Math.min(2, Math.max(1, s)),
                                    c =
                                      Math.round(
                                        (2 /
                                          (1 +
                                            Math.exp(
                                              -0.75 * o - this.edgeStalled,
                                            ))) *
                                          20,
                                      ) / 20;
                                  t.playbackRate = Math.min(l, Math.max(1, c));
                                } else
                                  1 !== t.playbackRate &&
                                    0 !== t.playbackRate &&
                                    (t.playbackRate = 1);
                              }
                            }
                          }
                        }
                      }),
                      (o.estimateLiveEdge = function() {
                        var t = this.levelDetails;
                        return null === t ? null : t.edge + t.age;
                      }),
                      (o.computeLatency = function() {
                        var t = this.estimateLiveEdge();
                        return null === t ? null : t - this.currentTime;
                      }),
                      (e = t),
                      (r = [
                        {
                          key: 'latency',
                          get: function() {
                            return this._latency || 0;
                          },
                        },
                        {
                          key: 'maxLatency',
                          get: function() {
                            var t = this.config,
                              e = this.levelDetails;
                            return void 0 !== t.liveMaxLatencyDuration
                              ? t.liveMaxLatencyDuration
                              : e
                              ? t.liveMaxLatencyDurationCount * e.targetduration
                              : 0;
                          },
                        },
                        {
                          key: 'targetLatency',
                          get: function() {
                            var t = this.levelDetails;
                            if (null === t) return null;
                            var e = t.holdBack,
                              r = t.partHoldBack,
                              n = t.targetduration,
                              i = this.config,
                              s = i.liveSyncDuration,
                              a = i.liveSyncDurationCount,
                              o = i.lowLatencyMode,
                              u = this.hls.userConfig,
                              l = (o && r) || e;
                            (u.liveSyncDuration ||
                              u.liveSyncDurationCount ||
                              0 === l) &&
                              (l = void 0 !== s ? s : a * n);
                            var c = n;
                            return l + Math.min(1 * this.stallCount, c);
                          },
                        },
                        {
                          key: 'liveSyncPosition',
                          get: function() {
                            var t = this.estimateLiveEdge(),
                              e = this.targetLatency,
                              r = this.levelDetails;
                            if (null === t || null === e || null === r)
                              return null;
                            var n = r.edge,
                              i = t - e - this.edgeStalled,
                              s = n - r.totalduration,
                              a =
                                n -
                                ((this.config.lowLatencyMode && r.partTarget) ||
                                  r.targetduration);
                            return Math.min(Math.max(s, i), a);
                          },
                        },
                        {
                          key: 'drift',
                          get: function() {
                            var t = this.levelDetails;
                            return null === t ? 1 : t.drift;
                          },
                        },
                        {
                          key: 'edgeStalled',
                          get: function() {
                            var t = this.levelDetails;
                            if (null === t) return 0;
                            var e =
                              3 *
                              ((this.config.lowLatencyMode && t.partTarget) ||
                                t.targetduration);
                            return Math.max(t.age - e, 0);
                          },
                        },
                        {
                          key: 'forwardBufferLength',
                          get: function() {
                            var t = this.media,
                              e = this.levelDetails;
                            if (!t || !e) return 0;
                            var r = t.buffered.length;
                            return (
                              (r ? t.buffered.end(r - 1) : e.edge) -
                              this.currentTime
                            );
                          },
                        },
                      ]) && n(e.prototype, r),
                      Object.defineProperty(e, 'prototype', { writable: !1 }),
                      t
                    );
                  })();
              },
              './src/controller/level-controller.ts': function(t, e, r) {
                function n() {
                  return (n = Object.assign
                    ? Object.assign.bind()
                    : function(t) {
                        for (var e = 1; e < arguments.length; e++) {
                          var r = arguments[e];
                          for (var n in r)
                            Object.prototype.hasOwnProperty.call(r, n) &&
                              (t[n] = r[n]);
                        }
                        return t;
                      }).apply(this, arguments);
                }
                function i(t, e) {
                  for (var r = 0; r < e.length; r++) {
                    var n = e[r];
                    (n.enumerable = n.enumerable || !1),
                      (n.configurable = !0),
                      'value' in n && (n.writable = !0),
                      Object.defineProperty(t, n.key, n);
                  }
                }
                function s(t, e) {
                  return (s = Object.setPrototypeOf
                    ? Object.setPrototypeOf.bind()
                    : function(t, e) {
                        return (t.__proto__ = e), t;
                      })(t, e);
                }
                r.r(e),
                  r.d(e, 'default', function() {
                    return p;
                  });
                var a = r('./src/types/level.ts'),
                  o = r('./src/events.ts'),
                  u = r('./src/errors.ts'),
                  l = r('./src/utils/codecs.ts'),
                  c = r('./src/controller/level-helper.ts'),
                  h = r('./src/controller/base-playlist-controller.ts'),
                  d = r('./src/types/loader.ts'),
                  f = /chrome|firefox/.test(navigator.userAgent.toLowerCase()),
                  p = (function(t) {
                    function e(e) {
                      var r;
                      return (
                        ((r =
                          t.call(this, e, '[level-controller]') ||
                          this)._levels = []),
                        (r._firstLevel = -1),
                        (r._startLevel = void 0),
                        (r.currentLevelIndex = -1),
                        (r.manualLevelIndex = -1),
                        (r.onParsedComplete = void 0),
                        r._registerListeners(),
                        r
                      );
                    }
                    var r, h;
                    (h = t),
                      ((r = e).prototype = Object.create(h.prototype)),
                      (r.prototype.constructor = r),
                      s(r, h);
                    var p,
                      v,
                      g = e.prototype;
                    return (
                      (g._registerListeners = function() {
                        var t = this.hls;
                        t.on(
                          o.Events.MANIFEST_LOADED,
                          this.onManifestLoaded,
                          this,
                        ),
                          t.on(o.Events.LEVEL_LOADED, this.onLevelLoaded, this),
                          t.on(
                            o.Events.AUDIO_TRACK_SWITCHED,
                            this.onAudioTrackSwitched,
                            this,
                          ),
                          t.on(o.Events.FRAG_LOADED, this.onFragLoaded, this),
                          t.on(o.Events.ERROR, this.onError, this);
                      }),
                      (g._unregisterListeners = function() {
                        var t = this.hls;
                        t.off(
                          o.Events.MANIFEST_LOADED,
                          this.onManifestLoaded,
                          this,
                        ),
                          t.off(
                            o.Events.LEVEL_LOADED,
                            this.onLevelLoaded,
                            this,
                          ),
                          t.off(
                            o.Events.AUDIO_TRACK_SWITCHED,
                            this.onAudioTrackSwitched,
                            this,
                          ),
                          t.off(o.Events.FRAG_LOADED, this.onFragLoaded, this),
                          t.off(o.Events.ERROR, this.onError, this);
                      }),
                      (g.destroy = function() {
                        this._unregisterListeners(),
                          (this.manualLevelIndex = -1),
                          (this._levels.length = 0),
                          t.prototype.destroy.call(this);
                      }),
                      (g.startLoad = function() {
                        this._levels.forEach(function(t) {
                          t.loadError = 0;
                        }),
                          t.prototype.startLoad.call(this);
                      }),
                      (g.onManifestLoaded = function(t, e) {
                        var r,
                          n,
                          i = [],
                          s = [],
                          h = [],
                          d = {},
                          p = !1,
                          v = !1,
                          g = !1;
                        if (
                          (e.levels.forEach(function(t) {
                            var e = t.attrs;
                            (p = p || !(!t.width || !t.height)),
                              (v = v || !!t.videoCodec),
                              (g = g || !!t.audioCodec),
                              f &&
                                t.audioCodec &&
                                -1 !== t.audioCodec.indexOf('mp4a.40.34') &&
                                (t.audioCodec = void 0);
                            var r =
                              t.bitrate +
                              '-' +
                              t.attrs.RESOLUTION +
                              '-' +
                              t.attrs.CODECS;
                            (n = d[r])
                              ? n.url.push(t.url)
                              : ((n = new a.Level(t)), (d[r] = n), i.push(n)),
                              e &&
                                (e.AUDIO &&
                                  Object(c.addGroupId)(n, 'audio', e.AUDIO),
                                e.SUBTITLES &&
                                  Object(c.addGroupId)(n, 'text', e.SUBTITLES));
                          }),
                          (p || v) &&
                            g &&
                            (i = i.filter(function(t) {
                              var e = t.videoCodec,
                                r = t.width,
                                n = t.height;
                              return !!e || !(!r || !n);
                            })),
                          (i = i.filter(function(t) {
                            var e = t.audioCodec,
                              r = t.videoCodec;
                            return (
                              (!e ||
                                Object(l.isCodecSupportedInMp4)(e, 'audio')) &&
                              (!r ||
                                Object(l.isCodecSupportedInMp4)(r, 'video'))
                            );
                          })),
                          e.audioTracks &&
                            ((s = e.audioTracks.filter(function(t) {
                              return (
                                !t.audioCodec ||
                                Object(l.isCodecSupportedInMp4)(
                                  t.audioCodec,
                                  'audio',
                                )
                              );
                            })),
                            Object(c.assignTrackIdsByGroup)(s)),
                          e.subtitles &&
                            ((h = e.subtitles),
                            Object(c.assignTrackIdsByGroup)(h)),
                          i.length > 0)
                        ) {
                          (r = i[0].bitrate),
                            i.sort(function(t, e) {
                              return t.bitrate - e.bitrate;
                            }),
                            (this._levels = i);
                          for (var m = 0; m < i.length; m++)
                            if (i[m].bitrate === r) {
                              (this._firstLevel = m),
                                this.log(
                                  'manifest loaded, ' +
                                    i.length +
                                    ' level(s) found, first bitrate: ' +
                                    r,
                                );
                              break;
                            }
                          var y = g && !v,
                            b = {
                              levels: i,
                              audioTracks: s,
                              subtitleTracks: h,
                              firstLevel: this._firstLevel,
                              stats: e.stats,
                              audio: g,
                              video: v,
                              altAudio:
                                !y &&
                                s.some(function(t) {
                                  return !!t.url;
                                }),
                            };
                          this.hls.trigger(o.Events.MANIFEST_PARSED, b),
                            (this.hls.config.autoStartLoad ||
                              this.hls.forceStartLoad) &&
                              this.hls.startLoad(this.hls.config.startPosition);
                        } else
                          this.hls.trigger(o.Events.ERROR, {
                            type: u.ErrorTypes.MEDIA_ERROR,
                            details:
                              u.ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
                            fatal: !0,
                            url: e.url,
                            reason:
                              'no level with compatible codecs found in manifest',
                          });
                      }),
                      (g.onError = function(e, r) {
                        var n;
                        if ((t.prototype.onError.call(this, e, r), !r.fatal)) {
                          var i = r.context,
                            s = this._levels[this.currentLevelIndex];
                          if (
                            i &&
                            ((i.type === d.PlaylistContextType.AUDIO_TRACK &&
                              s.audioGroupIds &&
                              i.groupId === s.audioGroupIds[s.urlId]) ||
                              (i.type ===
                                d.PlaylistContextType.SUBTITLE_TRACK &&
                                s.textGroupIds &&
                                i.groupId === s.textGroupIds[s.urlId]))
                          )
                            this.redundantFailover(this.currentLevelIndex);
                          else {
                            var a,
                              o = !1,
                              l = !0;
                            switch (r.details) {
                              case u.ErrorDetails.FRAG_LOAD_ERROR:
                              case u.ErrorDetails.FRAG_LOAD_TIMEOUT:
                              case u.ErrorDetails.KEY_LOAD_ERROR:
                              case u.ErrorDetails.KEY_LOAD_TIMEOUT:
                                if (r.frag) {
                                  var c =
                                      r.frag.type === d.PlaylistLevelType.MAIN
                                        ? r.frag.level
                                        : this.currentLevelIndex,
                                    h = this._levels[c];
                                  h
                                    ? (h.fragmentError++,
                                      h.fragmentError >
                                        this.hls.config.fragLoadingMaxRetry &&
                                        (a = c))
                                    : (a = c);
                                }
                                break;
                              case u.ErrorDetails.LEVEL_LOAD_ERROR:
                              case u.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                                i &&
                                  (i.deliveryDirectives && (l = !1),
                                  (a = i.level)),
                                  (o = !0);
                                break;
                              case u.ErrorDetails.REMUX_ALLOC_ERROR:
                                (a =
                                  null != (n = r.level)
                                    ? n
                                    : this.currentLevelIndex),
                                  (o = !0);
                            }
                            void 0 !== a && this.recoverLevel(r, a, o, l);
                          }
                        }
                      }),
                      (g.recoverLevel = function(t, e, r, n) {
                        var i = t.details,
                          s = this._levels[e];
                        if ((s.loadError++, r)) {
                          if (!this.retryLoadingOrFail(t))
                            return void (this.currentLevelIndex = -1);
                          t.levelRetry = !0;
                        }
                        if (n) {
                          var a = s.url.length;
                          if (a > 1 && s.loadError < a)
                            (t.levelRetry = !0), this.redundantFailover(e);
                          else if (-1 === this.manualLevelIndex) {
                            for (
                              var o = -1, u = this._levels, l = u.length;
                              l--;

                            ) {
                              var c = (l + this.currentLevelIndex) % u.length;
                              if (
                                c !== this.currentLevelIndex &&
                                0 === u[c].loadError
                              ) {
                                o = c;
                                break;
                              }
                            }
                            o > -1 &&
                              this.currentLevelIndex !== o &&
                              (this.warn(i + ': switch to ' + o),
                              (t.levelRetry = !0),
                              (this.hls.nextAutoLevel = o));
                          }
                        }
                      }),
                      (g.redundantFailover = function(t) {
                        var e = this._levels[t],
                          r = e.url.length;
                        if (r > 1) {
                          var n = (e.urlId + 1) % r;
                          this.warn('Switching to redundant URL-id ' + n),
                            this._levels.forEach(function(t) {
                              t.urlId = n;
                            }),
                            (this.level = t);
                        }
                      }),
                      (g.onFragLoaded = function(t, e) {
                        var r = e.frag;
                        if (
                          void 0 !== r &&
                          r.type === d.PlaylistLevelType.MAIN
                        ) {
                          var n = this._levels[r.level];
                          void 0 !== n &&
                            ((n.fragmentError = 0), (n.loadError = 0));
                        }
                      }),
                      (g.onLevelLoaded = function(t, e) {
                        var r,
                          n,
                          i = e.level,
                          s = e.details,
                          a = this._levels[i];
                        if (!a)
                          return (
                            this.warn('Invalid level index ' + i),
                            void (
                              null !== (n = e.deliveryDirectives) &&
                              void 0 !== n &&
                              n.skip &&
                              (s.deltaUpdateFailed = !0)
                            )
                          );
                        i === this.currentLevelIndex
                          ? (0 === a.fragmentError &&
                              ((a.loadError = 0), (this.retryCount = 0)),
                            this.playlistLoaded(i, e, a.details))
                          : null !== (r = e.deliveryDirectives) &&
                            void 0 !== r &&
                            r.skip &&
                            (s.deltaUpdateFailed = !0);
                      }),
                      (g.onAudioTrackSwitched = function(t, e) {
                        var r = this.hls.levels[this.currentLevelIndex];
                        if (r && r.audioGroupIds) {
                          for (
                            var n = -1,
                              i = this.hls.audioTracks[e.id].groupId,
                              s = 0;
                            s < r.audioGroupIds.length;
                            s++
                          )
                            if (r.audioGroupIds[s] === i) {
                              n = s;
                              break;
                            }
                          n !== r.urlId && ((r.urlId = n), this.startLoad());
                        }
                      }),
                      (g.loadPlaylist = function(t) {
                        var e = this.currentLevelIndex,
                          r = this._levels[e];
                        if (this.canLoad && r && r.url.length > 0) {
                          var n = r.urlId,
                            i = r.url[n];
                          if (t)
                            try {
                              i = t.addDirectives(i);
                            } catch (t) {
                              this.warn(
                                'Could not construct new URL with HLS Delivery Directives: ' +
                                  t,
                              );
                            }
                          this.log(
                            'Attempt loading level index ' +
                              e +
                              (t ? ' at sn ' + t.msn + ' part ' + t.part : '') +
                              ' with URL-id ' +
                              n +
                              ' ' +
                              i,
                          ),
                            this.clearTimer(),
                            this.hls.trigger(o.Events.LEVEL_LOADING, {
                              url: i,
                              level: e,
                              id: n,
                              deliveryDirectives: t || null,
                            });
                        }
                      }),
                      (g.removeLevel = function(t, e) {
                        var r = function(t, r) {
                            return r !== e;
                          },
                          n = this._levels
                            .filter(function(n, i) {
                              return (
                                i !== t ||
                                (n.url.length > 1 &&
                                  void 0 !== e &&
                                  ((n.url = n.url.filter(r)),
                                  n.audioGroupIds &&
                                    (n.audioGroupIds = n.audioGroupIds.filter(
                                      r,
                                    )),
                                  n.textGroupIds &&
                                    (n.textGroupIds = n.textGroupIds.filter(r)),
                                  (n.urlId = 0),
                                  !0))
                              );
                            })
                            .map(function(t, e) {
                              var r = t.details;
                              return (
                                null != r &&
                                  r.fragments &&
                                  r.fragments.forEach(function(t) {
                                    t.level = e;
                                  }),
                                t
                              );
                            });
                        (this._levels = n),
                          this.hls.trigger(o.Events.LEVELS_UPDATED, {
                            levels: n,
                          });
                      }),
                      (p = e),
                      (v = [
                        {
                          key: 'levels',
                          get: function() {
                            return 0 === this._levels.length
                              ? null
                              : this._levels;
                          },
                        },
                        {
                          key: 'level',
                          get: function() {
                            return this.currentLevelIndex;
                          },
                          set: function(t) {
                            var e,
                              r = this._levels;
                            if (
                              0 !== r.length &&
                              (this.currentLevelIndex !== t ||
                                null === (e = r[t]) ||
                                void 0 === e ||
                                !e.details)
                            ) {
                              if (t < 0 || t >= r.length) {
                                var i = t < 0;
                                if (
                                  (this.hls.trigger(o.Events.ERROR, {
                                    type: u.ErrorTypes.OTHER_ERROR,
                                    details: u.ErrorDetails.LEVEL_SWITCH_ERROR,
                                    level: t,
                                    fatal: i,
                                    reason: 'invalid level idx',
                                  }),
                                  i)
                                )
                                  return;
                                t = Math.min(t, r.length - 1);
                              }
                              this.clearTimer();
                              var s = this.currentLevelIndex,
                                a = r[s],
                                l = r[t];
                              this.log(
                                'switching to level ' + t + ' from ' + s,
                              ),
                                (this.currentLevelIndex = t);
                              var c = n({}, l, {
                                level: t,
                                maxBitrate: l.maxBitrate,
                                uri: l.uri,
                                urlId: l.urlId,
                              });
                              delete c._urlId,
                                this.hls.trigger(o.Events.LEVEL_SWITCHING, c);
                              var h = l.details;
                              if (!h || h.live) {
                                var d = this.switchParams(
                                  l.uri,
                                  null == a ? void 0 : a.details,
                                );
                                this.loadPlaylist(d);
                              }
                            }
                          },
                        },
                        {
                          key: 'manualLevel',
                          get: function() {
                            return this.manualLevelIndex;
                          },
                          set: function(t) {
                            (this.manualLevelIndex = t),
                              void 0 === this._startLevel &&
                                (this._startLevel = t),
                              -1 !== t && (this.level = t);
                          },
                        },
                        {
                          key: 'firstLevel',
                          get: function() {
                            return this._firstLevel;
                          },
                          set: function(t) {
                            this._firstLevel = t;
                          },
                        },
                        {
                          key: 'startLevel',
                          get: function() {
                            if (void 0 === this._startLevel) {
                              var t = this.hls.config.startLevel;
                              return void 0 !== t ? t : this._firstLevel;
                            }
                            return this._startLevel;
                          },
                          set: function(t) {
                            this._startLevel = t;
                          },
                        },
                        {
                          key: 'nextLoadLevel',
                          get: function() {
                            return -1 !== this.manualLevelIndex
                              ? this.manualLevelIndex
                              : this.hls.nextAutoLevel;
                          },
                          set: function(t) {
                            (this.level = t),
                              -1 === this.manualLevelIndex &&
                                (this.hls.nextAutoLevel = t);
                          },
                        },
                      ]) && i(p.prototype, v),
                      Object.defineProperty(p, 'prototype', { writable: !1 }),
                      e
                    );
                  })(h.default);
              },
              './src/controller/level-helper.ts': function(t, e, r) {
                function n() {
                  return (n = Object.assign
                    ? Object.assign.bind()
                    : function(t) {
                        for (var e = 1; e < arguments.length; e++) {
                          var r = arguments[e];
                          for (var n in r)
                            Object.prototype.hasOwnProperty.call(r, n) &&
                              (t[n] = r[n]);
                        }
                        return t;
                      }).apply(this, arguments);
                }
                function i(t, e, r) {
                  switch (e) {
                    case 'audio':
                      t.audioGroupIds || (t.audioGroupIds = []),
                        t.audioGroupIds.push(r);
                      break;
                    case 'text':
                      t.textGroupIds || (t.textGroupIds = []),
                        t.textGroupIds.push(r);
                  }
                }
                function s(t) {
                  var e = {};
                  t.forEach(function(t) {
                    var r = t.groupId || '';
                    (t.id = e[r] = e[r] || 0), e[r]++;
                  });
                }
                function a(t, e, r) {
                  o(t[e], t[r]);
                }
                function o(t, e) {
                  var r = e.startPTS;
                  if (Object(m.isFiniteNumber)(r)) {
                    var n,
                      i = 0;
                    e.sn > t.sn
                      ? ((i = r - t.start), (n = t))
                      : ((i = t.start - r), (n = e)),
                      n.duration !== i && (n.duration = i);
                  } else
                    e.sn > t.sn
                      ? t.cc === e.cc && t.minEndPTS
                        ? (e.start = t.start + (t.minEndPTS - t.start))
                        : (e.start = t.start + t.duration)
                      : (e.start = Math.max(t.start - e.duration, 0));
                }
                function u(t, e, r, n, i, s) {
                  n - r <= 0 &&
                    (y.logger.warn(
                      'Fragment should have a positive duration',
                      e,
                    ),
                    (n = r + e.duration),
                    (s = i + e.duration));
                  var a = r,
                    u = n,
                    l = e.startPTS,
                    c = e.endPTS;
                  if (Object(m.isFiniteNumber)(l)) {
                    var h = Math.abs(l - r);
                    Object(m.isFiniteNumber)(e.deltaPTS)
                      ? (e.deltaPTS = Math.max(h, e.deltaPTS))
                      : (e.deltaPTS = h),
                      (a = Math.max(r, l)),
                      (r = Math.min(r, l)),
                      (i = Math.min(i, e.startDTS)),
                      (u = Math.min(n, c)),
                      (n = Math.max(n, c)),
                      (s = Math.max(s, e.endDTS));
                  }
                  e.duration = n - r;
                  var d = r - e.start;
                  (e.appendedPTS = n),
                    (e.start = e.startPTS = r),
                    (e.maxStartPTS = a),
                    (e.startDTS = i),
                    (e.endPTS = n),
                    (e.minEndPTS = u),
                    (e.endDTS = s);
                  var f,
                    p = e.sn;
                  if (!t || p < t.startSN || p > t.endSN) return 0;
                  var v = p - t.startSN,
                    g = t.fragments;
                  for (g[v] = e, f = v; f > 0; f--) o(g[f], g[f - 1]);
                  for (f = v; f < g.length - 1; f++) o(g[f], g[f + 1]);
                  return (
                    t.fragmentHint && o(g[g.length - 1], t.fragmentHint),
                    (t.PTSKnown = t.alignedSliding = !0),
                    d
                  );
                }
                function l(t, e) {
                  for (
                    var r = null, i = t.fragments, s = i.length - 1;
                    s >= 0;
                    s--
                  ) {
                    var a = i[s].initSegment;
                    if (a) {
                      r = a;
                      break;
                    }
                  }
                  t.fragmentHint && delete t.fragmentHint.endPTS;
                  var o,
                    l,
                    f,
                    p,
                    v,
                    g = 0;
                  if (
                    (h(t, e, function(t, n) {
                      t.relurl && (g = t.cc - n.cc),
                        Object(m.isFiniteNumber)(t.startPTS) &&
                          Object(m.isFiniteNumber)(t.endPTS) &&
                          ((n.start = n.startPTS = t.startPTS),
                          (n.startDTS = t.startDTS),
                          (n.appendedPTS = t.appendedPTS),
                          (n.maxStartPTS = t.maxStartPTS),
                          (n.endPTS = t.endPTS),
                          (n.endDTS = t.endDTS),
                          (n.minEndPTS = t.minEndPTS),
                          (n.duration = t.endPTS - t.startPTS),
                          n.duration && (o = n),
                          (e.PTSKnown = e.alignedSliding = !0)),
                        (n.elementaryStreams = t.elementaryStreams),
                        (n.loader = t.loader),
                        (n.stats = t.stats),
                        (n.urlId = t.urlId),
                        t.initSegment &&
                          ((n.initSegment = t.initSegment),
                          (r = t.initSegment));
                    }),
                    r &&
                      (e.fragmentHint
                        ? e.fragments.concat(e.fragmentHint)
                        : e.fragments
                      ).forEach(function(t) {
                        var e;
                        (t.initSegment &&
                          t.initSegment.relurl !==
                            (null === (e = r) || void 0 === e
                              ? void 0
                              : e.relurl)) ||
                          (t.initSegment = r);
                      }),
                    e.skippedSegments)
                  )
                    if (
                      ((e.deltaUpdateFailed = e.fragments.some(function(t) {
                        return !t;
                      })),
                      e.deltaUpdateFailed)
                    ) {
                      y.logger.warn(
                        '[level-helper] Previous playlist missing segments skipped in delta playlist',
                      );
                      for (var E = e.skippedSegments; E--; )
                        e.fragments.shift();
                      (e.startSN = e.fragments[0].sn),
                        (e.startCC = e.fragments[0].cc);
                    } else
                      e.canSkipDateRanges &&
                        (e.dateRanges =
                          ((l = t.dateRanges),
                          (f = e.dateRanges),
                          (p = e.recentlyRemovedDateranges),
                          (v = n({}, l)),
                          p &&
                            p.forEach(function(t) {
                              delete v[t];
                            }),
                          Object.keys(f).forEach(function(t) {
                            var e = new b.DateRange(f[t].attr, v[t]);
                            e.isValid
                              ? (v[t] = e)
                              : y.logger.warn(
                                  'Ignoring invalid Playlist Delta Update DATERANGE tag: "' +
                                    JSON.stringify(f[t].attr) +
                                    '"',
                                );
                          }),
                          v));
                  var T = e.fragments;
                  if (g) {
                    y.logger.warn(
                      'discontinuity sliding from playlist, take drift into account',
                    );
                    for (var S = 0; S < T.length; S++) T[S].cc += g;
                  }
                  e.skippedSegments && (e.startCC = e.fragments[0].cc),
                    c(t.partList, e.partList, function(t, e) {
                      (e.elementaryStreams = t.elementaryStreams),
                        (e.stats = t.stats);
                    }),
                    o
                      ? u(e, o, o.startPTS, o.endPTS, o.startDTS, o.endDTS)
                      : d(t, e),
                    T.length && (e.totalduration = e.edge - T[0].start),
                    (e.driftStartTime = t.driftStartTime),
                    (e.driftStart = t.driftStart);
                  var L = e.advancedDateTime;
                  if (e.advanced && L) {
                    var _ = e.edge;
                    e.driftStart ||
                      ((e.driftStartTime = L), (e.driftStart = _)),
                      (e.driftEndTime = L),
                      (e.driftEnd = _);
                  } else
                    (e.driftEndTime = t.driftEndTime),
                      (e.driftEnd = t.driftEnd),
                      (e.advancedDateTime = t.advancedDateTime);
                }
                function c(t, e, r) {
                  if (t && e)
                    for (var n = 0, i = 0, s = t.length; i <= s; i++) {
                      var a = t[i],
                        o = e[i + n];
                      a &&
                      o &&
                      a.index === o.index &&
                      a.fragment.sn === o.fragment.sn
                        ? r(a, o)
                        : n--;
                    }
                }
                function h(t, e, r) {
                  for (
                    var n = e.skippedSegments,
                      i = Math.max(t.startSN, e.startSN) - e.startSN,
                      s =
                        (t.fragmentHint ? 1 : 0) +
                        (n ? e.endSN : Math.min(t.endSN, e.endSN)) -
                        e.startSN,
                      a = e.startSN - t.startSN,
                      o = e.fragmentHint
                        ? e.fragments.concat(e.fragmentHint)
                        : e.fragments,
                      u = t.fragmentHint
                        ? t.fragments.concat(t.fragmentHint)
                        : t.fragments,
                      l = i;
                    l <= s;
                    l++
                  ) {
                    var c = u[a + l],
                      h = o[l];
                    n && !h && l < n && (h = e.fragments[l] = c),
                      c && h && r(c, h);
                  }
                }
                function d(t, e) {
                  var r = e.startSN + e.skippedSegments - t.startSN,
                    n = t.fragments;
                  r < 0 || r >= n.length || f(e, n[r].start);
                }
                function f(t, e) {
                  if (e) {
                    for (
                      var r = t.fragments, n = t.skippedSegments;
                      n < r.length;
                      n++
                    )
                      r[n].start += e;
                    t.fragmentHint && (t.fragmentHint.start += e);
                  }
                }
                function p(t, e) {
                  var r,
                    n = 1e3 * t.levelTargetDuration,
                    i = n / 2,
                    s = t.age,
                    a = s > 0 && s < 3 * n,
                    o = e.loading.end - e.loading.start,
                    u = t.availabilityDelay;
                  if (!1 === t.updated)
                    if (a) {
                      var l = 333 * t.misses;
                      (r = Math.max(Math.min(i, 2 * o), l)),
                        (t.availabilityDelay = (t.availabilityDelay || 0) + r);
                    } else r = i;
                  else
                    a
                      ? ((u = Math.min(u || n / 2, s)),
                        (t.availabilityDelay = u),
                        (r = u + n - s))
                      : (r = n - o);
                  return Math.round(r);
                }
                function v(t, e, r) {
                  if (!t || !t.details) return null;
                  var n = t.details,
                    i = n.fragments[e - n.startSN];
                  return (
                    i ||
                    ((i = n.fragmentHint) && i.sn === e
                      ? i
                      : e < n.startSN && r && r.sn === e
                      ? r
                      : null)
                  );
                }
                function g(t, e, r) {
                  if (!t || !t.details) return null;
                  var n = t.details.partList;
                  if (n)
                    for (var i = n.length; i--; ) {
                      var s = n[i];
                      if (s.index === r && s.fragment.sn === e) return s;
                    }
                  return null;
                }
                r.r(e),
                  r.d(e, 'addGroupId', function() {
                    return i;
                  }),
                  r.d(e, 'assignTrackIdsByGroup', function() {
                    return s;
                  }),
                  r.d(e, 'updatePTS', function() {
                    return a;
                  }),
                  r.d(e, 'updateFragPTSDTS', function() {
                    return u;
                  }),
                  r.d(e, 'mergeDetails', function() {
                    return l;
                  }),
                  r.d(e, 'mapPartIntersection', function() {
                    return c;
                  }),
                  r.d(e, 'mapFragmentIntersection', function() {
                    return h;
                  }),
                  r.d(e, 'adjustSliding', function() {
                    return d;
                  }),
                  r.d(e, 'addSliding', function() {
                    return f;
                  }),
                  r.d(e, 'computeReloadInterval', function() {
                    return p;
                  }),
                  r.d(e, 'getFragmentWithSN', function() {
                    return v;
                  }),
                  r.d(e, 'getPartWith', function() {
                    return g;
                  });
                var m = r('./src/polyfills/number.ts'),
                  y = r('./src/utils/logger.ts'),
                  b = r('./src/loader/date-range.ts');
              },
              './src/controller/stream-controller.ts': function(t, e, r) {
                function n(t, e) {
                  for (var r = 0; r < e.length; r++) {
                    var n = e[r];
                    (n.enumerable = n.enumerable || !1),
                      (n.configurable = !0),
                      'value' in n && (n.writable = !0),
                      Object.defineProperty(t, n.key, n);
                  }
                }
                function i(t, e) {
                  return (i = Object.setPrototypeOf
                    ? Object.setPrototypeOf.bind()
                    : function(t, e) {
                        return (t.__proto__ = e), t;
                      })(t, e);
                }
                r.r(e),
                  r.d(e, 'default', function() {
                    return m;
                  });
                var s = r('./src/polyfills/number.ts'),
                  a = r('./src/controller/base-stream-controller.ts'),
                  o = r('./src/is-supported.ts'),
                  u = r('./src/events.ts'),
                  l = r('./src/utils/buffer-helper.ts'),
                  c = r('./src/controller/fragment-tracker.ts'),
                  h = r('./src/types/loader.ts'),
                  d = r('./src/loader/fragment.ts'),
                  f = r('./src/demux/transmuxer-interface.ts'),
                  p = r('./src/types/transmuxer.ts'),
                  v = r('./src/controller/gap-controller.ts'),
                  g = r('./src/errors.ts'),
                  m = (function(t) {
                    function e(e, r) {
                      var n;
                      return (
                        ((n =
                          t.call(this, e, r, '[stream-controller]') ||
                          this).audioCodecSwap = !1),
                        (n.gapController = null),
                        (n.level = -1),
                        (n._forceStartLoad = !1),
                        (n.altAudio = !1),
                        (n.audioOnly = !1),
                        (n.fragPlaying = null),
                        (n.onvplaying = null),
                        (n.onvseeked = null),
                        (n.fragLastKbps = 0),
                        (n.couldBacktrack = !1),
                        (n.backtrackFragment = null),
                        (n.audioCodecSwitch = !1),
                        (n.videoBuffer = null),
                        n._registerListeners(),
                        n
                      );
                    }
                    var r, m;
                    (m = t),
                      ((r = e).prototype = Object.create(m.prototype)),
                      (r.prototype.constructor = r),
                      i(r, m);
                    var y,
                      b,
                      E = e.prototype;
                    return (
                      (E._registerListeners = function() {
                        var t = this.hls;
                        t.on(
                          u.Events.MEDIA_ATTACHED,
                          this.onMediaAttached,
                          this,
                        ),
                          t.on(
                            u.Events.MEDIA_DETACHING,
                            this.onMediaDetaching,
                            this,
                          ),
                          t.on(
                            u.Events.MANIFEST_LOADING,
                            this.onManifestLoading,
                            this,
                          ),
                          t.on(
                            u.Events.MANIFEST_PARSED,
                            this.onManifestParsed,
                            this,
                          ),
                          t.on(
                            u.Events.LEVEL_LOADING,
                            this.onLevelLoading,
                            this,
                          ),
                          t.on(u.Events.LEVEL_LOADED, this.onLevelLoaded, this),
                          t.on(
                            u.Events.FRAG_LOAD_EMERGENCY_ABORTED,
                            this.onFragLoadEmergencyAborted,
                            this,
                          ),
                          t.on(u.Events.ERROR, this.onError, this),
                          t.on(
                            u.Events.AUDIO_TRACK_SWITCHING,
                            this.onAudioTrackSwitching,
                            this,
                          ),
                          t.on(
                            u.Events.AUDIO_TRACK_SWITCHED,
                            this.onAudioTrackSwitched,
                            this,
                          ),
                          t.on(
                            u.Events.BUFFER_CREATED,
                            this.onBufferCreated,
                            this,
                          ),
                          t.on(
                            u.Events.BUFFER_FLUSHED,
                            this.onBufferFlushed,
                            this,
                          ),
                          t.on(
                            u.Events.LEVELS_UPDATED,
                            this.onLevelsUpdated,
                            this,
                          ),
                          t.on(
                            u.Events.FRAG_BUFFERED,
                            this.onFragBuffered,
                            this,
                          );
                      }),
                      (E._unregisterListeners = function() {
                        var t = this.hls;
                        t.off(
                          u.Events.MEDIA_ATTACHED,
                          this.onMediaAttached,
                          this,
                        ),
                          t.off(
                            u.Events.MEDIA_DETACHING,
                            this.onMediaDetaching,
                            this,
                          ),
                          t.off(
                            u.Events.MANIFEST_LOADING,
                            this.onManifestLoading,
                            this,
                          ),
                          t.off(
                            u.Events.MANIFEST_PARSED,
                            this.onManifestParsed,
                            this,
                          ),
                          t.off(
                            u.Events.LEVEL_LOADED,
                            this.onLevelLoaded,
                            this,
                          ),
                          t.off(
                            u.Events.FRAG_LOAD_EMERGENCY_ABORTED,
                            this.onFragLoadEmergencyAborted,
                            this,
                          ),
                          t.off(u.Events.ERROR, this.onError, this),
                          t.off(
                            u.Events.AUDIO_TRACK_SWITCHING,
                            this.onAudioTrackSwitching,
                            this,
                          ),
                          t.off(
                            u.Events.AUDIO_TRACK_SWITCHED,
                            this.onAudioTrackSwitched,
                            this,
                          ),
                          t.off(
                            u.Events.BUFFER_CREATED,
                            this.onBufferCreated,
                            this,
                          ),
                          t.off(
                            u.Events.BUFFER_FLUSHED,
                            this.onBufferFlushed,
                            this,
                          ),
                          t.off(
                            u.Events.LEVELS_UPDATED,
                            this.onLevelsUpdated,
                            this,
                          ),
                          t.off(
                            u.Events.FRAG_BUFFERED,
                            this.onFragBuffered,
                            this,
                          );
                      }),
                      (E.onHandlerDestroying = function() {
                        this._unregisterListeners(), this.onMediaDetaching();
                      }),
                      (E.startLoad = function(t) {
                        if (this.levels) {
                          var e = this.lastCurrentTime,
                            r = this.hls;
                          if (
                            (this.stopLoad(),
                            this.setInterval(100),
                            (this.level = -1),
                            (this.fragLoadError = 0),
                            !this.startFragRequested)
                          ) {
                            var n = r.startLevel;
                            -1 === n &&
                              (r.config.testBandwidth && this.levels.length > 1
                                ? ((n = 0), (this.bitrateTest = !0))
                                : (n = r.nextAutoLevel)),
                              (this.level = r.nextLoadLevel = n),
                              (this.loadedmetadata = !1);
                          }
                          e > 0 &&
                            -1 === t &&
                            (this.log(
                              'Override startPosition with lastCurrentTime @' +
                                e.toFixed(3),
                            ),
                            (t = e)),
                            (this.state = a.State.IDLE),
                            (this.nextLoadPosition = this.startPosition = this.lastCurrentTime = t),
                            this.tick();
                        } else
                          (this._forceStartLoad = !0),
                            (this.state = a.State.STOPPED);
                      }),
                      (E.stopLoad = function() {
                        (this._forceStartLoad = !1),
                          t.prototype.stopLoad.call(this);
                      }),
                      (E.doTick = function() {
                        switch (this.state) {
                          case a.State.IDLE:
                            this.doTickIdle();
                            break;
                          case a.State.WAITING_LEVEL:
                            var t,
                              e = this.levels,
                              r = this.level,
                              n =
                                null == e || null === (t = e[r]) || void 0 === t
                                  ? void 0
                                  : t.details;
                            if (
                              n &&
                              (!n.live || this.levelLastLoaded === this.level)
                            ) {
                              if (this.waitForCdnTuneIn(n)) break;
                              this.state = a.State.IDLE;
                              break;
                            }
                            break;
                          case a.State.FRAG_LOADING_WAITING_RETRY:
                            var i,
                              s = self.performance.now(),
                              o = this.retryDate;
                            (!o ||
                              s >= o ||
                              (null !== (i = this.media) &&
                                void 0 !== i &&
                                i.seeking)) &&
                              (this.log(
                                'retryDate reached, switch back to IDLE state',
                              ),
                              this.resetStartWhenNotLoaded(this.level),
                              (this.state = a.State.IDLE));
                        }
                        this.onTickEnd();
                      }),
                      (E.onTickEnd = function() {
                        t.prototype.onTickEnd.call(this),
                          this.checkBuffer(),
                          this.checkFragmentChanged();
                      }),
                      (E.doTickIdle = function() {
                        var t,
                          e,
                          r = this.hls,
                          n = this.levelLastLoaded,
                          i = this.levels,
                          s = this.media,
                          o = r.config,
                          l = r.nextLoadLevel;
                        if (
                          null !== n &&
                          (s ||
                            (!this.startFragRequested &&
                              o.startFragPrefetch)) &&
                          (!this.altAudio || !this.audioOnly) &&
                          i &&
                          i[l]
                        ) {
                          var f = i[l];
                          this.level = r.nextLoadLevel = l;
                          var p = f.details;
                          if (
                            !p ||
                            this.state === a.State.WAITING_LEVEL ||
                            (p.live && this.levelLastLoaded !== l)
                          )
                            this.state = a.State.WAITING_LEVEL;
                          else {
                            var v = this.getMainFwdBufferInfo();
                            if (
                              null !== v &&
                              !(v.len >= this.getMaxBufferLength(f.maxBitrate))
                            ) {
                              if (this._streamEnded(v, p)) {
                                var g = {};
                                return (
                                  this.altAudio && (g.type = 'video'),
                                  this.hls.trigger(u.Events.BUFFER_EOS, g),
                                  void (this.state = a.State.ENDED)
                                );
                              }
                              this.backtrackFragment &&
                                this.backtrackFragment.start > v.end &&
                                (this.backtrackFragment = null);
                              var m = this.backtrackFragment
                                  ? this.backtrackFragment.start
                                  : v.end,
                                y = this.getNextFragment(m, p);
                              if (
                                this.couldBacktrack &&
                                !this.fragPrevious &&
                                y &&
                                'initSegment' !== y.sn &&
                                this.fragmentTracker.getState(y) !==
                                  c.FragmentState.OK
                              ) {
                                var b,
                                  E =
                                    (null != (b = this.backtrackFragment)
                                      ? b
                                      : y
                                    ).sn - p.startSN,
                                  T = p.fragments[E - 1];
                                T &&
                                  y.cc === T.cc &&
                                  ((y = T),
                                  this.fragmentTracker.removeFragment(T));
                              } else
                                this.backtrackFragment &&
                                  v.len &&
                                  (this.backtrackFragment = null);
                              if (
                                y &&
                                this.fragmentTracker.getState(y) ===
                                  c.FragmentState.OK &&
                                this.nextLoadPosition > m
                              ) {
                                var S =
                                  this.audioOnly && !this.altAudio
                                    ? d.ElementaryStreamTypes.AUDIO
                                    : d.ElementaryStreamTypes.VIDEO;
                                s &&
                                  this.afterBufferFlushed(
                                    s,
                                    S,
                                    h.PlaylistLevelType.MAIN,
                                  ),
                                  (y = this.getNextFragment(
                                    this.nextLoadPosition,
                                    p,
                                  ));
                              }
                              y &&
                                (!y.initSegment ||
                                  y.initSegment.data ||
                                  this.bitrateTest ||
                                  (y = y.initSegment),
                                'identity' !==
                                  (null === (t = y.decryptdata) || void 0 === t
                                    ? void 0
                                    : t.keyFormat) ||
                                (null !== (e = y.decryptdata) &&
                                  void 0 !== e &&
                                  e.key)
                                  ? this.loadFragment(y, p, m)
                                  : this.loadKey(y, p));
                            }
                          }
                        }
                      }),
                      (E.loadFragment = function(e, r, n) {
                        var i,
                          s = this.fragmentTracker.getState(e);
                        (this.fragCurrent = e),
                          s === c.FragmentState.NOT_LOADED
                            ? 'initSegment' === e.sn
                              ? this._loadInitSegment(e)
                              : this.bitrateTest
                              ? (this.log(
                                  'Fragment ' +
                                    e.sn +
                                    ' of level ' +
                                    e.level +
                                    ' is being downloaded to test bitrate and will not be buffered',
                                ),
                                this._loadBitrateTestFrag(e))
                              : ((this.startFragRequested = !0),
                                t.prototype.loadFragment.call(this, e, r, n))
                            : s === c.FragmentState.APPENDING
                            ? this.reduceMaxBufferLength(e.duration) &&
                              this.fragmentTracker.removeFragment(e)
                            : 0 ===
                                (null === (i = this.media) || void 0 === i
                                  ? void 0
                                  : i.buffered.length) &&
                              this.fragmentTracker.removeAllFragments();
                      }),
                      (E.getAppendedFrag = function(t) {
                        var e = this.fragmentTracker.getAppendedFrag(
                          t,
                          h.PlaylistLevelType.MAIN,
                        );
                        return e && 'fragment' in e ? e.fragment : e;
                      }),
                      (E.getBufferedFrag = function(t) {
                        return this.fragmentTracker.getBufferedFrag(
                          t,
                          h.PlaylistLevelType.MAIN,
                        );
                      }),
                      (E.followingBufferedFrag = function(t) {
                        return t ? this.getBufferedFrag(t.end + 0.5) : null;
                      }),
                      (E.immediateLevelSwitch = function() {
                        this.abortCurrentFrag(),
                          this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
                      }),
                      (E.nextLevelSwitch = function() {
                        var t = this.levels,
                          e = this.media;
                        if (null != e && e.readyState) {
                          var r,
                            n = this.getAppendedFrag(e.currentTime);
                          if (
                            (n &&
                              n.start > 1 &&
                              this.flushMainBuffer(0, n.start - 1),
                            !e.paused && t)
                          ) {
                            var i = t[this.hls.nextLoadLevel],
                              s = this.fragLastKbps;
                            r =
                              s && this.fragCurrent
                                ? (this.fragCurrent.duration * i.maxBitrate) /
                                    (1e3 * s) +
                                  1
                                : 0;
                          } else r = 0;
                          var a = this.getBufferedFrag(e.currentTime + r);
                          if (a) {
                            var o = this.followingBufferedFrag(a);
                            if (o) {
                              this.abortCurrentFrag();
                              var u = o.maxStartPTS ? o.maxStartPTS : o.start,
                                l = o.duration,
                                c = Math.max(
                                  a.end,
                                  u +
                                    Math.min(
                                      Math.max(
                                        l - this.config.maxFragLookUpTolerance,
                                        0.5 * l,
                                      ),
                                      0.75 * l,
                                    ),
                                );
                              this.flushMainBuffer(c, Number.POSITIVE_INFINITY);
                            }
                          }
                        }
                      }),
                      (E.abortCurrentFrag = function() {
                        var t = this.fragCurrent;
                        switch (
                          ((this.fragCurrent = null),
                          (this.backtrackFragment = null),
                          null != t && t.loader && t.loader.abort(),
                          this.state)
                        ) {
                          case a.State.KEY_LOADING:
                          case a.State.FRAG_LOADING:
                          case a.State.FRAG_LOADING_WAITING_RETRY:
                          case a.State.PARSING:
                          case a.State.PARSED:
                            this.state = a.State.IDLE;
                        }
                        this.nextLoadPosition = this.getLoadPosition();
                      }),
                      (E.flushMainBuffer = function(e, r) {
                        t.prototype.flushMainBuffer.call(
                          this,
                          e,
                          r,
                          this.altAudio ? 'video' : null,
                        );
                      }),
                      (E.onMediaAttached = function(e, r) {
                        t.prototype.onMediaAttached.call(this, e, r);
                        var n = r.media;
                        (this.onvplaying = this.onMediaPlaying.bind(this)),
                          (this.onvseeked = this.onMediaSeeked.bind(this)),
                          n.addEventListener('playing', this.onvplaying),
                          n.addEventListener('seeked', this.onvseeked),
                          (this.gapController = new v.default(
                            this.config,
                            n,
                            this.fragmentTracker,
                            this.hls,
                          ));
                      }),
                      (E.onMediaDetaching = function() {
                        var e = this.media;
                        e &&
                          this.onvplaying &&
                          this.onvseeked &&
                          (e.removeEventListener('playing', this.onvplaying),
                          e.removeEventListener('seeked', this.onvseeked),
                          (this.onvplaying = this.onvseeked = null),
                          (this.videoBuffer = null)),
                          (this.fragPlaying = null),
                          this.gapController &&
                            (this.gapController.destroy(),
                            (this.gapController = null)),
                          t.prototype.onMediaDetaching.call(this);
                      }),
                      (E.onMediaPlaying = function() {
                        this.tick();
                      }),
                      (E.onMediaSeeked = function() {
                        var t = this.media,
                          e = t ? t.currentTime : null;
                        Object(s.isFiniteNumber)(e) &&
                          this.log('Media seeked to ' + e.toFixed(3)),
                          this.tick();
                      }),
                      (E.onManifestLoading = function() {
                        this.log('Trigger BUFFER_RESET'),
                          this.hls.trigger(u.Events.BUFFER_RESET, void 0),
                          this.fragmentTracker.removeAllFragments(),
                          (this.couldBacktrack = !1),
                          (this.startPosition = this.lastCurrentTime = 0),
                          (this.fragPlaying = null),
                          (this.backtrackFragment = null);
                      }),
                      (E.onManifestParsed = function(t, e) {
                        var r,
                          n = !1,
                          i = !1;
                        e.levels.forEach(function(t) {
                          (r = t.audioCodec) &&
                            (-1 !== r.indexOf('mp4a.40.2') && (n = !0),
                            -1 !== r.indexOf('mp4a.40.5') && (i = !0));
                        }),
                          (this.audioCodecSwitch =
                            n && i && !Object(o.changeTypeSupported)()),
                          this.audioCodecSwitch &&
                            this.log(
                              'Both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC',
                            ),
                          (this.levels = e.levels),
                          (this.startFragRequested = !1);
                      }),
                      (E.onLevelLoading = function(t, e) {
                        var r = this.levels;
                        if (r && this.state === a.State.IDLE) {
                          var n = r[e.level];
                          (!n.details ||
                            (n.details.live &&
                              this.levelLastLoaded !== e.level) ||
                            this.waitForCdnTuneIn(n.details)) &&
                            (this.state = a.State.WAITING_LEVEL);
                        }
                      }),
                      (E.onLevelLoaded = function(t, e) {
                        var r,
                          n = this.levels,
                          i = e.level,
                          s = e.details,
                          o = s.totalduration;
                        if (n) {
                          this.log(
                            'Level ' +
                              i +
                              ' loaded [' +
                              s.startSN +
                              ',' +
                              s.endSN +
                              '], cc [' +
                              s.startCC +
                              ', ' +
                              s.endCC +
                              '] duration:' +
                              o,
                          );
                          var l = this.fragCurrent;
                          !l ||
                            (this.state !== a.State.FRAG_LOADING &&
                              this.state !==
                                a.State.FRAG_LOADING_WAITING_RETRY) ||
                            (l.level !== e.level &&
                              l.loader &&
                              ((this.state = a.State.IDLE),
                              (this.backtrackFragment = null),
                              l.loader.abort()));
                          var c = n[i],
                            h = 0;
                          if (
                            s.live ||
                            (null !== (r = c.details) && void 0 !== r && r.live)
                          ) {
                            if (
                              (s.fragments[0] || (s.deltaUpdateFailed = !0),
                              s.deltaUpdateFailed)
                            )
                              return;
                            h = this.alignPlaylists(s, c.details);
                          }
                          if (
                            ((c.details = s),
                            (this.levelLastLoaded = i),
                            this.hls.trigger(u.Events.LEVEL_UPDATED, {
                              details: s,
                              level: i,
                            }),
                            this.state === a.State.WAITING_LEVEL)
                          ) {
                            if (this.waitForCdnTuneIn(s)) return;
                            this.state = a.State.IDLE;
                          }
                          this.startFragRequested
                            ? s.live && this.synchronizeToLiveEdge(s)
                            : this.setStartPosition(s, h),
                            this.tick();
                        } else
                          this.warn(
                            'Levels were reset while loading level ' + i,
                          );
                      }),
                      (E._handleFragmentLoadProgress = function(t) {
                        var e,
                          r = t.frag,
                          n = t.part,
                          i = t.payload,
                          s = this.levels;
                        if (s) {
                          var a = s[r.level],
                            o = a.details;
                          if (o) {
                            var u = a.videoCodec,
                              l = o.PTSKnown || !o.live,
                              c =
                                null === (e = r.initSegment) || void 0 === e
                                  ? void 0
                                  : e.data,
                              d = this._getAudioCodec(a),
                              v = (this.transmuxer =
                                this.transmuxer ||
                                new f.default(
                                  this.hls,
                                  h.PlaylistLevelType.MAIN,
                                  this._handleTransmuxComplete.bind(this),
                                  this._handleTransmuxerFlush.bind(this),
                                )),
                              g = n ? n.index : -1,
                              m = -1 !== g,
                              y = new p.ChunkMetadata(
                                r.level,
                                r.sn,
                                r.stats.chunkCount,
                                i.byteLength,
                                g,
                                m,
                              ),
                              b = this.initPTS[r.cc];
                            v.push(i, c, d, u, r, n, o.totalduration, l, y, b);
                          } else
                            this.warn(
                              'Dropping fragment ' +
                                r.sn +
                                ' of level ' +
                                r.level +
                                ' after level details were reset',
                            );
                        } else
                          this.warn(
                            'Levels were reset while fragment load was in progress. Fragment ' +
                              r.sn +
                              ' of level ' +
                              r.level +
                              ' will not be buffered',
                          );
                      }),
                      (E.onAudioTrackSwitching = function(t, e) {
                        var r = this.altAudio,
                          n = !!e.url,
                          i = e.id;
                        if (!n) {
                          if (this.mediaBuffer !== this.media) {
                            this.log(
                              'Switching on main audio, use media.buffered to schedule main fragment loading',
                            ),
                              (this.mediaBuffer = this.media);
                            var s = this.fragCurrent;
                            null != s &&
                              s.loader &&
                              (this.log(
                                'Switching to main audio track, cancel main fragment load',
                              ),
                              s.loader.abort()),
                              this.resetTransmuxer(),
                              this.resetLoadingState();
                          } else this.audioOnly && this.resetTransmuxer();
                          var a = this.hls;
                          r &&
                            a.trigger(u.Events.BUFFER_FLUSHING, {
                              startOffset: 0,
                              endOffset: Number.POSITIVE_INFINITY,
                              type: 'audio',
                            }),
                            a.trigger(u.Events.AUDIO_TRACK_SWITCHED, { id: i });
                        }
                      }),
                      (E.onAudioTrackSwitched = function(t, e) {
                        var r = e.id,
                          n = !!this.hls.audioTracks[r].url;
                        if (n) {
                          var i = this.videoBuffer;
                          i &&
                            this.mediaBuffer !== i &&
                            (this.log(
                              'Switching on alternate audio, use video.buffered to schedule main fragment loading',
                            ),
                            (this.mediaBuffer = i));
                        }
                        (this.altAudio = n), this.tick();
                      }),
                      (E.onBufferCreated = function(t, e) {
                        var r,
                          n,
                          i = e.tracks,
                          s = !1;
                        for (var a in i) {
                          var o = i[a];
                          if ('main' === o.id) {
                            if (((n = a), (r = o), 'video' === a)) {
                              var u = i[a];
                              u && (this.videoBuffer = u.buffer);
                            }
                          } else s = !0;
                        }
                        s && r
                          ? (this.log(
                              'Alternate track found, use ' +
                                n +
                                '.buffered to schedule main fragment loading',
                            ),
                            (this.mediaBuffer = r.buffer))
                          : (this.mediaBuffer = this.media);
                      }),
                      (E.onFragBuffered = function(t, e) {
                        var r = e.frag,
                          n = e.part;
                        if (!r || r.type === h.PlaylistLevelType.MAIN) {
                          if (this.fragContextChanged(r))
                            return (
                              this.warn(
                                'Fragment ' +
                                  r.sn +
                                  (n ? ' p: ' + n.index : '') +
                                  ' of level ' +
                                  r.level +
                                  ' finished buffering, but was aborted. state: ' +
                                  this.state,
                              ),
                              void (
                                this.state === a.State.PARSED &&
                                (this.state = a.State.IDLE)
                              )
                            );
                          var i = n ? n.stats : r.stats;
                          (this.fragLastKbps = Math.round(
                            (8 * i.total) / (i.buffering.end - i.loading.first),
                          )),
                            'initSegment' !== r.sn && (this.fragPrevious = r),
                            this.fragBufferedComplete(r, n);
                        }
                      }),
                      (E.onError = function(t, e) {
                        switch (e.details) {
                          case g.ErrorDetails.FRAG_LOAD_ERROR:
                          case g.ErrorDetails.FRAG_LOAD_TIMEOUT:
                          case g.ErrorDetails.KEY_LOAD_ERROR:
                          case g.ErrorDetails.KEY_LOAD_TIMEOUT:
                            this.onFragmentOrKeyLoadError(
                              h.PlaylistLevelType.MAIN,
                              e,
                            );
                            break;
                          case g.ErrorDetails.LEVEL_LOAD_ERROR:
                          case g.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                            this.state !== a.State.ERROR &&
                              (e.fatal
                                ? (this.warn('' + e.details),
                                  (this.state = a.State.ERROR))
                                : e.levelRetry ||
                                  this.state !== a.State.WAITING_LEVEL ||
                                  (this.state = a.State.IDLE));
                            break;
                          case g.ErrorDetails.BUFFER_FULL_ERROR:
                            if (
                              'main' === e.parent &&
                              (this.state === a.State.PARSING ||
                                this.state === a.State.PARSED)
                            ) {
                              var r = !0,
                                n = this.getFwdBufferInfo(
                                  this.media,
                                  h.PlaylistLevelType.MAIN,
                                );
                              n &&
                                n.len > 0.5 &&
                                (r = !this.reduceMaxBufferLength(n.len)),
                                r &&
                                  (this.warn(
                                    'buffer full error also media.currentTime is not buffered, flush main',
                                  ),
                                  this.immediateLevelSwitch()),
                                this.resetLoadingState();
                            }
                        }
                      }),
                      (E.checkBuffer = function() {
                        var t = this.media,
                          e = this.gapController;
                        if (t && e && t.readyState) {
                          if (
                            this.loadedmetadata ||
                            !l.BufferHelper.getBuffered(t).length
                          ) {
                            var r =
                              this.state !== a.State.IDLE
                                ? this.fragCurrent
                                : null;
                            e.poll(this.lastCurrentTime, r);
                          }
                          this.lastCurrentTime = t.currentTime;
                        }
                      }),
                      (E.onFragLoadEmergencyAborted = function() {
                        (this.state = a.State.IDLE),
                          this.loadedmetadata ||
                            ((this.startFragRequested = !1),
                            (this.nextLoadPosition = this.startPosition)),
                          this.tickImmediate();
                      }),
                      (E.onBufferFlushed = function(t, e) {
                        var r = e.type;
                        if (
                          r !== d.ElementaryStreamTypes.AUDIO ||
                          (this.audioOnly && !this.altAudio)
                        ) {
                          var n =
                            (r === d.ElementaryStreamTypes.VIDEO
                              ? this.videoBuffer
                              : this.mediaBuffer) || this.media;
                          this.afterBufferFlushed(
                            n,
                            r,
                            h.PlaylistLevelType.MAIN,
                          );
                        }
                      }),
                      (E.onLevelsUpdated = function(t, e) {
                        this.levels = e.levels;
                      }),
                      (E.swapAudioCodec = function() {
                        this.audioCodecSwap = !this.audioCodecSwap;
                      }),
                      (E.seekToStartPos = function() {
                        var t = this.media;
                        if (t) {
                          var e = t.currentTime,
                            r = this.startPosition;
                          if (r >= 0 && e < r) {
                            if (t.seeking)
                              return void this.log(
                                'could not seek to ' +
                                  r +
                                  ', already seeking at ' +
                                  e,
                              );
                            var n = l.BufferHelper.getBuffered(t),
                              i = (n.length ? n.start(0) : 0) - r;
                            i > 0 &&
                              (i < this.config.maxBufferHole ||
                                i < this.config.maxFragLookUpTolerance) &&
                              (this.log(
                                'adjusting start position by ' +
                                  i +
                                  ' to match buffer start',
                              ),
                              (r += i),
                              (this.startPosition = r)),
                              this.log(
                                'seek to target start position ' +
                                  r +
                                  ' from current time ' +
                                  e,
                              ),
                              (t.currentTime = r);
                          }
                        }
                      }),
                      (E._getAudioCodec = function(t) {
                        var e = this.config.defaultAudioCodec || t.audioCodec;
                        return (
                          this.audioCodecSwap &&
                            e &&
                            (this.log('Swapping audio codec'),
                            (e =
                              -1 !== e.indexOf('mp4a.40.5')
                                ? 'mp4a.40.2'
                                : 'mp4a.40.5')),
                          e
                        );
                      }),
                      (E._loadBitrateTestFrag = function(t) {
                        var e = this;
                        (t.bitrateTest = !0),
                          this._doFragLoad(t).then(function(r) {
                            var n = e.hls;
                            if (
                              r &&
                              !n.nextLoadLevel &&
                              !e.fragContextChanged(t)
                            ) {
                              (e.fragLoadError = 0),
                                (e.state = a.State.IDLE),
                                (e.startFragRequested = !1),
                                (e.bitrateTest = !1);
                              var i = t.stats;
                              (i.parsing.start = i.parsing.end = i.buffering.start = i.buffering.end = self.performance.now()),
                                n.trigger(u.Events.FRAG_LOADED, r),
                                (t.bitrateTest = !1);
                            }
                          });
                      }),
                      (E._handleTransmuxComplete = function(t) {
                        var e,
                          r = 'main',
                          n = this.hls,
                          i = t.remuxResult,
                          o = t.chunkMeta,
                          l = this.getCurrentContext(o);
                        if (!l)
                          return (
                            this.warn(
                              'The loading context changed while buffering fragment ' +
                                o.sn +
                                ' of level ' +
                                o.level +
                                '. This chunk will not be buffered.',
                            ),
                            void this.resetStartWhenNotLoaded(o.level)
                          );
                        var c = l.frag,
                          h = l.part,
                          f = l.level,
                          p = i.video,
                          v = i.text,
                          g = i.id3,
                          m = i.initSegment,
                          y = f.details,
                          b = this.altAudio ? void 0 : i.audio;
                        if (!this.fragContextChanged(c)) {
                          if (((this.state = a.State.PARSING), m)) {
                            m.tracks &&
                              (this._bufferInitSegment(f, m.tracks, c, o),
                              n.trigger(u.Events.FRAG_PARSING_INIT_SEGMENT, {
                                frag: c,
                                id: r,
                                tracks: m.tracks,
                              }));
                            var E = m.initPTS,
                              T = m.timescale;
                            Object(s.isFiniteNumber)(E) &&
                              ((this.initPTS[c.cc] = E),
                              n.trigger(u.Events.INIT_PTS_FOUND, {
                                frag: c,
                                id: r,
                                initPTS: E,
                                timescale: T,
                              }));
                          }
                          if (p && !1 !== i.independent) {
                            if (y) {
                              var S = p.startPTS,
                                L = p.endPTS,
                                _ = p.startDTS,
                                A = p.endDTS;
                              if (h)
                                h.elementaryStreams[p.type] = {
                                  startPTS: S,
                                  endPTS: L,
                                  startDTS: _,
                                  endDTS: A,
                                };
                              else if (
                                (p.firstKeyFrame &&
                                  p.independent &&
                                  (this.couldBacktrack = !0),
                                p.dropped && p.independent)
                              ) {
                                var D = this.getMainFwdBufferInfo();
                                if (
                                  (D ? D.end : this.getLoadPosition()) +
                                    this.config.maxBufferHole <
                                  (p.firstKeyFramePTS
                                    ? p.firstKeyFramePTS
                                    : S) -
                                    this.config.maxBufferHole
                                )
                                  return void this.backtrack(c);
                                c.setElementaryStreamInfo(
                                  p.type,
                                  c.start,
                                  L,
                                  c.start,
                                  A,
                                  !0,
                                );
                              }
                              c.setElementaryStreamInfo(p.type, S, L, _, A),
                                this.backtrackFragment &&
                                  (this.backtrackFragment = c),
                                this.bufferFragmentData(p, c, h, o);
                            }
                          } else if (!1 === i.independent)
                            return void this.backtrack(c);
                          if (b) {
                            var w = b.startPTS,
                              k = b.endPTS,
                              R = b.startDTS,
                              O = b.endDTS;
                            h &&
                              (h.elementaryStreams[
                                d.ElementaryStreamTypes.AUDIO
                              ] = {
                                startPTS: w,
                                endPTS: k,
                                startDTS: R,
                                endDTS: O,
                              }),
                              c.setElementaryStreamInfo(
                                d.ElementaryStreamTypes.AUDIO,
                                w,
                                k,
                                R,
                                O,
                              ),
                              this.bufferFragmentData(b, c, h, o);
                          }
                          if (
                            y &&
                            null != g &&
                            null !== (e = g.samples) &&
                            void 0 !== e &&
                            e.length
                          ) {
                            var I = {
                              id: r,
                              frag: c,
                              details: y,
                              samples: g.samples,
                            };
                            n.trigger(u.Events.FRAG_PARSING_METADATA, I);
                          }
                          if (y && v) {
                            var C = {
                              id: r,
                              frag: c,
                              details: y,
                              samples: v.samples,
                            };
                            n.trigger(u.Events.FRAG_PARSING_USERDATA, C);
                          }
                        }
                      }),
                      (E._bufferInitSegment = function(t, e, r, n) {
                        var i = this;
                        if (this.state === a.State.PARSING) {
                          (this.audioOnly = !!e.audio && !e.video),
                            this.altAudio && !this.audioOnly && delete e.audio;
                          var s = e.audio,
                            o = e.video,
                            l = e.audiovideo;
                          if (s) {
                            var c = t.audioCodec,
                              h = navigator.userAgent.toLowerCase();
                            this.audioCodecSwitch &&
                              (c &&
                                (c =
                                  -1 !== c.indexOf('mp4a.40.5')
                                    ? 'mp4a.40.2'
                                    : 'mp4a.40.5'),
                              1 !== s.metadata.channelCount &&
                                -1 === h.indexOf('firefox') &&
                                (c = 'mp4a.40.5')),
                              -1 !== h.indexOf('android') &&
                                'audio/mpeg' !== s.container &&
                                ((c = 'mp4a.40.2'),
                                this.log('Android: force audio codec to ' + c)),
                              t.audioCodec &&
                                t.audioCodec !== c &&
                                this.log(
                                  'Swapping manifest audio codec "' +
                                    t.audioCodec +
                                    '" for "' +
                                    c +
                                    '"',
                                ),
                              (s.levelCodec = c),
                              (s.id = 'main'),
                              this.log(
                                'Init audio buffer, container:' +
                                  s.container +
                                  ', codecs[selected/level/parsed]=[' +
                                  (c || '') +
                                  '/' +
                                  (t.audioCodec || '') +
                                  '/' +
                                  s.codec +
                                  ']',
                              );
                          }
                          o &&
                            ((o.levelCodec = t.videoCodec),
                            (o.id = 'main'),
                            this.log(
                              'Init video buffer, container:' +
                                o.container +
                                ', codecs[level/parsed]=[' +
                                (t.videoCodec || '') +
                                '/' +
                                o.codec +
                                ']',
                            )),
                            l &&
                              this.log(
                                'Init audiovideo buffer, container:' +
                                  l.container +
                                  ', codecs[level/parsed]=[' +
                                  (t.attrs.CODECS || '') +
                                  '/' +
                                  l.codec +
                                  ']',
                              ),
                            this.hls.trigger(u.Events.BUFFER_CODECS, e),
                            Object.keys(e).forEach(function(t) {
                              var s = e[t].initSegment;
                              null != s &&
                                s.byteLength &&
                                i.hls.trigger(u.Events.BUFFER_APPENDING, {
                                  type: t,
                                  data: s,
                                  frag: r,
                                  part: null,
                                  chunkMeta: n,
                                  parent: r.type,
                                });
                            }),
                            this.tick();
                        }
                      }),
                      (E.getMainFwdBufferInfo = function() {
                        return this.getFwdBufferInfo(
                          this.mediaBuffer ? this.mediaBuffer : this.media,
                          h.PlaylistLevelType.MAIN,
                        );
                      }),
                      (E.backtrack = function(t) {
                        (this.couldBacktrack = !0),
                          (this.backtrackFragment = t),
                          this.resetTransmuxer(),
                          this.flushBufferGap(t),
                          this.fragmentTracker.removeFragment(t),
                          (this.fragPrevious = null),
                          (this.nextLoadPosition = t.start),
                          (this.state = a.State.IDLE);
                      }),
                      (E.checkFragmentChanged = function() {
                        var t = this.media,
                          e = null;
                        if (t && t.readyState > 1 && !1 === t.seeking) {
                          var r = t.currentTime;
                          if (
                            (l.BufferHelper.isBuffered(t, r)
                              ? (e = this.getAppendedFrag(r))
                              : l.BufferHelper.isBuffered(t, r + 0.1) &&
                                (e = this.getAppendedFrag(r + 0.1)),
                            e)
                          ) {
                            this.backtrackFragment = null;
                            var n = this.fragPlaying,
                              i = e.level;
                            (n &&
                              e.sn === n.sn &&
                              n.level === i &&
                              e.urlId === n.urlId) ||
                              (this.hls.trigger(u.Events.FRAG_CHANGED, {
                                frag: e,
                              }),
                              (n && n.level === i) ||
                                this.hls.trigger(u.Events.LEVEL_SWITCHED, {
                                  level: i,
                                }),
                              (this.fragPlaying = e));
                          }
                        }
                      }),
                      (y = e),
                      (b = [
                        {
                          key: 'nextLevel',
                          get: function() {
                            var t = this.nextBufferedFrag;
                            return t ? t.level : -1;
                          },
                        },
                        {
                          key: 'currentFrag',
                          get: function() {
                            var t = this.media;
                            return t
                              ? this.fragPlaying ||
                                  this.getAppendedFrag(t.currentTime)
                              : null;
                          },
                        },
                        {
                          key: 'currentProgramDateTime',
                          get: function() {
                            var t = this.media;
                            if (t) {
                              var e = t.currentTime,
                                r = this.currentFrag;
                              if (
                                r &&
                                Object(s.isFiniteNumber)(e) &&
                                Object(s.isFiniteNumber)(r.programDateTime)
                              ) {
                                var n = r.programDateTime + 1e3 * (e - r.start);
                                return new Date(n);
                              }
                            }
                            return null;
                          },
                        },
                        {
                          key: 'currentLevel',
                          get: function() {
                            var t = this.currentFrag;
                            return t ? t.level : -1;
                          },
                        },
                        {
                          key: 'nextBufferedFrag',
                          get: function() {
                            var t = this.currentFrag;
                            return t ? this.followingBufferedFrag(t) : null;
                          },
                        },
                        {
                          key: 'forceStartLoad',
                          get: function() {
                            return this._forceStartLoad;
                          },
                        },
                      ]) && n(y.prototype, b),
                      Object.defineProperty(y, 'prototype', { writable: !1 }),
                      e
                    );
                  })(a.default);
              },
              './src/controller/subtitle-stream-controller.ts': function(
                t,
                e,
                r,
              ) {
                function n(t, e) {
                  for (var r = 0; r < e.length; r++) {
                    var n = e[r];
                    (n.enumerable = n.enumerable || !1),
                      (n.configurable = !0),
                      'value' in n && (n.writable = !0),
                      Object.defineProperty(t, n.key, n);
                  }
                }
                function i(t, e) {
                  return (i = Object.setPrototypeOf
                    ? Object.setPrototypeOf.bind()
                    : function(t, e) {
                        return (t.__proto__ = e), t;
                      })(t, e);
                }
                r.r(e),
                  r.d(e, 'SubtitleStreamController', function() {
                    return p;
                  });
                var s = r('./src/events.ts'),
                  a = r('./src/utils/buffer-helper.ts'),
                  o = r('./src/controller/fragment-finders.ts'),
                  u = r('./src/utils/discontinuities.ts'),
                  l = r('./src/controller/level-helper.ts'),
                  c = r('./src/controller/fragment-tracker.ts'),
                  h = r('./src/controller/base-stream-controller.ts'),
                  d = r('./src/types/loader.ts'),
                  f = r('./src/types/level.ts'),
                  p = (function(t) {
                    function e(e, r) {
                      var n;
                      return (
                        ((n =
                          t.call(this, e, r, '[subtitle-stream-controller]') ||
                          this).levels = []),
                        (n.currentTrackId = -1),
                        (n.tracksBuffered = []),
                        (n.mainDetails = null),
                        n._registerListeners(),
                        n
                      );
                    }
                    var r, p;
                    (p = t),
                      ((r = e).prototype = Object.create(p.prototype)),
                      (r.prototype.constructor = r),
                      i(r, p);
                    var g,
                      m,
                      y = e.prototype;
                    return (
                      (y.onHandlerDestroying = function() {
                        this._unregisterListeners(), (this.mainDetails = null);
                      }),
                      (y._registerListeners = function() {
                        var t = this.hls;
                        t.on(
                          s.Events.MEDIA_ATTACHED,
                          this.onMediaAttached,
                          this,
                        ),
                          t.on(
                            s.Events.MEDIA_DETACHING,
                            this.onMediaDetaching,
                            this,
                          ),
                          t.on(
                            s.Events.MANIFEST_LOADING,
                            this.onManifestLoading,
                            this,
                          ),
                          t.on(s.Events.LEVEL_LOADED, this.onLevelLoaded, this),
                          t.on(s.Events.ERROR, this.onError, this),
                          t.on(
                            s.Events.SUBTITLE_TRACKS_UPDATED,
                            this.onSubtitleTracksUpdated,
                            this,
                          ),
                          t.on(
                            s.Events.SUBTITLE_TRACK_SWITCH,
                            this.onSubtitleTrackSwitch,
                            this,
                          ),
                          t.on(
                            s.Events.SUBTITLE_TRACK_LOADED,
                            this.onSubtitleTrackLoaded,
                            this,
                          ),
                          t.on(
                            s.Events.SUBTITLE_FRAG_PROCESSED,
                            this.onSubtitleFragProcessed,
                            this,
                          ),
                          t.on(
                            s.Events.BUFFER_FLUSHING,
                            this.onBufferFlushing,
                            this,
                          );
                      }),
                      (y._unregisterListeners = function() {
                        var t = this.hls;
                        t.off(
                          s.Events.MEDIA_ATTACHED,
                          this.onMediaAttached,
                          this,
                        ),
                          t.off(
                            s.Events.MEDIA_DETACHING,
                            this.onMediaDetaching,
                            this,
                          ),
                          t.off(
                            s.Events.MANIFEST_LOADING,
                            this.onManifestLoading,
                            this,
                          ),
                          t.off(
                            s.Events.LEVEL_LOADED,
                            this.onLevelLoaded,
                            this,
                          ),
                          t.off(s.Events.ERROR, this.onError, this),
                          t.off(
                            s.Events.SUBTITLE_TRACKS_UPDATED,
                            this.onSubtitleTracksUpdated,
                            this,
                          ),
                          t.off(
                            s.Events.SUBTITLE_TRACK_SWITCH,
                            this.onSubtitleTrackSwitch,
                            this,
                          ),
                          t.off(
                            s.Events.SUBTITLE_TRACK_LOADED,
                            this.onSubtitleTrackLoaded,
                            this,
                          ),
                          t.off(
                            s.Events.SUBTITLE_FRAG_PROCESSED,
                            this.onSubtitleFragProcessed,
                            this,
                          ),
                          t.off(
                            s.Events.BUFFER_FLUSHING,
                            this.onBufferFlushing,
                            this,
                          );
                      }),
                      (y.startLoad = function() {
                        this.stopLoad(),
                          (this.state = h.State.IDLE),
                          this.setInterval(500),
                          this.tick();
                      }),
                      (y.onManifestLoading = function() {
                        (this.mainDetails = null),
                          this.fragmentTracker.removeAllFragments();
                      }),
                      (y.onLevelLoaded = function(t, e) {
                        this.mainDetails = e.details;
                      }),
                      (y.onSubtitleFragProcessed = function(t, e) {
                        var r = e.frag,
                          n = e.success;
                        if (
                          ((this.fragPrevious = r),
                          (this.state = h.State.IDLE),
                          n)
                        ) {
                          var i = this.tracksBuffered[this.currentTrackId];
                          if (i) {
                            for (var s, a = r.start, o = 0; o < i.length; o++)
                              if (a >= i[o].start && a <= i[o].end) {
                                s = i[o];
                                break;
                              }
                            var u = r.start + r.duration;
                            s
                              ? (s.end = u)
                              : ((s = { start: a, end: u }), i.push(s)),
                              this.fragmentTracker.fragBuffered(r);
                          }
                        }
                      }),
                      (y.onBufferFlushing = function(t, e) {
                        var r = e.startOffset,
                          n = e.endOffset;
                        if (0 === r && n !== Number.POSITIVE_INFINITY) {
                          var i = this.currentTrackId,
                            s = this.levels;
                          if (!s.length || !s[i] || !s[i].details) return;
                          var a = n - s[i].details.targetduration;
                          if (a <= 0) return;
                          (e.endOffsetSubtitles = Math.max(0, a)),
                            this.tracksBuffered.forEach(function(t) {
                              for (var e = 0; e < t.length; )
                                if (t[e].end <= a) t.shift();
                                else {
                                  if (!(t[e].start < a)) break;
                                  (t[e].start = a), e++;
                                }
                            }),
                            this.fragmentTracker.removeFragmentsInRange(
                              r,
                              a,
                              d.PlaylistLevelType.SUBTITLE,
                            );
                        }
                      }),
                      (y.onError = function(t, e) {
                        var r,
                          n = e.frag;
                        n &&
                          n.type === d.PlaylistLevelType.SUBTITLE &&
                          (null !== (r = this.fragCurrent) &&
                            void 0 !== r &&
                            r.loader &&
                            this.fragCurrent.loader.abort(),
                          (this.state = h.State.IDLE));
                      }),
                      (y.onSubtitleTracksUpdated = function(t, e) {
                        var r = this,
                          n = e.subtitleTracks;
                        (this.tracksBuffered = []),
                          (this.levels = n.map(function(t) {
                            return new f.Level(t);
                          })),
                          this.fragmentTracker.removeAllFragments(),
                          (this.fragPrevious = null),
                          this.levels.forEach(function(t) {
                            r.tracksBuffered[t.id] = [];
                          }),
                          (this.mediaBuffer = null);
                      }),
                      (y.onSubtitleTrackSwitch = function(t, e) {
                        if (
                          ((this.currentTrackId = e.id),
                          this.levels.length && -1 !== this.currentTrackId)
                        ) {
                          var r = this.levels[this.currentTrackId];
                          null != r && r.details
                            ? (this.mediaBuffer = this.mediaBufferTimeRanges)
                            : (this.mediaBuffer = null),
                            r && this.setInterval(500);
                        } else this.clearInterval();
                      }),
                      (y.onSubtitleTrackLoaded = function(t, e) {
                        var r,
                          n = e.details,
                          i = e.id,
                          s = this.currentTrackId,
                          a = this.levels;
                        if (a.length) {
                          var c = a[s];
                          if (!(i >= a.length || i !== s) && c) {
                            if (
                              ((this.mediaBuffer = this.mediaBufferTimeRanges),
                              n.live ||
                                (null !== (r = c.details) &&
                                  void 0 !== r &&
                                  r.live))
                            ) {
                              var d = this.mainDetails;
                              if (n.deltaUpdateFailed || !d) return;
                              var f = d.fragments[0];
                              c.details
                                ? 0 === this.alignPlaylists(n, c.details) &&
                                  f &&
                                  Object(l.addSliding)(n, f.start)
                                : n.hasProgramDateTime && d.hasProgramDateTime
                                ? Object(u.alignMediaPlaylistByPDT)(n, d)
                                : f && Object(l.addSliding)(n, f.start);
                            }
                            (c.details = n),
                              (this.levelLastLoaded = i),
                              this.tick(),
                              n.live &&
                                !this.fragCurrent &&
                                this.media &&
                                this.state === h.State.IDLE &&
                                (Object(o.findFragmentByPTS)(
                                  null,
                                  n.fragments,
                                  this.media.currentTime,
                                  0,
                                ) ||
                                  (this.warn(
                                    'Subtitle playlist not aligned with playback',
                                  ),
                                  (c.details = void 0)));
                          }
                        }
                      }),
                      (y._handleFragmentLoadComplete = function(t) {
                        var e = t.frag,
                          r = t.payload,
                          n = e.decryptdata,
                          i = this.hls;
                        if (
                          !this.fragContextChanged(e) &&
                          r &&
                          r.byteLength > 0 &&
                          n &&
                          n.key &&
                          n.iv &&
                          'AES-128' === n.method
                        ) {
                          var a = performance.now();
                          this.decrypter
                            .webCryptoDecrypt(
                              new Uint8Array(r),
                              n.key.buffer,
                              n.iv.buffer,
                            )
                            .then(function(t) {
                              var r = performance.now();
                              i.trigger(s.Events.FRAG_DECRYPTED, {
                                frag: e,
                                payload: t,
                                stats: { tstart: a, tdecrypt: r },
                              });
                            });
                        }
                      }),
                      (y.doTick = function() {
                        if (this.media) {
                          if (this.state === h.State.IDLE) {
                            var t = this.currentTrackId,
                              e = this.levels;
                            if (!e.length || !e[t] || !e[t].details) return;
                            var r = e[t].details,
                              n = r.targetduration,
                              i = this.config,
                              s = this.media,
                              u = a.BufferHelper.bufferedInfo(
                                this.tracksBuffered[this.currentTrackId] || [],
                                s.currentTime - n,
                                i.maxBufferHole,
                              ),
                              l = u.end;
                            if (u.len > this.getMaxBufferLength() + n) return;
                            console.assert(
                              r,
                              'Subtitle track details are defined on idle subtitle stream controller tick',
                            );
                            var d,
                              f = r.fragments,
                              p = f.length,
                              v = r.edge,
                              g = this.fragPrevious;
                            if (l < v) {
                              var m = i.maxFragLookUpTolerance;
                              !(d = Object(o.findFragmentByPTS)(
                                g,
                                f,
                                Math.max(f[0].start, l),
                                m,
                              )) &&
                                g &&
                                g.start < f[0].start &&
                                (d = f[0]);
                            } else d = f[p - 1];
                            if (!(d = this.mapToInitFragWhenRequired(d)))
                              return;
                            if (
                              this.fragmentTracker.getState(d) !==
                              c.FragmentState.NOT_LOADED
                            )
                              return;
                            d.encrypted
                              ? this.loadKey(d, r)
                              : this.loadFragment(d, r, l);
                          }
                        } else this.state = h.State.IDLE;
                      }),
                      (y.loadFragment = function(e, r, n) {
                        (this.fragCurrent = e),
                          'initSegment' === e.sn
                            ? this._loadInitSegment(e)
                            : t.prototype.loadFragment.call(this, e, r, n);
                      }),
                      (g = e),
                      (m = [
                        {
                          key: 'mediaBufferTimeRanges',
                          get: function() {
                            return new v(
                              this.tracksBuffered[this.currentTrackId] || [],
                            );
                          },
                        },
                      ]) && n(g.prototype, m),
                      Object.defineProperty(g, 'prototype', { writable: !1 }),
                      e
                    );
                  })(h.default),
                  v = function(t) {
                    this.buffered = void 0;
                    var e = function(e, r, n) {
                      if ((r >>>= 0) > n - 1)
                        throw new DOMException(
                          "Failed to execute '" +
                            e +
                            "' on 'TimeRanges': The index provided (" +
                            r +
                            ') is greater than the maximum bound (' +
                            n +
                            ')',
                        );
                      return t[r][e];
                    };
                    this.buffered = {
                      get length() {
                        return t.length;
                      },
                      end: function(r) {
                        return e('end', r, t.length);
                      },
                      start: function(r) {
                        return e('start', r, t.length);
                      },
                    };
                  };
              },
              './src/controller/subtitle-track-controller.ts': function(
                t,
                e,
                r,
              ) {
                function n(t, e) {
                  for (var r = 0; r < e.length; r++) {
                    var n = e[r];
                    (n.enumerable = n.enumerable || !1),
                      (n.configurable = !0),
                      'value' in n && (n.writable = !0),
                      Object.defineProperty(t, n.key, n);
                  }
                }
                function i(t, e) {
                  return (i = Object.setPrototypeOf
                    ? Object.setPrototypeOf.bind()
                    : function(t, e) {
                        return (t.__proto__ = e), t;
                      })(t, e);
                }
                function s(t) {
                  for (var e = [], r = 0; r < t.length; r++) {
                    var n = t[r];
                    'subtitles' === n.kind && n.label && e.push(t[r]);
                  }
                  return e;
                }
                r.r(e);
                var a = r('./src/events.ts'),
                  o = r('./src/utils/texttrack-utils.ts'),
                  u = r('./src/controller/base-playlist-controller.ts'),
                  l = r('./src/types/loader.ts'),
                  c = (function(t) {
                    function e(e) {
                      var r;
                      return (
                        ((r =
                          t.call(this, e, '[subtitle-track-controller]') ||
                          this).media = null),
                        (r.tracks = []),
                        (r.groupId = null),
                        (r.tracksInGroup = []),
                        (r.trackId = -1),
                        (r.selectDefaultTrack = !0),
                        (r.queuedDefaultTrack = -1),
                        (r.trackChangeListener = function() {
                          return r.onTextTracksChanged();
                        }),
                        (r.asyncPollTrackChange = function() {
                          return r.pollTrackChange(0);
                        }),
                        (r.useTextTrackPolling = !1),
                        (r.subtitlePollingInterval = -1),
                        (r._subtitleDisplay = !0),
                        r.registerListeners(),
                        r
                      );
                    }
                    var r, u;
                    (u = t),
                      ((r = e).prototype = Object.create(u.prototype)),
                      (r.prototype.constructor = r),
                      i(r, u);
                    var c,
                      h,
                      d = e.prototype;
                    return (
                      (d.destroy = function() {
                        this.unregisterListeners(),
                          (this.tracks.length = 0),
                          (this.tracksInGroup.length = 0),
                          (this.trackChangeListener = this.asyncPollTrackChange = null),
                          t.prototype.destroy.call(this);
                      }),
                      (d.registerListeners = function() {
                        var t = this.hls;
                        t.on(
                          a.Events.MEDIA_ATTACHED,
                          this.onMediaAttached,
                          this,
                        ),
                          t.on(
                            a.Events.MEDIA_DETACHING,
                            this.onMediaDetaching,
                            this,
                          ),
                          t.on(
                            a.Events.MANIFEST_LOADING,
                            this.onManifestLoading,
                            this,
                          ),
                          t.on(
                            a.Events.MANIFEST_PARSED,
                            this.onManifestParsed,
                            this,
                          ),
                          t.on(
                            a.Events.LEVEL_LOADING,
                            this.onLevelLoading,
                            this,
                          ),
                          t.on(
                            a.Events.LEVEL_SWITCHING,
                            this.onLevelSwitching,
                            this,
                          ),
                          t.on(
                            a.Events.SUBTITLE_TRACK_LOADED,
                            this.onSubtitleTrackLoaded,
                            this,
                          ),
                          t.on(a.Events.ERROR, this.onError, this);
                      }),
                      (d.unregisterListeners = function() {
                        var t = this.hls;
                        t.off(
                          a.Events.MEDIA_ATTACHED,
                          this.onMediaAttached,
                          this,
                        ),
                          t.off(
                            a.Events.MEDIA_DETACHING,
                            this.onMediaDetaching,
                            this,
                          ),
                          t.off(
                            a.Events.MANIFEST_LOADING,
                            this.onManifestLoading,
                            this,
                          ),
                          t.off(
                            a.Events.MANIFEST_PARSED,
                            this.onManifestParsed,
                            this,
                          ),
                          t.off(
                            a.Events.LEVEL_LOADING,
                            this.onLevelLoading,
                            this,
                          ),
                          t.off(
                            a.Events.LEVEL_SWITCHING,
                            this.onLevelSwitching,
                            this,
                          ),
                          t.off(
                            a.Events.SUBTITLE_TRACK_LOADED,
                            this.onSubtitleTrackLoaded,
                            this,
                          ),
                          t.off(a.Events.ERROR, this.onError, this);
                      }),
                      (d.onMediaAttached = function(t, e) {
                        (this.media = e.media),
                          this.media &&
                            (this.queuedDefaultTrack > -1 &&
                              ((this.subtitleTrack = this.queuedDefaultTrack),
                              (this.queuedDefaultTrack = -1)),
                            (this.useTextTrackPolling = !(
                              this.media.textTracks &&
                              'onchange' in this.media.textTracks
                            )),
                            this.useTextTrackPolling
                              ? this.pollTrackChange(500)
                              : this.media.textTracks.addEventListener(
                                  'change',
                                  this.asyncPollTrackChange,
                                ));
                      }),
                      (d.pollTrackChange = function(t) {
                        self.clearInterval(this.subtitlePollingInterval),
                          (this.subtitlePollingInterval = self.setInterval(
                            this.trackChangeListener,
                            t,
                          ));
                      }),
                      (d.onMediaDetaching = function() {
                        this.media &&
                          (self.clearInterval(this.subtitlePollingInterval),
                          this.useTextTrackPolling ||
                            this.media.textTracks.removeEventListener(
                              'change',
                              this.asyncPollTrackChange,
                            ),
                          this.trackId > -1 &&
                            (this.queuedDefaultTrack = this.trackId),
                          s(this.media.textTracks).forEach(function(t) {
                            Object(o.clearCurrentCues)(t);
                          }),
                          (this.subtitleTrack = -1),
                          (this.media = null));
                      }),
                      (d.onManifestLoading = function() {
                        (this.tracks = []),
                          (this.groupId = null),
                          (this.tracksInGroup = []),
                          (this.trackId = -1),
                          (this.selectDefaultTrack = !0);
                      }),
                      (d.onManifestParsed = function(t, e) {
                        this.tracks = e.subtitleTracks;
                      }),
                      (d.onSubtitleTrackLoaded = function(t, e) {
                        var r = e.id,
                          n = e.details,
                          i = this.trackId,
                          s = this.tracksInGroup[i];
                        if (s) {
                          var a = s.details;
                          (s.details = e.details),
                            this.log(
                              'subtitle track ' +
                                r +
                                ' loaded [' +
                                n.startSN +
                                '-' +
                                n.endSN +
                                ']',
                            ),
                            r === this.trackId &&
                              ((this.retryCount = 0),
                              this.playlistLoaded(r, e, a));
                        } else this.warn('Invalid subtitle track id ' + r);
                      }),
                      (d.onLevelLoading = function(t, e) {
                        this.switchLevel(e.level);
                      }),
                      (d.onLevelSwitching = function(t, e) {
                        this.switchLevel(e.level);
                      }),
                      (d.switchLevel = function(t) {
                        var e = this.hls.levels[t];
                        if (null != e && e.textGroupIds) {
                          var r = e.textGroupIds[e.urlId];
                          if (this.groupId !== r) {
                            var n = this.tracksInGroup
                                ? this.tracksInGroup[this.trackId]
                                : void 0,
                              i = this.tracks.filter(function(t) {
                                return !r || t.groupId === r;
                              });
                            this.tracksInGroup = i;
                            var s =
                              this.findTrackId(null == n ? void 0 : n.name) ||
                              this.findTrackId();
                            this.groupId = r;
                            var o = { subtitleTracks: i };
                            this.log(
                              'Updating subtitle tracks, ' +
                                i.length +
                                ' track(s) found in "' +
                                r +
                                '" group-id',
                            ),
                              this.hls.trigger(
                                a.Events.SUBTITLE_TRACKS_UPDATED,
                                o,
                              ),
                              -1 !== s && this.setSubtitleTrack(s, n);
                          }
                        }
                      }),
                      (d.findTrackId = function(t) {
                        for (
                          var e = this.tracksInGroup, r = 0;
                          r < e.length;
                          r++
                        ) {
                          var n = e[r];
                          if (
                            (!this.selectDefaultTrack || n.default) &&
                            (!t || t === n.name)
                          )
                            return n.id;
                        }
                        return -1;
                      }),
                      (d.onError = function(e, r) {
                        t.prototype.onError.call(this, e, r),
                          !r.fatal &&
                            r.context &&
                            r.context.type ===
                              l.PlaylistContextType.SUBTITLE_TRACK &&
                            r.context.id === this.trackId &&
                            r.context.groupId === this.groupId &&
                            this.retryLoadingOrFail(r);
                      }),
                      (d.loadPlaylist = function(t) {
                        var e = this.tracksInGroup[this.trackId];
                        if (this.shouldLoadTrack(e)) {
                          var r = e.id,
                            n = e.groupId,
                            i = e.url;
                          if (t)
                            try {
                              i = t.addDirectives(i);
                            } catch (t) {
                              this.warn(
                                'Could not construct new URL with HLS Delivery Directives: ' +
                                  t,
                              );
                            }
                          this.log('Loading subtitle playlist for id ' + r),
                            this.hls.trigger(a.Events.SUBTITLE_TRACK_LOADING, {
                              url: i,
                              id: r,
                              groupId: n,
                              deliveryDirectives: t || null,
                            });
                        }
                      }),
                      (d.toggleTrackModes = function(t) {
                        var e = this,
                          r = this.media,
                          n = this.trackId;
                        if (r) {
                          var i = s(r.textTracks),
                            a = i.filter(function(t) {
                              return t.groupId === e.groupId;
                            });
                          if (-1 === t)
                            [].slice.call(i).forEach(function(t) {
                              t.mode = 'disabled';
                            });
                          else {
                            var o = a[n];
                            o && (o.mode = 'disabled');
                          }
                          var u = a[t];
                          u &&
                            (u.mode = this.subtitleDisplay
                              ? 'showing'
                              : 'hidden');
                        }
                      }),
                      (d.setSubtitleTrack = function(t, e) {
                        var r,
                          n = this.tracksInGroup;
                        if (this.media) {
                          if (
                            (this.trackId !== t && this.toggleTrackModes(t),
                            !(
                              (this.trackId === t &&
                                (-1 === t ||
                                  (null !== (r = n[t]) &&
                                    void 0 !== r &&
                                    r.details))) ||
                              t < -1 ||
                              t >= n.length
                            ))
                          ) {
                            this.clearTimer();
                            var i = n[t];
                            if (
                              (this.log('Switching to subtitle track ' + t),
                              (this.trackId = t),
                              i)
                            ) {
                              var s = i.id,
                                o = i.groupId,
                                u = void 0 === o ? '' : o,
                                l = i.name,
                                c = i.type,
                                h = i.url;
                              this.hls.trigger(a.Events.SUBTITLE_TRACK_SWITCH, {
                                id: s,
                                groupId: u,
                                name: l,
                                type: c,
                                url: h,
                              });
                              var d = this.switchParams(
                                i.url,
                                null == e ? void 0 : e.details,
                              );
                              this.loadPlaylist(d);
                            } else
                              this.hls.trigger(a.Events.SUBTITLE_TRACK_SWITCH, {
                                id: t,
                              });
                          }
                        } else this.queuedDefaultTrack = t;
                      }),
                      (d.onTextTracksChanged = function() {
                        if (
                          (this.useTextTrackPolling ||
                            self.clearInterval(this.subtitlePollingInterval),
                          this.media &&
                            this.hls.config.renderTextTracksNatively)
                        ) {
                          for (
                            var t = -1, e = s(this.media.textTracks), r = 0;
                            r < e.length;
                            r++
                          )
                            if ('hidden' === e[r].mode) t = r;
                            else if ('showing' === e[r].mode) {
                              t = r;
                              break;
                            }
                          this.subtitleTrack !== t && (this.subtitleTrack = t);
                        }
                      }),
                      (c = e),
                      (h = [
                        {
                          key: 'subtitleDisplay',
                          get: function() {
                            return this._subtitleDisplay;
                          },
                          set: function(t) {
                            (this._subtitleDisplay = t),
                              this.trackId > -1 &&
                                this.toggleTrackModes(this.trackId);
                          },
                        },
                        {
                          key: 'subtitleTracks',
                          get: function() {
                            return this.tracksInGroup;
                          },
                        },
                        {
                          key: 'subtitleTrack',
                          get: function() {
                            return this.trackId;
                          },
                          set: function(t) {
                            this.selectDefaultTrack = !1;
                            var e = this.tracksInGroup
                              ? this.tracksInGroup[this.trackId]
                              : void 0;
                            this.setSubtitleTrack(t, e);
                          },
                        },
                      ]) && n(c.prototype, h),
                      Object.defineProperty(c, 'prototype', { writable: !1 }),
                      e
                    );
                  })(u.default);
                e.default = c;
              },
              './src/controller/timeline-controller.ts': function(t, e, r) {
                function n(t, e) {
                  return (
                    t && t.label === e.name && !(t.textTrack1 || t.textTrack2)
                  );
                }
                r.r(e),
                  r.d(e, 'TimelineController', function() {
                    return p;
                  });
                var i = r('./src/polyfills/number.ts'),
                  s = r('./src/events.ts'),
                  a = r('./src/utils/cea-608-parser.ts'),
                  o = r('./src/utils/output-filter.ts'),
                  u = r('./src/utils/webvtt-parser.ts'),
                  l = r('./src/utils/texttrack-utils.ts'),
                  c = r('./src/utils/imsc1-ttml-parser.ts'),
                  h = r('./src/utils/mp4-tools.ts'),
                  d = r('./src/types/loader.ts'),
                  f = r('./src/utils/logger.ts'),
                  p = (function() {
                    function t(t) {
                      if (
                        ((this.hls = void 0),
                        (this.media = null),
                        (this.config = void 0),
                        (this.enabled = !0),
                        (this.Cues = void 0),
                        (this.textTracks = []),
                        (this.tracks = []),
                        (this.initPTS = []),
                        (this.timescale = []),
                        (this.unparsedVttFrags = []),
                        (this.captionsTracks = {}),
                        (this.nonNativeCaptionsTracks = {}),
                        (this.cea608Parser1 = void 0),
                        (this.cea608Parser2 = void 0),
                        (this.lastSn = -1),
                        (this.lastPartIndex = -1),
                        (this.prevCC = -1),
                        (this.vttCCs = {
                          ccOffset: 0,
                          presentationOffset: 0,
                          0: { start: 0, prevCC: -1, new: !0 },
                        }),
                        (this.captionsProperties = void 0),
                        (this.hls = t),
                        (this.config = t.config),
                        (this.Cues = t.config.cueHandler),
                        (this.captionsProperties = {
                          textTrack1: {
                            label: this.config.captionsTextTrack1Label,
                            languageCode: this.config
                              .captionsTextTrack1LanguageCode,
                          },
                          textTrack2: {
                            label: this.config.captionsTextTrack2Label,
                            languageCode: this.config
                              .captionsTextTrack2LanguageCode,
                          },
                          textTrack3: {
                            label: this.config.captionsTextTrack3Label,
                            languageCode: this.config
                              .captionsTextTrack3LanguageCode,
                          },
                          textTrack4: {
                            label: this.config.captionsTextTrack4Label,
                            languageCode: this.config
                              .captionsTextTrack4LanguageCode,
                          },
                        }),
                        this.config.enableCEA708Captions)
                      ) {
                        var e = new o.default(this, 'textTrack1'),
                          r = new o.default(this, 'textTrack2'),
                          n = new o.default(this, 'textTrack3'),
                          i = new o.default(this, 'textTrack4');
                        (this.cea608Parser1 = new a.default(1, e, r)),
                          (this.cea608Parser2 = new a.default(3, n, i));
                      }
                      t.on(
                        s.Events.MEDIA_ATTACHING,
                        this.onMediaAttaching,
                        this,
                      ),
                        t.on(
                          s.Events.MEDIA_DETACHING,
                          this.onMediaDetaching,
                          this,
                        ),
                        t.on(
                          s.Events.MANIFEST_LOADING,
                          this.onManifestLoading,
                          this,
                        ),
                        t.on(
                          s.Events.MANIFEST_LOADED,
                          this.onManifestLoaded,
                          this,
                        ),
                        t.on(
                          s.Events.SUBTITLE_TRACKS_UPDATED,
                          this.onSubtitleTracksUpdated,
                          this,
                        ),
                        t.on(s.Events.FRAG_LOADING, this.onFragLoading, this),
                        t.on(s.Events.FRAG_LOADED, this.onFragLoaded, this),
                        t.on(
                          s.Events.FRAG_PARSING_USERDATA,
                          this.onFragParsingUserdata,
                          this,
                        ),
                        t.on(
                          s.Events.FRAG_DECRYPTED,
                          this.onFragDecrypted,
                          this,
                        ),
                        t.on(
                          s.Events.INIT_PTS_FOUND,
                          this.onInitPtsFound,
                          this,
                        ),
                        t.on(
                          s.Events.SUBTITLE_TRACKS_CLEARED,
                          this.onSubtitleTracksCleared,
                          this,
                        ),
                        t.on(
                          s.Events.BUFFER_FLUSHING,
                          this.onBufferFlushing,
                          this,
                        );
                    }
                    var e = t.prototype;
                    return (
                      (e.destroy = function() {
                        var t = this.hls;
                        t.off(
                          s.Events.MEDIA_ATTACHING,
                          this.onMediaAttaching,
                          this,
                        ),
                          t.off(
                            s.Events.MEDIA_DETACHING,
                            this.onMediaDetaching,
                            this,
                          ),
                          t.off(
                            s.Events.MANIFEST_LOADING,
                            this.onManifestLoading,
                            this,
                          ),
                          t.off(
                            s.Events.MANIFEST_LOADED,
                            this.onManifestLoaded,
                            this,
                          ),
                          t.off(
                            s.Events.SUBTITLE_TRACKS_UPDATED,
                            this.onSubtitleTracksUpdated,
                            this,
                          ),
                          t.off(
                            s.Events.FRAG_LOADING,
                            this.onFragLoading,
                            this,
                          ),
                          t.off(s.Events.FRAG_LOADED, this.onFragLoaded, this),
                          t.off(
                            s.Events.FRAG_PARSING_USERDATA,
                            this.onFragParsingUserdata,
                            this,
                          ),
                          t.off(
                            s.Events.FRAG_DECRYPTED,
                            this.onFragDecrypted,
                            this,
                          ),
                          t.off(
                            s.Events.INIT_PTS_FOUND,
                            this.onInitPtsFound,
                            this,
                          ),
                          t.off(
                            s.Events.SUBTITLE_TRACKS_CLEARED,
                            this.onSubtitleTracksCleared,
                            this,
                          ),
                          t.off(
                            s.Events.BUFFER_FLUSHING,
                            this.onBufferFlushing,
                            this,
                          ),
                          (this.hls = this.config = this.cea608Parser1 = this.cea608Parser2 = null);
                      }),
                      (e.addCues = function(t, e, r, n, i) {
                        for (var a, o, u, l, c = !1, h = i.length; h--; ) {
                          var d = i[h],
                            f =
                              ((a = d[0]),
                              (o = d[1]),
                              (u = e),
                              (l = r),
                              Math.min(o, l) - Math.max(a, u));
                          if (
                            f >= 0 &&
                            ((d[0] = Math.min(d[0], e)),
                            (d[1] = Math.max(d[1], r)),
                            (c = !0),
                            f / (r - e) > 0.5)
                          )
                            return;
                        }
                        if (
                          (c || i.push([e, r]),
                          this.config.renderTextTracksNatively)
                        ) {
                          var p = this.captionsTracks[t];
                          this.Cues.newCue(p, e, r, n);
                        } else {
                          var v = this.Cues.newCue(null, e, r, n);
                          this.hls.trigger(s.Events.CUES_PARSED, {
                            type: 'captions',
                            cues: v,
                            track: t,
                          });
                        }
                      }),
                      (e.onInitPtsFound = function(t, e) {
                        var r = this,
                          n = e.frag,
                          i = e.id,
                          a = e.initPTS,
                          o = e.timescale,
                          u = this.unparsedVttFrags;
                        'main' === i &&
                          ((this.initPTS[n.cc] = a),
                          (this.timescale[n.cc] = o)),
                          u.length &&
                            ((this.unparsedVttFrags = []),
                            u.forEach(function(t) {
                              r.onFragLoaded(s.Events.FRAG_LOADED, t);
                            }));
                      }),
                      (e.getExistingTrack = function(t) {
                        var e = this.media;
                        if (e)
                          for (var r = 0; r < e.textTracks.length; r++) {
                            var n = e.textTracks[r];
                            if (n[t]) return n;
                          }
                        return null;
                      }),
                      (e.createCaptionsTrack = function(t) {
                        this.config.renderTextTracksNatively
                          ? this.createNativeTrack(t)
                          : this.createNonNativeTrack(t);
                      }),
                      (e.createNativeTrack = function(t) {
                        if (!this.captionsTracks[t]) {
                          var e = this.captionsProperties,
                            r = this.captionsTracks,
                            n = this.media,
                            i = e[t],
                            s = i.label,
                            a = i.languageCode,
                            o = this.getExistingTrack(t);
                          if (o)
                            (r[t] = o),
                              Object(l.clearCurrentCues)(r[t]),
                              Object(l.sendAddTrackEvent)(r[t], n);
                          else {
                            var u = this.createTextTrack('captions', s, a);
                            u && ((u[t] = !0), (r[t] = u));
                          }
                        }
                      }),
                      (e.createNonNativeTrack = function(t) {
                        if (!this.nonNativeCaptionsTracks[t]) {
                          var e = this.captionsProperties[t];
                          if (e) {
                            var r = {
                              _id: t,
                              label: e.label,
                              kind: 'captions',
                              default: !!e.media && !!e.media.default,
                              closedCaptions: e.media,
                            };
                            (this.nonNativeCaptionsTracks[t] = r),
                              this.hls.trigger(
                                s.Events.NON_NATIVE_TEXT_TRACKS_FOUND,
                                { tracks: [r] },
                              );
                          }
                        }
                      }),
                      (e.createTextTrack = function(t, e, r) {
                        var n = this.media;
                        if (n) return n.addTextTrack(t, e, r);
                      }),
                      (e.onMediaAttaching = function(t, e) {
                        (this.media = e.media), this._cleanTracks();
                      }),
                      (e.onMediaDetaching = function() {
                        var t = this.captionsTracks;
                        Object.keys(t).forEach(function(e) {
                          Object(l.clearCurrentCues)(t[e]), delete t[e];
                        }),
                          (this.nonNativeCaptionsTracks = {});
                      }),
                      (e.onManifestLoading = function() {
                        (this.lastSn = -1),
                          (this.lastPartIndex = -1),
                          (this.prevCC = -1),
                          (this.vttCCs = {
                            ccOffset: 0,
                            presentationOffset: 0,
                            0: { start: 0, prevCC: -1, new: !0 },
                          }),
                          this._cleanTracks(),
                          (this.tracks = []),
                          (this.captionsTracks = {}),
                          (this.nonNativeCaptionsTracks = {}),
                          (this.textTracks = []),
                          (this.unparsedVttFrags = this.unparsedVttFrags || []),
                          (this.initPTS = []),
                          (this.timescale = []),
                          this.cea608Parser1 &&
                            this.cea608Parser2 &&
                            (this.cea608Parser1.reset(),
                            this.cea608Parser2.reset());
                      }),
                      (e._cleanTracks = function() {
                        var t = this.media;
                        if (t) {
                          var e = t.textTracks;
                          if (e)
                            for (var r = 0; r < e.length; r++)
                              Object(l.clearCurrentCues)(e[r]);
                        }
                      }),
                      (e.onSubtitleTracksUpdated = function(t, e) {
                        var r = this;
                        this.textTracks = [];
                        var i = e.subtitleTracks || [],
                          a = i.some(function(t) {
                            return t.textCodec === c.IMSC1_CODEC;
                          });
                        if (
                          this.config.enableWebVTT ||
                          (a && this.config.enableIMSC1)
                        ) {
                          var o =
                            this.tracks && i && this.tracks.length === i.length;
                          if (
                            ((this.tracks = i || []),
                            this.config.renderTextTracksNatively)
                          ) {
                            var u = this.media ? this.media.textTracks : [];
                            this.tracks.forEach(function(t, e) {
                              var i;
                              if (e < u.length) {
                                for (var s = null, a = 0; a < u.length; a++)
                                  if (n(u[a], t)) {
                                    s = u[a];
                                    break;
                                  }
                                s && (i = s);
                              }
                              if (i) Object(l.clearCurrentCues)(i);
                              else {
                                var o = r._captionsOrSubtitlesFromCharacteristics(
                                  t,
                                );
                                (i = r.createTextTrack(o, t.name, t.lang)) &&
                                  (i.mode = 'disabled');
                              }
                              i &&
                                ((i.groupId = t.groupId), r.textTracks.push(i));
                            });
                          } else if (!o && this.tracks && this.tracks.length) {
                            var h = this.tracks.map(function(t) {
                              return {
                                label: t.name,
                                kind: t.type.toLowerCase(),
                                default: t.default,
                                subtitleTrack: t,
                              };
                            });
                            this.hls.trigger(
                              s.Events.NON_NATIVE_TEXT_TRACKS_FOUND,
                              { tracks: h },
                            );
                          }
                        }
                      }),
                      (e._captionsOrSubtitlesFromCharacteristics = function(t) {
                        var e;
                        if (
                          null !== (e = t.attrs) &&
                          void 0 !== e &&
                          e.CHARACTERISTICS
                        ) {
                          var r = /transcribes-spoken-dialog/gi.test(
                              t.attrs.CHARACTERISTICS,
                            ),
                            n = /describes-music-and-sound/gi.test(
                              t.attrs.CHARACTERISTICS,
                            );
                          if (r && n) return 'captions';
                        }
                        return 'subtitles';
                      }),
                      (e.onManifestLoaded = function(t, e) {
                        var r = this;
                        this.config.enableCEA708Captions &&
                          e.captions &&
                          e.captions.forEach(function(t) {
                            var e = /(?:CC|SERVICE)([1-4])/.exec(t.instreamId);
                            if (e) {
                              var n = 'textTrack' + e[1],
                                i = r.captionsProperties[n];
                              i &&
                                ((i.label = t.name),
                                t.lang && (i.languageCode = t.lang),
                                (i.media = t));
                            }
                          });
                      }),
                      (e.closedCaptionsForLevel = function(t) {
                        var e = this.hls.levels[t.level];
                        return null == e ? void 0 : e.attrs['CLOSED-CAPTIONS'];
                      }),
                      (e.onFragLoading = function(t, e) {
                        var r = this.cea608Parser1,
                          n = this.cea608Parser2,
                          i = this.lastSn,
                          s = this.lastPartIndex;
                        if (
                          this.enabled &&
                          r &&
                          n &&
                          e.frag.type === d.PlaylistLevelType.MAIN
                        ) {
                          var a,
                            o,
                            u = e.frag.sn,
                            l =
                              null !=
                              (a =
                                null == e ||
                                null === (o = e.part) ||
                                void 0 === o
                                  ? void 0
                                  : o.index)
                                ? a
                                : -1;
                          u === i + 1 ||
                            (u === i && l === s + 1) ||
                            (r.reset(), n.reset()),
                            (this.lastSn = u),
                            (this.lastPartIndex = l);
                        }
                      }),
                      (e.onFragLoaded = function(t, e) {
                        var r = e.frag,
                          n = e.payload,
                          a = this.initPTS,
                          o = this.unparsedVttFrags;
                        if (r.type === d.PlaylistLevelType.SUBTITLE)
                          if (n.byteLength) {
                            if (!Object(i.isFiniteNumber)(a[r.cc]))
                              return (
                                o.push(e),
                                void (
                                  a.length &&
                                  this.hls.trigger(
                                    s.Events.SUBTITLE_FRAG_PROCESSED,
                                    {
                                      success: !1,
                                      frag: r,
                                      error: new Error(
                                        'Missing initial subtitle PTS',
                                      ),
                                    },
                                  )
                                )
                              );
                            var u = r.decryptdata,
                              l = 'stats' in e;
                            if (
                              null == u ||
                              null == u.key ||
                              'AES-128' !== u.method ||
                              l
                            ) {
                              var h = this.tracks[r.level],
                                f = this.vttCCs;
                              f[r.cc] ||
                                ((f[r.cc] = {
                                  start: r.start,
                                  prevCC: this.prevCC,
                                  new: !0,
                                }),
                                (this.prevCC = r.cc)),
                                h && h.textCodec === c.IMSC1_CODEC
                                  ? this._parseIMSC1(r, n)
                                  : this._parseVTTs(r, n, f);
                            }
                          } else
                            this.hls.trigger(s.Events.SUBTITLE_FRAG_PROCESSED, {
                              success: !1,
                              frag: r,
                              error: new Error('Empty subtitle payload'),
                            });
                      }),
                      (e._parseIMSC1 = function(t, e) {
                        var r = this,
                          n = this.hls;
                        Object(c.parseIMSC1)(
                          e,
                          this.initPTS[t.cc],
                          this.timescale[t.cc],
                          function(e) {
                            r._appendCues(e, t.level),
                              n.trigger(s.Events.SUBTITLE_FRAG_PROCESSED, {
                                success: !0,
                                frag: t,
                              });
                          },
                          function(e) {
                            f.logger.log('Failed to parse IMSC1: ' + e),
                              n.trigger(s.Events.SUBTITLE_FRAG_PROCESSED, {
                                success: !1,
                                frag: t,
                                error: e,
                              });
                          },
                        );
                      }),
                      (e._parseVTTs = function(t, e, r) {
                        var n,
                          i = this,
                          a = this.hls,
                          o =
                            null !== (n = t.initSegment) &&
                            void 0 !== n &&
                            n.data
                              ? Object(h.appendUint8Array)(
                                  t.initSegment.data,
                                  new Uint8Array(e),
                                )
                              : e;
                        Object(u.parseWebVTT)(
                          o,
                          this.initPTS[t.cc],
                          this.timescale[t.cc],
                          r,
                          t.cc,
                          t.start,
                          function(e) {
                            i._appendCues(e, t.level),
                              a.trigger(s.Events.SUBTITLE_FRAG_PROCESSED, {
                                success: !0,
                                frag: t,
                              });
                          },
                          function(r) {
                            i._fallbackToIMSC1(t, e),
                              f.logger.log('Failed to parse VTT cue: ' + r),
                              a.trigger(s.Events.SUBTITLE_FRAG_PROCESSED, {
                                success: !1,
                                frag: t,
                                error: r,
                              });
                          },
                        );
                      }),
                      (e._fallbackToIMSC1 = function(t, e) {
                        var r = this,
                          n = this.tracks[t.level];
                        n.textCodec ||
                          Object(c.parseIMSC1)(
                            e,
                            this.initPTS[t.cc],
                            this.timescale[t.cc],
                            function() {
                              (n.textCodec = c.IMSC1_CODEC),
                                r._parseIMSC1(t, e);
                            },
                            function() {
                              n.textCodec = 'wvtt';
                            },
                          );
                      }),
                      (e._appendCues = function(t, e) {
                        var r = this.hls;
                        if (this.config.renderTextTracksNatively) {
                          var n = this.textTracks[e];
                          if (!n || 'disabled' === n.mode) return;
                          t.forEach(function(t) {
                            return Object(l.addCueToTrack)(n, t);
                          });
                        } else {
                          var i = this.tracks[e];
                          if (!i) return;
                          var a = i.default ? 'default' : 'subtitles' + e;
                          r.trigger(s.Events.CUES_PARSED, {
                            type: 'subtitles',
                            cues: t,
                            track: a,
                          });
                        }
                      }),
                      (e.onFragDecrypted = function(t, e) {
                        var r = e.frag;
                        if (r.type === d.PlaylistLevelType.SUBTITLE) {
                          if (!Object(i.isFiniteNumber)(this.initPTS[r.cc]))
                            return void this.unparsedVttFrags.push(e);
                          this.onFragLoaded(s.Events.FRAG_LOADED, e);
                        }
                      }),
                      (e.onSubtitleTracksCleared = function() {
                        (this.tracks = []), (this.captionsTracks = {});
                      }),
                      (e.onFragParsingUserdata = function(t, e) {
                        var r = this.cea608Parser1,
                          n = this.cea608Parser2;
                        if (this.enabled && r && n) {
                          var i = e.frag,
                            s = e.samples;
                          if (
                            i.type !== d.PlaylistLevelType.MAIN ||
                            'NONE' !== this.closedCaptionsForLevel(i)
                          )
                            for (var a = 0; a < s.length; a++) {
                              var o = s[a].bytes;
                              if (o) {
                                var u = this.extractCea608Data(o);
                                r.addData(s[a].pts, u[0]),
                                  n.addData(s[a].pts, u[1]);
                              }
                            }
                        }
                      }),
                      (e.onBufferFlushing = function(t, e) {
                        var r = e.startOffset,
                          n = e.endOffset,
                          i = e.endOffsetSubtitles,
                          s = e.type,
                          a = this.media;
                        if (a && !(a.currentTime < n)) {
                          if (!s || 'video' === s) {
                            var o = this.captionsTracks;
                            Object.keys(o).forEach(function(t) {
                              return Object(l.removeCuesInRange)(o[t], r, n);
                            });
                          }
                          if (
                            this.config.renderTextTracksNatively &&
                            0 === r &&
                            void 0 !== i
                          ) {
                            var u = this.textTracks;
                            Object.keys(u).forEach(function(t) {
                              return Object(l.removeCuesInRange)(u[t], r, i);
                            });
                          }
                        }
                      }),
                      (e.extractCea608Data = function(t) {
                        for (
                          var e = [[], []], r = 31 & t[0], n = 2, i = 0;
                          i < r;
                          i++
                        ) {
                          var s = t[n++],
                            a = 127 & t[n++],
                            o = 127 & t[n++];
                          if ((0 !== a || 0 !== o) && 0 != (4 & s)) {
                            var u = 3 & s;
                            (0 !== u && 1 !== u) ||
                              (e[u].push(a), e[u].push(o));
                          }
                        }
                        return e;
                      }),
                      t
                    );
                  })();
              },
              './src/crypt/aes-crypto.ts': function(t, e, r) {
                r.r(e),
                  r.d(e, 'default', function() {
                    return n;
                  });
                var n = (function() {
                  function t(t, e) {
                    (this.subtle = void 0),
                      (this.aesIV = void 0),
                      (this.subtle = t),
                      (this.aesIV = e);
                  }
                  return (
                    (t.prototype.decrypt = function(t, e) {
                      return this.subtle.decrypt(
                        { name: 'AES-CBC', iv: this.aesIV },
                        e,
                        t,
                      );
                    }),
                    t
                  );
                })();
              },
              './src/crypt/aes-decryptor.ts': function(t, e, r) {
                function n(t) {
                  var e = t.byteLength,
                    r = e && new DataView(t.buffer).getUint8(e - 1);
                  return r ? Object(i.sliceUint8)(t, 0, e - r) : t;
                }
                r.r(e),
                  r.d(e, 'removePadding', function() {
                    return n;
                  }),
                  r.d(e, 'default', function() {
                    return s;
                  });
                var i = r('./src/utils/typed-array.ts'),
                  s = (function() {
                    function t() {
                      (this.rcon = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54]),
                        (this.subMix = [
                          new Uint32Array(256),
                          new Uint32Array(256),
                          new Uint32Array(256),
                          new Uint32Array(256),
                        ]),
                        (this.invSubMix = [
                          new Uint32Array(256),
                          new Uint32Array(256),
                          new Uint32Array(256),
                          new Uint32Array(256),
                        ]),
                        (this.sBox = new Uint32Array(256)),
                        (this.invSBox = new Uint32Array(256)),
                        (this.key = new Uint32Array(0)),
                        (this.ksRows = 0),
                        (this.keySize = 0),
                        (this.keySchedule = void 0),
                        (this.invKeySchedule = void 0),
                        this.initTable();
                    }
                    var e = t.prototype;
                    return (
                      (e.uint8ArrayToUint32Array_ = function(t) {
                        for (
                          var e = new DataView(t),
                            r = new Uint32Array(4),
                            n = 0;
                          n < 4;
                          n++
                        )
                          r[n] = e.getUint32(4 * n);
                        return r;
                      }),
                      (e.initTable = function() {
                        var t = this.sBox,
                          e = this.invSBox,
                          r = this.subMix,
                          n = r[0],
                          i = r[1],
                          s = r[2],
                          a = r[3],
                          o = this.invSubMix,
                          u = o[0],
                          l = o[1],
                          c = o[2],
                          h = o[3],
                          d = new Uint32Array(256),
                          f = 0,
                          p = 0,
                          v = 0;
                        for (v = 0; v < 256; v++)
                          d[v] = v < 128 ? v << 1 : (v << 1) ^ 283;
                        for (v = 0; v < 256; v++) {
                          var g = p ^ (p << 1) ^ (p << 2) ^ (p << 3) ^ (p << 4);
                          (g = (g >>> 8) ^ (255 & g) ^ 99),
                            (t[f] = g),
                            (e[g] = f);
                          var m = d[f],
                            y = d[m],
                            b = d[y],
                            E = (257 * d[g]) ^ (16843008 * g);
                          (n[f] = (E << 24) | (E >>> 8)),
                            (i[f] = (E << 16) | (E >>> 16)),
                            (s[f] = (E << 8) | (E >>> 24)),
                            (a[f] = E),
                            (E =
                              (16843009 * b) ^
                              (65537 * y) ^
                              (257 * m) ^
                              (16843008 * f)),
                            (u[g] = (E << 24) | (E >>> 8)),
                            (l[g] = (E << 16) | (E >>> 16)),
                            (c[g] = (E << 8) | (E >>> 24)),
                            (h[g] = E),
                            f
                              ? ((f = m ^ d[d[d[b ^ m]]]), (p ^= d[d[p]]))
                              : (f = p = 1);
                        }
                      }),
                      (e.expandKey = function(t) {
                        for (
                          var e = this.uint8ArrayToUint32Array_(t),
                            r = !0,
                            n = 0;
                          n < e.length && r;

                        )
                          (r = e[n] === this.key[n]), n++;
                        if (!r) {
                          this.key = e;
                          var i = (this.keySize = e.length);
                          if (4 !== i && 6 !== i && 8 !== i)
                            throw new Error('Invalid aes key size=' + i);
                          var s,
                            a,
                            o,
                            u,
                            l = (this.ksRows = 4 * (i + 6 + 1)),
                            c = (this.keySchedule = new Uint32Array(l)),
                            h = (this.invKeySchedule = new Uint32Array(l)),
                            d = this.sBox,
                            f = this.rcon,
                            p = this.invSubMix,
                            v = p[0],
                            g = p[1],
                            m = p[2],
                            y = p[3];
                          for (s = 0; s < l; s++)
                            s < i
                              ? (o = c[s] = e[s])
                              : ((u = o),
                                s % i == 0
                                  ? ((u =
                                      (d[(u = (u << 8) | (u >>> 24)) >>> 24] <<
                                        24) |
                                      (d[(u >>> 16) & 255] << 16) |
                                      (d[(u >>> 8) & 255] << 8) |
                                      d[255 & u]),
                                    (u ^= f[(s / i) | 0] << 24))
                                  : i > 6 &&
                                    s % i == 4 &&
                                    (u =
                                      (d[u >>> 24] << 24) |
                                      (d[(u >>> 16) & 255] << 16) |
                                      (d[(u >>> 8) & 255] << 8) |
                                      d[255 & u]),
                                (c[s] = o = (c[s - i] ^ u) >>> 0));
                          for (a = 0; a < l; a++)
                            (s = l - a),
                              (u = 3 & a ? c[s] : c[s - 4]),
                              (h[a] =
                                a < 4 || s <= 4
                                  ? u
                                  : v[d[u >>> 24]] ^
                                    g[d[(u >>> 16) & 255]] ^
                                    m[d[(u >>> 8) & 255]] ^
                                    y[d[255 & u]]),
                              (h[a] = h[a] >>> 0);
                        }
                      }),
                      (e.networkToHostOrderSwap = function(t) {
                        return (
                          (t << 24) |
                          ((65280 & t) << 8) |
                          ((16711680 & t) >> 8) |
                          (t >>> 24)
                        );
                      }),
                      (e.decrypt = function(t, e, r) {
                        for (
                          var n,
                            i,
                            s,
                            a,
                            o,
                            u,
                            l,
                            c,
                            h,
                            d,
                            f,
                            p,
                            v,
                            g,
                            m = this.keySize + 6,
                            y = this.invKeySchedule,
                            b = this.invSBox,
                            E = this.invSubMix,
                            T = E[0],
                            S = E[1],
                            L = E[2],
                            _ = E[3],
                            A = this.uint8ArrayToUint32Array_(r),
                            D = A[0],
                            w = A[1],
                            k = A[2],
                            R = A[3],
                            O = new Int32Array(t),
                            I = new Int32Array(O.length),
                            C = this.networkToHostOrderSwap;
                          e < O.length;

                        ) {
                          for (
                            h = C(O[e]),
                              d = C(O[e + 1]),
                              f = C(O[e + 2]),
                              p = C(O[e + 3]),
                              o = h ^ y[0],
                              u = p ^ y[1],
                              l = f ^ y[2],
                              c = d ^ y[3],
                              v = 4,
                              g = 1;
                            g < m;
                            g++
                          )
                            (n =
                              T[o >>> 24] ^
                              S[(u >> 16) & 255] ^
                              L[(l >> 8) & 255] ^
                              _[255 & c] ^
                              y[v]),
                              (i =
                                T[u >>> 24] ^
                                S[(l >> 16) & 255] ^
                                L[(c >> 8) & 255] ^
                                _[255 & o] ^
                                y[v + 1]),
                              (s =
                                T[l >>> 24] ^
                                S[(c >> 16) & 255] ^
                                L[(o >> 8) & 255] ^
                                _[255 & u] ^
                                y[v + 2]),
                              (a =
                                T[c >>> 24] ^
                                S[(o >> 16) & 255] ^
                                L[(u >> 8) & 255] ^
                                _[255 & l] ^
                                y[v + 3]),
                              (o = n),
                              (u = i),
                              (l = s),
                              (c = a),
                              (v += 4);
                          (n =
                            (b[o >>> 24] << 24) ^
                            (b[(u >> 16) & 255] << 16) ^
                            (b[(l >> 8) & 255] << 8) ^
                            b[255 & c] ^
                            y[v]),
                            (i =
                              (b[u >>> 24] << 24) ^
                              (b[(l >> 16) & 255] << 16) ^
                              (b[(c >> 8) & 255] << 8) ^
                              b[255 & o] ^
                              y[v + 1]),
                            (s =
                              (b[l >>> 24] << 24) ^
                              (b[(c >> 16) & 255] << 16) ^
                              (b[(o >> 8) & 255] << 8) ^
                              b[255 & u] ^
                              y[v + 2]),
                            (a =
                              (b[c >>> 24] << 24) ^
                              (b[(o >> 16) & 255] << 16) ^
                              (b[(u >> 8) & 255] << 8) ^
                              b[255 & l] ^
                              y[v + 3]),
                            (I[e] = C(n ^ D)),
                            (I[e + 1] = C(a ^ w)),
                            (I[e + 2] = C(s ^ k)),
                            (I[e + 3] = C(i ^ R)),
                            (D = h),
                            (w = d),
                            (k = f),
                            (R = p),
                            (e += 4);
                        }
                        return I.buffer;
                      }),
                      t
                    );
                  })();
              },
              './src/crypt/decrypter.ts': function(t, e, r) {
                r.r(e),
                  r.d(e, 'default', function() {
                    return l;
                  });
                var n = r('./src/crypt/aes-crypto.ts'),
                  i = r('./src/crypt/fast-aes-key.ts'),
                  s = r('./src/crypt/aes-decryptor.ts'),
                  a = r('./src/utils/logger.ts'),
                  o = r('./src/utils/mp4-tools.ts'),
                  u = r('./src/utils/typed-array.ts'),
                  l = (function() {
                    function t(t, e, r) {
                      var n = (void 0 === r ? {} : r).removePKCS7Padding,
                        i = void 0 === n || n;
                      if (
                        ((this.logEnabled = !0),
                        (this.observer = void 0),
                        (this.config = void 0),
                        (this.removePKCS7Padding = void 0),
                        (this.subtle = null),
                        (this.softwareDecrypter = null),
                        (this.key = null),
                        (this.fastAesKey = null),
                        (this.remainderData = null),
                        (this.currentIV = null),
                        (this.currentResult = null),
                        (this.observer = t),
                        (this.config = e),
                        (this.removePKCS7Padding = i),
                        i)
                      )
                        try {
                          var s = self.crypto;
                          s && (this.subtle = s.subtle || s.webkitSubtle);
                        } catch (t) {}
                      null === this.subtle &&
                        (this.config.enableSoftwareAES = !0);
                    }
                    var e = t.prototype;
                    return (
                      (e.destroy = function() {
                        this.observer = null;
                      }),
                      (e.isSync = function() {
                        return this.config.enableSoftwareAES;
                      }),
                      (e.flush = function() {
                        var t = this.currentResult;
                        if (t) {
                          var e = new Uint8Array(t);
                          return (
                            this.reset(),
                            this.removePKCS7Padding
                              ? Object(s.removePadding)(e)
                              : e
                          );
                        }
                        this.reset();
                      }),
                      (e.reset = function() {
                        (this.currentResult = null),
                          (this.currentIV = null),
                          (this.remainderData = null),
                          this.softwareDecrypter &&
                            (this.softwareDecrypter = null);
                      }),
                      (e.decrypt = function(t, e, r, n) {
                        if (this.config.enableSoftwareAES) {
                          this.softwareDecrypt(new Uint8Array(t), e, r);
                          var i = this.flush();
                          i && n(i.buffer);
                        } else
                          this.webCryptoDecrypt(new Uint8Array(t), e, r).then(
                            n,
                          );
                      }),
                      (e.softwareDecrypt = function(t, e, r) {
                        var n = this.currentIV,
                          i = this.currentResult,
                          a = this.remainderData;
                        this.logOnce('JS AES decrypt'),
                          a &&
                            ((t = Object(o.appendUint8Array)(a, t)),
                            (this.remainderData = null));
                        var l = this.getValidChunk(t);
                        if (!l.length) return null;
                        n && (r = n);
                        var c = this.softwareDecrypter;
                        c || (c = this.softwareDecrypter = new s.default()),
                          c.expandKey(e);
                        var h = i;
                        return (
                          (this.currentResult = c.decrypt(l.buffer, 0, r)),
                          (this.currentIV = Object(u.sliceUint8)(
                            l,
                            -16,
                          ).buffer),
                          h || null
                        );
                      }),
                      (e.webCryptoDecrypt = function(t, e, r) {
                        var s = this,
                          a = this.subtle;
                        return (
                          (this.key === e && this.fastAesKey) ||
                            ((this.key = e),
                            (this.fastAesKey = new i.default(a, e))),
                          this.fastAesKey
                            .expandKey()
                            .then(function(e) {
                              return a
                                ? new n.default(a, r).decrypt(t.buffer, e)
                                : Promise.reject(
                                    new Error('web crypto not initialized'),
                                  );
                            })
                            .catch(function(n) {
                              return s.onWebCryptoError(n, t, e, r);
                            })
                        );
                      }),
                      (e.onWebCryptoError = function(t, e, r, n) {
                        return (
                          a.logger.warn(
                            '[decrypter.ts]: WebCrypto Error, disable WebCrypto API:',
                            t,
                          ),
                          (this.config.enableSoftwareAES = !0),
                          (this.logEnabled = !0),
                          this.softwareDecrypt(e, r, n)
                        );
                      }),
                      (e.getValidChunk = function(t) {
                        var e = t,
                          r = t.length - (t.length % 16);
                        return (
                          r !== t.length &&
                            ((e = Object(u.sliceUint8)(t, 0, r)),
                            (this.remainderData = Object(u.sliceUint8)(t, r))),
                          e
                        );
                      }),
                      (e.logOnce = function(t) {
                        this.logEnabled &&
                          (a.logger.log('[decrypter.ts]: ' + t),
                          (this.logEnabled = !1));
                      }),
                      t
                    );
                  })();
              },
              './src/crypt/fast-aes-key.ts': function(t, e, r) {
                r.r(e),
                  r.d(e, 'default', function() {
                    return n;
                  });
                var n = (function() {
                  function t(t, e) {
                    (this.subtle = void 0),
                      (this.key = void 0),
                      (this.subtle = t),
                      (this.key = e);
                  }
                  return (
                    (t.prototype.expandKey = function() {
                      return this.subtle.importKey(
                        'raw',
                        this.key,
                        { name: 'AES-CBC' },
                        !1,
                        ['encrypt', 'decrypt'],
                      );
                    }),
                    t
                  );
                })();
              },
              './src/demux/aacdemuxer.ts': function(t, e, r) {
                function n(t, e) {
                  return (n = Object.setPrototypeOf
                    ? Object.setPrototypeOf.bind()
                    : function(t, e) {
                        return (t.__proto__ = e), t;
                      })(t, e);
                }
                r.r(e);
                var i = r('./src/demux/base-audio-demuxer.ts'),
                  s = r('./src/demux/adts.ts'),
                  a = r('./src/utils/logger.ts'),
                  o = r('./src/demux/id3.ts'),
                  u = (function(t) {
                    function e(e, r) {
                      var n;
                      return (
                        ((n = t.call(this) || this).observer = void 0),
                        (n.config = void 0),
                        (n.observer = e),
                        (n.config = r),
                        n
                      );
                    }
                    var r, i;
                    (i = t),
                      ((r = e).prototype = Object.create(i.prototype)),
                      (r.prototype.constructor = r),
                      n(r, i);
                    var u = e.prototype;
                    return (
                      (u.resetInitSegment = function(e, r, n, i) {
                        t.prototype.resetInitSegment.call(this, e, r, n, i),
                          (this._audioTrack = {
                            container: 'audio/adts',
                            type: 'audio',
                            id: 2,
                            pid: -1,
                            sequenceNumber: 0,
                            segmentCodec: 'aac',
                            samples: [],
                            manifestCodec: r,
                            duration: i,
                            inputTimeScale: 9e4,
                            dropped: 0,
                          });
                      }),
                      (e.probe = function(t) {
                        if (!t) return !1;
                        for (
                          var e = (o.getID3Data(t, 0) || []).length,
                            r = t.length;
                          e < r;
                          e++
                        )
                          if (s.probe(t, e))
                            return a.logger.log('ADTS sync word found !'), !0;
                        return !1;
                      }),
                      (u.canParse = function(t, e) {
                        return s.canParse(t, e);
                      }),
                      (u.appendFrame = function(t, e, r) {
                        s.initTrackConfig(
                          t,
                          this.observer,
                          e,
                          r,
                          t.manifestCodec,
                        );
                        var n = s.appendFrame(
                          t,
                          e,
                          r,
                          this.basePTS,
                          this.frameIndex,
                        );
                        if (n && 0 === n.missing) return n;
                      }),
                      e
                    );
                  })(i.default);
                e.default = u;
              },
              './src/demux/adts.ts': function(t, e, r) {
                function n(t, e, r, n) {
                  var i,
                    s,
                    a,
                    o,
                    u = navigator.userAgent.toLowerCase(),
                    l = n,
                    c = [
                      96e3,
                      88200,
                      64e3,
                      48e3,
                      44100,
                      32e3,
                      24e3,
                      22050,
                      16e3,
                      12e3,
                      11025,
                      8e3,
                      7350,
                    ];
                  i = 1 + ((192 & e[r + 2]) >>> 6);
                  var h = (60 & e[r + 2]) >>> 2;
                  if (!(h > c.length - 1))
                    return (
                      (a = (1 & e[r + 2]) << 2),
                      (a |= (192 & e[r + 3]) >>> 6),
                      v.logger.log(
                        'manifest codec:' +
                          n +
                          ', ADTS type:' +
                          i +
                          ', samplingIndex:' +
                          h,
                      ),
                      /firefox/i.test(u)
                        ? h >= 6
                          ? ((i = 5), (o = new Array(4)), (s = h - 3))
                          : ((i = 2), (o = new Array(2)), (s = h))
                        : -1 !== u.indexOf('android')
                        ? ((i = 2), (o = new Array(2)), (s = h))
                        : ((i = 5),
                          (o = new Array(4)),
                          (n &&
                            (-1 !== n.indexOf('mp4a.40.29') ||
                              -1 !== n.indexOf('mp4a.40.5'))) ||
                          (!n && h >= 6)
                            ? (s = h - 3)
                            : (((n &&
                                -1 !== n.indexOf('mp4a.40.2') &&
                                ((h >= 6 && 1 === a) || /vivaldi/i.test(u))) ||
                                (!n && 1 === a)) &&
                                ((i = 2), (o = new Array(2))),
                              (s = h))),
                      (o[0] = i << 3),
                      (o[0] |= (14 & h) >> 1),
                      (o[1] |= (1 & h) << 7),
                      (o[1] |= a << 3),
                      5 === i &&
                        ((o[1] |= (14 & s) >> 1),
                        (o[2] = (1 & s) << 7),
                        (o[2] |= 8),
                        (o[3] = 0)),
                      {
                        config: o,
                        samplerate: c[h],
                        channelCount: a,
                        codec: 'mp4a.40.' + i,
                        manifestCodec: l,
                      }
                    );
                  t.trigger(m.Events.ERROR, {
                    type: g.ErrorTypes.MEDIA_ERROR,
                    details: g.ErrorDetails.FRAG_PARSING_ERROR,
                    fatal: !0,
                    reason: 'invalid ADTS sampling index:' + h,
                  });
                }
                function i(t, e) {
                  return 255 === t[e] && 240 == (246 & t[e + 1]);
                }
                function s(t, e) {
                  return 1 & t[e + 1] ? 7 : 9;
                }
                function a(t, e) {
                  return (
                    ((3 & t[e + 3]) << 11) |
                    (t[e + 4] << 3) |
                    ((224 & t[e + 5]) >>> 5)
                  );
                }
                function o(t, e) {
                  return e + 5 < t.length;
                }
                function u(t, e) {
                  return e + 1 < t.length && i(t, e);
                }
                function l(t, e) {
                  return o(t, e) && i(t, e) && a(t, e) <= t.length - e;
                }
                function c(t, e) {
                  if (u(t, e)) {
                    var r = s(t, e);
                    if (e + r >= t.length) return !1;
                    var n = a(t, e);
                    if (n <= r) return !1;
                    var i = e + n;
                    return i === t.length || u(t, i);
                  }
                  return !1;
                }
                function h(t, e, r, i, s) {
                  if (!t.samplerate) {
                    var a = n(e, r, i, s);
                    if (!a) return;
                    (t.config = a.config),
                      (t.samplerate = a.samplerate),
                      (t.channelCount = a.channelCount),
                      (t.codec = a.codec),
                      (t.manifestCodec = a.manifestCodec),
                      v.logger.log(
                        'parsed codec:' +
                          t.codec +
                          ', rate:' +
                          a.samplerate +
                          ', channels:' +
                          a.channelCount,
                      );
                  }
                }
                function d(t) {
                  return 9216e4 / t;
                }
                function f(t, e) {
                  var r = s(t, e);
                  if (e + r <= t.length) {
                    var n = a(t, e) - r;
                    if (n > 0) return { headerLength: r, frameLength: n };
                  }
                }
                function p(t, e, r, n, i) {
                  var s,
                    a = n + i * d(t.samplerate),
                    o = f(e, r);
                  if (o) {
                    var u = o.frameLength,
                      l = o.headerLength,
                      c = l + u,
                      h = Math.max(0, r + c - e.length);
                    h
                      ? (s = new Uint8Array(c - l)).set(
                          e.subarray(r + l, e.length),
                          0,
                        )
                      : (s = e.subarray(r + l, r + c));
                    var p = { unit: s, pts: a };
                    return (
                      h || t.samples.push(p),
                      { sample: p, length: c, missing: h }
                    );
                  }
                  var v = e.length - r;
                  return (
                    (s = new Uint8Array(v)).set(e.subarray(r, e.length), 0),
                    { sample: { unit: s, pts: a }, length: v, missing: -1 }
                  );
                }
                r.r(e),
                  r.d(e, 'getAudioConfig', function() {
                    return n;
                  }),
                  r.d(e, 'isHeaderPattern', function() {
                    return i;
                  }),
                  r.d(e, 'getHeaderLength', function() {
                    return s;
                  }),
                  r.d(e, 'getFullFrameLength', function() {
                    return a;
                  }),
                  r.d(e, 'canGetFrameLength', function() {
                    return o;
                  }),
                  r.d(e, 'isHeader', function() {
                    return u;
                  }),
                  r.d(e, 'canParse', function() {
                    return l;
                  }),
                  r.d(e, 'probe', function() {
                    return c;
                  }),
                  r.d(e, 'initTrackConfig', function() {
                    return h;
                  }),
                  r.d(e, 'getFrameDuration', function() {
                    return d;
                  }),
                  r.d(e, 'parseFrameHeader', function() {
                    return f;
                  }),
                  r.d(e, 'appendFrame', function() {
                    return p;
                  });
                var v = r('./src/utils/logger.ts'),
                  g = r('./src/errors.ts'),
                  m = r('./src/events.ts');
              },
              './src/demux/base-audio-demuxer.ts': function(t, e, r) {
                r.r(e),
                  r.d(e, 'initPTSFn', function() {
                    return c;
                  });
                var n = r('./src/polyfills/number.ts'),
                  i = r('./src/demux/id3.ts'),
                  s = r('./src/types/demuxer.ts'),
                  a = r('./src/demux/dummy-demuxed-track.ts'),
                  o = r('./src/utils/mp4-tools.ts'),
                  u = r('./src/utils/typed-array.ts'),
                  l = (function() {
                    function t() {
                      (this._audioTrack = void 0),
                        (this._id3Track = void 0),
                        (this.frameIndex = 0),
                        (this.cachedData = null),
                        (this.basePTS = null),
                        (this.initPTS = null);
                    }
                    var e = t.prototype;
                    return (
                      (e.resetInitSegment = function(t, e, r, n) {
                        this._id3Track = {
                          type: 'id3',
                          id: 3,
                          pid: -1,
                          inputTimeScale: 9e4,
                          sequenceNumber: 0,
                          samples: [],
                          dropped: 0,
                        };
                      }),
                      (e.resetTimeStamp = function(t) {
                        (this.initPTS = t), this.resetContiguity();
                      }),
                      (e.resetContiguity = function() {
                        (this.basePTS = null), (this.frameIndex = 0);
                      }),
                      (e.canParse = function(t, e) {
                        return !1;
                      }),
                      (e.appendFrame = function(t, e, r) {}),
                      (e.demux = function(t, e) {
                        this.cachedData &&
                          ((t = Object(o.appendUint8Array)(this.cachedData, t)),
                          (this.cachedData = null));
                        var r,
                          l,
                          h = i.getID3Data(t, 0),
                          d = h ? h.length : 0,
                          f = this._audioTrack,
                          p = this._id3Track,
                          v = h ? i.getTimeStamp(h) : void 0,
                          g = t.length;
                        for (
                          (null === this.basePTS ||
                            (0 === this.frameIndex &&
                              Object(n.isFiniteNumber)(v))) &&
                            (this.basePTS = c(v, e, this.initPTS)),
                            h &&
                              h.length > 0 &&
                              p.samples.push({
                                pts: this.basePTS,
                                dts: this.basePTS,
                                data: h,
                                type: s.MetadataSchema.audioId3,
                              }),
                            l = this.basePTS;
                          d < g;

                        ) {
                          if (this.canParse(t, d)) {
                            var m = this.appendFrame(f, t, d);
                            m
                              ? (this.frameIndex++,
                                (l = m.sample.pts),
                                (r = d += m.length))
                              : (d = g);
                          } else
                            i.canParse(t, d)
                              ? ((h = i.getID3Data(t, d)),
                                p.samples.push({
                                  pts: l,
                                  dts: l,
                                  data: h,
                                  type: s.MetadataSchema.audioId3,
                                }),
                                (r = d += h.length))
                              : d++;
                          if (d === g && r !== g) {
                            var y = Object(u.sliceUint8)(t, r);
                            this.cachedData
                              ? (this.cachedData = Object(o.appendUint8Array)(
                                  this.cachedData,
                                  y,
                                ))
                              : (this.cachedData = y);
                          }
                        }
                        return {
                          audioTrack: f,
                          videoTrack: Object(a.dummyTrack)(),
                          id3Track: p,
                          textTrack: Object(a.dummyTrack)(),
                        };
                      }),
                      (e.demuxSampleAes = function(t, e, r) {
                        return Promise.reject(
                          new Error(
                            '[' +
                              this +
                              '] This demuxer does not support Sample-AES decryption',
                          ),
                        );
                      }),
                      (e.flush = function(t) {
                        var e = this.cachedData;
                        return (
                          e && ((this.cachedData = null), this.demux(e, 0)),
                          {
                            audioTrack: this._audioTrack,
                            videoTrack: Object(a.dummyTrack)(),
                            id3Track: this._id3Track,
                            textTrack: Object(a.dummyTrack)(),
                          }
                        );
                      }),
                      (e.destroy = function() {}),
                      t
                    );
                  })(),
                  c = function(t, e, r) {
                    return Object(n.isFiniteNumber)(t)
                      ? 90 * t
                      : 9e4 * e + (r || 0);
                  };
                e.default = l;
              },
              './src/demux/chunk-cache.ts': function(t, e, r) {
                r.r(e),
                  r.d(e, 'default', function() {
                    return n;
                  });
                var n = (function() {
                  function t() {
                    (this.chunks = []), (this.dataLength = 0);
                  }
                  var e = t.prototype;
                  return (
                    (e.push = function(t) {
                      this.chunks.push(t), (this.dataLength += t.length);
                    }),
                    (e.flush = function() {
                      var t,
                        e = this.chunks,
                        r = this.dataLength;
                      return e.length
                        ? ((t =
                            1 === e.length
                              ? e[0]
                              : (function(t, e) {
                                  for (
                                    var r = new Uint8Array(e), n = 0, i = 0;
                                    i < t.length;
                                    i++
                                  ) {
                                    var s = t[i];
                                    r.set(s, n), (n += s.length);
                                  }
                                  return r;
                                })(e, r)),
                          this.reset(),
                          t)
                        : new Uint8Array(0);
                    }),
                    (e.reset = function() {
                      (this.chunks.length = 0), (this.dataLength = 0);
                    }),
                    t
                  );
                })();
              },
              './src/demux/dummy-demuxed-track.ts': function(t, e, r) {
                function n(t, e) {
                  return (
                    void 0 === t && (t = ''),
                    void 0 === e && (e = 9e4),
                    {
                      type: t,
                      id: -1,
                      pid: -1,
                      inputTimeScale: e,
                      sequenceNumber: -1,
                      samples: [],
                      dropped: 0,
                    }
                  );
                }
                r.r(e),
                  r.d(e, 'dummyTrack', function() {
                    return n;
                  });
              },
              './src/demux/exp-golomb.ts': function(t, e, r) {
                r.r(e);
                var n = r('./src/utils/logger.ts'),
                  i = (function() {
                    function t(t) {
                      (this.data = void 0),
                        (this.bytesAvailable = void 0),
                        (this.word = void 0),
                        (this.bitsAvailable = void 0),
                        (this.data = t),
                        (this.bytesAvailable = t.byteLength),
                        (this.word = 0),
                        (this.bitsAvailable = 0);
                    }
                    var e = t.prototype;
                    return (
                      (e.loadWord = function() {
                        var t = this.data,
                          e = this.bytesAvailable,
                          r = t.byteLength - e,
                          n = new Uint8Array(4),
                          i = Math.min(4, e);
                        if (0 === i) throw new Error('no bytes available');
                        n.set(t.subarray(r, r + i)),
                          (this.word = new DataView(n.buffer).getUint32(0)),
                          (this.bitsAvailable = 8 * i),
                          (this.bytesAvailable -= i);
                      }),
                      (e.skipBits = function(t) {
                        var e;
                        this.bitsAvailable > t
                          ? ((this.word <<= t), (this.bitsAvailable -= t))
                          : ((t -= this.bitsAvailable),
                            (t -= (e = t >> 3) >> 3),
                            (this.bytesAvailable -= e),
                            this.loadWord(),
                            (this.word <<= t),
                            (this.bitsAvailable -= t));
                      }),
                      (e.readBits = function(t) {
                        var e = Math.min(this.bitsAvailable, t),
                          r = this.word >>> (32 - e);
                        return (
                          t > 32 &&
                            n.logger.error(
                              'Cannot read more than 32 bits at a time',
                            ),
                          (this.bitsAvailable -= e),
                          this.bitsAvailable > 0
                            ? (this.word <<= e)
                            : this.bytesAvailable > 0 && this.loadWord(),
                          (e = t - e) > 0 && this.bitsAvailable
                            ? (r << e) | this.readBits(e)
                            : r
                        );
                      }),
                      (e.skipLZ = function() {
                        var t;
                        for (t = 0; t < this.bitsAvailable; ++t)
                          if (0 != (this.word & (2147483648 >>> t)))
                            return (
                              (this.word <<= t), (this.bitsAvailable -= t), t
                            );
                        return this.loadWord(), t + this.skipLZ();
                      }),
                      (e.skipUEG = function() {
                        this.skipBits(1 + this.skipLZ());
                      }),
                      (e.skipEG = function() {
                        this.skipBits(1 + this.skipLZ());
                      }),
                      (e.readUEG = function() {
                        var t = this.skipLZ();
                        return this.readBits(t + 1) - 1;
                      }),
                      (e.readEG = function() {
                        var t = this.readUEG();
                        return 1 & t ? (1 + t) >>> 1 : -1 * (t >>> 1);
                      }),
                      (e.readBoolean = function() {
                        return 1 === this.readBits(1);
                      }),
                      (e.readUByte = function() {
                        return this.readBits(8);
                      }),
                      (e.readUShort = function() {
                        return this.readBits(16);
                      }),
                      (e.readUInt = function() {
                        return this.readBits(32);
                      }),
                      (e.skipScalingList = function(t) {
                        for (var e = 8, r = 8, n = 0; n < t; n++)
                          0 !== r && (r = (e + this.readEG() + 256) % 256),
                            (e = 0 === r ? e : r);
                      }),
                      (e.readSPS = function() {
                        var t,
                          e,
                          r,
                          n = 0,
                          i = 0,
                          s = 0,
                          a = 0,
                          o = this.readUByte.bind(this),
                          u = this.readBits.bind(this),
                          l = this.readUEG.bind(this),
                          c = this.readBoolean.bind(this),
                          h = this.skipBits.bind(this),
                          d = this.skipEG.bind(this),
                          f = this.skipUEG.bind(this),
                          p = this.skipScalingList.bind(this);
                        o();
                        var v = o();
                        if (
                          (u(5),
                          h(3),
                          o(),
                          f(),
                          100 === v ||
                            110 === v ||
                            122 === v ||
                            244 === v ||
                            44 === v ||
                            83 === v ||
                            86 === v ||
                            118 === v ||
                            128 === v)
                        ) {
                          var g = l();
                          if ((3 === g && h(1), f(), f(), h(1), c()))
                            for (e = 3 !== g ? 8 : 12, r = 0; r < e; r++)
                              c() && p(r < 6 ? 16 : 64);
                        }
                        f();
                        var m = l();
                        if (0 === m) l();
                        else if (1 === m)
                          for (h(1), d(), d(), t = l(), r = 0; r < t; r++) d();
                        f(), h(1);
                        var y = l(),
                          b = l(),
                          E = u(1);
                        0 === E && h(1),
                          h(1),
                          c() && ((n = l()), (i = l()), (s = l()), (a = l()));
                        var T = [1, 1];
                        if (c() && c())
                          switch (o()) {
                            case 1:
                              T = [1, 1];
                              break;
                            case 2:
                              T = [12, 11];
                              break;
                            case 3:
                              T = [10, 11];
                              break;
                            case 4:
                              T = [16, 11];
                              break;
                            case 5:
                              T = [40, 33];
                              break;
                            case 6:
                              T = [24, 11];
                              break;
                            case 7:
                              T = [20, 11];
                              break;
                            case 8:
                              T = [32, 11];
                              break;
                            case 9:
                              T = [80, 33];
                              break;
                            case 10:
                              T = [18, 11];
                              break;
                            case 11:
                              T = [15, 11];
                              break;
                            case 12:
                              T = [64, 33];
                              break;
                            case 13:
                              T = [160, 99];
                              break;
                            case 14:
                              T = [4, 3];
                              break;
                            case 15:
                              T = [3, 2];
                              break;
                            case 16:
                              T = [2, 1];
                              break;
                            case 255:
                              T = [(o() << 8) | o(), (o() << 8) | o()];
                          }
                        return {
                          width: Math.ceil(16 * (y + 1) - 2 * n - 2 * i),
                          height:
                            (2 - E) * (b + 1) * 16 - (E ? 2 : 4) * (s + a),
                          pixelRatio: T,
                        };
                      }),
                      (e.readSliceType = function() {
                        return this.readUByte(), this.readUEG(), this.readUEG();
                      }),
                      t
                    );
                  })();
                e.default = i;
              },
              './src/demux/id3.ts': function(t, e, r) {
                function n() {
                  return (
                    i ||
                      void 0 === self.TextDecoder ||
                      (i = new self.TextDecoder('utf-8')),
                    i
                  );
                }
                r.r(e),
                  r.d(e, 'isHeader', function() {
                    return s;
                  }),
                  r.d(e, 'isFooter', function() {
                    return a;
                  }),
                  r.d(e, 'getID3Data', function() {
                    return o;
                  }),
                  r.d(e, 'canParse', function() {
                    return l;
                  }),
                  r.d(e, 'getTimeStamp', function() {
                    return c;
                  }),
                  r.d(e, 'isTimeStampFrame', function() {
                    return h;
                  }),
                  r.d(e, 'getID3Frames', function() {
                    return f;
                  }),
                  r.d(e, 'decodeFrame', function() {
                    return p;
                  }),
                  r.d(e, 'utf8ArrayToStr', function() {
                    return b;
                  }),
                  r.d(e, 'testables', function() {
                    return E;
                  });
                var i,
                  s = function(t, e) {
                    return (
                      e + 10 <= t.length &&
                      73 === t[e] &&
                      68 === t[e + 1] &&
                      51 === t[e + 2] &&
                      t[e + 3] < 255 &&
                      t[e + 4] < 255 &&
                      t[e + 6] < 128 &&
                      t[e + 7] < 128 &&
                      t[e + 8] < 128 &&
                      t[e + 9] < 128
                    );
                  },
                  a = function(t, e) {
                    return (
                      e + 10 <= t.length &&
                      51 === t[e] &&
                      68 === t[e + 1] &&
                      73 === t[e + 2] &&
                      t[e + 3] < 255 &&
                      t[e + 4] < 255 &&
                      t[e + 6] < 128 &&
                      t[e + 7] < 128 &&
                      t[e + 8] < 128 &&
                      t[e + 9] < 128
                    );
                  },
                  o = function(t, e) {
                    for (var r = e, n = 0; s(t, e); )
                      (n += 10),
                        (n += u(t, e + 6)),
                        a(t, e + 10) && (n += 10),
                        (e += n);
                    if (n > 0) return t.subarray(r, r + n);
                  },
                  u = function(t, e) {
                    var r = 0;
                    return (
                      (r = (127 & t[e]) << 21),
                      (r |= (127 & t[e + 1]) << 14),
                      (r |= (127 & t[e + 2]) << 7) | (127 & t[e + 3])
                    );
                  },
                  l = function(t, e) {
                    return s(t, e) && u(t, e + 6) + 10 <= t.length - e;
                  },
                  c = function(t) {
                    for (var e = f(t), r = 0; r < e.length; r++) {
                      var n = e[r];
                      if (h(n)) return y(n);
                    }
                  },
                  h = function(t) {
                    return (
                      t &&
                      'PRIV' === t.key &&
                      'com.apple.streaming.transportStreamTimestamp' === t.info
                    );
                  },
                  d = function(t) {
                    var e = String.fromCharCode(t[0], t[1], t[2], t[3]),
                      r = u(t, 4);
                    return { type: e, size: r, data: t.subarray(10, 10 + r) };
                  },
                  f = function(t) {
                    for (var e = 0, r = []; s(t, e); ) {
                      for (
                        var n = u(t, e + 6), i = (e += 10) + n;
                        e + 8 < i;

                      ) {
                        var o = d(t.subarray(e)),
                          l = p(o);
                        l && r.push(l), (e += o.size + 10);
                      }
                      a(t, e) && (e += 10);
                    }
                    return r;
                  },
                  p = function(t) {
                    return 'PRIV' === t.type
                      ? v(t)
                      : 'W' === t.type[0]
                      ? m(t)
                      : g(t);
                  },
                  v = function(t) {
                    if (!(t.size < 2)) {
                      var e = b(t.data, !0),
                        r = new Uint8Array(t.data.subarray(e.length + 1));
                      return { key: t.type, info: e, data: r.buffer };
                    }
                  },
                  g = function(t) {
                    if (!(t.size < 2)) {
                      if ('TXXX' === t.type) {
                        var e = 1,
                          r = b(t.data.subarray(e), !0);
                        e += r.length + 1;
                        var n = b(t.data.subarray(e));
                        return { key: t.type, info: r, data: n };
                      }
                      var i = b(t.data.subarray(1));
                      return { key: t.type, data: i };
                    }
                  },
                  m = function(t) {
                    if ('WXXX' === t.type) {
                      if (t.size < 2) return;
                      var e = 1,
                        r = b(t.data.subarray(e), !0);
                      e += r.length + 1;
                      var n = b(t.data.subarray(e));
                      return { key: t.type, info: r, data: n };
                    }
                    var i = b(t.data);
                    return { key: t.type, data: i };
                  },
                  y = function(t) {
                    if (8 === t.data.byteLength) {
                      var e = new Uint8Array(t.data),
                        r = 1 & e[3],
                        n = (e[4] << 23) + (e[5] << 15) + (e[6] << 7) + e[7];
                      return (n /= 45), r && (n += 47721858.84), Math.round(n);
                    }
                  },
                  b = function(t, e) {
                    void 0 === e && (e = !1);
                    var r = n();
                    if (r) {
                      var i = r.decode(t);
                      if (e) {
                        var s = i.indexOf('\0');
                        return -1 !== s ? i.substring(0, s) : i;
                      }
                      return i.replace(/\0/g, '');
                    }
                    for (var a, o, u, l = t.length, c = '', h = 0; h < l; ) {
                      if (0 === (a = t[h++]) && e) return c;
                      if (0 !== a && 3 !== a)
                        switch (a >> 4) {
                          case 0:
                          case 1:
                          case 2:
                          case 3:
                          case 4:
                          case 5:
                          case 6:
                          case 7:
                            c += String.fromCharCode(a);
                            break;
                          case 12:
                          case 13:
                            (o = t[h++]),
                              (c += String.fromCharCode(
                                ((31 & a) << 6) | (63 & o),
                              ));
                            break;
                          case 14:
                            (o = t[h++]),
                              (u = t[h++]),
                              (c += String.fromCharCode(
                                ((15 & a) << 12) |
                                  ((63 & o) << 6) |
                                  ((63 & u) << 0),
                              ));
                        }
                    }
                    return c;
                  },
                  E = { decodeTextFrame: g };
              },
              './src/demux/mp3demuxer.ts': function(t, e, r) {
                function n(t, e) {
                  return (n = Object.setPrototypeOf
                    ? Object.setPrototypeOf.bind()
                    : function(t, e) {
                        return (t.__proto__ = e), t;
                      })(t, e);
                }
                r.r(e);
                var i = r('./src/demux/base-audio-demuxer.ts'),
                  s = r('./src/demux/id3.ts'),
                  a = r('./src/utils/logger.ts'),
                  o = r('./src/demux/mpegaudio.ts'),
                  u = (function(t) {
                    function e() {
                      return t.apply(this, arguments) || this;
                    }
                    var r, i;
                    (i = t),
                      ((r = e).prototype = Object.create(i.prototype)),
                      (r.prototype.constructor = r),
                      n(r, i);
                    var u = e.prototype;
                    return (
                      (u.resetInitSegment = function(e, r, n, i) {
                        t.prototype.resetInitSegment.call(this, e, r, n, i),
                          (this._audioTrack = {
                            container: 'audio/mpeg',
                            type: 'audio',
                            id: 2,
                            pid: -1,
                            sequenceNumber: 0,
                            segmentCodec: 'mp3',
                            samples: [],
                            manifestCodec: r,
                            duration: i,
                            inputTimeScale: 9e4,
                            dropped: 0,
                          });
                      }),
                      (e.probe = function(t) {
                        if (!t) return !1;
                        for (
                          var e = (s.getID3Data(t, 0) || []).length,
                            r = t.length;
                          e < r;
                          e++
                        )
                          if (o.probe(t, e))
                            return (
                              a.logger.log('MPEG Audio sync word found !'), !0
                            );
                        return !1;
                      }),
                      (u.canParse = function(t, e) {
                        return o.canParse(t, e);
                      }),
                      (u.appendFrame = function(t, e, r) {
                        if (null !== this.basePTS)
                          return o.appendFrame(
                            t,
                            e,
                            r,
                            this.basePTS,
                            this.frameIndex,
                          );
                      }),
                      e
                    );
                  })(i.default);
                e.default = u;
              },
              './src/demux/mp4demuxer.ts': function(t, e, r) {
                r.r(e);
                var n = r('./src/polyfills/number.ts'),
                  i = r('./src/types/demuxer.ts'),
                  s = r('./src/utils/mp4-tools.ts'),
                  a = r('./src/demux/dummy-demuxed-track.ts'),
                  o = /\/emsg[-/]ID3/i,
                  u = (function() {
                    function t(t, e) {
                      (this.remainderData = null),
                        (this.timeOffset = 0),
                        (this.config = void 0),
                        (this.videoTrack = void 0),
                        (this.audioTrack = void 0),
                        (this.id3Track = void 0),
                        (this.txtTrack = void 0),
                        (this.config = e);
                    }
                    var e = t.prototype;
                    return (
                      (e.resetTimeStamp = function() {}),
                      (e.resetInitSegment = function(t, e, r, n) {
                        var i = Object(s.parseInitSegment)(t),
                          o = (this.videoTrack = Object(a.dummyTrack)(
                            'video',
                            1,
                          )),
                          u = (this.audioTrack = Object(a.dummyTrack)(
                            'audio',
                            1,
                          )),
                          l = (this.txtTrack = Object(a.dummyTrack)('text', 1));
                        if (
                          ((this.id3Track = Object(a.dummyTrack)('id3', 1)),
                          (this.timeOffset = 0),
                          i.video)
                        ) {
                          var c = i.video,
                            h = c.id,
                            d = c.timescale,
                            f = c.codec;
                          (o.id = h),
                            (o.timescale = l.timescale = d),
                            (o.codec = f);
                        }
                        if (i.audio) {
                          var p = i.audio,
                            v = p.id,
                            g = p.timescale,
                            m = p.codec;
                          (u.id = v), (u.timescale = g), (u.codec = m);
                        }
                        (l.id = s.RemuxerTrackIdConfig.text),
                          (o.sampleDuration = 0),
                          (o.duration = u.duration = n);
                      }),
                      (e.resetContiguity = function() {}),
                      (t.probe = function(t) {
                        return (
                          (t = t.length > 16384 ? t.subarray(0, 16384) : t),
                          Object(s.findBox)(t, ['moof']).length > 0
                        );
                      }),
                      (e.demux = function(t, e) {
                        this.timeOffset = e;
                        var r = t,
                          n = this.videoTrack,
                          i = this.txtTrack;
                        if (this.config.progressive) {
                          this.remainderData &&
                            (r = Object(s.appendUint8Array)(
                              this.remainderData,
                              t,
                            ));
                          var a = Object(s.segmentValidRange)(r);
                          (this.remainderData = a.remainder),
                            (n.samples = a.valid || new Uint8Array());
                        } else n.samples = r;
                        var o = this.extractID3Track(n, e);
                        return (
                          (i.samples = Object(s.parseSamples)(e, n)),
                          {
                            videoTrack: n,
                            audioTrack: this.audioTrack,
                            id3Track: o,
                            textTrack: this.txtTrack,
                          }
                        );
                      }),
                      (e.flush = function() {
                        var t = this.timeOffset,
                          e = this.videoTrack,
                          r = this.txtTrack;
                        (e.samples = this.remainderData || new Uint8Array()),
                          (this.remainderData = null);
                        var n = this.extractID3Track(e, this.timeOffset);
                        return (
                          (r.samples = Object(s.parseSamples)(t, e)),
                          {
                            videoTrack: e,
                            audioTrack: Object(a.dummyTrack)(),
                            id3Track: n,
                            textTrack: Object(a.dummyTrack)(),
                          }
                        );
                      }),
                      (e.extractID3Track = function(t, e) {
                        var r = this.id3Track;
                        if (t.samples.length) {
                          var a = Object(s.findBox)(t.samples, ['emsg']);
                          a &&
                            a.forEach(function(t) {
                              var a = Object(s.parseEmsg)(t);
                              if (o.test(a.schemeIdUri)) {
                                var u = Object(n.isFiniteNumber)(
                                    a.presentationTime,
                                  )
                                    ? a.presentationTime / a.timeScale
                                    : e + a.presentationTimeDelta / a.timeScale,
                                  l = a.payload;
                                r.samples.push({
                                  data: l,
                                  len: l.byteLength,
                                  dts: u,
                                  pts: u,
                                  type: i.MetadataSchema.emsg,
                                });
                              }
                            });
                        }
                        return r;
                      }),
                      (e.demuxSampleAes = function(t, e, r) {
                        return Promise.reject(
                          new Error(
                            'The MP4 demuxer does not support SAMPLE-AES decryption',
                          ),
                        );
                      }),
                      (e.destroy = function() {}),
                      t
                    );
                  })();
                e.default = u;
              },
              './src/demux/mpegaudio.ts': function(t, e, r) {
                function n(t, e, r, n, s) {
                  if (!(r + 24 > e.length)) {
                    var a = i(e, r);
                    if (a && r + a.frameLength <= e.length) {
                      var o =
                          n + s * ((9e4 * a.samplesPerFrame) / a.sampleRate),
                        u = {
                          unit: e.subarray(r, r + a.frameLength),
                          pts: o,
                          dts: o,
                        };
                      return (
                        (t.config = []),
                        (t.channelCount = a.channelCount),
                        (t.samplerate = a.sampleRate),
                        t.samples.push(u),
                        { sample: u, length: a.frameLength, missing: 0 }
                      );
                    }
                  }
                }
                function i(t, e) {
                  var r = (t[e + 1] >> 3) & 3,
                    n = (t[e + 1] >> 1) & 3,
                    i = (t[e + 2] >> 4) & 15,
                    s = (t[e + 2] >> 2) & 3;
                  if (1 !== r && 0 !== i && 15 !== i && 3 !== s) {
                    var a = (t[e + 2] >> 1) & 1,
                      o = t[e + 3] >> 6,
                      u =
                        1e3 *
                        c[14 * (3 === r ? 3 - n : 3 === n ? 3 : 4) + i - 1],
                      p = h[3 * (3 === r ? 0 : 2 === r ? 1 : 2) + s],
                      v = 3 === o ? 1 : 2,
                      g = d[r][n],
                      m = f[n],
                      y = 8 * g * m,
                      b = Math.floor((g * u) / p + a) * m;
                    if (null === l) {
                      var E = (navigator.userAgent || '').match(
                        /Chrome\/(\d+)/i,
                      );
                      l = E ? parseInt(E[1]) : 0;
                    }
                    return (
                      !!l &&
                        l <= 87 &&
                        2 === n &&
                        u >= 224e3 &&
                        0 === o &&
                        (t[e + 3] = 128 | t[e + 3]),
                      {
                        sampleRate: p,
                        channelCount: v,
                        frameLength: b,
                        samplesPerFrame: y,
                      }
                    );
                  }
                }
                function s(t, e) {
                  return (
                    255 === t[e] &&
                    224 == (224 & t[e + 1]) &&
                    0 != (6 & t[e + 1])
                  );
                }
                function a(t, e) {
                  return e + 1 < t.length && s(t, e);
                }
                function o(t, e) {
                  return s(t, e) && 4 <= t.length - e;
                }
                function u(t, e) {
                  if (e + 1 < t.length && s(t, e)) {
                    var r = i(t, e),
                      n = 4;
                    null != r && r.frameLength && (n = r.frameLength);
                    var o = e + n;
                    return o === t.length || a(t, o);
                  }
                  return !1;
                }
                r.r(e),
                  r.d(e, 'appendFrame', function() {
                    return n;
                  }),
                  r.d(e, 'parseHeader', function() {
                    return i;
                  }),
                  r.d(e, 'isHeaderPattern', function() {
                    return s;
                  }),
                  r.d(e, 'isHeader', function() {
                    return a;
                  }),
                  r.d(e, 'canParse', function() {
                    return o;
                  }),
                  r.d(e, 'probe', function() {
                    return u;
                  });
                var l = null,
                  c = [
                    32,
                    64,
                    96,
                    128,
                    160,
                    192,
                    224,
                    256,
                    288,
                    320,
                    352,
                    384,
                    416,
                    448,
                    32,
                    48,
                    56,
                    64,
                    80,
                    96,
                    112,
                    128,
                    160,
                    192,
                    224,
                    256,
                    320,
                    384,
                    32,
                    40,
                    48,
                    56,
                    64,
                    80,
                    96,
                    112,
                    128,
                    160,
                    192,
                    224,
                    256,
                    320,
                    32,
                    48,
                    56,
                    64,
                    80,
                    96,
                    112,
                    128,
                    144,
                    160,
                    176,
                    192,
                    224,
                    256,
                    8,
                    16,
                    24,
                    32,
                    40,
                    48,
                    56,
                    64,
                    80,
                    96,
                    112,
                    128,
                    144,
                    160,
                  ],
                  h = [44100, 48e3, 32e3, 22050, 24e3, 16e3, 11025, 12e3, 8e3],
                  d = [
                    [0, 72, 144, 12],
                    [0, 0, 0, 0],
                    [0, 72, 144, 12],
                    [0, 144, 144, 12],
                  ],
                  f = [0, 1, 1, 4];
              },
              './src/demux/sample-aes.ts': function(t, e, r) {
                r.r(e);
                var n = r('./src/crypt/decrypter.ts'),
                  i = r('./src/demux/tsdemuxer.ts'),
                  s = (function() {
                    function t(t, e, r) {
                      (this.keyData = void 0),
                        (this.decrypter = void 0),
                        (this.keyData = r),
                        (this.decrypter = new n.default(t, e, {
                          removePKCS7Padding: !1,
                        }));
                    }
                    var e = t.prototype;
                    return (
                      (e.decryptBuffer = function(t, e) {
                        this.decrypter.decrypt(
                          t,
                          this.keyData.key.buffer,
                          this.keyData.iv.buffer,
                          e,
                        );
                      }),
                      (e.decryptAacSample = function(t, e, r, n) {
                        var i = t[e].unit;
                        if (!(i.length <= 16)) {
                          var s = i.subarray(16, i.length - (i.length % 16)),
                            a = s.buffer.slice(
                              s.byteOffset,
                              s.byteOffset + s.length,
                            ),
                            o = this;
                          this.decryptBuffer(a, function(s) {
                            var a = new Uint8Array(s);
                            i.set(a, 16), n || o.decryptAacSamples(t, e + 1, r);
                          });
                        }
                      }),
                      (e.decryptAacSamples = function(t, e, r) {
                        for (; ; e++) {
                          if (e >= t.length) return void r();
                          if (!(t[e].unit.length < 32)) {
                            var n = this.decrypter.isSync();
                            if ((this.decryptAacSample(t, e, r, n), !n)) return;
                          }
                        }
                      }),
                      (e.getAvcEncryptedData = function(t) {
                        for (
                          var e = 16 * Math.floor((t.length - 48) / 160) + 16,
                            r = new Int8Array(e),
                            n = 0,
                            i = 32;
                          i < t.length - 16;
                          i += 160, n += 16
                        )
                          r.set(t.subarray(i, i + 16), n);
                        return r;
                      }),
                      (e.getAvcDecryptedUnit = function(t, e) {
                        for (
                          var r = new Uint8Array(e), n = 0, i = 32;
                          i < t.length - 16;
                          i += 160, n += 16
                        )
                          t.set(r.subarray(n, n + 16), i);
                        return t;
                      }),
                      (e.decryptAvcSample = function(t, e, r, n, s, a) {
                        var o = Object(i.discardEPB)(s.data),
                          u = this.getAvcEncryptedData(o),
                          l = this;
                        this.decryptBuffer(u.buffer, function(i) {
                          (s.data = l.getAvcDecryptedUnit(o, i)),
                            a || l.decryptAvcSamples(t, e, r + 1, n);
                        });
                      }),
                      (e.decryptAvcSamples = function(t, e, r, n) {
                        if (t instanceof Uint8Array)
                          throw new Error(
                            'Cannot decrypt samples of type Uint8Array',
                          );
                        for (; ; e++, r = 0) {
                          if (e >= t.length) return void n();
                          for (var i = t[e].units; !(r >= i.length); r++) {
                            var s = i[r];
                            if (
                              !(
                                s.data.length <= 48 ||
                                (1 !== s.type && 5 !== s.type)
                              )
                            ) {
                              var a = this.decrypter.isSync();
                              if ((this.decryptAvcSample(t, e, r, n, s, a), !a))
                                return;
                            }
                          }
                        }
                      }),
                      t
                    );
                  })();
                e.default = s;
              },
              './src/demux/transmuxer-interface.ts': function(t, e, r) {
                r.r(e),
                  r.d(e, 'default', function() {
                    return h;
                  });
                var n = r('./node_modules/webworkify-webpack/index.js'),
                  i = r('./src/events.ts'),
                  s = r('./src/demux/transmuxer.ts'),
                  a = r('./src/utils/logger.ts'),
                  o = r('./src/errors.ts'),
                  u = r('./src/utils/mediasource-helper.ts'),
                  l = r('./node_modules/eventemitter3/index.js'),
                  c = Object(u.getMediaSource)() || {
                    isTypeSupported: function() {
                      return !1;
                    },
                  },
                  h = (function() {
                    function t(t, e, r, u) {
                      var h = this;
                      (this.hls = void 0),
                        (this.id = void 0),
                        (this.observer = void 0),
                        (this.frag = null),
                        (this.part = null),
                        (this.worker = void 0),
                        (this.onwmsg = void 0),
                        (this.transmuxer = null),
                        (this.onTransmuxComplete = void 0),
                        (this.onFlush = void 0),
                        (this.hls = t),
                        (this.id = e),
                        (this.onTransmuxComplete = r),
                        (this.onFlush = u);
                      var d = t.config,
                        f = function(e, r) {
                          ((r = r || {}).frag = h.frag),
                            (r.id = h.id),
                            t.trigger(e, r);
                        };
                      (this.observer = new l.EventEmitter()),
                        this.observer.on(i.Events.FRAG_DECRYPTED, f),
                        this.observer.on(i.Events.ERROR, f);
                      var p = {
                          mp4: c.isTypeSupported('video/mp4'),
                          mpeg: c.isTypeSupported('audio/mpeg'),
                          mp3: c.isTypeSupported('audio/mp4; codecs="mp3"'),
                        },
                        v = navigator.vendor;
                      if (d.enableWorker && 'undefined' != typeof Worker) {
                        var g;
                        a.logger.log('demuxing in webworker');
                        try {
                          (g = this.worker = n(
                            './src/demux/transmuxer-worker.ts',
                          )),
                            (this.onwmsg = this.onWorkerMessage.bind(this)),
                            g.addEventListener('message', this.onwmsg),
                            (g.onerror = function(e) {
                              t.trigger(i.Events.ERROR, {
                                type: o.ErrorTypes.OTHER_ERROR,
                                details: o.ErrorDetails.INTERNAL_EXCEPTION,
                                fatal: !0,
                                event: 'demuxerWorker',
                                error: new Error(
                                  e.message +
                                    '  (' +
                                    e.filename +
                                    ':' +
                                    e.lineno +
                                    ')',
                                ),
                              });
                            }),
                            g.postMessage({
                              cmd: 'init',
                              typeSupported: p,
                              vendor: v,
                              id: e,
                              config: JSON.stringify(d),
                            });
                        } catch (t) {
                          a.logger.warn('Error in worker:', t),
                            a.logger.error(
                              'Error while initializing DemuxerWorker, fallback to inline',
                            ),
                            g && self.URL.revokeObjectURL(g.objectURL),
                            (this.transmuxer = new s.default(
                              this.observer,
                              p,
                              d,
                              v,
                              e,
                            )),
                            (this.worker = null);
                        }
                      } else
                        this.transmuxer = new s.default(
                          this.observer,
                          p,
                          d,
                          v,
                          e,
                        );
                    }
                    var e = t.prototype;
                    return (
                      (e.destroy = function() {
                        var t = this.worker;
                        if (t)
                          t.removeEventListener('message', this.onwmsg),
                            t.terminate(),
                            (this.worker = null),
                            (this.onwmsg = void 0);
                        else {
                          var e = this.transmuxer;
                          e && (e.destroy(), (this.transmuxer = null));
                        }
                        var r = this.observer;
                        r && r.removeAllListeners(),
                          (this.frag = null),
                          (this.observer = null),
                          (this.hls = null);
                      }),
                      (e.push = function(t, e, r, n, i, o, u, l, c, h) {
                        var d,
                          f,
                          p = this;
                        c.transmuxing.start = self.performance.now();
                        var v = this.transmuxer,
                          g = this.worker,
                          m = o ? o.start : i.start,
                          y = i.decryptdata,
                          b = this.frag,
                          E = !(b && i.cc === b.cc),
                          T = !(b && c.level === b.level),
                          S = b ? c.sn - b.sn : -1,
                          L = this.part ? c.part - this.part.index : -1,
                          _ =
                            0 === S &&
                            c.id > 1 &&
                            c.id === (null == b ? void 0 : b.stats.chunkCount),
                          A =
                            !T &&
                            (1 === S ||
                              (0 === S && (1 === L || (_ && L <= 0)))),
                          D = self.performance.now();
                        (T || S || 0 === i.stats.parsing.start) &&
                          (i.stats.parsing.start = D),
                          !o || (!L && A) || (o.stats.parsing.start = D);
                        var w = !(
                            b &&
                            (null === (d = i.initSegment) || void 0 === d
                              ? void 0
                              : d.url) ===
                              (null === (f = b.initSegment) || void 0 === f
                                ? void 0
                                : f.url)
                          ),
                          k = new s.TransmuxState(E, A, l, T, m, w);
                        if (!A || E || w) {
                          a.logger.log(
                            '[transmuxer-interface, ' +
                              i.type +
                              ']: Starting new transmux session for sn: ' +
                              c.sn +
                              ' p: ' +
                              c.part +
                              ' level: ' +
                              c.level +
                              ' id: ' +
                              c.id +
                              '\n        discontinuity: ' +
                              E +
                              '\n        trackSwitch: ' +
                              T +
                              '\n        contiguous: ' +
                              A +
                              '\n        accurateTimeOffset: ' +
                              l +
                              '\n        timeOffset: ' +
                              m +
                              '\n        initSegmentChange: ' +
                              w,
                          );
                          var R = new s.TransmuxConfig(r, n, e, u, h);
                          this.configureTransmuxer(R);
                        }
                        if (((this.frag = i), (this.part = o), g))
                          g.postMessage(
                            {
                              cmd: 'demux',
                              data: t,
                              decryptdata: y,
                              chunkMeta: c,
                              state: k,
                            },
                            t instanceof ArrayBuffer ? [t] : [],
                          );
                        else if (v) {
                          var O = v.push(t, y, c, k);
                          Object(s.isPromise)(O)
                            ? O.then(function(t) {
                                p.handleTransmuxComplete(t);
                              })
                            : this.handleTransmuxComplete(O);
                        }
                      }),
                      (e.flush = function(t) {
                        var e = this;
                        t.transmuxing.start = self.performance.now();
                        var r = this.transmuxer,
                          n = this.worker;
                        if (n) n.postMessage({ cmd: 'flush', chunkMeta: t });
                        else if (r) {
                          var i = r.flush(t);
                          Object(s.isPromise)(i)
                            ? i.then(function(r) {
                                e.handleFlushResult(r, t);
                              })
                            : this.handleFlushResult(i, t);
                        }
                      }),
                      (e.handleFlushResult = function(t, e) {
                        var r = this;
                        t.forEach(function(t) {
                          r.handleTransmuxComplete(t);
                        }),
                          this.onFlush(e);
                      }),
                      (e.onWorkerMessage = function(t) {
                        var e = t.data,
                          r = this.hls;
                        switch (e.event) {
                          case 'init':
                            self.URL.revokeObjectURL(this.worker.objectURL);
                            break;
                          case 'transmuxComplete':
                            this.handleTransmuxComplete(e.data);
                            break;
                          case 'flush':
                            this.onFlush(e.data);
                            break;
                          case 'workerLog':
                            a.logger[e.data.logType] &&
                              a.logger[e.data.logType](e.data.message);
                            break;
                          default:
                            (e.data = e.data || {}),
                              (e.data.frag = this.frag),
                              (e.data.id = this.id),
                              r.trigger(e.event, e.data);
                        }
                      }),
                      (e.configureTransmuxer = function(t) {
                        var e = this.worker,
                          r = this.transmuxer;
                        e
                          ? e.postMessage({ cmd: 'configure', config: t })
                          : r && r.configure(t);
                      }),
                      (e.handleTransmuxComplete = function(t) {
                        (t.chunkMeta.transmuxing.end = self.performance.now()),
                          this.onTransmuxComplete(t);
                      }),
                      t
                    );
                  })();
              },
              './src/demux/transmuxer-worker.ts': function(t, e, r) {
                function n(t) {
                  var e = new c.EventEmitter(),
                    r = function(e, r) {
                      t.postMessage({ event: e, data: r });
                    };
                  e.on(u.Events.FRAG_DECRYPTED, r),
                    e.on(u.Events.ERROR, r),
                    t.addEventListener('message', function(n) {
                      var s = n.data;
                      switch (s.cmd) {
                        case 'init':
                          var u = JSON.parse(s.config);
                          (t.transmuxer = new o.default(
                            e,
                            s.typeSupported,
                            u,
                            s.vendor,
                            s.id,
                          )),
                            Object(l.enableLogs)(u.debug),
                            (function() {
                              var t = function(t) {
                                l.logger[t] = function(e) {
                                  r('workerLog', { logType: t, message: e });
                                };
                              };
                              for (var e in l.logger) t(e);
                            })(),
                            r('init', null);
                          break;
                        case 'configure':
                          t.transmuxer.configure(s.config);
                          break;
                        case 'demux':
                          var c = t.transmuxer.push(
                            s.data,
                            s.decryptdata,
                            s.chunkMeta,
                            s.state,
                          );
                          Object(o.isPromise)(c)
                            ? c.then(function(e) {
                                i(t, e);
                              })
                            : i(t, c);
                          break;
                        case 'flush':
                          var h = s.chunkMeta,
                            d = t.transmuxer.flush(h);
                          Object(o.isPromise)(d)
                            ? d.then(function(e) {
                                a(t, e, h);
                              })
                            : a(t, d, h);
                      }
                    });
                }
                function i(t, e) {
                  if (
                    !(
                      (r = e.remuxResult).audio ||
                      r.video ||
                      r.text ||
                      r.id3 ||
                      r.initSegment
                    )
                  )
                    return !1;
                  var r,
                    n = [],
                    i = e.remuxResult,
                    a = i.audio,
                    o = i.video;
                  return (
                    a && s(n, a),
                    o && s(n, o),
                    t.postMessage({ event: 'transmuxComplete', data: e }, n),
                    !0
                  );
                }
                function s(t, e) {
                  e.data1 && t.push(e.data1.buffer),
                    e.data2 && t.push(e.data2.buffer);
                }
                function a(t, e, r) {
                  e.reduce(function(e, r) {
                    return i(t, r) || e;
                  }, !1) ||
                    t.postMessage({ event: 'transmuxComplete', data: e[0] }),
                    t.postMessage({ event: 'flush', data: r });
                }
                r.r(e),
                  r.d(e, 'default', function() {
                    return n;
                  });
                var o = r('./src/demux/transmuxer.ts'),
                  u = r('./src/events.ts'),
                  l = r('./src/utils/logger.ts'),
                  c = r('./node_modules/eventemitter3/index.js');
              },
              './src/demux/transmuxer.ts': function(t, e, r) {
                function n(t) {
                  return 'then' in t && t.then instanceof Function;
                }
                r.r(e),
                  r.d(e, 'default', function() {
                    return g;
                  }),
                  r.d(e, 'isPromise', function() {
                    return n;
                  }),
                  r.d(e, 'TransmuxConfig', function() {
                    return y;
                  }),
                  r.d(e, 'TransmuxState', function() {
                    return b;
                  });
                var i,
                  s = r('./src/events.ts'),
                  a = r('./src/errors.ts'),
                  o = r('./src/crypt/decrypter.ts'),
                  u = r('./src/demux/aacdemuxer.ts'),
                  l = r('./src/demux/mp4demuxer.ts'),
                  c = r('./src/demux/tsdemuxer.ts'),
                  h = r('./src/demux/mp3demuxer.ts'),
                  d = r('./src/remux/mp4-remuxer.ts'),
                  f = r('./src/remux/passthrough-remuxer.ts'),
                  p = r('./src/utils/logger.ts');
                try {
                  i = self.performance.now.bind(self.performance);
                } catch (t) {
                  p.logger.debug(
                    'Unable to use Performance API on this environment',
                  ),
                    (i = self.Date.now);
                }
                var v = [
                    { demux: c.default, remux: d.default },
                    { demux: l.default, remux: f.default },
                    { demux: u.default, remux: d.default },
                    { demux: h.default, remux: d.default },
                  ],
                  g = (function() {
                    function t(t, e, r, n, i) {
                      (this.observer = void 0),
                        (this.typeSupported = void 0),
                        (this.config = void 0),
                        (this.vendor = void 0),
                        (this.id = void 0),
                        (this.demuxer = void 0),
                        (this.remuxer = void 0),
                        (this.decrypter = void 0),
                        (this.probe = void 0),
                        (this.decryptionPromise = null),
                        (this.transmuxConfig = void 0),
                        (this.currentTransmuxState = void 0),
                        (this.observer = t),
                        (this.typeSupported = e),
                        (this.config = r),
                        (this.vendor = n),
                        (this.id = i);
                    }
                    var e = t.prototype;
                    return (
                      (e.configure = function(t) {
                        (this.transmuxConfig = t),
                          this.decrypter && this.decrypter.reset();
                      }),
                      (e.push = function(t, e, r, n) {
                        var s = this,
                          a = r.transmuxing;
                        a.executeStart = i();
                        var o = new Uint8Array(t),
                          u = this.config,
                          l = this.currentTransmuxState,
                          c = this.transmuxConfig;
                        n && (this.currentTransmuxState = n);
                        var h = n || l,
                          d = h.contiguous,
                          f = h.discontinuity,
                          p = h.trackSwitch,
                          v = h.accurateTimeOffset,
                          g = h.timeOffset,
                          y = h.initSegmentChange,
                          b = c.audioCodec,
                          E = c.videoCodec,
                          T = c.defaultInitPts,
                          S = c.duration,
                          L = c.initSegmentData;
                        (f || p || y) && this.resetInitSegment(L, b, E, S),
                          (f || y) && this.resetInitialTimestamp(T),
                          d || this.resetContiguity();
                        var _ = (function(t, e) {
                          var r = null;
                          return (
                            t.byteLength > 0 &&
                              null != e &&
                              null != e.key &&
                              null !== e.iv &&
                              null != e.method &&
                              (r = e),
                            r
                          );
                        })(o, e);
                        if (_ && 'AES-128' === _.method) {
                          var A = this.getDecrypter();
                          if (!u.enableSoftwareAES)
                            return (
                              (this.decryptionPromise = A.webCryptoDecrypt(
                                o,
                                _.key.buffer,
                                _.iv.buffer,
                              ).then(function(t) {
                                var e = s.push(t, null, r);
                                return (s.decryptionPromise = null), e;
                              })),
                              this.decryptionPromise
                            );
                          var D = A.softwareDecrypt(
                            o,
                            _.key.buffer,
                            _.iv.buffer,
                          );
                          if (!D) return (a.executeEnd = i()), m(r);
                          o = new Uint8Array(D);
                        }
                        this.needsProbing(o, f, p) &&
                          this.configureTransmuxer(o, c);
                        var w = this.transmux(o, _, g, v, r),
                          k = this.currentTransmuxState;
                        return (
                          (k.contiguous = !0),
                          (k.discontinuity = !1),
                          (k.trackSwitch = !1),
                          (a.executeEnd = i()),
                          w
                        );
                      }),
                      (e.flush = function(t) {
                        var e = this,
                          r = t.transmuxing;
                        r.executeStart = i();
                        var o = this.decrypter,
                          u = this.currentTransmuxState,
                          l = this.decryptionPromise;
                        if (l)
                          return l.then(function() {
                            return e.flush(t);
                          });
                        var c = [],
                          h = u.timeOffset;
                        if (o) {
                          var d = o.flush();
                          d && c.push(this.push(d, null, t));
                        }
                        var f = this.demuxer,
                          p = this.remuxer;
                        if (!f || !p)
                          return (
                            this.observer.emit(s.Events.ERROR, s.Events.ERROR, {
                              type: a.ErrorTypes.MEDIA_ERROR,
                              details: a.ErrorDetails.FRAG_PARSING_ERROR,
                              fatal: !0,
                              reason: 'no demux matching with content found',
                            }),
                            (r.executeEnd = i()),
                            [m(t)]
                          );
                        var v = f.flush(h);
                        return n(v)
                          ? v.then(function(r) {
                              return e.flushRemux(c, r, t), c;
                            })
                          : (this.flushRemux(c, v, t), c);
                      }),
                      (e.flushRemux = function(t, e, r) {
                        var n = e.audioTrack,
                          s = e.videoTrack,
                          a = e.id3Track,
                          o = e.textTrack,
                          u = this.currentTransmuxState,
                          l = u.accurateTimeOffset,
                          c = u.timeOffset;
                        p.logger.log(
                          '[transmuxer.ts]: Flushed fragment ' +
                            r.sn +
                            (r.part > -1 ? ' p: ' + r.part : '') +
                            ' of level ' +
                            r.level,
                        );
                        var h = this.remuxer.remux(
                          n,
                          s,
                          a,
                          o,
                          c,
                          l,
                          !0,
                          this.id,
                        );
                        t.push({ remuxResult: h, chunkMeta: r }),
                          (r.transmuxing.executeEnd = i());
                      }),
                      (e.resetInitialTimestamp = function(t) {
                        var e = this.demuxer,
                          r = this.remuxer;
                        e && r && (e.resetTimeStamp(t), r.resetTimeStamp(t));
                      }),
                      (e.resetContiguity = function() {
                        var t = this.demuxer,
                          e = this.remuxer;
                        t && e && (t.resetContiguity(), e.resetNextTimestamp());
                      }),
                      (e.resetInitSegment = function(t, e, r, n) {
                        var i = this.demuxer,
                          s = this.remuxer;
                        i &&
                          s &&
                          (i.resetInitSegment(t, e, r, n),
                          s.resetInitSegment(t, e, r));
                      }),
                      (e.destroy = function() {
                        this.demuxer &&
                          (this.demuxer.destroy(), (this.demuxer = void 0)),
                          this.remuxer &&
                            (this.remuxer.destroy(), (this.remuxer = void 0));
                      }),
                      (e.transmux = function(t, e, r, n, i) {
                        return e && 'SAMPLE-AES' === e.method
                          ? this.transmuxSampleAes(t, e, r, n, i)
                          : this.transmuxUnencrypted(t, r, n, i);
                      }),
                      (e.transmuxUnencrypted = function(t, e, r, n) {
                        var i = this.demuxer.demux(
                            t,
                            e,
                            !1,
                            !this.config.progressive,
                          ),
                          s = i.audioTrack,
                          a = i.videoTrack,
                          o = i.id3Track,
                          u = i.textTrack;
                        return {
                          remuxResult: this.remuxer.remux(
                            s,
                            a,
                            o,
                            u,
                            e,
                            r,
                            !1,
                            this.id,
                          ),
                          chunkMeta: n,
                        };
                      }),
                      (e.transmuxSampleAes = function(t, e, r, n, i) {
                        var s = this;
                        return this.demuxer
                          .demuxSampleAes(t, e, r)
                          .then(function(t) {
                            return {
                              remuxResult: s.remuxer.remux(
                                t.audioTrack,
                                t.videoTrack,
                                t.id3Track,
                                t.textTrack,
                                r,
                                n,
                                !1,
                                s.id,
                              ),
                              chunkMeta: i,
                            };
                          });
                      }),
                      (e.configureTransmuxer = function(t, e) {
                        for (
                          var r,
                            n = this.config,
                            i = this.observer,
                            s = this.typeSupported,
                            a = this.vendor,
                            o = e.audioCodec,
                            u = e.defaultInitPts,
                            c = e.duration,
                            h = e.initSegmentData,
                            d = e.videoCodec,
                            g = 0,
                            m = v.length;
                          g < m;
                          g++
                        )
                          if (v[g].demux.probe(t)) {
                            r = v[g];
                            break;
                          }
                        r ||
                          (p.logger.warn(
                            'Failed to find demuxer by probing frag, treating as mp4 passthrough',
                          ),
                          (r = { demux: l.default, remux: f.default }));
                        var y = this.demuxer,
                          b = this.remuxer,
                          E = r.remux,
                          T = r.demux;
                        (b && b instanceof E) ||
                          (this.remuxer = new E(i, n, s, a)),
                          (y && y instanceof T) ||
                            ((this.demuxer = new T(i, n, s)),
                            (this.probe = T.probe)),
                          this.resetInitSegment(h, o, d, c),
                          this.resetInitialTimestamp(u);
                      }),
                      (e.needsProbing = function(t, e, r) {
                        return !this.demuxer || !this.remuxer || e || r;
                      }),
                      (e.getDecrypter = function() {
                        var t = this.decrypter;
                        return (
                          t ||
                            (t = this.decrypter = new o.default(
                              this.observer,
                              this.config,
                            )),
                          t
                        );
                      }),
                      t
                    );
                  })(),
                  m = function(t) {
                    return { remuxResult: {}, chunkMeta: t };
                  },
                  y = function(t, e, r, n, i) {
                    (this.audioCodec = void 0),
                      (this.videoCodec = void 0),
                      (this.initSegmentData = void 0),
                      (this.duration = void 0),
                      (this.defaultInitPts = void 0),
                      (this.audioCodec = t),
                      (this.videoCodec = e),
                      (this.initSegmentData = r),
                      (this.duration = n),
                      (this.defaultInitPts = i);
                  },
                  b = function(t, e, r, n, i, s) {
                    (this.discontinuity = void 0),
                      (this.contiguous = void 0),
                      (this.accurateTimeOffset = void 0),
                      (this.trackSwitch = void 0),
                      (this.timeOffset = void 0),
                      (this.initSegmentChange = void 0),
                      (this.discontinuity = t),
                      (this.contiguous = e),
                      (this.accurateTimeOffset = r),
                      (this.trackSwitch = n),
                      (this.timeOffset = i),
                      (this.initSegmentChange = s);
                  };
              },
              './src/demux/tsdemuxer.ts': function(t, e, r) {
                function n() {
                  return (n = Object.assign
                    ? Object.assign.bind()
                    : function(t) {
                        for (var e = 1; e < arguments.length; e++) {
                          var r = arguments[e];
                          for (var n in r)
                            Object.prototype.hasOwnProperty.call(r, n) &&
                              (t[n] = r[n]);
                        }
                        return t;
                      }).apply(this, arguments);
                }
                function i(t, e, r, n) {
                  return {
                    key: t,
                    frame: !1,
                    pts: e,
                    dts: r,
                    units: [],
                    debug: n,
                    length: 0,
                  };
                }
                function s(t, e) {
                  return ((31 & t[e + 10]) << 8) | t[e + 11];
                }
                function a(t, e, r, n) {
                  var i = { audio: -1, avc: -1, id3: -1, segmentCodec: 'aac' },
                    s = e + 3 + (((15 & t[e + 1]) << 8) | t[e + 2]) - 4;
                  for (
                    e += 12 + (((15 & t[e + 10]) << 8) | t[e + 11]);
                    e < s;

                  ) {
                    var a = ((31 & t[e + 1]) << 8) | t[e + 2];
                    switch (t[e]) {
                      case 207:
                        if (!n) {
                          g.logger.log(
                            'ADTS AAC with AES-128-CBC frame encryption found in unencrypted stream',
                          );
                          break;
                        }
                      case 15:
                        -1 === i.audio && (i.audio = a);
                        break;
                      case 21:
                        -1 === i.id3 && (i.id3 = a);
                        break;
                      case 219:
                        if (!n) {
                          g.logger.log(
                            'H.264 with AES-128-CBC slice encryption found in unencrypted stream',
                          );
                          break;
                        }
                      case 27:
                        -1 === i.avc && (i.avc = a);
                        break;
                      case 3:
                      case 4:
                        !0 !== r.mpeg && !0 !== r.mp3
                          ? g.logger.log(
                              'MPEG audio found, not supported in this browser',
                            )
                          : -1 === i.audio &&
                            ((i.audio = a), (i.segmentCodec = 'mp3'));
                        break;
                      case 36:
                        g.logger.warn('Unsupported HEVC stream type found');
                    }
                    e += 5 + (((15 & t[e + 3]) << 8) | t[e + 4]);
                  }
                  return i;
                }
                function o(t) {
                  var e,
                    r,
                    n,
                    i,
                    s,
                    a = 0,
                    o = t.data;
                  if (!t || 0 === t.size) return null;
                  for (; o[0].length < 19 && o.length > 1; ) {
                    var u = new Uint8Array(o[0].length + o[1].length);
                    u.set(o[0]),
                      u.set(o[1], o[0].length),
                      (o[0] = u),
                      o.splice(1, 1);
                  }
                  if (1 === ((e = o[0])[0] << 16) + (e[1] << 8) + e[2]) {
                    if ((r = (e[4] << 8) + e[5]) && r > t.size - 6) return null;
                    var l = e[7];
                    192 & l &&
                      ((i =
                        536870912 * (14 & e[9]) +
                        4194304 * (255 & e[10]) +
                        16384 * (254 & e[11]) +
                        128 * (255 & e[12]) +
                        (254 & e[13]) / 2),
                      64 & l
                        ? i -
                            (s =
                              536870912 * (14 & e[14]) +
                              4194304 * (255 & e[15]) +
                              16384 * (254 & e[16]) +
                              128 * (255 & e[17]) +
                              (254 & e[18]) / 2) >
                            54e5 &&
                          (g.logger.warn(
                            Math.round((i - s) / 9e4) +
                              's delta between PTS and DTS, align them',
                          ),
                          (i = s))
                        : (s = i));
                    var c = (n = e[8]) + 9;
                    if (t.size <= c) return null;
                    t.size -= c;
                    for (
                      var h = new Uint8Array(t.size), d = 0, f = o.length;
                      d < f;
                      d++
                    ) {
                      var p = (e = o[d]).byteLength;
                      if (c) {
                        if (c > p) {
                          c -= p;
                          continue;
                        }
                        (e = e.subarray(c)), (p -= c), (c = 0);
                      }
                      h.set(e, a), (a += p);
                    }
                    return (
                      r && (r -= n + 3), { data: h, pts: i, dts: s, len: r }
                    );
                  }
                  return null;
                }
                function u(t, e) {
                  if (t.units.length && t.frame) {
                    if (void 0 === t.pts) {
                      var r = e.samples,
                        n = r.length;
                      if (!n) return void e.dropped++;
                      var i = r[n - 1];
                      (t.pts = i.pts), (t.dts = i.dts);
                    }
                    e.samples.push(t);
                  }
                  t.debug.length &&
                    g.logger.log(t.pts + '/' + t.dts + ':' + t.debug);
                }
                function l(t) {
                  for (var e = t.byteLength, r = [], n = 1; n < e - 2; )
                    0 === t[n] && 0 === t[n + 1] && 3 === t[n + 2]
                      ? (r.push(n + 2), (n += 2))
                      : n++;
                  if (0 === r.length) return t;
                  var i = e - r.length,
                    s = new Uint8Array(i),
                    a = 0;
                  for (n = 0; n < i; a++, n++)
                    a === r[0] && (a++, r.shift()), (s[n] = t[a]);
                  return s;
                }
                r.r(e),
                  r.d(e, 'discardEPB', function() {
                    return l;
                  });
                var c = r('./src/demux/adts.ts'),
                  h = r('./src/demux/mpegaudio.ts'),
                  d = r('./src/demux/exp-golomb.ts'),
                  f = r('./src/demux/sample-aes.ts'),
                  p = r('./src/events.ts'),
                  v = r('./src/utils/mp4-tools.ts'),
                  g = r('./src/utils/logger.ts'),
                  m = r('./src/errors.ts'),
                  y = r('./src/types/demuxer.ts'),
                  b = (function() {
                    function t(t, e, r) {
                      (this.observer = void 0),
                        (this.config = void 0),
                        (this.typeSupported = void 0),
                        (this.sampleAes = null),
                        (this.pmtParsed = !1),
                        (this.audioCodec = void 0),
                        (this.videoCodec = void 0),
                        (this._duration = 0),
                        (this._pmtId = -1),
                        (this._avcTrack = void 0),
                        (this._audioTrack = void 0),
                        (this._id3Track = void 0),
                        (this._txtTrack = void 0),
                        (this.aacOverFlow = null),
                        (this.avcSample = null),
                        (this.remainderData = null),
                        (this.observer = t),
                        (this.config = e),
                        (this.typeSupported = r);
                    }
                    (t.probe = function(t) {
                      return 71 === t[0] && 71 === t[188];
                    }),
                      (t.createTrack = function(t, e) {
                        return {
                          container:
                            'video' === t || 'audio' === t
                              ? 'video/mp2t'
                              : void 0,
                          type: t,
                          id: v.RemuxerTrackIdConfig[t],
                          pid: -1,
                          inputTimeScale: 9e4,
                          sequenceNumber: 0,
                          samples: [],
                          dropped: 0,
                          duration: 'audio' === t ? e : void 0,
                        };
                      });
                    var e = t.prototype;
                    return (
                      (e.resetInitSegment = function(e, r, n, i) {
                        (this.pmtParsed = !1),
                          (this._pmtId = -1),
                          (this._avcTrack = t.createTrack('video')),
                          (this._audioTrack = t.createTrack('audio', i)),
                          (this._id3Track = t.createTrack('id3')),
                          (this._txtTrack = t.createTrack('text')),
                          (this._audioTrack.segmentCodec = 'aac'),
                          (this.aacOverFlow = null),
                          (this.avcSample = null),
                          (this.remainderData = null),
                          (this.audioCodec = r),
                          (this.videoCodec = n),
                          (this._duration = i);
                      }),
                      (e.resetTimeStamp = function() {}),
                      (e.resetContiguity = function() {
                        var t = this._audioTrack,
                          e = this._avcTrack,
                          r = this._id3Track;
                        t && (t.pesData = null),
                          e && (e.pesData = null),
                          r && (r.pesData = null),
                          (this.aacOverFlow = null);
                      }),
                      (e.demux = function(t, e, r, n) {
                        var i;
                        void 0 === r && (r = !1),
                          void 0 === n && (n = !1),
                          r || (this.sampleAes = null);
                        var u = this._avcTrack,
                          l = this._audioTrack,
                          c = this._id3Track,
                          h = this._txtTrack,
                          d = u.pid,
                          f = u.pesData,
                          y = l.pid,
                          b = c.pid,
                          E = l.pesData,
                          T = c.pesData,
                          S = null,
                          L = this.pmtParsed,
                          _ = this._pmtId,
                          A = t.length;
                        if (
                          (this.remainderData &&
                            ((A = (t = Object(v.appendUint8Array)(
                              this.remainderData,
                              t,
                            )).length),
                            (this.remainderData = null)),
                          A < 188 && !n)
                        )
                          return (
                            (this.remainderData = t),
                            {
                              audioTrack: l,
                              videoTrack: u,
                              id3Track: c,
                              textTrack: h,
                            }
                          );
                        (A -= A % 188) < t.byteLength &&
                          !n &&
                          (this.remainderData = new Uint8Array(
                            t.buffer,
                            A,
                            t.buffer.byteLength - A,
                          ));
                        for (var D = 0, w = 0; w < A; w += 188)
                          if (71 === t[w]) {
                            var k = !!(64 & t[w + 1]),
                              R = ((31 & t[w + 1]) << 8) + t[w + 2],
                              O = void 0;
                            if ((48 & t[w + 3]) >> 4 > 1) {
                              if ((O = w + 5 + t[w + 4]) === w + 188) continue;
                            } else O = w + 4;
                            switch (R) {
                              case d:
                                k &&
                                  (f &&
                                    (i = o(f)) &&
                                    this.parseAVCPES(u, h, i, !1),
                                  (f = { data: [], size: 0 })),
                                  f &&
                                    (f.data.push(t.subarray(O, w + 188)),
                                    (f.size += w + 188 - O));
                                break;
                              case y:
                                if (k) {
                                  if (E && (i = o(E)))
                                    switch (l.segmentCodec) {
                                      case 'aac':
                                        this.parseAACPES(l, i);
                                        break;
                                      case 'mp3':
                                        this.parseMPEGPES(l, i);
                                    }
                                  E = { data: [], size: 0 };
                                }
                                E &&
                                  (E.data.push(t.subarray(O, w + 188)),
                                  (E.size += w + 188 - O));
                                break;
                              case b:
                                k &&
                                  (T && (i = o(T)) && this.parseID3PES(c, i),
                                  (T = { data: [], size: 0 })),
                                  T &&
                                    (T.data.push(t.subarray(O, w + 188)),
                                    (T.size += w + 188 - O));
                                break;
                              case 0:
                                k && (O += t[O] + 1),
                                  (_ = this._pmtId = s(t, O));
                                break;
                              case _:
                                k && (O += t[O] + 1);
                                var I = a(t, O, this.typeSupported, r);
                                (d = I.avc) > 0 && (u.pid = d),
                                  (y = I.audio) > 0 &&
                                    ((l.pid = y),
                                    (l.segmentCodec = I.segmentCodec)),
                                  (b = I.id3) > 0 && (c.pid = b),
                                  null === S ||
                                    L ||
                                    (g.logger.log(
                                      "unknown PID '" + S + "' in TS found",
                                    ),
                                    (S = null)),
                                  (L = this.pmtParsed = !0);
                                break;
                              case 17:
                              case 8191:
                                break;
                              default:
                                S = R;
                            }
                          } else D++;
                        D > 0 &&
                          this.observer.emit(p.Events.ERROR, p.Events.ERROR, {
                            type: m.ErrorTypes.MEDIA_ERROR,
                            details: m.ErrorDetails.FRAG_PARSING_ERROR,
                            fatal: !1,
                            reason:
                              'Found ' +
                              D +
                              ' TS packet/s that do not start with 0x47',
                          }),
                          (u.pesData = f),
                          (l.pesData = E),
                          (c.pesData = T);
                        var C = {
                          audioTrack: l,
                          videoTrack: u,
                          id3Track: c,
                          textTrack: h,
                        };
                        return n && this.extractRemainingSamples(C), C;
                      }),
                      (e.flush = function() {
                        var t,
                          e = this.remainderData;
                        return (
                          (this.remainderData = null),
                          (t = e
                            ? this.demux(e, -1, !1, !0)
                            : {
                                videoTrack: this._avcTrack,
                                audioTrack: this._audioTrack,
                                id3Track: this._id3Track,
                                textTrack: this._txtTrack,
                              }),
                          this.extractRemainingSamples(t),
                          this.sampleAes ? this.decrypt(t, this.sampleAes) : t
                        );
                      }),
                      (e.extractRemainingSamples = function(t) {
                        var e,
                          r = t.audioTrack,
                          n = t.videoTrack,
                          i = t.id3Track,
                          s = t.textTrack,
                          a = n.pesData,
                          u = r.pesData,
                          l = i.pesData;
                        if (
                          (a && (e = o(a))
                            ? (this.parseAVCPES(n, s, e, !0),
                              (n.pesData = null))
                            : (n.pesData = a),
                          u && (e = o(u)))
                        ) {
                          switch (r.segmentCodec) {
                            case 'aac':
                              this.parseAACPES(r, e);
                              break;
                            case 'mp3':
                              this.parseMPEGPES(r, e);
                          }
                          r.pesData = null;
                        } else
                          null != u &&
                            u.size &&
                            g.logger.log(
                              'last AAC PES packet truncated,might overlap between fragments',
                            ),
                            (r.pesData = u);
                        l && (e = o(l))
                          ? (this.parseID3PES(i, e), (i.pesData = null))
                          : (i.pesData = l);
                      }),
                      (e.demuxSampleAes = function(t, e, r) {
                        var n = this.demux(t, r, !0, !this.config.progressive),
                          i = (this.sampleAes = new f.default(
                            this.observer,
                            this.config,
                            e,
                          ));
                        return this.decrypt(n, i);
                      }),
                      (e.decrypt = function(t, e) {
                        return new Promise(function(r) {
                          var n = t.audioTrack,
                            i = t.videoTrack;
                          n.samples && 'aac' === n.segmentCodec
                            ? e.decryptAacSamples(n.samples, 0, function() {
                                i.samples
                                  ? e.decryptAvcSamples(
                                      i.samples,
                                      0,
                                      0,
                                      function() {
                                        r(t);
                                      },
                                    )
                                  : r(t);
                              })
                            : i.samples &&
                              e.decryptAvcSamples(i.samples, 0, 0, function() {
                                r(t);
                              });
                        });
                      }),
                      (e.destroy = function() {
                        this._duration = 0;
                      }),
                      (e.parseAVCPES = function(t, e, r, n) {
                        var s,
                          a = this,
                          o = this.parseAVCNALu(t, r.data),
                          c = this.avcSample,
                          h = !1;
                        (r.data = null),
                          c &&
                            o.length &&
                            !t.audFound &&
                            (u(c, t),
                            (c = this.avcSample = i(!1, r.pts, r.dts, ''))),
                          o.forEach(function(n) {
                            switch (n.type) {
                              case 1:
                                (s = !0),
                                  c ||
                                    (c = a.avcSample = i(!0, r.pts, r.dts, '')),
                                  (c.frame = !0);
                                var o = n.data;
                                if (h && o.length > 4) {
                                  var f = new d.default(o).readSliceType();
                                  (2 !== f && 4 !== f && 7 !== f && 9 !== f) ||
                                    (c.key = !0);
                                }
                                break;
                              case 5:
                                (s = !0),
                                  c ||
                                    (c = a.avcSample = i(!0, r.pts, r.dts, '')),
                                  (c.key = !0),
                                  (c.frame = !0);
                                break;
                              case 6:
                                (s = !0),
                                  Object(v.parseSEIMessageFromNALu)(
                                    l(n.data),
                                    r.pts,
                                    e.samples,
                                  );
                                break;
                              case 7:
                                if (((s = !0), (h = !0), !t.sps)) {
                                  var p = new d.default(n.data).readSPS();
                                  (t.width = p.width),
                                    (t.height = p.height),
                                    (t.pixelRatio = p.pixelRatio),
                                    (t.sps = [n.data]),
                                    (t.duration = a._duration);
                                  for (
                                    var g = n.data.subarray(1, 4),
                                      m = 'avc1.',
                                      y = 0;
                                    y < 3;
                                    y++
                                  ) {
                                    var b = g[y].toString(16);
                                    b.length < 2 && (b = '0' + b), (m += b);
                                  }
                                  t.codec = m;
                                }
                                break;
                              case 8:
                                (s = !0), t.pps || (t.pps = [n.data]);
                                break;
                              case 9:
                                (s = !1),
                                  (t.audFound = !0),
                                  c && u(c, t),
                                  (c = a.avcSample = i(!1, r.pts, r.dts, ''));
                                break;
                              case 12:
                                s = !0;
                                break;
                              default:
                                (s = !1),
                                  c &&
                                    (c.debug += 'unknown NAL ' + n.type + ' ');
                            }
                            c && s && c.units.push(n);
                          }),
                          n && c && (u(c, t), (this.avcSample = null));
                      }),
                      (e.getLastNalUnit = function(t) {
                        var e,
                          r,
                          n = this.avcSample;
                        if (
                          ((n && 0 !== n.units.length) || (n = t[t.length - 1]),
                          null !== (e = n) && void 0 !== e && e.units)
                        ) {
                          var i = n.units;
                          r = i[i.length - 1];
                        }
                        return r;
                      }),
                      (e.parseAVCNALu = function(t, e) {
                        var r,
                          n,
                          i = e.byteLength,
                          s = t.naluState || 0,
                          a = s,
                          o = [],
                          u = 0,
                          l = -1,
                          c = 0;
                        for (
                          -1 === s &&
                          ((l = 0), (c = 31 & e[0]), (s = 0), (u = 1));
                          u < i;

                        )
                          if (((r = e[u++]), s))
                            if (1 !== s)
                              if (r)
                                if (1 === r) {
                                  if (l >= 0) {
                                    var h = {
                                      data: e.subarray(l, u - s - 1),
                                      type: c,
                                    };
                                    o.push(h);
                                  } else {
                                    var d = this.getLastNalUnit(t.samples);
                                    if (
                                      d &&
                                      (a &&
                                        u <= 4 - a &&
                                        d.state &&
                                        (d.data = d.data.subarray(
                                          0,
                                          d.data.byteLength - a,
                                        )),
                                      (n = u - s - 1) > 0)
                                    ) {
                                      var f = new Uint8Array(
                                        d.data.byteLength + n,
                                      );
                                      f.set(d.data, 0),
                                        f.set(
                                          e.subarray(0, n),
                                          d.data.byteLength,
                                        ),
                                        (d.data = f),
                                        (d.state = 0);
                                    }
                                  }
                                  u < i
                                    ? ((l = u), (c = 31 & e[u]), (s = 0))
                                    : (s = -1);
                                } else s = 0;
                              else s = 3;
                            else s = r ? 0 : 2;
                          else s = r ? 0 : 1;
                        if (l >= 0 && s >= 0) {
                          var p = { data: e.subarray(l, i), type: c, state: s };
                          o.push(p);
                        }
                        if (0 === o.length) {
                          var v = this.getLastNalUnit(t.samples);
                          if (v) {
                            var g = new Uint8Array(
                              v.data.byteLength + e.byteLength,
                            );
                            g.set(v.data, 0),
                              g.set(e, v.data.byteLength),
                              (v.data = g);
                          }
                        }
                        return (t.naluState = s), o;
                      }),
                      (e.parseAACPES = function(t, e) {
                        var r,
                          n,
                          i,
                          s,
                          a,
                          o = 0,
                          u = this.aacOverFlow,
                          l = e.data;
                        if (u) {
                          this.aacOverFlow = null;
                          var h = u.missing,
                            d = u.sample.unit.byteLength;
                          if (-1 === h) {
                            var f = new Uint8Array(d + l.byteLength);
                            f.set(u.sample.unit, 0), f.set(l, d), (l = f);
                          } else {
                            var v = d - h;
                            u.sample.unit.set(l.subarray(0, h), v),
                              t.samples.push(u.sample),
                              (o = u.missing);
                          }
                        }
                        for (
                          r = o, n = l.length;
                          r < n - 1 && !c.isHeader(l, r);
                          r++
                        );
                        if (
                          r === o ||
                          (r < n - 1
                            ? ((i =
                                'AAC PES did not start with ADTS header,offset:' +
                                r),
                              (s = !1))
                            : ((i = 'no ADTS header found in AAC PES'),
                              (s = !0)),
                          g.logger.warn('parsing error:' + i),
                          this.observer.emit(p.Events.ERROR, p.Events.ERROR, {
                            type: m.ErrorTypes.MEDIA_ERROR,
                            details: m.ErrorDetails.FRAG_PARSING_ERROR,
                            fatal: s,
                            reason: i,
                          }),
                          !s)
                        ) {
                          if (
                            (c.initTrackConfig(
                              t,
                              this.observer,
                              l,
                              r,
                              this.audioCodec,
                            ),
                            void 0 !== e.pts)
                          )
                            a = e.pts;
                          else {
                            if (!u)
                              return void g.logger.warn(
                                '[tsdemuxer]: AAC PES unknown PTS',
                              );
                            var y = c.getFrameDuration(t.samplerate);
                            a = u.sample.pts + y;
                          }
                          for (var b, E = 0; r < n; ) {
                            if (
                              ((r += (b = c.appendFrame(t, l, r, a, E)).length),
                              b.missing)
                            ) {
                              this.aacOverFlow = b;
                              break;
                            }
                            for (E++; r < n - 1 && !c.isHeader(l, r); r++);
                          }
                        }
                      }),
                      (e.parseMPEGPES = function(t, e) {
                        var r = e.data,
                          n = r.length,
                          i = 0,
                          s = 0,
                          a = e.pts;
                        if (void 0 !== a)
                          for (; s < n; )
                            if (h.isHeader(r, s)) {
                              var o = h.appendFrame(t, r, s, a, i);
                              if (!o) break;
                              (s += o.length), i++;
                            } else s++;
                        else g.logger.warn('[tsdemuxer]: MPEG PES unknown PTS');
                      }),
                      (e.parseID3PES = function(t, e) {
                        if (void 0 !== e.pts) {
                          var r = n({}, e, {
                            type: this._avcTrack
                              ? y.MetadataSchema.emsg
                              : y.MetadataSchema.audioId3,
                          });
                          t.samples.push(r);
                        } else
                          g.logger.warn('[tsdemuxer]: ID3 PES unknown PTS');
                      }),
                      t
                    );
                  })();
                e.default = b;
              },
              './src/errors.ts': function(t, e, r) {
                var n, i;
                r.r(e),
                  r.d(e, 'ErrorTypes', function() {
                    return n;
                  }),
                  r.d(e, 'ErrorDetails', function() {
                    return i;
                  }),
                  (function(t) {
                    (t.NETWORK_ERROR = 'networkError'),
                      (t.MEDIA_ERROR = 'mediaError'),
                      (t.KEY_SYSTEM_ERROR = 'keySystemError'),
                      (t.MUX_ERROR = 'muxError'),
                      (t.OTHER_ERROR = 'otherError');
                  })(n || (n = {})),
                  (function(t) {
                    (t.KEY_SYSTEM_NO_KEYS = 'keySystemNoKeys'),
                      (t.KEY_SYSTEM_NO_ACCESS = 'keySystemNoAccess'),
                      (t.KEY_SYSTEM_NO_SESSION = 'keySystemNoSession'),
                      (t.KEY_SYSTEM_LICENSE_REQUEST_FAILED =
                        'keySystemLicenseRequestFailed'),
                      (t.KEY_SYSTEM_NO_INIT_DATA = 'keySystemNoInitData'),
                      (t.MANIFEST_LOAD_ERROR = 'manifestLoadError'),
                      (t.MANIFEST_LOAD_TIMEOUT = 'manifestLoadTimeOut'),
                      (t.MANIFEST_PARSING_ERROR = 'manifestParsingError'),
                      (t.MANIFEST_INCOMPATIBLE_CODECS_ERROR =
                        'manifestIncompatibleCodecsError'),
                      (t.LEVEL_EMPTY_ERROR = 'levelEmptyError'),
                      (t.LEVEL_LOAD_ERROR = 'levelLoadError'),
                      (t.LEVEL_LOAD_TIMEOUT = 'levelLoadTimeOut'),
                      (t.LEVEL_SWITCH_ERROR = 'levelSwitchError'),
                      (t.AUDIO_TRACK_LOAD_ERROR = 'audioTrackLoadError'),
                      (t.AUDIO_TRACK_LOAD_TIMEOUT = 'audioTrackLoadTimeOut'),
                      (t.SUBTITLE_LOAD_ERROR = 'subtitleTrackLoadError'),
                      (t.SUBTITLE_TRACK_LOAD_TIMEOUT =
                        'subtitleTrackLoadTimeOut'),
                      (t.FRAG_LOAD_ERROR = 'fragLoadError'),
                      (t.FRAG_LOAD_TIMEOUT = 'fragLoadTimeOut'),
                      (t.FRAG_DECRYPT_ERROR = 'fragDecryptError'),
                      (t.FRAG_PARSING_ERROR = 'fragParsingError'),
                      (t.REMUX_ALLOC_ERROR = 'remuxAllocError'),
                      (t.KEY_LOAD_ERROR = 'keyLoadError'),
                      (t.KEY_LOAD_TIMEOUT = 'keyLoadTimeOut'),
                      (t.BUFFER_ADD_CODEC_ERROR = 'bufferAddCodecError'),
                      (t.BUFFER_INCOMPATIBLE_CODECS_ERROR =
                        'bufferIncompatibleCodecsError'),
                      (t.BUFFER_APPEND_ERROR = 'bufferAppendError'),
                      (t.BUFFER_APPENDING_ERROR = 'bufferAppendingError'),
                      (t.BUFFER_STALLED_ERROR = 'bufferStalledError'),
                      (t.BUFFER_FULL_ERROR = 'bufferFullError'),
                      (t.BUFFER_SEEK_OVER_HOLE = 'bufferSeekOverHole'),
                      (t.BUFFER_NUDGE_ON_STALL = 'bufferNudgeOnStall'),
                      (t.INTERNAL_EXCEPTION = 'internalException'),
                      (t.INTERNAL_ABORTED = 'aborted'),
                      (t.UNKNOWN = 'unknown');
                  })(i || (i = {}));
              },
              './src/events.ts': function(t, e, r) {
                var n;
                r.r(e),
                  r.d(e, 'Events', function() {
                    return n;
                  }),
                  (function(t) {
                    (t.MEDIA_ATTACHING = 'hlsMediaAttaching'),
                      (t.MEDIA_ATTACHED = 'hlsMediaAttached'),
                      (t.MEDIA_DETACHING = 'hlsMediaDetaching'),
                      (t.MEDIA_DETACHED = 'hlsMediaDetached'),
                      (t.BUFFER_RESET = 'hlsBufferReset'),
                      (t.BUFFER_CODECS = 'hlsBufferCodecs'),
                      (t.BUFFER_CREATED = 'hlsBufferCreated'),
                      (t.BUFFER_APPENDING = 'hlsBufferAppending'),
                      (t.BUFFER_APPENDED = 'hlsBufferAppended'),
                      (t.BUFFER_EOS = 'hlsBufferEos'),
                      (t.BUFFER_FLUSHING = 'hlsBufferFlushing'),
                      (t.BUFFER_FLUSHED = 'hlsBufferFlushed'),
                      (t.MANIFEST_LOADING = 'hlsManifestLoading'),
                      (t.MANIFEST_LOADED = 'hlsManifestLoaded'),
                      (t.MANIFEST_PARSED = 'hlsManifestParsed'),
                      (t.LEVEL_SWITCHING = 'hlsLevelSwitching'),
                      (t.LEVEL_SWITCHED = 'hlsLevelSwitched'),
                      (t.LEVEL_LOADING = 'hlsLevelLoading'),
                      (t.LEVEL_LOADED = 'hlsLevelLoaded'),
                      (t.LEVEL_UPDATED = 'hlsLevelUpdated'),
                      (t.LEVEL_PTS_UPDATED = 'hlsLevelPtsUpdated'),
                      (t.LEVELS_UPDATED = 'hlsLevelsUpdated'),
                      (t.AUDIO_TRACKS_UPDATED = 'hlsAudioTracksUpdated'),
                      (t.AUDIO_TRACK_SWITCHING = 'hlsAudioTrackSwitching'),
                      (t.AUDIO_TRACK_SWITCHED = 'hlsAudioTrackSwitched'),
                      (t.AUDIO_TRACK_LOADING = 'hlsAudioTrackLoading'),
                      (t.AUDIO_TRACK_LOADED = 'hlsAudioTrackLoaded'),
                      (t.SUBTITLE_TRACKS_UPDATED = 'hlsSubtitleTracksUpdated'),
                      (t.SUBTITLE_TRACKS_CLEARED = 'hlsSubtitleTracksCleared'),
                      (t.SUBTITLE_TRACK_SWITCH = 'hlsSubtitleTrackSwitch'),
                      (t.SUBTITLE_TRACK_LOADING = 'hlsSubtitleTrackLoading'),
                      (t.SUBTITLE_TRACK_LOADED = 'hlsSubtitleTrackLoaded'),
                      (t.SUBTITLE_FRAG_PROCESSED = 'hlsSubtitleFragProcessed'),
                      (t.CUES_PARSED = 'hlsCuesParsed'),
                      (t.NON_NATIVE_TEXT_TRACKS_FOUND =
                        'hlsNonNativeTextTracksFound'),
                      (t.INIT_PTS_FOUND = 'hlsInitPtsFound'),
                      (t.FRAG_LOADING = 'hlsFragLoading'),
                      (t.FRAG_LOAD_EMERGENCY_ABORTED =
                        'hlsFragLoadEmergencyAborted'),
                      (t.FRAG_LOADED = 'hlsFragLoaded'),
                      (t.FRAG_DECRYPTED = 'hlsFragDecrypted'),
                      (t.FRAG_PARSING_INIT_SEGMENT =
                        'hlsFragParsingInitSegment'),
                      (t.FRAG_PARSING_USERDATA = 'hlsFragParsingUserdata'),
                      (t.FRAG_PARSING_METADATA = 'hlsFragParsingMetadata'),
                      (t.FRAG_PARSED = 'hlsFragParsed'),
                      (t.FRAG_BUFFERED = 'hlsFragBuffered'),
                      (t.FRAG_CHANGED = 'hlsFragChanged'),
                      (t.FPS_DROP = 'hlsFpsDrop'),
                      (t.FPS_DROP_LEVEL_CAPPING = 'hlsFpsDropLevelCapping'),
                      (t.ERROR = 'hlsError'),
                      (t.DESTROYING = 'hlsDestroying'),
                      (t.KEY_LOADING = 'hlsKeyLoading'),
                      (t.KEY_LOADED = 'hlsKeyLoaded'),
                      (t.LIVE_BACK_BUFFER_REACHED = 'hlsLiveBackBufferReached'),
                      (t.BACK_BUFFER_REACHED = 'hlsBackBufferReached');
                  })(n || (n = {}));
              },
              './src/hls.ts': function(t, e, r) {
                function n(t, e) {
                  for (var r = 0; r < e.length; r++) {
                    var n = e[r];
                    (n.enumerable = n.enumerable || !1),
                      (n.configurable = !0),
                      'value' in n && (n.writable = !0),
                      Object.defineProperty(t, n.key, n);
                  }
                }
                r.r(e),
                  r.d(e, 'default', function() {
                    return y;
                  });
                var i = r('./node_modules/url-toolkit/src/url-toolkit.js'),
                  s = r('./src/loader/playlist-loader.ts'),
                  a = r('./src/loader/key-loader.ts'),
                  o = r('./src/controller/id3-track-controller.ts'),
                  u = r('./src/controller/latency-controller.ts'),
                  l = r('./src/controller/level-controller.ts'),
                  c = r('./src/controller/fragment-tracker.ts'),
                  h = r('./src/controller/stream-controller.ts'),
                  d = r('./src/is-supported.ts'),
                  f = r('./src/utils/logger.ts'),
                  p = r('./src/config.ts'),
                  v = r('./node_modules/eventemitter3/index.js'),
                  g = r('./src/events.ts'),
                  m = r('./src/errors.ts'),
                  y = (function() {
                    function t(e) {
                      void 0 === e && (e = {}),
                        (this.config = void 0),
                        (this.userConfig = void 0),
                        (this.coreComponents = void 0),
                        (this.networkControllers = void 0),
                        (this._emitter = new v.EventEmitter()),
                        (this._autoLevelCapping = void 0),
                        (this.abrController = void 0),
                        (this.bufferController = void 0),
                        (this.capLevelController = void 0),
                        (this.latencyController = void 0),
                        (this.levelController = void 0),
                        (this.streamController = void 0),
                        (this.audioTrackController = void 0),
                        (this.subtitleTrackController = void 0),
                        (this.emeController = void 0),
                        (this.cmcdController = void 0),
                        (this._media = null),
                        (this.url = null);
                      var r = (this.config = Object(p.mergeConfig)(
                        t.DefaultConfig,
                        e,
                      ));
                      (this.userConfig = e),
                        Object(f.enableLogs)(r.debug),
                        (this._autoLevelCapping = -1),
                        r.progressive && Object(p.enableStreamingMode)(r);
                      var n = r.abrController,
                        i = r.bufferController,
                        d = r.capLevelController,
                        g = r.fpsController,
                        m = (this.abrController = new n(this)),
                        y = (this.bufferController = new i(this)),
                        b = (this.capLevelController = new d(this)),
                        E = new g(this),
                        T = new s.default(this),
                        S = new a.default(this),
                        L = new o.default(this),
                        _ = (this.levelController = new l.default(this)),
                        A = new c.FragmentTracker(this),
                        D = (this.streamController = new h.default(this, A));
                      b.setStreamController(D), E.setStreamController(D);
                      var w = [T, S, _, D];
                      this.networkControllers = w;
                      var k = [m, y, b, E, L, A];
                      (this.audioTrackController = this.createController(
                        r.audioTrackController,
                        null,
                        w,
                      )),
                        this.createController(r.audioStreamController, A, w),
                        (this.subtitleTrackController = this.createController(
                          r.subtitleTrackController,
                          null,
                          w,
                        )),
                        this.createController(r.subtitleStreamController, A, w),
                        this.createController(r.timelineController, null, k),
                        (this.emeController = this.createController(
                          r.emeController,
                          null,
                          k,
                        )),
                        (this.cmcdController = this.createController(
                          r.cmcdController,
                          null,
                          k,
                        )),
                        (this.latencyController = this.createController(
                          u.default,
                          null,
                          k,
                        )),
                        (this.coreComponents = k);
                    }
                    t.isSupported = function() {
                      return Object(d.isSupported)();
                    };
                    var e,
                      r,
                      y,
                      b = t.prototype;
                    return (
                      (b.createController = function(t, e, r) {
                        if (t) {
                          var n = e ? new t(this, e) : new t(this);
                          return r && r.push(n), n;
                        }
                        return null;
                      }),
                      (b.on = function(t, e, r) {
                        void 0 === r && (r = this), this._emitter.on(t, e, r);
                      }),
                      (b.once = function(t, e, r) {
                        void 0 === r && (r = this), this._emitter.once(t, e, r);
                      }),
                      (b.removeAllListeners = function(t) {
                        this._emitter.removeAllListeners(t);
                      }),
                      (b.off = function(t, e, r, n) {
                        void 0 === r && (r = this),
                          this._emitter.off(t, e, r, n);
                      }),
                      (b.listeners = function(t) {
                        return this._emitter.listeners(t);
                      }),
                      (b.emit = function(t, e, r) {
                        return this._emitter.emit(t, e, r);
                      }),
                      (b.trigger = function(t, e) {
                        if (this.config.debug) return this.emit(t, t, e);
                        try {
                          return this.emit(t, t, e);
                        } catch (e) {
                          f.logger.error(
                            'An internal error happened while handling event ' +
                              t +
                              '. Error message: "' +
                              e.message +
                              '". Here is a stacktrace:',
                            e,
                          ),
                            this.trigger(g.Events.ERROR, {
                              type: m.ErrorTypes.OTHER_ERROR,
                              details: m.ErrorDetails.INTERNAL_EXCEPTION,
                              fatal: !1,
                              event: t,
                              error: e,
                            });
                        }
                        return !1;
                      }),
                      (b.listenerCount = function(t) {
                        return this._emitter.listenerCount(t);
                      }),
                      (b.destroy = function() {
                        f.logger.log('destroy'),
                          this.trigger(g.Events.DESTROYING, void 0),
                          this.detachMedia(),
                          this.removeAllListeners(),
                          (this._autoLevelCapping = -1),
                          (this.url = null),
                          this.networkControllers.forEach(function(t) {
                            return t.destroy();
                          }),
                          (this.networkControllers.length = 0),
                          this.coreComponents.forEach(function(t) {
                            return t.destroy();
                          }),
                          (this.coreComponents.length = 0);
                      }),
                      (b.attachMedia = function(t) {
                        f.logger.log('attachMedia'),
                          (this._media = t),
                          this.trigger(g.Events.MEDIA_ATTACHING, { media: t });
                      }),
                      (b.detachMedia = function() {
                        f.logger.log('detachMedia'),
                          this.trigger(g.Events.MEDIA_DETACHING, void 0),
                          (this._media = null);
                      }),
                      (b.loadSource = function(t) {
                        this.stopLoad();
                        var e = this.media,
                          r = this.url,
                          n = (this.url = i.buildAbsoluteURL(
                            self.location.href,
                            t,
                            { alwaysNormalize: !0 },
                          ));
                        f.logger.log('loadSource:' + n),
                          e &&
                            r &&
                            r !== n &&
                            this.bufferController.hasSourceTypes() &&
                            (this.detachMedia(), this.attachMedia(e)),
                          this.trigger(g.Events.MANIFEST_LOADING, { url: t });
                      }),
                      (b.startLoad = function(t) {
                        void 0 === t && (t = -1),
                          f.logger.log('startLoad(' + t + ')'),
                          this.networkControllers.forEach(function(e) {
                            e.startLoad(t);
                          });
                      }),
                      (b.stopLoad = function() {
                        f.logger.log('stopLoad'),
                          this.networkControllers.forEach(function(t) {
                            t.stopLoad();
                          });
                      }),
                      (b.swapAudioCodec = function() {
                        f.logger.log('swapAudioCodec'),
                          this.streamController.swapAudioCodec();
                      }),
                      (b.recoverMediaError = function() {
                        f.logger.log('recoverMediaError');
                        var t = this._media;
                        this.detachMedia(), t && this.attachMedia(t);
                      }),
                      (b.removeLevel = function(t, e) {
                        void 0 === e && (e = 0),
                          this.levelController.removeLevel(t, e);
                      }),
                      (e = t),
                      (y = [
                        {
                          key: 'version',
                          get: function() {
                            return '1.2.4';
                          },
                        },
                        {
                          key: 'Events',
                          get: function() {
                            return g.Events;
                          },
                        },
                        {
                          key: 'ErrorTypes',
                          get: function() {
                            return m.ErrorTypes;
                          },
                        },
                        {
                          key: 'ErrorDetails',
                          get: function() {
                            return m.ErrorDetails;
                          },
                        },
                        {
                          key: 'DefaultConfig',
                          get: function() {
                            return t.defaultConfig
                              ? t.defaultConfig
                              : p.hlsDefaultConfig;
                          },
                          set: function(e) {
                            t.defaultConfig = e;
                          },
                        },
                      ]),
                      (r = [
                        {
                          key: 'levels',
                          get: function() {
                            return this.levelController.levels || [];
                          },
                        },
                        {
                          key: 'currentLevel',
                          get: function() {
                            return this.streamController.currentLevel;
                          },
                          set: function(t) {
                            f.logger.log('set currentLevel:' + t),
                              (this.loadLevel = t),
                              this.abrController.clearTimer(),
                              this.streamController.immediateLevelSwitch();
                          },
                        },
                        {
                          key: 'nextLevel',
                          get: function() {
                            return this.streamController.nextLevel;
                          },
                          set: function(t) {
                            f.logger.log('set nextLevel:' + t),
                              (this.levelController.manualLevel = t),
                              this.streamController.nextLevelSwitch();
                          },
                        },
                        {
                          key: 'loadLevel',
                          get: function() {
                            return this.levelController.level;
                          },
                          set: function(t) {
                            f.logger.log('set loadLevel:' + t),
                              (this.levelController.manualLevel = t);
                          },
                        },
                        {
                          key: 'nextLoadLevel',
                          get: function() {
                            return this.levelController.nextLoadLevel;
                          },
                          set: function(t) {
                            this.levelController.nextLoadLevel = t;
                          },
                        },
                        {
                          key: 'firstLevel',
                          get: function() {
                            return Math.max(
                              this.levelController.firstLevel,
                              this.minAutoLevel,
                            );
                          },
                          set: function(t) {
                            f.logger.log('set firstLevel:' + t),
                              (this.levelController.firstLevel = t);
                          },
                        },
                        {
                          key: 'startLevel',
                          get: function() {
                            return this.levelController.startLevel;
                          },
                          set: function(t) {
                            f.logger.log('set startLevel:' + t),
                              -1 !== t && (t = Math.max(t, this.minAutoLevel)),
                              (this.levelController.startLevel = t);
                          },
                        },
                        {
                          key: 'capLevelToPlayerSize',
                          get: function() {
                            return this.config.capLevelToPlayerSize;
                          },
                          set: function(t) {
                            var e = !!t;
                            e !== this.config.capLevelToPlayerSize &&
                              (e
                                ? this.capLevelController.startCapping()
                                : (this.capLevelController.stopCapping(),
                                  (this.autoLevelCapping = -1),
                                  this.streamController.nextLevelSwitch()),
                              (this.config.capLevelToPlayerSize = e));
                          },
                        },
                        {
                          key: 'autoLevelCapping',
                          get: function() {
                            return this._autoLevelCapping;
                          },
                          set: function(t) {
                            this._autoLevelCapping !== t &&
                              (f.logger.log('set autoLevelCapping:' + t),
                              (this._autoLevelCapping = t));
                          },
                        },
                        {
                          key: 'bandwidthEstimate',
                          get: function() {
                            var t = this.abrController.bwEstimator;
                            return t ? t.getEstimate() : NaN;
                          },
                        },
                        {
                          key: 'autoLevelEnabled',
                          get: function() {
                            return -1 === this.levelController.manualLevel;
                          },
                        },
                        {
                          key: 'manualLevel',
                          get: function() {
                            return this.levelController.manualLevel;
                          },
                        },
                        {
                          key: 'minAutoLevel',
                          get: function() {
                            var t = this.levels,
                              e = this.config.minAutoBitrate;
                            if (!t) return 0;
                            for (var r = t.length, n = 0; n < r; n++)
                              if (t[n].maxBitrate >= e) return n;
                            return 0;
                          },
                        },
                        {
                          key: 'maxAutoLevel',
                          get: function() {
                            var t = this.levels,
                              e = this.autoLevelCapping;
                            return -1 === e && t && t.length ? t.length - 1 : e;
                          },
                        },
                        {
                          key: 'nextAutoLevel',
                          get: function() {
                            return Math.min(
                              Math.max(
                                this.abrController.nextAutoLevel,
                                this.minAutoLevel,
                              ),
                              this.maxAutoLevel,
                            );
                          },
                          set: function(t) {
                            this.abrController.nextAutoLevel = Math.max(
                              this.minAutoLevel,
                              t,
                            );
                          },
                        },
                        {
                          key: 'playingDate',
                          get: function() {
                            return this.streamController.currentProgramDateTime;
                          },
                        },
                        {
                          key: 'mainForwardBufferInfo',
                          get: function() {
                            return this.streamController.getMainFwdBufferInfo();
                          },
                        },
                        {
                          key: 'audioTracks',
                          get: function() {
                            var t = this.audioTrackController;
                            return t ? t.audioTracks : [];
                          },
                        },
                        {
                          key: 'audioTrack',
                          get: function() {
                            var t = this.audioTrackController;
                            return t ? t.audioTrack : -1;
                          },
                          set: function(t) {
                            var e = this.audioTrackController;
                            e && (e.audioTrack = t);
                          },
                        },
                        {
                          key: 'subtitleTracks',
                          get: function() {
                            var t = this.subtitleTrackController;
                            return t ? t.subtitleTracks : [];
                          },
                        },
                        {
                          key: 'subtitleTrack',
                          get: function() {
                            var t = this.subtitleTrackController;
                            return t ? t.subtitleTrack : -1;
                          },
                          set: function(t) {
                            var e = this.subtitleTrackController;
                            e && (e.subtitleTrack = t);
                          },
                        },
                        {
                          key: 'media',
                          get: function() {
                            return this._media;
                          },
                        },
                        {
                          key: 'subtitleDisplay',
                          get: function() {
                            var t = this.subtitleTrackController;
                            return !!t && t.subtitleDisplay;
                          },
                          set: function(t) {
                            var e = this.subtitleTrackController;
                            e && (e.subtitleDisplay = t);
                          },
                        },
                        {
                          key: 'lowLatencyMode',
                          get: function() {
                            return this.config.lowLatencyMode;
                          },
                          set: function(t) {
                            this.config.lowLatencyMode = t;
                          },
                        },
                        {
                          key: 'liveSyncPosition',
                          get: function() {
                            return this.latencyController.liveSyncPosition;
                          },
                        },
                        {
                          key: 'latency',
                          get: function() {
                            return this.latencyController.latency;
                          },
                        },
                        {
                          key: 'maxLatency',
                          get: function() {
                            return this.latencyController.maxLatency;
                          },
                        },
                        {
                          key: 'targetLatency',
                          get: function() {
                            return this.latencyController.targetLatency;
                          },
                        },
                        {
                          key: 'drift',
                          get: function() {
                            return this.latencyController.drift;
                          },
                        },
                        {
                          key: 'forceStartLoad',
                          get: function() {
                            return this.streamController.forceStartLoad;
                          },
                        },
                      ]) && n(e.prototype, r),
                      y && n(e, y),
                      Object.defineProperty(e, 'prototype', { writable: !1 }),
                      t
                    );
                  })();
                y.defaultConfig = void 0;
              },
              './src/is-supported.ts': function(t, e, r) {
                function n() {
                  return self.SourceBuffer || self.WebKitSourceBuffer;
                }
                function i() {
                  var t = Object(a.getMediaSource)();
                  if (!t) return !1;
                  var e = n(),
                    r =
                      t &&
                      'function' == typeof t.isTypeSupported &&
                      t.isTypeSupported(
                        'video/mp4; codecs="avc1.42E01E,mp4a.40.2"',
                      ),
                    i =
                      !e ||
                      (e.prototype &&
                        'function' == typeof e.prototype.appendBuffer &&
                        'function' == typeof e.prototype.remove);
                  return !!r && !!i;
                }
                function s() {
                  var t,
                    e = n();
                  return (
                    'function' ==
                    typeof (null == e ||
                    null === (t = e.prototype) ||
                    void 0 === t
                      ? void 0
                      : t.changeType)
                  );
                }
                r.r(e),
                  r.d(e, 'isSupported', function() {
                    return i;
                  }),
                  r.d(e, 'changeTypeSupported', function() {
                    return s;
                  });
                var a = r('./src/utils/mediasource-helper.ts');
              },
              './src/loader/date-range.ts': function(t, e, r) {
                function n() {
                  return (n = Object.assign
                    ? Object.assign.bind()
                    : function(t) {
                        for (var e = 1; e < arguments.length; e++) {
                          var r = arguments[e];
                          for (var n in r)
                            Object.prototype.hasOwnProperty.call(r, n) &&
                              (t[n] = r[n]);
                        }
                        return t;
                      }).apply(this, arguments);
                }
                function i(t, e) {
                  for (var r = 0; r < e.length; r++) {
                    var n = e[r];
                    (n.enumerable = n.enumerable || !1),
                      (n.configurable = !0),
                      'value' in n && (n.writable = !0),
                      Object.defineProperty(t, n.key, n);
                  }
                }
                r.r(e),
                  r.d(e, 'DateRangeAttribute', function() {
                    return s;
                  }),
                  r.d(e, 'DateRange', function() {
                    return l;
                  });
                var s,
                  a = r('./src/polyfills/number.ts'),
                  o = r('./src/utils/attr-list.ts'),
                  u = r('./src/utils/logger.ts');
                !(function(t) {
                  (t.ID = 'ID'),
                    (t.CLASS = 'CLASS'),
                    (t.START_DATE = 'START-DATE'),
                    (t.DURATION = 'DURATION'),
                    (t.END_DATE = 'END-DATE'),
                    (t.END_ON_NEXT = 'END-ON-NEXT'),
                    (t.PLANNED_DURATION = 'PLANNED-DURATION'),
                    (t.SCTE35_OUT = 'SCTE35-OUT'),
                    (t.SCTE35_IN = 'SCTE35-IN');
                })(s || (s = {}));
                var l = (function() {
                  function t(t, e) {
                    if (
                      ((this.attr = void 0),
                      (this._startDate = void 0),
                      (this._endDate = void 0),
                      (this._badValueForSameId = void 0),
                      e)
                    ) {
                      var r = e.attr;
                      for (var i in r)
                        if (
                          Object.prototype.hasOwnProperty.call(t, i) &&
                          t[i] !== r[i]
                        ) {
                          u.logger.warn(
                            'DATERANGE tag attribute: "' +
                              i +
                              '" does not match for tags with ID: "' +
                              t.ID +
                              '"',
                          ),
                            (this._badValueForSameId = i);
                          break;
                        }
                      t = n(new o.AttrList({}), r, t);
                    }
                    if (
                      ((this.attr = t),
                      (this._startDate = new Date(t[s.START_DATE])),
                      s.END_DATE in this.attr)
                    ) {
                      var l = new Date(this.attr[s.END_DATE]);
                      Object(a.isFiniteNumber)(l.getTime()) &&
                        (this._endDate = l);
                    }
                  }
                  var e, r;
                  return (
                    (e = t),
                    (r = [
                      {
                        key: 'id',
                        get: function() {
                          return this.attr.ID;
                        },
                      },
                      {
                        key: 'class',
                        get: function() {
                          return this.attr.CLASS;
                        },
                      },
                      {
                        key: 'startDate',
                        get: function() {
                          return this._startDate;
                        },
                      },
                      {
                        key: 'endDate',
                        get: function() {
                          if (this._endDate) return this._endDate;
                          var t = this.duration;
                          return null !== t
                            ? new Date(this._startDate.getTime() + 1e3 * t)
                            : null;
                        },
                      },
                      {
                        key: 'duration',
                        get: function() {
                          if (s.DURATION in this.attr) {
                            var t = this.attr.decimalFloatingPoint(s.DURATION);
                            if (Object(a.isFiniteNumber)(t)) return t;
                          } else if (this._endDate)
                            return (
                              (this._endDate.getTime() -
                                this._startDate.getTime()) /
                              1e3
                            );
                          return null;
                        },
                      },
                      {
                        key: 'plannedDuration',
                        get: function() {
                          return s.PLANNED_DURATION in this.attr
                            ? this.attr.decimalFloatingPoint(s.PLANNED_DURATION)
                            : null;
                        },
                      },
                      {
                        key: 'endOnNext',
                        get: function() {
                          return this.attr.bool(s.END_ON_NEXT);
                        },
                      },
                      {
                        key: 'isValid',
                        get: function() {
                          return (
                            !!this.id &&
                            !this._badValueForSameId &&
                            Object(a.isFiniteNumber)(
                              this.startDate.getTime(),
                            ) &&
                            (null === this.duration || this.duration >= 0) &&
                            (!this.endOnNext || !!this.class)
                          );
                        },
                      },
                    ]) && i(e.prototype, r),
                    Object.defineProperty(e, 'prototype', { writable: !1 }),
                    t
                  );
                })();
              },
              './src/loader/fragment-loader.ts': function(t, e, r) {
                function n(t) {
                  var e = 'function' == typeof Map ? new Map() : void 0;
                  return (n = function(t) {
                    function r() {
                      return i(t, arguments, o(this).constructor);
                    }
                    if (
                      null === t ||
                      ((n = t),
                      -1 === Function.toString.call(n).indexOf('[native code]'))
                    )
                      return t;
                    var n;
                    if ('function' != typeof t)
                      throw new TypeError(
                        'Super expression must either be null or a function',
                      );
                    if (void 0 !== e) {
                      if (e.has(t)) return e.get(t);
                      e.set(t, r);
                    }
                    return (
                      (r.prototype = Object.create(t.prototype, {
                        constructor: {
                          value: r,
                          enumerable: !1,
                          writable: !0,
                          configurable: !0,
                        },
                      })),
                      a(r, t)
                    );
                  })(t);
                }
                function i(t, e, r) {
                  return (i = s()
                    ? Reflect.construct.bind()
                    : function(t, e, r) {
                        var n = [null];
                        n.push.apply(n, e);
                        var i = new (Function.bind.apply(t, n))();
                        return r && a(i, r.prototype), i;
                      }).apply(null, arguments);
                }
                function s() {
                  if ('undefined' == typeof Reflect || !Reflect.construct)
                    return !1;
                  if (Reflect.construct.sham) return !1;
                  if ('function' == typeof Proxy) return !0;
                  try {
                    return (
                      Boolean.prototype.valueOf.call(
                        Reflect.construct(Boolean, [], function() {}),
                      ),
                      !0
                    );
                  } catch (t) {
                    return !1;
                  }
                }
                function a(t, e) {
                  return (a = Object.setPrototypeOf
                    ? Object.setPrototypeOf.bind()
                    : function(t, e) {
                        return (t.__proto__ = e), t;
                      })(t, e);
                }
                function o(t) {
                  return (o = Object.setPrototypeOf
                    ? Object.getPrototypeOf.bind()
                    : function(t) {
                        return t.__proto__ || Object.getPrototypeOf(t);
                      })(t);
                }
                function u(t, e) {
                  void 0 === e && (e = null);
                  var r = e || t,
                    n = {
                      frag: t,
                      part: e,
                      responseType: 'arraybuffer',
                      url: r.url,
                      headers: {},
                      rangeStart: 0,
                      rangeEnd: 0,
                    },
                    i = r.byteRangeStartOffset,
                    s = r.byteRangeEndOffset;
                  return (
                    Object(l.isFiniteNumber)(i) &&
                      Object(l.isFiniteNumber)(s) &&
                      ((n.rangeStart = i), (n.rangeEnd = s)),
                    n
                  );
                }
                r.r(e),
                  r.d(e, 'default', function() {
                    return d;
                  }),
                  r.d(e, 'LoadError', function() {
                    return f;
                  });
                var l = r('./src/polyfills/number.ts'),
                  c = r('./src/errors.ts'),
                  h = Math.pow(2, 17),
                  d = (function() {
                    function t(t) {
                      (this.config = void 0),
                        (this.loader = null),
                        (this.partLoadTimeout = -1),
                        (this.config = t);
                    }
                    var e = t.prototype;
                    return (
                      (e.destroy = function() {
                        this.loader &&
                          (this.loader.destroy(), (this.loader = null));
                      }),
                      (e.abort = function() {
                        this.loader && this.loader.abort();
                      }),
                      (e.load = function(t, e) {
                        var r = this,
                          n = t.url;
                        if (!n)
                          return Promise.reject(
                            new f(
                              {
                                type: c.ErrorTypes.NETWORK_ERROR,
                                details: c.ErrorDetails.FRAG_LOAD_ERROR,
                                fatal: !1,
                                frag: t,
                                networkDetails: null,
                              },
                              'Fragment does not have a ' +
                                (n ? 'part list' : 'url'),
                            ),
                          );
                        this.abort();
                        var i = this.config,
                          s = i.fLoader,
                          a = i.loader;
                        return new Promise(function(n, o) {
                          r.loader && r.loader.destroy();
                          var l = (r.loader = t.loader = s
                              ? new s(i)
                              : new a(i)),
                            d = u(t),
                            p = {
                              timeout: i.fragLoadingTimeOut,
                              maxRetry: 0,
                              retryDelay: 0,
                              maxRetryDelay: i.fragLoadingMaxRetryTimeout,
                              highWaterMark: 'initSegment' === t.sn ? 1 / 0 : h,
                            };
                          (t.stats = l.stats),
                            l.load(d, p, {
                              onSuccess: function(e, i, s, a) {
                                r.resetLoader(t, l),
                                  n({
                                    frag: t,
                                    part: null,
                                    payload: e.data,
                                    networkDetails: a,
                                  });
                              },
                              onError: function(e, n, i) {
                                r.resetLoader(t, l),
                                  o(
                                    new f({
                                      type: c.ErrorTypes.NETWORK_ERROR,
                                      details: c.ErrorDetails.FRAG_LOAD_ERROR,
                                      fatal: !1,
                                      frag: t,
                                      response: e,
                                      networkDetails: i,
                                    }),
                                  );
                              },
                              onAbort: function(e, n, i) {
                                r.resetLoader(t, l),
                                  o(
                                    new f({
                                      type: c.ErrorTypes.NETWORK_ERROR,
                                      details: c.ErrorDetails.INTERNAL_ABORTED,
                                      fatal: !1,
                                      frag: t,
                                      networkDetails: i,
                                    }),
                                  );
                              },
                              onTimeout: function(e, n, i) {
                                r.resetLoader(t, l),
                                  o(
                                    new f({
                                      type: c.ErrorTypes.NETWORK_ERROR,
                                      details: c.ErrorDetails.FRAG_LOAD_TIMEOUT,
                                      fatal: !1,
                                      frag: t,
                                      networkDetails: i,
                                    }),
                                  );
                              },
                              onProgress: function(r, n, i, s) {
                                e &&
                                  e({
                                    frag: t,
                                    part: null,
                                    payload: i,
                                    networkDetails: s,
                                  });
                              },
                            });
                        });
                      }),
                      (e.loadPart = function(t, e, r) {
                        var n = this;
                        this.abort();
                        var i = this.config,
                          s = i.fLoader,
                          a = i.loader;
                        return new Promise(function(o, l) {
                          n.loader && n.loader.destroy();
                          var d = (n.loader = t.loader = s
                              ? new s(i)
                              : new a(i)),
                            p = u(t, e),
                            v = {
                              timeout: i.fragLoadingTimeOut,
                              maxRetry: 0,
                              retryDelay: 0,
                              maxRetryDelay: i.fragLoadingMaxRetryTimeout,
                              highWaterMark: h,
                            };
                          (e.stats = d.stats),
                            d.load(p, v, {
                              onSuccess: function(i, s, a, u) {
                                n.resetLoader(t, d),
                                  n.updateStatsFromPart(t, e);
                                var l = {
                                  frag: t,
                                  part: e,
                                  payload: i.data,
                                  networkDetails: u,
                                };
                                r(l), o(l);
                              },
                              onError: function(r, i, s) {
                                n.resetLoader(t, d),
                                  l(
                                    new f({
                                      type: c.ErrorTypes.NETWORK_ERROR,
                                      details: c.ErrorDetails.FRAG_LOAD_ERROR,
                                      fatal: !1,
                                      frag: t,
                                      part: e,
                                      response: r,
                                      networkDetails: s,
                                    }),
                                  );
                              },
                              onAbort: function(r, i, s) {
                                (t.stats.aborted = e.stats.aborted),
                                  n.resetLoader(t, d),
                                  l(
                                    new f({
                                      type: c.ErrorTypes.NETWORK_ERROR,
                                      details: c.ErrorDetails.INTERNAL_ABORTED,
                                      fatal: !1,
                                      frag: t,
                                      part: e,
                                      networkDetails: s,
                                    }),
                                  );
                              },
                              onTimeout: function(r, i, s) {
                                n.resetLoader(t, d),
                                  l(
                                    new f({
                                      type: c.ErrorTypes.NETWORK_ERROR,
                                      details: c.ErrorDetails.FRAG_LOAD_TIMEOUT,
                                      fatal: !1,
                                      frag: t,
                                      part: e,
                                      networkDetails: s,
                                    }),
                                  );
                              },
                            });
                        });
                      }),
                      (e.updateStatsFromPart = function(t, e) {
                        var r = t.stats,
                          n = e.stats,
                          i = n.total;
                        if (((r.loaded += n.loaded), i)) {
                          var s = Math.round(t.duration / e.duration),
                            a = Math.min(Math.round(r.loaded / i), s),
                            o = (s - a) * Math.round(r.loaded / a);
                          r.total = r.loaded + o;
                        } else r.total = Math.max(r.loaded, r.total);
                        var u = r.loading,
                          l = n.loading;
                        u.start
                          ? (u.first += l.first - l.start)
                          : ((u.start = l.start), (u.first = l.first)),
                          (u.end = l.end);
                      }),
                      (e.resetLoader = function(t, e) {
                        (t.loader = null),
                          this.loader === e &&
                            (self.clearTimeout(this.partLoadTimeout),
                            (this.loader = null)),
                          e.destroy();
                      }),
                      t
                    );
                  })(),
                  f = (function(t) {
                    function e(e) {
                      for (
                        var r,
                          n = arguments.length,
                          i = new Array(n > 1 ? n - 1 : 0),
                          s = 1;
                        s < n;
                        s++
                      )
                        i[s - 1] = arguments[s];
                      return (
                        ((r =
                          t.call.apply(t, [this].concat(i)) ||
                          this).data = void 0),
                        (r.data = e),
                        r
                      );
                    }
                    var r, n;
                    return (
                      (n = t),
                      ((r = e).prototype = Object.create(n.prototype)),
                      (r.prototype.constructor = r),
                      a(r, n),
                      e
                    );
                  })(n(Error));
              },
              './src/loader/fragment.ts': function(t, e, r) {
                function n(t, e) {
                  var r, n;
                  (t.prototype = Object.create(e.prototype)),
                    (t.prototype.constructor = t),
                    (r = t),
                    (n = e),
                    (Object.setPrototypeOf
                      ? Object.setPrototypeOf.bind()
                      : function(t, e) {
                          return (t.__proto__ = e), t;
                        })(r, n);
                }
                function i(t, e) {
                  for (var r = 0; r < e.length; r++) {
                    var n = e[r];
                    (n.enumerable = n.enumerable || !1),
                      (n.configurable = !0),
                      'value' in n && (n.writable = !0),
                      Object.defineProperty(t, n.key, n);
                  }
                }
                function s(t, e, r) {
                  return (
                    e && i(t.prototype, e),
                    r && i(t, r),
                    Object.defineProperty(t, 'prototype', { writable: !1 }),
                    t
                  );
                }
                r.r(e),
                  r.d(e, 'ElementaryStreamTypes', function() {
                    return a;
                  }),
                  r.d(e, 'BaseSegment', function() {
                    return d;
                  }),
                  r.d(e, 'Fragment', function() {
                    return f;
                  }),
                  r.d(e, 'Part', function() {
                    return p;
                  });
                var a,
                  o = r('./src/polyfills/number.ts'),
                  u = r('./node_modules/url-toolkit/src/url-toolkit.js'),
                  l = r('./src/utils/logger.ts'),
                  c = r('./src/loader/level-key.ts'),
                  h = r('./src/loader/load-stats.ts');
                !(function(t) {
                  (t.AUDIO = 'audio'),
                    (t.VIDEO = 'video'),
                    (t.AUDIOVIDEO = 'audiovideo');
                })(a || (a = {}));
                var d = (function() {
                    function t(t) {
                      var e;
                      (this._byteRange = null),
                        (this._url = null),
                        (this.baseurl = void 0),
                        (this.relurl = void 0),
                        (this.elementaryStreams =
                          (((e = {})[a.AUDIO] = null),
                          (e[a.VIDEO] = null),
                          (e[a.AUDIOVIDEO] = null),
                          e)),
                        (this.baseurl = t);
                    }
                    return (
                      (t.prototype.setByteRange = function(t, e) {
                        var r = t.split('@', 2),
                          n = [];
                        1 === r.length
                          ? (n[0] = e ? e.byteRangeEndOffset : 0)
                          : (n[0] = parseInt(r[1])),
                          (n[1] = parseInt(r[0]) + n[0]),
                          (this._byteRange = n);
                      }),
                      s(t, [
                        {
                          key: 'byteRange',
                          get: function() {
                            return this._byteRange ? this._byteRange : [];
                          },
                        },
                        {
                          key: 'byteRangeStartOffset',
                          get: function() {
                            return this.byteRange[0];
                          },
                        },
                        {
                          key: 'byteRangeEndOffset',
                          get: function() {
                            return this.byteRange[1];
                          },
                        },
                        {
                          key: 'url',
                          get: function() {
                            return (
                              !this._url &&
                                this.baseurl &&
                                this.relurl &&
                                (this._url = Object(u.buildAbsoluteURL)(
                                  this.baseurl,
                                  this.relurl,
                                  { alwaysNormalize: !0 },
                                )),
                              this._url || ''
                            );
                          },
                          set: function(t) {
                            this._url = t;
                          },
                        },
                      ]),
                      t
                    );
                  })(),
                  f = (function(t) {
                    function e(e, r) {
                      var n;
                      return (
                        ((n = t.call(this, r) || this)._decryptdata = null),
                        (n.rawProgramDateTime = null),
                        (n.programDateTime = null),
                        (n.tagList = []),
                        (n.duration = 0),
                        (n.sn = 0),
                        (n.levelkey = void 0),
                        (n.type = void 0),
                        (n.loader = null),
                        (n.level = -1),
                        (n.cc = 0),
                        (n.startPTS = void 0),
                        (n.endPTS = void 0),
                        (n.appendedPTS = void 0),
                        (n.startDTS = void 0),
                        (n.endDTS = void 0),
                        (n.start = 0),
                        (n.deltaPTS = void 0),
                        (n.maxStartPTS = void 0),
                        (n.minEndPTS = void 0),
                        (n.stats = new h.LoadStats()),
                        (n.urlId = 0),
                        (n.data = void 0),
                        (n.bitrateTest = !1),
                        (n.title = null),
                        (n.initSegment = null),
                        (n.type = e),
                        n
                      );
                    }
                    n(e, t);
                    var r = e.prototype;
                    return (
                      (r.createInitializationVector = function(t) {
                        for (var e = new Uint8Array(16), r = 12; r < 16; r++)
                          e[r] = (t >> (8 * (15 - r))) & 255;
                        return e;
                      }),
                      (r.setDecryptDataFromLevelKey = function(t, e) {
                        var r = t;
                        return (
                          'AES-128' === (null == t ? void 0 : t.method) &&
                            t.uri &&
                            !t.iv &&
                            (((r = c.LevelKey.fromURI(t.uri)).method =
                              t.method),
                            (r.iv = this.createInitializationVector(e)),
                            (r.keyFormat = 'identity')),
                          r
                        );
                      }),
                      (r.setElementaryStreamInfo = function(t, e, r, n, i, s) {
                        void 0 === s && (s = !1);
                        var a = this.elementaryStreams,
                          o = a[t];
                        o
                          ? ((o.startPTS = Math.min(o.startPTS, e)),
                            (o.endPTS = Math.max(o.endPTS, r)),
                            (o.startDTS = Math.min(o.startDTS, n)),
                            (o.endDTS = Math.max(o.endDTS, i)))
                          : (a[t] = {
                              startPTS: e,
                              endPTS: r,
                              startDTS: n,
                              endDTS: i,
                              partial: s,
                            });
                      }),
                      (r.clearElementaryStreamInfo = function() {
                        var t = this.elementaryStreams;
                        (t[a.AUDIO] = null),
                          (t[a.VIDEO] = null),
                          (t[a.AUDIOVIDEO] = null);
                      }),
                      s(e, [
                        {
                          key: 'decryptdata',
                          get: function() {
                            if (!this.levelkey && !this._decryptdata)
                              return null;
                            if (!this._decryptdata && this.levelkey) {
                              var t = this.sn;
                              'number' != typeof t &&
                                (this.levelkey &&
                                  'AES-128' === this.levelkey.method &&
                                  !this.levelkey.iv &&
                                  l.logger.warn(
                                    'missing IV for initialization segment with method="' +
                                      this.levelkey.method +
                                      '" - compliance issue',
                                  ),
                                (t = 0)),
                                (this._decryptdata = this.setDecryptDataFromLevelKey(
                                  this.levelkey,
                                  t,
                                ));
                            }
                            return this._decryptdata;
                          },
                        },
                        {
                          key: 'end',
                          get: function() {
                            return this.start + this.duration;
                          },
                        },
                        {
                          key: 'endProgramDateTime',
                          get: function() {
                            if (null === this.programDateTime) return null;
                            if (!Object(o.isFiniteNumber)(this.programDateTime))
                              return null;
                            var t = Object(o.isFiniteNumber)(this.duration)
                              ? this.duration
                              : 0;
                            return this.programDateTime + 1e3 * t;
                          },
                        },
                        {
                          key: 'encrypted',
                          get: function() {
                            var t;
                            return !(
                              null === (t = this.decryptdata) ||
                              void 0 === t ||
                              !t.keyFormat ||
                              !this.decryptdata.uri
                            );
                          },
                        },
                      ]),
                      e
                    );
                  })(d),
                  p = (function(t) {
                    function e(e, r, n, i, s) {
                      var a;
                      ((a = t.call(this, n) || this).fragOffset = 0),
                        (a.duration = 0),
                        (a.gap = !1),
                        (a.independent = !1),
                        (a.relurl = void 0),
                        (a.fragment = void 0),
                        (a.index = void 0),
                        (a.stats = new h.LoadStats()),
                        (a.duration = e.decimalFloatingPoint('DURATION')),
                        (a.gap = e.bool('GAP')),
                        (a.independent = e.bool('INDEPENDENT')),
                        (a.relurl = e.enumeratedString('URI')),
                        (a.fragment = r),
                        (a.index = i);
                      var o = e.enumeratedString('BYTERANGE');
                      return (
                        o && a.setByteRange(o, s),
                        s && (a.fragOffset = s.fragOffset + s.duration),
                        a
                      );
                    }
                    return (
                      n(e, t),
                      s(e, [
                        {
                          key: 'start',
                          get: function() {
                            return this.fragment.start + this.fragOffset;
                          },
                        },
                        {
                          key: 'end',
                          get: function() {
                            return this.start + this.duration;
                          },
                        },
                        {
                          key: 'loaded',
                          get: function() {
                            var t = this.elementaryStreams;
                            return !!(t.audio || t.video || t.audiovideo);
                          },
                        },
                      ]),
                      e
                    );
                  })(d);
              },
              './src/loader/key-loader.ts': function(t, e, r) {
                r.r(e),
                  r.d(e, 'default', function() {
                    return a;
                  });
                var n = r('./src/events.ts'),
                  i = r('./src/errors.ts'),
                  s = r('./src/utils/logger.ts'),
                  a = (function() {
                    function t(t) {
                      (this.hls = void 0),
                        (this.loaders = {}),
                        (this.decryptkey = null),
                        (this.decrypturl = null),
                        (this.hls = t),
                        this.registerListeners();
                    }
                    var e = t.prototype;
                    return (
                      (e.startLoad = function(t) {}),
                      (e.stopLoad = function() {
                        this.destroyInternalLoaders();
                      }),
                      (e.registerListeners = function() {
                        this.hls.on(
                          n.Events.KEY_LOADING,
                          this.onKeyLoading,
                          this,
                        );
                      }),
                      (e.unregisterListeners = function() {
                        this.hls.off(n.Events.KEY_LOADING, this.onKeyLoading);
                      }),
                      (e.destroyInternalLoaders = function() {
                        for (var t in this.loaders) {
                          var e = this.loaders[t];
                          e && e.destroy();
                        }
                        this.loaders = {};
                      }),
                      (e.destroy = function() {
                        this.unregisterListeners(),
                          this.destroyInternalLoaders();
                      }),
                      (e.onKeyLoading = function(t, e) {
                        var r = e.frag,
                          i = r.type,
                          a = this.loaders[i];
                        if (r.decryptdata) {
                          var o = r.decryptdata.uri;
                          if (
                            o !== this.decrypturl ||
                            null === this.decryptkey
                          ) {
                            var u = this.hls.config;
                            if (
                              (a &&
                                (s.logger.warn(
                                  'abort previous key loader for type:' + i,
                                ),
                                a.abort()),
                              !o)
                            )
                              return void s.logger.warn('key uri is falsy');
                            var l = u.loader,
                              c = (r.loader = this.loaders[i] = new l(u));
                            (this.decrypturl = o), (this.decryptkey = null);
                            var h = {
                                url: o,
                                frag: r,
                                responseType: 'arraybuffer',
                              },
                              d = {
                                timeout: u.fragLoadingTimeOut,
                                maxRetry: 0,
                                retryDelay: u.fragLoadingRetryDelay,
                                maxRetryDelay: u.fragLoadingMaxRetryTimeout,
                                highWaterMark: 0,
                              },
                              f = {
                                onSuccess: this.loadsuccess.bind(this),
                                onError: this.loaderror.bind(this),
                                onTimeout: this.loadtimeout.bind(this),
                              };
                            c.load(h, d, f);
                          } else
                            this.decryptkey &&
                              ((r.decryptdata.key = this.decryptkey),
                              this.hls.trigger(n.Events.KEY_LOADED, {
                                frag: r,
                              }));
                        } else
                          s.logger.warn(
                            'Missing decryption data on fragment in onKeyLoading',
                          );
                      }),
                      (e.loadsuccess = function(t, e, r) {
                        var i = r.frag;
                        i.decryptdata
                          ? ((this.decryptkey = i.decryptdata.key = new Uint8Array(
                              t.data,
                            )),
                            (i.loader = null),
                            delete this.loaders[i.type],
                            this.hls.trigger(n.Events.KEY_LOADED, { frag: i }))
                          : s.logger.error('after key load, decryptdata unset');
                      }),
                      (e.loaderror = function(t, e) {
                        var r = e.frag,
                          s = r.loader;
                        s && s.abort(),
                          delete this.loaders[r.type],
                          this.hls.trigger(n.Events.ERROR, {
                            type: i.ErrorTypes.NETWORK_ERROR,
                            details: i.ErrorDetails.KEY_LOAD_ERROR,
                            fatal: !1,
                            frag: r,
                            response: t,
                          });
                      }),
                      (e.loadtimeout = function(t, e) {
                        var r = e.frag,
                          s = r.loader;
                        s && s.abort(),
                          delete this.loaders[r.type],
                          this.hls.trigger(n.Events.ERROR, {
                            type: i.ErrorTypes.NETWORK_ERROR,
                            details: i.ErrorDetails.KEY_LOAD_TIMEOUT,
                            fatal: !1,
                            frag: r,
                          });
                      }),
                      t
                    );
                  })();
              },
              './src/loader/level-details.ts': function(t, e, r) {
                function n(t, e) {
                  for (var r = 0; r < e.length; r++) {
                    var n = e[r];
                    (n.enumerable = n.enumerable || !1),
                      (n.configurable = !0),
                      'value' in n && (n.writable = !0),
                      Object.defineProperty(t, n.key, n);
                  }
                }
                r.r(e),
                  r.d(e, 'LevelDetails', function() {
                    return s;
                  });
                var i = r('./src/polyfills/number.ts'),
                  s = (function() {
                    function t(t) {
                      (this.PTSKnown = !1),
                        (this.alignedSliding = !1),
                        (this.averagetargetduration = void 0),
                        (this.endCC = 0),
                        (this.endSN = 0),
                        (this.fragments = void 0),
                        (this.fragmentHint = void 0),
                        (this.partList = null),
                        (this.dateRanges = void 0),
                        (this.live = !0),
                        (this.ageHeader = 0),
                        (this.advancedDateTime = void 0),
                        (this.updated = !0),
                        (this.advanced = !0),
                        (this.availabilityDelay = void 0),
                        (this.misses = 0),
                        (this.needSidxRanges = !1),
                        (this.startCC = 0),
                        (this.startSN = 0),
                        (this.startTimeOffset = null),
                        (this.targetduration = 0),
                        (this.totalduration = 0),
                        (this.type = null),
                        (this.url = void 0),
                        (this.m3u8 = ''),
                        (this.version = null),
                        (this.canBlockReload = !1),
                        (this.canSkipUntil = 0),
                        (this.canSkipDateRanges = !1),
                        (this.skippedSegments = 0),
                        (this.recentlyRemovedDateranges = void 0),
                        (this.partHoldBack = 0),
                        (this.holdBack = 0),
                        (this.partTarget = 0),
                        (this.preloadHint = void 0),
                        (this.renditionReports = void 0),
                        (this.tuneInGoal = 0),
                        (this.deltaUpdateFailed = void 0),
                        (this.driftStartTime = 0),
                        (this.driftEndTime = 0),
                        (this.driftStart = 0),
                        (this.driftEnd = 0),
                        (this.fragments = []),
                        (this.dateRanges = {}),
                        (this.url = t);
                    }
                    var e, r;
                    return (
                      (t.prototype.reloaded = function(t) {
                        if (!t)
                          return (this.advanced = !0), void (this.updated = !0);
                        var e = this.lastPartSn - t.lastPartSn,
                          r = this.lastPartIndex - t.lastPartIndex;
                        (this.updated = this.endSN !== t.endSN || !!r || !!e),
                          (this.advanced =
                            this.endSN > t.endSN ||
                            e > 0 ||
                            (0 === e && r > 0)),
                          this.updated || this.advanced
                            ? (this.misses = Math.floor(0.6 * t.misses))
                            : (this.misses = t.misses + 1),
                          (this.availabilityDelay = t.availabilityDelay);
                      }),
                      (e = t),
                      (r = [
                        {
                          key: 'hasProgramDateTime',
                          get: function() {
                            return (
                              !!this.fragments.length &&
                              Object(i.isFiniteNumber)(
                                this.fragments[this.fragments.length - 1]
                                  .programDateTime,
                              )
                            );
                          },
                        },
                        {
                          key: 'levelTargetDuration',
                          get: function() {
                            return (
                              this.averagetargetduration ||
                              this.targetduration ||
                              10
                            );
                          },
                        },
                        {
                          key: 'drift',
                          get: function() {
                            var t = this.driftEndTime - this.driftStartTime;
                            return t > 0
                              ? (1e3 * (this.driftEnd - this.driftStart)) / t
                              : 1;
                          },
                        },
                        {
                          key: 'edge',
                          get: function() {
                            return this.partEnd || this.fragmentEnd;
                          },
                        },
                        {
                          key: 'partEnd',
                          get: function() {
                            var t;
                            return null !== (t = this.partList) &&
                              void 0 !== t &&
                              t.length
                              ? this.partList[this.partList.length - 1].end
                              : this.fragmentEnd;
                          },
                        },
                        {
                          key: 'fragmentEnd',
                          get: function() {
                            var t;
                            return null !== (t = this.fragments) &&
                              void 0 !== t &&
                              t.length
                              ? this.fragments[this.fragments.length - 1].end
                              : 0;
                          },
                        },
                        {
                          key: 'age',
                          get: function() {
                            return this.advancedDateTime
                              ? Math.max(
                                  Date.now() - this.advancedDateTime,
                                  0,
                                ) / 1e3
                              : 0;
                          },
                        },
                        {
                          key: 'lastPartIndex',
                          get: function() {
                            var t;
                            return null !== (t = this.partList) &&
                              void 0 !== t &&
                              t.length
                              ? this.partList[this.partList.length - 1].index
                              : -1;
                          },
                        },
                        {
                          key: 'lastPartSn',
                          get: function() {
                            var t;
                            return null !== (t = this.partList) &&
                              void 0 !== t &&
                              t.length
                              ? this.partList[this.partList.length - 1].fragment
                                  .sn
                              : this.endSN;
                          },
                        },
                      ]) && n(e.prototype, r),
                      Object.defineProperty(e, 'prototype', { writable: !1 }),
                      t
                    );
                  })();
              },
              './src/loader/level-key.ts': function(t, e, r) {
                function n(t, e) {
                  for (var r = 0; r < e.length; r++) {
                    var n = e[r];
                    (n.enumerable = n.enumerable || !1),
                      (n.configurable = !0),
                      'value' in n && (n.writable = !0),
                      Object.defineProperty(t, n.key, n);
                  }
                }
                r.r(e),
                  r.d(e, 'LevelKey', function() {
                    return s;
                  });
                var i = r('./node_modules/url-toolkit/src/url-toolkit.js'),
                  s = (function() {
                    function t(t, e) {
                      (this._uri = null),
                        (this.method = null),
                        (this.keyFormat = null),
                        (this.keyFormatVersions = null),
                        (this.keyID = null),
                        (this.key = null),
                        (this.iv = null),
                        (this._uri = e
                          ? Object(i.buildAbsoluteURL)(t, e, {
                              alwaysNormalize: !0,
                            })
                          : t);
                    }
                    var e, r;
                    return (
                      (t.fromURL = function(e, r) {
                        return new t(e, r);
                      }),
                      (t.fromURI = function(e) {
                        return new t(e);
                      }),
                      (e = t),
                      (r = [
                        {
                          key: 'uri',
                          get: function() {
                            return this._uri;
                          },
                        },
                      ]) && n(e.prototype, r),
                      Object.defineProperty(e, 'prototype', { writable: !1 }),
                      t
                    );
                  })();
              },
              './src/loader/load-stats.ts': function(t, e, r) {
                r.r(e),
                  r.d(e, 'LoadStats', function() {
                    return n;
                  });
                var n = function() {
                  (this.aborted = !1),
                    (this.loaded = 0),
                    (this.retry = 0),
                    (this.total = 0),
                    (this.chunkCount = 0),
                    (this.bwEstimate = 0),
                    (this.loading = { start: 0, first: 0, end: 0 }),
                    (this.parsing = { start: 0, end: 0 }),
                    (this.buffering = { start: 0, first: 0, end: 0 });
                };
              },
              './src/loader/m3u8-parser.ts': function(t, e, r) {
                function n(t, e) {
                  ['video', 'audio', 'text'].forEach(function(r) {
                    var n = t.filter(function(t) {
                      return Object(v.isCodecType)(t, r);
                    });
                    if (n.length) {
                      var i = n.filter(function(t) {
                        return (
                          0 === t.lastIndexOf('avc1', 0) ||
                          0 === t.lastIndexOf('mp4a', 0)
                        );
                      });
                      (e[r + 'Codec'] = i.length > 0 ? i[0] : n[0]),
                        (t = t.filter(function(t) {
                          return -1 === n.indexOf(t);
                        }));
                    }
                  }),
                    (e.unknownCodecs = t);
                }
                function i(t, e, r) {
                  var n = e[r];
                  n && (t[r] = n);
                }
                function s(t, e) {
                  t.rawProgramDateTime
                    ? (t.programDateTime = Date.parse(t.rawProgramDateTime))
                    : null != e &&
                      e.programDateTime &&
                      (t.programDateTime = e.endProgramDateTime),
                    Object(o.isFiniteNumber)(t.programDateTime) ||
                      ((t.programDateTime = null),
                      (t.rawProgramDateTime = null));
                }
                function a(t, e, r, n) {
                  (t.relurl = e.URI),
                    e.BYTERANGE && t.setByteRange(e.BYTERANGE),
                    (t.level = r),
                    (t.sn = 'initSegment'),
                    n && (t.levelkey = n),
                    (t.initSegment = null);
                }
                r.r(e),
                  r.d(e, 'default', function() {
                    return T;
                  });
                var o = r('./src/polyfills/number.ts'),
                  u = r('./node_modules/url-toolkit/src/url-toolkit.js'),
                  l = r('./src/loader/date-range.ts'),
                  c = r('./src/loader/fragment.ts'),
                  h = r('./src/loader/level-details.ts'),
                  d = r('./src/loader/level-key.ts'),
                  f = r('./src/utils/attr-list.ts'),
                  p = r('./src/utils/logger.ts'),
                  v = r('./src/utils/codecs.ts'),
                  g = /#EXT-X-STREAM-INF:([^\r\n]*)(?:[\r\n](?:#[^\r\n]*)?)*([^\r\n]+)|#EXT-X-SESSION-DATA:([^\r\n]*)[\r\n]+/g,
                  m = /#EXT-X-MEDIA:(.*)/g,
                  y = new RegExp(
                    [
                      /#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
                      /(?!#) *(\S[\S ]*)/.source,
                      /#EXT-X-BYTERANGE:*(.+)/.source,
                      /#EXT-X-PROGRAM-DATE-TIME:(.+)/.source,
                      /#.*/.source,
                    ].join('|'),
                    'g',
                  ),
                  b = new RegExp(
                    [
                      /#(EXTM3U)/.source,
                      /#EXT-X-(DATERANGE|KEY|MAP|PART|PART-INF|PLAYLIST-TYPE|PRELOAD-HINT|RENDITION-REPORT|SERVER-CONTROL|SKIP|START):(.+)/
                        .source,
                      /#EXT-X-(BITRATE|DISCONTINUITY-SEQUENCE|MEDIA-SEQUENCE|TARGETDURATION|VERSION): *(\d+)/
                        .source,
                      /#EXT-X-(DISCONTINUITY|ENDLIST|GAP)/.source,
                      /(#)([^:]*):(.*)/.source,
                      /(#)(.*)(?:.*)\r?\n?/.source,
                    ].join('|'),
                  ),
                  E = /\.(mp4|m4s|m4v|m4a)$/i,
                  T = (function() {
                    function t() {}
                    return (
                      (t.findGroup = function(t, e) {
                        for (var r = 0; r < t.length; r++) {
                          var n = t[r];
                          if (n.id === e) return n;
                        }
                      }),
                      (t.convertAVC1ToAVCOTI = function(t) {
                        var e = t.split('.');
                        if (e.length > 2) {
                          var r = e.shift() + '.';
                          return (
                            (r += parseInt(e.shift()).toString(16)) +
                            ('000' + parseInt(e.shift()).toString(16)).slice(-4)
                          );
                        }
                        return t;
                      }),
                      (t.resolve = function(t, e) {
                        return u.buildAbsoluteURL(e, t, {
                          alwaysNormalize: !0,
                        });
                      }),
                      (t.parseMasterPlaylist = function(e, r) {
                        var i,
                          s = [],
                          a = [],
                          o = {},
                          u = !1;
                        for (g.lastIndex = 0; null != (i = g.exec(e)); )
                          if (i[1]) {
                            var l,
                              c = new f.AttrList(i[1]),
                              h = {
                                attrs: c,
                                bitrate:
                                  c.decimalInteger('AVERAGE-BANDWIDTH') ||
                                  c.decimalInteger('BANDWIDTH'),
                                name: c.NAME,
                                url: t.resolve(i[2], r),
                              },
                              d = c.decimalResolution('RESOLUTION');
                            d && ((h.width = d.width), (h.height = d.height)),
                              n(
                                (c.CODECS || '')
                                  .split(/[ ,]+/)
                                  .filter(function(t) {
                                    return t;
                                  }),
                                h,
                              ),
                              h.videoCodec &&
                                -1 !== h.videoCodec.indexOf('avc1') &&
                                (h.videoCodec = t.convertAVC1ToAVCOTI(
                                  h.videoCodec,
                                )),
                              (null !== (l = h.unknownCodecs) &&
                                void 0 !== l &&
                                l.length) ||
                                a.push(h),
                              s.push(h);
                          } else if (i[3]) {
                            var p = new f.AttrList(i[3]);
                            p['DATA-ID'] && ((u = !0), (o[p['DATA-ID']] = p));
                          }
                        return {
                          levels: a.length > 0 && a.length < s.length ? a : s,
                          sessionData: u ? o : null,
                        };
                      }),
                      (t.parseMasterPlaylistMedia = function(e, r, n, s) {
                        var a;
                        void 0 === s && (s = []);
                        var o = [],
                          u = 0;
                        for (m.lastIndex = 0; null !== (a = m.exec(e)); ) {
                          var l = new f.AttrList(a[1]);
                          if (l.TYPE === n) {
                            var c = {
                              attrs: l,
                              bitrate: 0,
                              id: u++,
                              groupId: l['GROUP-ID'],
                              instreamId: l['INSTREAM-ID'],
                              name: l.NAME || l.LANGUAGE || '',
                              type: n,
                              default: l.bool('DEFAULT'),
                              autoselect: l.bool('AUTOSELECT'),
                              forced: l.bool('FORCED'),
                              lang: l.LANGUAGE,
                              url: l.URI ? t.resolve(l.URI, r) : '',
                            };
                            if (s.length) {
                              var h = t.findGroup(s, c.groupId) || s[0];
                              i(c, h, 'audioCodec'), i(c, h, 'textCodec');
                            }
                            o.push(c);
                          }
                        }
                        return o;
                      }),
                      (t.parseLevelPlaylist = function(t, e, r, n, i) {
                        var v,
                          g,
                          m,
                          T = new h.LevelDetails(e),
                          S = T.fragments,
                          L = null,
                          _ = 0,
                          A = 0,
                          D = 0,
                          w = 0,
                          k = null,
                          R = new c.Fragment(n, e),
                          O = -1,
                          I = !1;
                        for (
                          y.lastIndex = 0, T.m3u8 = t;
                          null !== (v = y.exec(t));

                        ) {
                          I &&
                            ((I = !1),
                            ((R = new c.Fragment(n, e)).start = D),
                            (R.sn = _),
                            (R.cc = w),
                            (R.level = r),
                            L &&
                              ((R.initSegment = L),
                              (R.rawProgramDateTime = L.rawProgramDateTime),
                              (L.rawProgramDateTime = null)));
                          var C = v[1];
                          if (C) {
                            R.duration = parseFloat(C);
                            var x = (' ' + v[2]).slice(1);
                            (R.title = x || null),
                              R.tagList.push(x ? ['INF', C, x] : ['INF', C]);
                          } else if (v[3])
                            Object(o.isFiniteNumber)(R.duration) &&
                              ((R.start = D),
                              m && (R.levelkey = m),
                              (R.sn = _),
                              (R.level = r),
                              (R.cc = w),
                              (R.urlId = i),
                              S.push(R),
                              (R.relurl = (' ' + v[3]).slice(1)),
                              s(R, k),
                              (k = R),
                              (D += R.duration),
                              _++,
                              (A = 0),
                              (I = !0));
                          else if (v[4]) {
                            var P = (' ' + v[4]).slice(1);
                            k ? R.setByteRange(P, k) : R.setByteRange(P);
                          } else if (v[5])
                            (R.rawProgramDateTime = (' ' + v[5]).slice(1)),
                              R.tagList.push([
                                'PROGRAM-DATE-TIME',
                                R.rawProgramDateTime,
                              ]),
                              -1 === O && (O = S.length);
                          else {
                            if (!(v = v[0].match(b))) {
                              p.logger.warn(
                                'No matches on slow regex match for level playlist!',
                              );
                              continue;
                            }
                            for (g = 1; g < v.length && void 0 === v[g]; g++);
                            var M = (' ' + v[g]).slice(1),
                              F = (' ' + v[g + 1]).slice(1),
                              N = v[g + 2] ? (' ' + v[g + 2]).slice(1) : '';
                            switch (M) {
                              case 'PLAYLIST-TYPE':
                                T.type = F.toUpperCase();
                                break;
                              case 'MEDIA-SEQUENCE':
                                _ = T.startSN = parseInt(F);
                                break;
                              case 'SKIP':
                                var U = new f.AttrList(F),
                                  B = U.decimalInteger('SKIPPED-SEGMENTS');
                                if (Object(o.isFiniteNumber)(B)) {
                                  T.skippedSegments = B;
                                  for (var j = B; j--; ) S.unshift(null);
                                  _ += B;
                                }
                                var G = U.enumeratedString(
                                  'RECENTLY-REMOVED-DATERANGES',
                                );
                                G &&
                                  (T.recentlyRemovedDateranges = G.split('\t'));
                                break;
                              case 'TARGETDURATION':
                                T.targetduration = parseFloat(F);
                                break;
                              case 'VERSION':
                                T.version = parseInt(F);
                                break;
                              case 'EXTM3U':
                                break;
                              case 'ENDLIST':
                                T.live = !1;
                                break;
                              case '#':
                                (F || N) && R.tagList.push(N ? [F, N] : [F]);
                                break;
                              case 'DISCONTINUITY':
                                w++, R.tagList.push(['DIS']);
                                break;
                              case 'GAP':
                                R.tagList.push([M]);
                                break;
                              case 'BITRATE':
                                R.tagList.push([M, F]);
                                break;
                              case 'DATERANGE':
                                var V = new f.AttrList(F),
                                  H = new l.DateRange(V, T.dateRanges[V.ID]);
                                H.isValid || T.skippedSegments
                                  ? (T.dateRanges[H.id] = H)
                                  : p.logger.warn(
                                      'Ignoring invalid DATERANGE tag: "' +
                                        F +
                                        '"',
                                    ),
                                  R.tagList.push(['EXT-X-DATERANGE', F]);
                                break;
                              case 'DISCONTINUITY-SEQUENCE':
                                w = parseInt(F);
                                break;
                              case 'KEY':
                                var K,
                                  W = new f.AttrList(F),
                                  Y = W.enumeratedString('METHOD'),
                                  q = W.URI,
                                  z = W.hexadecimalInteger('IV'),
                                  X = W.enumeratedString('KEYFORMATVERSIONS'),
                                  $ = W.enumeratedString('KEYID'),
                                  Q =
                                    null !=
                                    (K = W.enumeratedString('KEYFORMAT'))
                                      ? K
                                      : 'identity';
                                if (
                                  [
                                    'com.apple.streamingkeydelivery',
                                    'com.microsoft.playready',
                                    'urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed',
                                    'com.widevine',
                                  ].indexOf(Q) > -1
                                ) {
                                  p.logger.warn(
                                    'Keyformat ' +
                                      Q +
                                      ' is not supported from the manifest',
                                  );
                                  continue;
                                }
                                if ('identity' !== Q) continue;
                                Y &&
                                  ((m = d.LevelKey.fromURL(e, q)),
                                  q &&
                                    [
                                      'AES-128',
                                      'SAMPLE-AES',
                                      'SAMPLE-AES-CENC',
                                    ].indexOf(Y) >= 0 &&
                                    ((m.method = Y),
                                    (m.keyFormat = Q),
                                    $ && (m.keyID = $),
                                    X && (m.keyFormatVersions = X),
                                    (m.iv = z)));
                                break;
                              case 'START':
                                var J = new f.AttrList(F).decimalFloatingPoint(
                                  'TIME-OFFSET',
                                );
                                Object(o.isFiniteNumber)(J) &&
                                  (T.startTimeOffset = J);
                                break;
                              case 'MAP':
                                var Z = new f.AttrList(F);
                                if (R.duration) {
                                  var tt = new c.Fragment(n, e);
                                  a(tt, Z, r, m),
                                    (L = tt),
                                    (R.initSegment = L),
                                    L.rawProgramDateTime &&
                                      !R.rawProgramDateTime &&
                                      (R.rawProgramDateTime =
                                        L.rawProgramDateTime);
                                } else a(R, Z, r, m), (L = R), (I = !0);
                                break;
                              case 'SERVER-CONTROL':
                                var et = new f.AttrList(F);
                                (T.canBlockReload = et.bool(
                                  'CAN-BLOCK-RELOAD',
                                )),
                                  (T.canSkipUntil = et.optionalFloat(
                                    'CAN-SKIP-UNTIL',
                                    0,
                                  )),
                                  (T.canSkipDateRanges =
                                    T.canSkipUntil > 0 &&
                                    et.bool('CAN-SKIP-DATERANGES')),
                                  (T.partHoldBack = et.optionalFloat(
                                    'PART-HOLD-BACK',
                                    0,
                                  )),
                                  (T.holdBack = et.optionalFloat(
                                    'HOLD-BACK',
                                    0,
                                  ));
                                break;
                              case 'PART-INF':
                                var rt = new f.AttrList(F);
                                T.partTarget = rt.decimalFloatingPoint(
                                  'PART-TARGET',
                                );
                                break;
                              case 'PART':
                                var nt = T.partList;
                                nt || (nt = T.partList = []);
                                var it = A > 0 ? nt[nt.length - 1] : void 0,
                                  st = A++,
                                  at = new c.Part(
                                    new f.AttrList(F),
                                    R,
                                    e,
                                    st,
                                    it,
                                  );
                                nt.push(at), (R.duration += at.duration);
                                break;
                              case 'PRELOAD-HINT':
                                var ot = new f.AttrList(F);
                                T.preloadHint = ot;
                                break;
                              case 'RENDITION-REPORT':
                                var ut = new f.AttrList(F);
                                (T.renditionReports = T.renditionReports || []),
                                  T.renditionReports.push(ut);
                                break;
                              default:
                                p.logger.warn(
                                  'line parsed but not handled: ' + v,
                                );
                            }
                          }
                        }
                        k && !k.relurl
                          ? (S.pop(),
                            (D -= k.duration),
                            T.partList && (T.fragmentHint = k))
                          : T.partList &&
                            (s(R, k), (R.cc = w), (T.fragmentHint = R));
                        var lt = S.length,
                          ct = S[0],
                          ht = S[lt - 1];
                        if (
                          (D += T.skippedSegments * T.targetduration) > 0 &&
                          lt &&
                          ht
                        ) {
                          T.averagetargetduration = D / lt;
                          var dt = ht.sn;
                          (T.endSN = 'initSegment' !== dt ? dt : 0),
                            ct &&
                              ((T.startCC = ct.cc),
                              ct.initSegment ||
                                (T.fragments.every(function(t) {
                                  return (
                                    t.relurl &&
                                    ((e = t.relurl),
                                    E.test(
                                      null !=
                                        (r =
                                          null === (n = u.parseURL(e)) ||
                                          void 0 === n
                                            ? void 0
                                            : n.path)
                                        ? r
                                        : '',
                                    ))
                                  );
                                  var e, r, n;
                                }) &&
                                  (p.logger.warn(
                                    'MP4 fragments found but no init segment (probably no MAP, incomplete M3U8), trying to fetch SIDX',
                                  ),
                                  ((R = new c.Fragment(n, e)).relurl =
                                    ht.relurl),
                                  (R.level = r),
                                  (R.sn = 'initSegment'),
                                  (ct.initSegment = R),
                                  (T.needSidxRanges = !0))));
                        } else (T.endSN = 0), (T.startCC = 0);
                        return (
                          T.fragmentHint && (D += T.fragmentHint.duration),
                          (T.totalduration = D),
                          (T.endCC = w),
                          O > 0 &&
                            (function(t, e) {
                              for (var r = t[e], n = e; n--; ) {
                                var i = t[n];
                                if (!i) return;
                                (i.programDateTime =
                                  r.programDateTime - 1e3 * i.duration),
                                  (r = i);
                              }
                            })(S, O),
                          T
                        );
                      }),
                      t
                    );
                  })();
              },
              './src/loader/playlist-loader.ts': function(t, e, r) {
                function n(t, e) {
                  var r = t.url;
                  return (
                    (void 0 !== r && 0 !== r.indexOf('data:')) || (r = e.url), r
                  );
                }
                r.r(e);
                var i = r('./src/polyfills/number.ts'),
                  s = r('./src/events.ts'),
                  a = r('./src/errors.ts'),
                  o = r('./src/utils/logger.ts'),
                  u = r('./src/utils/mp4-tools.ts'),
                  l = r('./src/loader/m3u8-parser.ts'),
                  c = r('./src/types/loader.ts'),
                  h = r('./src/utils/attr-list.ts'),
                  d = (function() {
                    function t(t) {
                      (this.hls = void 0),
                        (this.loaders = Object.create(null)),
                        (this.hls = t),
                        this.registerListeners();
                    }
                    var e = t.prototype;
                    return (
                      (e.startLoad = function(t) {}),
                      (e.stopLoad = function() {
                        this.destroyInternalLoaders();
                      }),
                      (e.registerListeners = function() {
                        var t = this.hls;
                        t.on(
                          s.Events.MANIFEST_LOADING,
                          this.onManifestLoading,
                          this,
                        ),
                          t.on(
                            s.Events.LEVEL_LOADING,
                            this.onLevelLoading,
                            this,
                          ),
                          t.on(
                            s.Events.AUDIO_TRACK_LOADING,
                            this.onAudioTrackLoading,
                            this,
                          ),
                          t.on(
                            s.Events.SUBTITLE_TRACK_LOADING,
                            this.onSubtitleTrackLoading,
                            this,
                          );
                      }),
                      (e.unregisterListeners = function() {
                        var t = this.hls;
                        t.off(
                          s.Events.MANIFEST_LOADING,
                          this.onManifestLoading,
                          this,
                        ),
                          t.off(
                            s.Events.LEVEL_LOADING,
                            this.onLevelLoading,
                            this,
                          ),
                          t.off(
                            s.Events.AUDIO_TRACK_LOADING,
                            this.onAudioTrackLoading,
                            this,
                          ),
                          t.off(
                            s.Events.SUBTITLE_TRACK_LOADING,
                            this.onSubtitleTrackLoading,
                            this,
                          );
                      }),
                      (e.createInternalLoader = function(t) {
                        var e = this.hls.config,
                          r = e.pLoader,
                          n = e.loader,
                          i = new (r || n)(e);
                        return (t.loader = i), (this.loaders[t.type] = i), i;
                      }),
                      (e.getInternalLoader = function(t) {
                        return this.loaders[t.type];
                      }),
                      (e.resetInternalLoader = function(t) {
                        this.loaders[t] && delete this.loaders[t];
                      }),
                      (e.destroyInternalLoaders = function() {
                        for (var t in this.loaders) {
                          var e = this.loaders[t];
                          e && e.destroy(), this.resetInternalLoader(t);
                        }
                      }),
                      (e.destroy = function() {
                        this.unregisterListeners(),
                          this.destroyInternalLoaders();
                      }),
                      (e.onManifestLoading = function(t, e) {
                        var r = e.url;
                        this.load({
                          id: null,
                          groupId: null,
                          level: 0,
                          responseType: 'text',
                          type: c.PlaylistContextType.MANIFEST,
                          url: r,
                          deliveryDirectives: null,
                        });
                      }),
                      (e.onLevelLoading = function(t, e) {
                        var r = e.id,
                          n = e.level,
                          i = e.url,
                          s = e.deliveryDirectives;
                        this.load({
                          id: r,
                          groupId: null,
                          level: n,
                          responseType: 'text',
                          type: c.PlaylistContextType.LEVEL,
                          url: i,
                          deliveryDirectives: s,
                        });
                      }),
                      (e.onAudioTrackLoading = function(t, e) {
                        var r = e.id,
                          n = e.groupId,
                          i = e.url,
                          s = e.deliveryDirectives;
                        this.load({
                          id: r,
                          groupId: n,
                          level: null,
                          responseType: 'text',
                          type: c.PlaylistContextType.AUDIO_TRACK,
                          url: i,
                          deliveryDirectives: s,
                        });
                      }),
                      (e.onSubtitleTrackLoading = function(t, e) {
                        var r = e.id,
                          n = e.groupId,
                          i = e.url,
                          s = e.deliveryDirectives;
                        this.load({
                          id: r,
                          groupId: n,
                          level: null,
                          responseType: 'text',
                          type: c.PlaylistContextType.SUBTITLE_TRACK,
                          url: i,
                          deliveryDirectives: s,
                        });
                      }),
                      (e.load = function(t) {
                        var e,
                          r,
                          n,
                          i,
                          s,
                          a,
                          u = this.hls.config,
                          l = this.getInternalLoader(t);
                        if (l) {
                          var h = l.context;
                          if (h && h.url === t.url)
                            return void o.logger.trace(
                              '[playlist-loader]: playlist request ongoing',
                            );
                          o.logger.log(
                            '[playlist-loader]: aborting previous loader for type: ' +
                              t.type,
                          ),
                            l.abort();
                        }
                        switch (t.type) {
                          case c.PlaylistContextType.MANIFEST:
                            (r = u.manifestLoadingMaxRetry),
                              (n = u.manifestLoadingTimeOut),
                              (i = u.manifestLoadingRetryDelay),
                              (s = u.manifestLoadingMaxRetryTimeout);
                            break;
                          case c.PlaylistContextType.LEVEL:
                          case c.PlaylistContextType.AUDIO_TRACK:
                          case c.PlaylistContextType.SUBTITLE_TRACK:
                            (r = 0), (n = u.levelLoadingTimeOut);
                            break;
                          default:
                            (r = u.levelLoadingMaxRetry),
                              (n = u.levelLoadingTimeOut),
                              (i = u.levelLoadingRetryDelay),
                              (s = u.levelLoadingMaxRetryTimeout);
                        }
                        if (
                          ((l = this.createInternalLoader(t)),
                          null !== (e = t.deliveryDirectives) &&
                            void 0 !== e &&
                            e.part &&
                            (t.type === c.PlaylistContextType.LEVEL &&
                            null !== t.level
                              ? (a = this.hls.levels[t.level].details)
                              : t.type === c.PlaylistContextType.AUDIO_TRACK &&
                                null !== t.id
                              ? (a = this.hls.audioTracks[t.id].details)
                              : t.type ===
                                  c.PlaylistContextType.SUBTITLE_TRACK &&
                                null !== t.id &&
                                (a = this.hls.subtitleTracks[t.id].details),
                            a))
                        ) {
                          var d = a.partTarget,
                            f = a.targetduration;
                          d &&
                            f &&
                            (n = Math.min(1e3 * Math.max(3 * d, 0.8 * f), n));
                        }
                        var p = {
                            timeout: n,
                            maxRetry: r,
                            retryDelay: i,
                            maxRetryDelay: s,
                            highWaterMark: 0,
                          },
                          v = {
                            onSuccess: this.loadsuccess.bind(this),
                            onError: this.loaderror.bind(this),
                            onTimeout: this.loadtimeout.bind(this),
                          };
                        l.load(t, p, v);
                      }),
                      (e.loadsuccess = function(t, e, r, n) {
                        if ((void 0 === n && (n = null), r.isSidxRequest))
                          return (
                            this.handleSidxRequest(t, r),
                            void this.handlePlaylistLoaded(t, e, r, n)
                          );
                        this.resetInternalLoader(r.type);
                        var i = t.data;
                        0 === i.indexOf('#EXTM3U')
                          ? ((e.parsing.start = performance.now()),
                            i.indexOf('#EXTINF:') > 0 ||
                            i.indexOf('#EXT-X-TARGETDURATION:') > 0
                              ? this.handleTrackOrLevelPlaylist(t, e, r, n)
                              : this.handleMasterPlaylist(t, e, r, n))
                          : this.handleManifestParsingError(
                              t,
                              r,
                              'no EXTM3U delimiter',
                              n,
                            );
                      }),
                      (e.loaderror = function(t, e, r) {
                        void 0 === r && (r = null),
                          this.handleNetworkError(e, r, !1, t);
                      }),
                      (e.loadtimeout = function(t, e, r) {
                        void 0 === r && (r = null),
                          this.handleNetworkError(e, r, !0);
                      }),
                      (e.handleMasterPlaylist = function(t, e, r, i) {
                        var a = this.hls,
                          u = t.data,
                          c = n(t, r),
                          d = l.default.parseMasterPlaylist(u, c),
                          f = d.levels,
                          p = d.sessionData;
                        if (f.length) {
                          var v = f.map(function(t) {
                              return {
                                id: t.attrs.AUDIO,
                                audioCodec: t.audioCodec,
                              };
                            }),
                            g = f.map(function(t) {
                              return {
                                id: t.attrs.SUBTITLES,
                                textCodec: t.textCodec,
                              };
                            }),
                            m = l.default.parseMasterPlaylistMedia(
                              u,
                              c,
                              'AUDIO',
                              v,
                            ),
                            y = l.default.parseMasterPlaylistMedia(
                              u,
                              c,
                              'SUBTITLES',
                              g,
                            ),
                            b = l.default.parseMasterPlaylistMedia(
                              u,
                              c,
                              'CLOSED-CAPTIONS',
                            );
                          m.length &&
                            (m.some(function(t) {
                              return !t.url;
                            }) ||
                              !f[0].audioCodec ||
                              f[0].attrs.AUDIO ||
                              (o.logger.log(
                                '[playlist-loader]: audio codec signaled in quality level, but no embedded audio track signaled, create one',
                              ),
                              m.unshift({
                                type: 'main',
                                name: 'main',
                                default: !1,
                                autoselect: !1,
                                forced: !1,
                                id: -1,
                                attrs: new h.AttrList({}),
                                bitrate: 0,
                                url: '',
                              }))),
                            a.trigger(s.Events.MANIFEST_LOADED, {
                              levels: f,
                              audioTracks: m,
                              subtitles: y,
                              captions: b,
                              url: c,
                              stats: e,
                              networkDetails: i,
                              sessionData: p,
                            });
                        } else
                          this.handleManifestParsingError(
                            t,
                            r,
                            'no level found in manifest',
                            i,
                          );
                      }),
                      (e.handleTrackOrLevelPlaylist = function(t, e, r, o) {
                        var u = this.hls,
                          d = r.id,
                          f = r.level,
                          p = r.type,
                          v = n(t, r),
                          g = Object(i.isFiniteNumber)(d) ? d : 0,
                          m = Object(i.isFiniteNumber)(f) ? f : g,
                          y = (function(t) {
                            switch (t.type) {
                              case c.PlaylistContextType.AUDIO_TRACK:
                                return c.PlaylistLevelType.AUDIO;
                              case c.PlaylistContextType.SUBTITLE_TRACK:
                                return c.PlaylistLevelType.SUBTITLE;
                              default:
                                return c.PlaylistLevelType.MAIN;
                            }
                          })(r),
                          b = l.default.parseLevelPlaylist(t.data, v, m, y, g);
                        if (b.fragments.length) {
                          if (p === c.PlaylistContextType.MANIFEST) {
                            var E = {
                              attrs: new h.AttrList({}),
                              bitrate: 0,
                              details: b,
                              name: '',
                              url: v,
                            };
                            u.trigger(s.Events.MANIFEST_LOADED, {
                              levels: [E],
                              audioTracks: [],
                              url: v,
                              stats: e,
                              networkDetails: o,
                              sessionData: null,
                            });
                          }
                          if (
                            ((e.parsing.end = performance.now()),
                            b.needSidxRanges)
                          ) {
                            var T,
                              S =
                                null === (T = b.fragments[0].initSegment) ||
                                void 0 === T
                                  ? void 0
                                  : T.url;
                            this.load({
                              url: S,
                              isSidxRequest: !0,
                              type: p,
                              level: f,
                              levelDetails: b,
                              id: d,
                              groupId: null,
                              rangeStart: 0,
                              rangeEnd: 2048,
                              responseType: 'arraybuffer',
                              deliveryDirectives: null,
                            });
                          } else
                            (r.levelDetails = b),
                              this.handlePlaylistLoaded(t, e, r, o);
                        } else
                          u.trigger(s.Events.ERROR, {
                            type: a.ErrorTypes.NETWORK_ERROR,
                            details: a.ErrorDetails.LEVEL_EMPTY_ERROR,
                            fatal: !1,
                            url: v,
                            reason: 'no fragments found in level',
                            level:
                              'number' == typeof r.level ? r.level : void 0,
                          });
                      }),
                      (e.handleSidxRequest = function(t, e) {
                        var r = new Uint8Array(t.data),
                          n = Object(u.findBox)(r, ['sidx'])[0];
                        if (n) {
                          var i = Object(u.parseSegmentIndex)(n);
                          if (i) {
                            var s = i.references,
                              a = e.levelDetails;
                            s.forEach(function(t, e) {
                              var n = t.info,
                                i = a.fragments[e];
                              if (
                                (0 === i.byteRange.length &&
                                  i.setByteRange(
                                    String(1 + n.end - n.start) +
                                      '@' +
                                      String(n.start),
                                  ),
                                i.initSegment)
                              ) {
                                var s = Object(u.findBox)(r, ['moov'])[0],
                                  o = s ? s.length : null;
                                i.initSegment.setByteRange(String(o) + '@0');
                              }
                            });
                          }
                        }
                      }),
                      (e.handleManifestParsingError = function(t, e, r, n) {
                        this.hls.trigger(s.Events.ERROR, {
                          type: a.ErrorTypes.NETWORK_ERROR,
                          details: a.ErrorDetails.MANIFEST_PARSING_ERROR,
                          fatal: e.type === c.PlaylistContextType.MANIFEST,
                          url: t.url,
                          reason: r,
                          response: t,
                          context: e,
                          networkDetails: n,
                        });
                      }),
                      (e.handleNetworkError = function(t, e, r, n) {
                        void 0 === r && (r = !1),
                          o.logger.warn(
                            '[playlist-loader]: A network ' +
                              (r ? 'timeout' : 'error') +
                              ' occurred while loading ' +
                              t.type +
                              ' level: ' +
                              t.level +
                              ' id: ' +
                              t.id +
                              ' group-id: "' +
                              t.groupId +
                              '"',
                          );
                        var i = a.ErrorDetails.UNKNOWN,
                          u = !1,
                          l = this.getInternalLoader(t);
                        switch (t.type) {
                          case c.PlaylistContextType.MANIFEST:
                            (i = r
                              ? a.ErrorDetails.MANIFEST_LOAD_TIMEOUT
                              : a.ErrorDetails.MANIFEST_LOAD_ERROR),
                              (u = !0);
                            break;
                          case c.PlaylistContextType.LEVEL:
                            (i = r
                              ? a.ErrorDetails.LEVEL_LOAD_TIMEOUT
                              : a.ErrorDetails.LEVEL_LOAD_ERROR),
                              (u = !1);
                            break;
                          case c.PlaylistContextType.AUDIO_TRACK:
                            (i = r
                              ? a.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT
                              : a.ErrorDetails.AUDIO_TRACK_LOAD_ERROR),
                              (u = !1);
                            break;
                          case c.PlaylistContextType.SUBTITLE_TRACK:
                            (i = r
                              ? a.ErrorDetails.SUBTITLE_TRACK_LOAD_TIMEOUT
                              : a.ErrorDetails.SUBTITLE_LOAD_ERROR),
                              (u = !1);
                        }
                        l && this.resetInternalLoader(t.type);
                        var h = {
                          type: a.ErrorTypes.NETWORK_ERROR,
                          details: i,
                          fatal: u,
                          url: t.url,
                          loader: l,
                          context: t,
                          networkDetails: e,
                        };
                        n && (h.response = n),
                          this.hls.trigger(s.Events.ERROR, h);
                      }),
                      (e.handlePlaylistLoaded = function(t, e, r, n) {
                        var i = r.type,
                          a = r.level,
                          o = r.id,
                          u = r.groupId,
                          l = r.loader,
                          h = r.levelDetails,
                          d = r.deliveryDirectives;
                        if (null != h && h.targetduration) {
                          if (l)
                            switch (
                              (h.live &&
                                (l.getCacheAge &&
                                  (h.ageHeader = l.getCacheAge() || 0),
                                (l.getCacheAge && !isNaN(h.ageHeader)) ||
                                  (h.ageHeader = 0)),
                              i)
                            ) {
                              case c.PlaylistContextType.MANIFEST:
                              case c.PlaylistContextType.LEVEL:
                                this.hls.trigger(s.Events.LEVEL_LOADED, {
                                  details: h,
                                  level: a || 0,
                                  id: o || 0,
                                  stats: e,
                                  networkDetails: n,
                                  deliveryDirectives: d,
                                });
                                break;
                              case c.PlaylistContextType.AUDIO_TRACK:
                                this.hls.trigger(s.Events.AUDIO_TRACK_LOADED, {
                                  details: h,
                                  id: o || 0,
                                  groupId: u || '',
                                  stats: e,
                                  networkDetails: n,
                                  deliveryDirectives: d,
                                });
                                break;
                              case c.PlaylistContextType.SUBTITLE_TRACK:
                                this.hls.trigger(
                                  s.Events.SUBTITLE_TRACK_LOADED,
                                  {
                                    details: h,
                                    id: o || 0,
                                    groupId: u || '',
                                    stats: e,
                                    networkDetails: n,
                                    deliveryDirectives: d,
                                  },
                                );
                            }
                        } else
                          this.handleManifestParsingError(
                            t,
                            r,
                            'invalid target duration',
                            n,
                          );
                      }),
                      t
                    );
                  })();
                e.default = d;
              },
              './src/polyfills/number.ts': function(t, e, r) {
                r.r(e),
                  r.d(e, 'isFiniteNumber', function() {
                    return n;
                  }),
                  r.d(e, 'MAX_SAFE_INTEGER', function() {
                    return i;
                  });
                var n =
                    Number.isFinite ||
                    function(t) {
                      return 'number' == typeof t && isFinite(t);
                    },
                  i = Number.MAX_SAFE_INTEGER || 9007199254740991;
              },
              './src/remux/aac-helper.ts': function(t, e, r) {
                r.r(e);
                var n = (function() {
                  function t() {}
                  return (
                    (t.getSilentFrame = function(t, e) {
                      switch (t) {
                        case 'mp4a.40.2':
                          if (1 === e)
                            return new Uint8Array([0, 200, 0, 128, 35, 128]);
                          if (2 === e)
                            return new Uint8Array([
                              33,
                              0,
                              73,
                              144,
                              2,
                              25,
                              0,
                              35,
                              128,
                            ]);
                          if (3 === e)
                            return new Uint8Array([
                              0,
                              200,
                              0,
                              128,
                              32,
                              132,
                              1,
                              38,
                              64,
                              8,
                              100,
                              0,
                              142,
                            ]);
                          if (4 === e)
                            return new Uint8Array([
                              0,
                              200,
                              0,
                              128,
                              32,
                              132,
                              1,
                              38,
                              64,
                              8,
                              100,
                              0,
                              128,
                              44,
                              128,
                              8,
                              2,
                              56,
                            ]);
                          if (5 === e)
                            return new Uint8Array([
                              0,
                              200,
                              0,
                              128,
                              32,
                              132,
                              1,
                              38,
                              64,
                              8,
                              100,
                              0,
                              130,
                              48,
                              4,
                              153,
                              0,
                              33,
                              144,
                              2,
                              56,
                            ]);
                          if (6 === e)
                            return new Uint8Array([
                              0,
                              200,
                              0,
                              128,
                              32,
                              132,
                              1,
                              38,
                              64,
                              8,
                              100,
                              0,
                              130,
                              48,
                              4,
                              153,
                              0,
                              33,
                              144,
                              2,
                              0,
                              178,
                              0,
                              32,
                              8,
                              224,
                            ]);
                          break;
                        default:
                          if (1 === e)
                            return new Uint8Array([
                              1,
                              64,
                              34,
                              128,
                              163,
                              78,
                              230,
                              128,
                              186,
                              8,
                              0,
                              0,
                              0,
                              28,
                              6,
                              241,
                              193,
                              10,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              94,
                            ]);
                          if (2 === e)
                            return new Uint8Array([
                              1,
                              64,
                              34,
                              128,
                              163,
                              94,
                              230,
                              128,
                              186,
                              8,
                              0,
                              0,
                              0,
                              0,
                              149,
                              0,
                              6,
                              241,
                              161,
                              10,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              94,
                            ]);
                          if (3 === e)
                            return new Uint8Array([
                              1,
                              64,
                              34,
                              128,
                              163,
                              94,
                              230,
                              128,
                              186,
                              8,
                              0,
                              0,
                              0,
                              0,
                              149,
                              0,
                              6,
                              241,
                              161,
                              10,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              90,
                              94,
                            ]);
                      }
                    }),
                    t
                  );
                })();
                e.default = n;
              },
              './src/remux/mp4-generator.ts': function(t, e, r) {
                r.r(e);
                var n = Math.pow(2, 32) - 1,
                  i = (function() {
                    function t() {}
                    return (
                      (t.init = function() {
                        var e;
                        for (e in ((t.types = {
                          avc1: [],
                          avcC: [],
                          btrt: [],
                          dinf: [],
                          dref: [],
                          esds: [],
                          ftyp: [],
                          hdlr: [],
                          mdat: [],
                          mdhd: [],
                          mdia: [],
                          mfhd: [],
                          minf: [],
                          moof: [],
                          moov: [],
                          mp4a: [],
                          '.mp3': [],
                          mvex: [],
                          mvhd: [],
                          pasp: [],
                          sdtp: [],
                          stbl: [],
                          stco: [],
                          stsc: [],
                          stsd: [],
                          stsz: [],
                          stts: [],
                          tfdt: [],
                          tfhd: [],
                          traf: [],
                          trak: [],
                          trun: [],
                          trex: [],
                          tkhd: [],
                          vmhd: [],
                          smhd: [],
                        }),
                        t.types))
                          t.types.hasOwnProperty(e) &&
                            (t.types[e] = [
                              e.charCodeAt(0),
                              e.charCodeAt(1),
                              e.charCodeAt(2),
                              e.charCodeAt(3),
                            ]);
                        var r = new Uint8Array([
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            118,
                            105,
                            100,
                            101,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            86,
                            105,
                            100,
                            101,
                            111,
                            72,
                            97,
                            110,
                            100,
                            108,
                            101,
                            114,
                            0,
                          ]),
                          n = new Uint8Array([
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            115,
                            111,
                            117,
                            110,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            83,
                            111,
                            117,
                            110,
                            100,
                            72,
                            97,
                            110,
                            100,
                            108,
                            101,
                            114,
                            0,
                          ]);
                        t.HDLR_TYPES = { video: r, audio: n };
                        var i = new Uint8Array([
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            12,
                            117,
                            114,
                            108,
                            32,
                            0,
                            0,
                            0,
                            1,
                          ]),
                          s = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0]);
                        (t.STTS = t.STSC = t.STCO = s),
                          (t.STSZ = new Uint8Array([
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                          ])),
                          (t.VMHD = new Uint8Array([
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                          ])),
                          (t.SMHD = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0])),
                          (t.STSD = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 1]));
                        var a = new Uint8Array([105, 115, 111, 109]),
                          o = new Uint8Array([97, 118, 99, 49]),
                          u = new Uint8Array([0, 0, 0, 1]);
                        (t.FTYP = t.box(t.types.ftyp, a, u, a, o)),
                          (t.DINF = t.box(
                            t.types.dinf,
                            t.box(t.types.dref, i),
                          ));
                      }),
                      (t.box = function(t) {
                        for (
                          var e = 8,
                            r = arguments.length,
                            n = new Array(r > 1 ? r - 1 : 0),
                            i = 1;
                          i < r;
                          i++
                        )
                          n[i - 1] = arguments[i];
                        for (var s = n.length, a = s; s--; )
                          e += n[s].byteLength;
                        var o = new Uint8Array(e);
                        for (
                          o[0] = (e >> 24) & 255,
                            o[1] = (e >> 16) & 255,
                            o[2] = (e >> 8) & 255,
                            o[3] = 255 & e,
                            o.set(t, 4),
                            s = 0,
                            e = 8;
                          s < a;
                          s++
                        )
                          o.set(n[s], e), (e += n[s].byteLength);
                        return o;
                      }),
                      (t.hdlr = function(e) {
                        return t.box(t.types.hdlr, t.HDLR_TYPES[e]);
                      }),
                      (t.mdat = function(e) {
                        return t.box(t.types.mdat, e);
                      }),
                      (t.mdhd = function(e, r) {
                        r *= e;
                        var i = Math.floor(r / (n + 1)),
                          s = Math.floor(r % (n + 1));
                        return t.box(
                          t.types.mdhd,
                          new Uint8Array([
                            1,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            2,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            3,
                            (e >> 24) & 255,
                            (e >> 16) & 255,
                            (e >> 8) & 255,
                            255 & e,
                            i >> 24,
                            (i >> 16) & 255,
                            (i >> 8) & 255,
                            255 & i,
                            s >> 24,
                            (s >> 16) & 255,
                            (s >> 8) & 255,
                            255 & s,
                            85,
                            196,
                            0,
                            0,
                          ]),
                        );
                      }),
                      (t.mdia = function(e) {
                        return t.box(
                          t.types.mdia,
                          t.mdhd(e.timescale, e.duration),
                          t.hdlr(e.type),
                          t.minf(e),
                        );
                      }),
                      (t.mfhd = function(e) {
                        return t.box(
                          t.types.mfhd,
                          new Uint8Array([
                            0,
                            0,
                            0,
                            0,
                            e >> 24,
                            (e >> 16) & 255,
                            (e >> 8) & 255,
                            255 & e,
                          ]),
                        );
                      }),
                      (t.minf = function(e) {
                        return 'audio' === e.type
                          ? t.box(
                              t.types.minf,
                              t.box(t.types.smhd, t.SMHD),
                              t.DINF,
                              t.stbl(e),
                            )
                          : t.box(
                              t.types.minf,
                              t.box(t.types.vmhd, t.VMHD),
                              t.DINF,
                              t.stbl(e),
                            );
                      }),
                      (t.moof = function(e, r, n) {
                        return t.box(t.types.moof, t.mfhd(e), t.traf(n, r));
                      }),
                      (t.moov = function(e) {
                        for (var r = e.length, n = []; r--; )
                          n[r] = t.trak(e[r]);
                        return t.box.apply(
                          null,
                          [t.types.moov, t.mvhd(e[0].timescale, e[0].duration)]
                            .concat(n)
                            .concat(t.mvex(e)),
                        );
                      }),
                      (t.mvex = function(e) {
                        for (var r = e.length, n = []; r--; )
                          n[r] = t.trex(e[r]);
                        return t.box.apply(null, [t.types.mvex].concat(n));
                      }),
                      (t.mvhd = function(e, r) {
                        r *= e;
                        var i = Math.floor(r / (n + 1)),
                          s = Math.floor(r % (n + 1)),
                          a = new Uint8Array([
                            1,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            2,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            3,
                            (e >> 24) & 255,
                            (e >> 16) & 255,
                            (e >> 8) & 255,
                            255 & e,
                            i >> 24,
                            (i >> 16) & 255,
                            (i >> 8) & 255,
                            255 & i,
                            s >> 24,
                            (s >> 16) & 255,
                            (s >> 8) & 255,
                            255 & s,
                            0,
                            1,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            64,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            255,
                            255,
                            255,
                            255,
                          ]);
                        return t.box(t.types.mvhd, a);
                      }),
                      (t.sdtp = function(e) {
                        var r,
                          n,
                          i = e.samples || [],
                          s = new Uint8Array(4 + i.length);
                        for (r = 0; r < i.length; r++)
                          (n = i[r].flags),
                            (s[r + 4] =
                              (n.dependsOn << 4) |
                              (n.isDependedOn << 2) |
                              n.hasRedundancy);
                        return t.box(t.types.sdtp, s);
                      }),
                      (t.stbl = function(e) {
                        return t.box(
                          t.types.stbl,
                          t.stsd(e),
                          t.box(t.types.stts, t.STTS),
                          t.box(t.types.stsc, t.STSC),
                          t.box(t.types.stsz, t.STSZ),
                          t.box(t.types.stco, t.STCO),
                        );
                      }),
                      (t.avc1 = function(e) {
                        var r,
                          n,
                          i,
                          s = [],
                          a = [];
                        for (r = 0; r < e.sps.length; r++)
                          (i = (n = e.sps[r]).byteLength),
                            s.push((i >>> 8) & 255),
                            s.push(255 & i),
                            (s = s.concat(Array.prototype.slice.call(n)));
                        for (r = 0; r < e.pps.length; r++)
                          (i = (n = e.pps[r]).byteLength),
                            a.push((i >>> 8) & 255),
                            a.push(255 & i),
                            (a = a.concat(Array.prototype.slice.call(n)));
                        var o = t.box(
                            t.types.avcC,
                            new Uint8Array(
                              [1, s[3], s[4], s[5], 255, 224 | e.sps.length]
                                .concat(s)
                                .concat([e.pps.length])
                                .concat(a),
                            ),
                          ),
                          u = e.width,
                          l = e.height,
                          c = e.pixelRatio[0],
                          h = e.pixelRatio[1];
                        return t.box(
                          t.types.avc1,
                          new Uint8Array([
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            (u >> 8) & 255,
                            255 & u,
                            (l >> 8) & 255,
                            255 & l,
                            0,
                            72,
                            0,
                            0,
                            0,
                            72,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            1,
                            18,
                            100,
                            97,
                            105,
                            108,
                            121,
                            109,
                            111,
                            116,
                            105,
                            111,
                            110,
                            47,
                            104,
                            108,
                            115,
                            46,
                            106,
                            115,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            24,
                            17,
                            17,
                          ]),
                          o,
                          t.box(
                            t.types.btrt,
                            new Uint8Array([
                              0,
                              28,
                              156,
                              128,
                              0,
                              45,
                              198,
                              192,
                              0,
                              45,
                              198,
                              192,
                            ]),
                          ),
                          t.box(
                            t.types.pasp,
                            new Uint8Array([
                              c >> 24,
                              (c >> 16) & 255,
                              (c >> 8) & 255,
                              255 & c,
                              h >> 24,
                              (h >> 16) & 255,
                              (h >> 8) & 255,
                              255 & h,
                            ]),
                          ),
                        );
                      }),
                      (t.esds = function(t) {
                        var e = t.config.length;
                        return new Uint8Array(
                          [
                            0,
                            0,
                            0,
                            0,
                            3,
                            23 + e,
                            0,
                            1,
                            0,
                            4,
                            15 + e,
                            64,
                            21,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            5,
                          ]
                            .concat([e])
                            .concat(t.config)
                            .concat([6, 1, 2]),
                        );
                      }),
                      (t.mp4a = function(e) {
                        var r = e.samplerate;
                        return t.box(
                          t.types.mp4a,
                          new Uint8Array([
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            e.channelCount,
                            0,
                            16,
                            0,
                            0,
                            0,
                            0,
                            (r >> 8) & 255,
                            255 & r,
                            0,
                            0,
                          ]),
                          t.box(t.types.esds, t.esds(e)),
                        );
                      }),
                      (t.mp3 = function(e) {
                        var r = e.samplerate;
                        return t.box(
                          t.types['.mp3'],
                          new Uint8Array([
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            e.channelCount,
                            0,
                            16,
                            0,
                            0,
                            0,
                            0,
                            (r >> 8) & 255,
                            255 & r,
                            0,
                            0,
                          ]),
                        );
                      }),
                      (t.stsd = function(e) {
                        return 'audio' === e.type
                          ? 'mp3' === e.segmentCodec && 'mp3' === e.codec
                            ? t.box(t.types.stsd, t.STSD, t.mp3(e))
                            : t.box(t.types.stsd, t.STSD, t.mp4a(e))
                          : t.box(t.types.stsd, t.STSD, t.avc1(e));
                      }),
                      (t.tkhd = function(e) {
                        var r = e.id,
                          i = e.duration * e.timescale,
                          s = e.width,
                          a = e.height,
                          o = Math.floor(i / (n + 1)),
                          u = Math.floor(i % (n + 1));
                        return t.box(
                          t.types.tkhd,
                          new Uint8Array([
                            1,
                            0,
                            0,
                            7,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            2,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            3,
                            (r >> 24) & 255,
                            (r >> 16) & 255,
                            (r >> 8) & 255,
                            255 & r,
                            0,
                            0,
                            0,
                            0,
                            o >> 24,
                            (o >> 16) & 255,
                            (o >> 8) & 255,
                            255 & o,
                            u >> 24,
                            (u >> 16) & 255,
                            (u >> 8) & 255,
                            255 & u,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            64,
                            0,
                            0,
                            0,
                            (s >> 8) & 255,
                            255 & s,
                            0,
                            0,
                            (a >> 8) & 255,
                            255 & a,
                            0,
                            0,
                          ]),
                        );
                      }),
                      (t.traf = function(e, r) {
                        var i = t.sdtp(e),
                          s = e.id,
                          a = Math.floor(r / (n + 1)),
                          o = Math.floor(r % (n + 1));
                        return t.box(
                          t.types.traf,
                          t.box(
                            t.types.tfhd,
                            new Uint8Array([
                              0,
                              0,
                              0,
                              0,
                              s >> 24,
                              (s >> 16) & 255,
                              (s >> 8) & 255,
                              255 & s,
                            ]),
                          ),
                          t.box(
                            t.types.tfdt,
                            new Uint8Array([
                              1,
                              0,
                              0,
                              0,
                              a >> 24,
                              (a >> 16) & 255,
                              (a >> 8) & 255,
                              255 & a,
                              o >> 24,
                              (o >> 16) & 255,
                              (o >> 8) & 255,
                              255 & o,
                            ]),
                          ),
                          t.trun(e, i.length + 16 + 20 + 8 + 16 + 8 + 8),
                          i,
                        );
                      }),
                      (t.trak = function(e) {
                        return (
                          (e.duration = e.duration || 4294967295),
                          t.box(t.types.trak, t.tkhd(e), t.mdia(e))
                        );
                      }),
                      (t.trex = function(e) {
                        var r = e.id;
                        return t.box(
                          t.types.trex,
                          new Uint8Array([
                            0,
                            0,
                            0,
                            0,
                            r >> 24,
                            (r >> 16) & 255,
                            (r >> 8) & 255,
                            255 & r,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            1,
                          ]),
                        );
                      }),
                      (t.trun = function(e, r) {
                        var n,
                          i,
                          s,
                          a,
                          o,
                          u,
                          l = e.samples || [],
                          c = l.length,
                          h = 12 + 16 * c,
                          d = new Uint8Array(h);
                        for (
                          r += 8 + h,
                            d.set(
                              [
                                'video' === e.type ? 1 : 0,
                                0,
                                15,
                                1,
                                (c >>> 24) & 255,
                                (c >>> 16) & 255,
                                (c >>> 8) & 255,
                                255 & c,
                                (r >>> 24) & 255,
                                (r >>> 16) & 255,
                                (r >>> 8) & 255,
                                255 & r,
                              ],
                              0,
                            ),
                            n = 0;
                          n < c;
                          n++
                        )
                          (s = (i = l[n]).duration),
                            (a = i.size),
                            (o = i.flags),
                            (u = i.cts),
                            d.set(
                              [
                                (s >>> 24) & 255,
                                (s >>> 16) & 255,
                                (s >>> 8) & 255,
                                255 & s,
                                (a >>> 24) & 255,
                                (a >>> 16) & 255,
                                (a >>> 8) & 255,
                                255 & a,
                                (o.isLeading << 2) | o.dependsOn,
                                (o.isDependedOn << 6) |
                                  (o.hasRedundancy << 4) |
                                  (o.paddingValue << 1) |
                                  o.isNonSync,
                                61440 & o.degradPrio,
                                15 & o.degradPrio,
                                (u >>> 24) & 255,
                                (u >>> 16) & 255,
                                (u >>> 8) & 255,
                                255 & u,
                              ],
                              12 + 16 * n,
                            );
                        return t.box(t.types.trun, d);
                      }),
                      (t.initSegment = function(e) {
                        t.types || t.init();
                        var r = t.moov(e),
                          n = new Uint8Array(t.FTYP.byteLength + r.byteLength);
                        return n.set(t.FTYP), n.set(r, t.FTYP.byteLength), n;
                      }),
                      t
                    );
                  })();
                (i.types = void 0),
                  (i.HDLR_TYPES = void 0),
                  (i.STTS = void 0),
                  (i.STSC = void 0),
                  (i.STCO = void 0),
                  (i.STSZ = void 0),
                  (i.VMHD = void 0),
                  (i.SMHD = void 0),
                  (i.STSD = void 0),
                  (i.FTYP = void 0),
                  (i.DINF = void 0),
                  (e.default = i);
              },
              './src/remux/mp4-remuxer.ts': function(t, e, r) {
                function n() {
                  return (n = Object.assign
                    ? Object.assign.bind()
                    : function(t) {
                        for (var e = 1; e < arguments.length; e++) {
                          var r = arguments[e];
                          for (var n in r)
                            Object.prototype.hasOwnProperty.call(r, n) &&
                              (t[n] = r[n]);
                        }
                        return t;
                      }).apply(this, arguments);
                }
                function i(t, e) {
                  var r;
                  if (null === e) return t;
                  for (
                    r = e < t ? -8589934592 : 8589934592;
                    Math.abs(t - e) > 4294967296;

                  )
                    t += r;
                  return t;
                }
                function s(t, e, r, n) {
                  var s = t.samples.length;
                  if (s) {
                    for (var a = t.inputTimeScale, o = 0; o < s; o++) {
                      var u = t.samples[o];
                      (u.pts = i(u.pts - r, e * a) / a),
                        (u.dts = i(u.dts - n, e * a) / a);
                    }
                    var l = t.samples;
                    return (t.samples = []), { samples: l };
                  }
                }
                function a(t, e, r) {
                  var n = t.samples.length;
                  if (n) {
                    for (var s = t.inputTimeScale, a = 0; a < n; a++) {
                      var o = t.samples[a];
                      o.pts = i(o.pts - r, e * s) / s;
                    }
                    t.samples.sort(function(t, e) {
                      return t.pts - e.pts;
                    });
                    var u = t.samples;
                    return (t.samples = []), { samples: u };
                  }
                }
                r.r(e),
                  r.d(e, 'default', function() {
                    return m;
                  }),
                  r.d(e, 'normalizePts', function() {
                    return i;
                  }),
                  r.d(e, 'flushTextTrackMetadataCueSamples', function() {
                    return s;
                  }),
                  r.d(e, 'flushTextTrackUserdataCueSamples', function() {
                    return a;
                  });
                var o = r('./src/polyfills/number.ts'),
                  u = r('./src/remux/aac-helper.ts'),
                  l = r('./src/remux/mp4-generator.ts'),
                  c = r('./src/events.ts'),
                  h = r('./src/errors.ts'),
                  d = r('./src/utils/logger.ts'),
                  f = r('./src/types/loader.ts'),
                  p = r('./src/utils/timescale-conversion.ts'),
                  v = null,
                  g = null,
                  m = (function() {
                    function t(t, e, r, n) {
                      if (
                        (void 0 === n && (n = ''),
                        (this.observer = void 0),
                        (this.config = void 0),
                        (this.typeSupported = void 0),
                        (this.ISGenerated = !1),
                        (this._initPTS = void 0),
                        (this._initDTS = void 0),
                        (this.nextAvcDts = null),
                        (this.nextAudioPts = null),
                        (this.videoSampleDuration = null),
                        (this.isAudioContiguous = !1),
                        (this.isVideoContiguous = !1),
                        (this.observer = t),
                        (this.config = e),
                        (this.typeSupported = r),
                        (this.ISGenerated = !1),
                        null === v)
                      ) {
                        var i = (navigator.userAgent || '').match(
                          /Chrome\/(\d+)/i,
                        );
                        v = i ? parseInt(i[1]) : 0;
                      }
                      if (null === g) {
                        var s = navigator.userAgent.match(/Safari\/(\d+)/i);
                        g = s ? parseInt(s[1]) : 0;
                      }
                    }
                    var e = t.prototype;
                    return (
                      (e.destroy = function() {}),
                      (e.resetTimeStamp = function(t) {
                        d.logger.log('[mp4-remuxer]: initPTS & initDTS reset'),
                          (this._initPTS = this._initDTS = t);
                      }),
                      (e.resetNextTimestamp = function() {
                        d.logger.log('[mp4-remuxer]: reset next timestamp'),
                          (this.isVideoContiguous = !1),
                          (this.isAudioContiguous = !1);
                      }),
                      (e.resetInitSegment = function() {
                        d.logger.log('[mp4-remuxer]: ISGenerated flag reset'),
                          (this.ISGenerated = !1);
                      }),
                      (e.getVideoStartPts = function(t) {
                        var e = !1,
                          r = t.reduce(function(t, r) {
                            var n = r.pts - t;
                            return n < -4294967296
                              ? ((e = !0), i(t, r.pts))
                              : n > 0
                              ? t
                              : r.pts;
                          }, t[0].pts);
                        return e && d.logger.debug('PTS rollover detected'), r;
                      }),
                      (e.remux = function(t, e, r, n, o, u, l, c) {
                        var h,
                          p,
                          v,
                          g,
                          m,
                          y,
                          b = o,
                          E = o,
                          T = t.pid > -1,
                          S = e.pid > -1,
                          L = e.samples.length,
                          _ = t.samples.length > 0,
                          A = (l && L > 0) || L > 1;
                        if (((!T || _) && (!S || A)) || this.ISGenerated || l) {
                          this.ISGenerated || (v = this.generateIS(t, e, o));
                          var D,
                            w = this.isVideoContiguous,
                            k = -1;
                          if (
                            A &&
                            ((k = (function(t) {
                              for (var e = 0; e < t.length; e++)
                                if (t[e].key) return e;
                              return -1;
                            })(e.samples)),
                            !w && this.config.forceKeyFrameOnDiscontinuity)
                          )
                            if (((y = !0), k > 0)) {
                              d.logger.warn(
                                '[mp4-remuxer]: Dropped ' +
                                  k +
                                  ' out of ' +
                                  L +
                                  ' video samples due to a missing keyframe',
                              );
                              var R = this.getVideoStartPts(e.samples);
                              (e.samples = e.samples.slice(k)),
                                (e.dropped += k),
                                (D = E +=
                                  (e.samples[0].pts - R) / e.inputTimeScale);
                            } else
                              -1 === k &&
                                (d.logger.warn(
                                  '[mp4-remuxer]: No keyframe found out of ' +
                                    L +
                                    ' video samples',
                                ),
                                (y = !1));
                          if (this.ISGenerated) {
                            if (_ && A) {
                              var O = this.getVideoStartPts(e.samples),
                                I =
                                  (i(t.samples[0].pts, O) - O) /
                                  e.inputTimeScale;
                              (b += Math.max(0, I)), (E += Math.max(0, -I));
                            }
                            if (_) {
                              if (
                                (t.samplerate ||
                                  (d.logger.warn(
                                    '[mp4-remuxer]: regenerate InitSegment as audio detected',
                                  ),
                                  (v = this.generateIS(t, e, o))),
                                (p = this.remuxAudio(
                                  t,
                                  b,
                                  this.isAudioContiguous,
                                  u,
                                  S || A || c === f.PlaylistLevelType.AUDIO
                                    ? E
                                    : void 0,
                                )),
                                A)
                              ) {
                                var C = p ? p.endPTS - p.startPTS : 0;
                                e.inputTimeScale ||
                                  (d.logger.warn(
                                    '[mp4-remuxer]: regenerate InitSegment as video detected',
                                  ),
                                  (v = this.generateIS(t, e, o))),
                                  (h = this.remuxVideo(e, E, w, C));
                              }
                            } else A && (h = this.remuxVideo(e, E, w, 0));
                            h &&
                              ((h.firstKeyFrame = k),
                              (h.independent = -1 !== k),
                              (h.firstKeyFramePTS = D));
                          }
                        }
                        return (
                          this.ISGenerated &&
                            (r.samples.length &&
                              (m = s(r, o, this._initPTS, this._initDTS)),
                            n.samples.length && (g = a(n, o, this._initPTS))),
                          {
                            audio: p,
                            video: h,
                            initSegment: v,
                            independent: y,
                            text: g,
                            id3: m,
                          }
                        );
                      }),
                      (e.generateIS = function(t, e, r) {
                        var n,
                          s,
                          a,
                          u = t.samples,
                          c = e.samples,
                          h = this.typeSupported,
                          d = {},
                          f = !Object(o.isFiniteNumber)(this._initPTS),
                          p = 'audio/mp4';
                        if ((f && (n = s = 1 / 0), t.config && u.length)) {
                          switch (
                            ((t.timescale = t.samplerate), t.segmentCodec)
                          ) {
                            case 'mp3':
                              h.mpeg
                                ? ((p = 'audio/mpeg'), (t.codec = ''))
                                : h.mp3 && (t.codec = 'mp3');
                          }
                          (d.audio = {
                            id: 'audio',
                            container: p,
                            codec: t.codec,
                            initSegment:
                              'mp3' === t.segmentCodec && h.mpeg
                                ? new Uint8Array(0)
                                : l.default.initSegment([t]),
                            metadata: { channelCount: t.channelCount },
                          }),
                            f &&
                              ((a = t.inputTimeScale),
                              (n = s = u[0].pts - Math.round(a * r)));
                        }
                        if (
                          e.sps &&
                          e.pps &&
                          c.length &&
                          ((e.timescale = e.inputTimeScale),
                          (d.video = {
                            id: 'main',
                            container: 'video/mp4',
                            codec: e.codec,
                            initSegment: l.default.initSegment([e]),
                            metadata: { width: e.width, height: e.height },
                          }),
                          f)
                        ) {
                          a = e.inputTimeScale;
                          var v = this.getVideoStartPts(c),
                            g = Math.round(a * r);
                          (s = Math.min(s, i(c[0].dts, v) - g)),
                            (n = Math.min(n, v - g));
                        }
                        if (Object.keys(d).length)
                          return (
                            (this.ISGenerated = !0),
                            f && ((this._initPTS = n), (this._initDTS = s)),
                            { tracks: d, initPTS: n, timescale: a }
                          );
                      }),
                      (e.remuxVideo = function(t, e, r, s) {
                        var a,
                          o,
                          u = t.inputTimeScale,
                          f = t.samples,
                          m = [],
                          b = f.length,
                          E = this._initPTS,
                          T = this.nextAvcDts,
                          S = 8,
                          L = this.videoSampleDuration,
                          _ = Number.POSITIVE_INFINITY,
                          A = Number.NEGATIVE_INFINITY,
                          D = !1;
                        (r && null !== T) ||
                          (T = e * u - (f[0].pts - i(f[0].dts, f[0].pts)));
                        for (var w = 0; w < b; w++) {
                          var k = f[w];
                          (k.pts = i(k.pts - E, T)),
                            (k.dts = i(k.dts - E, T)),
                            k.dts < f[w > 0 ? w - 1 : w].dts && (D = !0);
                        }
                        D &&
                          f.sort(function(t, e) {
                            var r = t.dts - e.dts,
                              n = t.pts - e.pts;
                            return r || n;
                          }),
                          (a = f[0].dts);
                        var R = f[f.length - 1].dts - a,
                          O = R
                            ? Math.round(R / (b - 1))
                            : L || t.inputTimeScale / 30;
                        if (r) {
                          var I = a - T,
                            C = I > O;
                          if (C || I < -1) {
                            C
                              ? d.logger.warn(
                                  'AVC: ' +
                                    Object(p.toMsFromMpegTsClock)(I, !0) +
                                    ' ms (' +
                                    I +
                                    'dts) hole between fragments detected, filling it',
                                )
                              : d.logger.warn(
                                  'AVC: ' +
                                    Object(p.toMsFromMpegTsClock)(-I, !0) +
                                    ' ms (' +
                                    I +
                                    'dts) overlapping between fragments detected',
                                ),
                              (a = T);
                            var x = f[0].pts - I;
                            (f[0].dts = a),
                              (f[0].pts = x),
                              d.logger.log(
                                'Video: First PTS/DTS adjusted: ' +
                                  Object(p.toMsFromMpegTsClock)(x, !0) +
                                  '/' +
                                  Object(p.toMsFromMpegTsClock)(a, !0) +
                                  ', delta: ' +
                                  Object(p.toMsFromMpegTsClock)(I, !0) +
                                  ' ms',
                              );
                          }
                        }
                        a = Math.max(0, a);
                        for (var P = 0, M = 0, F = 0; F < b; F++) {
                          for (
                            var N = f[F],
                              U = N.units,
                              B = U.length,
                              j = 0,
                              G = 0;
                            G < B;
                            G++
                          )
                            j += U[G].data.length;
                          (M += j),
                            (P += B),
                            (N.length = j),
                            (N.dts = Math.max(N.dts, a)),
                            (_ = Math.min(N.pts, _)),
                            (A = Math.max(N.pts, A));
                        }
                        o = f[b - 1].dts;
                        var V,
                          H = M + 4 * P + 8;
                        try {
                          V = new Uint8Array(H);
                        } catch (t) {
                          return void this.observer.emit(
                            c.Events.ERROR,
                            c.Events.ERROR,
                            {
                              type: h.ErrorTypes.MUX_ERROR,
                              details: h.ErrorDetails.REMUX_ALLOC_ERROR,
                              fatal: !1,
                              bytes: H,
                              reason: 'fail allocating video mdat ' + H,
                            },
                          );
                        }
                        var K = new DataView(V.buffer);
                        K.setUint32(0, H), V.set(l.default.types.mdat, 4);
                        for (
                          var W = !1,
                            Y = Number.POSITIVE_INFINITY,
                            q = Number.POSITIVE_INFINITY,
                            z = Number.NEGATIVE_INFINITY,
                            X = Number.NEGATIVE_INFINITY,
                            $ = 0;
                          $ < b;
                          $++
                        ) {
                          for (
                            var Q = f[$],
                              J = Q.units,
                              Z = 0,
                              tt = 0,
                              et = J.length;
                            tt < et;
                            tt++
                          ) {
                            var rt = J[tt],
                              nt = rt.data,
                              it = rt.data.byteLength;
                            K.setUint32(S, it),
                              (S += 4),
                              V.set(nt, S),
                              (S += it),
                              (Z += 4 + it);
                          }
                          var st = void 0;
                          if ($ < b - 1)
                            (L = f[$ + 1].dts - Q.dts),
                              (st = f[$ + 1].pts - Q.pts);
                          else {
                            var at = this.config,
                              ot = $ > 0 ? Q.dts - f[$ - 1].dts : O;
                            if (
                              ((st = $ > 0 ? Q.pts - f[$ - 1].pts : O),
                              at.stretchShortVideoTrack &&
                                null !== this.nextAudioPts)
                            ) {
                              var ut = Math.floor(at.maxBufferHole * u),
                                lt =
                                  (s ? _ + s * u : this.nextAudioPts) - Q.pts;
                              lt > ut
                                ? ((L = lt - ot) < 0 ? (L = ot) : (W = !0),
                                  d.logger.log(
                                    '[mp4-remuxer]: It is approximately ' +
                                      lt / 90 +
                                      ' ms to the next segment; using duration ' +
                                      L / 90 +
                                      ' ms for the last video frame.',
                                  ))
                                : (L = ot);
                            } else L = ot;
                          }
                          var ct = Math.round(Q.pts - Q.dts);
                          (Y = Math.min(Y, L)),
                            (z = Math.max(z, L)),
                            (q = Math.min(q, st)),
                            (X = Math.max(X, st)),
                            m.push(new y(Q.key, L, Z, ct));
                        }
                        if (m.length)
                          if (v) {
                            if (v < 70) {
                              var ht = m[0].flags;
                              (ht.dependsOn = 2), (ht.isNonSync = 0);
                            }
                          } else if (
                            g &&
                            X - q < z - Y &&
                            O / z < 0.025 &&
                            0 === m[0].cts
                          ) {
                            d.logger.warn(
                              'Found irregular gaps in sample duration. Using PTS instead of DTS to determine MP4 sample duration.',
                            );
                            for (
                              var dt = a, ft = 0, pt = m.length;
                              ft < pt;
                              ft++
                            ) {
                              var vt = dt + m[ft].duration,
                                gt = dt + m[ft].cts;
                              if (ft < pt - 1) {
                                var mt = vt + m[ft + 1].cts;
                                m[ft].duration = mt - gt;
                              } else
                                m[ft].duration = ft ? m[ft - 1].duration : O;
                              (m[ft].cts = 0), (dt = vt);
                            }
                          }
                        console.assert(
                          null !== L,
                          'mp4SampleDuration must be computed',
                        ),
                          (L = W || !L ? O : L),
                          (this.nextAvcDts = T = o + L),
                          (this.videoSampleDuration = L),
                          (this.isVideoContiguous = !0);
                        var yt = {
                          data1: l.default.moof(
                            t.sequenceNumber++,
                            a,
                            n({}, t, { samples: m }),
                          ),
                          data2: V,
                          startPTS: _ / u,
                          endPTS: (A + L) / u,
                          startDTS: a / u,
                          endDTS: T / u,
                          type: 'video',
                          hasAudio: !1,
                          hasVideo: !0,
                          nb: m.length,
                          dropped: t.dropped,
                        };
                        return (
                          (t.samples = []),
                          (t.dropped = 0),
                          console.assert(
                            V.length,
                            'MDAT length must not be zero',
                          ),
                          yt
                        );
                      }),
                      (e.remuxAudio = function(t, e, r, s, a) {
                        var o = t.inputTimeScale,
                          f = o / (t.samplerate ? t.samplerate : o),
                          p = 'aac' === t.segmentCodec ? 1024 : 1152,
                          v = p * f,
                          g = this._initPTS,
                          m =
                            'mp3' === t.segmentCodec && this.typeSupported.mpeg,
                          b = [],
                          E = void 0 !== a,
                          T = t.samples,
                          S = m ? 0 : 8,
                          L = this.nextAudioPts || -1,
                          _ = e * o;
                        if (
                          ((this.isAudioContiguous = r =
                            r ||
                            (T.length &&
                              L > 0 &&
                              ((s && Math.abs(_ - L) < 9e3) ||
                                Math.abs(i(T[0].pts - g, _) - L) < 20 * v))),
                          T.forEach(function(t) {
                            t.pts = i(t.pts - g, _);
                          }),
                          !r || L < 0)
                        ) {
                          if (
                            !(T = T.filter(function(t) {
                              return t.pts >= 0;
                            })).length
                          )
                            return;
                          L = 0 === a ? 0 : s && !E ? Math.max(0, _) : T[0].pts;
                        }
                        if ('aac' === t.segmentCodec)
                          for (
                            var A = this.config.maxAudioFramesDrift,
                              D = 0,
                              w = L;
                            D < T.length;
                            D++
                          ) {
                            var k = T[D],
                              R = k.pts,
                              O = R - w,
                              I = Math.abs((1e3 * O) / o);
                            if (O <= -A * v && E)
                              0 === D &&
                                (d.logger.warn(
                                  'Audio frame @ ' +
                                    (R / o).toFixed(3) +
                                    's overlaps nextAudioPts by ' +
                                    Math.round((1e3 * O) / o) +
                                    ' ms.',
                                ),
                                (this.nextAudioPts = L = w = R));
                            else if (O >= A * v && I < 1e4 && E) {
                              var C = Math.round(O / v);
                              (w = R - C * v) < 0 && (C--, (w += v)),
                                0 === D && (this.nextAudioPts = L = w),
                                d.logger.warn(
                                  '[mp4-remuxer]: Injecting ' +
                                    C +
                                    ' audio frame @ ' +
                                    (w / o).toFixed(3) +
                                    's due to ' +
                                    Math.round((1e3 * O) / o) +
                                    ' ms gap.',
                                );
                              for (var x = 0; x < C; x++) {
                                var P = Math.max(w, 0),
                                  M = u.default.getSilentFrame(
                                    t.manifestCodec || t.codec,
                                    t.channelCount,
                                  );
                                M ||
                                  (d.logger.log(
                                    '[mp4-remuxer]: Unable to get silent frame for given audio codec; duplicating last frame instead.',
                                  ),
                                  (M = k.unit.subarray())),
                                  T.splice(D, 0, { unit: M, pts: P }),
                                  (w += v),
                                  D++;
                              }
                            }
                            (k.pts = w), (w += v);
                          }
                        for (
                          var F, N = null, U = null, B = 0, j = T.length;
                          j--;

                        )
                          B += T[j].unit.byteLength;
                        for (var G = 0, V = T.length; G < V; G++) {
                          var H = T[G],
                            K = H.unit,
                            W = H.pts;
                          if (null !== U)
                            b[G - 1].duration = Math.round((W - U) / f);
                          else {
                            if (
                              (r && 'aac' === t.segmentCodec && (W = L),
                              (N = W),
                              !(B > 0))
                            )
                              return;
                            B += S;
                            try {
                              F = new Uint8Array(B);
                            } catch (t) {
                              return void this.observer.emit(
                                c.Events.ERROR,
                                c.Events.ERROR,
                                {
                                  type: h.ErrorTypes.MUX_ERROR,
                                  details: h.ErrorDetails.REMUX_ALLOC_ERROR,
                                  fatal: !1,
                                  bytes: B,
                                  reason: 'fail allocating audio mdat ' + B,
                                },
                              );
                            }
                            m ||
                              (new DataView(F.buffer).setUint32(0, B),
                              F.set(l.default.types.mdat, 4));
                          }
                          F.set(K, S);
                          var Y = K.byteLength;
                          (S += Y), b.push(new y(!0, p, Y, 0)), (U = W);
                        }
                        var q = b.length;
                        if (q) {
                          var z = b[b.length - 1];
                          this.nextAudioPts = L = U + f * z.duration;
                          var X = m
                            ? new Uint8Array(0)
                            : l.default.moof(
                                t.sequenceNumber++,
                                N / f,
                                n({}, t, { samples: b }),
                              );
                          t.samples = [];
                          var $ = N / o,
                            Q = L / o,
                            J = {
                              data1: X,
                              data2: F,
                              startPTS: $,
                              endPTS: Q,
                              startDTS: $,
                              endDTS: Q,
                              type: 'audio',
                              hasAudio: !0,
                              hasVideo: !1,
                              nb: q,
                            };
                          return (
                            (this.isAudioContiguous = !0),
                            console.assert(
                              F.length,
                              'MDAT length must not be zero',
                            ),
                            J
                          );
                        }
                      }),
                      (e.remuxEmptyAudio = function(t, e, r, n) {
                        var i = t.inputTimeScale,
                          s = i / (t.samplerate ? t.samplerate : i),
                          a = this.nextAudioPts,
                          o = (null !== a ? a : n.startDTS * i) + this._initDTS,
                          l = n.endDTS * i + this._initDTS,
                          c = 1024 * s,
                          h = Math.ceil((l - o) / c),
                          f = u.default.getSilentFrame(
                            t.manifestCodec || t.codec,
                            t.channelCount,
                          );
                        if (
                          (d.logger.warn('[mp4-remuxer]: remux empty Audio'), f)
                        ) {
                          for (var p = [], v = 0; v < h; v++) {
                            var g = o + v * c;
                            p.push({ unit: f, pts: g, dts: g });
                          }
                          return (t.samples = p), this.remuxAudio(t, e, r, !1);
                        }
                        d.logger.trace(
                          '[mp4-remuxer]: Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec',
                        );
                      }),
                      t
                    );
                  })(),
                  y = function(t, e, r, n) {
                    (this.size = void 0),
                      (this.duration = void 0),
                      (this.cts = void 0),
                      (this.flags = void 0),
                      (this.duration = e),
                      (this.size = r),
                      (this.cts = n),
                      (this.flags = new b(t));
                  },
                  b = function(t) {
                    (this.isLeading = 0),
                      (this.isDependedOn = 0),
                      (this.hasRedundancy = 0),
                      (this.degradPrio = 0),
                      (this.dependsOn = 1),
                      (this.isNonSync = 1),
                      (this.dependsOn = t ? 2 : 1),
                      (this.isNonSync = t ? 0 : 1);
                  };
              },
              './src/remux/passthrough-remuxer.ts': function(t, e, r) {
                function n(t, e) {
                  var r = null == t ? void 0 : t.codec;
                  return r && r.length > 4
                    ? r
                    : 'hvc1' === r || 'hev1' === r
                    ? 'hvc1.1.c.L120.90'
                    : 'av01' === r
                    ? 'av01.0.04M.08'
                    : 'avc1' === r || e === o.ElementaryStreamTypes.VIDEO
                    ? 'avc1.42e01e'
                    : 'mp4a.40.5';
                }
                r.r(e);
                var i = r('./src/polyfills/number.ts'),
                  s = r('./src/remux/mp4-remuxer.ts'),
                  a = r('./src/utils/mp4-tools.ts'),
                  o = r('./src/loader/fragment.ts'),
                  u = r('./src/utils/logger.ts'),
                  l = (function() {
                    function t() {
                      (this.emitInitSegment = !1),
                        (this.audioCodec = void 0),
                        (this.videoCodec = void 0),
                        (this.initData = void 0),
                        (this.initPTS = void 0),
                        (this.initTracks = void 0),
                        (this.lastEndTime = null);
                    }
                    var e = t.prototype;
                    return (
                      (e.destroy = function() {}),
                      (e.resetTimeStamp = function(t) {
                        (this.initPTS = t), (this.lastEndTime = null);
                      }),
                      (e.resetNextTimestamp = function() {
                        this.lastEndTime = null;
                      }),
                      (e.resetInitSegment = function(t, e, r) {
                        (this.audioCodec = e),
                          (this.videoCodec = r),
                          this.generateInitSegment(t),
                          (this.emitInitSegment = !0);
                      }),
                      (e.generateInitSegment = function(t) {
                        var e = this.audioCodec,
                          r = this.videoCodec;
                        if (!t || !t.byteLength)
                          return (
                            (this.initTracks = void 0),
                            void (this.initData = void 0)
                          );
                        var i = (this.initData = Object(a.parseInitSegment)(t));
                        e || (e = n(i.audio, o.ElementaryStreamTypes.AUDIO)),
                          r || (r = n(i.video, o.ElementaryStreamTypes.VIDEO));
                        var s = {};
                        i.audio && i.video
                          ? (s.audiovideo = {
                              container: 'video/mp4',
                              codec: e + ',' + r,
                              initSegment: t,
                              id: 'main',
                            })
                          : i.audio
                          ? (s.audio = {
                              container: 'audio/mp4',
                              codec: e,
                              initSegment: t,
                              id: 'audio',
                            })
                          : i.video
                          ? (s.video = {
                              container: 'video/mp4',
                              codec: r,
                              initSegment: t,
                              id: 'main',
                            })
                          : u.logger.warn(
                              '[passthrough-remuxer.ts]: initSegment does not contain moov or trak boxes.',
                            ),
                          (this.initTracks = s);
                      }),
                      (e.remux = function(t, e, r, n, o) {
                        var l,
                          c = this.initPTS,
                          h = this.lastEndTime,
                          d = {
                            audio: void 0,
                            video: void 0,
                            text: n,
                            id3: r,
                            initSegment: void 0,
                          };
                        Object(i.isFiniteNumber)(h) ||
                          (h = this.lastEndTime = o || 0);
                        var f = e.samples;
                        if (!f || !f.length) return d;
                        var p = { initPTS: void 0, timescale: 1 },
                          v = this.initData;
                        if (
                          ((v && v.length) ||
                            (this.generateInitSegment(f), (v = this.initData)),
                          !v || !v.length)
                        )
                          return (
                            u.logger.warn(
                              '[passthrough-remuxer.ts]: Failed to generate initSegment.',
                            ),
                            d
                          );
                        this.emitInitSegment &&
                          ((p.tracks = this.initTracks),
                          (this.emitInitSegment = !1));
                        var g = Object(a.getStartDTS)(v, f);
                        Object(i.isFiniteNumber)(c) ||
                          (this.initPTS = p.initPTS = c = g - o);
                        var m = Object(a.getDuration)(f, v),
                          y = t ? g - c : h,
                          b = y + m;
                        Object(a.offsetStartDTS)(v, f, c),
                          m > 0
                            ? (this.lastEndTime = b)
                            : (u.logger.warn(
                                'Duration parsed from mp4 should be greater than zero',
                              ),
                              this.resetNextTimestamp());
                        var E = !!v.audio,
                          T = !!v.video,
                          S = '';
                        E && (S += 'audio'), T && (S += 'video');
                        var L = {
                          data1: f,
                          startPTS: y,
                          startDTS: y,
                          endPTS: b,
                          endDTS: b,
                          type: S,
                          hasAudio: E,
                          hasVideo: T,
                          nb: 1,
                          dropped: 0,
                        };
                        (d.audio = 'audio' === L.type ? L : void 0),
                          (d.video = 'audio' !== L.type ? L : void 0),
                          (d.initSegment = p);
                        var _ = null != (l = this.initPTS) ? l : 0;
                        return (
                          (d.id3 = Object(s.flushTextTrackMetadataCueSamples)(
                            r,
                            o,
                            _,
                            _,
                          )),
                          n.samples.length &&
                            (d.text = Object(
                              s.flushTextTrackUserdataCueSamples,
                            )(n, o, _)),
                          d
                        );
                      }),
                      t
                    );
                  })();
                e.default = l;
              },
              './src/task-loop.ts': function(t, e, r) {
                r.r(e),
                  r.d(e, 'default', function() {
                    return n;
                  });
                var n = (function() {
                  function t() {
                    (this._boundTick = void 0),
                      (this._tickTimer = null),
                      (this._tickInterval = null),
                      (this._tickCallCount = 0),
                      (this._boundTick = this.tick.bind(this));
                  }
                  var e = t.prototype;
                  return (
                    (e.destroy = function() {
                      this.onHandlerDestroying(), this.onHandlerDestroyed();
                    }),
                    (e.onHandlerDestroying = function() {
                      this.clearNextTick(), this.clearInterval();
                    }),
                    (e.onHandlerDestroyed = function() {}),
                    (e.hasInterval = function() {
                      return !!this._tickInterval;
                    }),
                    (e.hasNextTick = function() {
                      return !!this._tickTimer;
                    }),
                    (e.setInterval = function(t) {
                      return (
                        !this._tickInterval &&
                        ((this._tickInterval = self.setInterval(
                          this._boundTick,
                          t,
                        )),
                        !0)
                      );
                    }),
                    (e.clearInterval = function() {
                      return (
                        !!this._tickInterval &&
                        (self.clearInterval(this._tickInterval),
                        (this._tickInterval = null),
                        !0)
                      );
                    }),
                    (e.clearNextTick = function() {
                      return (
                        !!this._tickTimer &&
                        (self.clearTimeout(this._tickTimer),
                        (this._tickTimer = null),
                        !0)
                      );
                    }),
                    (e.tick = function() {
                      this._tickCallCount++,
                        1 === this._tickCallCount &&
                          (this.doTick(),
                          this._tickCallCount > 1 && this.tickImmediate(),
                          (this._tickCallCount = 0));
                    }),
                    (e.tickImmediate = function() {
                      this.clearNextTick(),
                        (this._tickTimer = self.setTimeout(this._boundTick, 0));
                    }),
                    (e.doTick = function() {}),
                    t
                  );
                })();
              },
              './src/types/cmcd.ts': function(t, e, r) {
                r.r(e),
                  r.d(e, 'CMCDVersion', function() {
                    return a;
                  }),
                  r.d(e, 'CMCDObjectType', function() {
                    return n;
                  }),
                  r.d(e, 'CMCDStreamingFormat', function() {
                    return i;
                  }),
                  r.d(e, 'CMCDStreamType', function() {
                    return s;
                  });
                var n,
                  i,
                  s,
                  a = 1;
                !(function(t) {
                  (t.MANIFEST = 'm'),
                    (t.AUDIO = 'a'),
                    (t.VIDEO = 'v'),
                    (t.MUXED = 'av'),
                    (t.INIT = 'i'),
                    (t.CAPTION = 'c'),
                    (t.TIMED_TEXT = 'tt'),
                    (t.KEY = 'k'),
                    (t.OTHER = 'o');
                })(n || (n = {})),
                  (function(t) {
                    (t.DASH = 'd'),
                      (t.HLS = 'h'),
                      (t.SMOOTH = 's'),
                      (t.OTHER = 'o');
                  })(i || (i = {})),
                  (function(t) {
                    (t.VOD = 'v'), (t.LIVE = 'l');
                  })(s || (s = {}));
              },
              './src/types/demuxer.ts': function(t, e, r) {
                var n;
                r.r(e),
                  r.d(e, 'MetadataSchema', function() {
                    return n;
                  }),
                  (function(t) {
                    (t.audioId3 = 'org.id3'),
                      (t.dateRange = 'com.apple.quicktime.HLS'),
                      (t.emsg = 'https://aomedia.org/emsg/ID3');
                  })(n || (n = {}));
              },
              './src/types/level.ts': function(t, e, r) {
                function n(t, e) {
                  for (var r = 0; r < e.length; r++) {
                    var n = e[r];
                    (n.enumerable = n.enumerable || !1),
                      (n.configurable = !0),
                      'value' in n && (n.writable = !0),
                      Object.defineProperty(t, n.key, n);
                  }
                }
                function i(t, e) {
                  var r = t.canSkipUntil,
                    n = t.canSkipDateRanges,
                    i = t.endSN;
                  return r && (void 0 !== e ? e - i : 0) < r
                    ? n
                      ? s.v2
                      : s.Yes
                    : s.No;
                }
                var s;
                r.r(e),
                  r.d(e, 'HlsSkip', function() {
                    return s;
                  }),
                  r.d(e, 'getSkipValue', function() {
                    return i;
                  }),
                  r.d(e, 'HlsUrlParameters', function() {
                    return a;
                  }),
                  r.d(e, 'Level', function() {
                    return o;
                  }),
                  (function(t) {
                    (t.No = ''), (t.Yes = 'YES'), (t.v2 = 'v2');
                  })(s || (s = {}));
                var a = (function() {
                    function t(t, e, r) {
                      (this.msn = void 0),
                        (this.part = void 0),
                        (this.skip = void 0),
                        (this.msn = t),
                        (this.part = e),
                        (this.skip = r);
                    }
                    return (
                      (t.prototype.addDirectives = function(t) {
                        var e = new self.URL(t);
                        return (
                          void 0 !== this.msn &&
                            e.searchParams.set('_HLS_msn', this.msn.toString()),
                          void 0 !== this.part &&
                            e.searchParams.set(
                              '_HLS_part',
                              this.part.toString(),
                            ),
                          this.skip &&
                            e.searchParams.set('_HLS_skip', this.skip),
                          e.toString()
                        );
                      }),
                      t
                    );
                  })(),
                  o = (function() {
                    function t(t) {
                      (this.attrs = void 0),
                        (this.audioCodec = void 0),
                        (this.bitrate = void 0),
                        (this.codecSet = void 0),
                        (this.height = void 0),
                        (this.id = void 0),
                        (this.name = void 0),
                        (this.videoCodec = void 0),
                        (this.width = void 0),
                        (this.unknownCodecs = void 0),
                        (this.audioGroupIds = void 0),
                        (this.details = void 0),
                        (this.fragmentError = 0),
                        (this.loadError = 0),
                        (this.loaded = void 0),
                        (this.realBitrate = 0),
                        (this.textGroupIds = void 0),
                        (this.url = void 0),
                        (this._urlId = 0),
                        (this.url = [t.url]),
                        (this.attrs = t.attrs),
                        (this.bitrate = t.bitrate),
                        t.details && (this.details = t.details),
                        (this.id = t.id || 0),
                        (this.name = t.name),
                        (this.width = t.width || 0),
                        (this.height = t.height || 0),
                        (this.audioCodec = t.audioCodec),
                        (this.videoCodec = t.videoCodec),
                        (this.unknownCodecs = t.unknownCodecs),
                        (this.codecSet = [t.videoCodec, t.audioCodec]
                          .filter(function(t) {
                            return t;
                          })
                          .join(',')
                          .replace(/\.[^.,]+/g, ''));
                    }
                    var e, r;
                    return (
                      (e = t),
                      (r = [
                        {
                          key: 'maxBitrate',
                          get: function() {
                            return Math.max(this.realBitrate, this.bitrate);
                          },
                        },
                        {
                          key: 'uri',
                          get: function() {
                            return this.url[this._urlId] || '';
                          },
                        },
                        {
                          key: 'urlId',
                          get: function() {
                            return this._urlId;
                          },
                          set: function(t) {
                            var e = t % this.url.length;
                            this._urlId !== e &&
                              ((this.details = void 0), (this._urlId = e));
                          },
                        },
                      ]) && n(e.prototype, r),
                      Object.defineProperty(e, 'prototype', { writable: !1 }),
                      t
                    );
                  })();
              },
              './src/types/loader.ts': function(t, e, r) {
                var n, i;
                r.r(e),
                  r.d(e, 'PlaylistContextType', function() {
                    return n;
                  }),
                  r.d(e, 'PlaylistLevelType', function() {
                    return i;
                  }),
                  (function(t) {
                    (t.MANIFEST = 'manifest'),
                      (t.LEVEL = 'level'),
                      (t.AUDIO_TRACK = 'audioTrack'),
                      (t.SUBTITLE_TRACK = 'subtitleTrack');
                  })(n || (n = {})),
                  (function(t) {
                    (t.MAIN = 'main'),
                      (t.AUDIO = 'audio'),
                      (t.SUBTITLE = 'subtitle');
                  })(i || (i = {}));
              },
              './src/types/transmuxer.ts': function(t, e, r) {
                r.r(e),
                  r.d(e, 'ChunkMetadata', function() {
                    return n;
                  });
                var n = function(t, e, r, n, i, s) {
                  void 0 === n && (n = 0),
                    void 0 === i && (i = -1),
                    void 0 === s && (s = !1),
                    (this.level = void 0),
                    (this.sn = void 0),
                    (this.part = void 0),
                    (this.id = void 0),
                    (this.size = void 0),
                    (this.partial = void 0),
                    (this.transmuxing = {
                      start: 0,
                      executeStart: 0,
                      executeEnd: 0,
                      end: 0,
                    }),
                    (this.buffering = {
                      audio: {
                        start: 0,
                        executeStart: 0,
                        executeEnd: 0,
                        end: 0,
                      },
                      video: {
                        start: 0,
                        executeStart: 0,
                        executeEnd: 0,
                        end: 0,
                      },
                      audiovideo: {
                        start: 0,
                        executeStart: 0,
                        executeEnd: 0,
                        end: 0,
                      },
                    }),
                    (this.level = t),
                    (this.sn = e),
                    (this.id = r),
                    (this.size = n),
                    (this.part = i),
                    (this.partial = s);
                };
              },
              './src/utils/attr-list.ts': function(t, e, r) {
                r.r(e),
                  r.d(e, 'AttrList', function() {
                    return s;
                  });
                var n = /^(\d+)x(\d+)$/,
                  i = /\s*(.+?)\s*=((?:\".*?\")|.*?)(?:,|$)/g,
                  s = (function() {
                    function t(e) {
                      for (var r in ('string' == typeof e &&
                        (e = t.parseAttrList(e)),
                      e))
                        e.hasOwnProperty(r) && (this[r] = e[r]);
                    }
                    var e = t.prototype;
                    return (
                      (e.decimalInteger = function(t) {
                        var e = parseInt(this[t], 10);
                        return e > Number.MAX_SAFE_INTEGER ? 1 / 0 : e;
                      }),
                      (e.hexadecimalInteger = function(t) {
                        if (this[t]) {
                          var e = (this[t] || '0x').slice(2);
                          e = (1 & e.length ? '0' : '') + e;
                          for (
                            var r = new Uint8Array(e.length / 2), n = 0;
                            n < e.length / 2;
                            n++
                          )
                            r[n] = parseInt(e.slice(2 * n, 2 * n + 2), 16);
                          return r;
                        }
                        return null;
                      }),
                      (e.hexadecimalIntegerAsNumber = function(t) {
                        var e = parseInt(this[t], 16);
                        return e > Number.MAX_SAFE_INTEGER ? 1 / 0 : e;
                      }),
                      (e.decimalFloatingPoint = function(t) {
                        return parseFloat(this[t]);
                      }),
                      (e.optionalFloat = function(t, e) {
                        var r = this[t];
                        return r ? parseFloat(r) : e;
                      }),
                      (e.enumeratedString = function(t) {
                        return this[t];
                      }),
                      (e.bool = function(t) {
                        return 'YES' === this[t];
                      }),
                      (e.decimalResolution = function(t) {
                        var e = n.exec(this[t]);
                        if (null !== e)
                          return {
                            width: parseInt(e[1], 10),
                            height: parseInt(e[2], 10),
                          };
                      }),
                      (t.parseAttrList = function(t) {
                        var e,
                          r = {};
                        for (i.lastIndex = 0; null !== (e = i.exec(t)); ) {
                          var n = e[2];
                          0 === n.indexOf('"') &&
                            n.lastIndexOf('"') === n.length - 1 &&
                            (n = n.slice(1, -1)),
                            (r[e[1]] = n);
                        }
                        return r;
                      }),
                      t
                    );
                  })();
              },
              './src/utils/binary-search.ts': function(t, e, r) {
                r.r(e),
                  (e.default = {
                    search: function(t, e) {
                      for (
                        var r = 0, n = t.length - 1, i = null, s = null;
                        r <= n;

                      ) {
                        var a = e((s = t[(i = ((r + n) / 2) | 0)]));
                        if (a > 0) r = i + 1;
                        else {
                          if (!(a < 0)) return s;
                          n = i - 1;
                        }
                      }
                      return null;
                    },
                  });
              },
              './src/utils/buffer-helper.ts': function(t, e, r) {
                r.r(e),
                  r.d(e, 'BufferHelper', function() {
                    return s;
                  });
                var n = r('./src/utils/logger.ts'),
                  i = {
                    length: 0,
                    start: function() {
                      return 0;
                    },
                    end: function() {
                      return 0;
                    },
                  },
                  s = (function() {
                    function t() {}
                    return (
                      (t.isBuffered = function(e, r) {
                        try {
                          if (e)
                            for (
                              var n = t.getBuffered(e), i = 0;
                              i < n.length;
                              i++
                            )
                              if (r >= n.start(i) && r <= n.end(i)) return !0;
                        } catch (t) {}
                        return !1;
                      }),
                      (t.bufferInfo = function(e, r, n) {
                        try {
                          if (e) {
                            var i,
                              s = t.getBuffered(e),
                              a = [];
                            for (i = 0; i < s.length; i++)
                              a.push({ start: s.start(i), end: s.end(i) });
                            return this.bufferedInfo(a, r, n);
                          }
                        } catch (t) {}
                        return { len: 0, start: r, end: r, nextStart: void 0 };
                      }),
                      (t.bufferedInfo = function(t, e, r) {
                        (e = Math.max(0, e)),
                          t.sort(function(t, e) {
                            return t.start - e.start || e.end - t.end;
                          });
                        var n = [];
                        if (r)
                          for (var i = 0; i < t.length; i++) {
                            var s = n.length;
                            if (s) {
                              var a = n[s - 1].end;
                              t[i].start - a < r
                                ? t[i].end > a && (n[s - 1].end = t[i].end)
                                : n.push(t[i]);
                            } else n.push(t[i]);
                          }
                        else n = t;
                        for (
                          var o, u = 0, l = e, c = e, h = 0;
                          h < n.length;
                          h++
                        ) {
                          var d = n[h].start,
                            f = n[h].end;
                          if (e + r >= d && e < f) (l = d), (u = (c = f) - e);
                          else if (e + r < d) {
                            o = d;
                            break;
                          }
                        }
                        return {
                          len: u,
                          start: l || 0,
                          end: c || 0,
                          nextStart: o,
                        };
                      }),
                      (t.getBuffered = function(t) {
                        try {
                          return t.buffered;
                        } catch (t) {
                          return (
                            n.logger.log('failed to get media.buffered', t), i
                          );
                        }
                      }),
                      t
                    );
                  })();
              },
              './src/utils/cea-608-parser.ts': function(t, e, r) {
                function n(t, e, r) {
                  (r.a = t), (r.b = e);
                }
                function i(t, e, r) {
                  return r.a === t && r.b === e;
                }
                r.r(e),
                  r.d(e, 'Row', function() {
                    return y;
                  }),
                  r.d(e, 'CaptionScreen', function() {
                    return b;
                  });
                var s,
                  a = r('./src/utils/logger.ts'),
                  o = {
                    42: 225,
                    92: 233,
                    94: 237,
                    95: 243,
                    96: 250,
                    123: 231,
                    124: 247,
                    125: 209,
                    126: 241,
                    127: 9608,
                    128: 174,
                    129: 176,
                    130: 189,
                    131: 191,
                    132: 8482,
                    133: 162,
                    134: 163,
                    135: 9834,
                    136: 224,
                    137: 32,
                    138: 232,
                    139: 226,
                    140: 234,
                    141: 238,
                    142: 244,
                    143: 251,
                    144: 193,
                    145: 201,
                    146: 211,
                    147: 218,
                    148: 220,
                    149: 252,
                    150: 8216,
                    151: 161,
                    152: 42,
                    153: 8217,
                    154: 9473,
                    155: 169,
                    156: 8480,
                    157: 8226,
                    158: 8220,
                    159: 8221,
                    160: 192,
                    161: 194,
                    162: 199,
                    163: 200,
                    164: 202,
                    165: 203,
                    166: 235,
                    167: 206,
                    168: 207,
                    169: 239,
                    170: 212,
                    171: 217,
                    172: 249,
                    173: 219,
                    174: 171,
                    175: 187,
                    176: 195,
                    177: 227,
                    178: 205,
                    179: 204,
                    180: 236,
                    181: 210,
                    182: 242,
                    183: 213,
                    184: 245,
                    185: 123,
                    186: 125,
                    187: 92,
                    188: 94,
                    189: 95,
                    190: 124,
                    191: 8764,
                    192: 196,
                    193: 228,
                    194: 214,
                    195: 246,
                    196: 223,
                    197: 165,
                    198: 164,
                    199: 9475,
                    200: 197,
                    201: 229,
                    202: 216,
                    203: 248,
                    204: 9487,
                    205: 9491,
                    206: 9495,
                    207: 9499,
                  },
                  u = function(t) {
                    var e = t;
                    return (
                      o.hasOwnProperty(t) && (e = o[t]), String.fromCharCode(e)
                    );
                  },
                  l = {
                    17: 1,
                    18: 3,
                    21: 5,
                    22: 7,
                    23: 9,
                    16: 11,
                    19: 12,
                    20: 14,
                  },
                  c = { 17: 2, 18: 4, 21: 6, 22: 8, 23: 10, 19: 13, 20: 15 },
                  h = {
                    25: 1,
                    26: 3,
                    29: 5,
                    30: 7,
                    31: 9,
                    24: 11,
                    27: 12,
                    28: 14,
                  },
                  d = { 25: 2, 26: 4, 29: 6, 30: 8, 31: 10, 27: 13, 28: 15 },
                  f = [
                    'white',
                    'green',
                    'blue',
                    'cyan',
                    'red',
                    'yellow',
                    'magenta',
                    'black',
                    'transparent',
                  ];
                !(function(t) {
                  (t[(t.ERROR = 0)] = 'ERROR'),
                    (t[(t.TEXT = 1)] = 'TEXT'),
                    (t[(t.WARNING = 2)] = 'WARNING'),
                    (t[(t.INFO = 2)] = 'INFO'),
                    (t[(t.DEBUG = 3)] = 'DEBUG'),
                    (t[(t.DATA = 3)] = 'DATA');
                })(s || (s = {}));
                var p = (function() {
                    function t() {
                      (this.time = null), (this.verboseLevel = s.ERROR);
                    }
                    return (
                      (t.prototype.log = function(t, e) {
                        this.verboseLevel >= t &&
                          a.logger.log(this.time + ' [' + t + '] ' + e);
                      }),
                      t
                    );
                  })(),
                  v = function(t) {
                    for (var e = [], r = 0; r < t.length; r++)
                      e.push(t[r].toString(16));
                    return e;
                  },
                  g = (function() {
                    function t(t, e, r, n, i) {
                      (this.foreground = void 0),
                        (this.underline = void 0),
                        (this.italics = void 0),
                        (this.background = void 0),
                        (this.flash = void 0),
                        (this.foreground = t || 'white'),
                        (this.underline = e || !1),
                        (this.italics = r || !1),
                        (this.background = n || 'black'),
                        (this.flash = i || !1);
                    }
                    var e = t.prototype;
                    return (
                      (e.reset = function() {
                        (this.foreground = 'white'),
                          (this.underline = !1),
                          (this.italics = !1),
                          (this.background = 'black'),
                          (this.flash = !1);
                      }),
                      (e.setStyles = function(t) {
                        for (
                          var e = [
                              'foreground',
                              'underline',
                              'italics',
                              'background',
                              'flash',
                            ],
                            r = 0;
                          r < e.length;
                          r++
                        ) {
                          var n = e[r];
                          t.hasOwnProperty(n) && (this[n] = t[n]);
                        }
                      }),
                      (e.isDefault = function() {
                        return (
                          'white' === this.foreground &&
                          !this.underline &&
                          !this.italics &&
                          'black' === this.background &&
                          !this.flash
                        );
                      }),
                      (e.equals = function(t) {
                        return (
                          this.foreground === t.foreground &&
                          this.underline === t.underline &&
                          this.italics === t.italics &&
                          this.background === t.background &&
                          this.flash === t.flash
                        );
                      }),
                      (e.copy = function(t) {
                        (this.foreground = t.foreground),
                          (this.underline = t.underline),
                          (this.italics = t.italics),
                          (this.background = t.background),
                          (this.flash = t.flash);
                      }),
                      (e.toString = function() {
                        return (
                          'color=' +
                          this.foreground +
                          ', underline=' +
                          this.underline +
                          ', italics=' +
                          this.italics +
                          ', background=' +
                          this.background +
                          ', flash=' +
                          this.flash
                        );
                      }),
                      t
                    );
                  })(),
                  m = (function() {
                    function t(t, e, r, n, i, s) {
                      (this.uchar = void 0),
                        (this.penState = void 0),
                        (this.uchar = t || ' '),
                        (this.penState = new g(e, r, n, i, s));
                    }
                    var e = t.prototype;
                    return (
                      (e.reset = function() {
                        (this.uchar = ' '), this.penState.reset();
                      }),
                      (e.setChar = function(t, e) {
                        (this.uchar = t), this.penState.copy(e);
                      }),
                      (e.setPenState = function(t) {
                        this.penState.copy(t);
                      }),
                      (e.equals = function(t) {
                        return (
                          this.uchar === t.uchar &&
                          this.penState.equals(t.penState)
                        );
                      }),
                      (e.copy = function(t) {
                        (this.uchar = t.uchar), this.penState.copy(t.penState);
                      }),
                      (e.isEmpty = function() {
                        return ' ' === this.uchar && this.penState.isDefault();
                      }),
                      t
                    );
                  })(),
                  y = (function() {
                    function t(t) {
                      (this.chars = void 0),
                        (this.pos = void 0),
                        (this.currPenState = void 0),
                        (this.cueStartTime = void 0),
                        (this.logger = void 0),
                        (this.chars = []);
                      for (var e = 0; e < 100; e++) this.chars.push(new m());
                      (this.logger = t),
                        (this.pos = 0),
                        (this.currPenState = new g());
                    }
                    var e = t.prototype;
                    return (
                      (e.equals = function(t) {
                        for (var e = !0, r = 0; r < 100; r++)
                          if (!this.chars[r].equals(t.chars[r])) {
                            e = !1;
                            break;
                          }
                        return e;
                      }),
                      (e.copy = function(t) {
                        for (var e = 0; e < 100; e++)
                          this.chars[e].copy(t.chars[e]);
                      }),
                      (e.isEmpty = function() {
                        for (var t = !0, e = 0; e < 100; e++)
                          if (!this.chars[e].isEmpty()) {
                            t = !1;
                            break;
                          }
                        return t;
                      }),
                      (e.setCursor = function(t) {
                        this.pos !== t && (this.pos = t),
                          this.pos < 0
                            ? (this.logger.log(
                                s.DEBUG,
                                'Negative cursor position ' + this.pos,
                              ),
                              (this.pos = 0))
                            : this.pos > 100 &&
                              (this.logger.log(
                                s.DEBUG,
                                'Too large cursor position ' + this.pos,
                              ),
                              (this.pos = 100));
                      }),
                      (e.moveCursor = function(t) {
                        var e = this.pos + t;
                        if (t > 1)
                          for (var r = this.pos + 1; r < e + 1; r++)
                            this.chars[r].setPenState(this.currPenState);
                        this.setCursor(e);
                      }),
                      (e.backSpace = function() {
                        this.moveCursor(-1),
                          this.chars[this.pos].setChar(' ', this.currPenState);
                      }),
                      (e.insertChar = function(t) {
                        t >= 144 && this.backSpace();
                        var e = u(t);
                        this.pos >= 100
                          ? this.logger.log(
                              s.ERROR,
                              'Cannot insert ' +
                                t.toString(16) +
                                ' (' +
                                e +
                                ') at position ' +
                                this.pos +
                                '. Skipping it!',
                            )
                          : (this.chars[this.pos].setChar(e, this.currPenState),
                            this.moveCursor(1));
                      }),
                      (e.clearFromPos = function(t) {
                        var e;
                        for (e = t; e < 100; e++) this.chars[e].reset();
                      }),
                      (e.clear = function() {
                        this.clearFromPos(0),
                          (this.pos = 0),
                          this.currPenState.reset();
                      }),
                      (e.clearToEndOfRow = function() {
                        this.clearFromPos(this.pos);
                      }),
                      (e.getTextString = function() {
                        for (var t = [], e = !0, r = 0; r < 100; r++) {
                          var n = this.chars[r].uchar;
                          ' ' !== n && (e = !1), t.push(n);
                        }
                        return e ? '' : t.join('');
                      }),
                      (e.setPenStyles = function(t) {
                        this.currPenState.setStyles(t),
                          this.chars[this.pos].setPenState(this.currPenState);
                      }),
                      t
                    );
                  })(),
                  b = (function() {
                    function t(t) {
                      (this.rows = void 0),
                        (this.currRow = void 0),
                        (this.nrRollUpRows = void 0),
                        (this.lastOutputScreen = void 0),
                        (this.logger = void 0),
                        (this.rows = []);
                      for (var e = 0; e < 15; e++) this.rows.push(new y(t));
                      (this.logger = t),
                        (this.currRow = 14),
                        (this.nrRollUpRows = null),
                        (this.lastOutputScreen = null),
                        this.reset();
                    }
                    var e = t.prototype;
                    return (
                      (e.reset = function() {
                        for (var t = 0; t < 15; t++) this.rows[t].clear();
                        this.currRow = 14;
                      }),
                      (e.equals = function(t) {
                        for (var e = !0, r = 0; r < 15; r++)
                          if (!this.rows[r].equals(t.rows[r])) {
                            e = !1;
                            break;
                          }
                        return e;
                      }),
                      (e.copy = function(t) {
                        for (var e = 0; e < 15; e++)
                          this.rows[e].copy(t.rows[e]);
                      }),
                      (e.isEmpty = function() {
                        for (var t = !0, e = 0; e < 15; e++)
                          if (!this.rows[e].isEmpty()) {
                            t = !1;
                            break;
                          }
                        return t;
                      }),
                      (e.backSpace = function() {
                        this.rows[this.currRow].backSpace();
                      }),
                      (e.clearToEndOfRow = function() {
                        this.rows[this.currRow].clearToEndOfRow();
                      }),
                      (e.insertChar = function(t) {
                        this.rows[this.currRow].insertChar(t);
                      }),
                      (e.setPen = function(t) {
                        this.rows[this.currRow].setPenStyles(t);
                      }),
                      (e.moveCursor = function(t) {
                        this.rows[this.currRow].moveCursor(t);
                      }),
                      (e.setCursor = function(t) {
                        this.logger.log(s.INFO, 'setCursor: ' + t),
                          this.rows[this.currRow].setCursor(t);
                      }),
                      (e.setPAC = function(t) {
                        this.logger.log(
                          s.INFO,
                          'pacData = ' + JSON.stringify(t),
                        );
                        var e = t.row - 1;
                        if (
                          (this.nrRollUpRows &&
                            e < this.nrRollUpRows - 1 &&
                            (e = this.nrRollUpRows - 1),
                          this.nrRollUpRows && this.currRow !== e)
                        ) {
                          for (var r = 0; r < 15; r++) this.rows[r].clear();
                          var n = this.currRow + 1 - this.nrRollUpRows,
                            i = this.lastOutputScreen;
                          if (i) {
                            var a = i.rows[n].cueStartTime,
                              o = this.logger.time;
                            if (a && null !== o && a < o)
                              for (var u = 0; u < this.nrRollUpRows; u++)
                                this.rows[e - this.nrRollUpRows + u + 1].copy(
                                  i.rows[n + u],
                                );
                          }
                        }
                        this.currRow = e;
                        var l = this.rows[this.currRow];
                        if (null !== t.indent) {
                          var c = t.indent,
                            h = Math.max(c - 1, 0);
                          l.setCursor(t.indent),
                            (t.color = l.chars[h].penState.foreground);
                        }
                        var d = {
                          foreground: t.color,
                          underline: t.underline,
                          italics: t.italics,
                          background: 'black',
                          flash: !1,
                        };
                        this.setPen(d);
                      }),
                      (e.setBkgData = function(t) {
                        this.logger.log(
                          s.INFO,
                          'bkgData = ' + JSON.stringify(t),
                        ),
                          this.backSpace(),
                          this.setPen(t),
                          this.insertChar(32);
                      }),
                      (e.setRollUpRows = function(t) {
                        this.nrRollUpRows = t;
                      }),
                      (e.rollUp = function() {
                        if (null !== this.nrRollUpRows) {
                          this.logger.log(s.TEXT, this.getDisplayText());
                          var t = this.currRow + 1 - this.nrRollUpRows,
                            e = this.rows.splice(t, 1)[0];
                          e.clear(),
                            this.rows.splice(this.currRow, 0, e),
                            this.logger.log(s.INFO, 'Rolling up');
                        } else
                          this.logger.log(
                            s.DEBUG,
                            'roll_up but nrRollUpRows not set yet',
                          );
                      }),
                      (e.getDisplayText = function(t) {
                        t = t || !1;
                        for (var e = [], r = '', n = -1, i = 0; i < 15; i++) {
                          var s = this.rows[i].getTextString();
                          s &&
                            ((n = i + 1),
                            t
                              ? e.push('Row ' + n + ": '" + s + "'")
                              : e.push(s.trim()));
                        }
                        return (
                          e.length > 0 &&
                            (r = t ? '[' + e.join(' | ') + ']' : e.join('\n')),
                          r
                        );
                      }),
                      (e.getTextAndFormat = function() {
                        return this.rows;
                      }),
                      t
                    );
                  })(),
                  E = (function() {
                    function t(t, e, r) {
                      (this.chNr = void 0),
                        (this.outputFilter = void 0),
                        (this.mode = void 0),
                        (this.verbose = void 0),
                        (this.displayedMemory = void 0),
                        (this.nonDisplayedMemory = void 0),
                        (this.lastOutputScreen = void 0),
                        (this.currRollUpRow = void 0),
                        (this.writeScreen = void 0),
                        (this.cueStartTime = void 0),
                        (this.logger = void 0),
                        (this.chNr = t),
                        (this.outputFilter = e),
                        (this.mode = null),
                        (this.verbose = 0),
                        (this.displayedMemory = new b(r)),
                        (this.nonDisplayedMemory = new b(r)),
                        (this.lastOutputScreen = new b(r)),
                        (this.currRollUpRow = this.displayedMemory.rows[14]),
                        (this.writeScreen = this.displayedMemory),
                        (this.mode = null),
                        (this.cueStartTime = null),
                        (this.logger = r);
                    }
                    var e = t.prototype;
                    return (
                      (e.reset = function() {
                        (this.mode = null),
                          this.displayedMemory.reset(),
                          this.nonDisplayedMemory.reset(),
                          this.lastOutputScreen.reset(),
                          this.outputFilter.reset(),
                          (this.currRollUpRow = this.displayedMemory.rows[14]),
                          (this.writeScreen = this.displayedMemory),
                          (this.mode = null),
                          (this.cueStartTime = null);
                      }),
                      (e.getHandler = function() {
                        return this.outputFilter;
                      }),
                      (e.setHandler = function(t) {
                        this.outputFilter = t;
                      }),
                      (e.setPAC = function(t) {
                        this.writeScreen.setPAC(t);
                      }),
                      (e.setBkgData = function(t) {
                        this.writeScreen.setBkgData(t);
                      }),
                      (e.setMode = function(t) {
                        t !== this.mode &&
                          ((this.mode = t),
                          this.logger.log(s.INFO, 'MODE=' + t),
                          'MODE_POP-ON' === this.mode
                            ? (this.writeScreen = this.nonDisplayedMemory)
                            : ((this.writeScreen = this.displayedMemory),
                              this.writeScreen.reset()),
                          'MODE_ROLL-UP' !== this.mode &&
                            ((this.displayedMemory.nrRollUpRows = null),
                            (this.nonDisplayedMemory.nrRollUpRows = null)),
                          (this.mode = t));
                      }),
                      (e.insertChars = function(t) {
                        for (var e = 0; e < t.length; e++)
                          this.writeScreen.insertChar(t[e]);
                        var r =
                          this.writeScreen === this.displayedMemory
                            ? 'DISP'
                            : 'NON_DISP';
                        this.logger.log(
                          s.INFO,
                          r + ': ' + this.writeScreen.getDisplayText(!0),
                        ),
                          ('MODE_PAINT-ON' !== this.mode &&
                            'MODE_ROLL-UP' !== this.mode) ||
                            (this.logger.log(
                              s.TEXT,
                              'DISPLAYED: ' +
                                this.displayedMemory.getDisplayText(!0),
                            ),
                            this.outputDataUpdate());
                      }),
                      (e.ccRCL = function() {
                        this.logger.log(s.INFO, 'RCL - Resume Caption Loading'),
                          this.setMode('MODE_POP-ON');
                      }),
                      (e.ccBS = function() {
                        this.logger.log(s.INFO, 'BS - BackSpace'),
                          'MODE_TEXT' !== this.mode &&
                            (this.writeScreen.backSpace(),
                            this.writeScreen === this.displayedMemory &&
                              this.outputDataUpdate());
                      }),
                      (e.ccAOF = function() {}),
                      (e.ccAON = function() {}),
                      (e.ccDER = function() {
                        this.logger.log(s.INFO, 'DER- Delete to End of Row'),
                          this.writeScreen.clearToEndOfRow(),
                          this.outputDataUpdate();
                      }),
                      (e.ccRU = function(t) {
                        this.logger.log(s.INFO, 'RU(' + t + ') - Roll Up'),
                          (this.writeScreen = this.displayedMemory),
                          this.setMode('MODE_ROLL-UP'),
                          this.writeScreen.setRollUpRows(t);
                      }),
                      (e.ccFON = function() {
                        this.logger.log(s.INFO, 'FON - Flash On'),
                          this.writeScreen.setPen({ flash: !0 });
                      }),
                      (e.ccRDC = function() {
                        this.logger.log(
                          s.INFO,
                          'RDC - Resume Direct Captioning',
                        ),
                          this.setMode('MODE_PAINT-ON');
                      }),
                      (e.ccTR = function() {
                        this.logger.log(s.INFO, 'TR'),
                          this.setMode('MODE_TEXT');
                      }),
                      (e.ccRTD = function() {
                        this.logger.log(s.INFO, 'RTD'),
                          this.setMode('MODE_TEXT');
                      }),
                      (e.ccEDM = function() {
                        this.logger.log(s.INFO, 'EDM - Erase Displayed Memory'),
                          this.displayedMemory.reset(),
                          this.outputDataUpdate(!0);
                      }),
                      (e.ccCR = function() {
                        this.logger.log(s.INFO, 'CR - Carriage Return'),
                          this.writeScreen.rollUp(),
                          this.outputDataUpdate(!0);
                      }),
                      (e.ccENM = function() {
                        this.logger.log(
                          s.INFO,
                          'ENM - Erase Non-displayed Memory',
                        ),
                          this.nonDisplayedMemory.reset();
                      }),
                      (e.ccEOC = function() {
                        if (
                          (this.logger.log(s.INFO, 'EOC - End Of Caption'),
                          'MODE_POP-ON' === this.mode)
                        ) {
                          var t = this.displayedMemory;
                          (this.displayedMemory = this.nonDisplayedMemory),
                            (this.nonDisplayedMemory = t),
                            (this.writeScreen = this.nonDisplayedMemory),
                            this.logger.log(
                              s.TEXT,
                              'DISP: ' + this.displayedMemory.getDisplayText(),
                            );
                        }
                        this.outputDataUpdate(!0);
                      }),
                      (e.ccTO = function(t) {
                        this.logger.log(s.INFO, 'TO(' + t + ') - Tab Offset'),
                          this.writeScreen.moveCursor(t);
                      }),
                      (e.ccMIDROW = function(t) {
                        var e = { flash: !1 };
                        if (
                          ((e.underline = t % 2 == 1),
                          (e.italics = t >= 46),
                          e.italics)
                        )
                          e.foreground = 'white';
                        else {
                          var r = Math.floor(t / 2) - 16;
                          e.foreground = [
                            'white',
                            'green',
                            'blue',
                            'cyan',
                            'red',
                            'yellow',
                            'magenta',
                          ][r];
                        }
                        this.logger.log(s.INFO, 'MIDROW: ' + JSON.stringify(e)),
                          this.writeScreen.setPen(e);
                      }),
                      (e.outputDataUpdate = function(t) {
                        void 0 === t && (t = !1);
                        var e = this.logger.time;
                        null !== e &&
                          this.outputFilter &&
                          (null !== this.cueStartTime ||
                          this.displayedMemory.isEmpty()
                            ? this.displayedMemory.equals(
                                this.lastOutputScreen,
                              ) ||
                              (this.outputFilter.newCue(
                                this.cueStartTime,
                                e,
                                this.lastOutputScreen,
                              ),
                              t &&
                                this.outputFilter.dispatchCue &&
                                this.outputFilter.dispatchCue(),
                              (this.cueStartTime = this.displayedMemory.isEmpty()
                                ? null
                                : e))
                            : (this.cueStartTime = e),
                          this.lastOutputScreen.copy(this.displayedMemory));
                      }),
                      (e.cueSplitAtTime = function(t) {
                        this.outputFilter &&
                          (this.displayedMemory.isEmpty() ||
                            (this.outputFilter.newCue &&
                              this.outputFilter.newCue(
                                this.cueStartTime,
                                t,
                                this.displayedMemory,
                              ),
                            (this.cueStartTime = t)));
                      }),
                      t
                    );
                  })(),
                  T = (function() {
                    function t(t, e, r) {
                      (this.channels = void 0),
                        (this.currentChannel = 0),
                        (this.cmdHistory = void 0),
                        (this.logger = void 0);
                      var n = new p();
                      (this.channels = [
                        null,
                        new E(t, e, n),
                        new E(t + 1, r, n),
                      ]),
                        (this.cmdHistory = { a: null, b: null }),
                        (this.logger = n);
                    }
                    var e = t.prototype;
                    return (
                      (e.getHandler = function(t) {
                        return this.channels[t].getHandler();
                      }),
                      (e.setHandler = function(t, e) {
                        this.channels[t].setHandler(e);
                      }),
                      (e.addData = function(t, e) {
                        var r,
                          n,
                          i,
                          a = !1;
                        this.logger.time = t;
                        for (var o = 0; o < e.length; o += 2)
                          if (
                            ((n = 127 & e[o]),
                            (i = 127 & e[o + 1]),
                            0 !== n || 0 !== i)
                          ) {
                            if (
                              (this.logger.log(
                                s.DATA,
                                '[' +
                                  v([e[o], e[o + 1]]) +
                                  '] -> (' +
                                  v([n, i]) +
                                  ')',
                              ),
                              (r = this.parseCmd(n, i)) ||
                                (r = this.parseMidrow(n, i)),
                              r || (r = this.parsePAC(n, i)),
                              r || (r = this.parseBackgroundAttributes(n, i)),
                              !r && (a = this.parseChars(n, i)))
                            ) {
                              var u = this.currentChannel;
                              u && u > 0
                                ? this.channels[u].insertChars(a)
                                : this.logger.log(
                                    s.WARNING,
                                    'No channel found yet. TEXT-MODE?',
                                  );
                            }
                            r ||
                              a ||
                              this.logger.log(
                                s.WARNING,
                                "Couldn't parse cleaned data " +
                                  v([n, i]) +
                                  ' orig: ' +
                                  v([e[o], e[o + 1]]),
                              );
                          }
                      }),
                      (e.parseCmd = function(t, e) {
                        var r = this.cmdHistory;
                        if (
                          !(
                            ((20 === t || 28 === t || 21 === t || 29 === t) &&
                              e >= 32 &&
                              e <= 47) ||
                            ((23 === t || 31 === t) && e >= 33 && e <= 35)
                          )
                        )
                          return !1;
                        if (i(t, e, r))
                          return (
                            n(null, null, r),
                            this.logger.log(
                              s.DEBUG,
                              'Repeated command (' + v([t, e]) + ') is dropped',
                            ),
                            !0
                          );
                        var a = 20 === t || 21 === t || 23 === t ? 1 : 2,
                          o = this.channels[a];
                        return (
                          20 === t || 21 === t || 28 === t || 29 === t
                            ? 32 === e
                              ? o.ccRCL()
                              : 33 === e
                              ? o.ccBS()
                              : 34 === e
                              ? o.ccAOF()
                              : 35 === e
                              ? o.ccAON()
                              : 36 === e
                              ? o.ccDER()
                              : 37 === e
                              ? o.ccRU(2)
                              : 38 === e
                              ? o.ccRU(3)
                              : 39 === e
                              ? o.ccRU(4)
                              : 40 === e
                              ? o.ccFON()
                              : 41 === e
                              ? o.ccRDC()
                              : 42 === e
                              ? o.ccTR()
                              : 43 === e
                              ? o.ccRTD()
                              : 44 === e
                              ? o.ccEDM()
                              : 45 === e
                              ? o.ccCR()
                              : 46 === e
                              ? o.ccENM()
                              : 47 === e && o.ccEOC()
                            : o.ccTO(e - 32),
                          n(t, e, r),
                          (this.currentChannel = a),
                          !0
                        );
                      }),
                      (e.parseMidrow = function(t, e) {
                        var r = 0;
                        if ((17 === t || 25 === t) && e >= 32 && e <= 47) {
                          if ((r = 17 === t ? 1 : 2) !== this.currentChannel)
                            return (
                              this.logger.log(
                                s.ERROR,
                                'Mismatch channel in midrow parsing',
                              ),
                              !1
                            );
                          var n = this.channels[r];
                          return (
                            !!n &&
                            (n.ccMIDROW(e),
                            this.logger.log(
                              s.DEBUG,
                              'MIDROW (' + v([t, e]) + ')',
                            ),
                            !0)
                          );
                        }
                        return !1;
                      }),
                      (e.parsePAC = function(t, e) {
                        var r,
                          s = this.cmdHistory;
                        if (
                          !(
                            (((t >= 17 && t <= 23) || (t >= 25 && t <= 31)) &&
                              e >= 64 &&
                              e <= 127) ||
                            ((16 === t || 24 === t) && e >= 64 && e <= 95)
                          )
                        )
                          return !1;
                        if (i(t, e, s)) return n(null, null, s), !0;
                        var a = t <= 23 ? 1 : 2;
                        r =
                          e >= 64 && e <= 95
                            ? 1 === a
                              ? l[t]
                              : h[t]
                            : 1 === a
                            ? c[t]
                            : d[t];
                        var o = this.channels[a];
                        return (
                          !!o &&
                          (o.setPAC(this.interpretPAC(r, e)),
                          n(t, e, s),
                          (this.currentChannel = a),
                          !0)
                        );
                      }),
                      (e.interpretPAC = function(t, e) {
                        var r,
                          n = {
                            color: null,
                            italics: !1,
                            indent: null,
                            underline: !1,
                            row: t,
                          };
                        return (
                          (r = e > 95 ? e - 96 : e - 64),
                          (n.underline = 1 == (1 & r)),
                          r <= 13
                            ? (n.color = [
                                'white',
                                'green',
                                'blue',
                                'cyan',
                                'red',
                                'yellow',
                                'magenta',
                                'white',
                              ][Math.floor(r / 2)])
                            : r <= 15
                            ? ((n.italics = !0), (n.color = 'white'))
                            : (n.indent = 4 * Math.floor((r - 16) / 2)),
                          n
                        );
                      }),
                      (e.parseChars = function(t, e) {
                        var r,
                          i,
                          a = null,
                          o = null;
                        if (
                          (t >= 25
                            ? ((r = 2), (o = t - 8))
                            : ((r = 1), (o = t)),
                          o >= 17 && o <= 19
                            ? ((i =
                                17 === o
                                  ? e + 80
                                  : 18 === o
                                  ? e + 112
                                  : e + 144),
                              this.logger.log(
                                s.INFO,
                                "Special char '" + u(i) + "' in channel " + r,
                              ),
                              (a = [i]))
                            : t >= 32 &&
                              t <= 127 &&
                              (a = 0 === e ? [t] : [t, e]),
                          a)
                        ) {
                          var l = v(a);
                          this.logger.log(
                            s.DEBUG,
                            'Char codes =  ' + l.join(','),
                          ),
                            n(t, e, this.cmdHistory);
                        }
                        return a;
                      }),
                      (e.parseBackgroundAttributes = function(t, e) {
                        var r;
                        if (
                          !(
                            ((16 === t || 24 === t) && e >= 32 && e <= 47) ||
                            ((23 === t || 31 === t) && e >= 45 && e <= 47)
                          )
                        )
                          return !1;
                        var i = {};
                        16 === t || 24 === t
                          ? ((r = Math.floor((e - 32) / 2)),
                            (i.background = f[r]),
                            e % 2 == 1 &&
                              (i.background = i.background + '_semi'))
                          : 45 === e
                          ? (i.background = 'transparent')
                          : ((i.foreground = 'black'),
                            47 === e && (i.underline = !0));
                        var s = t <= 23 ? 1 : 2;
                        return (
                          this.channels[s].setBkgData(i),
                          n(t, e, this.cmdHistory),
                          !0
                        );
                      }),
                      (e.reset = function() {
                        for (
                          var t = 0;
                          t < Object.keys(this.channels).length;
                          t++
                        ) {
                          var e = this.channels[t];
                          e && e.reset();
                        }
                        this.cmdHistory = { a: null, b: null };
                      }),
                      (e.cueSplitAtTime = function(t) {
                        for (var e = 0; e < this.channels.length; e++) {
                          var r = this.channels[e];
                          r && r.cueSplitAtTime(t);
                        }
                      }),
                      t
                    );
                  })();
                e.default = T;
              },
              './src/utils/codecs.ts': function(t, e, r) {
                function n(t, e) {
                  var r = s[e];
                  return !!r && !0 === r[t.slice(0, 4)];
                }
                function i(t, e) {
                  return MediaSource.isTypeSupported(
                    (e || 'video') + '/mp4;codecs="' + t + '"',
                  );
                }
                r.r(e),
                  r.d(e, 'isCodecType', function() {
                    return n;
                  }),
                  r.d(e, 'isCodecSupportedInMp4', function() {
                    return i;
                  });
                var s = {
                  audio: {
                    a3ds: !0,
                    'ac-3': !0,
                    'ac-4': !0,
                    alac: !0,
                    alaw: !0,
                    dra1: !0,
                    'dts+': !0,
                    'dts-': !0,
                    dtsc: !0,
                    dtse: !0,
                    dtsh: !0,
                    'ec-3': !0,
                    enca: !0,
                    g719: !0,
                    g726: !0,
                    m4ae: !0,
                    mha1: !0,
                    mha2: !0,
                    mhm1: !0,
                    mhm2: !0,
                    mlpa: !0,
                    mp4a: !0,
                    'raw ': !0,
                    Opus: !0,
                    samr: !0,
                    sawb: !0,
                    sawp: !0,
                    sevc: !0,
                    sqcp: !0,
                    ssmv: !0,
                    twos: !0,
                    ulaw: !0,
                  },
                  video: {
                    avc1: !0,
                    avc2: !0,
                    avc3: !0,
                    avc4: !0,
                    avcp: !0,
                    av01: !0,
                    drac: !0,
                    dva1: !0,
                    dvav: !0,
                    dvh1: !0,
                    dvhe: !0,
                    encv: !0,
                    hev1: !0,
                    hvc1: !0,
                    mjp2: !0,
                    mp4v: !0,
                    mvc1: !0,
                    mvc2: !0,
                    mvc3: !0,
                    mvc4: !0,
                    resv: !0,
                    rv60: !0,
                    s263: !0,
                    svc1: !0,
                    svc2: !0,
                    'vc-1': !0,
                    vp08: !0,
                    vp09: !0,
                  },
                  text: { stpp: !0, wvtt: !0 },
                };
              },
              './src/utils/cues.ts': function(t, e, r) {
                r.r(e);
                var n = r('./src/utils/vttparser.ts'),
                  i = r('./src/utils/webvtt-parser.ts'),
                  s = r('./src/utils/texttrack-utils.ts'),
                  a = /\s/,
                  o = {
                    newCue: function(t, e, r, o) {
                      for (
                        var u,
                          l,
                          c,
                          h,
                          d,
                          f = [],
                          p = self.VTTCue || self.TextTrackCue,
                          v = 0;
                        v < o.rows.length;
                        v++
                      )
                        if (
                          ((c = !0),
                          (h = 0),
                          (d = ''),
                          !(u = o.rows[v]).isEmpty())
                        ) {
                          for (var g = 0; g < u.chars.length; g++)
                            a.test(u.chars[g].uchar) && c
                              ? h++
                              : ((d += u.chars[g].uchar), (c = !1));
                          (u.cueStartTime = e),
                            e === r && (r += 1e-4),
                            h >= 16 ? h-- : h++;
                          var m = Object(n.fixLineBreaks)(d.trim()),
                            y = Object(i.generateCueId)(e, r, m);
                          (t && t.cues && t.cues.getCueById(y)) ||
                            (((l = new p(e, r, m)).id = y),
                            (l.line = v + 1),
                            (l.align = 'left'),
                            (l.position =
                              10 + Math.min(80, 10 * Math.floor((8 * h) / 32))),
                            f.push(l));
                        }
                      return (
                        t &&
                          f.length &&
                          (f.sort(function(t, e) {
                            return 'auto' === t.line || 'auto' === e.line
                              ? 0
                              : t.line > 8 && e.line > 8
                              ? e.line - t.line
                              : t.line - e.line;
                          }),
                          f.forEach(function(e) {
                            return Object(s.addCueToTrack)(t, e);
                          })),
                        f
                      );
                    },
                  };
                e.default = o;
              },
              './src/utils/discontinuities.ts': function(t, e, r) {
                function n(t, e) {
                  for (var r = null, n = 0, i = t.length; n < i; n++) {
                    var s = t[n];
                    if (s && s.cc === e) {
                      r = s;
                      break;
                    }
                  }
                  return r;
                }
                function i(t, e, r) {
                  return !(
                    !e.details ||
                    !(r.endCC > r.startCC || (t && t.cc < r.startCC))
                  );
                }
                function s(t, e) {
                  var r = t.fragments,
                    i = e.fragments;
                  if (i.length && r.length) {
                    var s = n(r, i[0].cc);
                    if (s && (!s || s.startPTS)) return s;
                    f.logger.log('No frag in previous level to align on');
                  } else f.logger.log('No fragments to align');
                }
                function a(t, e) {
                  if (t) {
                    var r = t.start + e;
                    (t.start = t.startPTS = r), (t.endPTS = r + t.duration);
                  }
                }
                function o(t, e) {
                  for (var r = e.fragments, n = 0, i = r.length; n < i; n++)
                    a(r[n], t);
                  e.fragmentHint && a(e.fragmentHint, t),
                    (e.alignedSliding = !0);
                }
                function u(t, e, r) {
                  e &&
                    ((function(t, e, r) {
                      if (i(t, r, e)) {
                        var n = s(r.details, e);
                        n &&
                          Object(d.isFiniteNumber)(n.start) &&
                          (f.logger.log(
                            'Adjusting PTS using last level due to CC increase within current level ' +
                              e.url,
                          ),
                          o(n.start, e));
                      }
                    })(t, r, e),
                    !r.alignedSliding && e.details && l(r, e.details),
                    r.alignedSliding ||
                      !e.details ||
                      r.skippedSegments ||
                      Object(p.adjustSliding)(e.details, r));
                }
                function l(t, e) {
                  if (
                    e.fragments.length &&
                    t.hasProgramDateTime &&
                    e.hasProgramDateTime
                  ) {
                    var r = e.fragments[0].programDateTime,
                      n = t.fragments[0].programDateTime,
                      i = (n - r) / 1e3 + e.fragments[0].start;
                    i &&
                      Object(d.isFiniteNumber)(i) &&
                      (f.logger.log(
                        'Adjusting PTS using programDateTime delta ' +
                          (n - r) +
                          'ms, sliding:' +
                          i.toFixed(3) +
                          ' ' +
                          t.url +
                          ' ',
                      ),
                      o(i, t));
                  }
                }
                function c(t, e) {
                  var r = t.programDateTime;
                  if (r) {
                    var n = (r - e) / 1e3;
                    (t.start = t.startPTS = n), (t.endPTS = n + t.duration);
                  }
                }
                function h(t, e) {
                  if (
                    e.fragments.length &&
                    t.hasProgramDateTime &&
                    e.hasProgramDateTime
                  ) {
                    var r =
                      e.fragments[0].programDateTime -
                      1e3 * e.fragments[0].start;
                    t.fragments.forEach(function(t) {
                      c(t, r);
                    }),
                      t.fragmentHint && c(t.fragmentHint, r),
                      (t.alignedSliding = !0);
                  }
                }
                r.r(e),
                  r.d(e, 'findFirstFragWithCC', function() {
                    return n;
                  }),
                  r.d(e, 'shouldAlignOnDiscontinuities', function() {
                    return i;
                  }),
                  r.d(e, 'findDiscontinuousReferenceFrag', function() {
                    return s;
                  }),
                  r.d(e, 'adjustSlidingStart', function() {
                    return o;
                  }),
                  r.d(e, 'alignStream', function() {
                    return u;
                  }),
                  r.d(e, 'alignPDT', function() {
                    return l;
                  }),
                  r.d(e, 'alignFragmentByPDTDelta', function() {
                    return c;
                  }),
                  r.d(e, 'alignMediaPlaylistByPDT', function() {
                    return h;
                  });
                var d = r('./src/polyfills/number.ts'),
                  f = r('./src/utils/logger.ts'),
                  p = r('./src/controller/level-helper.ts');
              },
              './src/utils/ewma-bandwidth-estimator.ts': function(t, e, r) {
                r.r(e);
                var n = r('./src/utils/ewma.ts'),
                  i = (function() {
                    function t(t, e, r) {
                      (this.defaultEstimate_ = void 0),
                        (this.minWeight_ = void 0),
                        (this.minDelayMs_ = void 0),
                        (this.slow_ = void 0),
                        (this.fast_ = void 0),
                        (this.defaultEstimate_ = r),
                        (this.minWeight_ = 0.001),
                        (this.minDelayMs_ = 50),
                        (this.slow_ = new n.default(t)),
                        (this.fast_ = new n.default(e));
                    }
                    var e = t.prototype;
                    return (
                      (e.update = function(t, e) {
                        var r = this.slow_,
                          i = this.fast_;
                        this.slow_.halfLife !== t &&
                          (this.slow_ = new n.default(
                            t,
                            r.getEstimate(),
                            r.getTotalWeight(),
                          )),
                          this.fast_.halfLife !== e &&
                            (this.fast_ = new n.default(
                              e,
                              i.getEstimate(),
                              i.getTotalWeight(),
                            ));
                      }),
                      (e.sample = function(t, e) {
                        var r = (t = Math.max(t, this.minDelayMs_)) / 1e3,
                          n = (8 * e) / r;
                        this.fast_.sample(r, n), this.slow_.sample(r, n);
                      }),
                      (e.canEstimate = function() {
                        var t = this.fast_;
                        return t && t.getTotalWeight() >= this.minWeight_;
                      }),
                      (e.getEstimate = function() {
                        return this.canEstimate()
                          ? Math.min(
                              this.fast_.getEstimate(),
                              this.slow_.getEstimate(),
                            )
                          : this.defaultEstimate_;
                      }),
                      (e.destroy = function() {}),
                      t
                    );
                  })();
                e.default = i;
              },
              './src/utils/ewma.ts': function(t, e, r) {
                r.r(e);
                var n = (function() {
                  function t(t, e, r) {
                    void 0 === e && (e = 0),
                      void 0 === r && (r = 0),
                      (this.halfLife = void 0),
                      (this.alpha_ = void 0),
                      (this.estimate_ = void 0),
                      (this.totalWeight_ = void 0),
                      (this.halfLife = t),
                      (this.alpha_ = t ? Math.exp(Math.log(0.5) / t) : 0),
                      (this.estimate_ = e),
                      (this.totalWeight_ = r);
                  }
                  var e = t.prototype;
                  return (
                    (e.sample = function(t, e) {
                      var r = Math.pow(this.alpha_, t);
                      (this.estimate_ = e * (1 - r) + r * this.estimate_),
                        (this.totalWeight_ += t);
                    }),
                    (e.getTotalWeight = function() {
                      return this.totalWeight_;
                    }),
                    (e.getEstimate = function() {
                      if (this.alpha_) {
                        var t = 1 - Math.pow(this.alpha_, this.totalWeight_);
                        if (t) return this.estimate_ / t;
                      }
                      return this.estimate_;
                    }),
                    t
                  );
                })();
                e.default = n;
              },
              './src/utils/fetch-loader.ts': function(t, e, r) {
                function n(t) {
                  var e = 'function' == typeof Map ? new Map() : void 0;
                  return (n = function(t) {
                    function r() {
                      return i(t, arguments, o(this).constructor);
                    }
                    if (
                      null === t ||
                      ((n = t),
                      -1 === Function.toString.call(n).indexOf('[native code]'))
                    )
                      return t;
                    var n;
                    if ('function' != typeof t)
                      throw new TypeError(
                        'Super expression must either be null or a function',
                      );
                    if (void 0 !== e) {
                      if (e.has(t)) return e.get(t);
                      e.set(t, r);
                    }
                    return (
                      (r.prototype = Object.create(t.prototype, {
                        constructor: {
                          value: r,
                          enumerable: !1,
                          writable: !0,
                          configurable: !0,
                        },
                      })),
                      a(r, t)
                    );
                  })(t);
                }
                function i(t, e, r) {
                  return (i = s()
                    ? Reflect.construct.bind()
                    : function(t, e, r) {
                        var n = [null];
                        n.push.apply(n, e);
                        var i = new (Function.bind.apply(t, n))();
                        return r && a(i, r.prototype), i;
                      }).apply(null, arguments);
                }
                function s() {
                  if ('undefined' == typeof Reflect || !Reflect.construct)
                    return !1;
                  if (Reflect.construct.sham) return !1;
                  if ('function' == typeof Proxy) return !0;
                  try {
                    return (
                      Boolean.prototype.valueOf.call(
                        Reflect.construct(Boolean, [], function() {}),
                      ),
                      !0
                    );
                  } catch (t) {
                    return !1;
                  }
                }
                function a(t, e) {
                  return (a = Object.setPrototypeOf
                    ? Object.setPrototypeOf.bind()
                    : function(t, e) {
                        return (t.__proto__ = e), t;
                      })(t, e);
                }
                function o(t) {
                  return (o = Object.setPrototypeOf
                    ? Object.getPrototypeOf.bind()
                    : function(t) {
                        return t.__proto__ || Object.getPrototypeOf(t);
                      })(t);
                }
                function u() {
                  return (u = Object.assign
                    ? Object.assign.bind()
                    : function(t) {
                        for (var e = 1; e < arguments.length; e++) {
                          var r = arguments[e];
                          for (var n in r)
                            Object.prototype.hasOwnProperty.call(r, n) &&
                              (t[n] = r[n]);
                        }
                        return t;
                      }).apply(this, arguments);
                }
                function l() {
                  if (
                    self.fetch &&
                    self.AbortController &&
                    self.ReadableStream &&
                    self.Request
                  )
                    try {
                      return new self.ReadableStream({}), !0;
                    } catch (t) {}
                  return !1;
                }
                function c(t, e) {
                  return new self.Request(t.url, e);
                }
                r.r(e),
                  r.d(e, 'fetchSupported', function() {
                    return l;
                  });
                var h = r('./src/polyfills/number.ts'),
                  d = r('./src/loader/load-stats.ts'),
                  f = r('./src/demux/chunk-cache.ts'),
                  p = (function() {
                    function t(t) {
                      (this.fetchSetup = void 0),
                        (this.requestTimeout = void 0),
                        (this.request = void 0),
                        (this.response = void 0),
                        (this.controller = void 0),
                        (this.context = void 0),
                        (this.config = null),
                        (this.callbacks = null),
                        (this.stats = void 0),
                        (this.loader = null),
                        (this.fetchSetup = t.fetchSetup || c),
                        (this.controller = new self.AbortController()),
                        (this.stats = new d.LoadStats());
                    }
                    var e = t.prototype;
                    return (
                      (e.destroy = function() {
                        (this.loader = this.callbacks = null),
                          this.abortInternal();
                      }),
                      (e.abortInternal = function() {
                        var t = this.response;
                        (t && t.ok) ||
                          ((this.stats.aborted = !0), this.controller.abort());
                      }),
                      (e.abort = function() {
                        var t;
                        this.abortInternal(),
                          null !== (t = this.callbacks) &&
                            void 0 !== t &&
                            t.onAbort &&
                            this.callbacks.onAbort(
                              this.stats,
                              this.context,
                              this.response,
                            );
                      }),
                      (e.load = function(t, e, r) {
                        var n = this,
                          i = this.stats;
                        if (i.loading.start)
                          throw new Error('Loader can only be used once.');
                        i.loading.start = self.performance.now();
                        var s = (function(t, e) {
                            var r = {
                              method: 'GET',
                              mode: 'cors',
                              credentials: 'same-origin',
                              signal: e,
                              headers: new self.Headers(u({}, t.headers)),
                            };
                            return (
                              t.rangeEnd &&
                                r.headers.set(
                                  'Range',
                                  'bytes=' +
                                    t.rangeStart +
                                    '-' +
                                    String(t.rangeEnd - 1),
                                ),
                              r
                            );
                          })(t, this.controller.signal),
                          a = r.onProgress,
                          o = 'arraybuffer' === t.responseType,
                          l = o ? 'byteLength' : 'length';
                        (this.context = t),
                          (this.config = e),
                          (this.callbacks = r),
                          (this.request = this.fetchSetup(t, s)),
                          self.clearTimeout(this.requestTimeout),
                          (this.requestTimeout = self.setTimeout(function() {
                            n.abortInternal(), r.onTimeout(i, t, n.response);
                          }, e.timeout)),
                          self
                            .fetch(this.request)
                            .then(function(r) {
                              if (((n.response = n.loader = r), !r.ok)) {
                                var s = r.status,
                                  u = r.statusText;
                                throw new v(
                                  u || 'fetch, bad network response',
                                  s,
                                  r,
                                );
                              }
                              return (
                                (i.loading.first = Math.max(
                                  self.performance.now(),
                                  i.loading.start,
                                )),
                                (i.total = parseInt(
                                  r.headers.get('Content-Length') || '0',
                                )),
                                a && Object(h.isFiniteNumber)(e.highWaterMark)
                                  ? n.loadProgressively(
                                      r,
                                      i,
                                      t,
                                      e.highWaterMark,
                                      a,
                                    )
                                  : o
                                  ? r.arrayBuffer()
                                  : r.text()
                              );
                            })
                            .then(function(s) {
                              var o = n.response;
                              self.clearTimeout(n.requestTimeout),
                                (i.loading.end = Math.max(
                                  self.performance.now(),
                                  i.loading.first,
                                )),
                                (i.loaded = i.total = s[l]);
                              var u = { url: o.url, data: s };
                              a &&
                                !Object(h.isFiniteNumber)(e.highWaterMark) &&
                                a(i, t, s, o),
                                r.onSuccess(u, i, t, o);
                            })
                            .catch(function(e) {
                              if (
                                (self.clearTimeout(n.requestTimeout),
                                !i.aborted)
                              ) {
                                var s = (e && e.code) || 0,
                                  a = e ? e.message : null;
                                r.onError(
                                  { code: s, text: a },
                                  t,
                                  e ? e.details : null,
                                );
                              }
                            });
                      }),
                      (e.getCacheAge = function() {
                        var t = null;
                        if (this.response) {
                          var e = this.response.headers.get('age');
                          t = e ? parseFloat(e) : null;
                        }
                        return t;
                      }),
                      (e.loadProgressively = function(t, e, r, n, i) {
                        void 0 === n && (n = 0);
                        var s = new f.default(),
                          a = t.body.getReader();
                        return (function o() {
                          return a
                            .read()
                            .then(function(a) {
                              if (a.done)
                                return (
                                  s.dataLength && i(e, r, s.flush(), t),
                                  Promise.resolve(new ArrayBuffer(0))
                                );
                              var u = a.value,
                                l = u.length;
                              return (
                                (e.loaded += l),
                                l < n || s.dataLength
                                  ? (s.push(u),
                                    s.dataLength >= n && i(e, r, s.flush(), t))
                                  : i(e, r, u, t),
                                o()
                              );
                            })
                            .catch(function() {
                              return Promise.reject();
                            });
                        })();
                      }),
                      t
                    );
                  })(),
                  v = (function(t) {
                    function e(e, r, n) {
                      var i;
                      return (
                        ((i = t.call(this, e) || this).code = void 0),
                        (i.details = void 0),
                        (i.code = r),
                        (i.details = n),
                        i
                      );
                    }
                    var r, n;
                    return (
                      (n = t),
                      ((r = e).prototype = Object.create(n.prototype)),
                      (r.prototype.constructor = r),
                      a(r, n),
                      e
                    );
                  })(n(Error));
                e.default = p;
              },
              './src/utils/imsc1-ttml-parser.ts': function(t, e, r) {
                function n() {
                  return (n = Object.assign
                    ? Object.assign.bind()
                    : function(t) {
                        for (var e = 1; e < arguments.length; e++) {
                          var r = arguments[e];
                          for (var n in r)
                            Object.prototype.hasOwnProperty.call(r, n) &&
                              (t[n] = r[n]);
                        }
                        return t;
                      }).apply(this, arguments);
                }
                function i(t, e, r, i, h) {
                  var g = Object(c.findBox)(new Uint8Array(t), ['mdat']);
                  if (0 !== g.length) {
                    var m = g.map(function(t) {
                        return Object(f.utf8ArrayToStr)(t);
                      }),
                      y = Object(p.toTimescaleFromScale)(e, 1, r);
                    try {
                      m.forEach(function(t) {
                        return i(
                          (function(t, e) {
                            var r = new DOMParser()
                              .parseFromString(t, 'text/xml')
                              .getElementsByTagName('tt')[0];
                            if (!r) throw new Error('Invalid ttml');
                            var i = {
                                frameRate: 30,
                                subFrameRate: 1,
                                frameRateMultiplier: 0,
                                tickRate: 0,
                              },
                              c = Object.keys(i).reduce(function(t, e) {
                                return (
                                  (t[e] = r.getAttribute('ttp:' + e) || i[e]), t
                                );
                              }, {}),
                              h = 'preserve' !== r.getAttribute('xml:space'),
                              f = a(s(r, 'styling', 'style')),
                              p = a(s(r, 'layout', 'region')),
                              g = s(r, 'body', '[begin]');
                            return [].map
                              .call(g, function(t) {
                                var r = (function t(e, r) {
                                  return [].slice
                                    .call(e.childNodes)
                                    .reduce(function(e, n, i) {
                                      var s;
                                      return 'br' === n.nodeName && i
                                        ? e + '\n'
                                        : null !== (s = n.childNodes) &&
                                          void 0 !== s &&
                                          s.length
                                        ? t(n, r)
                                        : r
                                        ? e +
                                          n.textContent
                                            .trim()
                                            .replace(/\s+/g, ' ')
                                        : e + n.textContent;
                                    }, '');
                                })(t, h);
                                if (!r || !t.hasAttribute('begin')) return null;
                                var i = l(t.getAttribute('begin'), c),
                                  s = l(t.getAttribute('dur'), c),
                                  a = l(t.getAttribute('end'), c);
                                if (null === i) throw u(t);
                                if (null === a) {
                                  if (null === s) throw u(t);
                                  a = i + s;
                                }
                                var g = new d.default(i - e, a - e, r);
                                g.id = Object(v.generateCueId)(
                                  g.startTime,
                                  g.endTime,
                                  g.text,
                                );
                                var m = p[t.getAttribute('region')],
                                  y = f[t.getAttribute('style')];
                                (g.position = 10), (g.size = 80);
                                var E = (function(t, e, r) {
                                    var n = 'http://www.w3.org/ns/ttml#styling',
                                      i = null,
                                      s =
                                        null != t && t.hasAttribute('style')
                                          ? t.getAttribute('style')
                                          : null;
                                    return (
                                      s && r.hasOwnProperty(s) && (i = r[s]),
                                      [
                                        'displayAlign',
                                        'textAlign',
                                        'color',
                                        'backgroundColor',
                                        'fontSize',
                                        'fontFamily',
                                      ].reduce(function(r, s) {
                                        var a =
                                          o(e, n, s) ||
                                          o(t, n, s) ||
                                          o(i, n, s);
                                        return a && (r[s] = a), r;
                                      }, {})
                                    );
                                  })(m, y, f),
                                  T = E.textAlign;
                                if (T) {
                                  var S = b[T];
                                  S && (g.lineAlign = S), (g.align = T);
                                }
                                return n(g, E), g;
                              })
                              .filter(function(t) {
                                return null !== t;
                              });
                          })(t, y),
                        );
                      });
                    } catch (t) {
                      h(t);
                    }
                  } else h(new Error('Could not parse IMSC1 mdat'));
                }
                function s(t, e, r) {
                  var n = t.getElementsByTagName(e)[0];
                  return n ? [].slice.call(n.querySelectorAll(r)) : [];
                }
                function a(t) {
                  return t.reduce(function(t, e) {
                    var r = e.getAttribute('xml:id');
                    return r && (t[r] = e), t;
                  }, {});
                }
                function o(t, e, r) {
                  return t && t.hasAttributeNS(e, r)
                    ? t.getAttributeNS(e, r)
                    : null;
                }
                function u(t) {
                  return new Error('Could not parse ttml timestamp ' + t);
                }
                function l(t, e) {
                  if (!t) return null;
                  var r = Object(h.parseTimeStamp)(t);
                  return (
                    null === r &&
                      (m.test(t)
                        ? (r = (function(t, e) {
                            var r = m.exec(t),
                              n = (0 | r[4]) + (0 | r[5]) / e.subFrameRate;
                            return (
                              3600 * (0 | r[1]) +
                              60 * (0 | r[2]) +
                              (0 | r[3]) +
                              n / e.frameRate
                            );
                          })(t, e))
                        : y.test(t) &&
                          (r = (function(t, e) {
                            var r = y.exec(t),
                              n = Number(r[1]);
                            switch (r[2]) {
                              case 'h':
                                return 3600 * n;
                              case 'm':
                                return 60 * n;
                              case 'ms':
                                return 1e3 * n;
                              case 'f':
                                return n / e.frameRate;
                              case 't':
                                return n / e.tickRate;
                            }
                            return n;
                          })(t, e))),
                    r
                  );
                }
                r.r(e),
                  r.d(e, 'IMSC1_CODEC', function() {
                    return g;
                  }),
                  r.d(e, 'parseIMSC1', function() {
                    return i;
                  });
                var c = r('./src/utils/mp4-tools.ts'),
                  h = r('./src/utils/vttparser.ts'),
                  d = r('./src/utils/vttcue.ts'),
                  f = r('./src/demux/id3.ts'),
                  p = r('./src/utils/timescale-conversion.ts'),
                  v = r('./src/utils/webvtt-parser.ts'),
                  g = 'stpp.ttml.im1t',
                  m = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/,
                  y = /^(\d*(?:\.\d*)?)(h|m|s|ms|f|t)$/,
                  b = {
                    left: 'start',
                    center: 'center',
                    right: 'end',
                    start: 'start',
                    end: 'end',
                  };
              },
              './src/utils/logger.ts': function(t, e, r) {
                function n(t) {
                  var e = self.console[t];
                  return e ? e.bind(self.console, '[' + t + '] >') : s;
                }
                function i(t) {
                  if ((self.console && !0 === t) || 'object' == typeof t) {
                    !(function(t) {
                      for (
                        var e = arguments.length,
                          r = new Array(e > 1 ? e - 1 : 0),
                          i = 1;
                        i < e;
                        i++
                      )
                        r[i - 1] = arguments[i];
                      r.forEach(function(e) {
                        o[e] = t[e] ? t[e].bind(t) : n(e);
                      });
                    })(t, 'debug', 'log', 'info', 'warn', 'error');
                    try {
                      o.log();
                    } catch (t) {
                      o = a;
                    }
                  } else o = a;
                }
                r.r(e),
                  r.d(e, 'enableLogs', function() {
                    return i;
                  }),
                  r.d(e, 'logger', function() {
                    return u;
                  });
                var s = function() {},
                  a = {
                    trace: s,
                    debug: s,
                    log: s,
                    warn: s,
                    info: s,
                    error: s,
                  },
                  o = a,
                  u = a;
              },
              './src/utils/mediakeys-helper.ts': function(t, e, r) {
                var n;
                r.r(e),
                  r.d(e, 'KeySystems', function() {
                    return n;
                  }),
                  r.d(e, 'requestMediaKeySystemAccess', function() {
                    return i;
                  }),
                  (function(t) {
                    (t.WIDEVINE = 'com.widevine.alpha'),
                      (t.PLAYREADY = 'com.microsoft.playready');
                  })(n || (n = {}));
                var i =
                  'undefined' != typeof self &&
                  self.navigator &&
                  self.navigator.requestMediaKeySystemAccess
                    ? self.navigator.requestMediaKeySystemAccess.bind(
                        self.navigator,
                      )
                    : null;
              },
              './src/utils/mediasource-helper.ts': function(t, e, r) {
                function n() {
                  return self.MediaSource || self.WebKitMediaSource;
                }
                r.r(e),
                  r.d(e, 'getMediaSource', function() {
                    return n;
                  });
              },
              './src/utils/mp4-tools.ts': function(t, e, r) {
                function n(t) {
                  return String.fromCharCode.apply(null, t);
                }
                function i(t, e) {
                  var r = (t[e] << 8) | t[e + 1];
                  return r < 0 ? 65536 + r : r;
                }
                function s(t, e) {
                  var r = a(t, e);
                  return r < 0 ? 4294967296 + r : r;
                }
                function a(t, e) {
                  return (
                    (t[e] << 24) | (t[e + 1] << 16) | (t[e + 2] << 8) | t[e + 3]
                  );
                }
                function o(t, e, r) {
                  (t[e] = r >> 24),
                    (t[e + 1] = (r >> 16) & 255),
                    (t[e + 2] = (r >> 8) & 255),
                    (t[e + 3] = 255 & r);
                }
                function u(t, e) {
                  var r = [];
                  if (!e.length) return r;
                  for (var i = t.byteLength, a = 0; a < i; ) {
                    var o = s(t, a),
                      l = o > 1 ? a + o : i;
                    if (n(t.subarray(a + 4, a + 8)) === e[0])
                      if (1 === e.length) r.push(t.subarray(a + 8, l));
                      else {
                        var c = u(t.subarray(a + 8, l), e.slice(1));
                        c.length && A.apply(r, c);
                      }
                    a = l;
                  }
                  return r;
                }
                function l(t) {
                  var e = [],
                    r = t[0],
                    n = 8,
                    a = s(t, n);
                  (n += 4), (n += 0 === r ? 8 : 16), (n += 2);
                  var o = t.length + 0,
                    u = i(t, n);
                  n += 2;
                  for (var l = 0; l < u; l++) {
                    var c = n,
                      h = s(t, c);
                    c += 4;
                    var d = 2147483647 & h;
                    if (1 == (2147483648 & h) >>> 31)
                      return (
                        console.warn(
                          'SIDX has hierarchical references (not supported)',
                        ),
                        null
                      );
                    var f = s(t, c);
                    (c += 4),
                      e.push({
                        referenceSize: d,
                        subsegmentDuration: f,
                        info: { duration: f / a, start: o, end: o + d - 1 },
                      }),
                      (o += d),
                      (n = c += 4);
                  }
                  return {
                    earliestPresentationTime: 0,
                    timescale: a,
                    version: r,
                    referencesCount: u,
                    references: e,
                  };
                }
                function c(t) {
                  for (
                    var e = [], r = u(t, ['moov', 'trak']), i = 0;
                    i < r.length;
                    i++
                  ) {
                    var a = r[i],
                      o = u(a, ['tkhd'])[0];
                    if (o) {
                      var l = o[0],
                        c = 0 === l ? 12 : 20,
                        h = s(o, c),
                        d = u(a, ['mdia', 'mdhd'])[0];
                      if (d) {
                        var f = s(d, (c = 0 === (l = d[0]) ? 12 : 20)),
                          p = u(a, ['mdia', 'hdlr'])[0];
                        if (p) {
                          var v = n(p.subarray(8, 12)),
                            g = {
                              soun: S.ElementaryStreamTypes.AUDIO,
                              vide: S.ElementaryStreamTypes.VIDEO,
                            }[v];
                          if (g) {
                            var m = u(a, ['mdia', 'minf', 'stbl', 'stsd'])[0],
                              y = void 0;
                            m && (y = n(m.subarray(12, 16))),
                              (e[h] = { timescale: f, type: g }),
                              (e[g] = { timescale: f, id: h, codec: y });
                          }
                        }
                      }
                    }
                  }
                  return (
                    u(t, ['moov', 'mvex', 'trex']).forEach(function(t) {
                      var r = s(t, 4),
                        n = e[r];
                      n &&
                        (n.default = { duration: s(t, 12), flags: s(t, 20) });
                    }),
                    e
                  );
                }
                function h(t, e) {
                  return (
                    u(e, ['moof', 'traf']).reduce(function(e, r) {
                      var n = u(r, ['tfdt'])[0],
                        i = n[0],
                        a = u(r, ['tfhd']).reduce(function(e, r) {
                          var a = s(r, 4),
                            o = t[a];
                          if (o) {
                            var u = s(n, 4);
                            1 === i && ((u *= Math.pow(2, 32)), (u += s(n, 8)));
                            var l = u / (o.timescale || 9e4);
                            if (isFinite(l) && (null === e || l < e)) return l;
                          }
                          return e;
                        }, null);
                      return null !== a && isFinite(a) && (null === e || a < e)
                        ? a
                        : e;
                    }, null) || 0
                  );
                }
                function d(t, e) {
                  for (
                    var r = 0, n = 0, i = 0, a = u(t, ['moof', 'traf']), o = 0;
                    o < a.length;
                    o++
                  ) {
                    var c = a[o],
                      h = u(c, ['tfhd'])[0],
                      d = e[s(h, 4)];
                    if (d) {
                      var p = d.default,
                        v = s(h, 0) | (null == p ? void 0 : p.flags),
                        g = null == p ? void 0 : p.duration;
                      8 & v && (g = s(h, 2 & v ? 12 : 8));
                      for (
                        var m = d.timescale || 9e4, y = u(c, ['trun']), b = 0;
                        b < y.length;
                        b++
                      )
                        !(r = f(y[b])) && g && (r = g * s(y[b], 4)),
                          d.type === S.ElementaryStreamTypes.VIDEO
                            ? (n += r / m)
                            : d.type === S.ElementaryStreamTypes.AUDIO &&
                              (i += r / m);
                    }
                  }
                  if (0 === n && 0 === i) {
                    for (
                      var E = 0, T = u(t, ['sidx']), L = 0;
                      L < T.length;
                      L++
                    ) {
                      var _ = l(T[L]);
                      null != _ &&
                        _.references &&
                        (E += _.references.reduce(function(t, e) {
                          return t + e.info.duration || 0;
                        }, 0));
                    }
                    return E;
                  }
                  return n || i;
                }
                function f(t) {
                  var e = s(t, 0),
                    r = 8;
                  1 & e && (r += 4), 4 & e && (r += 4);
                  for (var n = 0, i = s(t, 4), a = 0; a < i; a++)
                    256 & e && ((n += s(t, r)), (r += 4)),
                      512 & e && (r += 4),
                      1024 & e && (r += 4),
                      2048 & e && (r += 4);
                  return n;
                }
                function p(t, e, r) {
                  u(e, ['moof', 'traf']).forEach(function(e) {
                    u(e, ['tfhd']).forEach(function(n) {
                      var i = s(n, 4),
                        a = t[i];
                      if (a) {
                        var l = a.timescale || 9e4;
                        u(e, ['tfdt']).forEach(function(t) {
                          var e = t[0],
                            n = s(t, 4);
                          if (0 === e)
                            (n -= r * l), o(t, 4, (n = Math.max(n, 0)));
                          else {
                            (n *= Math.pow(2, 32)),
                              (n += s(t, 8)),
                              (n -= r * l),
                              (n = Math.max(n, 0));
                            var i = Math.floor(n / (_ + 1)),
                              a = Math.floor(n % (_ + 1));
                            o(t, 4, i), o(t, 8, a);
                          }
                        });
                      }
                    });
                  });
                }
                function v(t) {
                  var e = { valid: null, remainder: null },
                    r = u(t, ['moof']);
                  if (!r) return e;
                  if (r.length < 2) return (e.remainder = t), e;
                  var n = r[r.length - 1];
                  return (
                    (e.valid = Object(T.sliceUint8)(t, 0, n.byteOffset - 8)),
                    (e.remainder = Object(T.sliceUint8)(t, n.byteOffset - 8)),
                    e
                  );
                }
                function g(t, e) {
                  var r = new Uint8Array(t.length + e.length);
                  return r.set(t), r.set(e, t.length), r;
                }
                function m(t, e) {
                  var r = [],
                    n = e.samples,
                    i = e.timescale,
                    o = e.id,
                    l = !1;
                  return (
                    u(n, ['moof']).map(function(c) {
                      var h = c.byteOffset - 8;
                      u(c, ['traf']).map(function(c) {
                        var d = u(c, ['tfdt']).map(function(t) {
                          var e = t[0],
                            r = s(t, 4);
                          return (
                            1 === e && ((r *= Math.pow(2, 32)), (r += s(t, 8))),
                            r / i
                          );
                        })[0];
                        return (
                          void 0 !== d && (t = d),
                          u(c, ['tfhd']).map(function(d) {
                            var f = s(d, 4),
                              p = 16777215 & s(d, 0),
                              v = 0,
                              g = 0 != (16 & p),
                              m = 0,
                              E = 0 != (32 & p),
                              T = 8;
                            f === o &&
                              (0 != (1 & p) && (T += 8),
                              0 != (2 & p) && (T += 4),
                              0 != (8 & p) && ((v = s(d, T)), (T += 4)),
                              g && ((m = s(d, T)), (T += 4)),
                              E && (T += 4),
                              'video' === e.type &&
                                (l = (function(t) {
                                  if (!t) return !1;
                                  var e = t.indexOf('.'),
                                    r = e < 0 ? t : t.substring(0, e);
                                  return (
                                    'hvc1' === r ||
                                    'hev1' === r ||
                                    'dvh1' === r ||
                                    'dvhe' === r
                                  );
                                })(e.codec)),
                              u(c, ['trun']).map(function(o) {
                                var u = o[0],
                                  c = 16777215 & s(o, 0),
                                  d = 0 != (1 & c),
                                  f = 0,
                                  p = 0 != (4 & c),
                                  g = 0 != (256 & c),
                                  E = 0,
                                  T = 0 != (512 & c),
                                  L = 0,
                                  _ = 0 != (1024 & c),
                                  A = 0 != (2048 & c),
                                  D = 0,
                                  w = s(o, 4),
                                  k = 8;
                                d && ((f = s(o, k)), (k += 4)), p && (k += 4);
                                for (var R = f + h, O = 0; O < w; O++) {
                                  if (
                                    (g ? ((E = s(o, k)), (k += 4)) : (E = v),
                                    T ? ((L = s(o, k)), (k += 4)) : (L = m),
                                    _ && (k += 4),
                                    A &&
                                      ((D = 0 === u ? s(o, k) : a(o, k)),
                                      (k += 4)),
                                    e.type === S.ElementaryStreamTypes.VIDEO)
                                  )
                                    for (var I = 0; I < L; ) {
                                      var C = s(n, R),
                                        x = 31 & n[(R += 4)];
                                      y(l, x) &&
                                        b(n.subarray(R, R + C), t + D / i, r),
                                        (R += C),
                                        (I += C + 4);
                                    }
                                  t += E / i;
                                }
                              }));
                          })
                        );
                      });
                    }),
                    r
                  );
                }
                function y(t, e) {
                  return t ? 39 === e || 40 === e : 6 === e;
                }
                function b(t, e, r) {
                  var n = (function(t) {
                      for (var e = t.byteLength, r = [], n = 1; n < e - 2; )
                        0 === t[n] && 0 === t[n + 1] && 3 === t[n + 2]
                          ? (r.push(n + 2), (n += 2))
                          : n++;
                      if (0 === r.length) return t;
                      var i = e - r.length,
                        s = new Uint8Array(i),
                        a = 0;
                      for (n = 0; n < i; a++, n++)
                        a === r[0] && (a++, r.shift()), (s[n] = t[a]);
                      return s;
                    })(t),
                    a = 0;
                  a++;
                  for (var o = 0, u = 0, l = !1, c = 0; a < n.length; ) {
                    o = 0;
                    do {
                      if (a >= n.length) break;
                      o += c = n[a++];
                    } while (255 === c);
                    u = 0;
                    do {
                      if (a >= n.length) break;
                      u += c = n[a++];
                    } while (255 === c);
                    var h = n.length - a;
                    if (!l && 4 === o && a < n.length) {
                      if (((l = !0), 181 === n[a++])) {
                        var d = i(n, a);
                        if (((a += 2), 49 === d)) {
                          var f = s(n, a);
                          if (((a += 4), 1195456820 === f)) {
                            var p = n[a++];
                            if (3 === p) {
                              var v = n[a++],
                                g = 64 & v,
                                m = g ? 2 + 3 * (31 & v) : 0,
                                y = new Uint8Array(m);
                              if (g) {
                                y[0] = v;
                                for (var b = 1; b < m; b++) y[b] = n[a++];
                              }
                              r.push({
                                type: p,
                                payloadType: o,
                                pts: e,
                                bytes: y,
                              });
                            }
                          }
                        }
                      }
                    } else if (5 === o && u < h) {
                      if (((l = !0), u > 16)) {
                        for (var E = [], T = 0; T < 16; T++) {
                          var S = n[a++].toString(16);
                          E.push(1 == S.length ? '0' + S : S),
                            (3 !== T && 5 !== T && 7 !== T && 9 !== T) ||
                              E.push('-');
                        }
                        for (
                          var _ = u - 16, A = new Uint8Array(_), D = 0;
                          D < _;
                          D++
                        )
                          A[D] = n[a++];
                        r.push({
                          payloadType: o,
                          pts: e,
                          uuid: E.join(''),
                          userData: Object(L.utf8ArrayToStr)(A),
                          userDataBytes: A,
                        });
                      }
                    } else if (u < h) a += u;
                    else if (u > h) break;
                  }
                }
                function E(t) {
                  var e = t[0],
                    r = '',
                    i = '',
                    a = 0,
                    o = 0,
                    u = 0,
                    l = 0,
                    c = 0,
                    h = 0;
                  if (0 === e) {
                    for (; '\0' !== n(t.subarray(h, h + 1)); )
                      (r += n(t.subarray(h, h + 1))), (h += 1);
                    for (
                      r += n(t.subarray(h, h + 1)), h += 1;
                      '\0' !== n(t.subarray(h, h + 1));

                    )
                      (i += n(t.subarray(h, h + 1))), (h += 1);
                    (i += n(t.subarray(h, h + 1))),
                      (h += 1),
                      (a = s(t, 12)),
                      (o = s(t, 16)),
                      (l = s(t, 20)),
                      (c = s(t, 24)),
                      (h = 28);
                  } else if (1 === e) {
                    a = s(t, (h += 4));
                    var d = s(t, (h += 4)),
                      f = s(t, (h += 4));
                    for (
                      h += 4,
                        u = Math.pow(2, 32) * d + f,
                        Number.isSafeInteger(u) ||
                          ((u = Number.MAX_SAFE_INTEGER),
                          console.warn(
                            'Presentation time exceeds safe integer limit and wrapped to max safe integer in parsing emsg box',
                          )),
                        l = s(t, h),
                        c = s(t, (h += 4)),
                        h += 4;
                      '\0' !== n(t.subarray(h, h + 1));

                    )
                      (r += n(t.subarray(h, h + 1))), (h += 1);
                    for (
                      r += n(t.subarray(h, h + 1)), h += 1;
                      '\0' !== n(t.subarray(h, h + 1));

                    )
                      (i += n(t.subarray(h, h + 1))), (h += 1);
                    (i += n(t.subarray(h, h + 1))), (h += 1);
                  }
                  return {
                    schemeIdUri: r,
                    value: i,
                    timeScale: a,
                    presentationTime: u,
                    presentationTimeDelta: o,
                    eventDuration: l,
                    id: c,
                    payload: t.subarray(h, t.byteLength),
                  };
                }
                r.r(e),
                  r.d(e, 'RemuxerTrackIdConfig', function() {
                    return D;
                  }),
                  r.d(e, 'bin2str', function() {
                    return n;
                  }),
                  r.d(e, 'readUint16', function() {
                    return i;
                  }),
                  r.d(e, 'readUint32', function() {
                    return s;
                  }),
                  r.d(e, 'readSint32', function() {
                    return a;
                  }),
                  r.d(e, 'writeUint32', function() {
                    return o;
                  }),
                  r.d(e, 'findBox', function() {
                    return u;
                  }),
                  r.d(e, 'parseSegmentIndex', function() {
                    return l;
                  }),
                  r.d(e, 'parseInitSegment', function() {
                    return c;
                  }),
                  r.d(e, 'getStartDTS', function() {
                    return h;
                  }),
                  r.d(e, 'getDuration', function() {
                    return d;
                  }),
                  r.d(e, 'computeRawDurationFromSamples', function() {
                    return f;
                  }),
                  r.d(e, 'offsetStartDTS', function() {
                    return p;
                  }),
                  r.d(e, 'segmentValidRange', function() {
                    return v;
                  }),
                  r.d(e, 'appendUint8Array', function() {
                    return g;
                  }),
                  r.d(e, 'parseSamples', function() {
                    return m;
                  }),
                  r.d(e, 'parseSEIMessageFromNALu', function() {
                    return b;
                  }),
                  r.d(e, 'parseEmsg', function() {
                    return E;
                  });
                var T = r('./src/utils/typed-array.ts'),
                  S = r('./src/loader/fragment.ts'),
                  L = r('./src/demux/id3.ts'),
                  _ = Math.pow(2, 32) - 1,
                  A = [].push,
                  D = { video: 1, audio: 2, id3: 3, text: 4 };
              },
              './src/utils/output-filter.ts': function(t, e, r) {
                r.r(e),
                  r.d(e, 'default', function() {
                    return n;
                  });
                var n = (function() {
                  function t(t, e) {
                    (this.timelineController = void 0),
                      (this.cueRanges = []),
                      (this.trackName = void 0),
                      (this.startTime = null),
                      (this.endTime = null),
                      (this.screen = null),
                      (this.timelineController = t),
                      (this.trackName = e);
                  }
                  var e = t.prototype;
                  return (
                    (e.dispatchCue = function() {
                      null !== this.startTime &&
                        (this.timelineController.addCues(
                          this.trackName,
                          this.startTime,
                          this.endTime,
                          this.screen,
                          this.cueRanges,
                        ),
                        (this.startTime = null));
                    }),
                    (e.newCue = function(t, e, r) {
                      (null === this.startTime || this.startTime > t) &&
                        (this.startTime = t),
                        (this.endTime = e),
                        (this.screen = r),
                        this.timelineController.createCaptionsTrack(
                          this.trackName,
                        );
                    }),
                    (e.reset = function() {
                      (this.cueRanges = []), (this.startTime = null);
                    }),
                    t
                  );
                })();
              },
              './src/utils/texttrack-utils.ts': function(t, e, r) {
                function n(t, e) {
                  var r;
                  try {
                    r = new Event('addtrack');
                  } catch (t) {
                    (r = document.createEvent('Event')).initEvent(
                      'addtrack',
                      !1,
                      !1,
                    );
                  }
                  (r.track = t), e.dispatchEvent(r);
                }
                function i(t, e) {
                  var r = t.mode;
                  if (
                    ('disabled' === r && (t.mode = 'hidden'),
                    t.cues && !t.cues.getCueById(e.id))
                  )
                    try {
                      if ((t.addCue(e), !t.cues.getCueById(e.id)))
                        throw new Error('addCue is failed for: ' + e);
                    } catch (r) {
                      u.logger.debug('[texttrack-utils]: ' + r);
                      var n = new self.TextTrackCue(
                        e.startTime,
                        e.endTime,
                        e.text,
                      );
                      (n.id = e.id), t.addCue(n);
                    }
                  'disabled' === r && (t.mode = r);
                }
                function s(t) {
                  var e = t.mode;
                  if (('disabled' === e && (t.mode = 'hidden'), t.cues))
                    for (var r = t.cues.length; r--; ) t.removeCue(t.cues[r]);
                  'disabled' === e && (t.mode = e);
                }
                function a(t, e, r, n) {
                  var i = t.mode;
                  if (
                    ('disabled' === i && (t.mode = 'hidden'),
                    t.cues && t.cues.length > 0)
                  )
                    for (var s = o(t.cues, e, r), a = 0; a < s.length; a++)
                      (n && !n(s[a])) || t.removeCue(s[a]);
                  'disabled' === i && (t.mode = i);
                }
                function o(t, e, r) {
                  var n = [],
                    i = (function(t, e) {
                      if (e < t[0].startTime) return 0;
                      var r = t.length - 1;
                      if (e > t[r].endTime) return -1;
                      for (var n = 0, i = r; n <= i; ) {
                        var s = Math.floor((i + n) / 2);
                        if (e < t[s].startTime) i = s - 1;
                        else {
                          if (!(e > t[s].startTime && n < r)) return s;
                          n = s + 1;
                        }
                      }
                      return t[n].startTime - e < e - t[i].startTime ? n : i;
                    })(t, e);
                  if (i > -1)
                    for (var s = i, a = t.length; s < a; s++) {
                      var o = t[s];
                      if (o.startTime >= e && o.endTime <= r) n.push(o);
                      else if (o.startTime > r) return n;
                    }
                  return n;
                }
                r.r(e),
                  r.d(e, 'sendAddTrackEvent', function() {
                    return n;
                  }),
                  r.d(e, 'addCueToTrack', function() {
                    return i;
                  }),
                  r.d(e, 'clearCurrentCues', function() {
                    return s;
                  }),
                  r.d(e, 'removeCuesInRange', function() {
                    return a;
                  }),
                  r.d(e, 'getCuesInRange', function() {
                    return o;
                  });
                var u = r('./src/utils/logger.ts');
              },
              './src/utils/time-ranges.ts': function(t, e, r) {
                r.r(e),
                  (e.default = {
                    toString: function(t) {
                      for (var e = '', r = t.length, n = 0; n < r; n++)
                        e +=
                          '[' +
                          t.start(n).toFixed(3) +
                          ',' +
                          t.end(n).toFixed(3) +
                          ']';
                      return e;
                    },
                  });
              },
              './src/utils/timescale-conversion.ts': function(t, e, r) {
                function n(t, e, r, n) {
                  void 0 === r && (r = 1), void 0 === n && (n = !1);
                  var i = t * e * r;
                  return n ? Math.round(i) : i;
                }
                function i(t, e, r, i) {
                  return (
                    void 0 === r && (r = 1),
                    void 0 === i && (i = !1),
                    n(t, e, 1 / r, i)
                  );
                }
                function s(t, e) {
                  return void 0 === e && (e = !1), n(t, 1e3, 1 / 9e4, e);
                }
                function a(t, e) {
                  return void 0 === e && (e = 1), n(t, 9e4, 1 / e);
                }
                r.r(e),
                  r.d(e, 'toTimescaleFromBase', function() {
                    return n;
                  }),
                  r.d(e, 'toTimescaleFromScale', function() {
                    return i;
                  }),
                  r.d(e, 'toMsFromMpegTsClock', function() {
                    return s;
                  }),
                  r.d(e, 'toMpegTsClockFromTimescale', function() {
                    return a;
                  });
              },
              './src/utils/typed-array.ts': function(t, e, r) {
                function n(t, e, r) {
                  return Uint8Array.prototype.slice
                    ? t.slice(e, r)
                    : new Uint8Array(Array.prototype.slice.call(t, e, r));
                }
                r.r(e),
                  r.d(e, 'sliceUint8', function() {
                    return n;
                  });
              },
              './src/utils/vttcue.ts': function(t, e, r) {
                r.r(e),
                  (e.default = (function() {
                    function t(t, e) {
                      if ('string' != typeof e) return !1;
                      if (!Array.isArray(t)) return !1;
                      var r = e.toLowerCase();
                      return !!~t.indexOf(r) && r;
                    }
                    function e(e) {
                      return t(s, e);
                    }
                    function r(t) {
                      for (
                        var e = arguments.length,
                          r = new Array(e > 1 ? e - 1 : 0),
                          n = 1;
                        n < e;
                        n++
                      )
                        r[n - 1] = arguments[n];
                      for (var i = 1; i < arguments.length; i++) {
                        var s = arguments[i];
                        for (var a in s) t[a] = s[a];
                      }
                      return t;
                    }
                    function n(n, s, a) {
                      var o = this,
                        u = { enumerable: !0 };
                      o.hasBeenReset = !1;
                      var l = '',
                        c = !1,
                        h = n,
                        d = s,
                        f = a,
                        p = null,
                        v = '',
                        g = !0,
                        m = 'auto',
                        y = 'start',
                        b = 50,
                        E = 'middle',
                        T = 50,
                        S = 'middle';
                      Object.defineProperty(
                        o,
                        'id',
                        r({}, u, {
                          get: function() {
                            return l;
                          },
                          set: function(t) {
                            l = '' + t;
                          },
                        }),
                      ),
                        Object.defineProperty(
                          o,
                          'pauseOnExit',
                          r({}, u, {
                            get: function() {
                              return c;
                            },
                            set: function(t) {
                              c = !!t;
                            },
                          }),
                        ),
                        Object.defineProperty(
                          o,
                          'startTime',
                          r({}, u, {
                            get: function() {
                              return h;
                            },
                            set: function(t) {
                              if ('number' != typeof t)
                                throw new TypeError(
                                  'Start time must be set to a number.',
                                );
                              (h = t), (this.hasBeenReset = !0);
                            },
                          }),
                        ),
                        Object.defineProperty(
                          o,
                          'endTime',
                          r({}, u, {
                            get: function() {
                              return d;
                            },
                            set: function(t) {
                              if ('number' != typeof t)
                                throw new TypeError(
                                  'End time must be set to a number.',
                                );
                              (d = t), (this.hasBeenReset = !0);
                            },
                          }),
                        ),
                        Object.defineProperty(
                          o,
                          'text',
                          r({}, u, {
                            get: function() {
                              return f;
                            },
                            set: function(t) {
                              (f = '' + t), (this.hasBeenReset = !0);
                            },
                          }),
                        ),
                        Object.defineProperty(
                          o,
                          'region',
                          r({}, u, {
                            get: function() {
                              return p;
                            },
                            set: function(t) {
                              (p = t), (this.hasBeenReset = !0);
                            },
                          }),
                        ),
                        Object.defineProperty(
                          o,
                          'vertical',
                          r({}, u, {
                            get: function() {
                              return v;
                            },
                            set: function(e) {
                              var r = (function(e) {
                                return t(i, e);
                              })(e);
                              if (!1 === r)
                                throw new SyntaxError(
                                  'An invalid or illegal string was specified.',
                                );
                              (v = r), (this.hasBeenReset = !0);
                            },
                          }),
                        ),
                        Object.defineProperty(
                          o,
                          'snapToLines',
                          r({}, u, {
                            get: function() {
                              return g;
                            },
                            set: function(t) {
                              (g = !!t), (this.hasBeenReset = !0);
                            },
                          }),
                        ),
                        Object.defineProperty(
                          o,
                          'line',
                          r({}, u, {
                            get: function() {
                              return m;
                            },
                            set: function(t) {
                              if ('number' != typeof t && 'auto' !== t)
                                throw new SyntaxError(
                                  'An invalid number or illegal string was specified.',
                                );
                              (m = t), (this.hasBeenReset = !0);
                            },
                          }),
                        ),
                        Object.defineProperty(
                          o,
                          'lineAlign',
                          r({}, u, {
                            get: function() {
                              return y;
                            },
                            set: function(t) {
                              var r = e(t);
                              if (!r)
                                throw new SyntaxError(
                                  'An invalid or illegal string was specified.',
                                );
                              (y = r), (this.hasBeenReset = !0);
                            },
                          }),
                        ),
                        Object.defineProperty(
                          o,
                          'position',
                          r({}, u, {
                            get: function() {
                              return b;
                            },
                            set: function(t) {
                              if (t < 0 || t > 100)
                                throw new Error(
                                  'Position must be between 0 and 100.',
                                );
                              (b = t), (this.hasBeenReset = !0);
                            },
                          }),
                        ),
                        Object.defineProperty(
                          o,
                          'positionAlign',
                          r({}, u, {
                            get: function() {
                              return E;
                            },
                            set: function(t) {
                              var r = e(t);
                              if (!r)
                                throw new SyntaxError(
                                  'An invalid or illegal string was specified.',
                                );
                              (E = r), (this.hasBeenReset = !0);
                            },
                          }),
                        ),
                        Object.defineProperty(
                          o,
                          'size',
                          r({}, u, {
                            get: function() {
                              return T;
                            },
                            set: function(t) {
                              if (t < 0 || t > 100)
                                throw new Error(
                                  'Size must be between 0 and 100.',
                                );
                              (T = t), (this.hasBeenReset = !0);
                            },
                          }),
                        ),
                        Object.defineProperty(
                          o,
                          'align',
                          r({}, u, {
                            get: function() {
                              return S;
                            },
                            set: function(t) {
                              var r = e(t);
                              if (!r)
                                throw new SyntaxError(
                                  'An invalid or illegal string was specified.',
                                );
                              (S = r), (this.hasBeenReset = !0);
                            },
                          }),
                        ),
                        (o.displayState = void 0);
                    }
                    if ('undefined' != typeof self && self.VTTCue)
                      return self.VTTCue;
                    var i = ['', 'lr', 'rl'],
                      s = ['start', 'middle', 'end', 'left', 'right'];
                    return (
                      (n.prototype.getCueAsHTML = function() {
                        return self.WebVTT.convertCueToDOMTree(self, this.text);
                      }),
                      n
                    );
                  })());
              },
              './src/utils/vttparser.ts': function(t, e, r) {
                function n(t) {
                  function e(t, e, r, n) {
                    return (
                      3600 * (0 | t) +
                      60 * (0 | e) +
                      (0 | r) +
                      parseFloat(n || 0)
                    );
                  }
                  var r = t.match(/^(?:(\d+):)?(\d{2}):(\d{2})(\.\d+)?/);
                  return r
                    ? parseFloat(r[2]) > 59
                      ? e(r[2], r[3], 0, r[4])
                      : e(r[1], r[2], r[3], r[4])
                    : null;
                }
                function i(t, e, r, n) {
                  var i = n ? t.split(n) : [t];
                  for (var s in i)
                    if ('string' == typeof i[s]) {
                      var a = i[s].split(r);
                      2 === a.length && e(a[0], a[1]);
                    }
                }
                function s(t, e, r) {
                  function s() {
                    var e = n(t);
                    if (null === e)
                      throw new Error('Malformed timestamp: ' + o);
                    return (t = t.replace(/^[^\sa-zA-Z-]+/, '')), e;
                  }
                  function a() {
                    t = t.replace(/^\s+/, '');
                  }
                  var o = t;
                  if (
                    (a(), (e.startTime = s()), a(), '--\x3e' !== t.slice(0, 3))
                  )
                    throw new Error(
                      "Malformed time stamp (time stamps must be separated by '--\x3e'): " +
                        o,
                    );
                  (t = t.slice(3)),
                    a(),
                    (e.endTime = s()),
                    a(),
                    (function(t, e) {
                      var n = new l();
                      i(
                        t,
                        function(t, e) {
                          var i;
                          switch (t) {
                            case 'region':
                              for (var s = r.length - 1; s >= 0; s--)
                                if (r[s].id === e) {
                                  n.set(t, r[s].region);
                                  break;
                                }
                              break;
                            case 'vertical':
                              n.alt(t, e, ['rl', 'lr']);
                              break;
                            case 'line':
                              (i = e.split(',')),
                                n.integer(t, i[0]),
                                n.percent(t, i[0]) && n.set('snapToLines', !1),
                                n.alt(t, i[0], ['auto']),
                                2 === i.length &&
                                  n.alt('lineAlign', i[1], ['start', h, 'end']);
                              break;
                            case 'position':
                              (i = e.split(',')),
                                n.percent(t, i[0]),
                                2 === i.length &&
                                  n.alt('positionAlign', i[1], [
                                    'start',
                                    h,
                                    'end',
                                    'line-left',
                                    'line-right',
                                    'auto',
                                  ]);
                              break;
                            case 'size':
                              n.percent(t, e);
                              break;
                            case 'align':
                              n.alt(t, e, ['start', h, 'end', 'left', 'right']);
                          }
                        },
                        /:/,
                        /\s/,
                      ),
                        (e.region = n.get('region', null)),
                        (e.vertical = n.get('vertical', ''));
                      var s = n.get('line', 'auto');
                      'auto' === s && -1 === c.line && (s = -1),
                        (e.line = s),
                        (e.lineAlign = n.get('lineAlign', 'start')),
                        (e.snapToLines = n.get('snapToLines', !0)),
                        (e.size = n.get('size', 100)),
                        (e.align = n.get('align', h));
                      var a = n.get('position', 'auto');
                      'auto' === a &&
                        50 === c.position &&
                        (a =
                          'start' === e.align || 'left' === e.align
                            ? 0
                            : 'end' === e.align || 'right' === e.align
                            ? 100
                            : 50),
                        (e.position = a);
                    })(t, e);
                }
                function a(t) {
                  return t.replace(/<br(?: \/)?>/gi, '\n');
                }
                r.r(e),
                  r.d(e, 'parseTimeStamp', function() {
                    return n;
                  }),
                  r.d(e, 'fixLineBreaks', function() {
                    return a;
                  }),
                  r.d(e, 'VTTParser', function() {
                    return d;
                  });
                var o = r('./src/utils/vttcue.ts'),
                  u = (function() {
                    function t() {}
                    return (
                      (t.prototype.decode = function(t, e) {
                        if (!t) return '';
                        if ('string' != typeof t)
                          throw new Error('Error - expected string data.');
                        return decodeURIComponent(encodeURIComponent(t));
                      }),
                      t
                    );
                  })(),
                  l = (function() {
                    function t() {
                      this.values = Object.create(null);
                    }
                    var e = t.prototype;
                    return (
                      (e.set = function(t, e) {
                        this.get(t) || '' === e || (this.values[t] = e);
                      }),
                      (e.get = function(t, e, r) {
                        return r
                          ? this.has(t)
                            ? this.values[t]
                            : e[r]
                          : this.has(t)
                          ? this.values[t]
                          : e;
                      }),
                      (e.has = function(t) {
                        return t in this.values;
                      }),
                      (e.alt = function(t, e, r) {
                        for (var n = 0; n < r.length; ++n)
                          if (e === r[n]) {
                            this.set(t, e);
                            break;
                          }
                      }),
                      (e.integer = function(t, e) {
                        /^-?\d+$/.test(e) && this.set(t, parseInt(e, 10));
                      }),
                      (e.percent = function(t, e) {
                        if (/^([\d]{1,3})(\.[\d]*)?%$/.test(e)) {
                          var r = parseFloat(e);
                          if (r >= 0 && r <= 100) return this.set(t, r), !0;
                        }
                        return !1;
                      }),
                      t
                    );
                  })(),
                  c = new o.default(0, 0, ''),
                  h = 'middle' === c.align ? 'middle' : 'center',
                  d = (function() {
                    function t() {
                      (this.state = 'INITIAL'),
                        (this.buffer = ''),
                        (this.decoder = new u()),
                        (this.regionList = []),
                        (this.cue = null),
                        (this.oncue = void 0),
                        (this.onparsingerror = void 0),
                        (this.onflush = void 0);
                    }
                    var e = t.prototype;
                    return (
                      (e.parse = function(t) {
                        function e() {
                          var t = r.buffer,
                            e = 0;
                          for (
                            t = a(t);
                            e < t.length && '\r' !== t[e] && '\n' !== t[e];

                          )
                            ++e;
                          var n = t.slice(0, e);
                          return (
                            '\r' === t[e] && ++e,
                            '\n' === t[e] && ++e,
                            (r.buffer = t.slice(e)),
                            n
                          );
                        }
                        var r = this;
                        t && (r.buffer += r.decoder.decode(t, { stream: !0 }));
                        try {
                          var n = '';
                          if ('INITIAL' === r.state) {
                            if (!/\r\n|\n/.test(r.buffer)) return this;
                            var u = (n = e()).match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
                            if (!u || !u[0])
                              throw new Error('Malformed WebVTT signature.');
                            r.state = 'HEADER';
                          }
                          for (var l = !1; r.buffer; ) {
                            if (!/\r\n|\n/.test(r.buffer)) return this;
                            switch ((l ? (l = !1) : (n = e()), r.state)) {
                              case 'HEADER':
                                /:/.test(n)
                                  ? i(n, function(t, e) {}, /:/)
                                  : n || (r.state = 'ID');
                                continue;
                              case 'NOTE':
                                n || (r.state = 'ID');
                                continue;
                              case 'ID':
                                if (/^NOTE($|[ \t])/.test(n)) {
                                  r.state = 'NOTE';
                                  break;
                                }
                                if (!n) continue;
                                if (
                                  ((r.cue = new o.default(0, 0, '')),
                                  (r.state = 'CUE'),
                                  -1 === n.indexOf('--\x3e'))
                                ) {
                                  r.cue.id = n;
                                  continue;
                                }
                              case 'CUE':
                                if (!r.cue) {
                                  r.state = 'BADCUE';
                                  continue;
                                }
                                try {
                                  s(n, r.cue, r.regionList);
                                } catch (t) {
                                  (r.cue = null), (r.state = 'BADCUE');
                                  continue;
                                }
                                r.state = 'CUETEXT';
                                continue;
                              case 'CUETEXT':
                                var c = -1 !== n.indexOf('--\x3e');
                                if (!n || (c && (l = !0))) {
                                  r.oncue && r.cue && r.oncue(r.cue),
                                    (r.cue = null),
                                    (r.state = 'ID');
                                  continue;
                                }
                                if (null === r.cue) continue;
                                r.cue.text && (r.cue.text += '\n'),
                                  (r.cue.text += n);
                                continue;
                              case 'BADCUE':
                                n || (r.state = 'ID');
                            }
                          }
                        } catch (t) {
                          'CUETEXT' === r.state &&
                            r.cue &&
                            r.oncue &&
                            r.oncue(r.cue),
                            (r.cue = null),
                            (r.state =
                              'INITIAL' === r.state ? 'BADWEBVTT' : 'BADCUE');
                        }
                        return this;
                      }),
                      (e.flush = function() {
                        try {
                          if (
                            ((this.cue || 'HEADER' === this.state) &&
                              ((this.buffer += '\n\n'), this.parse()),
                            'INITIAL' === this.state ||
                              'BADWEBVTT' === this.state)
                          )
                            throw new Error('Malformed WebVTT signature.');
                        } catch (t) {
                          this.onparsingerror && this.onparsingerror(t);
                        }
                        return this.onflush && this.onflush(), this;
                      }),
                      t
                    );
                  })();
              },
              './src/utils/webvtt-parser.ts': function(t, e, r) {
                function n(t, e, r) {
                  return d(t.toString()) + d(e.toString()) + d(r);
                }
                function i(t, e, r, i, d, f, p, v) {
                  var g,
                    m = new a.VTTParser(),
                    y = Object(o.utf8ArrayToStr)(new Uint8Array(t))
                      .trim()
                      .replace(c, '\n')
                      .split('\n'),
                    b = [],
                    E = Object(u.toMpegTsClockFromTimescale)(e, r),
                    T = '00:00.000',
                    S = 0,
                    L = 0,
                    _ = !0;
                  (m.oncue = function(t) {
                    var e = i[d],
                      r = i.ccOffset,
                      s = (S - E) / 9e4;
                    null != e &&
                      e.new &&
                      (void 0 !== L
                        ? (r = i.ccOffset = e.start)
                        : (function(t, e, r) {
                            var n = t[e],
                              i = t[n.prevCC];
                            if (!i || (!i.new && n.new))
                              return (
                                (t.ccOffset = t.presentationOffset = n.start),
                                void (n.new = !1)
                              );
                            for (
                              ;
                              null !== (s = i) && void 0 !== s && s.new;

                            ) {
                              var s;
                              (t.ccOffset += n.start - i.start),
                                (n.new = !1),
                                (i = t[(n = i).prevCC]);
                            }
                            t.presentationOffset = r;
                          })(i, d, s)),
                      s && (r = s - i.presentationOffset);
                    var a = t.endTime - t.startTime,
                      o =
                        Object(l.normalizePts)(
                          9e4 * (t.startTime + r - L),
                          9e4 * f,
                        ) / 9e4;
                    (t.startTime = Math.max(o, 0)),
                      (t.endTime = Math.max(o + a, 0));
                    var u = t.text.trim();
                    (t.text = decodeURIComponent(encodeURIComponent(u))),
                      t.id || (t.id = n(t.startTime, t.endTime, u)),
                      t.endTime > 0 && b.push(t);
                  }),
                    (m.onparsingerror = function(t) {
                      g = t;
                    }),
                    (m.onflush = function() {
                      g ? v(g) : p(b);
                    }),
                    y.forEach(function(t) {
                      if (_) {
                        if (h(t, 'X-TIMESTAMP-MAP=')) {
                          (_ = !1),
                            t
                              .slice(16)
                              .split(',')
                              .forEach(function(t) {
                                h(t, 'LOCAL:')
                                  ? (T = t.slice(6))
                                  : h(t, 'MPEGTS:') &&
                                    (S = parseInt(t.slice(7)));
                              });
                          try {
                            L =
                              (function(t) {
                                var e = parseInt(t.slice(-3)),
                                  r = parseInt(t.slice(-6, -4)),
                                  n = parseInt(t.slice(-9, -7)),
                                  i =
                                    t.length > 9
                                      ? parseInt(t.substring(0, t.indexOf(':')))
                                      : 0;
                                if (
                                  !(
                                    Object(s.isFiniteNumber)(e) &&
                                    Object(s.isFiniteNumber)(r) &&
                                    Object(s.isFiniteNumber)(n) &&
                                    Object(s.isFiniteNumber)(i)
                                  )
                                )
                                  throw Error(
                                    'Malformed X-TIMESTAMP-MAP: Local:' + t,
                                  );
                                return (
                                  (e += 1e3 * r), (e += 6e4 * n) + 36e5 * i
                                );
                              })(T) / 1e3;
                          } catch (t) {
                            g = t;
                          }
                          return;
                        }
                        '' === t && (_ = !1);
                      }
                      m.parse(t + '\n');
                    }),
                    m.flush();
                }
                r.r(e),
                  r.d(e, 'generateCueId', function() {
                    return n;
                  }),
                  r.d(e, 'parseWebVTT', function() {
                    return i;
                  });
                var s = r('./src/polyfills/number.ts'),
                  a = r('./src/utils/vttparser.ts'),
                  o = r('./src/demux/id3.ts'),
                  u = r('./src/utils/timescale-conversion.ts'),
                  l = r('./src/remux/mp4-remuxer.ts'),
                  c = /\r\n|\n\r|\n|\r/g,
                  h = function(t, e, r) {
                    return (
                      void 0 === r && (r = 0), t.slice(r, r + e.length) === e
                    );
                  },
                  d = function(t) {
                    for (var e = 5381, r = t.length; r; )
                      e = (33 * e) ^ t.charCodeAt(--r);
                    return (e >>> 0).toString();
                  };
              },
              './src/utils/xhr-loader.ts': function(t, e, r) {
                r.r(e);
                var n = r('./src/utils/logger.ts'),
                  i = r('./src/loader/load-stats.ts'),
                  s = /^age:\s*[\d.]+\s*$/m,
                  a = (function() {
                    function t(t) {
                      (this.xhrSetup = void 0),
                        (this.requestTimeout = void 0),
                        (this.retryTimeout = void 0),
                        (this.retryDelay = void 0),
                        (this.config = null),
                        (this.callbacks = null),
                        (this.context = void 0),
                        (this.loader = null),
                        (this.stats = void 0),
                        (this.xhrSetup = t ? t.xhrSetup : null),
                        (this.stats = new i.LoadStats()),
                        (this.retryDelay = 0);
                    }
                    var e = t.prototype;
                    return (
                      (e.destroy = function() {
                        (this.callbacks = null),
                          this.abortInternal(),
                          (this.loader = null),
                          (this.config = null);
                      }),
                      (e.abortInternal = function() {
                        var t = this.loader;
                        self.clearTimeout(this.requestTimeout),
                          self.clearTimeout(this.retryTimeout),
                          t &&
                            ((t.onreadystatechange = null),
                            (t.onprogress = null),
                            4 !== t.readyState &&
                              ((this.stats.aborted = !0), t.abort()));
                      }),
                      (e.abort = function() {
                        var t;
                        this.abortInternal(),
                          null !== (t = this.callbacks) &&
                            void 0 !== t &&
                            t.onAbort &&
                            this.callbacks.onAbort(
                              this.stats,
                              this.context,
                              this.loader,
                            );
                      }),
                      (e.load = function(t, e, r) {
                        if (this.stats.loading.start)
                          throw new Error('Loader can only be used once.');
                        (this.stats.loading.start = self.performance.now()),
                          (this.context = t),
                          (this.config = e),
                          (this.callbacks = r),
                          (this.retryDelay = e.retryDelay),
                          this.loadInternal();
                      }),
                      (e.loadInternal = function() {
                        var t = this.config,
                          e = this.context;
                        if (t) {
                          var r = (this.loader = new self.XMLHttpRequest()),
                            n = this.stats;
                          (n.loading.first = 0), (n.loaded = 0);
                          var i = this.xhrSetup;
                          try {
                            if (i)
                              try {
                                i(r, e.url);
                              } catch (t) {
                                r.open('GET', e.url, !0), i(r, e.url);
                              }
                            r.readyState || r.open('GET', e.url, !0);
                            var s = this.context.headers;
                            if (s) for (var a in s) r.setRequestHeader(a, s[a]);
                          } catch (t) {
                            return void this.callbacks.onError(
                              { code: r.status, text: t.message },
                              e,
                              r,
                            );
                          }
                          e.rangeEnd &&
                            r.setRequestHeader(
                              'Range',
                              'bytes=' + e.rangeStart + '-' + (e.rangeEnd - 1),
                            ),
                            (r.onreadystatechange = this.readystatechange.bind(
                              this,
                            )),
                            (r.onprogress = this.loadprogress.bind(this)),
                            (r.responseType = e.responseType),
                            self.clearTimeout(this.requestTimeout),
                            (this.requestTimeout = self.setTimeout(
                              this.loadtimeout.bind(this),
                              t.timeout,
                            )),
                            r.send();
                        }
                      }),
                      (e.readystatechange = function() {
                        var t = this.context,
                          e = this.loader,
                          r = this.stats;
                        if (t && e) {
                          var i = e.readyState,
                            s = this.config;
                          if (!r.aborted && i >= 2)
                            if (
                              (self.clearTimeout(this.requestTimeout),
                              0 === r.loading.first &&
                                (r.loading.first = Math.max(
                                  self.performance.now(),
                                  r.loading.start,
                                )),
                              4 === i)
                            ) {
                              (e.onreadystatechange = null),
                                (e.onprogress = null);
                              var a = e.status;
                              if (a >= 200 && a < 300) {
                                var o, u;
                                if (
                                  ((r.loading.end = Math.max(
                                    self.performance.now(),
                                    r.loading.first,
                                  )),
                                  (u =
                                    'arraybuffer' === t.responseType
                                      ? (o = e.response).byteLength
                                      : (o = e.responseText).length),
                                  (r.loaded = r.total = u),
                                  !this.callbacks)
                                )
                                  return;
                                var l = this.callbacks.onProgress;
                                if ((l && l(r, t, o, e), !this.callbacks))
                                  return;
                                var c = { url: e.responseURL, data: o };
                                this.callbacks.onSuccess(c, r, t, e);
                              } else
                                r.retry >= s.maxRetry || (a >= 400 && a < 499)
                                  ? (n.logger.error(
                                      a + ' while loading ' + t.url,
                                    ),
                                    this.callbacks.onError(
                                      { code: a, text: e.statusText },
                                      t,
                                      e,
                                    ))
                                  : (n.logger.warn(
                                      a +
                                        ' while loading ' +
                                        t.url +
                                        ', retrying in ' +
                                        this.retryDelay +
                                        '...',
                                    ),
                                    this.abortInternal(),
                                    (this.loader = null),
                                    self.clearTimeout(this.retryTimeout),
                                    (this.retryTimeout = self.setTimeout(
                                      this.loadInternal.bind(this),
                                      this.retryDelay,
                                    )),
                                    (this.retryDelay = Math.min(
                                      2 * this.retryDelay,
                                      s.maxRetryDelay,
                                    )),
                                    r.retry++);
                            } else
                              self.clearTimeout(this.requestTimeout),
                                (this.requestTimeout = self.setTimeout(
                                  this.loadtimeout.bind(this),
                                  s.timeout,
                                ));
                        }
                      }),
                      (e.loadtimeout = function() {
                        n.logger.warn(
                          'timeout while loading ' + this.context.url,
                        );
                        var t = this.callbacks;
                        t &&
                          (this.abortInternal(),
                          t.onTimeout(this.stats, this.context, this.loader));
                      }),
                      (e.loadprogress = function(t) {
                        var e = this.stats;
                        (e.loaded = t.loaded),
                          t.lengthComputable && (e.total = t.total);
                      }),
                      (e.getCacheAge = function() {
                        var t = null;
                        if (
                          this.loader &&
                          s.test(this.loader.getAllResponseHeaders())
                        ) {
                          var e = this.loader.getResponseHeader('age');
                          t = e ? parseFloat(e) : null;
                        }
                        return t;
                      }),
                      t
                    );
                  })();
                e.default = a;
              },
            }).default;
          }),
          (t.exports = n()));
      },
      function(t, e, r) {
        e.__esModule = !0;
        var n = r(71),
          i = r(73),
          s = r(75),
          a = r(76),
          o = r(77),
          u = r(53),
          l = r(78),
          c = (function() {
            function t() {
              this.config = o.PLAYER_CONFIG;
            }
            return (
              (t.prototype.isHlsSupported = function() {
                return (
                  !window.location.href.includes('flash=true') &&
                  n.isSupported()
                );
              }),
              (t.prototype.init = function(t, e, r) {
                if (
                  ((this.config = e || this.config),
                  (this.videoWrapperElement = t),
                  r && (this.config.flashId = r),
                  this.isHlsSupported())
                )
                  (this.videoElement = this.createVideoElement()),
                    this.videoWrapperElement.appendChild(this.videoElement),
                    (this.player = new s.HlsJsPlayer(
                      this.config,
                      this.videoElement,
                    ));
                else {
                  l.embedSWF(
                    'flashlsChromeless.swf?inline=1',
                    this.config.flashId,
                    '500',
                    '500',
                    '22.0.0.209',
                    '',
                    {},
                    {
                      Flashvars: 'callback=flashlsCallback',
                      allowScriptAccess: 'sameDomain',
                      wmode: 'opaque',
                    },
                  );
                  var n = this.getFlashObject(this.config.flashId);
                  this.player = new i.FlashlsPlayer(this.config, n);
                }
              }),
              (t.prototype.getFlashObject = function(t) {
                return window.document[t]
                  ? window.document[t]
                  : navigator.appName.includes('Microsoft Internet')
                  ? document.getElementById(t)
                  : document.embeds && document.embeds[t]
                  ? document.embeds[t]
                  : void 0;
              }),
              (t.prototype.createVideoElement = function() {
                return document.createElement('video');
              }),
              (t.prototype.play = function() {
                this.player && this.player.play();
              }),
              (t.prototype.stop = function() {
                this.player && this.player.stop();
              }),
              (t.prototype.seek = function(t) {
                this.player && this.player.seek(t);
              }),
              (t.prototype.pause = function() {
                this.player && this.player.pause();
              }),
              (t.prototype.resume = function() {
                this.player && this.player.resume();
              }),
              (t.prototype.getVolume = function() {
                this.player && this.player.getVolume();
              }),
              (t.prototype.setVolume = function(t) {
                this.player && this.player.setVolume(t);
              }),
              (t.prototype.warmUp = function() {
                this.player && this.player.warmUp();
              }),
              (t.prototype.destroy = function() {
                this.player &&
                  (this.player.destroy(),
                  (this.player = null),
                  (this.videoWrapperElement = null));
              }),
              (t.prototype.loadAsset = function(t, e) {
                if (this.player) {
                  (this.config = e || this.config),
                    (this.config.autoPlay = t.autoPlay),
                    (this.config.startPosition = t.startTime
                      ? t.startTime
                      : -1);
                  var r = [
                    u.VideoFileTypes.MOV,
                    u.VideoFileTypes.MP4,
                    u.VideoFileTypes.OGG,
                    u.VideoFileTypes.WEBM,
                    u.VideoFileTypes.MPEG,
                  ];
                  if (t.type && r.includes(t.type)) {
                    this.videoElement ||
                      ((this.videoElement = this.createVideoElement()),
                      this.videoWrapperElement.appendChild(this.videoElement));
                    var n = new a.BlobPlayer(this.config, this.videoElement);
                    n.gatherSubscriptionCallbacks(this.player),
                      (this.player = n),
                      this.player.destroy();
                  }
                  return this.player.loadAsset(
                    t,
                    this.config,
                    this.videoElement,
                  );
                }
              }),
              (t.prototype.subscribe = function(t, e) {
                return this.player.subscribe(t, e);
              }),
              (t.EVENTS = u.WebVideoPlayerEvents),
              t
            );
          })();
        e.default = c;
      },
      function(t, e, r) {
        e.__esModule = !0;
        var n = r(70),
          i = r(69),
          s = r(53),
          a = r(74),
          o = r(68),
          u = (function() {
            function t(t, e) {
              var r = this;
              (this.flashVolumeAdjFactor = 100),
                (this.playbackReady$ = new n.Subject()),
                (this.playerCreated$ = new n.Subject()),
                (this.options = t || this.options),
                (window.flashlsCallback = function(t, e) {
                  r.listenFlashHlsEvents(t, e);
                }),
                (this.flashlsApi = new a.FlashlsApi(e));
            }
            return (
              (t.prototype.listenFlashHlsEvents = function(t, e) {
                switch (
                  (o.Logger.logMessage(
                    this.options.debug,
                    o.Logger.LEVEL_DEBUG,
                    t,
                    e,
                  ),
                  t)
                ) {
                  case s.FlashEvents.PLAYING:
                    break;
                  case s.FlashEvents.READY:
                    this.playerCreated$.next(!0);
                    break;
                  case s.FlashEvents.MANIFEST:
                    this.playbackReady$.next(!1);
                    break;
                  case s.FlashEvents.COMPLETE:
                    this.playbackCompleteCallback();
                    break;
                  case s.FlashEvents.ERROR:
                    o.Logger.logMessage(
                      this.options.debug,
                      o.Logger.LEVEL_DEBUG,
                      'onError():error code:' +
                        e[0] +
                        ' url:' +
                        e[1] +
                        ' message:' +
                        e[2],
                    );
                    break;
                  case s.FlashEvents.SEEK_STATE:
                  case s.FlashEvents.STATE:
                    this.handleState(t, e);
                    break;
                  case s.FlashEvents.POSITION:
                    var r = e[0];
                    this.playheadTimeCallback(
                      s.WebVideoPlayerEvents.PLAYHEAD_TIME_CHANGED,
                      r.position,
                      r.duration,
                    );
                }
              }),
              (t.prototype.loadAsset = function(t, e, r) {
                this.stop(),
                  this.resetPlaybackReady(),
                  (this.offset = e.startPosition),
                  this.flashlsApi.load(t.url);
              }),
              (t.prototype.play = function() {
                var t = this.offset || -1;
                this.flashlsApi.play(t), (this.offset = null);
              }),
              (t.prototype.destroy = function() {}),
              (t.prototype.pause = function() {
                this.flashlsApi.pause();
              }),
              (t.prototype.resume = function() {
                this.flashlsApi.resume();
              }),
              (t.prototype.seek = function(t) {
                this.flashlsApi.seek(t);
              }),
              (t.prototype.stop = function() {
                this.flashlsApi.stop();
              }),
              (t.prototype.warmUp = function() {}),
              (t.prototype.setVolume = function(t) {
                var e = t * this.flashVolumeAdjFactor;
                this.flashlsApi.volume(e);
              }),
              (t.prototype.handleState = function(t, e) {
                o.Logger.logMessage(
                  this.options.debug,
                  o.Logger.LEVEL_DEBUG,
                  'state',
                  e[0],
                ),
                  e[0] === s.FlashStates.PLAYING
                    ? this.playingCallback && this.playingCallback()
                    : e[0] === s.FlashStates.PAUSED
                    ? this.pausedCallback && this.pausedCallback()
                    : e[0] === s.FlashStates.PAUSED_BUFFERING ||
                      e[0] === s.FlashStates.PLAYING_BUFFERING
                    ? this.loadStartCallback()
                    : e[0] === s.FlashStates.SEEKED && this.seekedCallback();
              }),
              (t.prototype.subscribe = function(t, e) {
                t === s.WebVideoPlayerEvents.PLAYBACK_READY
                  ? this.resetPlaybackReady(e)
                  : t === s.WebVideoPlayerEvents.PLAYER_CREATED
                  ? this.resetPlayerCreated(e)
                  : t === s.WebVideoPlayerEvents.PLAYING
                  ? (this.playingCallback = e)
                  : t === s.WebVideoPlayerEvents.PAUSED
                  ? (this.pausedCallback = e)
                  : t === s.WebVideoPlayerEvents.LOAD_START
                  ? (this.loadStartCallback = e)
                  : t === s.WebVideoPlayerEvents.PLAYHEAD_TIME_CHANGED
                  ? (this.playheadTimeCallback = e)
                  : t === s.WebVideoPlayerEvents.SEEKED
                  ? (this.seekedCallback = e)
                  : t === s.WebVideoPlayerEvents.PLAYBACK_COMPLETE &&
                    (this.playbackCompleteCallback = e);
              }),
              (t.prototype.resetPlaybackReady = function(t) {
                var e = this;
                t && (this.playbackReadyCallback = t),
                  this.playbackReadySub && this.playbackReadySub.unsubscribe(),
                  (this.playbackReadySub = this.playbackReady$
                    .pipe(i.take(1))
                    .subscribe(function(t) {
                      e.playbackReadyCallback(t);
                    }));
              }),
              (t.prototype.resetPlayerCreated = function(t) {
                var e = this;
                t && (this.playerCreatedCallback = t),
                  this.playerCreatedSub && this.playerCreatedSub.unsubscribe(),
                  (this.playerCreatedSub = this.playerCreated$
                    .pipe(
                      i.filter(function(t) {
                        return !!t;
                      }),
                      i.take(1),
                    )
                    .subscribe(function() {
                      e.playerCreatedCallback();
                    }));
              }),
              t
            );
          })();
        e.FlashlsPlayer = u;
      },
      function(t, e, r) {
        e.__esModule = !0;
        var n = (function() {
          function t(t) {
            this.flashObject = t;
          }
          return (
            (t.prototype.load = function(t) {
              this.flashObject.playerLoad(t);
            }),
            (t.prototype.play = function(t) {
              this.flashObject.playerPlay(t);
            }),
            (t.prototype.pause = function() {
              this.flashObject.playerPause();
            }),
            (t.prototype.resume = function() {
              this.flashObject.playerResume();
            }),
            (t.prototype.seek = function(t) {
              this.flashObject.playerSeek(t);
            }),
            (t.prototype.stop = function() {
              this.flashObject.playerStop();
            }),
            (t.prototype.volume = function(t) {
              this.flashObject.playerVolume(t);
            }),
            (t.prototype.setCurrentLevel = function(t) {
              this.flashObject.playerSetCurrentLevel(t);
            }),
            (t.prototype.setNextLevel = function(t) {
              this.flashObject.playerSetNextLevel(t);
            }),
            (t.prototype.setLoadLevel = function(t) {
              this.flashObject.playerSetLoadLevel(t);
            }),
            (t.prototype.setMaxBufngth = function(t) {
              this.flashObject.playerSetmaxBufferLength(t);
            }),
            (t.prototype.getPosition = function() {
              return this.flashObject.getPosition();
            }),
            (t.prototype.getDuration = function() {
              return this.flashObject.getDuration();
            }),
            (t.prototype.getbufferLength = function() {
              return this.flashObject.getbufferLength();
            }),
            (t.prototype.getbackBufferLength = function() {
              return this.flashObject.getbackBufferLength();
            }),
            (t.prototype.getLowBufferLength = function() {
              return this.flashObject.getlowBufferLength();
            }),
            (t.prototype.getMinBufferLength = function() {
              return this.flashObject.getminBufferLength();
            }),
            (t.prototype.getMaxBufferLength = function() {
              return this.flashObject.getmaxBufferLength();
            }),
            (t.prototype.getLevels = function() {
              return this.flashObject.getLevels();
            }),
            (t.prototype.getAutoLevel = function() {
              return this.flashObject.getAutoLevel();
            }),
            (t.prototype.getCurrentLevel = function() {
              return this.flashObject.getCurrentLevel();
            }),
            (t.prototype.getNextLevel = function() {
              return this.flashObject.getNextLevel();
            }),
            (t.prototype.getLoadLevel = function() {
              return this.flashObject.getLoadLevel();
            }),
            (t.prototype.getAudioTrackList = function() {
              return this.flashObject.getAudioTrackList();
            }),
            (t.prototype.getStats = function() {
              return this.flashObject.getStats();
            }),
            (t.prototype.setAudioTrack = function(t) {
              this.flashObject.playerSetAudioTrack(t);
            }),
            (t.prototype.playerSetLogDebug = function(t) {
              this.flashObject.playerSetLogDebug(t);
            }),
            (t.prototype.getLogDebug = function() {
              return this.flashObject.getLogDebug();
            }),
            (t.prototype.playerSetLogDebug2 = function(t) {
              this.flashObject.playerSetLogDebug2(t);
            }),
            (t.prototype.getLogDebug2 = function() {
              return this.flashObject.getLogDebug2();
            }),
            (t.prototype.playerSetUseHardwareVideoDecoder = function(t) {
              this.flashObject.playerSetUseHardwareVideoDecoder(t);
            }),
            (t.prototype.getUseHardwareVideoDecoder = function() {
              return this.flashObject.getUseHardwareVideoDecoder();
            }),
            (t.prototype.playerSetflushLiveURLCache = function(t) {
              this.flashObject.playerSetflushLiveURLCache(t);
            }),
            (t.prototype.getflushLiveURLCache = function() {
              return this.flashObject.getflushLiveURLCache();
            }),
            (t.prototype.playerSetJSURLStream = function(t) {
              this.flashObject.playerSetJSURLStream(t);
            }),
            (t.prototype.getJSURLStream = function() {
              return this.flashObject.getJSURLStream();
            }),
            (t.prototype.playerCapLeveltoStage = function(t) {
              this.flashObject.playerCapLeveltoStage(t);
            }),
            (t.prototype.getCapLeveltoStage = function() {
              return this.flashObject.getCapLeveltoStage();
            }),
            (t.prototype.playerSetAutoLevelCapping = function(t) {
              this.flashObject.playerSetAutoLevelCapping(t);
            }),
            (t.prototype.getAutoLevelCapping = function() {
              return this.flashObject.getAutoLevelCapping();
            }),
            t
          );
        })();
        e.FlashlsApi = n;
      },
      function(t, e, r) {
        e.__esModule = !0;
        var n = r(70),
          i = r(69),
          s = r(71),
          a = r(68),
          o = r(53),
          u = (function() {
            function t(t, e) {
              (this.playbackReady$ = new n.Subject()),
                (this.playerCreated$ = new n.Subject()),
                (this.config = t),
                this.listenMediaEvents(e),
                (this.hls = new s(t)),
                this.hls.attachMedia(e),
                this.listenHlsEvents(),
                this.listenHlsErrorEvents();
            }
            return (
              (t.prototype.play = function() {
                var t = this;
                if (this.hls) {
                  var e = this.hls.media.play();
                  if (!e) return;
                  e.catch(function(e) {
                    t.autoplayBlockedCallback && t.autoplayBlockedCallback(e);
                  });
                }
              }),
              (t.prototype.pause = function() {
                this.hls && this.hls.media.pause();
              }),
              (t.prototype.resume = function() {
                this.hls && this.hls.media.play();
              }),
              (t.prototype.stop = function() {
                this.pause(), this.destroy();
              }),
              (t.prototype.destroy = function() {
                this.hls && this.hls.destroy(), (this.hls = null);
              }),
              (t.prototype.setVolume = function(t) {
                this.hls && (this.hls.media.volume = t);
              }),
              (t.prototype.getVolume = function() {
                if (this.hls) return this.hls.media.volume;
              }),
              (t.prototype.warmUp = function() {}),
              (t.prototype.loadAsset = function(t, e, r) {
                this.destroy(),
                  this.resetPlaybackReady(),
                  (this.hls = new s(e)),
                  this.hls.attachMedia(r),
                  this.listenHlsEvents(),
                  this.listenHlsErrorEvents(),
                  (this.offset = e.startPosition),
                  this.hls && this.hls.loadSource(t.url);
              }),
              (t.prototype.seek = function(t) {
                this.hls && (this.hls.media.currentTime = t);
              }),
              (t.prototype.listenMediaEvents = function(t) {
                t.addEventListener('resize', this.handleVideoEvent.bind(this)),
                  t.addEventListener(
                    'seeking',
                    this.handleVideoEvent.bind(this),
                  ),
                  t.addEventListener(
                    'seeked',
                    this.handleVideoEvent.bind(this),
                  ),
                  t.addEventListener('pause', this.handleVideoEvent.bind(this)),
                  t.addEventListener('play', this.handleVideoEvent.bind(this)),
                  t.addEventListener(
                    'canplay',
                    this.handleVideoEvent.bind(this),
                  ),
                  t.addEventListener(
                    'canplaythrough',
                    this.handleVideoEvent.bind(this),
                  ),
                  t.addEventListener('ended', this.handleVideoEvent.bind(this)),
                  t.addEventListener(
                    'playing',
                    this.handleVideoEvent.bind(this),
                  ),
                  t.addEventListener('error', this.handleVideoEvent.bind(this)),
                  t.addEventListener(
                    'loadedmetadata',
                    this.handleVideoEvent.bind(this),
                  ),
                  t.addEventListener(
                    'loadeddata',
                    this.handleVideoEvent.bind(this),
                  ),
                  t.addEventListener(
                    'durationchange',
                    this.handleVideoEvent.bind(this),
                  ),
                  t.addEventListener(
                    'timeupdate',
                    this.handleVideoEvent.bind(this),
                  ),
                  t.addEventListener(
                    'waiting',
                    this.handleVideoEvent.bind(this),
                  ),
                  t.addEventListener(
                    'stalled',
                    this.handleVideoEvent.bind(this),
                  ),
                  t.addEventListener(
                    'loadstart',
                    this.handleVideoEvent.bind(this),
                  ),
                  t.addEventListener(
                    'progress',
                    this.handleVideoEvent.bind(this),
                  );
              }),
              (t.prototype.listenHlsEvents = function() {
                var t = this;
                this.hls &&
                  (this.hls.on(s.Events.MEDIA_ATTACHED, function() {
                    t.playerCreated$.next(!0);
                  }),
                  this.hls.on(s.Events.LEVEL_LOADED, function(e, r) {
                    a.Logger.logMessage(
                      t.config.debug,
                      a.Logger.LEVEL_DEBUG,
                      'Hls.Events.LEVEL_LOADED',
                      e,
                      r,
                    );
                  }),
                  this.hls.on(s.Events.MEDIA_DETACHED, function() {
                    a.Logger.logMessage(
                      t.config.debug,
                      a.Logger.LEVEL_DEBUG,
                      'Media element detached',
                    );
                  }),
                  this.hls.on(s.Events.LEVEL_SWITCHING, function(e, r) {
                    a.Logger.logMessage(
                      t.config.debug,
                      a.Logger.LEVEL_DEBUG,
                      'LEVEL_SWITCHING',
                      e,
                      r,
                    );
                  }),
                  this.hls.on(s.Events.MANIFEST_PARSED, function(e, r) {
                    a.Logger.logMessage(
                      t.config.debug,
                      a.Logger.LEVEL_DEBUG,
                      'No of quality levels found: ' + t.hls.levels.length,
                    ),
                      a.Logger.logMessage(
                        t.config.debug,
                        a.Logger.LEVEL_DEBUG,
                        'Manifest successfully loaded',
                      ),
                      a.Logger.logMessage(
                        t.config.debug,
                        a.Logger.LEVEL_DEBUG,
                        'MANIFEST_PARSED',
                        e,
                        r,
                      ),
                      t.setQualityLevel();
                  }),
                  this.hls.on(s.Events.BUFFER_CREATED, function(e, r) {
                    a.Logger.logMessage(
                      t.config.debug,
                      a.Logger.LEVEL_DEBUG,
                      e,
                      r,
                    );
                  }),
                  this.hls.on(s.Events.BUFFER_APPENDING, function(e, r) {
                    a.Logger.logMessage(
                      t.config.debug,
                      a.Logger.LEVEL_DEBUG,
                      e,
                      r,
                    );
                  }),
                  this.hls.on(s.Events.FPS_DROP, function(e, r) {
                    a.Logger.logMessage(
                      t.config.debug,
                      a.Logger.LEVEL_DEBUG,
                      e,
                      r,
                    );
                  }));
              }),
              (t.prototype.handleVideoEvent = function(t) {
                a.Logger.logMessage(
                  this.config.debug,
                  a.Logger.LEVEL_DEBUG,
                  'HLS Player Video Event',
                  t.type,
                );
                var e = {
                  type: t.type,
                  playhead: t.target.currentTime,
                  duration: t.target.duration,
                };
                switch (t.type) {
                  case o.HTMLMediaEvents.CAN_PLAY_THROUGH:
                  case o.HTMLMediaEvents.DURATION_CHANGE:
                  case o.HTMLMediaEvents.LOADED_DATA:
                  case o.HTMLMediaEvents.LOAD_META_DATA:
                  case o.HTMLMediaEvents.SEEKING:
                  case o.HTMLMediaEvents.STALLED:
                  case o.HTMLMediaEvents.WAITING:
                    break;
                  case o.HTMLMediaEvents.LOAD_START:
                    (e.type = o.WebVideoPlayerEvents.LOAD_START),
                      this.loadStartCallback && this.loadStartCallback(e);
                    break;
                  case o.HTMLMediaEvents.CAN_PLAY:
                    this.playbackReady$.next(!0);
                    break;
                  case o.HTMLMediaEvents.ENDED:
                    (e.type = o.WebVideoPlayerEvents.PLAYBACK_COMPLETE),
                      this.playbackCompleteCallback(e);
                    break;
                  case o.HTMLMediaEvents.SEEKED:
                    (e.type = o.WebVideoPlayerEvents.SEEKED),
                      this.seekedCallback(e);
                    break;
                  case o.HTMLMediaEvents.PLAY:
                  case o.HTMLMediaEvents.PLAYING:
                    (e.type = o.WebVideoPlayerEvents.PLAYING),
                      this.playingCallback && this.playingCallback(e);
                    break;
                  case o.HTMLMediaEvents.PAUSE:
                    (e.type = o.WebVideoPlayerEvents.PAUSED),
                      this.pausedCallback && this.pausedCallback(e);
                    break;
                  case o.HTMLMediaEvents.TIME_UPDATE:
                    (e.type = o.WebVideoPlayerEvents.PLAYHEAD_TIME_CHANGED),
                      (this.offset = t.target.currentTime),
                      this.playheadTimeCallback(e);
                    break;
                  case o.HTMLMediaEvents.ERROR:
                    var r = void 0,
                      n = t.currentTarget.error;
                    switch (n.code) {
                      case n.MEDIA_ERR_ABORTED:
                        r = 'You aborted the video playback';
                        break;
                      case n.MEDIA_ERR_DECODE:
                        r =
                          'The video playback was aborted due to a corruption problem or because the video used features your browser did not support';
                        break;
                      case n.MEDIA_ERR_NETWORK:
                        r =
                          'A network error caused the video download to fail part-way';
                        break;
                      case n.MEDIA_ERR_SRC_NOT_SUPPORTED:
                        r =
                          'The video could not be loaded, either because the server or network failed or because the format is not supported';
                    }
                    n.message && (r += ' - ' + n.message),
                      a.Logger.logMessage(
                        this.config.debug,
                        a.Logger.LEVEL_DEBUG,
                        r,
                        t.type,
                      );
                }
              }),
              (t.prototype.listenHlsErrorEvents = function() {
                var t = this;
                this.hls &&
                  this.hls.on(s.Events.ERROR, function(e, r) {
                    switch (
                      (a.Logger.logMessage(
                        t.config.debug,
                        a.Logger.LEVEL_WARN,
                        'Error event:',
                        r,
                      ),
                      r.details)
                    ) {
                      case s.ErrorDetails.MANIFEST_LOAD_ERROR:
                        a.Logger.logMessage(
                          t.config.debug,
                          a.Logger.LEVEL_ERROR,
                          'MANIFEST_LOAD_ERROR',
                        );
                        break;
                      case s.ErrorDetails.MANIFEST_LOAD_TIMEOUT:
                        a.Logger.logMessage(
                          t.config.debug,
                          a.Logger.LEVEL_ERROR,
                          'Timeout while loading manifest',
                        );
                        break;
                      case s.ErrorDetails.MANIFEST_PARSING_ERROR:
                        a.Logger.logMessage(
                          t.config.debug,
                          a.Logger.LEVEL_ERROR,
                          'Error while parsing manifest:' + r.reason,
                        );
                        break;
                      case s.ErrorDetails.LEVEL_LOAD_ERROR:
                        a.Logger.logMessage(
                          t.config.debug,
                          a.Logger.LEVEL_ERROR,
                          'Error while loading level playlist',
                        );
                        break;
                      case s.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                        a.Logger.logMessage(
                          t.config.debug,
                          a.Logger.LEVEL_ERROR,
                          'Timeout while loading level playlist',
                        );
                        break;
                      case s.ErrorDetails.LEVEL_SWITCH_ERROR:
                        a.Logger.logMessage(
                          t.config.debug,
                          a.Logger.LEVEL_ERROR,
                          'Error while trying to switch to level ' + r.level,
                        );
                        break;
                      case s.ErrorDetails.FRAG_LOAD_ERROR:
                        a.Logger.logMessage(
                          t.config.debug,
                          a.Logger.LEVEL_ERROR,
                          'Error while loading fragment ' + r.frag.url,
                        );
                        break;
                      case s.ErrorDetails.FRAG_LOAD_TIMEOUT:
                        a.Logger.logMessage(
                          t.config.debug,
                          a.Logger.LEVEL_ERROR,
                          'Timeout while loading fragment ' + r.frag.url,
                        );
                        break;
                      case s.ErrorDetails.FRAG_DECRYPT_ERROR:
                        a.Logger.logMessage(
                          t.config.debug,
                          a.Logger.LEVEL_ERROR,
                          'Decrypting error:' + r.reason,
                        );
                        break;
                      case s.ErrorDetails.FRAG_PARSING_ERROR:
                        a.Logger.logMessage(
                          t.config.debug,
                          a.Logger.LEVEL_ERROR,
                          'Parsing error:' + r.reason,
                        );
                        break;
                      case s.ErrorDetails.KEY_LOAD_ERROR:
                        a.Logger.logMessage(
                          t.config.debug,
                          a.Logger.LEVEL_ERROR,
                          'Error while loading key ' + r.frag.decryptdata.uri,
                        );
                        break;
                      case s.ErrorDetails.KEY_LOAD_TIMEOUT:
                        a.Logger.logMessage(
                          t.config.debug,
                          a.Logger.LEVEL_ERROR,
                          'Timeout while loading key ' + r.frag.decryptdata.uri,
                        );
                        break;
                      case s.ErrorDetails.BUFFER_APPEND_ERROR:
                        a.Logger.logMessage(
                          t.config.debug,
                          a.Logger.LEVEL_ERROR,
                          'Buffer append error',
                        );
                        break;
                      case s.ErrorDetails.BUFFER_ADD_CODEC_ERROR:
                        a.Logger.logMessage(
                          t.config.debug,
                          a.Logger.LEVEL_ERROR,
                          'Buffer add codec error for ' +
                            r.mimeType +
                            ':' +
                            r.err.message,
                        );
                        break;
                      case s.ErrorDetails.BUFFER_APPENDING_ERROR:
                        a.Logger.logMessage(
                          t.config.debug,
                          a.Logger.LEVEL_ERROR,
                          'Buffer appending error',
                        );
                        break;
                      case s.ErrorDetails.BUFFER_STALLED_ERROR:
                        a.Logger.logMessage(
                          t.config.debug,
                          a.Logger.LEVEL_ERROR,
                          'Buffer stalled error',
                        ),
                          t.stalledCallback && t.stalledCallback();
                    }
                    if (r.fatal)
                      switch (
                        (a.Logger.logMessage(
                          t.config.debug,
                          a.Logger.LEVEL_ERROR,
                          'Fatal error :' + r.details,
                        ),
                        r.type)
                      ) {
                        case s.ErrorTypes.MEDIA_ERROR:
                          a.Logger.logMessage(
                            t.config.debug,
                            a.Logger.LEVEL_ERROR,
                            'An hls media error occured',
                          ),
                            t.handleMediaError();
                          break;
                        case s.ErrorTypes.NETWORK_ERROR:
                          a.Logger.logMessage(
                            t.config.debug,
                            a.Logger.LEVEL_ERROR,
                            'An hls network error occured',
                          ),
                            t.hls && t.hls.startLoad(t.offset || 0);
                          break;
                        default:
                          a.Logger.logMessage(
                            t.config.debug,
                            a.Logger.LEVEL_ERROR,
                            'An unrecoverable error occured, destorying the video player',
                          ),
                            t.hls.destroy();
                      }
                  });
              }),
              (t.prototype.subscribe = function(t, e) {
                t === o.WebVideoPlayerEvents.PLAYBACK_READY
                  ? this.resetPlaybackReady(e)
                  : t === o.WebVideoPlayerEvents.PLAYER_CREATED
                  ? this.resetPlayerCreated(e)
                  : t === o.WebVideoPlayerEvents.PLAYING
                  ? (this.playingCallback = e)
                  : t === o.WebVideoPlayerEvents.PAUSED
                  ? (this.pausedCallback = e)
                  : t === o.WebVideoPlayerEvents.LOAD_START
                  ? (this.loadStartCallback = e)
                  : t === o.WebVideoPlayerEvents.PLAYHEAD_TIME_CHANGED
                  ? (this.playheadTimeCallback = e)
                  : t === o.WebVideoPlayerEvents.SEEKED
                  ? (this.seekedCallback = e)
                  : t === o.WebVideoPlayerEvents.PLAYBACK_COMPLETE
                  ? (this.playbackCompleteCallback = e)
                  : t === o.WebVideoPlayerEvents.STALLED
                  ? (this.stalledCallback = e)
                  : t === o.WebVideoPlayerEvents.AUTOPLAY_BLOCKED &&
                    (this.autoplayBlockedCallback = e);
              }),
              (t.prototype.handleMediaError = function() {
                this.hls.recoverMediaError();
              }),
              (t.prototype.setQualityLevel = function() {
                this.hls &&
                  (this.hls.startLevel = Math.floor(
                    0.85 * this.hls.levels.length,
                  ));
              }),
              (t.prototype.resetPlaybackReady = function(t) {
                var e = this;
                t && (this.playbackReadyCallback = t),
                  this.playbackReadySub && this.playbackReadySub.unsubscribe(),
                  (this.playbackReadySub = this.playbackReady$
                    .pipe(i.take(1))
                    .subscribe(function() {
                      e.playbackReadyCallback();
                    }));
              }),
              (t.prototype.resetPlayerCreated = function(t) {
                var e = this;
                t && (this.playerCreatedCallback = t),
                  this.playerCreatedSub ||
                    (this.playerCreatedSub = this.playerCreated$
                      .pipe(i.take(1))
                      .subscribe(function() {
                        e.playerCreatedCallback();
                      }));
              }),
              t
            );
          })();
        e.HlsJsPlayer = u;
      },
      function(t, e, r) {
        e.__esModule = !0;
        var n = r(70),
          i = r(69),
          s = r(53),
          a = r(68),
          o = (function() {
            function t(t, e) {
              (this.playbackReady$ = new n.Subject()),
                (this.playerCreated$ = new n.Subject()),
                (this.config = t),
                this.listenMediaEvents(e),
                (this.videoElement = e),
                this.playerCreated$.next(!0);
            }
            return (
              (t.prototype.play = function() {
                this.videoElement.play();
              }),
              (t.prototype.pause = function() {
                this.videoElement.pause();
              }),
              (t.prototype.resume = function() {
                this.videoElement.play();
              }),
              (t.prototype.stop = function() {
                this.pause(),
                  this.videoElement.removeAttribute('src'),
                  this.videoElement.load(),
                  this.destroy();
              }),
              (t.prototype.destroy = function() {}),
              (t.prototype.setVolume = function(t) {
                this.videoElement.volume = t;
              }),
              (t.prototype.getVolume = function() {
                return this.videoElement.volume;
              }),
              (t.prototype.warmUp = function() {}),
              (t.prototype.loadAsset = function(t, e, r) {
                this.destroy(),
                  this.resetPlayerCreated(),
                  this.resetPlaybackReady(),
                  (r.autoplay = t.autoPlay),
                  (r.src = t.url),
                  r.load(),
                  (this.offset = e.startPosition);
              }),
              (t.prototype.seek = function(t) {
                this.videoElement.currentTime = t;
              }),
              (t.prototype.listenMediaEvents = function(t) {
                t.addEventListener('resize', this.handleVideoEvent.bind(this)),
                  t.addEventListener(
                    'seeking',
                    this.handleVideoEvent.bind(this),
                  ),
                  t.addEventListener(
                    'seeked',
                    this.handleVideoEvent.bind(this),
                  ),
                  t.addEventListener('pause', this.handleVideoEvent.bind(this)),
                  t.addEventListener('play', this.handleVideoEvent.bind(this)),
                  t.addEventListener(
                    'canplay',
                    this.handleVideoEvent.bind(this),
                  ),
                  t.addEventListener(
                    'canplaythrough',
                    this.handleVideoEvent.bind(this),
                  ),
                  t.addEventListener('ended', this.handleVideoEvent.bind(this)),
                  t.addEventListener(
                    'playing',
                    this.handleVideoEvent.bind(this),
                  ),
                  t.addEventListener('error', this.handleVideoEvent.bind(this)),
                  t.addEventListener(
                    'loadedmetadata',
                    this.handleVideoEvent.bind(this),
                  ),
                  t.addEventListener(
                    'loadeddata',
                    this.handleVideoEvent.bind(this),
                  ),
                  t.addEventListener(
                    'durationchange',
                    this.handleVideoEvent.bind(this),
                  ),
                  t.addEventListener(
                    'timeupdate',
                    this.handleVideoEvent.bind(this),
                  ),
                  t.addEventListener(
                    'waiting',
                    this.handleVideoEvent.bind(this),
                  ),
                  t.addEventListener(
                    'stalled',
                    this.handleVideoEvent.bind(this),
                  ),
                  t.addEventListener(
                    'loadstart',
                    this.handleVideoEvent.bind(this),
                  ),
                  t.addEventListener(
                    'progress',
                    this.handleVideoEvent.bind(this),
                  );
              }),
              (t.prototype.handleVideoEvent = function(t) {
                a.Logger.logMessage(
                  this.config.debug,
                  a.Logger.LEVEL_DEBUG,
                  'Blob Player Video Event',
                  t.type,
                );
                var e = {
                  type: t.type,
                  playhead: t.target.currentTime,
                  duration: t.target.duration,
                };
                switch (t.type) {
                  case s.HTMLMediaEvents.CAN_PLAY_THROUGH:
                  case s.HTMLMediaEvents.DURATION_CHANGE:
                  case s.HTMLMediaEvents.LOAD_META_DATA:
                  case s.HTMLMediaEvents.LOADED_DATA:
                  case s.HTMLMediaEvents.SEEKING:
                  case s.HTMLMediaEvents.STALLED:
                  case s.HTMLMediaEvents.WAITING:
                    break;
                  case s.HTMLMediaEvents.LOAD_START:
                    (e.type = s.WebVideoPlayerEvents.LOAD_START),
                      this.loadStartCallback && this.loadStartCallback();
                    break;
                  case s.HTMLMediaEvents.CAN_PLAY:
                    this.playbackReady$.next(!0);
                    break;
                  case s.HTMLMediaEvents.ENDED:
                    (e.type = s.WebVideoPlayerEvents.PLAYBACK_COMPLETE),
                      this.playbackCompleteCallback(e);
                    break;
                  case s.HTMLMediaEvents.SEEKED:
                    (e.type = s.WebVideoPlayerEvents.SEEKED),
                      this.seekedCallback(e);
                    break;
                  case s.HTMLMediaEvents.PLAY:
                  case s.HTMLMediaEvents.PLAYING:
                    (e.type = s.WebVideoPlayerEvents.PLAYING),
                      this.playingCallback && this.playingCallback(e);
                    break;
                  case s.HTMLMediaEvents.PAUSE:
                    (e.type = s.WebVideoPlayerEvents.PAUSED),
                      this.pausedCallback && this.pausedCallback(e);
                    break;
                  case s.HTMLMediaEvents.TIME_UPDATE:
                    (e.type = s.WebVideoPlayerEvents.PLAYHEAD_TIME_CHANGED),
                      (this.offset = t.target.currentTime),
                      this.playheadTimeCallback(e);
                    break;
                  case s.HTMLMediaEvents.ERROR:
                    var r = t.currentTarget.error,
                      n = void 0;
                    switch (r.code) {
                      case r.MEDIA_ERR_ABORTED:
                        n = 'You aborted the video playback';
                        break;
                      case r.MEDIA_ERR_DECODE:
                        n =
                          'The video playback was aborted due to a corruption problem or because the video used features your browser did not support';
                        break;
                      case r.MEDIA_ERR_NETWORK:
                        n =
                          'A network error caused the video download to fail part-way';
                        break;
                      case r.MEDIA_ERR_SRC_NOT_SUPPORTED:
                        n =
                          'The video could not be loaded, either because the server or network failed or because the format is not supported';
                    }
                    r.message && (n += ' - ' + r.message),
                      a.Logger.logMessage(
                        this.config.debug,
                        a.Logger.LEVEL_DEBUG,
                        n,
                        t.type,
                      );
                }
              }),
              (t.prototype.subscribe = function(t, e) {
                t === s.WebVideoPlayerEvents.PLAYBACK_READY
                  ? this.resetPlaybackReady(e)
                  : t === s.WebVideoPlayerEvents.PLAYER_CREATED
                  ? this.resetPlayerCreated(e)
                  : t === s.WebVideoPlayerEvents.PLAYING
                  ? (this.playingCallback = e)
                  : t === s.WebVideoPlayerEvents.PAUSED
                  ? (this.pausedCallback = e)
                  : t === s.WebVideoPlayerEvents.LOAD_START
                  ? (this.loadStartCallback = e)
                  : t === s.WebVideoPlayerEvents.PLAYHEAD_TIME_CHANGED
                  ? (this.playheadTimeCallback = e)
                  : t === s.WebVideoPlayerEvents.SEEKED
                  ? (this.seekedCallback = e)
                  : t === s.WebVideoPlayerEvents.PLAYBACK_COMPLETE
                  ? (this.playbackCompleteCallback = e)
                  : t === s.WebVideoPlayerEvents.STALLED &&
                    (this.stalledCallback = e);
              }),
              (t.prototype.gatherSubscriptionCallbacks = function(t) {
                (this.playingCallback = t.playingCallback),
                  (this.pausedCallback = t.pausedCallback),
                  (this.loadStartCallback = t.loadStartCallback),
                  (this.playbackReadyCallback = t.playbackReadyCallback),
                  (this.playerCreatedCallback = t.playerCreatedCallback),
                  (this.playheadTimeCallback = t.playheadTimeCallback),
                  (this.playbackCompleteCallback = t.playbackCompleteCallback),
                  (this.seekedCallback = t.seekedCallback),
                  (this.stalledCallback = t.stalledCallback);
              }),
              (t.prototype.resetPlaybackReady = function(t) {
                var e = this;
                t && (this.playbackReadyCallback = t),
                  this.playbackReady$.pipe(i.take(1)).subscribe(function() {
                    e.playbackReadyCallback();
                  });
              }),
              (t.prototype.resetPlayerCreated = function(t) {
                var e = this;
                t && (this.playerCreatedCallback = t),
                  this.playerCreated$.pipe(i.take(1)).subscribe(function() {
                    e.playerCreatedCallback();
                  });
              }),
              t
            );
          })();
        e.BlobPlayer = o;
      },
      function(t, e, r) {
        (e.__esModule = !0),
          (e.PLAYER_CONFIG = {
            autoStartLoad: !0,
            startPosition: -1,
            capLevelToPlayerSize: !1,
            debug: !1,
            defaultAudioCodec: void 0,
            initialLiveManifestSize: 1,
            maxBufferLength: 30,
            maxMaxBufferLength: 600,
            maxBufferSize: 6e7,
            maxBufferHole: 0.5,
            lowBufferWatchdogPeriod: 0.5,
            highBufferWatchdogPeriod: 3,
            nudgeOffset: 0.1,
            nudgeMaxRetry: 3,
            maxFragLookUpTolerance: 0.2,
            liveSyncDurationCount: 3,
            liveMaxLatencyDurationCount: 10,
            enableWorker: !0,
            enableSoftwareAES: !0,
            manifestLoadingTimeOut: 1e4,
            manifestLoadingMaxRetry: 1,
            manifestLoadingRetryDelay: 500,
            manifestLoadingMaxRetryTimeout: 64e3,
            startLevel: void 0,
            levelLoadingTimeOut: 1e4,
            levelLoadingMaxRetry: 4,
            levelLoadingRetryDelay: 500,
            levelLoadingMaxRetryTimeout: 64e3,
            fragLoadingTimeOut: 2e4,
            fragLoadingMaxRetry: 6,
            fragLoadingRetryDelay: 500,
            fragLoadingMaxRetryTimeout: 64e3,
            startFragPrefetch: !1,
            appendErrorMaxRetry: 3,
            xhrSetup: function(t, e) {
              t.withCredentials = !0;
            },
            enableWebVTT: !0,
            enableCEA708Captions: !0,
            stretchShortVideoTrack: !1,
            maxAudioFramesDrift: 1,
            forceKeyFrameOnDiscontinuity: !0,
            abrEwmaFastLive: 5,
            abrEwmaSlowLive: 9,
            abrEwmaFastVoD: 4,
            abrEwmaSlowVoD: 15,
            abrEwmaDefaultEstimate: 5e5,
            abrBandWidthFactor: 0.95,
            abrBandWidthUpFactor: 0.7,
            minAutoBitrate: 0,
          });
      },
      function(t, e) {
        var r = (function() {
          function t() {
            if (!G && document.getElementsByTagName('body')[0]) {
              try {
                var t,
                  e = v('span');
                (e.style.display = 'none'),
                  (t = P.getElementsByTagName('body')[0].appendChild(
                    e,
                  )).parentNode.removeChild(t),
                  (t = null),
                  (e = null);
              } catch (t) {
                return;
              }
              G = !0;
              for (var r = N.length, n = 0; n < r; n++) N[n]();
            }
          }
          function e(t) {
            G ? t() : (N[N.length] = t);
          }
          function n() {
            var t = U.length;
            if (t > 0)
              for (var e = 0; e < t; e++) {
                var r = U[e].id,
                  n = U[e].callbackFn,
                  u = { success: !1, id: r };
                if (W.pv[0] > 0) {
                  var l = p(r);
                  if (l)
                    if (!m(U[e].swfVersion) || (W.wk && W.wk < 312))
                      if (U[e].expressInstall && s()) {
                        var c = {};
                        (c.data = U[e].expressInstall),
                          (c.width = l.getAttribute('width') || '0'),
                          (c.height = l.getAttribute('height') || '0'),
                          l.getAttribute('class') &&
                            (c.styleclass = l.getAttribute('class')),
                          l.getAttribute('align') &&
                            (c.align = l.getAttribute('align'));
                        for (
                          var h = {},
                            d = l.getElementsByTagName('param'),
                            f = d.length,
                            v = 0;
                          v < f;
                          v++
                        )
                          'movie' != d[v].getAttribute('name').toLowerCase() &&
                            (h[d[v].getAttribute('name')] = d[v].getAttribute(
                              'value',
                            ));
                        a(c, h, r, n);
                      } else o(l), n && n(u);
                    else
                      b(r, !0),
                        n &&
                          ((u.success = !0), (u.ref = i(r)), (u.id = r), n(u));
                } else if ((b(r, !0), n)) {
                  var g = i(r);
                  g &&
                    typeof g.SetVariable != w &&
                    ((u.success = !0), (u.ref = g), (u.id = g.id)),
                    n(u);
                }
              }
          }
          function i(t) {
            var e = null,
              r = p(t);
            return (
              r &&
                'OBJECT' === r.nodeName.toUpperCase() &&
                (e =
                  typeof r.SetVariable !== w
                    ? r
                    : r.getElementsByTagName(k)[0] || r),
              e
            );
          }
          function s() {
            return (
              !V && m('6.0.65') && (W.win || W.mac) && !(W.wk && W.wk < 312)
            );
          }
          function a(t, e, r, n) {
            var i = p(r);
            if (
              ((r = f(r)),
              (V = !0),
              (L = n || null),
              (_ = { success: !1, id: r }),
              i)
            ) {
              'OBJECT' == i.nodeName.toUpperCase()
                ? ((T = u(i)), (S = null))
                : ((T = i), (S = r)),
                (t.id = I),
                (typeof t.width == w ||
                  (!/%$/.test(t.width) && g(t.width) < 310)) &&
                  (t.width = '310'),
                (typeof t.height == w ||
                  (!/%$/.test(t.height) && g(t.height) < 137)) &&
                  (t.height = '137');
              var s = W.ie ? 'ActiveX' : 'PlugIn',
                a =
                  'MMredirectURL=' +
                  encodeURIComponent(
                    x.location.toString().replace(/&/g, '%26'),
                  ) +
                  '&MMplayerType=' +
                  s +
                  '&MMdoctitle=' +
                  encodeURIComponent(
                    P.title.slice(0, 47) + ' - Flash Player Installation',
                  );
              if (
                (typeof e.flashvars != w
                  ? (e.flashvars += '&' + a)
                  : (e.flashvars = a),
                W.ie && 4 != i.readyState)
              ) {
                var o = v('div');
                (r += 'SWFObjectNew'),
                  o.setAttribute('id', r),
                  i.parentNode.insertBefore(o, i),
                  (i.style.display = 'none'),
                  h(i);
              }
              l(t, e, r);
            }
          }
          function o(t) {
            if (W.ie && 4 != t.readyState) {
              t.style.display = 'none';
              var e = v('div');
              t.parentNode.insertBefore(e, t),
                e.parentNode.replaceChild(u(t), e),
                h(t);
            } else t.parentNode.replaceChild(u(t), t);
          }
          function u(t) {
            var e = v('div');
            if (W.win && W.ie) e.innerHTML = t.innerHTML;
            else {
              var r = t.getElementsByTagName(k)[0];
              if (r) {
                var n = r.childNodes;
                if (n)
                  for (var i = n.length, s = 0; s < i; s++)
                    (1 == n[s].nodeType && 'PARAM' == n[s].nodeName) ||
                      8 == n[s].nodeType ||
                      e.appendChild(n[s].cloneNode(!0));
              }
            }
            return e;
          }
          function l(t, e, r) {
            var n,
              i = p(r);
            if (((r = f(r)), W.wk && W.wk < 312)) return n;
            if (i) {
              var s,
                a,
                o,
                u = W.ie ? v('div') : v(k);
              for (o in (typeof t.id == w && (t.id = r), e))
                e.hasOwnProperty(o) &&
                  'movie' !== o.toLowerCase() &&
                  c(u, o, e[o]);
              for (s in (W.ie &&
                (u = (function(t, e) {
                  var r = v('div');
                  return (
                    (r.innerHTML =
                      "<object classid='clsid:D27CDB6E-AE6D-11cf-96B8-444553540000'><param name='movie' value='" +
                      t +
                      "'>" +
                      e +
                      '</object>'),
                    r.firstChild
                  );
                })(t.data, u.innerHTML)),
              t))
                t.hasOwnProperty(s) &&
                  ('styleclass' === (a = s.toLowerCase())
                    ? u.setAttribute('class', t[s])
                    : 'classid' !== a &&
                      'data' !== a &&
                      u.setAttribute(s, t[s]));
              W.ie
                ? (B[B.length] = t.id)
                : (u.setAttribute('type', O), u.setAttribute('data', t.data)),
                i.parentNode.replaceChild(u, i),
                (n = u);
            }
            return n;
          }
          function c(t, e, r) {
            var n = v('param');
            n.setAttribute('name', e),
              n.setAttribute('value', r),
              t.appendChild(n);
          }
          function h(t) {
            var e = p(t);
            e &&
              'OBJECT' == e.nodeName.toUpperCase() &&
              (W.ie
                ? ((e.style.display = 'none'),
                  (function t() {
                    if (4 == e.readyState) {
                      for (var r in e)
                        'function' == typeof e[r] && (e[r] = null);
                      e.parentNode.removeChild(e);
                    } else setTimeout(t, 10);
                  })())
                : e.parentNode.removeChild(e));
          }
          function d(t) {
            return t && t.nodeType && 1 === t.nodeType;
          }
          function f(t) {
            return d(t) ? t.id : t;
          }
          function p(t) {
            if (d(t)) return t;
            var e = null;
            try {
              e = P.getElementById(t);
            } catch (t) {}
            return e;
          }
          function v(t) {
            return P.createElement(t);
          }
          function g(t) {
            return parseInt(t, 10);
          }
          function m(t) {
            t += '';
            var e = W.pv,
              r = t.split('.');
            return (
              (r[0] = g(r[0])),
              (r[1] = g(r[1]) || 0),
              (r[2] = g(r[2]) || 0),
              e[0] > r[0] ||
                (e[0] == r[0] && e[1] > r[1]) ||
                (e[0] == r[0] && e[1] == r[1] && e[2] >= r[2])
            );
          }
          function y(t, e, r, n) {
            var i = P.getElementsByTagName('head')[0];
            if (i) {
              var s = 'string' == typeof r ? r : 'screen';
              if ((n && ((A = null), (D = null)), !A || D != s)) {
                var a = v('style');
                a.setAttribute('type', 'text/css'),
                  a.setAttribute('media', s),
                  (A = i.appendChild(a)),
                  W.ie &&
                    typeof P.styleSheets != w &&
                    P.styleSheets.length > 0 &&
                    (A = P.styleSheets[P.styleSheets.length - 1]),
                  (D = s);
              }
              A &&
                (typeof A.addRule != w
                  ? A.addRule(t, e)
                  : typeof P.createTextNode != w &&
                    A.appendChild(P.createTextNode(t + ' {' + e + '}')));
            }
          }
          function b(t, e) {
            if (H) {
              var r = e ? 'visible' : 'hidden',
                n = p(t);
              G && n
                ? (n.style.visibility = r)
                : 'string' == typeof t && y('#' + t, 'visibility:' + r);
            }
          }
          function E(t) {
            return null != /[\\\"<>\.;]/.exec(t) &&
              typeof encodeURIComponent != w
              ? encodeURIComponent(t)
              : t;
          }
          var T,
            S,
            L,
            _,
            A,
            D,
            w = 'undefined',
            k = 'object',
            R = 'Shockwave Flash',
            O = 'application/x-shockwave-flash',
            I = 'SWFObjectExprInst',
            C = 'onreadystatechange',
            x = window,
            P = document,
            M = navigator,
            F = !1,
            N = [],
            U = [],
            B = [],
            j = [],
            G = !1,
            V = !1,
            H = !0,
            K = !1,
            W = (function() {
              var t =
                  typeof P.getElementById != w &&
                  typeof P.getElementsByTagName != w &&
                  typeof P.createElement != w,
                e = M.userAgent.toLowerCase(),
                r = M.platform.toLowerCase(),
                n = /win/.test(r || e),
                i = /mac/.test(r || e),
                s =
                  !!/webkit/.test(e) &&
                  parseFloat(e.replace(/^.*webkit\/(\d+(\.\d+)?).*$/, '$1')),
                a = 'Microsoft Internet Explorer' === M.appName,
                o = [0, 0, 0],
                u = null;
              if (typeof M.plugins != w && typeof M.plugins[R] == k)
                (u = M.plugins[R].description) &&
                  typeof M.mimeTypes != w &&
                  M.mimeTypes[O] &&
                  M.mimeTypes[O].enabledPlugin &&
                  ((F = !0),
                  (a = !1),
                  (u = u.replace(/^.*\s+(\S+\s+\S+$)/, '$1')),
                  (o[0] = g(u.replace(/^(.*)\..*$/, '$1'))),
                  (o[1] = g(u.replace(/^.*\.(.*)\s.*$/, '$1'))),
                  (o[2] = /[a-zA-Z]/.test(u)
                    ? g(u.replace(/^.*[a-zA-Z]+(.*)$/, '$1'))
                    : 0));
              else if (typeof x.ActiveXObject != w)
                try {
                  var l = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
                  l &&
                    (u = l.GetVariable('$version')) &&
                    ((a = !0),
                    (o = [
                      g((u = u.split(' ')[1].split(','))[0]),
                      g(u[1]),
                      g(u[2]),
                    ]));
                } catch (t) {}
              return { w3: t, pv: o, wk: s, ie: a, win: n, mac: i };
            })();
          return (
            W.w3 &&
              (((typeof P.readyState != w &&
                ('complete' === P.readyState ||
                  'interactive' === P.readyState)) ||
                (typeof P.readyState == w &&
                  (P.getElementsByTagName('body')[0] || P.body))) &&
                t(),
              G ||
                (typeof P.addEventListener != w &&
                  P.addEventListener('DOMContentLoaded', t, !1),
                W.ie &&
                  (P.attachEvent(C, function e() {
                    'complete' == P.readyState && (P.detachEvent(C, e), t());
                  }),
                  x == top &&
                    (function e() {
                      if (!G) {
                        try {
                          P.documentElement.doScroll('left');
                        } catch (t) {
                          return void setTimeout(e, 0);
                        }
                        t();
                      }
                    })()),
                W.wk &&
                  (function e() {
                    G ||
                      (/loaded|complete/.test(P.readyState)
                        ? t()
                        : setTimeout(e, 0));
                  })())),
            (N[0] = function() {
              F
                ? (function() {
                    var t = P.getElementsByTagName('body')[0],
                      e = v(k);
                    e.setAttribute('style', 'visibility: hidden;'),
                      e.setAttribute('type', O);
                    var r = t.appendChild(e);
                    if (r) {
                      var i = 0;
                      !(function s() {
                        if (typeof r.GetVariable != w)
                          try {
                            var a = r.GetVariable('$version');
                            a &&
                              ((a = a.split(' ')[1].split(',')),
                              (W.pv = [g(a[0]), g(a[1]), g(a[2])]));
                          } catch (t) {
                            W.pv = [8, 0, 0];
                          }
                        else if (i < 10) return i++, void setTimeout(s, 10);
                        t.removeChild(e), (r = null), n();
                      })();
                    } else n();
                  })()
                : n();
            }),
            W.ie &&
              window.attachEvent('onunload', function() {
                for (var t = j.length, e = 0; e < t; e++)
                  j[e][0].detachEvent(j[e][1], j[e][2]);
                for (var n = B.length, i = 0; i < n; i++) h(B[i]);
                for (var s in W) W[s] = null;
                for (var a in ((W = null), r)) r[a] = null;
                r = null;
              }),
            {
              registerObject: function(t, e, r, n) {
                if (W.w3 && t && e) {
                  var i = {};
                  (i.id = t),
                    (i.swfVersion = e),
                    (i.expressInstall = r),
                    (i.callbackFn = n),
                    (U[U.length] = i),
                    b(t, !1);
                } else n && n({ success: !1, id: t });
              },
              getObjectById: function(t) {
                if (W.w3) return i(t);
              },
              embedSWF: function(t, r, n, i, o, u, c, h, d, p) {
                var v = f(r),
                  g = { success: !1, id: v };
                W.w3 && !(W.wk && W.wk < 312) && t && r && n && i && o
                  ? (b(v, !1),
                    e(function() {
                      (n += ''), (i += '');
                      var e = {};
                      if (d && typeof d === k) for (var f in d) e[f] = d[f];
                      (e.data = t), (e.width = n), (e.height = i);
                      var y = {};
                      if (h && typeof h === k) for (var E in h) y[E] = h[E];
                      if (c && typeof c === k)
                        for (var T in c)
                          if (c.hasOwnProperty(T)) {
                            var S = K ? encodeURIComponent(T) : T,
                              L = K ? encodeURIComponent(c[T]) : c[T];
                            typeof y.flashvars != w
                              ? (y.flashvars += '&' + S + '=' + L)
                              : (y.flashvars = S + '=' + L);
                          }
                      if (m(o)) {
                        var _ = l(e, y, r);
                        e.id == v && b(v, !0),
                          (g.success = !0),
                          (g.ref = _),
                          (g.id = _.id);
                      } else {
                        if (u && s()) return (e.data = u), void a(e, y, r, p);
                        b(v, !0);
                      }
                      p && p(g);
                    }))
                  : p && p(g);
              },
              switchOffAutoHideShow: function() {
                H = !1;
              },
              enableUriEncoding: function(t) {
                K = typeof t === w || t;
              },
              ua: W,
              getFlashPlayerVersion: function() {
                return { major: W.pv[0], minor: W.pv[1], release: W.pv[2] };
              },
              hasFlashPlayerVersion: m,
              createSWF: function(t, e, r) {
                return W.w3 ? l(t, e, r) : void 0;
              },
              showExpressInstall: function(t, e, r, n) {
                W.w3 && s() && a(t, e, r, n);
              },
              removeSWF: function(t) {
                W.w3 && h(t);
              },
              createCSS: function(t, e, r, n) {
                W.w3 && y(t, e, r, n);
              },
              addDomLoadEvent: e,
              addLoadEvent: function(t) {
                if (typeof x.addEventListener != w)
                  x.addEventListener('load', t, !1);
                else if (typeof P.addEventListener != w)
                  P.addEventListener('load', t, !1);
                else if (typeof x.attachEvent != w)
                  !(function(t, e, r) {
                    t.attachEvent('onload', r),
                      (j[j.length] = [t, 'onload', r]);
                  })(x, 0, t);
                else if ('function' == typeof x.onload) {
                  var e = x.onload;
                  x.onload = function() {
                    e(), t();
                  };
                } else x.onload = t;
              },
              getQueryParamValue: function(t) {
                var e = P.location.search || P.location.hash;
                if (e) {
                  if ((/\?/.test(e) && (e = e.split('?')[1]), null == t))
                    return E(e);
                  for (var r = e.split('&'), n = 0; n < r.length; n++)
                    if (r[n].substring(0, r[n].indexOf('=')) == t)
                      return E(r[n].substring(r[n].indexOf('=') + 1));
                }
                return '';
              },
              expressInstallCallback: function() {
                if (V) {
                  var t = p(I);
                  t &&
                    T &&
                    (t.parentNode.replaceChild(T, t),
                    S && (b(S, !0), W.ie && (T.style.display = 'block')),
                    L && L(_)),
                    (V = !1);
                }
              },
              version: '2.3',
            }
          );
        })();
        t.exports = r;
      },
    ]);
  }),
  'object' == typeof exports && 'object' == typeof module
    ? (module.exports = e())
    : 'function' == typeof define && define.amd
    ? define([], e)
    : 'object' == typeof exports
    ? (exports.SXMVideoPlayer = e())
    : (t.SXMVideoPlayer = e());
